/*eslint angular/window-service: 0 */
(function() {
  'use strict';

  var dependencies = [
    'ngMaterial',
    'ngAnimate',
    'ngCookies',
    'ngSanitize',
    'ngMessages',
    'ngAria',
    'ui.router',
    'ui.grid',
    'ngclipboard',
    'ui.grid.autoResize',
    'ui.grid.edit',
    'ui.grid.pagination',
    'ui.grid.selection',
    'ui.grid.pinning',
    'isteven-multi-select',
    'uiGmapgoogle-maps',
    'angular-jwt',
    'duScroll',
    'pascalprecht.translate',
    'updateMeta',
    'angularMoment',
    'angularModalService',
    '720kb.tooltips',
    'ngStorage',
    'datePicker',
    'ngImgCrop',
    'ngFileUpload',
    'cloudinary',
    'restangular',
    'base64',
    'ng-drag-scroll',
    'ngIntlTelInput'
  ];

  switch(window.location.hostname) {
    case 'partner.busrapido.com': {
      window.env = 'production';
      break;
    }
    case 'partner.web-staging.busrapido.com': {
      window.env = 'production';
      break;
    }
    case 'localhost': {
      window.env = 'localhost';
      break;
    }
    case '127.0.0.1': {
      window.env = 'localhost';
      break;
    }
    default: {
      window.env = 'other';
    }
  }

  if(window.env === 'production') {
    dependencies.push('ngRaven');
  }

  angular
    .module('busrapidoAppWeb', dependencies)
    .config(function($mdThemingProvider) {
      $mdThemingProvider.theme('default')
        .primaryPalette('deep-orange')
        .accentPalette('red');
    })
    .config(function (ngIntlTelInputProvider) {
      ngIntlTelInputProvider.set({initialCountry: 'auto'});
      ngIntlTelInputProvider.set({preferredCountries: ['it', 'gb'], geoIpLookup: function(callback) {
        $.get("https://ipinfo.io", function() {}, "jsonp").always(function(resp) {
          var countryCode = (resp && resp.country) ? resp.country : "";
          callback(countryCode);
        });
      },
      //separateDialCode: true,
      formatOnDisplay: true
     });
    });

  if(window.env === 'production') {
    window.Raven.config('https://8eec44cc9c6c4e2d8945e201f167c6fd@sentry.io/140326', {
      release: '1.12.3'
    })
    .addPlugin(window.Raven.Plugins.Angular).install();
  }

  // polyfills
  // https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
  if (!String.prototype.padStart) {
    String.prototype.padStart = function padStart(targetLength, padString) {
        targetLength = targetLength >> 0; //truncate if number, or convert non-number to 0;
        padString = String(typeof padString !== 'undefined' ? padString : ' ');
        if (this.length >= targetLength) {
            return String(this);
        } else {
            targetLength = targetLength - this.length;
            if (targetLength > padString.length) {
                padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
            }
            return padString.slice(0, targetLength) + String(this);
        }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .factory('VehicleModal', vehicleService);

  /** @ngInject */
  function vehicleService(ModalService, $rootScope, $timeout, $window) {
    var tmt, mdl;
    var service = {
      show: function(data, cross, after, timeout, onCancel, onConfirm) {
        if(after) {
          tmt = $timeout(showModal, after);
        }
        else {
          showModal();
        }

        function showModal() {
          ModalService.showModal({
            templateUrl: "app/views/supplier/tables/vehicles/modal/alert.modal.html",
            controller: 'VehicleModalController',
            controllerAs: 'modal',
            inputs: {
              data: data,
              cross: cross,
              after: after,
              timeout: timeout
            }
          }).then(function(modal) {
            mdl = modal;
            modal.close.then(function(result) {
              if(result === 1) {
                if(angular.isFunction(onConfirm)) onConfirm(result);
              }
              else {
                if(angular.isFunction(onCancel)) onCancel(result);
              }
            });
          });
        }
      }
    };

    var deregistrationCallback1 = $rootScope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams) {
      $timeout.cancel(tmt);
      if(mdl && mdl.scope && angular.isFunction(mdl.scope.close)) {
        mdl.scope.close();
      }
    });
    $rootScope.$on('$destroy', deregistrationCallback1);

    $rootScope.$on('$destroy', function() {
      $timeout.cancel(tmt);
      if(mdl && mdl.scope && angular.isFunction(mdl.scope.close)) {
        mdl.scope.close();
      }
    });

    return service;
  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('VehicleModalController', VehicleModalController);

  /** @ngInject */
  function VehicleModalController($scope, $timeout, close, data, cross, after, timeout, $supplier, $error, $document) {
    var vm = this;
    vm.data = data;
    vm.user = {
      signup: {

      }
    };
    vm.inputs = {
      years: [],
    };
    var curYear = new Date().getFullYear();
    for(var i = curYear; i >= curYear-15; i--) {
      vm.inputs.years.push({value: i, name: 'Anno ' + i});
    }
    vm.submit = function($event) {

      var form = ($event && $event.srcElement) || $document.find('form')[0]
      vm.validated = true;

      if (form.checkValidity()) {
        vm.closeIt(1);
      }
    }
    vm.closeIt = function (result) {
      if (angular.isFunction(close)) {
        close(result);
      }
    };

    if (timeout > 0) {
      var tmt = $timeout(function () {
        vm.closeIt(-2);
      }, timeout);
      $scope.$on('$destroy', function () {
        $timeout.cancel(tmt);
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .factory('VehicleModal', vehicleService);

  /** @ngInject */
  function vehicleService(ModalService, $rootScope, $timeout, $window) {
    var tmt, mdl;
    var service = {
      show: function(data, cross, after, timeout, onCancel, onConfirm) {
        if(after) {
          tmt = $timeout(showModal, after);
        }
        else {
          showModal();
        }

        function showModal() {
          ModalService.showModal({
            templateUrl: "app/views/supplier/tables/vehicles/modal/alert.modal.html",
            controller: 'VehicleModalController',
            controllerAs: 'modal',
            inputs: {
              data: data,
              cross: cross,
              after: after,
              timeout: timeout
            }
          }).then(function(modal) {
            mdl = modal;
            modal.close.then(function(result) {
              if(result === 1) {
                if(angular.isFunction(onConfirm)) onConfirm(result);
              }
              else {
                if(angular.isFunction(onCancel)) onCancel(result);
              }
            });
          });
        }
      }
    };

    var deregistrationCallback1 = $rootScope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams) {
      $timeout.cancel(tmt);
      if(mdl && mdl.scope && angular.isFunction(mdl.scope.close)) {
        mdl.scope.close();
      }
    });
    $rootScope.$on('$destroy', deregistrationCallback1);

    $rootScope.$on('$destroy', function() {
      $timeout.cancel(tmt);
      if(mdl && mdl.scope && angular.isFunction(mdl.scope.close)) {
        mdl.scope.close();
      }
    });

    return service;
  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('VehicleModalController', VehicleModalController);

  /** @ngInject */
  function VehicleModalController($scope, $timeout, close, data, cross, after, timeout, $supplier, $error, $document) {
    var vm = this;
    vm.data = data;
    vm.user = {
      signup: {

      }
    };
    vm.inputs = {
      years: [],
    };
    var curYear = new Date().getFullYear();
    for(var i = curYear; i >= curYear-15; i--) {
      vm.inputs.years.push({value: i, name: 'Anno ' + i});
    }
    vm.submit = function($event) {

      var form = ($event && $event.srcElement) || $document.find('form')[0]
      vm.validated = true;

      if (form.checkValidity()) {
        vm.closeIt(1);
      }
    }
    vm.closeIt = function (result) {
      if (angular.isFunction(close)) {
        close(result);
      }
    };

    if (timeout > 0) {
      var tmt = $timeout(function () {
        vm.closeIt(-2);
      }, timeout);
      $scope.$on('$destroy', function () {
        $timeout.cancel(tmt);
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brEndService', EndServiceDirective);

  /** @ngInject */
  function EndServiceDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        index: '=brIndex',
        request: '=brRequest',
        onSubmit: '&brOnSubmit',
        maps: '=brMaps',
        googleDirectionsService: '=brGoogleDirectionsService',
        lowPassengersAlert: '=?brLowPassengersAlert'
      },
      templateUrl: 'app/elements/planner-topic/services/end/end.html',
      controller: 'EndServiceController',
      controllerAs: 'service',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('EndServiceController', EndServiceController);

  /** @ngInject */
  function EndServiceController($scope, $state, $timeout, $alert, $common) {
    var vm = this;

    vm.$onInit = function () {
      vm.request.services[vm.index].depart = vm.request.services[vm.index].depart || angular.copy(vm.request.services[vm.index-1].depart);
      /*
      vm.request.services[vm.index].place = angular.copy(vm.request.services[vm.index-1].place);
      */
      vm.MIN_LAYOVER = 9e2;
      vm.MIN_HW_SPEED = 40;
      vm.MAX_VEHICLE_SPEED = 80;

      vm.MAX_DRIVING_TIME_UNINTERRUPTED = 4.5 * 60 * 60;
      vm.STOPOVER_TIME = 45 * 60;
      vm.STOPOVER_TIME_PART1 = 30 * 60;
      vm.STOPOVER_TIME_PART2 = 15 * 60;
      vm.directions = vm.request.services[vm.index].directions;
      if (vm.request.services[vm.index].depart) vm.request.services[vm.index].depart = new Date(vm.request.services[vm.index].depart);
      vm.onCompute = function () {
        var delta = vm.directions.total.duration > vm.MAX_DRIVING_TIME_UNINTERRUPTED ? 25 : 0;
        var leavingDelta = vm.MIN_LAYOVER * 1000;
        if (vm.request.services[vm.index].arrive && vm.request.services[vm.index].depart) {
          // leavingDelta = vm.request.services[vm.index].depart.getTime() - vm.request.services[vm.index].arrive.getTime();
        }
        vm.request.services[vm.index].arrive = new Date(new Date(vm.from.depart).getTime() + vm.directions.total.duration  * 1000 * (100 + delta) / 100);
        if (vm.request.services[vm.index].depart) {
          vm.request.services[vm.index].depart = new Date($common.max(vm.request.services[vm.index].arrive.getTime() + leavingDelta, vm.request.services[vm.index].depart.getTime()))
        }
        else {
          vm.request.services[vm.index].depart = new Date(vm.request.services[vm.index].arrive.getTime() + leavingDelta);
        }
        vm.request.services[vm.index].directions = angular.copy(vm.directions);
        vm.request.services[vm.index].layover = vm.directions.total.duration * delta / 100;
        $timeout(function() {
          $scope.$apply();
        }, 0)
      }
      function update() {
        vm.waypoints = [];
        for (var i = vm.index - 1; i >= 0; i--) {
          if (vm.request.services[i].type !== 'transit') {
            vm.from = vm.request.services[i];
            break;
          }
          else {
            vm.waypoints.push({
              location: vm.request.services[i].place.location,
              stopover: true
            });
          }
        }
        vm.waypoints.reverse();
        $timeout(function() {
          $scope.$apply();
        }, 0);
      }
      /*
      $scope.$watch(function() {return vm.request.services[vm.index-1].place}, function() {
        vm.request.services[vm.index].place = angular.copy(vm.request.services[vm.index-1].place);
      }, true);
      */
      $scope.$watch(function () { return vm.index }, function (newValue, oldValue) {
        update();
        if (oldValue) {
          $timeout(function() {
            $scope.$apply();
          }, 0);
        }
      });
      update();
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brTransitService', TransitServiceDirective);

  /** @ngInject */
  function TransitServiceDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        index: '=brIndex',
        request: '=brRequest',
        maps: '=brMaps',
        googleDirectionsService: '=brGoogleDirectionsService',
        onSubmit: '&brOnSubmit',
        lowPassengersAlert: '=?brLowPassengersAlert'
      },
      templateUrl: 'app/elements/planner-topic/services/transit/transit.html',
      controller: 'TransitServiceController',
      controllerAs: 'service',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('TransitServiceController', TransitServiceController);

  /** @ngInject */
  function TransitServiceController($scope, $state, $timeout, $alert) {
    var vm = this;

    vm.$onInit = function () {

    };

  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brTransferService', TransferServiceDirective);

  /** @ngInject */
  function TransferServiceDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        index: '=brIndex',
        request: '=brRequest',
        maps: '=brMaps',
        googleDirectionsService: '=brGoogleDirectionsService',
        onSubmit: '&brOnSubmit',
        lowPassengersAlert: '=?brLowPassengersAlert'
      },
      templateUrl: 'app/elements/planner-topic/services/transfer/transfer.html',
      controller: 'TransferServiceController',
      controllerAs: 'service',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('TransferServiceController', TransferServiceController);

  /** @ngInject */
  function TransferServiceController($scope, $state, $timeout, $alert, $common) {
    var vm = this;

    vm.$onInit = function () {

      vm.MIN_LAYOVER = 9e2;
      vm.MIN_HW_SPEED = 40;
      vm.MAX_VEHICLE_SPEED = 80;

      vm.MAX_DRIVING_TIME_UNINTERRUPTED = 4.5 * 60 * 60;
      vm.STOPOVER_TIME = 45 * 60;
      vm.STOPOVER_TIME_PART1 = 30 * 60;
      vm.STOPOVER_TIME_PART2 = 15 * 60;
      vm.directions = vm.request.services[vm.index].directions;
      if (vm.request.services[vm.index].depart) vm.request.services[vm.index].depart = new Date(vm.request.services[vm.index].depart);
      vm.onCompute = function () {
        var delta = vm.directions.total.duration > vm.MAX_DRIVING_TIME_UNINTERRUPTED ? 25 : 0;
        var leavingDelta = vm.MIN_LAYOVER * 1000;
        if (vm.request.services[vm.index].arrive && vm.request.services[vm.index].depart) {
          // leavingDelta = vm.request.services[vm.index].depart.getTime() - vm.request.services[vm.index].arrive.getTime();
        }
        vm.request.services[vm.index].arrive = new Date(new Date(vm.from.depart).getTime() + vm.directions.total.duration  * 1000 * (100 + delta) / 100);
        if (vm.request.services[vm.index].depart) {
          vm.request.services[vm.index].depart = new Date($common.max(vm.request.services[vm.index].arrive.getTime() + leavingDelta, vm.request.services[vm.index].depart.getTime()))
        }
        else {
          vm.request.services[vm.index].depart = new Date(vm.request.services[vm.index].arrive.getTime() + leavingDelta);
        }
        vm.request.services[vm.index].directions = angular.copy(vm.directions);
        vm.request.services[vm.index].layover = vm.directions.total.duration * delta / 100;
        $timeout(function() {
          $scope.$apply();
        }, 0)
      }
      function update() {
        vm.waypoints = [];
        for (var i = vm.index - 1; i >= 0; i--) {
          if (vm.request.services[i].type !== 'transit') {
            vm.from = vm.request.services[i];
            break;
          }
          else {
            vm.waypoints.push({
              location: vm.request.services[i].place.location,
              stopover: true
            });
          }
        }
        vm.waypoints.reverse();
        $timeout(function() {
          $scope.$apply();
        }, 0);
      }
      $scope.$watch(function () { return vm.index }, function (newValue, oldValue) {
        update();
        if (oldValue) {
          $timeout(function() {
            $scope.$apply();
          }, 0);
        }
      });
      update();
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brReturnService', ReturnServiceDirective);

  /** @ngInject */
  function ReturnServiceDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        index: '=brIndex',
        request: '=brRequest',
        onSubmit: '&brOnSubmit',
        maps: '=brMaps',
        googleDirectionsService: '=brGoogleDirectionsService',
        lowPassengersAlert: '=?brLowPassengersAlert'
      },
      templateUrl: 'app/elements/planner-topic/services/return/return.html',
      controller: 'ReturnServiceController',
      controllerAs: 'service',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('ReturnServiceController', ReturnServiceController);

  /** @ngInject */
  function ReturnServiceController($scope, $state, $timeout, $alert, $common) {
    var vm = this;

    vm.$onInit = function () {

      vm.MIN_LAYOVER = 9e2;
      vm.MIN_HW_SPEED = 40;
      vm.MAX_VEHICLE_SPEED = 80;

      vm.MAX_DRIVING_TIME_UNINTERRUPTED = 4.5 * 60 * 60;
      vm.STOPOVER_TIME = 45 * 60;
      vm.STOPOVER_TIME_PART1 = 30 * 60;
      vm.STOPOVER_TIME_PART2 = 15 * 60;
      vm.directions = vm.request.services[vm.index].directions;
      if (vm.request.services[vm.index].depart) vm.request.services[vm.index].depart = new Date(vm.request.services[vm.index].depart);
      vm.onCompute = function () {
      //console.log('Return computing')
        var delta = vm.directions.total.duration > vm.MAX_DRIVING_TIME_UNINTERRUPTED ? 25 : 0;
        var leavingDelta = vm.MIN_LAYOVER * 1000;
        if (vm.request.services[vm.index].arrive && vm.request.services[vm.index].depart) {
          // leavingDelta = vm.request.services[vm.index].depart.getTime() - vm.request.services[vm.index].arrive.getTime();
        }
        vm.request.services[vm.index].arrive = new Date(new Date(vm.from.depart).getTime() + vm.directions.total.duration  * 1000 * (100 + delta) / 100);
        if (vm.request.services[vm.index].depart) {
          vm.request.services[vm.index].depart = new Date($common.max(vm.request.services[vm.index].arrive.getTime() + leavingDelta, vm.request.services[vm.index].depart.getTime()))
        }
        else {
          vm.request.services[vm.index].depart = new Date(vm.request.services[vm.index].arrive.getTime() + leavingDelta);
        }
        vm.request.services[vm.index].directions = angular.copy(vm.directions);
        vm.request.services[vm.index].layover = vm.directions.total.duration  * delta / 100;
        $timeout(function() {
          $scope.$apply();
        }, 0)
      }
      function update() {
        vm.waypoints = [];
        for (var i = vm.index - 1; i >= 0; i--) {
          if (vm.request.services[i].type !== 'transit') {
            vm.from = vm.request.services[i];
            break;
          }
          else {
            vm.waypoints.push({
              location: vm.request.services[i].place.location,
              stopover: true
            });
          }
        }
        vm.waypoints.reverse();
        $timeout(function() {
          $scope.$apply();
        }, 0);
      }
      $scope.$watch(function () { return vm.index }, function (newValue, oldValue) {
        update();
        if (oldValue) {
          $timeout(function() {
            $scope.$apply();
          }, 0);
        }
      });
      $scope.$watch(function() { return vm.request.services[0] }, function() {

        $timeout(function() {
          $scope.$apply();
        }, 0)
        vm.request.services[vm.index].place = vm.request.services[0].place;
        $timeout(function() {
          $scope.$apply();
        }, 0)
      });
      update();
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brShuttleService', ShuttleServiceDirective);

  /** @ngInject */
  function ShuttleServiceDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        index: '=brIndex',
        request: '=brRequest',
        onSubmit: '&brOnSubmit',
        maps: '=brMaps',
        googleDirectionsService: '=brGoogleDirectionsService',
        lowPassengersAlert: '=?brLowPassengersAlert'
      },
      templateUrl: 'app/elements/planner-topic/services/shuttle/shuttle.html',
      controller: 'ShuttleServiceController',
      controllerAs: 'service',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('ShuttleServiceController', ShuttleServiceController);

  /** @ngInject */
  function ShuttleServiceController($scope, $state, $timeout, $alert) {
    var vm = this;

    vm.$onInit = function () {
      vm.request.services[vm.index].place = angular.copy(vm.request.services[vm.index-1].place);
      vm.request.services[vm.index].depart = vm.request.services[vm.index].depart || angular.copy(vm.request.services[vm.index-1].depart);
      if (vm.request.services[vm.index].depart) vm.request.services[vm.index].depart = new Date(vm.request.services[vm.index].depart);
      if (vm.request.services[vm.index-1].type === 'transfer') {
        vm.showStart = false;
      }

      $scope.$watch(function() {return vm.request.services[vm.index-1].place}, function() {
        vm.request.services[vm.index].place = angular.copy(vm.request.services[vm.index-1].place);
      }, true);
      vm.deltas = [];

      for (var i = 5; i < 5 * 60; i += 5) {
        vm.deltas.push(i);
      }
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brDisposalService', DisposalServiceDirective);

  /** @ngInject */
  function DisposalServiceDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        index: '=brIndex',
        request: '=brRequest',
        maps: '=brMaps',
        googleDirectionsService: '=brGoogleDirectionsService',
        onSubmit: '&brOnSubmit',
        lowPassengersAlert: '=?brLowPassengersAlert'
      },
      templateUrl: 'app/elements/planner-topic/services/disposal/disposal.html',
      controller: 'DisposalServiceController',
      controllerAs: 'service',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('DisposalServiceController', DisposalServiceController);

  /** @ngInject */
  function DisposalServiceController($scope, $state, $timeout, $alert) {
    var vm = this;

    vm.$onInit = function () {
      vm.request.services[vm.index].place = angular.copy(vm.request.services[vm.index-1].place);
      vm.request.services[vm.index].depart = vm.request.services[vm.index].depart || angular.copy(vm.request.services[vm.index-1].depart);
      if (vm.request.services[vm.index].depart) vm.request.services[vm.index].depart = new Date(vm.request.services[vm.index].depart);
      if (vm.request.services[vm.index-1].type === 'transfer') {
        vm.showStart = false;
      }
      $scope.$watch(function() {return vm.request.services[vm.index-1].place}, function() {
        vm.request.services[vm.index].place = angular.copy(vm.request.services[vm.index-1].place);
      }, true);
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brPickupService', PickupServiceDirective);

  /** @ngInject */
  function PickupServiceDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        index: '=brIndex',
        request: '=brRequest',
        onSubmit: '&brOnSubmit',
        maps: '=brMaps',
        googleDirectionsService: '=brGoogleDirectionsService',
        lowPassengersAlert: '=?brLowPassengersAlert'
      },
      templateUrl: 'app/elements/planner-topic/services/pickup/pickup.html',
      controller: 'PickupServiceController',
      controllerAs: 'service',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('PickupServiceController', PickupServiceController);

  /** @ngInject */
  function PickupServiceController($scope, $state, $timeout, $alert) {
    var vm = this;

    vm.$onInit = function () {
      vm.internalDate = false;
      vm.modelTimepicker = '';
      vm.modelDatepicker = null;
      vm.request.services[vm.index].depart = new Date(vm.request.services[vm.index].depart);
    //console.log(vm.request.services[vm.index].depart)
      if(angular.isUndefined(vm.request.services[vm.index].depart)) {
        vm.request.services[vm.index].depart = null;
      }
      if(angular.isUndefined(vm.defTime)) {
        vm.defTime = '08:00';
      }

      /**
       * Scope Functions
       */
      vm.onDateChange = function() {
        //console.log("[CALL] DATETIMEPICKER - DATECHANGE", vm.modelDatepicker);
        if(!angular.isDate(vm.modelDatepicker)) return;
        if(!angular.isDate(vm.request.services[vm.index].depart)) {
          vm.internalDate = true;
          vm.request.services[vm.index].depart = new Date(vm.modelDatepicker);
        }
        else {
          var date = new Date(vm.request.services[vm.index].depart);
          date.setFullYear(vm.modelDatepicker.getFullYear());
          date.setMonth(vm.modelDatepicker.getMonth());
          date.setDate(vm.modelDatepicker.getDate());

          if(vm.request.services[vm.index].depart !== date) {
            vm.internalDate = true;
            vm.request.services[vm.index].depart = date;
          }
        }
        if(!angular.isString(vm.modelTimepicker) || vm.modelTimepicker === '') {
          var time;
          if(angular.isString(vm.defTime) && vm.defTime !== '') {
            time = vm.defTime.split(':');
            var def = new Date(vm.request.services[vm.index].depart);
            def.setHours(time[0], time[1], 0, 0);

            if(angular.isDate(vm.minDate) && vm.minDate > def) {
              time = zeroFill(vm.minDate.getHours()) + ':' + zeroFill(vm.minDate.getMinutes());
              vm.modelTimepicker = time;
              if(vm.request.services[vm.index].depart !== vm.minDate) {
                vm.internalDate = true;
                vm.request.services[vm.index].depart = vm.minDate;
              }
            }
            else {
              vm.modelTimepicker = vm.defTime;
              if(vm.request.services[vm.index].depart !== def) {
                vm.internalDate = true;
                vm.request.services[vm.index].depart = def;
              }
            }
          }
          else {
            if(angular.isDate(vm.minDate)) {
              time = zeroFill(vm.minDate.getHours()) + ':' + zeroFill(vm.minDate.getMinutes());
              vm.modelTimepicker = time;
              if(vm.request.services[vm.index].depart !== vm.request.services[vm.index].depart) {
                vm.internalDate = true;
                vm.request.services[vm.index].depart = vm.minDate;
              }
            }
            else {
              time = zeroFill(vm.request.services[vm.index].depart.getHours()) + ':' + zeroFill(vm.request.services[vm.index].depart.getMinutes());
              vm.modelTimepicker = time;
            }
          }
        }
      };
      vm.onTimeChange = function() {
        //console.log("[CALL] DATETIMEPICKER - TIMECHANGE", vm.modelTimepicker);
        if(!angular.isDate(vm.modelDatepicker) || !angular.isString(vm.modelTimepicker) || vm.modelTimepicker === '') {
          return;
        }
        var time = vm.modelTimepicker.split(':');
        if(time.length !== 2) return;
        var date = new Date(vm.request.services[vm.index].depart);
        date.setHours(time[0], time[1], 0, 0);

        if(vm.request.services[vm.index].depart !== date) {
          vm.internalDate = true;
          vm.request.services[vm.index].depart = date;
        }
      };
      /**
      * Controller function
      */
      function zeroFill(number) {
        if(number.toString().length < 2) {
          return '0' + number;
        }
        return '' + number;
      }
      /**
      * Controller watchers
      */
      $scope.$watch(function() { return vm.request.services[vm.index].depart }, function() {
        if(vm.internalDate) {
          //console.log("[WATCH] DATETIMEPICKER - INTERNAL DATE CHANGE", vm.request.services[vm.index].depart);
          vm.internalDate = false;
          $timeout(vm.onChange, 0);
          return;
        }
        //console.log("[WATCH] DATETIMEPICKER - EXTERNAL DATE CHANGE", vm.request.services[vm.index].depart);
        if(!angular.isDate(vm.request.services[vm.index].depart)) {
          vm.modelTimepicker = '';
          vm.modelDatepicker = null;
          return;
        }
        var time = zeroFill(vm.request.services[vm.index].depart.getHours()) + ':' + zeroFill(vm.request.services[vm.index].depart.getMinutes());

        if(vm.modelDatepicker === vm.request.services[vm.index].depart && vm.modelTimepicker === time) return;

        vm.modelTimepicker = time;
        vm.modelDatepicker = new Date(vm.request.services[vm.index].depart);
      });
      $scope.$watch(function() { return vm.request; }, function() {
      //console.log('change');
        try {
          if (vm.request.services[vm.request.services.length - 1].type !== 'end')
            vm.duration = (vm.request.services[vm.request.services.length - 1].depart.getTime() - vm.request.services[0].depart.getTime()) / 1000;
          else
            vm.duration = (vm.request.services[vm.request.services.length - 2].depart.getTime() - vm.request.services[0].depart.getTime()) / 1000;

        } catch (error) {
          vm.duration = 0;
        }
        vm.distance = 0;
        vm.drive = 0;
        for (var i = 0; i < vm.request.services.length; i++) {
          if (vm.request.services[i].type === 'transfer' || vm.request.services[i].type === 'return') {
          //console.log(vm.request.services[i].layover)
            vm.drive += vm.request.services[i].directions.total.duration;
            vm.distance += vm.request.services[i].directions.total.distance;
          }
        }
      }, true);
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brCitytourService', CitytourServiceDirective);

  /** @ngInject */
  function CitytourServiceDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        index: '=brIndex',
        request: '=brRequest',
        onSubmit: '&brOnSubmit',
        maps: '=brMaps',
        googleDirectionsService: '=brGoogleDirectionsService',
        lowPassengersAlert: '=?brLowPassengersAlert'
      },
      templateUrl: 'app/elements/planner-topic/services/citytour/citytour.html',
      controller: 'CitytourServiceController',
      controllerAs: 'service',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('CitytourServiceController', CitytourServiceController);

  /** @ngInject */
  function CitytourServiceController($scope, $state, $timeout, $alert) {
    var vm = this;

    vm.$onInit = function () {
      vm.request.services[vm.index].place = angular.copy(vm.request.services[vm.index-1].place);
      vm.request.services[vm.index].depart = vm.request.services[vm.index].depart || angular.copy(vm.request.services[vm.index-1].depart);
      if (vm.request.services[vm.index].depart) vm.request.services[vm.index].depart = new Date(vm.request.services[vm.index].depart);

      if (vm.request.services[vm.index-1].type === 'transfer') {
        vm.showStart = false;
      }

      $scope.$watch(function() {return vm.request.services[vm.index-1].place}, function() {
        vm.request.services[vm.index].place = angular.copy(vm.request.services[vm.index-1].place);
      }, true);
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brBusService', BusServiceDirective);

  /** @ngInject */
  function BusServiceDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        index: '=brIndex',
        request: '=brRequest',
        onSubmit: '&brOnSubmit',
        maps: '=brMaps',
        googleDirectionsService: '=brGoogleDirectionsService',
        lowPassengersAlert: '=?brLowPassengersAlert'
      },
      templateUrl: 'app/elements/planner-topic/services/bus/bus.html',
      controller: 'BusServiceController',
      controllerAs: 'service',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('BusServiceController', BusServiceController);

  /** @ngInject */
  function BusServiceController($scope, $state, $timeout, $alert) {
    var vm = this;

    vm.$onInit = function () {
      vm.request.services[vm.index].place = angular.copy(vm.request.services[vm.index-1].place);
      vm.request.services[vm.index].depart = vm.request.services[vm.index].depart || angular.copy(vm.request.services[vm.index-1].depart);
      if (vm.request.services[vm.index].depart) vm.request.services[vm.index].depart = new Date(vm.request.services[vm.index].depart);
      if (vm.request.services[vm.index-1].type === 'transfer') {
        vm.showStart = false;
      }

      $scope.$watch(function() {return vm.request.services[vm.index-1].place}, function() {
        vm.request.services[vm.index].place = angular.copy(vm.request.services[vm.index-1].place);
      }, true);
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('VehiclesTableController', VehiclesTableController);

  /** @ngInject */
  function VehiclesTableController($filter, $scope, $state, $timeout, $alert, $validator, $error, $supplier, $solutions, uiGridConstants, $common, Filtersave, $window, VehicleModal) {
    var vm = this;


    vm.$onInit = function () {
      // vm.loaded = false;
      $supplier.isVerified().then(function (response) {
        vm.verified = response.verified;
      });
      vm.search = function (number) {

        var data = [];
        for (var i = 0; i < vm.unfiltered.length; i++) {
          if (vm.unfiltered[i].specs.plate.indexOf(number) !== -1) {
            data.push(vm.unfiltered[i]);

          }
        }
        vm.gridOptions.data = data;
        vm.gridApi.core.refresh();
      }
      vm.numPax = [];
      vm.minPax = 10000;
      vm.maxPax = 0;
      vm.saveFilter = function (filter) {
        //
        $supplier.saveFilter(filter).then(function (response) {
          $alert.show('Salvato', '', '', '', true, 0, 1200);
        });
      }
      vm.duplicate = function () {
        var toSend = angular.copy(vm.gridApi.selection.getSelectedRows()[0]);
        delete toSend.specs.plate;
        VehicleModal.show(toSend, true, 0, -1, function () {

        }, function () {
          $supplier.addVehicle(toSend.place_id, toSend.specs, toSend.services, toSend.costs, toSend.imgs).then(function (vehicle) {
            $state.reload();
          }, function (err) {
            vm.loaded = true;
            var str = $error.get(err, 'api');
            $alert.show(str.title, str.msg, 'Chiudi', '', true, 0, 5000);
          });
        })
      }
      $supplier.getVehicles().then(function (response) {
        vm.unfiltered = response.vehicles;
        vm.gridOptions = {
          paginationPageSizes: [20, 40, 80, 120],
          paginationPageSize: 20,
          minRowsToShow: 23,
          enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
          enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
          onRegisterApi: function (gridApi) {
            vm.gridApi = gridApi;
            vm.gridStyle.height = getTableHeight(1, 20, vm.gridOptions.data.length);

            vm.gridApi.grid.handleWindowResize();
            vm.gridApi.core.refresh();

            vm.gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
              vm.gridStyle.height = getTableHeight(newPage, pageSize, vm.gridOptions.data.length);

              vm.gridApi.grid.handleWindowResize();
              vm.gridApi.core.refresh();

            });
          }
        };
        vm.zoom = 100;
        vm.resize = function (percentage) {
          var columnDefs = referenceColumnDefs;
          for (var i = 0; i < columnDefs.length; i++) {
            if (columnDefs[i].width) {
              vm.gridOptions.columnDefs[i].width = columnDefs[i].width * percentage / 100;
            }
            if (columnDefs[i].minWidth) {
              vm.gridOptions.columnDefs[i].minWidth = columnDefs[i].minWidth * percentage / 100;
            }
            if (columnDefs[i].maxWidth) {
              vm.gridOptions.columnDefs[i].maxWidth = columnDefs[i].maxWidth * percentage / 100;
            }
          }
          vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
          if (percentage < 80) {

            vm.gridStyle['font-size'] = (percentage + 10) + '%';
          } else {
            vm.gridStyle['font-size'] = (percentage) + '%';
          }


        }

        $scope.$watch(function () {

          return vm.show;
        }, function () {
          if (vm.gridApi && vm.gridApi.core) {
            filterAll();
          }
        });
        vm.filterData = {};

        vm.export = function () {
          var selected = vm.gridApi.selection.getSelectedRows();

          var csvRow = [
            [
              '"Tipo di Richiesta"',
              '"N° Prenotazione"',
              '"Tipologia"',
              '"Pax"',
              '"Pick-Up"',
              '"Drop-Off"',
              '"Prezzo"',
              '"Servizio"',
              '"Ora d\'Inizio"',
              '"Data d\'Inizio"',
              '"Ora di Fine"',
              '"Data di Fine"',
            ]
          ];

          function identityFunction(v) {
            return v;
          }
          for (var i = 0; i < selected.length; i++) {
            csvRow.push('"' +
              $common.convertQuoteToCSV(selected[i], [
                ['Quote', 'request_type'],
                ['Quote', '_id'],
                ['Quote', 'service_type'],
                ['Quote', 'onboard', 'passengers'],
                ['Quote', 'pickup'],
                ['Quote', 'dropoff'],
                ['Quote', 'partnerTotal'],
                ['Quote', 'info'],
                ['Quote', 'startdate'],
                ['Quote', 'startdate'],
                ['Quote', 'enddate'],
                ['Quote', 'enddate'],
              ], [
                $filter('requestType'),
                $filter('quoteId'),
                $filter('serviceType'),
                identityFunction,
                identityFunction,
                identityFunction,
                $filter('currency'),
                $filter('currency'),
                identityFunction,
                $filter('time'),
                $filter('calendar'),
                $filter('time'),
                $filter('calendar'),
              ]).join('","') + '"')
          }


          var blob = new Blob([csvRow.join('\n')], {
            type: 'text/plain'
          });
          var url = $window.URL;
          vm.url = url.createObjectURL(blob);
          var link = angular.element('<a/>');

          link.css({
            display: 'none'
          });
          link.attr({
            href: url.createObjectURL(blob),
            target: '_blank',
            download: 'Prenotazioni_Busrapido_' + $filter('dates')(new Date()) + '.csv'
          })
          link[0].click();
          // clean up
          link.remove();
          url.revokeObjectURL(blob);
        }

        vm.gridStyle = {
          height: '600px'
        };

        function getTableHeight(currentPage, pageSize, dataLen) {
          var rowHeight = 30; // row height
          var headerHeight = 50; // header height
          var footerHeight = 60; // bottom scroll bar height
          var totalH = 0;
          var totalPage = Math.floor(dataLen / pageSize) + (dataLen % pageSize > 0 ? 1 : 0)
          if (totalPage > 1) {
            if (currentPage < totalPage) {
              totalH = pageSize * rowHeight + headerHeight + footerHeight;
            } else {
              var lastPageSize = dataLen % pageSize;
              if (lastPageSize === 0) {
                totalH = pageSize * rowHeight + headerHeight + footerHeight;
              } else {
                totalH = lastPageSize * rowHeight + headerHeight + footerHeight;
              }
            }

          } else {
            totalH = dataLen * rowHeight + headerHeight + footerHeight;
          }
          return $common.max(totalH, 300) + 'px';
        }
        var i = 0;
        var ok = {};
        var keys = [];
        var good = {

          specs: {
            seats: {

            }
          },
          services: {},
          costs: {},
        }

        good.specs.manufacturer = [];
        ok = {};
        for (i = 0; i < vm.unfiltered.length; i++) {
          ok[vm.unfiltered[i].specs.manufacturer] = true;
        }
        keys = Object.keys(ok);
        for (i = 0; i < keys.length; i++) {
          good.specs.manufacturer.push({
            name: keys[i],
            code: keys[i],
            selected: true
          })
        }


        good.specs.model = [];
        ok = {};
        for (i = 0; i < vm.unfiltered.length; i++) {
          ok[vm.unfiltered[i].specs.model] = true;
        }
        keys = Object.keys(ok);
        for (i = 0; i < keys.length; i++) {
          good.specs.model.push({
            name: keys[i],
            code: keys[i],
            selected: true
          })
        }


        good.specs.axis = [];
        ok = {};
        for (i = 0; i < vm.unfiltered.length; i++) {
          ok[vm.unfiltered[i].specs.axis] = true;
        }
        keys = Object.keys(ok);
        for (i = 0; i < keys.length; i++) {
          good.specs.axis.push({
            name: keys[i],
            code: keys[i],
            selected: true
          })
        }


        good.specs.emissionClass = [];
        ok = {};
        for (i = 0; i < vm.unfiltered.length; i++) {
          ok[vm.unfiltered[i].specs.emissionClass] = true;
        }
        keys = Object.keys(ok);
        for (i = 0; i < keys.length; i++) {
          good.specs.emissionClass.push({
            name: keys[i],
            code: keys[i],
            selected: true
          })
        }


        vm.filterData = {
          currentFilter: {
            between: [{
              "field": "specs.matriculation",
              "type": "date"
            }, {
              "field": "specs.seats.drivers",
              "type": "number"
            }, {
              "field": "specs.seats.passengers",
              "type": "number"
            }],
            belongs: [{
              "values": good.specs.manufacturer,
              "field": "specs.manufacturer",
              "type": "string",
              "value": []
            }, {
              "values": good.specs.model,
              "field": "specs.model",
              "type": "string",
              "value": []
            }, {
              "values": good.specs.axis,
              "field": "specs.axis",
              "type": "number",
              "value": []
            }, {
              "values": good.specs.emissionClass,
              "field": "specs.emissionClass",
              "type": "string",
              "value": []
            }, {
              "values": [{
                "selected": true,
                "code": "Y",
                "name": "S&igrave;"
              }, {
                "selected": true,
                "code": "N",
                "name": "No"
              }],
              "field": "services.audio",
              "type": "boolean",
              "value": []
            }, {
              "values": [{
                "selected": true,
                "code": "Y",
                "name": "S&igrave;"
              }, {
                "selected": true,
                "code": "N",
                "name": "No"
              }],
              "field": "services.coffeMachine",
              "type": "boolean",
              "value": []
            }, {
              "values": [{
                "selected": true,
                "code": "Y",
                "name": "S&igrave;"
              }, {
                "selected": true,
                "code": "N",
                "name": "No"
              }],
              "field": "services.conditioner",
              "type": "boolean",
              "value": []
            }, {
              "values": [{
                "selected": true,
                "code": "Y",
                "name": "S&igrave;"
              }, {
                "selected": true,
                "code": "N",
                "name": "No"
              }],
              "field": "services.display",
              "type": "boolean",
              "value": []
            }, {
              "values": [{
                "selected": true,
                "code": "Y",
                "name": "S&igrave;"
              }, {
                "selected": true,
                "code": "N",
                "name": "No"
              }],
              "field": "services.dvdPlayer",
              "type": "boolean",
              "value": []
            }, {
              "values": [{
                "selected": true,
                "code": "Y",
                "name": "S&igrave;"
              }, {
                "selected": true,
                "code": "N",
                "name": "No"
              }],
              "field": "services.electricity",
              "type": "boolean",
              "value": []
            }, {
              "values": [{
                "selected": true,
                "code": "Y",
                "name": "S&igrave;"
              }, {
                "selected": true,
                "code": "N",
                "name": "No"
              }],
              "field": "services.fridge",
              "type": "boolean",
              "value": []
            }, {
              "values": [{
                "selected": true,
                "code": "Y",
                "name": "S&igrave;"
              }, {
                "selected": true,
                "code": "N",
                "name": "No"
              }],
              "field": "services.kitchen",
              "type": "boolean",
              "value": []
            }, {
              "values": [{
                "selected": true,
                "code": "Y",
                "name": "S&igrave;"
              }, {
                "selected": true,
                "code": "N",
                "name": "No"
              }],
              "field": "services.leatherSeats",
              "type": "boolean",
              "value": []
            }, {
              "values": [{
                "selected": true,
                "code": "Y",
                "name": "S&igrave;"
              }, {
                "selected": true,
                "code": "N",
                "name": "No"
              }],
              "field": "services.light",
              "type": "boolean",
              "value": []
            }, {
              "values": [{
                "selected": true,
                "code": "Y",
                "name": "S&igrave;"
              }, {
                "selected": true,
                "code": "N",
                "name": "No"
              }],
              "field": "services.luggage",
              "type": "boolean",
              "value": []
            }, {
              "values": [{
                "selected": true,
                "code": "Y",
                "name": "S&igrave;"
              }, {
                "selected": true,
                "code": "N",
                "name": "No"
              }],
              "field": "services.microphone",
              "type": "boolean",
              "value": []
            }, {
              "values": [{
                "selected": true,
                "code": "Y",
                "name": "S&igrave;"
              }, {
                "selected": true,
                "code": "N",
                "name": "No"
              }],
              "field": "services.panoramicWindows",
              "type": "boolean",
              "value": []
            }, {
              "values": [{
                "selected": true,
                "code": "Y",
                "name": "S&igrave;"
              }, {
                "selected": true,
                "code": "N",
                "name": "No"
              }],
              "field": "services.radio",
              "type": "boolean",
              "value": []
            }, {
              "values": [{
                "selected": true,
                "code": "Y",
                "name": "S&igrave;"
              }, {
                "selected": true,
                "code": "N",
                "name": "No"
              }],
              "field": "services.tintedWindows",
              "type": "boolean",
              "value": []
            }, {
              "values": [{
                "selected": true,
                "code": "Y",
                "name": "S&igrave;"
              }, {
                "selected": true,
                "code": "N",
                "name": "No"
              }],
              "field": "services.toilet",
              "type": "boolean",
              "value": []
            }, {
              "values": [{
                "selected": true,
                "code": "Y",
                "name": "S&igrave;"
              }, {
                "selected": true,
                "code": "N",
                "name": "No"
              }],
              "field": "services.tvAerial",
              "type": "boolean",
              "value": []
            }, {
              "values": [{
                "selected": true,
                "code": "Y",
                "name": "S&igrave;"
              }, {
                "selected": true,
                "code": "N",
                "name": "No"
              }],
              "field": "services.usb",
              "type": "boolean",
              "value": []
            }, {
              "values": [{
                "selected": true,
                "code": "Y",
                "name": "S&igrave;"
              }, {
                "selected": true,
                "code": "N",
                "name": "No"
              }],
              "field": "services.wheelchair",
              "type": "boolean",
              "value": []
            }, {
              "values": [{
                "selected": true,
                "code": "Y",
                "name": "S&igrave;"
              }, {
                "selected": true,
                "code": "N",
                "name": "No"
              }],
              "field": "services.wifi",
              "type": "boolean",
              "value": []
            }],
            equals: [],
          }
        };


        var columnsData = {
          specs: {
            seats: {

            }
          },
          services: {},
          costs: {},
        };


        var columns = {
          specs: {
            seats: {

            }
          },
          services: {},
          costs: {},
        };


        var filterBase = {
          show: false,
          filterData: vm.filterData,
          onApply: function () {
            this.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },
        };


        var base = {
          enableColumnMenu: false,
          cellTooltip: true,
          headerCellTemplate: 'app/components/header-filter/generic.html',
          minWidth: 150
        }


        columnsData.specs.plate = angular.copy(filterBase);
        columnsData.specs.plate.label = 'Targa';
        columnsData.specs.plate.dataType = 'string';
        columnsData.specs.plate.filterData = vm.filterData;
        columnsData.specs.plate.field = 'specs.plate';

        columnsData.specs.manufacturer = angular.copy(filterBase);
        columnsData.specs.manufacturer.label = 'Marca';
        columnsData.specs.manufacturer.dataType = 'string';
        columnsData.specs.manufacturer.filterData = vm.filterData;
        columnsData.specs.manufacturer.field = 'specs.manufacturer';
        columnsData.specs.manufacturer.filterType = 'belongs';

        columnsData.specs.model = angular.copy(filterBase);
        columnsData.specs.model.label = 'Modello';
        columnsData.specs.model.dataType = 'string';
        columnsData.specs.model.filterData = vm.filterData;
        columnsData.specs.model.field = 'specs.model';
        columnsData.specs.model.filterType = 'belongs';

        columnsData.specs.matriculation = angular.copy(filterBase);
        columnsData.specs.matriculation.label = 'Immatricolazione';
        columnsData.specs.matriculation.dataType = 'date';
        columnsData.specs.matriculation.filterData = vm.filterData;
        columnsData.specs.matriculation.field = 'specs.matriculation';
        columnsData.specs.matriculation.filterType = 'between';

        columnsData.specs.axis = angular.copy(filterBase);
        columnsData.specs.axis.label = 'Assi';
        columnsData.specs.axis.dataType = 'number';
        columnsData.specs.axis.filterData = vm.filterData;
        columnsData.specs.axis.field = 'specs.axis';
        columnsData.specs.axis.filterType = 'belongs';

        columnsData.specs.seats.drivers = angular.copy(filterBase);
        columnsData.specs.seats.drivers.label = 'Posti autista';
        columnsData.specs.seats.drivers.dataType = 'number';
        columnsData.specs.seats.drivers.filterData = vm.filterData;
        columnsData.specs.seats.drivers.field = 'specs.seats.drivers';
        columnsData.specs.seats.drivers.filterType = 'between';

        columnsData.specs.seats.passengers = angular.copy(filterBase);
        columnsData.specs.seats.passengers.label = 'Posti passeggero';
        columnsData.specs.seats.passengers.dataType = 'number';
        columnsData.specs.seats.passengers.filterData = vm.filterData;
        columnsData.specs.seats.passengers.field = 'specs.seats.passengers';
        columnsData.specs.seats.passengers.filterType = 'between';

        columnsData.specs.emissionClass = angular.copy(filterBase);
        columnsData.specs.emissionClass.label = 'Euro';
        columnsData.specs.emissionClass.dataType = 'string';
        columnsData.specs.emissionClass.filterData = vm.filterData;
        columnsData.specs.emissionClass.field = 'specs.emissionClass';
        columnsData.specs.emissionClass.filterType = 'belongs';

        columnsData.services.audio = angular.copy(filterBase);
        columnsData.services.audio.label = 'Impianto stereo';
        columnsData.services.audio.dataType = 'boolean';
        columnsData.services.audio.filterData = vm.filterData;
        columnsData.services.audio.field = 'services.audio';
        columnsData.services.audio.filterType = 'belongs';

        columnsData.services.coffeMachine = angular.copy(filterBase);
        columnsData.services.coffeMachine.label = 'Macchina del caff&egrave;';
        columnsData.services.coffeMachine.dataType = 'boolean';
        columnsData.services.coffeMachine.filterData = vm.filterData;
        columnsData.services.coffeMachine.field = 'services.coffeMachine';
        columnsData.services.coffeMachine.filterType = 'belongs';

        columnsData.services.conditioner = angular.copy(filterBase);
        columnsData.services.conditioner.label = 'Aria condizionata';
        columnsData.services.conditioner.dataType = 'boolean';
        columnsData.services.conditioner.filterData = vm.filterData;
        columnsData.services.conditioner.field = 'services.conditioner';
        columnsData.services.conditioner.filterType = 'belongs';

        columnsData.services.display = angular.copy(filterBase);
        columnsData.services.display.label = 'Schermo TV';
        columnsData.services.display.dataType = 'boolean';
        columnsData.services.display.filterData = vm.filterData;
        columnsData.services.display.field = 'services.display';
        columnsData.services.display.filterType = 'belongs';

        columnsData.services.dvdPlayer = angular.copy(filterBase);
        columnsData.services.dvdPlayer.label = 'Lettore DVD';
        columnsData.services.dvdPlayer.dataType = 'boolean';
        columnsData.services.dvdPlayer.filterData = vm.filterData;
        columnsData.services.dvdPlayer.field = 'services.dvdPlayer';
        columnsData.services.dvdPlayer.filterType = 'belongs';

        columnsData.services.electricity = angular.copy(filterBase);
        columnsData.services.electricity.label = 'Prese elettriche';
        columnsData.services.electricity.dataType = 'boolean';
        columnsData.services.electricity.filterData = vm.filterData;
        columnsData.services.electricity.field = 'services.electricity';
        columnsData.services.electricity.filterType = 'belongs';

        columnsData.services.fridge = angular.copy(filterBase);
        columnsData.services.fridge.label = 'Mini Frigorifero';
        columnsData.services.fridge.dataType = 'boolean';
        columnsData.services.fridge.filterData = vm.filterData;
        columnsData.services.fridge.field = 'services.fridge';
        columnsData.services.fridge.filterType = 'belongs';

        columnsData.services.kitchen = angular.copy(filterBase);
        columnsData.services.kitchen.label = 'Cucina a bordo';
        columnsData.services.kitchen.dataType = 'boolean';
        columnsData.services.kitchen.filterData = vm.filterData;
        columnsData.services.kitchen.field = 'services.kitchen';
        columnsData.services.kitchen.filterType = 'belongs';

        columnsData.services.leatherSeats = angular.copy(filterBase);
        columnsData.services.leatherSeats.label = 'Sedili in pelle';
        columnsData.services.leatherSeats.dataType = 'boolean';
        columnsData.services.leatherSeats.filterData = vm.filterData;
        columnsData.services.leatherSeats.field = 'services.leatherSeats';
        columnsData.services.leatherSeats.filterType = 'belongs';

        columnsData.services.light = angular.copy(filterBase);
        columnsData.services.light.label = 'Luce da lettura';
        columnsData.services.light.dataType = 'boolean';
        columnsData.services.light.filterData = vm.filterData;
        columnsData.services.light.field = 'services.light';
        columnsData.services.light.filterType = 'belongs';

        columnsData.services.luggage = angular.copy(filterBase);
        columnsData.services.luggage.label = 'Vano valige';
        columnsData.services.luggage.dataType = 'boolean';
        columnsData.services.luggage.filterData = vm.filterData;
        columnsData.services.luggage.field = 'services.luggage';
        columnsData.services.luggage.filterType = 'belongs';

        columnsData.services.microphone = angular.copy(filterBase);
        columnsData.services.microphone.label = 'Microfono';
        columnsData.services.microphone.dataType = 'boolean';
        columnsData.services.microphone.filterData = vm.filterData;
        columnsData.services.microphone.field = 'services.microphone';
        columnsData.services.microphone.filterType = 'belongs';

        columnsData.services.panoramicWindows = angular.copy(filterBase);
        columnsData.services.panoramicWindows.label = 'Vetri panoramici';
        columnsData.services.panoramicWindows.dataType = 'boolean';
        columnsData.services.panoramicWindows.filterData = vm.filterData;
        columnsData.services.panoramicWindows.field = 'services.panoramicWindows';
        columnsData.services.panoramicWindows.filterType = 'belongs';

        columnsData.services.radio = angular.copy(filterBase);
        columnsData.services.radio.label = 'Radio';
        columnsData.services.radio.dataType = 'boolean';
        columnsData.services.radio.filterData = vm.filterData;
        columnsData.services.radio.field = 'services.radio';
        columnsData.services.radio.filterType = 'belongs';

        columnsData.services.tintedWindows = angular.copy(filterBase);
        columnsData.services.tintedWindows.label = 'Vetri oscurati';
        columnsData.services.tintedWindows.dataType = 'boolean';
        columnsData.services.tintedWindows.filterData = vm.filterData;
        columnsData.services.tintedWindows.field = 'services.tintedWindows';
        columnsData.services.tintedWindows.filterType = 'belongs';

        columnsData.services.toilet = angular.copy(filterBase);
        columnsData.services.toilet.label = 'Toilet';
        columnsData.services.toilet.dataType = 'boolean';
        columnsData.services.toilet.filterData = vm.filterData;
        columnsData.services.toilet.field = 'services.toilet';
        columnsData.services.toilet.filterType = 'belongs';

        columnsData.services.tvAerial = angular.copy(filterBase);
        columnsData.services.tvAerial.label = 'Antenna TV';
        columnsData.services.tvAerial.dataType = 'boolean';
        columnsData.services.tvAerial.filterData = vm.filterData;
        columnsData.services.tvAerial.field = 'services.tvAerial';
        columnsData.services.tvAerial.filterType = 'belongs';

        columnsData.services.usb = angular.copy(filterBase);
        columnsData.services.usb.label = 'Carica USB';
        columnsData.services.usb.dataType = 'boolean';
        columnsData.services.usb.filterData = vm.filterData;
        columnsData.services.usb.field = 'services.usb';
        columnsData.services.usb.filterType = 'belongs';

        columnsData.services.wheelchair = angular.copy(filterBase);
        columnsData.services.wheelchair.label = 'Pedana carrozzine';
        columnsData.services.wheelchair.dataType = 'boolean';
        columnsData.services.wheelchair.filterData = vm.filterData;
        columnsData.services.wheelchair.field = 'services.wheelchair';
        columnsData.services.wheelchair.filterType = 'belongs';

        columnsData.services.wifi = angular.copy(filterBase);
        columnsData.services.wifi.label = 'Wi-Fi';
        columnsData.services.wifi.dataType = 'boolean';
        columnsData.services.wifi.filterData = vm.filterData;
        columnsData.services.wifi.field = 'services.wifi';
        columnsData.services.wifi.filterType = 'belongs';

        columns.specs.plate = angular.copy(base);
        columns.specs.plate.field = 'specs.plate';
        columns.specs.plate.name = 'Targa';
        columns.specs.plate.data = columnsData.specs.plate;
        columns.specs.plate.cellTemplate = '<div class="ui-grid-cell-contents"  title="{{COL_FIELD CUSTOM_FILTERS}}"><a ui-sref="root.it.supplier.vehicles.edit({\'id\': row.entity._id})">{{COL_FIELD CUSTOM_FILTERS}}</a></div>';

        columns.specs.manufacturer = angular.copy(base);
        columns.specs.manufacturer.field = 'specs.manufacturer';
        columns.specs.manufacturer.name = 'Marca';
        columns.specs.manufacturer.data = columnsData.specs.manufacturer;

        columns.specs.model = angular.copy(base);
        columns.specs.model.field = 'specs.model';
        columns.specs.model.name = 'Modello';
        columns.specs.model.data = columnsData.specs.model;

        columns.specs.matriculation = angular.copy(base);
        columns.specs.matriculation.field = 'specs.matriculation';
        columns.specs.matriculation.name = 'Immatricolazione';
        columns.specs.matriculation.data = columnsData.specs.matriculation;
        columns.specs.matriculation.width = 80;

        columns.specs.axis = angular.copy(base);
        columns.specs.axis.field = 'specs.axis';
        columns.specs.axis.name = 'Assi';
        columns.specs.axis.data = columnsData.specs.axis;
        columns.specs.axis.width = 60;

        columns.specs.seats.drivers = angular.copy(base);
        columns.specs.seats.drivers.field = 'specs.seats.drivers';
        columns.specs.seats.drivers.name = 'Posti autista';
        columns.specs.seats.drivers.data = columnsData.specs.seats.drivers;
        columns.specs.seats.drivers.width = 60;

        columns.specs.seats.passengers = angular.copy(base);
        columns.specs.seats.passengers.field = 'specs.seats.passengers';
        columns.specs.seats.passengers.name = 'Posti passeggero';
        columns.specs.seats.passengers.data = columnsData.specs.seats.passengers;
        columns.specs.seats.passengers.width = 60;
        columnsData.specs.seats.passengers.icon = 'icon-users';

        columns.specs.emissionClass = angular.copy(base);
        columns.specs.emissionClass.field = 'specs.emissionClass';
        columns.specs.emissionClass.name = 'Euro';
        columns.specs.emissionClass.data = columnsData.specs.emissionClass;
        columns.specs.emissionClass.width = 80;

        columns.services.audio = angular.copy(base);
        columns.services.audio.field = 'services.audio';
        columns.services.audio.name = 'Impianto stereo';
        columns.services.audio.data = columnsData.services.audio;
        columns.services.audio.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';
        columnsData.services.audio.icon = 'icon-music-player';
        columns.services.audio.width = 60;

        columns.services.coffeMachine = angular.copy(base);
        columns.services.coffeMachine.field = 'services.coffeMachine';
        columns.services.coffeMachine.name = 'Macchina del caff&egrave;';
        columns.services.coffeMachine.data = columnsData.services.coffeMachine;
        columns.services.coffeMachine.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';
        columnsData.services.coffeMachine.icon = 'icon-coffee-machine';
        columns.services.coffeMachine.width = 60;

        columns.services.conditioner = angular.copy(base);
        columns.services.conditioner.field = 'services.conditioner';
        columns.services.conditioner.name = 'Aria condizionata';
        columns.services.conditioner.data = columnsData.services.conditioner;
        columns.services.conditioner.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';
        columnsData.services.conditioner.icon = 'icon-air-conditioner';
        columns.services.conditioner.width = 60;

        columns.services.display = angular.copy(base);
        columns.services.display.field = 'services.display';
        columns.services.display.name = 'Schermo TV';
        columns.services.display.data = columnsData.services.display;
        columns.services.display.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';
        columnsData.services.display.icon = 'icon-monitor';
        columns.services.display.width = 60;

        columns.services.dvdPlayer = angular.copy(base);
        columns.services.dvdPlayer.field = 'services.dvdPlayer';
        columns.services.dvdPlayer.name = 'Lettore DVD';
        columns.services.dvdPlayer.data = columnsData.services.dvdPlayer;
        columns.services.dvdPlayer.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';
        columnsData.services.dvdPlayer.icon = 'icon-dvd';
        columns.services.dvdPlayer.width = 60;

        columns.services.electricity = angular.copy(base);
        columns.services.electricity.field = 'services.electricity';
        columns.services.electricity.name = 'Prese elettriche';
        columns.services.electricity.data = columnsData.services.electricity;
        columns.services.electricity.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';
        columnsData.services.electricity.icon = 'icon-plug';
        columns.services.electricity.width = 60;

        columns.services.fridge = angular.copy(base);
        columns.services.fridge.field = 'services.fridge';
        columns.services.fridge.name = 'Mini Frigorifero';
        columns.services.fridge.data = columnsData.services.fridge;
        columns.services.fridge.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';
        columnsData.services.fridge.icon = 'icon-fridge';
        columns.services.fridge.width = 60;

        columns.services.kitchen = angular.copy(base);
        columns.services.kitchen.field = 'services.kitchen';
        columns.services.kitchen.name = 'Cucina a bordo';
        columns.services.kitchen.data = columnsData.services.kitchen;
        columns.services.kitchen.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';
        columnsData.services.kitchen.icon = 'icon-oven';
        columns.services.kitchen.width = 60;

        columns.services.leatherSeats = angular.copy(base);
        columns.services.leatherSeats.field = 'services.leatherSeats';
        columns.services.leatherSeats.name = 'Sedili in pelle';
        columns.services.leatherSeats.data = columnsData.services.leatherSeats;
        columns.services.leatherSeats.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';
        columnsData.services.leatherSeats.icon = 'icon-leather';
        columns.services.leatherSeats.width = 60;

        columns.services.light = angular.copy(base);
        columns.services.light.field = 'services.light';
        columns.services.light.name = 'Luce da lettura';
        columns.services.light.data = columnsData.services.light;
        columns.services.light.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';
        columnsData.services.light.icon = 'icon-idea';
        columns.services.light.width = 60;

        columns.services.luggage = angular.copy(base);
        columns.services.luggage.field = 'services.luggage';
        columns.services.luggage.name = 'Vano valige';
        columns.services.luggage.data = columnsData.services.luggage;
        columns.services.luggage.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';
        columnsData.services.luggage.icon = 'icon-luggage';
        columns.services.luggage.width = 60;

        columns.services.microphone = angular.copy(base);
        columns.services.microphone.field = 'services.microphone';
        columns.services.microphone.name = 'Microfono';
        columns.services.microphone.data = columnsData.services.microphone;
        columns.services.microphone.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';
        columnsData.services.microphone.icon = 'icon-karaoke';
        columns.services.microphone.width = 60;

        columns.services.panoramicWindows = angular.copy(base);
        columns.services.panoramicWindows.field = 'services.panoramicWindows';
        columns.services.panoramicWindows.name = 'Vetri panoramici';
        columns.services.panoramicWindows.data = columnsData.services.panoramicWindows;
        columns.services.panoramicWindows.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';
        columnsData.services.panoramicWindows.icon = 'icon-window';
        columns.services.panoramicWindows.width = 60;

        columns.services.radio = angular.copy(base);
        columns.services.radio.field = 'services.radio';
        columns.services.radio.name = 'Radio';
        columns.services.radio.data = columnsData.services.radio;
        columns.services.radio.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';
        columnsData.services.radio.icon = 'icon-radio';
        columns.services.radio.width = 60;

        columns.services.tintedWindows = angular.copy(base);
        columns.services.tintedWindows.field = 'services.tintedWindows';
        columns.services.tintedWindows.name = 'Vetri oscurati';
        columns.services.tintedWindows.data = columnsData.services.tintedWindows;
        columns.services.tintedWindows.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';
        columnsData.services.tintedWindows.icon = 'icon-window-tinted';
        columns.services.tintedWindows.width = 60;

        columns.services.toilet = angular.copy(base);
        columns.services.toilet.field = 'services.toilet';
        columns.services.toilet.name = 'Toilet';
        columns.services.toilet.data = columnsData.services.toilet;
        columns.services.toilet.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';
        columnsData.services.toilet.icon = 'icon-toilet';
        columns.services.toilet.width = 60;

        columns.services.tvAerial = angular.copy(base);
        columns.services.tvAerial.field = 'services.tvAerial';
        columns.services.tvAerial.name = 'Antenna TV';
        columns.services.tvAerial.data = columnsData.services.tvAerial;
        columns.services.tvAerial.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';
        columnsData.services.tvAerial.icon = 'icon-television';
        columns.services.tvAerial.width = 60;

        columns.services.usb = angular.copy(base);
        columns.services.usb.field = 'services.usb';
        columns.services.usb.name = 'Carica USB';
        columns.services.usb.data = columnsData.services.usb;
        columns.services.usb.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';
        columnsData.services.usb.icon = 'icon-usb';
        columns.services.usb.width = 60;

        columns.services.wheelchair = angular.copy(base);
        columns.services.wheelchair.field = 'services.wheelchair';
        columns.services.wheelchair.name = 'Pedana carrozzine';
        columns.services.wheelchair.data = columnsData.services.wheelchair;
        columns.services.wheelchair.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';
        columnsData.services.wheelchair.icon = 'icon-wheelchair';
        columns.services.wheelchair.width = 60;

        columns.services.wifi = angular.copy(base);
        columns.services.wifi.field = 'services.wifi';
        columns.services.wifi.name = 'Wi-Fi';
        columns.services.wifi.data = columnsData.services.wifi;
        columns.services.wifi.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';
        columnsData.services.wifi.icon = 'icon-connection';
        columns.services.wifi.width = 60;
        vm.defaultColumnDefs = [
          columns.specs.plate,
          columns.specs.manufacturer,
          columns.specs.model,
          columns.specs.matriculation,
          columns.specs.axis,
          columns.specs.seats.drivers,
          columns.specs.seats.passengers,
          columns.specs.emissionClass,
          columns.services.audio,
          columns.services.coffeMachine,
          columns.services.conditioner,
          columns.services.display,
          columns.services.dvdPlayer,
          columns.services.electricity,
          columns.services.fridge,
          columns.services.kitchen,
          columns.services.leatherSeats,
          columns.services.light,
          columns.services.luggage,
          columns.services.microphone,
          columns.services.panoramicWindows,
          columns.services.radio,
          columns.services.tintedWindows,
          columns.services.toilet,
          columns.services.tvAerial,
          columns.services.usb,
          columns.services.wheelchair,
          columns.services.wifi,
        ]

        function filterAll() {
          var filter = {
            specs: {
              seats: {

              }
            },
            services: {},
            costs: {},
          };
          var data = vm.unfiltered;
          filter.specs.manufacturer = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'specs.manufacturer';
          });
          data = $common.filterContained(data, 'specs.manufacturer', filter.specs.manufacturer.values);
          filter.specs.model = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'specs.model';
          });
          data = $common.filterContained(data, 'specs.model', filter.specs.model.values);
          filter.specs.matriculation = vm.currentFilter.between.find(function (element) {
            return element.field === 'specs.matriculation';
          });
          data = $common.filterNumber(data, 'specs.matriculation', filter.specs.matriculation.min, filter.specs.matriculation.max);
          filter.specs.axis = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'specs.axis';
          });
          data = $common.filterContained(data, 'specs.axis', filter.specs.axis.values);
          filter.specs.seats.drivers = vm.currentFilter.between.find(function (element) {
            return element.field === 'specs.seats.drivers';
          });
          data = $common.filterNumber(data, 'specs.seats.drivers', filter.specs.seats.drivers.min, filter.specs.seats.drivers.max);
          filter.specs.seats.passengers = vm.currentFilter.between.find(function (element) {
            return element.field === 'specs.seats.passengers';
          });
          data = $common.filterNumber(data, 'specs.seats.passengers', filter.specs.seats.passengers.min, filter.specs.seats.passengers.max);
          filter.specs.emissionClass = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'specs.emissionClass';
          });
          data = $common.filterContained(data, 'specs.emissionClass', filter.specs.emissionClass.values);
          filter.services.audio = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'services.audio';
          });
          data = $common.filterBoolean(data, 'services.audio', filter.services.audio.values);
          filter.services.coffeMachine = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'services.coffeMachine';
          });
          data = $common.filterBoolean(data, 'services.coffeMachine', filter.services.coffeMachine.values);
          filter.services.conditioner = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'services.conditioner';
          });
          data = $common.filterBoolean(data, 'services.conditioner', filter.services.conditioner.values);
          filter.services.display = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'services.display';
          });
          data = $common.filterBoolean(data, 'services.display', filter.services.display.values);
          filter.services.dvdPlayer = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'services.dvdPlayer';
          });
          data = $common.filterBoolean(data, 'services.dvdPlayer', filter.services.dvdPlayer.values);
          filter.services.electricity = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'services.electricity';
          });
          data = $common.filterBoolean(data, 'services.electricity', filter.services.electricity.values);
          filter.services.fridge = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'services.fridge';
          });
          data = $common.filterBoolean(data, 'services.fridge', filter.services.fridge.values);
          filter.services.kitchen = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'services.kitchen';
          });
          data = $common.filterBoolean(data, 'services.kitchen', filter.services.kitchen.values);
          filter.services.leatherSeats = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'services.leatherSeats';
          });
          data = $common.filterBoolean(data, 'services.leatherSeats', filter.services.leatherSeats.values);
          filter.services.light = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'services.light';
          });
          data = $common.filterBoolean(data, 'services.light', filter.services.light.values);
          filter.services.luggage = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'services.luggage';
          });
          data = $common.filterBoolean(data, 'services.luggage', filter.services.luggage.values);
          filter.services.microphone = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'services.microphone';
          });
          data = $common.filterBoolean(data, 'services.microphone', filter.services.microphone.values);
          filter.services.panoramicWindows = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'services.panoramicWindows';
          });
          data = $common.filterBoolean(data, 'services.panoramicWindows', filter.services.panoramicWindows.values);
          filter.services.radio = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'services.radio';
          });
          data = $common.filterBoolean(data, 'services.radio', filter.services.radio.values);
          filter.services.tintedWindows = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'services.tintedWindows';
          });
          data = $common.filterBoolean(data, 'services.tintedWindows', filter.services.tintedWindows.values);
          filter.services.toilet = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'services.toilet';
          });
          data = $common.filterBoolean(data, 'services.toilet', filter.services.toilet.values);
          filter.services.tvAerial = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'services.tvAerial';
          });
          data = $common.filterBoolean(data, 'services.tvAerial', filter.services.tvAerial.values);
          filter.services.usb = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'services.usb';
          });
          data = $common.filterBoolean(data, 'services.usb', filter.services.usb.values);
          filter.services.wheelchair = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'services.wheelchair';
          });
          data = $common.filterBoolean(data, 'services.wheelchair', filter.services.wheelchair.values);
          filter.services.wifi = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'services.wifi';
          });
          data = $common.filterBoolean(data, 'services.wifi', filter.services.wifi.values);


          vm.gridOptions.data = data;
          vm.gridApi.core.refresh();
        }




        vm.gridOptions.columnDefs = (vm.defaultColumnDefs);
        var referenceColumnDefs = angular.copy(vm.defaultColumnDefs);
        vm.gridOptions.data = vm.unfiltered;
        vm.loaded = true;
      }, function (err) {
        var str = $error.get(err, 'api');
        $alert.show(str.title, str.msg, 'Ricarica', '', true, 0, 5000,
          function (cancel) {
            $state.reload();
          });
      });

    }
  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('SentQuotesController', SentQuotesController);

  /** @ngInject */
  function SentQuotesController($filter, $scope, $state, $alert, $error, $supplier, uiGridConstants, $common, $window) {
    var vm = this;
    console.log('what')
    console.log('what')
    console.log('what')
    vm.createQuote = function () {
      console.log('create quote')
      $supplier.updateQuote({}).then(function (response) {
        $state.go('root.it.supplier.sentquotes.edit', {
          id: response.quote.id
        });
      }, function (err) {
        var str = $error.get(err, 'api');
        $alert.show(str.title, str.msg, 'Ricarica', '', true, 0, 5000,
          function (cancel) {
            $state.reload();
          });
      });
    };

    vm.$onInit = function () {
      // vm.loaded = false;
      $supplier.isVerified().then(function (response) {
        vm.verified = response.verified;
      });


      vm.search = function (number) {

        var data = [];
        for (var i = 0; i < vm.unfiltered.length; i++) {
          if (vm.unfiltered[i].specs.plate.indexOf(number) !== -1) {
            data.push(vm.unfiltered[i]);

          }
        }
        vm.gridOptions.data = data;
        vm.gridApi.core.refresh();
      }
      vm.numPax = [];
      vm.minPax = 10000;
      vm.maxPax = 0;
      vm.saveFilter = function (filter) {
        //
        $supplier.saveFilter(filter).then(function (response) {
          $alert.show('Salvato', '', '', '', true, 0, 1200);
        });
      }
      vm.duplicate = function () {
        $alert.show('Vuoi duplicare la richiesta?', '', 'Non duplicare', 'Duplica', false, 0, -1,
          function () {

          },
          function () {
            $supplier.duplicateQuote(vm.gridApi.selection.getSelectedRows()[0]._id).then(function (response) {
              $state.go('root.it.supplier.sentquotes.edit', {
                id: response.quote.id
              });
            }, function (err) {
              var str = $error.get(err, 'api');
              $alert.show(str.title, str.msg, 'Ricarica', '', true, 0, 5000,
                function (cancel) {
                  $state.reload();
                });
            });
          });


        vm.reload()
      }
      $supplier.getSentQuotes().then(function (response) {
        vm.unfiltered = response.quotes;
        vm.numPassengers = [];
        vm.minPassengers = 10000;
        vm.maxPassengers = 0;
        for (var i = 0; i < vm.unfiltered.length; i++) {
          vm.unfiltered[i].partnerTotal = $common.getPartnerPrice(vm.unfiltered[i]);
          vm.unfiltered[i].action = 'modifica';
          vm.unfiltered[i].number = $filter('quoteId')(vm.unfiltered[i].id);
          /*
            if (angular.isDefined(vm.unfiltered[i].trip) && angular.isDefined(vm.unfiltered[i].trip.steps) && vm.unfiltered[i].trip.steps.length > 0) {
              vm.unfiltered[i].pickup = vm.unfiltered[i].trip.steps[0].place.address || '';
              var startdate = new Date(vm.unfiltered[i].trip.steps[0].depart);
              vm.unfiltered[i].startdate = startdate;
              vm.unfiltered[i].dropoff = vm.unfiltered[i].trip.steps[vm.unfiltered[i].trip.steps.length - 1].place.address || '';
              var enddate = new Date(vm.unfiltered[i].trip.steps[vm.unfiltered[i].trip.steps.length - 1].arrive);
              vm.unfiltered[i].enddate = enddate;
            }
          */
          // if (angular.isDefined(vm.unfiltered[i].service_type)) {
          //  vm.serviceTypes.push(vm.unfiltered[i].service_type);
          // }
          if (angular.isDefined(vm.unfiltered[i].onboard)) {
            vm.numPassengers.push(vm.unfiltered[i].onboard.passengers);
            vm.minPassengers = $common.min(vm.minPassengers, vm.unfiltered[i].onboard.passengers);
            vm.maxPassengers = $common.max(vm.maxPassengers, vm.unfiltered[i].onboard.passengers);
            vm.numPassengers.sort();
          }
          if (angular.isDefined(vm.unfiltered[i].requests[0])) {
            if (angular.isDefined(vm.unfiltered[i].requests[0].services)) {
              vm.unfiltered[i].pickup = vm.unfiltered[i].requests[0].services[0].place.address;
              vm.unfiltered[i].dropoff = vm.unfiltered[i].requests[vm.unfiltered[i].requests.length - 1].services[vm.unfiltered[i].requests[vm.unfiltered[i].requests.length - 1].services.length - 1].place.address;
            } else {
              vm.unfiltered[i].pickup = '';
              vm.unfiltered[i].dropoff = '';
            }
            for (var requestIndex = 0; requestIndex < vm.unfiltered[i].requests.length; requestIndex++) {
              var request = vm.unfiltered[i].requests[requestIndex];
              for (var serviceIndex = 0; serviceIndex < request.services.length; serviceIndex++) {
                var service = request.services[serviceIndex];
                vm.unfiltered[i].startdate = vm.unfiltered[i].startdate ? new Date($common.min(vm.unfiltered[i].startdate.getTime(), new Date(service.depart).getTime())) : new Date(service.depart);
                vm.unfiltered[i].enddate = vm.unfiltered[i].enddate ? new Date($common.max(vm.unfiltered[i].enddate.getTime(), new Date(service.depart).getTime())) : new Date(service.depart);
              }
            }
          }
        }
        for (var paxIndex = 1; paxIndex < vm.numPassengers.length;) {
          if (vm.numPassengers[paxIndex] == vm.numPassengers[paxIndex - 1]) {
            vm.numPassengers.splice(paxIndex, 1);
          } else {
            paxIndex++;
          }
        }
        vm.search = function (number) {
          var data = [];
          for (var i = 0; i < vm.unfiltered.length; i++) {
            if (vm.unfiltered[i].number.indexOf(number) !== -1) {
              data.push(vm.unfiltered[i]);
            }
          }
          vm.gridOptions.data = data;
          vm.gridApi.core.refresh();
        }
        $scope.$watch(function () {
          return vm.filters;
        }, function () {
          if (vm.loaded && vm.gridApi) {
            var data = [];
            for (var i = 0; i < vm.unfiltered.length; i++) {
              if (vm.unfiltered[i].status.indexOf(vm.filters) !== -1) {
                data.push(vm.unfiltered[i]);
              }
            }
            vm.gridOptions.data = data;
            vm.gridApi.core.refresh();
          }
        });
        ////console.log(vm.unfiltered)
        vm.pickups = {
          selected: []
        };
        vm.dropoffs = {
          selected: []
        };

        vm.places = $common.places;
        vm.goodPickup = {};
        vm.goodDropoff = {};
        for (var placesIndex = 0; placesIndex < vm.places.length; placesIndex++) {
          vm.goodPickup[vm.places[placesIndex].code] = 0;
          vm.goodDropoff[vm.places[placesIndex].code] = 0;
        }
        for (var quoteIndex = 0; quoteIndex < vm.unfiltered.length; quoteIndex++) {
          if (vm.unfiltered[quoteIndex].pickup) {
            var addressTokens = vm.unfiltered[quoteIndex].pickup.split(/[^\w]/);
            for (var addressIndex = 0; addressIndex < addressTokens.length; addressIndex++) {
              if (vm.goodPickup[addressTokens[addressIndex]] === 0) {
                vm.goodPickup[addressTokens[addressIndex]] = 1;
              }
            }
            addressTokens = vm.unfiltered[quoteIndex].dropoff.split(/[^\w]/);
            for (addressIndex = 0; addressIndex < addressTokens.length; addressIndex++) {
              if (vm.goodDropoff[addressTokens[addressIndex]] === 0) {
                vm.goodDropoff[addressTokens[addressIndex]] = 1;
              }
            }
          }
        }
        vm.placePickups = [];
        for (placesIndex = 0; placesIndex < vm.places.length; placesIndex++) {
          if (vm.goodPickup[vm.places[placesIndex].code] === 1) {
            vm.placePickups.push(vm.places[placesIndex]);
          }
        }
        vm.placeDropoffs = [];
        for (placesIndex = 0; placesIndex < vm.places.length; placesIndex++) {
          if (vm.goodDropoff[vm.places[placesIndex].code] === 1) {
            vm.placeDropoffs.push(vm.places[placesIndex]);
          }
        }
        vm.unfiltered = response.quotes;
        vm.gridOptions = {
          paginationPageSizes: [20, 40, 80, 120],
          paginationPageSize: 20,
          minRowsToShow: 23,
          enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
          enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
          onRegisterApi: function (gridApi) {
            vm.gridApi = gridApi;
            vm.gridStyle.height = getTableHeight(1, 20, vm.gridOptions.data.length);

            vm.gridApi.grid.handleWindowResize();
            vm.gridApi.core.refresh();

            vm.gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
              vm.gridStyle.height = getTableHeight(newPage, pageSize, vm.gridOptions.data.length);

              vm.gridApi.grid.handleWindowResize();
              vm.gridApi.core.refresh();

            });
          }
        };
        vm.zoom = 100;
        vm.resize = function (percentage) {
          var columnDefs = referenceColumnDefs;
          for (var i = 0; i < columnDefs.length; i++) {
            if (columnDefs[i].width) {
              vm.gridOptions.columnDefs[i].width = columnDefs[i].width * percentage / 100;
            }
            if (columnDefs[i].minWidth) {
              vm.gridOptions.columnDefs[i].minWidth = columnDefs[i].minWidth * percentage / 100;
            }
            if (columnDefs[i].maxWidth) {
              vm.gridOptions.columnDefs[i].maxWidth = columnDefs[i].maxWidth * percentage / 100;
            }
          }
          vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
          if (percentage < 80) {

            vm.gridStyle['font-size'] = (percentage + 10) + '%';
          } else {
            vm.gridStyle['font-size'] = (percentage) + '%';
          }


        }

        $scope.$watch(function () {

          return vm.show;
        }, function () {
          if (vm.gridApi && vm.gridApi.core) {
            filterAll();
          }
        });
        vm.filterData = {};

        vm.export = function () {
          var selected = vm.gridApi.selection.getSelectedRows();

          var csvRow = [
            [
              '"Tipo di Richiesta"',
              '"N° Prenotazione"',
              '"Tipologia"',
              '"Pax"',
              '"Pick-Up"',
              '"Drop-Off"',
              '"Prezzo"',
              '"Servizio"',
              '"Ora d\'Inizio"',
              '"Data d\'Inizio"',
              '"Ora di Fine"',
              '"Data di Fine"',
            ]
          ];

          function identityFunction(v) {
            return v;
          }
          for (var i = 0; i < selected.length; i++) {
            csvRow.push('"' +
              $common.convertQuoteToCSV(selected[i], [
                ['Quote', 'request_type'],
                ['Quote', '_id'],
                ['Quote', 'service_type'],
                ['Quote', 'onboard', 'passengers'],
                ['Quote', 'pickup'],
                ['Quote', 'dropoff'],
                ['Quote', 'partnerTotal'],
                ['Quote', 'info'],
                ['Quote', 'startdate'],
                ['Quote', 'startdate'],
                ['Quote', 'enddate'],
                ['Quote', 'enddate'],
              ], [
                $filter('requestType'),
                $filter('quoteId'),
                $filter('serviceType'),
                identityFunction,
                identityFunction,
                identityFunction,
                $filter('currency'),
                $filter('currency'),
                identityFunction,
                $filter('time'),
                $filter('calendar'),
                $filter('time'),
                $filter('calendar'),
              ]).join('","') + '"')
          }


          var blob = new Blob([csvRow.join('\n')], {
            type: 'text/plain'
          });
          var url = $window.URL;
          vm.url = url.createObjectURL(blob);
          var link = angular.element('<a/>');

          link.css({
            display: 'none'
          });
          link.attr({
            href: url.createObjectURL(blob),
            target: '_blank',
            download: 'Prenotazioni_Busrapido_' + $filter('dates')(new Date()) + '.csv'
          })
          link[0].click();
          // clean up
          link.remove();
          url.revokeObjectURL(blob);
        }

        vm.gridStyle = {
          height: '600px'
        };

        function getTableHeight(currentPage, pageSize, dataLen) {
          var rowHeight = 30; // row height
          var headerHeight = 50; // header height
          var footerHeight = 60; // bottom scroll bar height
          var totalH = 0;
          var totalPage = Math.floor(dataLen / pageSize) + (dataLen % pageSize > 0 ? 1 : 0)
          if (totalPage > 1) {
            if (currentPage < totalPage) {
              totalH = pageSize * rowHeight + headerHeight + footerHeight;
            } else {
              var lastPageSize = dataLen % pageSize;
              if (lastPageSize === 0) {
                totalH = pageSize * rowHeight + headerHeight + footerHeight;
              } else {
                totalH = lastPageSize * rowHeight + headerHeight + footerHeight;
              }
            }

          } else {
            totalH = dataLen * rowHeight + headerHeight + footerHeight;
          }
          return $common.max(totalH, 300) + 'px';
        }

        var i = 0;
        var j = 0;
        var ok = {};
        var keys = [];
        var good = {}

        good.request_type = [];
        ok = {};
        for (i = 0; i < vm.unfiltered.length; i++) {
          ok[vm.unfiltered[i].request_type] = true;
        }
        keys = Object.keys(ok);
        for (i = 0; i < keys.length; i++) {
          good.request_type.push({
            name: keys[i],
            code: keys[i],
            selected: true
          })
        }
        good.request_type.push({
          name: 'Altro',
          code: '',
          selected: true
        });



        good.serviceType = [];
        ok = {};
        for (i = 0; i < vm.unfiltered.length; i++) {
          ok[vm.unfiltered[i].serviceType] = true;
        }
        keys = Object.keys(ok);
        for (i = 0; i < keys.length; i++) {
          good.serviceType.push({
            name: keys[i],
            code: keys[i],
            selected: true
          })
        }
        good.serviceType.push({
          name: 'Altro',
          code: '',
          selected: true
        });



        vm.filterData = {
          currentFilter: {
            between: [{
              "field": "updatedAt",
              "type": "date"
            }, {
              "field": "pax",
              "type": "number"
            }, {
              "field": "client_price",
              "type": "number"
            }, {
              "field": "startdate",
              "type": "time"
            }, {
              "field": "startdate",
              "type": "date"
            }, {
              "field": "enddate",
              "type": "time"
            }, {
              "field": "enddate",
              "type": "date"
            }],
            belongs: [{
              "values": good.request_type,
              "field": "request_type",
              "type": "string",
              "value": []
            }, {
              "values": good.serviceType,
              "field": "serviceType",
              "type": "string",
              "value": []
            }, {
              "values": $common.places,
              "field": "pickup",
              "type": "place",
              "value": []
            }, {
              "values": $common.places,
              "field": "dropoff",
              "type": "place",
              "value": []
            }],
            equals: [],
          }
        };


        var columnsData = {};


        var columns = {};


        var filterBase = {
          show: false,
          filterData: vm.filterData,
          onApply: function () {
            this.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },
        };


        var base = {
          enableColumnMenu: false,
          cellTooltip: true,
          headerCellTemplate: 'app/components/header-filter/generic.html',
          minWidth: 150
        }


        columnsData.request_type = angular.copy(filterBase);
        columnsData.request_type.label = 'Tipo di richiesta';
        columnsData.request_type.dataType = 'string';
        columnsData.request_type.filterData = vm.filterData;
        columnsData.request_type.field = 'request_type';
        columnsData.request_type.filterType = 'belongs';

        columnsData._id = angular.copy(filterBase);
        columnsData._id.label = 'N⁰ Prenotazione';
        columnsData._id.dataType = 'string';
        columnsData._id.filterData = vm.filterData;
        columnsData._id.field = '_id';

        columnsData.updatedAt = angular.copy(filterBase);
        columnsData.updatedAt.label = 'Modificata il';
        columnsData.updatedAt.dataType = 'date';
        columnsData.updatedAt.filterData = vm.filterData;
        columnsData.updatedAt.field = 'updatedAt';
        columnsData.updatedAt.filterType = 'between';

        columnsData.serviceType = angular.copy(filterBase);
        columnsData.serviceType.label = 'Tipologia';
        columnsData.serviceType.dataType = 'string';
        columnsData.serviceType.filterData = vm.filterData;
        columnsData.serviceType.field = 'service_type';
        columnsData.serviceType.filterType = 'belongs';

        columnsData.pax = angular.copy(filterBase);
        columnsData.pax.label = 'Pax';
        columnsData.pax.dataType = 'number';
        columnsData.pax.filterData = vm.filterData;
        columnsData.pax.field = 'pax';
        columnsData.pax.filterType = 'between';

        columnsData.pickup = angular.copy(filterBase);
        columnsData.pickup.label = 'Pick-up';
        columnsData.pickup.dataType = 'place';
        columnsData.pickup.filterData = vm.filterData;
        columnsData.pickup.field = 'pickup';
        columnsData.pickup.filterType = 'belongs';

        columnsData.dropoff = angular.copy(filterBase);
        columnsData.dropoff.label = 'Drop-off';
        columnsData.dropoff.dataType = 'place';
        columnsData.dropoff.filterData = vm.filterData;
        columnsData.dropoff.field = 'dropoff';
        columnsData.dropoff.filterType = 'belongs';

        columnsData.client_price = angular.copy(filterBase);
        columnsData.client_price.label = 'Prezzo';
        columnsData.client_price.dataType = 'number';
        columnsData.client_price.filterData = vm.filterData;
        columnsData.client_price.field = 'client_price';
        columnsData.client_price.filterType = 'between';

        columnsData.info = angular.copy(filterBase);
        columnsData.info.label = 'Servizio';
        columnsData.info.dataType = 'string';
        columnsData.info.filterData = vm.filterData;
        columnsData.info.field = 'info';

        columnsData.startdate = angular.copy(filterBase);
        columnsData.startdate.label = 'Ora d\'inizio';
        columnsData.startdate.dataType = 'time';
        columnsData.startdate.filterData = vm.filterData;
        columnsData.startdate.field = 'startdate';
        columnsData.startdate.filterType = 'between';

        columnsData.startdate = angular.copy(filterBase);
        columnsData.startdate.label = 'Data d\'inizio';
        columnsData.startdate.dataType = 'date';
        columnsData.startdate.filterData = vm.filterData;
        columnsData.startdate.field = 'startdate';
        columnsData.startdate.filterType = 'between';

        columnsData.enddate = angular.copy(filterBase);
        columnsData.enddate.label = 'Ora di fine';
        columnsData.enddate.dataType = 'time';
        columnsData.enddate.filterData = vm.filterData;
        columnsData.enddate.field = 'enddate';
        columnsData.enddate.filterType = 'between';

        columnsData.enddate = angular.copy(filterBase);
        columnsData.enddate.label = 'Data di fine';
        columnsData.enddate.dataType = 'date';
        columnsData.enddate.filterData = vm.filterData;
        columnsData.enddate.field = 'enddate';
        columnsData.enddate.filterType = 'between';

        columns.request_type = angular.copy(base);
        columns.request_type.field = 'request_type';
        columns.request_type.name = 'Tipo di richiesta';
        columns.request_type.data = columnsData.request_type;
        columns.request_type.cellFilter = 'requestType';


        columns._id = angular.copy(base);
        columns._id.field = '_id';
        columns._id.name = 'N⁰ Prenotazione';
        columns._id.data = columnsData._id;
        columns._id.cellTemplate = '<div class="ui-grid-cell-contents"  title="{{COL_FIELD CUSTOM_FILTERS}}"><a ui-sref="root.it.supplier.sentquotes.edit({\'id\': COL_FIELD})">{{COL_FIELD CUSTOM_FILTERS}}</a></div>';
        columns._id.cellFilter = 'quoteId';


        columns.updatedAt = angular.copy(base);
        columns.updatedAt.field = 'updatedAt';
        columns.updatedAt.name = 'Modificata il';
        columns.updatedAt.data = columnsData.updatedAt;
        columns.updatedAt.cellFilter = 'calendar';
        columns.updatedAt.sort = {
          direction: uiGridConstants.DESC,
          priority: 0,
        };

        columns.serviceType = angular.copy(base);
        columns.serviceType.field = 'service_type';
        columns.serviceType.name = 'Tipologia';
        columns.serviceType.data = columnsData.serviceType;

        columns.pax = angular.copy(base);
        columns.pax.field = 'onboard.passengers';
        columns.pax.name = 'Pax';
        columns.pax.data = columnsData.pax;

        columns.pickup = angular.copy(base);
        columns.pickup.field = 'pickup';
        columns.pickup.name = 'Pick-up';
        columns.pickup.data = columnsData.pickup;

        columns.dropoff = angular.copy(base);
        columns.dropoff.field = 'dropoff';
        columns.dropoff.name = 'Drop-off';
        columns.dropoff.data = columnsData.dropoff;

        columns.client_price = angular.copy(base);
        columns.client_price.field = 'partner_price';
        columns.client_price.name = 'Prezzo';
        columns.client_price.data = columnsData.client_price;

        columns.info = angular.copy(base);
        columns.info.field = 'info';
        columns.info.name = 'Servizio';
        columns.info.data = columnsData.info;

        columns.starttime = angular.copy(base);
        columns.starttime.field = 'startdate';
        columns.starttime.name = 'Ora d\'inizio';
        columns.starttime.data = columnsData.startdate;
        columns.starttime.cellFilter = 'time';

        columns.startdate = angular.copy(base);
        columns.startdate.field = 'startdate';
        columns.startdate.name = 'Data d\'inizio';
        columns.startdate.data = columnsData.startdate;
        columns.startdate.cellFilter = 'calendar';

        columns.endtime = angular.copy(base);
        columns.endtime.field = 'enddate';
        columns.endtime.name = 'Ora di fine';
        columns.endtime.data = columnsData.endtime;
        columns.endtime.cellFilter = 'time';

        columns.enddate = angular.copy(base);
        columns.enddate.field = 'enddate';
        columns.enddate.name = 'Data di fine';
        columns.enddate.data = columnsData.enddate;
        columns.enddate.cellFilter = 'calendar';

        vm.defaultColumnDefs = [
          columns.request_type,
          columns._id,
          columns.updatedAt,
          columns.serviceType,
          columns.pax,
          columns.pickup,
          columns.dropoff,
          columns.client_price,
          columns.info,
          columns.startdate,
          columns.startdate,
          columns.enddate,
          columns.enddate,
        ]

        function filterAll() {
          var filter = {
            legal: {
              it: {}
            },
            contact: {},
            place: {},
            vehicles: {
              common: {},
              wheelchair: {}
            },
            insurance: {}
          };
          var data = vm.unfiltered;
          filter.request_type = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'request_type';
          });
          data = $common.filterContained(data, 'request_type', filter.request_type.values);
          filter.updatedAt = vm.currentFilter.between.find(function (element) {
            return element.field === 'updatedAt';
          });
          data = $common.filterNumber(data, 'updatedAt', filter.updatedAt.min, filter.updatedAt.max);
          filter.serviceType = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'serviceType';
          });
          data = $common.filterContained(data, 'serviceType', filter.serviceType.values);
          filter.pax = vm.currentFilter.between.find(function (element) {
            return element.field === 'pax';
          });
          data = $common.filterNumber(data, 'pax', filter.pax.min, filter.pax.max);
          filter.pickup = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'pickup';
          });
          data = $common.filterPlace(data, 'pickup', filter.pickup.values, $common.places);
          filter.dropoff = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'dropoff';
          });
          data = $common.filterPlace(data, 'dropoff', filter.dropoff.values, $common.places);

          data = $common.filterDate(data, 'startdate', filter.startdate.min, filter.startdate.max);
          filter.startdate = vm.currentFilter.between.find(function (element) {
            return element.field === 'startdate';
          });
          data = $common.filterDate(data, 'startdate', filter.startdate.min, filter.startdate.max);
          filter.enddate = vm.currentFilter.between.find(function (element) {
            return element.field === 'enddate';
          });
          data = $common.filterDate(data, 'enddate', filter.enddate.min, filter.enddate.max);
          filter.enddate = vm.currentFilter.between.find(function (element) {
            return element.field === 'enddate';
          });
          data = $common.filterDate(data, 'enddate', filter.enddate.min, filter.enddate.max);


          vm.gridOptions.data = data;
          vm.gridApi.core.refresh();
        }




        vm.gridOptions.columnDefs = (vm.defaultColumnDefs);
        var referenceColumnDefs = angular.copy(vm.defaultColumnDefs);

        function filterVoided(quotes) {
          var available = [];
          for (var i = 0; i < quotes.length; i++) {
            if (quotes[i].status !== 'voided') {
              available.push(quotes[i]);
            }
          }
          return available;
        }

        vm.gridOptions.data = angular.copy(filterVoided(vm.unfiltered));
        console.log(vm.unfiltered)
        vm.loaded = true;
      }, function (err) {
        var str = $error.get(err, 'api');
        $alert.show(str.title, str.msg, 'Ricarica', '', true, 0, 5000,
          function (cancel) {
            $state.reload();
          });
      });

    }
  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('PricingTableController', PricingTableController);

  /** @ngInject */
  function PricingTableController($filter, $scope, $state, $timeout, $alert, $validator, $error, $supplier, $solutions, uiGridConstants, $common, Filtersave, $window, VehicleModal, Upload, cloudinary) {
    var vm = this;

    vm.$onInit = function () {
      // vm.loaded = false;
      vm.months = [false, false, true, true, true, true, false, false, true, true, false, false];
      vm.monthNames = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre']
      $supplier.isVerified().then(function (response) {
        vm.verified = response.verified;

      });

      function getTableHeight(currentPage, pageSize, dataLen) {
        var rowHeight = 30; // row height
        var headerHeight = 50; // header height
        var footerHeight = 0; // bottom scroll bar height
        var totalH = 0;
        var totalPage = Math.floor(dataLen / pageSize) + (dataLen % pageSize > 0 ? 1 : 0)
        if (totalPage > 1) {
          if (currentPage < totalPage) {
            totalH = pageSize * rowHeight + headerHeight + footerHeight;
          } else {
            var lastPageSize = dataLen % pageSize;
            if (lastPageSize === 0) {
              totalH = pageSize * rowHeight + headerHeight + footerHeight;
            } else {
              totalH = lastPageSize * rowHeight + headerHeight + footerHeight;
            }
          }

        } else {
          totalH = dataLen * rowHeight + headerHeight + footerHeight;
        }
        return $common.max(totalH, 100) + 'px';
      }

      vm.zoom = 100;
      vm.resize = function (percentage) {
        var columnDefs = vm.referenceColumnDefs;
        for (var i = 0; i < columnDefs.length; i++) {
          if (columnDefs[i].width) {
            vm.gridOptions.columnDefs[i].width = columnDefs[i].width * percentage / 100;
          }
          if (columnDefs[i].minWidth) {
            vm.gridOptions.columnDefs[i].minWidth = columnDefs[i].minWidth * percentage / 100;
          }
          if (columnDefs[i].maxWidth) {
            vm.gridOptions.columnDefs[i].maxWidth = columnDefs[i].maxWidth * percentage / 100;
          }
        }
        vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
        if (percentage < 80) {

          vm.gridStyle['font-size'] = (percentage + 10) + '%';
        } else {
          vm.gridStyle['font-size'] = (percentage) + '%';
        }


      }

      var vehicleTypes = [
        'car',
        'minivan',
        'minibus',
        'minibuslg',
        'coach',
        'coachlg',
        'coach3',
        'double',
        'vintage',
        'limousine',
      ]

      function InitGrid() {

        vm.gridOptions = {
          minRowsToShow: 20,

          enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
          enableVerticalScrollbar: uiGridConstants.scrollbars.NEVER,
          onRegisterApi: function (gridApi) {
            vm.gridApi = gridApi;
            vm.gridStyle.height = getTableHeight(1, 20, vm.gridOptions.data.length);
            vm.gridStyle['width'] = (vm.gridOptions.columnDefs.length * 90 + 340) + 'px';

            vm.gridApi.grid.handleWindowResize();
            vm.gridApi.core.refresh();
            gridApi.edit.on.afterCellEdit($scope, function (rowEntity, colDef, newValue, oldValue) {
              //console.log(vm.gridOptions.data)
            });

          }
        };

        vm.gridStyle = {
          height: '600px'
        };

        vm.defaultColumnDefs = [];
        var serviceType = {
          name: 'Tipo di servizio',
          displayName: 'Tipo di servizio',
          type: 'string',
          enableColumnMenu: false,
          cellTooltip: true,
          enableCellEdit: false,
          field: 'description',
          minWidth: 400,
          maxWidth: 500,
          // cellFilter: 'currency',
        }
        var serviceDuration = {
          name: 'max ore',
          displayName: 'max ore',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          enableCellEdit: false,
          field: 'type',
          width: 90,
          cellFilter: 'serviceDuration',
        }
        var serviceLength = {
          name: 'max km',
          displayName: 'max km',
          type: 'string',
          enableColumnMenu: false,
          enableCellEdit: false,
          cellTooltip: true,
          field: 'type',
          width: 90,

          cellFilter: 'serviceLength',
        }
        var vehicles = {};
        vehicles.minivan = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '6-7-8 PAX',
          displayName: '6-7-8 PAX',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,
          field: 'minivan',
        }
        vehicles.minibus = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '9-18 PAX',
          displayName: '9-18 PAX',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,

          field: 'minibus',

        }
        vehicles.minibuslg = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '19-28 PAX',
          displayName: '19-28 PAX',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,
          field: 'minibuslg',

        }
        vehicles.coach = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '29-40 PAX',
          displayName: '29-40 PAX',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,

          field: 'coach',
        }
        vehicles.coachlg = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '40-56 PAX',
          displayName: '40-56 PAX',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,

          field: 'coachlg',
        }
        vehicles.coach3 = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '57-64 PAX',
          displayName: '57-64 PAX',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,

          field: 'coach3',
        }
        vehicles.double = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '65+ PAX',
          displayName: '65+ PAX',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,

          field: 'double',
        }
        vehicles.vintage = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: 'D\'EPOCA',
          displayName: 'D\'EPOCA',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,

          field: 'vintage',
        }
        vehicles.limousine = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: 'LIMOUSINE',
          displayName: 'LIMOUSINE',
          type: 'number',
          enableColumnMenu: false,
          minWidth: 80,
          // maxWidth: 100,
          cellTooltip: true,
          field: 'limousine',
        }
        vehicles.car = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '1-5 PAX',
          displayName: '1-5 PAX',
          type: 'number',
          enableColumnMenu: false,
          minWidth: 80,
          // cellTooltip: true,
          field: 'car',
        }
        vm.data = [{
            type: 'local2h50k',
            description: 'SERVIZIO LOCALE (02 ORE - 050 KM)',
            'minivan': 0,
            'minibus': 0,
            'minibuslg': 0,
            'coach': 0,
            'coachlg': 0,
            'coach3': 0,
            'double': 0,
            'vintage': 0,
            'limousine': 0,
            'car': 0,
          },

          {
            type: 'local3h75k',
            description: 'SERVIZIO LOCALE (03 ORE - 075 KM)',

            'minivan': 0,
            'minibus': 0,
            'minibuslg': 0,
            'coach': 0,
            'coachlg': 0,
            'coach3': 0,
            'double': 0,
            'vintage': 0,
            'limousine': 0,
            'car': 0,
          },

          {
            type: 'local4h100k',
            description: 'SERVIZIO LOCALE (04 ORE - 100 KM)',

            'minivan': 0,
            'minibus': 0,
            'minibuslg': 0,
            'coach': 0,
            'coachlg': 0,
            'coach3': 0,
            'double': 0,
            'vintage': 0,
            'limousine': 0,
            'car': 0,
          },

          {
            type: 'local6h100k',
            description: 'SERVIZIO LOCALE (06 ORE - 100 KM)',

            'minivan': 0,
            'minibus': 0,
            'minibuslg': 0,
            'coach': 0,
            'coachlg': 0,
            'coach3': 0,
            'double': 0,
            'vintage': 0,
            'limousine': 0,
            'car': 0,
          },

          {
            type: 'local6h150k',
            description: 'SERVIZIO LOCALE (06 ORE - 150 KM)',

            'minivan': 0,
            'minibus': 0,
            'minibuslg': 0,
            'coach': 0,
            'coachlg': 0,
            'coach3': 0,
            'double': 0,
            'vintage': 0,
            'limousine': 0,
            'car': 0,
          },

          {
            type: 'local12h150k',
            description: 'SERVIZIO LOCALE (12 ORE - 150 KM)',

            'minivan': 0,
            'minibus': 0,
            'minibuslg': 0,
            'coach': 0,
            'coachlg': 0,
            'coach3': 0,
            'double': 0,
            'vintage': 0,
            'limousine': 0,
            'car': 0,
          },

          {
            type: 'daily12h200k',
            description: 'ESCURSIONE GIORNALIERA (12 ORE - 200 KM)',

            'minivan': 0,
            'minibus': 0,
            'minibuslg': 0,
            'coach': 0,
            'coachlg': 0,
            'coach3': 0,
            'double': 0,
            'vintage': 0,
            'limousine': 0,
            'car': 0,
          },

          {
            type: 'daily12h250k',
            description: 'ESCURSIONE GIORNALIERA (12 ORE - 250 KM)',

            'minivan': 0,
            'minibus': 0,
            'minibuslg': 0,
            'coach': 0,
            'coachlg': 0,
            'coach3': 0,
            'double': 0,
            'vintage': 0,
            'limousine': 0,
            'car': 0,
          },

          {
            type: 'daily12h400k',
            description: 'ESCURSIONE GIORNALIERA (12 ORE - 400 KM)',

            'minivan': 0,
            'minibus': 0,
            'minibuslg': 0,
            'coach': 0,
            'coachlg': 0,
            'coach3': 0,
            'double': 0,
            'vintage': 0,
            'limousine': 0,
            'car': 0,
          },

          {
            type: 'daily14h400k',
            description: 'ESCURSIONE GIORNALIERA (14 ORE - 400 KM)',
            'minivan': 0,
            'minibus': 0,
            'minibuslg': 0,
            'coach': 0,
            'coachlg': 0,
            'coach3': 0,
            'double': 0,
            'vintage': 0,
            'limousine': 0,
            'car': 0,
          },

          {
            type: 'daily18h400k',
            description: 'ESCURSIONE GIORNALIERA (18 ORE - 400 KM)',
            'minivan': 0,
            'minibus': 0,
            'minibuslg': 0,
            'coach': 0,
            'coachlg': 0,
            'coach3': 0,
            'double': 0,
            'vintage': 0,
            'limousine': 0,
            'car': 0,
          },

          {
            type: 'daily12h650k',
            description: 'ESCURSIONE GIORNALIERA (12 ORE - 650 KM)',
            'minivan': 0,
            'minibus': 0,
            'minibuslg': 0,
            'coach': 0,
            'coachlg': 0,
            'coach3': 0,
            'double': 0,
            'vintage': 0,
            'limousine': 0,
            'car': 0,
          },

          {
            type: 'daily18h700k',
            description: 'ESCURSIONE GIORNALIERA (18 ORE - 700 KM)',

            'minivan': 0,
            'minibus': 0,
            'minibuslg': 0,
            'coach': 0,
            'coachlg': 0,
            'coach3': 0,
            'double': 0,
            'vintage': 0,
            'limousine': 0,
            'car': 0,
          },

          {
            type: 'daily16h900k',
            description: 'ESCURSIONE GIORNALIERA (16 ORE - 900 KM)',

            'minivan': 0,
            'minibus': 0,
            'minibuslg': 0,
            'coach': 0,
            'coachlg': 0,
            'coach3': 0,
            'double': 0,
            'vintage': 0,
            'limousine': 0,
            'car': 0,
          },

          {
            type: 'daily18h1000k',
            description: 'ESCURSIONE GIORNALIERA (18 ORE - 1000 KM)',

            'minivan': 0,
            'minibus': 0,
            'minibuslg': 0,
            'coach': 0,
            'coachlg': 0,
            'coach3': 0,
            'double': 0,
            'vintage': 0,
            'limousine': 0,
            'car': 0,
          },

          {
            type: 'tour250k',
            description: 'TOUR - MEDIA CHILOMETRICA GIORNALIERA (KM 250)',
            'minivan': 0,
            'minibus': 0,
            'minibuslg': 0,
            'coach': 0,
            'coachlg': 0,
            'coach3': 0,
            'double': 0,
            'vintage': 0,
            'limousine': 0,
            'car': 0,
          },

          {
            type: 'tour300k',
            description: 'TOUR - MEDIA CHILOMETRICA GIORNALIERA (KM 300)',
            'minivan': 0,
            'minibus': 0,
            'minibuslg': 0,
            'coach': 0,
            'coachlg': 0,
            'coach3': 0,
            'double': 0,
            'vintage': 0,
            'limousine': 0,
            'car': 0,
          },

          {
            type: 'tour500k',
            description: 'TOUR - MEDIA CHILOMETRICA GIORNALIERA (KM 500)',

            'minivan': 0,
            'minibus': 0,
            'minibuslg': 0,
            'coach': 0,
            'coachlg': 0,
            'coach3': 0,
            'double': 0,
            'vintage': 0,
            'limousine': 0,
            'car': 0,
          },

          {
            type: 'tour1000k',
            description: 'TOUR - MEDIA CHILOMETRICA GIORNALIERA (KM 1000)',

            'minivan': 0,
            'minibus': 0,
            'minibuslg': 0,
            'coach': 0,
            'coachlg': 0,
            'coach3': 0,
            'double': 0,
            'vintage': 0,
            'limousine': 0,
            'car': 0,
          },
        ]

        if (!vm.current.pricing) {
          vm.current.pricing = {
            services: {},
            extra: {}
          };
        }
        vm.defaultColumnDefs.push(serviceType)
        vm.defaultColumnDefs.push(serviceDuration)
        vm.defaultColumnDefs.push(serviceLength)
        for (var i = 0; i < vehicleTypes.length; i++) {
          if (vm.current.vehicles.common[vehicleTypes[i]]) {
            vm.defaultColumnDefs.push(vehicles[vehicleTypes[i]])
          }
        }

        vm.gridOptions.columnDefs = (vm.defaultColumnDefs);
        vm.referenceColumnDefs = angular.copy(vm.defaultColumnDefs);
        vm.gridOptions.data = vm.data;
      }

      function InitChargesGrid() {

        vm.gridOptionsCharges = {
          minRowsToShow: 20,

          enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
          enableVerticalScrollbar: uiGridConstants.scrollbars.NEVER,
          onRegisterApi: function (gridApi) {
            vm.gridApiCharges = gridApi;
            vm.gridStyleCharges.height = getTableHeight(1, 20, vm.gridOptionsCharges.data.length);
            vm.gridStyleCharges['width'] = (vm.gridOptionsCharges.columnDefs.length * 90 + 340) + 'px';

            vm.gridApiCharges.grid.handleWindowResize();
            vm.gridApiCharges.core.refresh();
            gridApi.edit.on.afterCellEdit($scope, function (rowEntity, colDef, newValue, oldValue) {
              //console.log(vm.gridOptions.data)
            });

          }
        };

        vm.gridStyleCharges = {};
        vm.defaultColumnDefsCharges = [];
        var chargeType = {
          name: '',
          displayName: '',
          type: 'string',
          enableColumnMenu: false,
          cellTooltip: true,
          enableCellEdit: false,
          field: 'type',
          minWidth: 400,
          maxWidth: 500,
          cellFilter: 'chargeType',
        }
        var vehicles = {};

        vehicles.minivan = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '6-7-8 PAX',
          displayName: '6-7-8 PAX',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,
          field: 'minivan',
        }
        vehicles.minibus = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '9-18 PAX',
          displayName: '9-18 PAX',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,

          field: 'minibus',

        }
        vehicles.minibuslg = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '19-28 PAX',
          displayName: '19-28 PAX',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,
          field: 'minibuslg',

        }
        vehicles.coach = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '29-40 PAX',
          displayName: '29-40 PAX',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,

          field: 'coach',
        }
        vehicles.coachlg = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '40-56 PAX',
          displayName: '40-56 PAX',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,

          field: 'coachlg',
        }
        vehicles.coach3 = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '57-64 PAX',
          displayName: '57-64 PAX',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,

          field: 'coach3',
        }
        vehicles.double = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '65+ PAX',
          displayName: '65+ PAX',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,

          field: 'double',
        }
        vehicles.vintage = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: 'D\'EPOCA',
          displayName: 'D\'EPOCA',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,

          field: 'vintage',
        }
        vehicles.limousine = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: 'LIMOUSINE',
          displayName: 'LIMOUSINE',
          type: 'number',
          enableColumnMenu: false,
          minWidth: 80,
          // maxWidth: 100,
          cellTooltip: true,
          field: 'limousine',
        }
        vehicles.car = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '1-5 PAX',
          displayName: '1-5 PAX',
          type: 'number',
          enableColumnMenu: false,
          minWidth: 80,
          // cellTooltip: true,
          field: 'car',
        }
        vm.defaultColumnDefsCharges.push(chargeType)
        for (var i = 0; i < vehicleTypes.length; i++) {
          if (vm.current.vehicles.common[vehicleTypes[i]]) {
            vm.defaultColumnDefsCharges.push(vehicles[vehicleTypes[i]])
          }
        }
        vm.dataCharges = [{
            type: 'hour',
            'minivan': 50,
            'minibus': 50,
            'minibuslg': 50,
            'coach': 50,
            'coachlg': 50,
            'coach3': 50,
            'double': 50,
            'vintage': 50,
            'limousine': 50,
            'car': 50,
          },
          {
            type: 'km',
            'minivan': 0.5,
            'minibus': 0.5,
            'minibuslg': 0.5,
            'coach': 0.5,
            'coachlg': 0.5,
            'coach3': 0.5,
            'double': 0.5,
            'vintage': 0.5,
            'limousine': 0.5,
            'car': 0.5,
          },
          {
            type: 'driver',
            'minivan': 100,
            'minibus': 100,
            'minibuslg': 100,
            'coach': 100,
            'coachlg': 100,
            'coach3': 100,
            'double': 100,
            'vintage': 100,
            'limousine': 100,
            'car': 100,
          }
        ];
        vm.gridOptionsCharges.data = vm.dataCharges;
        vm.gridOptionsCharges.columnDefs = (vm.defaultColumnDefsCharges);

      }

      function InitTransfersGrid() {
        vm.removeSelected = function () {
          var selection = vm.gridApiTransfers.selection.getSelectedRows();
          var keep = [];
          for (var j = 0; j < vm.gridOptionsTransfers.data.length; j++) {
            var good = true;
            for (var i = 0; i < selection.length; i++) {
              if (vm.gridOptionsTransfers.data[j] == selection[i]) {
                good = false;
              }
            }
            if (good) {
              keep.push(vm.gridOptionsTransfers.data[j]);
            }
          }
          vm.gridOptionsTransfers.data = keep;
          vm.gridApiTransfers.selection.clearSelectedRows();
          vm.gridApiTransfers.core.refresh();
        }
        vm.addTransfer = function () {
          vm.gridOptionsTransfers.data.push({
            from: {
              address: '',
              location: {
                lat: -90,
                lng: -90
              }
            },
            to: {
              address: '',
              location: {
                lat: -90,
                lng: -90
              }
            }
          });
          vm.gridStyleTransfers.height = getTableHeight(1, 40, vm.gridOptionsTransfers.data.length);
          vm.gridApiTransfers.grid.handleWindowResize();
          vm.gridApiTransfers.core.refresh();
        }
        vm.gridOptionsTransfers = {
          minRowsToShow: 20,

          enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
          enableVerticalScrollbar: uiGridConstants.scrollbars.NEVER,
          onRegisterApi: function (gridApi) {
            vm.gridApiTransfers = gridApi;
            vm.gridStyleTransfers.height = getTableHeight(1, 20, vm.gridOptionsTransfers.data.length);
            vm.gridStyleTransfers['width'] = (vm.gridOptionsTransfers.columnDefs.length * 90 + 340) + 'px';

            vm.gridApiTransfers.grid.handleWindowResize();
            vm.gridApiTransfers.core.refresh();
            gridApi.edit.on.afterCellEdit($scope, function (rowEntity, colDef, newValue, oldValue) {
              //console.log(vm.gridOptions.data)
            });

          }
        };

        vm.gridStyleTransfers = {};
        vm.defaultColumnDefsTransfers = [];
        var start = {
          name: 'Tratta',
          displayName: 'Trasferimento',
          type: 'string',
          enableColumnMenu: false,
          cellTooltip: true,
          enableCellEdit: false,
          field: 'type',
          minWidth: 400,
          maxWidth: 500,
          cellFilter: 'chargeType',
          cellTemplate: '<div class="row no-margin no-padding" style="line-height: 2;"><div class="col-xs"><brplacepickernice br-to="row.entity.from" br-placeholder="Punto di partenza"></brplacepickernice></div>X<div class="col-xs"><brplacepickernice br-to="row.entity.to" br-placeholder="Punto di arrivo"></brplacepickernice></div></div>'
        }
        var vehicles = {};

        vehicles.minivan = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '6-7-8 PAX',
          displayName: '6-7-8 PAX',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,
          field: 'minivan',
        }
        vehicles.minibus = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '9-18 PAX',
          displayName: '9-18 PAX',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,

          field: 'minibus',

        }
        vehicles.minibuslg = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '19-28 PAX',
          displayName: '19-28 PAX',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,
          field: 'minibuslg',

        }
        vehicles.coach = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '29-40 PAX',
          displayName: '29-40 PAX',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,

          field: 'coach',
        }
        vehicles.coachlg = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '40-56 PAX',
          displayName: '40-56 PAX',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,

          field: 'coachlg',
        }
        vehicles.coach3 = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '57-64 PAX',
          displayName: '57-64 PAX',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,

          field: 'coach3',
        }
        vehicles.double = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '65+ PAX',
          displayName: '65+ PAX',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,

          field: 'double',
        }
        vehicles.vintage = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: 'D\'EPOCA',
          displayName: 'D\'EPOCA',
          type: 'number',
          enableColumnMenu: false,
          cellTooltip: true,
          minWidth: 80,
          // maxWidth: 100,

          field: 'vintage',
        }
        vehicles.limousine = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: 'LIMOUSINE',
          displayName: 'LIMOUSINE',
          type: 'number',
          enableColumnMenu: false,
          minWidth: 80,
          // maxWidth: 100,
          cellTooltip: true,
          field: 'limousine',
        }
        vehicles.car = {
          cellFilter: 'currency',

          enableCellEdit: true,
          name: '1-5 PAX',
          displayName: '1-5 PAX',
          type: 'number',
          enableColumnMenu: false,
          minWidth: 80,
          // cellTooltip: true,
          field: 'car',
        }
        vm.defaultColumnDefsTransfers.push(start)
        for (var i = 0; i < vehicleTypes.length; i++) {
          if (vm.current.vehicles.common[vehicleTypes[i]]) {
            vm.defaultColumnDefsTransfers.push(vehicles[vehicleTypes[i]])
          }
        }
        vm.dataTransfers = [{
          from: {
            address: '',
            location: {
              lat: -90,
              lng: -90
            }
          },
          to: {
            address: '',
            location: {
              lat: -90,
              lng: -90
            }
          }
        }];
        vm.gridOptionsTransfers.data = vm.dataTransfers;
        vm.gridOptionsTransfers.columnDefs = (vm.defaultColumnDefsTransfers);

      }

      function load() {
        if (!(vm.current.pricing && vm.current.pricing.extra && vm.current.pricing.services)) {
          vm.current.pricing = {
            services: {},
            extra: {
              season: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            }
          };
        }
        //console.log(current)
      }

      function init() {
        if (vm.current.pricing && vm.current.pricing.extra && vm.current.pricing.services) {
          for (var i = 0; i < vm.data.length; i++) {
            for (var j = 0; j < vehicleTypes.length; j++) {
              if (vm.current.pricing.services[vm.data[i].type] && vm.current.pricing.services[vm.data[i].type][vehicleTypes[j]])
                vm.gridOptions.data[i][vehicleTypes[j]] = vm.current.pricing.services[vm.data[i].type][vehicleTypes[j]];
            }
          }
          if (!vm.current.pricing.extra.fixed) vm.current.pricing.extra.fixed = {
            hour: {},
            km: {},
            driver: {},
          };

          for (var i = 0; i < vm.dataCharges.length; i++) {
            for (var j = 0; j < vehicleTypes.length; j++) {
              if (vm.current.pricing.extra.fixed[vm.dataCharges[i].type] && vm.current.pricing.extra.fixed[vm.dataCharges[i].type][vehicleTypes[j]])
                vm.gridOptionsCharges.data[i][vehicleTypes[j]] = vm.current.pricing.extra.fixed[vm.dataCharges[i].type][vehicleTypes[j]];
            }
          }
          // vm.hour = current.pricing.extra.hour;
          // vm.driver = current.pricing.extra.driver;
          // vm.km = current.pricing.extra.km;
          vm.night = vm.current.pricing.extra.night;
          vm.nightstart = vm.current.pricing.extra.nightstart;
          vm.nightend = vm.current.pricing.extra.nightend;
          vm.sunday = vm.current.pricing.extra.sunday;
          vm.saturday = vm.current.pricing.extra.saturday;
          vm.special = vm.current.pricing.extra.special;
          vm.emergency = vm.current.pricing.extra.emergency;
          vm.high = 0;
          for (var i = 0; i < 12; i++) {
            if (angular.isNumber(vm.current.pricing.extra.season[i]) && vm.current.pricing.extra.season[i] > 0) {
              vm.high = vm.current.pricing.extra.season[i];
              vm.months[i] = true;
            } else {
              vm.months[i] = false;
            }
          }
          if (vm.current.pricing && vm.current.pricing.transfers && vm.current.pricing.transfers.length)
            vm.gridOptionsTransfers.data = vm.current.pricing.transfers;
        }
      }
      $scope.$watch(function () {
        return $supplier.current()
      }, function () {
        if ($supplier.current()) {
          vm.current = angular.copy($supplier.current());
          InitGrid();
          InitChargesGrid();
          InitTransfersGrid();
          load();
          init();
          if (!vm.km) vm.km = '0.50';
          if (!vm.hour) vm.hour = '50';
          if (!vm.driver) vm.driver = '200';
          if (!vm.nightstart) vm.nightstart = '24:00';
          if (!vm.nightend) vm.nightend = '06:00';
          if (!vm.saturday) vm.saturday = 0;
          if (!vm.sunday) vm.sunday = 0;
          if (!vm.special) vm.special = 10;
          if (!vm.high && !(vm.high >= 0)) vm.high = 10;
          vm.loaded = true;
        }
      }, true);
      vm.files = [];

      function onControllerLoaded(responseUpload) {
        vm.save = function () {

          var fileToUpload = vm.files.length;
          if (fileToUpload > 0) {
            angular.forEach(vm.files, function (file) {
              var upload = {};
              angular.copy(responseUpload.upload, upload);
              upload.file = file;
              Upload.upload({
                url: cloudinary.config().cloud_upload,
                data: upload
              }).progress(function (e) {
                file.progress = Math.round((e.loaded * 100.0) / e.total);
              }).success(function (data, status, headers, config) {
                file.result = data;
                console.log(data);
                vm.current.subscription = vm.current.subscription || {};
                vm.current.subscription.attachments = vm.current.subscription.attachments || [];
                vm.current.subscription.attachments.push({
                  url: data.public_id,
                  name: file.fname,
                  provider: 'cloudinary',
                  authorization: 'private'
                });
                fileToUpload--;
                if (fileToUpload === 0) {
                  onUploadComplete();
                }
              }).error(function (data, status, headers, config) {
                var str = $error.get(data);
                vm.warning = str.msg;
                fileToUpload--;
              });
            });
            vm.files = [];
          } else {
            onUploadComplete();
          }

          function onUploadComplete() {

            if (!vm.current.pricing) {
              vm.current.pricing = {
                services: {},
                extra: {
                  season: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                }
              };
            }
            for (var i = 0; i < vm.data.length; i++) {
              if (!vm.current.pricing.services[vm.data[i].type]) {
                vm.current.pricing.services[vm.data[i].type] = {};
              }
              for (var j = 0; j < vehicleTypes.length; j++) {
                vm.current.pricing.services[vm.data[i].type][vehicleTypes[j]] = vm.gridOptions.data[i][vehicleTypes[j]];
              }
            }
            for (var i = 0; i < vm.dataCharges.length; i++) {

              if (!vm.current.pricing.extra.fixed[vm.dataCharges[i].type]) {
                vm.current.pricing.extra.fixed[vm.dataCharges[i].type] = {};
              }
              for (var j = 0; j < vehicleTypes.length; j++) {
                if (!vm.current.pricing.extra.fixed[vm.dataCharges[i].type]) vm.current.pricing.extra.fixed[vm.dataCharges[i].type] = {};
                vm.current.pricing.extra.fixed[vm.dataCharges[i].type][vehicleTypes[j]] = vm.gridOptionsCharges.data[i][vehicleTypes[j]];
              }
            }
            // current.pricing.extra.hour = vm.hour;
            // current.pricing.extra.km = vm.km;
            // current.pricing.extra.driver = vm.driver;
            vm.current.pricing.extra.night = vm.night;
            vm.current.pricing.extra.nightstart = vm.nightstart;
            vm.current.pricing.extra.nightend = vm.nightend;
            vm.current.pricing.extra.sunday = vm.sunday;
            vm.current.pricing.extra.saturday = vm.saturday;
            vm.current.pricing.extra.special = vm.special;
            vm.current.pricing.extra.emergency = vm.emergency;
            for (var i = 0; i < 12; i++) {
              if (vm.months[i])
                vm.current.pricing.extra.season[i] = vm.high;
              else
                vm.current.pricing.extra.season[i] = 0;
            }
            console.log(vm.months)
            console.log(vm.current.pricing.extra.season)
            vm.current.pricing.transfers = angular.copy(vm.gridOptionsTransfers.data);
            $supplier.update({
              supplier: vm.current
            }).then(function (result) {
              $state.reload();
            }).catch(function (err) {
              var str = $error.get(err, 'api');
              $alert.show(str.title, str.msg, 'Ricarica', '', true, 0, 5000,
                function (cancel) {
                  $state.reload();
                });
            });
          }

        }
      }

      vm.now = new Date();

      $supplier.getUploadSign().then(function (responseUpload) {
        onControllerLoaded(responseUpload);
      }, function (err) {
        var str = $error.get(err, 'api');
        $alert.show(str.title, str.msg, 'Torna alla dashboard', 'Ricarica pagina', true, 0, 5000,
          function (cancel) {
            $state.go('root.it.supplier.quotes.list');
          },
          function (accept) {
            $state.reload();
          });
      });

    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brBookSupplier', overviewDirective);

  /** @ngInject */
  function overviewDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        quote: '=brQuote',
        supplier: '=brSupplier',
      },
      templateUrl: 'app/views/supplier/book/supplier/supplier.html',
      controller: 'BookSupplierController',
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('BookSupplierController', SupplierController);

  /** @ngInject */
  function SupplierController($rootScope, $scope, $state, $timeout, $interval, $alert, $validator, $error, $supplier, uiGridConstants) {
    var vm = this;
    vm.$onInit = function () {
      $supplier.getSupplierQuotes(vm.quote.id).then(function (response) {
        for (var i = 0; i < response.quotes.length; i++) {
          if (response.quotes[i].status === 'accepted') {
            vm.supplier.quote = response.quotes[i];
          }
        }
        vm.gridOptions2 = {
          enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
          onRegisterApi: function (gridApi) { vm.gridApi = gridApi; }
        };
        vm.gridOptions2.columnDefs = [
          {
            field: 'status',
            name: 'Status',
            cellTemplate: '<div class="ui-grid-cell-contents"  title="TOOLTIP"><span class="tag tag-sm" ng-class="{\'tag-green\':COL_FIELD == \'accepted\', \'tag-yellow\':COL_FIELD == \'hidden\'}">{{COL_FIELD CUSTOM_FILTERS}}</span></div>',
            minWidth: 120,
            cellTooltip: true,
            pinnedLeft: true,
            cellFilter: 'partnerStatus'
          },
          {
            field: 'notification',
            cellFilter: 'notificationStatus',
            name: 'Notificato',
            minWidth: 100,
            pinnedLeft: true,
            cellTooltip: true,
          },
          {
            field: 'Supplier.company',
            name: 'Azienda',
            minWidth: 200,
            pinnedLeft: true,
            cellTooltip: true,
          },
          {
            field: 'Supplier.email',
            name: 'Email verificata',
            cellTooltip: true,
            minWidth: 200,

          },
          {
            field: 'Supplier.place.address',
            name: 'Sede Amministrativa',
            cellTooltip: true,
            minWidth: 200,

          },
          {
            field: 'Supplier.companyphone',
            name: 'Telefono',
            minWidth: 100,
            cellTooltip: true,

          },
          {
            field: 'Supplier.emergencyphone',
            name: 'Emergenze',
            minWidth: 100,

            cellTooltip: true,
          },
        ];
        $supplier.getSupplierQuotesTmp(vm.quote.id).then(function (response1) {
          response.quotes = response.quotes.concat(response1.quotes)
          vm.gridOptions2.data = response.quotes;
          /*
          vm.gridOptions3 = {
            enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
            onRegisterApi: function (gridApi) { vm.gridApi1 = gridApi; }
          };
          vm.gridOptions3.columnDefs = [
            {
              field: 'status',
              name: 'Status',
              cellTemplate: '<div class="ui-grid-cell-contents"  title="TOOLTIP"><span class="tag tag-sm" ng-class="{\'tag-green\':COL_FIELD == \'accepted\', \'tag-yellow\':COL_FIELD == \'hidden\'}">{{COL_FIELD CUSTOM_FILTERS}}</span></div>',
              minWidth: 100,
              cellTooltip: true,
              pinnedLeft: true,
              cellFilter: 'partnerStatus'
            },
            {
              field: 'notification',
              name: 'Notificato',
              minWidth: 100,
              pinnedLeft: true,
              cellTooltip: true,
            },
            {
              field: 'Supplier.company',
              name: 'Azienda',
              pinnedLeft: true,
              minWidth: 200,
              cellTooltip: true,
            },
            {
              field: 'Supplier.email',
              name: 'Email verificata',
              cellTooltip: true,
              minWidth: 200,

            },
            {
              field: 'Supplier.place.address',
              name: 'Sede Amministrativa',
              cellTooltip: true,
              minWidth: 200,

            },
            /*
            {
              field: 'Supplier.companyphone',
              name: 'Telefono',
              minWidth: 100,
              cellTooltip: true,

            },
            {
              field: 'Supplier.emergencyphone',
              name: 'Emergenze',
              minWidth: 100,

              cellTooltip: true,
            },
          ];
          vm.gridOptions3.data = response.quotes;
          */
          vm.loaded = true;

          vm.hideSelected = function () {
            var selected = vm.gridApi.selection.getSelectedRows();
            var toVoid = [];
            for (var i = 0; i < selected.length; i++) {
              if (!selected[i].Supplier.external)
                toVoid.push(selected[i].Supplier.id);
            }
            $supplier.hideQuotes(vm.quote.id, toVoid).then(function (response) {
              // selected = vm.gridApi1.selection.getSelectedRows();
              toVoid = [];
              for (var i = 0; i < selected.length; i++) {
                if (selected[i].Supplier.external)
                  toVoid.push(selected[i].Supplier.id);
              }
              $supplier.hideQuotesTmp(vm.quote.id, toVoid).then(function (response) {
                $alert.show('Richieste nascoste', '', '', '', true, 200, 2000, function() {
                  $state.reload();
                });

              }, function (err) {
                var str = $error.get(err, 'api');
                $alert.show(str.title, str.msg, 'Torna alla dashboard', 'Nascondi messaggio di errore', true, 0, -1,
                  function (cancel) { $state.go('root.it.supplier.quotes.list'); }, function (accept) { });

              });
            }, function (err) {
              var str = $error.get(err, 'api');
              $alert.show(str.title, str.msg, 'Torna alla dashboard', 'Nascondi messaggio di errore', true, 0, -1,
                function (cancel) { $state.go('root.it.supplier.quotes.list'); }, function (accept) { });

            });


          }
        }, function (err) {
          var str = $error.get(err, 'api');
          $alert.show(str.title, str.msg, 'Torna alla dashboard', 'Nascondi messaggio di errore', true, 0, -1,
            function (cancel) { $state.go('root.it.supplier.quotes.list'); }, function (accept) { });

        });
      }, function (err) {
        var str = $error.get(err, 'api');
        $alert.show(str.title, str.msg, 'Torna alla dashboard', 'Nascondi messaggio di errore', true, 0, -1,
          function (cancel) { $state.go('root.it.supplier.quotes.list'); }, function (accept) { });

      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('NetworkTableController', NetworkTableController);

  /** @ngInject */
  function NetworkTableController($filter, $scope, $state, $timeout, $alert, $validator, $error, $supplier, $solutions, uiGridConstants, $common, Filtersave, $window, VehicleModal) {
    var vm = this;


    vm.$onInit = function () {
      // vm.loaded = false;
      vm.network = [];
      $supplier.isVerified().then(function (response) {
        vm.verified = response.verified;

      });

      vm.removePartner = function (index) {
        vm.network.splice(index, 1);
      }

      vm.addPartner = function () {
        vm.network.push({email: '', name: ''});
      }
      function init() {
        vm.loaded = false;
        $supplier.getNetwork().then(function(result) {
          vm.network = result.network;
        }).catch(function(err) {
          var str = $error.get(err, 'api');
          $alert.show(str.title, str.msg, 'Ricarica', '', true, 0, 5000,
            function (cancel) { $state.reload(); });
        });
        vm.loaded = true;
        return;
      }
      vm.resetChanges = function() {
        init();
      }
      vm.save = function() {
        vm.loaded = false;
        console.log(vm.network)
        $supplier.updateNetwork(angular.copy(vm.network)).then(function(result) {
          $state.reload();
        }).catch(function(err) {
          var str = $error.get(err, 'api');
          $alert.show(str.title, str.msg, 'Ricarica', '', true, 0, 5000,
            function (cancel) { $state.reload(); });
        });
      }

      init();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brBookPrice', bookPriceDirective);

  /** @ngInject */
  function bookPriceDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        quote: '=brQuote',
      },
      templateUrl: 'app/views/supplier/book/price/price.html',
      controller: 'BookPriceController',
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('BookPriceController', BookPriceController);

  /** @ngInject */
  function BookPriceController($rootScope, $scope, $state, $timeout, $alert, $validator, $error, $location, $cookies, $supplier, $common) {
    var vm = this;
    vm.$onInit = function () {
      vm.admin = false;
      vm.vat = 10;
      vm.partner_vat = 10;

      vm.who = [
        'us',
        'partner',
        'client'
      ];
      vm.cost = {
        name: '',
        value: 0,
        vat: 0,
        who: 'us'
      };

      vm.updatePartnerPrice = function () {
        vm.quote.partner_total = $common.roundToTwo(vm.quote.partner_price * (1 + vm.quote.vat / 100));
      }
      vm.updatePartnerTotal = function () {
        vm.quote.partner_price = $common.roundToTwo(vm.quote.partner_total / (1 + vm.quote.vat / 100));
      }
      vm.updatePartnerVat = function () {
        vm.quote.partner_total = $common.roundToTwo(vm.quote.partner_price * (1 + vm.quote.vat / 100));
      }
      vm.updateClientPrice = function () {
        vm.quote.client_total = $common.roundToTwo(vm.quote.client_price * (1 + vm.quote.client_vat / 100));
        if (!vm.admin) {
          vm.quote.partner_total = vm.quote.client_total;
        }
      }
      vm.updateClientTotal = function () {
        vm.quote.client_price = $common.roundToTwo(vm.quote.client_total / (1 + vm.quote.client_vat / 100));
        if (!vm.admin) {
          vm.quote.partner_price = vm.quote.client_price;
        }
      }
      vm.updateClientVat = function () {
        vm.quote.client_total = $common.roundToTwo(vm.quote.client_price * (1 + vm.quote.client_vat / 100));
        if (!vm.admin) {
          vm.quote.partner_total = vm.quote.client_total;
          vm.quote.partner_vat = vm.quote.client_vat;
        }
      }

      if (!vm.quote.costs) vm.quote.costs = [];
      vm.removeCost = function (index) {
        vm.quote.costs.splice(index, 1);
      }
      vm.addCost = function () {
        vm.quote.costs.push(angular.copy(vm.cost));
        vm.cost = {
          name: '',
          value: 0,
          vat: 0,
          who: 'us'
        }
      }
      vm.updateVAT = function () {
        // vm.quote.vat = roundToTwo(vm.vat * vm.quote.partner_price / 100);
      };
      $scope.$on('saveChanges', function () {

      });
      if (angular.isUndefined(vm.quote.client_vat)) vm.quote.client_vat = vm.vat;
      if (angular.isUndefined(vm.quote.vat)) vm.quote.vat = vm.vat;
      $scope.$watch(function () { return vm.quote.partner_price }, function () {
        vm.updateVAT();
      })
      vm.loaded = true;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brBookUsers', usersDirective);

  /** @ngInject */
  function usersDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        quote: '=brQuote',
      },
      templateUrl: 'app/views/supplier/book/users/users.html',
      controller: 'BookUsersController',
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('BookUsersController', BookUsersController);

  /** @ngInject */
  function BookUsersController($rootScope, $scope, $state, $timeout, $interval, $alert, $validator, $error) {
    var vm = this;
    vm.$onInit = function() {
      vm.loaded = true;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brBookStandards', standardsDirective);

  /** @ngInject */
  function standardsDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        quote: '=brQuote',
      },
      templateUrl: 'app/views/supplier/book/standards/standards.html',
      controller: 'BookStandardsController',
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('BookStandardsController', BookStandardsController);

  /** @ngInject */
  function BookStandardsController($rootScope, $scope, $state, $timeout, $interval, $alert, $validator, $error, $supplier) {
    var vm = this;
    vm.$onInit = function () {
      vm.now = new Date();

      $scope.$on('saveChanges', function () {

      });

      vm.services = {
        audio: { icon: 'icon-music-player', name: 'Impianto stereo' },
        coffeMachine: { icon: 'icon-coffee-machine', name: 'Macchina del caffè' },
        conditioner: { icon: 'icon-air-conditioner', name: 'Aria condizionata' },
        display: { icon: 'icon-monitor', name: 'Schermo TV' },
        dvdPlayer: { icon: 'icon-dvd', name: 'Lettore DVD' },
        electricity: { icon: 'icon-plug', name: 'Prese elettriche' },
        fridge: { icon: 'icon-fridge', name: 'Mini Frigorifero' },
        kitchen: { icon: 'icon-oven', name: 'Cucina a bordo' },
        leatherSeats: { icon: 'icon-leather', name: 'Sedili in pelle' },
        light: { icon: 'icon-idea', name: 'Luce da lettura' },
        luggage: { icon: 'icon-luggage', name: 'Vano valige' },
        microphone: { icon: 'icon-karaoke', name: 'Microfono' },
        panoramicWindows: { icon: 'icon-window', name: 'Vetri panoramici' },
        radio: { icon: 'icon-radio', name: 'Radio' },
        tintedWindows: { icon: 'icon-window-tinted', name: 'Vetri oscurati' },
        toilet: { icon: 'icon-toilet', name: 'Toilet' },
        tvAerial: { icon: 'icon-television', name: 'Antenna TV' },
        usb: { icon: 'icon-usb', name: 'Carica USB' },
        wheelchair: { icon: 'icon-wheelchair', name: 'Pedana carrozzine' },
        wifi: { icon: 'icon-connection', name: 'Wi-Fi' },
      };

      vm.inputs = {
        axis: [],
        lengthiness: [],
        largeness: [],
        highness: [],
        years: [],
        emissions: [],
        drivers: [],
        passengers: [],
        insurance: [],
        seatbelts: [
          {name: 'all', value: 'all'},
          {name: 'rear', value: 'rear'},
          {name: 'none', value: 'none'}
        ]
      };
      function roundToTwo(num) {
        return Number(Math.round(num + 'e+2') + 'e-2');
      }
      var i = 0;
      for (i = 2; i <= 4; i++) {
        vm.inputs.axis.push({ value: i, name: i + ' Assi' });
      }
      for (i = 4.5; i <= 15; i += 0.5) {
        vm.inputs.lengthiness.push({ value: roundToTwo(i), name: roundToTwo(i) + ' metri' });
      }
      for (i = 1.80; i <= 3; i += 0.10) {
        vm.inputs.largeness.push({ value: roundToTwo(i), name: roundToTwo(i) + ' metri' });
      }
      for (i = 1.80; i <= 4.5; i += 0.10) {
        vm.inputs.highness.push({ value: roundToTwo(i), name: roundToTwo(i) + ' metri' });
      }
      var curYear = new Date().getFullYear();
      for (i = curYear; i >= curYear - 15; i--) {
        vm.inputs.years.push({ value: i, name: 'Anno ' + i });
      }
      for (i = 6; i >= 2; i--) {
        vm.inputs.emissions.push({ value: 'EUR' + i, name: 'EURO ' + i });
      }
      for (i = 0; i <= 4; i++) {
        vm.inputs.drivers.push({ value: i + 1, name: i + ' Posti' });
      }
      for (i = 3; i <= 120; i++) {
        vm.inputs.passengers.push({ value: i, name: i + ' Posti' });
      }
      for (i = 1000000; i <= 100000000; i += 1000000) {
        vm.inputs.insurance.push({value: i, name: i / 1000000 + ' Milioni'});
      }
      if (!vm.quote.insurance) vm.quote.insurance = 30000000;

      if (angular.isUndefined(vm.quote.vehicle)) {

        vm.quote.vehicle = {
          specs: {
            seats: {}
          },
          services: {
            audio: false,
            coffeMachine: false,
            conditioner: false,
            display: false,
            dvdPlayer: false,
            electricity: false,
            fridge: false,
            kitchen: false,
            leatherSeats: false,
            light: false,
            luggage: false,
            microphone: false,
            panoramicWindows: false,
            radio: false,
            tintedWindows: false,
            toilet: false,
            tvAerial: false,
            usb: false,
            wheelchair: false,
            wifi: false
          }
        };
      }
      if (angular.isUndefined(vm.quote.vehicle.specs)) {
        vm.quote.vehicle.specs = { seats: {} };
      }
      vm.setStandards = function (level) {
        vm.quote.vehicle.services.fridge = false;
        vm.quote.vehicle.specs.emissionClass = 'EUR4';
        vm.quote.vehicle.specs.matriculation = '2006';
        vm.quote.vehicle.services.fridge = false;
        vm.quote.vehicle.services.leatherSeats = false;
        vm.quote.vehicle.services.coffeMachine = false;
        vm.quote.vehicle.services.luggage = false;
        vm.quote.vehicle.services.audio = false;
        vm.quote.vehicle.services.light = false;

        switch (level) {
          case 5:
          case 4:
            vm.quote.vehicle.specs.emissionClass = vm.quote.vehicle.specs.emissionClass > 'EUR6' ? vm.quote.vehicle.specs.emissionClass : 'EUR6';
            vm.quote.vehicle.specs.matriculation = vm.quote.vehicle.specs.matriculation > '2015' ? vm.quote.vehicle.specs.matriculation : '2015';
            vm.quote.vehicle.services.fridge = true;
            vm.quote.vehicle.services.leatherSeats = true;
            vm.quote.vehicle.services.coffeMachine = true;
            vm.quote.vehicle.services.leatherSeats = true;
            vm.quote.vehicle.specs.matriculation = vm.quote.vehicle.specs.matriculation > '2011' ? vm.quote.vehicle.specs.matriculation : '2011';
            vm.quote.vehicle.specs.emissionClass = vm.quote.vehicle.specs.emissionClass > 'EUR5' ? vm.quote.vehicle.specs.emissionClass : 'EUR5';
            vm.quote.vehicle.specs.matriculation = vm.quote.vehicle.specs.matriculation > '2006' ? vm.quote.vehicle.specs.matriculation : '2006';
            vm.quote.vehicle.services.conditioner = true;
            vm.quote.vehicle.services.luggage = true;
            vm.quote.vehicle.services.audio = true;
            vm.quote.vehicle.specs.emissionClass = vm.quote.vehicle.specs.emissionClass > 'EUR4' ? vm.quote.vehicle.specs.emissionClass : 'EUR4';
            break;
          case 3:
            vm.quote.vehicle.services.leatherSeats = true;
            vm.quote.vehicle.specs.matriculation = vm.quote.vehicle.specs.matriculation > '2011' ? vm.quote.vehicle.specs.matriculation : '2011';
            vm.quote.vehicle.specs.emissionClass = vm.quote.vehicle.specs.emissionClass > 'EUR5' ? vm.quote.vehicle.specs.emissionClass : 'EUR5';
            vm.quote.vehicle.specs.matriculation = vm.quote.vehicle.specs.matriculation > '2006' ? vm.quote.vehicle.specs.matriculation : '2006';
            vm.quote.vehicle.services.conditioner = true;
            vm.quote.vehicle.services.luggage = true;
            vm.quote.vehicle.services.audio = true;
            vm.quote.vehicle.specs.emissionClass = vm.quote.vehicle.specs.emissionClass > 'EUR4' ? vm.quote.vehicle.specs.emissionClass : 'EUR4';
            break;
          case 2:
            vm.quote.vehicle.specs.matriculation = vm.quote.vehicle.specs.matriculation > '2011' ? vm.quote.vehicle.specs.matriculation : '2011';
            vm.quote.vehicle.specs.emissionClass = vm.quote.vehicle.specs.emissionClass > 'EUR5' ? vm.quote.vehicle.specs.emissionClass : 'EUR5';
            vm.quote.vehicle.specs.matriculation = vm.quote.vehicle.specs.matriculation > '2006' ? vm.quote.vehicle.specs.matriculation : '2006';
            vm.quote.vehicle.services.conditioner = true;
            vm.quote.vehicle.services.luggage = true;
            vm.quote.vehicle.services.audio = true;
            vm.quote.vehicle.specs.emissionClass = vm.quote.vehicle.specs.emissionClass > 'EUR4' ? vm.quote.vehicle.specs.emissionClass : 'EUR4';
            break;
          case 1:
            vm.quote.vehicle.specs.matriculation = vm.quote.vehicle.specs.matriculation > '2006' ? vm.quote.vehicle.specs.matriculation : '2006';
            vm.quote.vehicle.services.conditioner = true;
            vm.quote.vehicle.services.luggage = true;
            vm.quote.vehicle.services.audio = true;
            vm.quote.vehicle.specs.emissionClass = vm.quote.vehicle.specs.emissionClass > 'EUR4' ? vm.quote.vehicle.specs.emissionClass : 'EUR4';
            break;
          case 0:
            vm.quote.vehicle = {
              specs: {
                seats: {}
              },
              services: {
                audio: false,
                coffeMachine: false,
                conditioner: false,
                display: false,
                dvdPlayer: false,
                electricity: false,
                fridge: false,
                kitchen: false,
                leatherSeats: false,
                light: false,
                luggage: false,
                microphone: false,
                panoramicWindows: false,
                radio: false,
                tintedWindows: false,
                toilet: false,
                tvAerial: false,
                usb: false,
                wheelchair: false,
                wifi: false
              }
            };
            break;
          default:
            break;
        }
      }
      vm.loaded = true;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brBookPublish', publishDirective);

  /** @ngInject */
  function publishDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        supplierQuote: '=brSupplierQuote',
        adminQuote: '=brQuote',
      },
      templateUrl: 'app/views/supplier/book/publish/publish.html',
      controller: 'BookPublishController',
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('BookPublishController', BookPublishController);

  /** @ngInject */
  function BookPublishController($rootScope, $scope, $state, $timeout, $interval, $alert, $validator, $error, $supplier) {
    var vm = this;
    vm.$onInit = function() {
      vm.admin = false;
      $scope.$on('saveChanges', function() {
      });
      vm.quote = {
        status: 'pending',
        Quote: vm.adminQuote
      };

      $scope.$watch(function() {return vm.supplierQuote}, function(newVal) {
        vm.quote = angular.copy(vm.supplierQuote || {status: 'pending'});
        vm.quote.Quote = vm.adminQuote;
          if (vm.quote && vm.quote.status != 'pending') {
            vm.prefix = '';
          }
          else {
            vm.prefix = 'Preview '
          }
      }, true);
      vm.loaded = true;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brBookPlan', bookPlanDirective);

  /** @ngInject */
  function bookPlanDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        quote: '=brQuote',
      },
      templateUrl: 'app/views/supplier/book/plan/plan.html',
      controller: 'BookPlanController',
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('BookPlanController', BookPlanController);

  /** @ngInject */
  function BookPlanController($rootScope, $state, $timeout, $alert, $validator, $error, $location, $cookies, $supplier) {
    var vm = this;
    vm.$onInit = function() {
      vm.loaded = true;
      var views = ['new', 'manual'];
      vm.index = views.indexOf(vm.quote.view);
      vm.index = vm.index === -1 ? 0 : vm.index;
    //console.log(vm.index)
      vm.select = function(tripType) {
        vm.quote.view = tripType;
        vm.view = tripType;
        switch (tripType) {
          case 'manual':
          case 'new':
          case 'tour':
          case 'shuttle':
            break;
        }
      }
      /*
      var id = $state.params.id;

      if(!id) {
        onControllerLoaded();
      }
      else if($validator('id', id) == 1) {
        vm.id = id;
        $result.trip(id).then(function(response) {
          vm.data = {
            passengers: response.result.passengers,
            trip: response.result.trip
          };
          onControllerLoaded();
        }, function(err) {
          var str = $error.get(err, 'api');
          switch(str.title) {
            case 'Codice ricerca errato': {
              $alert.show(str.title, str.msg, 'Torna alla homepage', 'Effettua una nuova ricerca', false, 0, 0,
              function(cancel) { $state.go('root.it.home'); },
              function(confirm) { $state.go('root.it.book.plan'); });
              break;
            }
            default: {
              $alert.show(str.title, str.msg, 'Ricarica', '', false, 0, 0,
                function(cancel) { $state.reload(); });
            }
          }
        });
      }
      else {
        $alert.show('Codice ricerca errato', 'La ricerca da te richiesta non esiste.', 'Torna alla homepage', 'Effettua una nuova ricerca', false, 0, 0,
          function(cancel) { $state.go('root.it.home'); },
          function(confirm) { $state.go('root.it.book.plan') });
      }

      function onControllerLoaded() {
        $timeout(function() { vm.loaded = true; }, 500);
        vm.onPlannerSubmit = function() {
          // Track action - start
          var steps = vm.data.trip.steps.map(function(step) {
            return step.place.address;
          }).join(' -> ');
          $segment.track('Products Searched', {
            query: steps,
            pickup_location: vm.data.trip.steps[0].place.address,
            pickup_date: vm.data.trip.steps[0].depart,
            dropoff_location: vm.data.trip.steps[vm.data.trip.steps.length-1].place.address,
            dropoff_date: vm.data.trip.steps[vm.data.trip.steps.length-1].arrive,
            filters: [{
              type: 'passengers',
              value: vm.data.onboard.passengers
            }]
          });
          // Track action - end

          $rootScope.$searching = true;
          $result.add(vm.data).then(function(response) {
            //console.log("[PLANNER] RESULT", response);
            $state.go('root.it.book.results', {id: response.result_id});
          }, function(err) {
            var str = $error.get(err, 'api');
            // Track action - start
            if(str.title == 'Area non coperta dal servizio') {
              var steps = vm.data.trip.steps.map(function(step) {
                return step.place.address;
              }).join(' -> ');
              $segment.track('Uncovered Area', {
                query: steps,
                pickup_location: vm.data.trip.steps[0].place.address,
                pickup_date: vm.data.trip.steps[0].depart,
                dropoff_location: vm.data.trip.steps[vm.data.trip.steps.length-1].place.address,
                dropoff_date: vm.data.trip.steps[vm.data.trip.steps.length-1].arrive,
                filters: [{
                  type: 'passengers',
                  value: vm.data.onboard.passengers
                }]
              });
            }
            // Track action - end

            $rootScope.$searching = false;
            $alert.show(str.title, str.msg, 'Chiudi', '', true);
          });
        };
      }*/
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brBookPartners', partnersDirective);

  /** @ngInject */
  function partnersDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        quote: '=brQuote',
      },
      templateUrl: 'app/views/supplier/book/partners/partners.html',
      controller: 'BookPartnersController',
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('BookPartnersController', BookPartnersController);

  /** @ngInject */
  function BookPartnersController($rootScope, $scope, $state, $timeout, $interval, $alert, $validator, $error, $supplier, uiGridConstants, $common) {
    var vm = this;
    vm.$onInit = function () {
      vm.admin = false;
      vm.seqNumber = 0;
      var DEFAULT_LAT = -360;
      var DEFAULT_LNG = -360;
      vm.distance = 100;
      vm.place = {
        location: {
          lat: DEFAULT_LAT,
          lng: DEFAULT_LNG
        }
      };
      /*
      $scope.$watch(function () {
        try {
          return vm.quote.trip.steps[0].place.location;
        } catch (err) {
          return '';
        }
      }, function () {
        try {
          if (vm.place.location.lat === DEFAULT_LAT && vm.place.location.lng === DEFAULT_LNG
            && vm.quote.trip.steps[0].place.location.lat !== DEFAULT_LAT && vm.quote.trip.steps[0].place.location.lng !== DEFAULT_LNG) {
            vm.place.location.lat = vm.quote.trip.steps[0].place.location.lat;
            vm.place.location.lng = vm.quote.trip.steps[0].place.location.lng;
            vm.searchSuppliers();
          }
        }
        catch (err) {

        }
      }, true);
      */
      $scope.$watch(function () {
        try {
          return vm.quote.requests[0].services[0].place.location;
        } catch (err) {
          return '';
        }
      }, function () {
        try {
          if (vm.place.location.lat === DEFAULT_LAT && vm.place.location.lng === DEFAULT_LNG &&
            vm.quote.requests[0].services[0].place.location.lat !== DEFAULT_LAT && vm.quote.requests[0].services[0].place.location.lng !== DEFAULT_LNG) {
            vm.place.location.lat = vm.quote.requests[0].services[0].place.location.lat;
            vm.place.location.lng = vm.quote.requests[0].services[0].place.location.lng;
            vm.searchSuppliers();
          }
        } catch (err) {

        }
      }, true);
      vm.registered = [];
      vm.selected = {};

      vm.zoom = 100;
      vm.resize = function (percentage) {
        var columnDefs = vm.defaultColumnDefs;
        for (var i = 0; i < columnDefs.length; i++) {
          if (columnDefs[i].width) {
            vm.gridOptions.columnDefs[i].width = columnDefs[i].width * percentage / 100;
          }
          if (columnDefs[i].minWidth) {
            vm.gridOptions.columnDefs[i].minWidth = columnDefs[i].minWidth * percentage / 100;
          }
          if (columnDefs[i].maxWidth) {
            vm.gridOptions.columnDefs[i].maxWidth = columnDefs[i].maxWidth * percentage / 100;
          }
        }
        vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
        if (percentage < 80) {
          vm.gridStyle['font-size'] = (percentage + 10) + '%';
        } else {
          vm.gridStyle['font-size'] = (percentage) + '%';
        }
        console.log('Resize')
        console.log(vm.gridStyle)
      }

      function getTableHeight(currentPage, pageSize, dataLen) {
        dataLen = $common.max(20, dataLen);
        var rowHeight = 30; // row height
        var headerHeight = 50; // header height
        var footerHeight = 60; // bottom scroll bar height
        var totalH = 0;
        var totalPage = Math.floor(dataLen / pageSize) + (dataLen % pageSize > 0 ? 1 : 0)
        if (totalPage > 1) {
          if (currentPage < totalPage) {
            totalH = pageSize * rowHeight + headerHeight + footerHeight;
          } else {
            var lastPageSize = dataLen % pageSize;
            if (lastPageSize === 0) {
              totalH = pageSize * rowHeight + headerHeight + footerHeight;
            } else {
              totalH = lastPageSize * rowHeight + headerHeight + footerHeight;
            }
          }
          console.log(totalH);
        } else {
          totalH = dataLen * rowHeight + headerHeight + footerHeight;
        }
        return $common.max(totalH, 300) + 'px';
      }

      vm.unfiltered = [];
      var i = 0;
      var j = 0;
      var ok = {};
      var keys = [];
      var good = {
        legal: {
          it: {}
        },
        contact: {

        },
        place: {

        },
        vehicles: {
          common: {

          },
          wheelchair: {

          }
        },
        insurance: {}
      }

      good.contact.warehouses = [];
      ok = {};
      for (i = 0; i < vm.unfiltered.length; i++) {
        if ($common.getDeep(vm.unfiltered[i], 'contact.warehouses')) {
          for (j = 0; j < vm.unfiltered[i].contact.warehouses.length; j++) {
            ok[vm.unfiltered[i].contact.warehouses[j]] = true;
          }
        }
      }
      keys = Object.keys(ok);
      for (i = 0; i < keys.length; i++) {
        good.contact.warehouses.push({
          name: keys[i],
          code: keys[i],
          selected: true
        });
      }
      good.contact.warehouses.push({
        name: 'Altro',
        code: '',
        selected: true
      });


      vm.filterData = {
        currentFilter: {
          between: [],
          belongs: [{
            "values": [{
              "selected": true,
              "value": true,
              "code": "s&igrave",
              "name": "S&igrave;"
            }, {
              "selected": true,
              "value": false,
              "code": "no",
              "name": "No"
            }, {
              "selected": true,
              "value": 'undefined',
              "code": "n/a",
              "name": "Risposta non presente nel db"
            }],
            "field": "verified",
            "type": "boolean",
            "value": []
          }, {
            "values": [{
              "selected": true,
              "value": true,
              "code": "non registrato",
              "name": "Non registrato"
            }, {
              "selected": true,
              "value": 'undefined',
              "code": "registrato",
              "name": "Registrato"
            }],
            "field": "external",
            "type": "boolean",
            "value": []
          }, {
            "values": $common.places,
            "field": "place.address",
            "type": "place",
            "value": []
          }, {
            "values": [{
              "selected": true,
              "value": true,
              "code": "s&igrave",
              "name": "S&igrave;"
            }, {
              "selected": true,
              "value": false,
              "code": "no",
              "name": "No"
            }, {
              "selected": true,
              "value": "undefined",
              "code": "n/a",
              "name": "Risposta non presente nel db"
            }],
            "field": "legal.it.mepa",
            "type": "boolean",
            "value": []
          }, {
            "values": good.contact.warehouses,
            "field": "contact.warehouses",
            "type": "array",
            "value": []
          }, {
            "values": [{
              "selected": true,
              "value": true,
              "code": "s&igrave",
              "name": "S&igrave;"
            }, {
              "selected": true,
              "value": false,
              "code": "no",
              "name": "No"
            }, {
              "selected": true,
              "value": "undefined",
              "code": "n/a",
              "name": "Risposta non presente nel db"
            }],
            "field": "vehicles.common.car",
            "type": "boolean",
            "value": []
          }, {
            "values": [{
              "selected": true,
              "value": true,
              "code": "s&igrave",
              "name": "S&igrave;"
            }, {
              "selected": true,
              "value": false,
              "code": "no",
              "name": "No"
            }, {
              "selected": true,
              "value": "undefined",
              "code": "n/a",
              "name": "Risposta non presente nel db"
            }],
            "field": "vehicles.common.minivan",
            "type": "boolean",
            "value": []
          }, {
            "values": [{
              "selected": true,
              "value": true,
              "code": "s&igrave",
              "name": "S&igrave;"
            }, {
              "selected": true,
              "value": false,
              "code": "no",
              "name": "No"
            }, {
              "selected": true,
              "value": "undefined",
              "code": "n/a",
              "name": "Risposta non presente nel db"
            }],
            "field": "vehicles.common.minibus",
            "type": "boolean",
            "value": []
          }, {
            "values": [{
              "selected": true,
              "value": true,
              "code": "s&igrave",
              "name": "S&igrave;"
            }, {
              "selected": true,
              "value": false,
              "code": "no",
              "name": "No"
            }, {
              "selected": true,
              "value": "undefined",
              "code": "n/a",
              "name": "Risposta non presente nel db"
            }],
            "field": "vehicles.common.coach",
            "type": "boolean",
            "value": []
          }, {
            "values": [{
              "selected": true,
              "value": true,
              "code": "s&igrave",
              "name": "S&igrave;"
            }, {
              "selected": true,
              "value": false,
              "code": "no",
              "name": "No"
            }, {
              "selected": true,
              "value": "undefined",
              "code": "n/a",
              "name": "Risposta non presente nel db"
            }],
            "field": "vehicles.common.coach3",
            "type": "boolean",
            "value": []
          }, {
            "values": [{
              "selected": true,
              "value": true,
              "code": "s&igrave",
              "name": "S&igrave;"
            }, {
              "selected": true,
              "value": false,
              "code": "no",
              "name": "No"
            }, {
              "selected": true,
              "value": "undefined",
              "code": "n/a",
              "name": "Risposta non presente nel db"
            }],
            "field": "vehicles.common.double",
            "type": "boolean",
            "value": []
          }, {
            "values": [{
              "selected": true,
              "value": true,
              "code": "s&igrave",
              "name": "S&igrave;"
            }, {
              "selected": true,
              "value": false,
              "code": "no",
              "name": "No"
            }, {
              "selected": true,
              "value": "undefined",
              "code": "n/a",
              "name": "Risposta non presente nel db"
            }],
            "field": "vehicles.common.vintage",
            "type": "boolean",
            "value": []
          }, {
            "values": [{
              "selected": true,
              "value": true,
              "code": "s&igrave",
              "name": "S&igrave;"
            }, {
              "selected": true,
              "value": false,
              "code": "no",
              "name": "No"
            }, {
              "selected": true,
              "value": "undefined",
              "code": "n/a",
              "name": "Risposta non presente nel db"
            }],
            "field": "vehicles.common.limousine",
            "type": "boolean",
            "value": []
          }, {
            "values": [{
              "selected": true,
              "value": true,
              "code": "s&igrave",
              "name": "S&igrave;"
            }, {
              "selected": true,
              "value": false,
              "code": "no",
              "name": "No"
            }, {
              "selected": true,
              "value": "undefined",
              "code": "n/a",
              "name": "Risposta non presente nel db"
            }],
            "field": "vehicles.wheelchair.minivan",
            "type": "boolean",
            "value": []
          }, {
            "values": [{
              "selected": true,
              "value": true,
              "code": "s&igrave",
              "name": "S&igrave;"
            }, {
              "selected": true,
              "value": false,
              "code": "no",
              "name": "No"
            }, {
              "selected": true,
              "value": "undefined",
              "code": "n/a",
              "name": "Risposta non presente nel db"
            }],
            "field": "vehicles.wheelchair.minibus",
            "type": "boolean",
            "value": []
          }, {
            "values": [{
              "selected": true,
              "value": true,
              "code": "s&igrave",
              "name": "S&igrave;"
            }, {
              "selected": true,
              "value": false,
              "code": "no",
              "name": "No"
            }, {
              "selected": true,
              "value": "undefined",
              "code": "n/a",
              "name": "Risposta non presente nel db"
            }],
            "field": "vehicles.wheelchair.minibuslg",
            "type": "boolean",
            "value": []
          }, {
            "values": [{
              "selected": true,
              "value": true,
              "code": "s&igrave",
              "name": "S&igrave;"
            }, {
              "selected": true,
              "value": false,
              "code": "no",
              "name": "No"
            }, {
              "selected": true,
              "value": "undefined",
              "code": "n/a",
              "name": "Risposta non presente nel db"
            }],
            "field": "vehicles.wheelchair.coach",
            "type": "boolean",
            "value": []
          }, {
            "values": [{
              "selected": true,
              "value": true,
              "code": "s&igrave",
              "name": "S&igrave;"
            }, {
              "selected": true,
              "value": false,
              "code": "no",
              "name": "No"
            }, {
              "selected": true,
              "value": "undefined",
              "code": "n/a",
              "name": "Risposta non presente nel db"
            }],
            "field": "vehicles.wheelchair.coach3",
            "type": "boolean",
            "value": []
          }],
          equals: [],
        }
      };


      var columnsData = {
        legal: {
          it: {}
        },
        contact: {

        },
        place: {

        },
        vehicles: {
          common: {

          },
          wheelchair: {

          }
        },
        insurance: {}
      };


      var columns = {
        legal: {
          it: {}
        },
        contact: {

        },

        place: {

        },
        vehicles: {
          common: {

          },
          wheelchair: {

          }
        },
        insurance: {}
      };


      var filterBase = {
        show: false,
        filterData: vm.filterData,
        onApply: function () {
          this.show = false;
          vm.currentFilter = angular.copy(vm.filterData.currentFilter);
          filterAll();
        },
      };


      var base = {
        enableColumnMenu: false,
        cellTooltip: true,
        headerCellTemplate: 'app/components/header-filter/generic.html',
        minWidth: 150
      }


      columnsData._id = angular.copy(filterBase);
      columnsData._id.label = 'Id';
      columnsData._id.dataType = 'string';
      columnsData._id.filterData = vm.filterData;
      columnsData._id.field = '_id';

      columnsData.external = angular.copy(filterBase);
      columnsData.external.label = 'Registrato';
      columnsData.external.dataType = 'boolean';
      columnsData.external.filterData = vm.filterData;
      columnsData.external.field = 'external';
      columnsData.external.filterType = 'belongs';

      columnsData.verified = angular.copy(filterBase);
      columnsData.verified.label = 'Verificato';
      columnsData.verified.dataType = 'boolean';
      columnsData.verified.filterData = vm.filterData;
      columnsData.verified.field = 'verified';
      columnsData.verified.filterType = 'belongs';

      columnsData.company = angular.copy(filterBase);
      columnsData.company.label = 'Ragione sociale';
      columnsData.company.dataType = 'string';
      columnsData.company.filterData = vm.filterData;
      columnsData.company.field = 'company';

      columnsData.email = angular.copy(filterBase);
      columnsData.email.label = 'Email verificata';
      columnsData.email.dataType = 'available';
      columnsData.email.filterData = vm.filterData;
      columnsData.email.field = 'email';

      columnsData.temail = angular.copy(filterBase);
      columnsData.temail.label = 'Email temporanea';
      columnsData.temail.dataType = 'available';
      columnsData.temail.filterData = vm.filterData;
      columnsData.temail.field = 'temail';

      columnsData.place.address = angular.copy(filterBase);
      columnsData.place.address.label = 'Sede legale';
      columnsData.place.address.dataType = 'place';
      columnsData.place.address.filterData = vm.filterData;
      columnsData.place.address.field = 'place.address';
      columnsData.place.address.filterType = 'belongs';

      columnsData.legal.it.mepa = angular.copy(filterBase);
      columnsData.legal.it.mepa.label = 'MEPA';
      columnsData.legal.it.mepa.dataType = 'boolean';
      columnsData.legal.it.mepa.filterData = vm.filterData;
      columnsData.legal.it.mepa.field = 'legal.it.mepa';
      columnsData.legal.it.mepa.filterType = 'belongs';

      columnsData.contact.warehouses = angular.copy(filterBase);
      columnsData.contact.warehouses.label = 'Depositi';
      columnsData.contact.warehouses.dataType = 'array';
      columnsData.contact.warehouses.filterData = vm.filterData;
      columnsData.contact.warehouses.field = 'contact.warehouses';
      columnsData.contact.warehouses.filterType = 'belongs';

      columnsData.vehicles.common.car = angular.copy(filterBase);
      columnsData.vehicles.common.car.label = 'Auto (1-5 PAX)';
      columnsData.vehicles.common.car.dataType = 'boolean';
      columnsData.vehicles.common.car.filterData = vm.filterData;
      columnsData.vehicles.common.car.field = 'vehicles.common.car';
      columnsData.vehicles.common.car.filterType = 'belongs';

      columnsData.vehicles.common.minivan = angular.copy(filterBase);
      columnsData.vehicles.common.minivan.label = 'Minivan (6-7-8 PAX)';
      columnsData.vehicles.common.minivan.dataType = 'boolean';
      columnsData.vehicles.common.minivan.filterData = vm.filterData;
      columnsData.vehicles.common.minivan.field = 'vehicles.common.minivan';
      columnsData.vehicles.common.minivan.filterType = 'belongs';

      columnsData.vehicles.common.minibus = angular.copy(filterBase);
      columnsData.vehicles.common.minibus.label = 'Minibus (9-28 PAX)';
      columnsData.vehicles.common.minibus.dataType = 'boolean';
      columnsData.vehicles.common.minibus.filterData = vm.filterData;
      columnsData.vehicles.common.minibus.field = 'vehicles.common.minibus';
      columnsData.vehicles.common.minibus.filterType = 'belongs';

      columnsData.vehicles.common.coach = angular.copy(filterBase);
      columnsData.vehicles.common.coach.label = 'Autobus (29-56 PAX)';
      columnsData.vehicles.common.coach.dataType = 'boolean';
      columnsData.vehicles.common.coach.filterData = vm.filterData;
      columnsData.vehicles.common.coach.field = 'vehicles.common.coach';
      columnsData.vehicles.common.coach.filterType = 'belongs';

      columnsData.vehicles.common.coach3 = angular.copy(filterBase);
      columnsData.vehicles.common.coach3.label = 'Autobus 3 assi (57-64 PAX)';
      columnsData.vehicles.common.coach3.dataType = 'boolean';
      columnsData.vehicles.common.coach3.filterData = vm.filterData;
      columnsData.vehicles.common.coach3.field = 'vehicles.common.coach3';
      columnsData.vehicles.common.coach3.filterType = 'belongs';

      columnsData.vehicles.common.double = angular.copy(filterBase);
      columnsData.vehicles.common.double.label = 'Autobus 2 piani (65+ PAX)';
      columnsData.vehicles.common.double.dataType = 'boolean';
      columnsData.vehicles.common.double.filterData = vm.filterData;
      columnsData.vehicles.common.double.field = 'vehicles.common.double';
      columnsData.vehicles.common.double.filterType = 'belongs';

      columnsData.vehicles.common.vintage = angular.copy(filterBase);
      columnsData.vehicles.common.vintage.label = 'Veicoli d\'epoca';
      columnsData.vehicles.common.vintage.dataType = 'boolean';
      columnsData.vehicles.common.vintage.filterData = vm.filterData;
      columnsData.vehicles.common.vintage.field = 'vehicles.common.vintage';
      columnsData.vehicles.common.vintage.filterType = 'belongs';

      columnsData.vehicles.common.limousine = angular.copy(filterBase);
      columnsData.vehicles.common.limousine.label = 'Limousine';
      columnsData.vehicles.common.limousine.dataType = 'boolean';
      columnsData.vehicles.common.limousine.filterData = vm.filterData;
      columnsData.vehicles.common.limousine.field = 'vehicles.common.limousine';
      columnsData.vehicles.common.limousine.filterType = 'belongs';

      columnsData.vehicles.wheelchair.minivan = angular.copy(filterBase);
      columnsData.vehicles.wheelchair.minivan.label = 'Minivan disabili (3-6 PAX)';
      columnsData.vehicles.wheelchair.minivan.dataType = 'boolean';
      columnsData.vehicles.wheelchair.minivan.filterData = vm.filterData;
      columnsData.vehicles.wheelchair.minivan.field = 'vehicles.wheelchair.minivan';
      columnsData.vehicles.wheelchair.minivan.filterType = 'belongs';

      columnsData.vehicles.wheelchair.minibus = angular.copy(filterBase);
      columnsData.vehicles.wheelchair.minibus.label = 'Minibus disabili (9-13 PAX)';
      columnsData.vehicles.wheelchair.minibus.dataType = 'boolean';
      columnsData.vehicles.wheelchair.minibus.filterData = vm.filterData;
      columnsData.vehicles.wheelchair.minibus.field = 'vehicles.wheelchair.minibus';
      columnsData.vehicles.wheelchair.minibus.filterType = 'belongs';

      columnsData.vehicles.wheelchair.minibuslg = angular.copy(filterBase);
      columnsData.vehicles.wheelchair.minibuslg.label = 'Minibus disabili (14-30 PAX)';
      columnsData.vehicles.wheelchair.minibuslg.dataType = 'boolean';
      columnsData.vehicles.wheelchair.minibuslg.filterData = vm.filterData;
      columnsData.vehicles.wheelchair.minibuslg.field = 'vehicles.wheelchair.minibuslg';
      columnsData.vehicles.wheelchair.minibuslg.filterType = 'belongs';

      columnsData.vehicles.wheelchair.coach = angular.copy(filterBase);
      columnsData.vehicles.wheelchair.coach.label = 'Autobus disabili (31-48 PAX)';
      columnsData.vehicles.wheelchair.coach.dataType = 'boolean';
      columnsData.vehicles.wheelchair.coach.filterData = vm.filterData;
      columnsData.vehicles.wheelchair.coach.field = 'vehicles.wheelchair.coach';
      columnsData.vehicles.wheelchair.coach.filterType = 'belongs';

      columnsData.vehicles.wheelchair.coach3 = angular.copy(filterBase);
      columnsData.vehicles.wheelchair.coach3.label = 'Autobus 3 assi disabili (49-61 PAX)';
      columnsData.vehicles.wheelchair.coach3.dataType = 'boolean';
      columnsData.vehicles.wheelchair.coach3.filterData = vm.filterData;
      columnsData.vehicles.wheelchair.coach3.field = 'vehicles.wheelchair.coach3';
      columnsData.vehicles.wheelchair.coach3.filterType = 'belongs';

      columns._id = angular.copy(base);
      columns._id.field = '_id';
      columns._id.name = 'Id';
      columns._id.data = columnsData._id;
      columns._id.cellTemplate = '<div class="ui-grid-cell-contents"  title="{{COL_FIELD CUSTOM_FILTERS}}"><a ui-sref="root.it.admin.suppliers.edit({\'id\': COL_FIELD})">{{COL_FIELD CUSTOM_FILTERS}}</a></div>';

      columns.verified = angular.copy(base);
      columns.verified.field = 'verified';
      columns.verified.name = 'Verificato';
      columns.verified.data = columnsData.verified;
      columns.verified.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';


      columns.external = angular.copy(base);
      columns.external.field = 'external';
      columns.external.name = 'Registrato';
      columns.external.data = columnsData.external;
      columns.external.cellTemplate = '<div class="ui-grid-cell-contents" title="{{!COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': !COL_FIELD}"></span></div>';

      columns.company = angular.copy(base);
      columns.company.field = 'company';
      columns.company.name = 'Ragione sociale';
      columns.company.data = columnsData.company;

      columns.email = angular.copy(base);
      columns.email.field = 'email';
      columns.email.name = 'Email verificata';
      columns.email.data = columnsData.email;

      columns.temail = angular.copy(base);
      columns.temail.field = 'temail';
      columns.temail.name = 'Email temporanea';
      columns.temail.data = columnsData.temail;

      columns.place.address = angular.copy(base);
      columns.place.address.field = 'place.address';
      columns.place.address.name = 'Sede legale';
      columns.place.address.data = columnsData.place.address;

      columns.legal.it.mepa = angular.copy(base);
      columns.legal.it.mepa.field = 'legal.it.mepa';
      columns.legal.it.mepa.name = 'MEPA';
      columns.legal.it.mepa.data = columnsData.legal.it.mepa;
      columns.legal.it.mepa.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';

      columns.contact.warehouses = angular.copy(base);
      columns.contact.warehouses.field = 'contact.warehouses';
      columns.contact.warehouses.name = 'Depositi';
      columns.contact.warehouses.data = columnsData.contact.warehouses;
      columns.contact.warehouses.cellFilter = 'addressArray';

      columns.vehicles.common.car = angular.copy(base);
      columns.vehicles.common.car.field = 'vehicles.common.car';
      columns.vehicles.common.car.name = 'Auto (1-5 PAX)';
      columns.vehicles.common.car.data = columnsData.vehicles.common.car;
      columns.vehicles.common.car.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';

      columns.vehicles.common.minivan = angular.copy(base);
      columns.vehicles.common.minivan.field = 'vehicles.common.minivan';
      columns.vehicles.common.minivan.name = 'Minivan (6-7-8 PAX)';
      columns.vehicles.common.minivan.data = columnsData.vehicles.common.minivan;
      columns.vehicles.common.minivan.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';

      columns.vehicles.common.minibus = angular.copy(base);
      columns.vehicles.common.minibus.field = 'vehicles.common.minibus';
      columns.vehicles.common.minibus.name = 'Minibus (9-28 PAX)';
      columns.vehicles.common.minibus.data = columnsData.vehicles.common.minibus;
      columns.vehicles.common.minibus.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';

      columns.vehicles.common.coach = angular.copy(base);
      columns.vehicles.common.coach.field = 'vehicles.common.coach';
      columns.vehicles.common.coach.name = 'Autobus (29-56 PAX)';
      columns.vehicles.common.coach.data = columnsData.vehicles.common.coach;
      columns.vehicles.common.coach.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';

      columns.vehicles.common.coach3 = angular.copy(base);
      columns.vehicles.common.coach3.field = 'vehicles.common.coach3';
      columns.vehicles.common.coach3.name = 'Autobus 3 assi (57-64 PAX)';
      columns.vehicles.common.coach3.data = columnsData.vehicles.common.coach3;
      columns.vehicles.common.coach3.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';

      columns.vehicles.common.double = angular.copy(base);
      columns.vehicles.common.double.field = 'vehicles.common.double';
      columns.vehicles.common.double.name = 'Autobus 2 piani (65+ PAX)';
      columns.vehicles.common.double.data = columnsData.vehicles.common.double;
      columns.vehicles.common.double.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';

      columns.vehicles.common.vintage = angular.copy(base);
      columns.vehicles.common.vintage.field = 'vehicles.common.vintage';
      columns.vehicles.common.vintage.name = 'Veicoli d\'epoca';
      columns.vehicles.common.vintage.data = columnsData.vehicles.common.vintage;
      columns.vehicles.common.vintage.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';

      columns.vehicles.common.limousine = angular.copy(base);
      columns.vehicles.common.limousine.field = 'vehicles.common.limousine';
      columns.vehicles.common.limousine.name = 'Limousine';
      columns.vehicles.common.limousine.data = columnsData.vehicles.common.limousine;
      columns.vehicles.common.limousine.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';

      columns.vehicles.wheelchair.minivan = angular.copy(base);
      columns.vehicles.wheelchair.minivan.field = 'vehicles.wheelchair.minivan';
      columns.vehicles.wheelchair.minivan.name = 'Minivan disabili (3-6 PAX)';
      columns.vehicles.wheelchair.minivan.data = columnsData.vehicles.wheelchair.minivan;
      columns.vehicles.wheelchair.minivan.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';

      columns.vehicles.wheelchair.minibus = angular.copy(base);
      columns.vehicles.wheelchair.minibus.field = 'vehicles.wheelchair.minibus';
      columns.vehicles.wheelchair.minibus.name = 'Minibus disabili (9-13 PAX)';
      columns.vehicles.wheelchair.minibus.data = columnsData.vehicles.wheelchair.minibus;
      columns.vehicles.wheelchair.minibus.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';

      columns.vehicles.wheelchair.minibuslg = angular.copy(base);
      columns.vehicles.wheelchair.minibuslg.field = 'vehicles.wheelchair.minibuslg';
      columns.vehicles.wheelchair.minibuslg.name = 'Minibus disabili (14-30 PAX)';
      columns.vehicles.wheelchair.minibuslg.data = columnsData.vehicles.wheelchair.minibuslg;
      columns.vehicles.wheelchair.minibuslg.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';

      columns.vehicles.wheelchair.coach = angular.copy(base);
      columns.vehicles.wheelchair.coach.field = 'vehicles.wheelchair.coach';
      columns.vehicles.wheelchair.coach.name = 'Autobus disabili (31-48 PAX)';
      columns.vehicles.wheelchair.coach.data = columnsData.vehicles.wheelchair.coach;
      columns.vehicles.wheelchair.coach.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';

      columns.vehicles.wheelchair.coach3 = angular.copy(base);
      columns.vehicles.wheelchair.coach3.field = 'vehicles.wheelchair.coach3';
      columns.vehicles.wheelchair.coach3.name = 'Autobus 3 assi disabili (49-61 PAX)';
      columns.vehicles.wheelchair.coach3.data = columnsData.vehicles.wheelchair.coach3;
      columns.vehicles.wheelchair.coach3.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD CUSTOM_FILTERS}}"><span class="icon" ng-class="{\'icon-thick\': COL_FIELD}"></span></div>';
      vm.defaultColumnDefs = [
        columns._id,
        columns.external,
        columns.verified,
        columns.company,
        columns.email,
        columns.temail,
        columns.place.address,
        columns.legal.it.mepa,
        columns.contact.warehouses,
        columns.vehicles.common.car,
        columns.vehicles.common.minivan,
        columns.vehicles.common.minibus,
        columns.vehicles.common.coach,
        columns.vehicles.common.coach3,
        columns.vehicles.common.double,
        columns.vehicles.common.vintage,
        columns.vehicles.common.limousine,
        columns.vehicles.wheelchair.minivan,
        columns.vehicles.wheelchair.minibus,
        columns.vehicles.wheelchair.minibuslg,
        columns.vehicles.wheelchair.coach,
        columns.vehicles.wheelchair.coach3,
      ]

      function filterAll() {
        var filter = {
          legal: {
            it: {}
          },
          contact: {},
          place: {},
          vehicles: {
            common: {},
            wheelchair: {}
          },
          insurance: {}
        };
        var data = vm.unfiltered;
        filter.verified = vm.currentFilter.belongs.find(function (element) {
          return element.field === 'verified';
        });
        data = $common.filterBoolean(data, 'verified', filter.verified.values);

        filter.external = vm.currentFilter.belongs.find(function (element) {
          return element.field === 'external';
        });
        data = $common.filterBoolean(data, 'external', filter.external.values);

        filter.place.address = vm.currentFilter.belongs.find(function (element) {
          return element.field === 'place.address';
        });
        data = $common.filterPlace(data, 'place.address', filter.place.address.values, $common.places);
        filter.legal.it.mepa = vm.currentFilter.belongs.find(function (element) {
          return element.field === 'legal.it.mepa';
        });
        data = $common.filterBoolean(data, 'legal.it.mepa', filter.legal.it.mepa.values);
        filter.contact.warehouses = vm.currentFilter.belongs.find(function (element) {
          return element.field === 'contact.warehouses';
        });
        data = $common.filterIntersection(data, 'contact.warehouses', filter.contact.warehouses.values);
        filter.vehicles.common.car = vm.currentFilter.belongs.find(function (element) {
          return element.field === 'vehicles.common.car';
        });
        data = $common.filterBoolean(data, 'vehicles.common.car', filter.vehicles.common.car.values);
        filter.vehicles.common.minivan = vm.currentFilter.belongs.find(function (element) {
          return element.field === 'vehicles.common.minivan';
        });
        data = $common.filterBoolean(data, 'vehicles.common.minivan', filter.vehicles.common.minivan.values);
        filter.vehicles.common.minibus = vm.currentFilter.belongs.find(function (element) {
          return element.field === 'vehicles.common.minibus';
        });
        data = $common.filterBoolean(data, 'vehicles.common.minibus', filter.vehicles.common.minibus.values);
        filter.vehicles.common.coach = vm.currentFilter.belongs.find(function (element) {
          return element.field === 'vehicles.common.coach';
        });
        data = $common.filterBoolean(data, 'vehicles.common.coach', filter.vehicles.common.coach.values);
        filter.vehicles.common.coach3 = vm.currentFilter.belongs.find(function (element) {
          return element.field === 'vehicles.common.coach3';
        });
        data = $common.filterBoolean(data, 'vehicles.common.coach3', filter.vehicles.common.coach3.values);
        filter.vehicles.common.double = vm.currentFilter.belongs.find(function (element) {
          return element.field === 'vehicles.common.double';
        });
        data = $common.filterBoolean(data, 'vehicles.common.double', filter.vehicles.common.double.values);
        filter.vehicles.common.vintage = vm.currentFilter.belongs.find(function (element) {
          return element.field === 'vehicles.common.vintage';
        });
        data = $common.filterBoolean(data, 'vehicles.common.vintage', filter.vehicles.common.vintage.values);
        filter.vehicles.common.limousine = vm.currentFilter.belongs.find(function (element) {
          return element.field === 'vehicles.common.limousine';
        });
        data = $common.filterBoolean(data, 'vehicles.common.limousine', filter.vehicles.common.limousine.values);
        filter.vehicles.wheelchair.minivan = vm.currentFilter.belongs.find(function (element) {
          return element.field === 'vehicles.wheelchair.minivan';
        });
        data = $common.filterBoolean(data, 'vehicles.wheelchair.minivan', filter.vehicles.wheelchair.minivan.values);
        filter.vehicles.wheelchair.minibus = vm.currentFilter.belongs.find(function (element) {
          return element.field === 'vehicles.wheelchair.minibus';
        });
        data = $common.filterBoolean(data, 'vehicles.wheelchair.minibus', filter.vehicles.wheelchair.minibus.values);
        filter.vehicles.wheelchair.minibuslg = vm.currentFilter.belongs.find(function (element) {
          return element.field === 'vehicles.wheelchair.minibuslg';
        });
        data = $common.filterBoolean(data, 'vehicles.wheelchair.minibuslg', filter.vehicles.wheelchair.minibuslg.values);
        filter.vehicles.wheelchair.coach = vm.currentFilter.belongs.find(function (element) {
          return element.field === 'vehicles.wheelchair.coach';
        });
        data = $common.filterBoolean(data, 'vehicles.wheelchair.coach', filter.vehicles.wheelchair.coach.values);
        filter.vehicles.wheelchair.coach3 = vm.currentFilter.belongs.find(function (element) {
          return element.field === 'vehicles.wheelchair.coach3';
        });
        data = $common.filterBoolean(data, 'vehicles.wheelchair.coach3', filter.vehicles.wheelchair.coach3.values);


        vm.gridOptions.data = data;
        vm.gridApi.core.refresh();
      }


      vm.gridOptions1 = {
        enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
        onRegisterApi: function (gridApi) {
          vm.gridApi1 = gridApi;
        }
      };
      vm.gridStyle = {
        height: '600px'
      };
      vm.gridOptions = {
        paginationPageSizes: [20, 40, 80, 120],
        paginationPageSize: 80,
        minRowsToShow: 23,
        enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
        enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
        onRegisterApi: function (gridApi) {
          vm.gridApi = gridApi;
          vm.gridStyle.height = getTableHeight(1, 20, vm.gridOptions.data.length);
          vm.gridApi.grid.handleWindowResize();
          vm.gridApi.core.refresh();

          vm.gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
            vm.gridStyle.height = getTableHeight(newPage, pageSize, vm.gridOptions.data.length);
            vm.gridApi.grid.handleWindowResize();
            vm.gridApi.core.refresh();
          });
        }
      };
      vm.gridOptions.columnDefs = vm.defaultColumnDefs;

      vm.gridOptions1.columnDefs = [{
          field: 'company',
          name: 'Azienda',
          cellTooltip: true,
          pinnedLeft: true,
          minWidth: 200,

        },
        {
          field: 'place.address',
          name: 'Sede Amministrativa',
          cellTooltip: true,
          minWidth: 200,

        },
        {
          field: 'email',
          name: 'Email',
          cellTooltip: true,
          minWidth: 200,

        }
      ];
      vm.searchSuppliers = function () {
        vm.unfiltered = [];
        $supplier.getSuppliersNear(vm.place, vm.distance).then(function (response) {
          return $supplier.getTmpSuppliersNear(vm.place, vm.distance).then(function (response1) {
            response.suppliers = response.suppliers.concat(response1.suppliers)
            var tmp = [];
            // vm.selected = {};
            // var slc = vm.gridApi.selection.getSelectedRows()
            // for (var i = 0; i < slc.length; i++) {
            //   if (!slc[i].external) {
            //     tmp.push(slc[i]);
            //     vm.selected[slc[i].id] = true;
            //   }
            // }
            vm.registered = tmp;
            for (i = 0; i < response.suppliers.length; i++) {
              // if (!vm.selected[response.suppliers[i].id]) {
              response.suppliers[i].selected = false;
              vm.registered.push(response.suppliers[i]);
              // }
            }
            vm.unfiltered = vm.registered;
            vm.gridApi.grid.modifyRows(vm.gridOptions.data);
            vm.gridOptions.data = vm.registered;
            // for (i = 0; i < vm.gridOptions.data.length; i++) {
            //   if (vm.selected[vm.gridOptions.data[i].id]) {
            //     vm.gridApi.selection.selectRow(vm.gridOptions.data[i]);
            //   }
            // }
            vm.gridApi.core.refresh();
            if (vm.number)
              vm.search(vm.number);
            //console.log(vm.nonRegistered);
          });
        }, function (err) {
          var str = $error.get(err, 'api');
          $alert.show(str.title, str.msg, 'Torna alla dashboard', 'Nascondi messaggio di errore', true, 0, -1,
            function (cancel) {
              $state.go('root.it.supplier.quotes.list');
            },
            function (accept) {});

        });
      }
      vm.search = function (val) {
        var data = [];
        console.log(data)
        console.log(data)
        console.log(data)
        for (var i = 0; i < vm.unfiltered.length; i++) {
          if ((vm.unfiltered[i].tcompany && vm.unfiltered[i].tcompany.toLocaleLowerCase().indexOf(val.toLocaleLowerCase()) !== -1) ||
            (vm.unfiltered[i].company && vm.unfiltered[i].company.toLocaleLowerCase().indexOf(val.toLocaleLowerCase()) !== -1) ||
            (vm.unfiltered[i].email && vm.unfiltered[i].email.toLocaleLowerCase().indexOf(val.toLocaleLowerCase()) !== -1) ||
            (vm.unfiltered[i].temail && vm.unfiltered[i].temail.toLocaleLowerCase().indexOf(val.toLocaleLowerCase()) !== -1) ||
            (vm.unfiltered[i].place.address && vm.unfiltered[i].place.address.toLocaleLowerCase().indexOf(val.toLocaleLowerCase()) !== -1) ||
            (vm.unfiltered[i].name && vm.unfiltered[i].name.toLocaleLowerCase().indexOf(val.toLocaleLowerCase()) !== -1) ||
            (vm.unfiltered[i].surname && vm.unfiltered[i].surname.toLocaleLowerCase().indexOf(val.toLocaleLowerCase()) !== -1) ||
            (vm.unfiltered[i].pec && vm.unfiltered[i].pec.toLocaleLowerCase().indexOf(val.toLocaleLowerCase()) !== -1) ||
            (vm.unfiltered[i].phone && vm.unfiltered[i].phone.toLocaleLowerCase().indexOf(val.toLocaleLowerCase()) !== -1) ||
            (vm.unfiltered[i].companyphone && vm.unfiltered[i].companyphone.toLocaleLowerCase().indexOf(val.toLocaleLowerCase()) !== -1) ||
            (vm.unfiltered[i].emergencyphone && vm.unfiltered[i].emergencyphone.toLocaleLowerCase().indexOf(val.toLocaleLowerCase()) !== -1)) {
            data.push(vm.unfiltered[i]);
            console.log(data)
          }
        }
        vm.gridOptions.data = data;
        vm.gridApi.core.refresh();
      }
      /*
      $supplier.getSupplierQuotes(vm.quote.id).then(function (response) {
        vm.gridApi.grid.modifyRows(vm.gridOptions.data);

        for (var i = 0; i < response.quotes.length; i++) {
          vm.selected[response.quotes[i].Supplier.id] = response.quotes[i].status !== 'voided';
          var old = false;
          var idx = -1;
          for (var j = 0; j < vm.registered.length; j++) {
            if (vm.registered[j].id === response.quotes[i].Supplier.id) {
              old = true;
              idx = j;
              break;
            }
          }
          if (!old)
            vm.registered.push(response.quotes[i].Supplier);
          else {
            // vm.gridApi.selection.selectRow(vm.gridOptions.data[idx]);
          }
        }

        vm.gridOptions.data = vm.registered;
        vm.gridApi.core.refresh();
        //console.log(vm.selected);
      }, function (err) {
        var str = $error.get(err, 'api');
        $alert.show(str.title, str.msg, 'Torna alla dashboard', 'Ricarica pagina', true, 0, 5000,
          function (cancel) {
            $state.go('root.it.supplier.quotes.list');
          },
          function (accept) {
            $state.reload();
          });
      });
      $supplier.getSupplierQuotesTmp(vm.quote.id).then(function (response) {
        vm.gridApi1.grid.modifyRows(vm.gridOptions1.data);

        for (var i = 0; i < response.quotes.length; i++) {
          vm.selected1[response.quotes[i].Supplier.id] = response.quotes[i].status !== 'voided';
          response.quotes[i].Supplier;
          var old = false;
          var idx = -1;
          for (var j = 0; j < vm.nonRegistered.length; j++) {
            if (vm.nonRegistered[j].id === response.quotes[i].Supplier.id) {
              old = true;
              idx = j;
              break;
            }
          }
          if (!old)
            vm.nonRegistered.push(response.quotes[i].Supplier);
          else {
            // vm.gridApi1.selection.selectRow(vm.gridOptions1.data[idx]);
          }
        }

        vm.gridOptions1.data = vm.nonRegistered;
        vm.gridApi1.core.refresh();
        //console.log(vm.selected);
      }, function (err) {
        var str = $error.get(err, 'api');
        $alert.show(str.title, str.msg, 'Torna alla dashboard', 'Ricarica pagina', true, 0, 5000,
          function (cancel) {
            $state.go('root.it.supplier.quotes.list');
          },
          function (accept) {
            $state.reload();
          });
      });
      */
      $scope.$on('sendQuotes', function () {
        var suppliers = [];
        var supplierstmp = [];
        var selected = vm.gridApi.selection.getSelectedRows();
        for (var i = 0; i < selected.length; i++) {
          if (selected[i].external) {
            supplierstmp.push(selected[i].id);
          } else {
            suppliers.push(selected[i].id);
          }
        }

        // var selected1 = vm.gridApi1.selection.getSelectedRows();
        //
        // for (var j = 0; j < selected1.length; j++) {
        //   supplierstmp.push(selected1[j].id);
        // }
        $supplier.sendQuote(vm.quote.id, suppliers, vm.type).then(function (response) {
          $supplier.sendQuoteTmp(vm.quote.id, supplierstmp, vm.type).then(function (response1) {
            vm.warning = 'Da adesso i partner selezionati possono visualizzare la richiesta'
            $timeout(function () {
              delete vm.warning;
            }, 5000);
          }, function (err) {
            var str = $error.get(err, 'api');
            $alert.show(str.title, str.msg, 'Torna alla dashboard', 'Nascondi messaggio di errore', true, 0, -1,
              function (cancel) {
                $state.go('root.it.supplier.quotes.list');
              },
              function (accept) {});
          });
        }, function (err) {
          var str = $error.get(err, 'api');
          $alert.show(str.title, str.msg, 'Torna alla dashboard', 'Nascondi messaggio di errore', true, 0, -1,
            function (cancel) {
              $state.go('root.it.supplier.quotes.list');
            },
            function (accept) {});

        });
      });

      $scope.$on('quoteUpdated', function (event, seqNumber) {

        var suppliers = [];
        var supplierstmp = [];
        var selected = vm.gridApi.selection.getSelectedRows();
        var emails = '';
        for (var j = 0; j < selected.length; j++) {
          emails += (selected[j].email !== '' ? selected[j].email : selected[j].temail) + '<br/>';
          if (selected[j].external) supplierstmp.push(selected[j].id);
          else suppliers.push(selected[j].id);

        }
        /*
        var selected1 = vm.gridApi1.selection.getSelectedRows();

        for (j = 0; j < selected1.length; j++) {
          emails += (selected[j].email !== '' ? selected[j].email : selected[j].temail) + '<br/>';
          supplierstmp.push(selected1[j].id);
        }
        */
        $scope.$broadcast('sendQuotes');
        $scope.$broadcast('sendQuoteEmails');
        if (seqNumber === vm.seqNumber) {
          //for (var i = 0; i < selected.length; i++) {
          //  suppliers.push(selected[i].id);
          //}
          $supplier.sendQuoteEmails(vm.quote.id, suppliers).then(function (response) {
            $alert.show('Email inviata a', emails, 'Torna alla dashboard', 'Continua a modificare la richiesta', true, 0, -1,
              function (cancel) {
                $state.go('root.it.supplier.quotes.list');
              },
              function (accept) {});
          }, function (err) {
            var str = $error.get(err, 'api');
            $alert.show(str.title, str.msg, 'Torna alla dashboard', 'Nascondi messaggio di errore', true, 0, -1,
              function (cancel) {
                $state.go('root.it.supplier.quotes.list');
              },
              function (accept) {});

          });
          $supplier.sendQuoteTmpEmails(vm.quote.id, supplierstmp).then(function (response) {

          }, function (err) {
            var str = $error.get(err, 'api');
            $alert.show(str.title, str.msg, 'Torna alla dashboard', 'Nascondi messaggio di errore', true, 0, -1,
              function (cancel) {
                $state.go('root.it.supplier.quotes.list');
              },
              function (accept) {});

          });
        }
      });
      vm.sendQuoteEmails = function () {
        var suppliers = [];
        var selected = vm.gridApi.selection.getSelectedRows();
        var supplierstmp = [];
        var emails = '';
        for (var j = 0; j < selected.length; j++) {
          emails += (selected[j].email !== '' ? selected[j].email : selected[j].temail) + '<br/>';
          if (selected[j].external) supplierstmp.push(selected[j].id);
          else suppliers.push(selected[j].id);
        }
        //var selected1 = vm.gridApi1.selection.getSelectedRows();
        //
        //for (j = 0; j < selected1.length; j++) {
        //  emails += selected1[j].email + '<br/>';
        //  supplierstmp.push(selected1[j].id);
        //}
        $alert.show('Invia richiesta via email', emails, 'Annulla invio', 'Invia email ai partner selezionati', false, 500, -1, function (cancel) {}, function (accept) {
          vm.seqNumber++;
          console.log('Requested update for ' + vm.seqNumber)
          $scope.$emit('updateQuote', vm.seqNumber);
        });
      }
      vm.sendQuotes = function () {
        $scope.$broadcast('sendQuotes');
      }
      vm.now = new Date();
      vm.loaded = true;

    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brBookOverview', overviewDirective);

  /** @ngInject */
  function overviewDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        quote: '=brQuote',
      },
      templateUrl: 'app/views/supplier/book/overview/overview.html',
      controller: 'BookOverviewController',
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('BookOverviewController', BookOverviewController);

  /** @ngInject */
  function BookOverviewController($rootScope, $scope, $state, $timeout, $interval, $alert, $validator, $error, $supplier, $common) {
    var vm = this;
    vm.$onInit = function () {
      vm.admin = false;
      vm.quote.onboard = vm.quote.onboard || {};
      vm.vat = 10;
      $scope.$on('saveChanges', function () {});
      vm.loaded = true;

      vm.name = $common.getRequestShortDescription;
      // vm.name(vm.quote.requests)
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brBookNetwork', networkDirective);

  /** @ngInject */
  function networkDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        quote: '=brQuote',
      },
      templateUrl: 'app/views/supplier/book/network/network.html',
      controller: 'BookNetworkController',
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('BookNetworkController', BookNetworkController);

  /** @ngInject */
  function BookNetworkController($rootScope, $scope, $state, $timeout, $interval, $alert, $validator, $error, $supplier, uiGridConstants, $common) {
    var vm = this;
    vm.$onInit = function () {
      vm.network = [];
      $supplier.isVerified().then(function (response) {
        vm.verified = response.verified;

      });
      vm.flipAll = function () {
        vm.flipping = true;
        var network = angular.copy(vm.network)
        vm.networkAll = !vm.networkAll;
        for (var i = 0; i < network.length; i++) {
          network[i].selected = vm.networkAll;
        }
        vm.network = network
        vm.flipping = false;
      }
      $scope.$watch(function() {return vm.network}, function() {
        if (vm.flipping) return;
        vm.networkAll = true;
        for (var i = 0; i < vm.network.length; i++) {
          if (vm.flipping) break;
          if (!vm.network[i].selected) {
            vm.networkAll = false;
            break;
          }
        }
      }, true);
      function init() {
        if (vm.deregister) vm.deregister();
        vm.loaded = false;
        $supplier.getNetwork().then(function(result) {
          console.log(result)
          console.log(vm.quote.network)
          for (var i = 0; i < result.network.length; i++) {
            vm.network.push(result.network[i]);
            for (var j = 0; j < vm.quote.network.length; j++) {
              if (vm.quote.network[j].email == result.network[i].email) {
                vm.network[vm.network.length - 1].selected = true;
              }
            }
          }
          vm.loaded = true;
          vm.deregister = $scope.$watch(function() {
            return vm.network;
          }, function(newValue) {
            vm.quote.network = [];
            for (var i = 0; i < newValue.length; i++) {
              if (newValue[i].selected)
                vm.quote.network.push({email: newValue[i].email, name: newValue[i].name});
            }
          }, true);
        }).catch(function(err) {
          var str = $error.get(err, 'api');
          $alert.show(str.title, str.msg, 'Ricarica', '', true, 0, 5000,
            function (cancel) { $state.reload(); });
        });
        return;
      }

      init();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brBookAttachment', attachmentDirective);

  /** @ngInject */
  function attachmentDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        quote: '=brQuote',
      },
      templateUrl: 'app/views/supplier/book/attachments/attachments.html',
      controller: 'BookAttachmentsController',
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('BookAttachmentsController', BookAttachmentsController);

  /** @ngInject */
  function BookAttachmentsController($rootScope, $scope, $state, $timeout, $interval, $alert, $validator, $error, $supplier, Upload, cloudinary) {
    var vm = this;
    vm.$onInit = function () {
      vm.admin = false;
      vm.loaded = true;
      vm.files = [];
      vm.tags = ["private", "public"];

      function onControllerLoaded(responseUpload) {
        $scope.$on('saveChanges', function (event, seqNumber) {

          var fileToUpload = vm.files.length;
          if (fileToUpload > 0) {
            angular.forEach(vm.files, function (file) {
              var upload = {};
              angular.copy(responseUpload.upload, upload);
              upload.file = file;
              Upload.upload({
                url: cloudinary.config().cloud_upload,
                data: upload
              }).progress(function (e) {
                file.progress = Math.round((e.loaded * 100.0) / e.total);
              }).success(function (data, status, headers, config) {
                file.result = data;
                console.log(data);
                vm.quote.attachments.push({ url: data.public_id, name: file.fname, provider: 'cloudinary', authorization: 'private' });
                fileToUpload--;
                if (fileToUpload === 0) {
                  onUploadComplete();
                }
              }).error(function (data, status, headers, config) {
                var str = $error.get(data);
                vm.warning = str.msg;
                fileToUpload--;
              });
            });
            vm.files = [];
          }
          else {
            onUploadComplete();
          }
          function onUploadComplete() {
            console.log('File uploaded for', seqNumber)
            $scope.$emit('fileUploaded', seqNumber);
          }
        });

      }

      vm.now = new Date();

      $supplier.getUploadSign(vm.quote.id).then(function (responseUpload) {
        onControllerLoaded(responseUpload);
      }, function (err) {
        var str = $error.get(err, 'api');
        $alert.show(str.title, str.msg, 'Torna alla dashboard', 'Ricarica pagina', true, 0, 5000,
          function (cancel) { $state.go('root.it.supplier.quotes.list'); }, function (accept) { $state.reload(); });
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brBookDrivers', driversDirective);

  /** @ngInject */
  function driversDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        quote: '=brQuote',
      },
      templateUrl: 'app/views/supplier/book/drivers/drivers.html',
      controller: 'BookUsersController',
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('BookDriversController', BookDriversController);

  /** @ngInject */
  function BookDriversController($rootScope, $scope, $state, $timeout, $interval, $alert, $validator, $error) {
    var vm = this;
    vm.$onInit = function() {
      vm.loaded = true;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brBookEmail', emailDirective);

  /** @ngInject */
  function emailDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        quote: '=brQuote',
      },
      templateUrl: 'app/views/supplier/book/email/email.html',
      controller: 'BookEmailController',
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('BookEmailController', BookEmailController);

  /** @ngInject */
  function BookEmailController($rootScope, $scope, $state, $timeout, $interval, $alert, $validator, $error, $supplier, $filter, $compile, $common) {
    var vm = this;
    vm.$onInit = function () {

      vm.templates = [];
      vm.getRequestsString = function (requests) {
        return $common.getRequestFullDescription(requests, vm.quote.service_type);
      }
      $supplier.getEmailTemplates().then(function (response) {
        vm.templates = vm.templates.concat(response.result);
        console.log(response)
      }).catch(function (error) {

      });
      vm.refreshEmail = function () {
        vm.quote.email.subject = 'Oggetto: 🚌 Richiesta di ' + vm.quote.info + ' - ' + vm.quote.onboard.passengers + 'PAX - ' + $common.getRequestDate(vm.quote) + ' - ' + $filter('quoteId')(vm.quote.id);

        vm.quote.email.html = vm.templates[vm.template]['Html-part']
          .replace('{{var:info}}', vm.quote.info)
          .replace('{{var:quoteId}}', $filter('quoteId')(vm.quote.id))
          .replace('{{var:passengers}}', vm.quote.onboard.passengers)
          .replace('{{var:request}}', vm.getRequestsString(vm.quote.requests))
          .replace('{{var:price}}', $filter('currency')(vm.quote.partner_price + vm.quote.partner_price * vm.quote.vat / 100));
        $timeout(function () {
          $scope.$apply();
        }, 0);
      };
      $scope.$watch(function () {
        return vm.template
      }, function () {
        if (!vm.template) return;
        vm.quote.email.subject = vm.quote.info;
        vm.quote.email.from = vm.templates[vm.template]['Headers']['SenderEmail'];
        vm.quote.email.reply = vm.templates[vm.template]['Headers']['SenderEmail'];
        vm.quote.email.name = vm.templates[vm.template]['Headers']['SenderName'];
        console.log('update email')
        vm.refreshEmail();
        console.log(vm.quote.email.html);
        console.log(vm.templates)
      });

      if (!angular.isObject(vm.quote.email)) {
        vm.quote.email = {
          from: 'info@busrapido.com',
          name: 'Busrapido',
          reply: 'info@busrapido.com',
          subject: vm.quote.info,
          html: ''
        };
        vm.template = 0;
        $timeout(function () {
          $scope.$apply();
        }, 0);
      }
      if (angular.isUndefined(vm.quote.email.reply)) {
        vm.quote.email.reply = vm.quote.email.from;
      }
      vm.loaded = true;
    }
  }
})();

(function() {
'use strict';

angular.module('busrapidoAppWeb')
    .controller('SupplierSubscribeController', SupplierSubscribeController);

/** @ngInject */
function SupplierSubscribeController(
    $scope, $rootScope, $state, $supplier, $timeout, $alert, $validator, $error,
    $document, $window, $common, cloudinary, Upload, $location, $filter) {
  var vm = this;
  vm.$onInit = function() {
    vm.$users = $rootScope.$users;

    function computeAmount(vehicles) {
      // console.log('veicoli')
      // console.log(vehicles)
      if (vehicles <= 1) {
        return 25;
      }
      if (vehicles >= 2 && vehicles <= 5) {
        return 125;
      }
      if (vehicles >= 6 && vehicles <= 10) {
        return 250;
      }
      if (vehicles >= 11 && vehicles <= 15) {
        return 375;
      }
      if (vehicles >= 15 && vehicles <= 30) {
        return 500;
      }
      if (vehicles >= 31) {
        return 1000;
      }
    }


    vm.current = $supplier.current();

    if (vm.current) {
      vm.amount = computeAmount($supplier.current().vehicles.fleet);
      if (vm.current.subscription && vm.current.subscription.amount) {
        vm.amount = vm.current.subscription.amount;
      }
      if (vm.current.subscription && vm.current.subscription.tier) {
        vm.amount = vm.current.subscription.amount;

        vm.tier = vm.current.subscription.tier;
        vm.interval = vm.current.subscription.interval;
      }
    }

    function onControllerLoaded(responseUpload) {
      vm.loaded = true;
      vm.current = $supplier.current();

      if (vm.current) {
        vm.amount = computeAmount($supplier.current().vehicles.fleet);

        if (vm.current.subscription && vm.current.subscription.amount && vm.current.gocardless) {
          vm.amount = vm.current.subscription.amount;
        }
        if (vm.current.subscription && vm.current.subscription.tier && vm.current.gocardless) {
          vm.amount = vm.current.subscription.amount;
          vm.tier = vm.current.subscription.tier;
          vm.interval = vm.current.subscription.interval;
        }
      }
      if ($location.search().redirect_flow_id &&
          $location.search().redirect_flow_id.length > 5) {
        $supplier.completeMandate($location.search().redirect_flow_id)
            .then(function(result) {
              $location.search('redirect_flow_id', null);
              $alert.show(
                  'Grazie per aver sottoscritto l\'abbonamento',
                  'Appena avremo la conferma dalla banca ti manderemo una email di conferma',
                  '', '', true, 0, -1, function(cancel) {});
            })
            .catch(function(err) {
              var str = $error.get(err, 'api');
              $alert.show(
                  str.title, str.msg, 'Ricarica', '', true, 0, -1,
                  function(cancel) {
                    $state.reload();
                  });
            });
      }
      vm.document = {};
      vm.picking = [];
      vm.timeout = [];
      vm.pickcount = 0;
      vm.mandate(['standard'], ['monthly', 'yearly']);

      if (!angular.isArray(vm.docs)) {
        vm.docs = [];
      }
      /**
       * Scope Functions
       */

      vm.setAlready =
          function() {
        vm.document =
            new File(['Compilato in fiera'], 'compilato_in_fiera.txt', {
              type: 'text/plain',
            });
        vm.already = !vm.already;
        vm.attachment = {url: 'In fiera'};
      }

          function uploadFile(file) {
            vm.loading = true;
            var upload = {};
            angular.copy(responseUpload.upload, upload);
            upload.file = file;
            Upload.upload({url: cloudinary.config().cloud_upload, data: upload})
                .progress(function(e) {
                  file.progress = Math.round((e.loaded * 100.0) / e.total);
                })
                .success(function(data, status, headers, config) {
                  vm.loading = false;
                  $timeout(function() {
                    $scope.$apply();
                    $timeout(function() {
                      vm.rid = true;
                    }, 200);
                  }, 0);
                  file.result = data;
                  // console.log(data);
                  vm.attachment = ({
                    url: data.public_id,
                    name: file.fname,
                    provider: 'cloudinary',
                    authorization: 'private'
                  });
                })
                .error(function(data, status, headers, config) {
                  var str = $error.get(data);
                  vm.warning = str.msg;
                });
          }

          vm.selectFile = function(document) {
        vm.rid = false;
        // console.log(document)
        for (var i = 0; i < document.length; i++) {
          vm.document = document[i];
          vm.picking.push(true);
          vm.pickcount++;
          vm.timeout.push($timeout(function(index) {
            vm.picking[index] = false;
            vm.pickcount--;
          }, (vm.pickcount) * 10000, true, 0));
          uploadFile(vm.document, true);
        }
      }
    }

    function totalAmount(amount, type) {
      if (type === 'monthly') {
        return amount;
      } else if (type === 'yearly') {
        return amount * 12 * 80 / 100;
      } else {
        return amount * 24 * 2 / 3;
      }
    }
    vm.subscribe = function() {
      $supplier
          .update({
            supplier: {
              subscription: {amount: 0, tier: 'base', name: 'Piano base'},
              gocardless: 'base'
            }
          })
          .then(function(result) {
            $state.go('root.it.supplier.quotes.list');
          })
          .catch(function(err) {
            var str = $error.get(err, 'api');
            $alert.show(
                str.title, str.msg, 'Ricarica', '', true, 0, 5000,
                function(cancel) {
                  $state.reload();
                });
          });
    };

    function getName(tier, kind, amount) {
      return 'Abbonamento ' + tier + ' ' +
          $filter('subscriptionInterval')(kind) + '\n' +
          $filter('currency')(amount);
    }
    vm.getName = getName;
    vm.choose = function(plan) {
      var subscription = vm.current.subscription;
      subscription.amount = plan.amount,
      subscription.interval = plan.interval,
      subscription.name = plan.name,
      subscription.tier = plan.tier
      $supplier
          .update({
            supplier: {
              subscription: subscription
            }
          })
          .then(function(result) {
            //$alert.show('Grazie per aver sottoscritto l\'abbonamento', '', '',
            //'', true, 0, 5000, function (cancel) {
            //});
          })
          .catch(function(err) {
            var str = $error.get(err, 'api');
            $alert.show(
                str.title, str.msg, 'Ricarica', '', true, 0, 5000,
                function(cancel) {
                  $state.reload();
                });
          });
    };
    vm.mandate = function(tiers, intervals) {
      var plans = [];
      for (var i = 0; i < tiers.length; i++) {
        for (var j = 0; j < intervals.length; j++) {
          var tier = tiers[i];
          var interval = intervals[j];
          var amount = totalAmount(false ? vm.amount : computeAmount($supplier.current().vehicles.fleet), interval);
          var name = getName(tier, interval, amount);
          plans.push({
            name: name,
            interval: interval,
            amount: amount,
            tier: tier,
          })
        }
      }
      console.log(plans)
      if (vm.current.subscription && vm.current.subscription.specialamount && vm.current.subscription.tier) {
        plans.push({
          name: getName(vm.current.subscription.tier, vm.current.subscription.interval, vm.current.subscription.specialamount),
          interval: vm.current.subscription.interval,
          amount: vm.current.subscription.specialamount,
          tier: vm.current.subscription.tier
        });
      }

      if ((!vm.current.gocardless || vm.tier == 'base') &&
          !($location.search('redirect_flow_id') &&
            $location.search('redirect_flow_id').length > 5)) {
        $supplier.getMandateLink(plans)
            .then(function(result) {
              // $window.open(result.url, '_blank');

              vm.mandateLink = {
                base: {},
                standard: {},
                premium: {},
              };
              vm.plan = {
                base: {},
                standard: {},
                premium: {},
              };
              console.log(plans)
              console.log(result);
              for (var i = 0; i < plans.length; i++) {
                vm.mandateLink[plans[i].tier][plans[i].interval] =
                    result.url[i];
                vm.plan[plans[i].tier][plans[i].interval] = plans[i];
              }
              console.log(vm.mandateLink)
              console.log(vm.plan)
            })
            .catch(function(err) {
              var str = $error.get(err, 'api');
              console.log(err)
              $alert.show(
                  str.title, str.msg, 'Ricarica', '', true, 0, 5000,
                  function(cancel) {
                    $state.reload();
                  });
            });
      }
    };

    vm.now = new Date();

    $supplier.getUploadSign().then(
        function(responseUpload) {
          $supplier.refresh().then(function () {
            onControllerLoaded(responseUpload);

          });
        },
        function(err) {
          var str = $error.get(err, 'api');
          $alert.show(
              str.title, str.msg, 'Ricarica pagina', '', true, 0, 5000,
              function(cancel) {
                $state.reload();
              });
        });
  }
}
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('BookQuoteController', BookQuoteController);

  /** @ngInject */
  function BookQuoteController($scope, $state, $timeout, $alert, $validator, $error, $supplier, $solutions, $common) {
    var vm = this;
    vm.$onInit = function () {
      vm.admin = false;
      vm.seqNumber = 0;
      vm.supplier = {quote: {status: 'pending'}};
      $supplier.getSentQuote($state.params.id).then(function (response) {
        vm.quote = response.quote;
        if (vm.quote.trip) {
          vm.quote.start = vm.quote.start ? new Date(vm.quote.start) : undefined;
          vm.quote.end = vm.quote.end ? new Date(vm.quote.end) : undefined;
          for (var i = 0; i < vm.quote.trip.steps.length; i++) {
            vm.quote.trip.steps[i].arrive = new Date(vm.quote.trip.steps[i].arrive);
            vm.quote.trip.steps[i].depart = new Date(vm.quote.trip.steps[i].depart);
          }
        }
        vm.now = new Date();
        vm.loaded = true;
      }, function (err) {
        var str = $error.get(err, 'api');
        $alert.show(str.title, str.msg, 'Torna alla dashboard', 'Nascondi messaggio di errore', true, 0, -1,
          function (cancel) {
            $state.go('root.it.supplier.quotes.list');
          },
          function (accept) {});
      });
      vm.grace = false;
      $scope.$watch(function () {
        return vm.quote;
      }, function () {
        if (angular.isUndefined(vm.quote)) return;
        if (vm.quote.status !== 'hidden') return;
        if (vm.grace || !vm.loaded) return
        if (vm.save) return;
        vm.save = $timeout(function () {
          $scope.$broadcast('saveChanges');
          $supplier.updateQuote(vm.quote);
          vm.save = false;
        }, 15000)
      }, true);

    }

    function updateClient() {
      vm.quote.client_name = $supplier.current().tcompany;
      vm.quote.client_email = $supplier.current().email || $supplier.current().temail;
    }
    vm.saveChanges = function () {
      updateClient();

      vm.seqNumber++;
      var currentSeqNumber = vm.seqNumber;
      var deregister = $scope.$on('fileUploaded', function (event, seqNumber) {

        if (seqNumber === currentSeqNumber) {
          console.log(angular.copy(vm.quote))
          console.log(seqNumber)
          console.log(currentSeqNumber)
          $supplier.updateQuote(vm.quote).then(function (response) {
            $alert.show('Modifiche salvate', '', '', '', false, 500, 1000);
          });
        }
        if (seqNumber >= currentSeqNumber) {
          deregister();
        }
      });
      $scope.$broadcast('saveChanges', currentSeqNumber);
    }
    vm.resetChanges = function () {
      $state.reload();
    }
    function updateNetwork() {
      vm.quote.client = '';
      vm.quote.client += vm.quote.all ? 'Invia a tutta la rete Busrapido\n' : '';
      for (var i = 0; i < vm.quote.network.length; i++) {
        vm.quote.client += 'Invia a ' + vm.quote.network[i].name + ' ' + vm.quote.network[i].email + '\n';
      }
    }
    vm.publish = function () {
      // updateNetwork();
      updateClient();
      $alert.show('Invia la richiesta', 'Con Busrapido puoi inviare la tua richiesta a partner selezionati o a tutta la rete Busrapido', '', 'Invia richiesta', true, 0, -1,
          function (cancel) {
            /**

             vm.seqNumber++;
             var currentSeqNumber = vm.seqNumber;
             var deregister = $scope.$on('fileUploaded', function (event, seqNumber) {
               if (seqNumber === currentSeqNumber) {
                 $supplier.updateQuote(vm.quote).then(function (response) {
                   $supplier.changeStatusQuote(vm.quote.id, 'public', $common.getRequestFullDescription(vm.quote.requests, vm.quote.service_type)).then(function (response) {
                     $alert.show('Richiesta pubblicata', '', '', '', false, 500, 2000, function () {
                       $state.reload();
                     });
                   }, function (err) {
                     var str = $error.get(err, 'api');
                     $alert.show(str.title, str.msg, 'Torna alla dashboard', 'Nascondi messaggio di errore', true, 0, -1,
                       function (cancel) {
                         $state.go('root.it.supplier.quotes.list');
                       },
                       function (accept) {});

                   });
                 });
               }
               if (seqNumber >= currentSeqNumber) {
                 deregister();
               }
             });
             $scope.$broadcast('saveChanges', currentSeqNumber);
             */
          },
          function (accept) {
            vm.seqNumber++;
            var currentSeqNumber = vm.seqNumber;

            var deregister = $scope.$on('fileUploaded', function (event, seqNumber) {
              if (seqNumber === currentSeqNumber) {
                $supplier.updateQuote(vm.quote).then(function (response) {
                  $supplier.changeStatusQuote(vm.quote.id, 'public', $common.getRequestFullDescription(vm.quote.requests, vm.quote.service_type)).then(function (response) {
                    $alert.show('Richiesta pubblicata', '', '', '', false, 500, 2000, function () {
                      $state.reload();
                    });
                  }, function (err) {
                    var str = $error.get(err, 'api');
                    $alert.show(str.title, str.msg, 'Torna alla dashboard', 'Nascondi messaggio di errore', true, 0, -1,
                      function (cancel) {
                        $state.go('root.it.supplier.quotes.list');
                      },
                      function (accept) {});

                  });
                });
              }
              if (seqNumber >= currentSeqNumber) {
                deregister();
              }
            });
            $scope.$broadcast('saveChanges', currentSeqNumber);
          });
    }
    /**
     * Some component requested to save the work
     */
    $scope.$on('updateQuote', function (event, reqNumber) {
      console.log('Uploading for ' + reqNumber)
      var deregister = $scope.$on('fileUploaded', function (event, seqNumber) {
        console.log('Uploaded for ' + reqNumber)
        console.log('Uploaded for ' + seqNumber)

        if (seqNumber === reqNumber) {
          $supplier.updateQuote(vm.quote).then(function (response) {
            console.log('Uploaded for ' + reqNumber)
            $scope.$broadcast('quoteUpdated', reqNumber);
          }).catch(function (err) {
            var str = $error.get(err, 'api');
            $alert.show(str.title, str.msg, 'Torna alla dashboard', 'Nascondi messaggio di errore', true, 0, -1,
              function (cancel) { $state.go('root.it.supplier.quotes.list'); }, function (accept) { });
          });
        }
        if (seqNumber >= reqNumber) {
          deregister();
        }
      });
      $scope.$broadcast('saveChanges', reqNumber);
    });
    vm.hide = function () {
      $supplier.changeStatusQuote(vm.quote.id, 'hidden').then(function (response) {
        $alert.show('Richiesta nascosta', '', '', '', false, 500, 1000, function () {
          $state.reload();
        });
      }, function (err) {
        var str = $error.get(err, 'api');
        $alert.show(str.title, str.msg, 'Torna alla dashboard', 'Nascondi messaggio di errore', true, 0, -1,
          function (cancel) {
            $state.go('root.it.supplier.quotes.list');
          },
          function (accept) {});
      });
    }
    /*
    vm.sendQuoteEmails = function () {
      $scope.$broadcast('sendQuoteEmails');
    }
*/
  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brVehicleStep', VehicleStepDirective);

  /** @ngInject */
  function VehicleStepDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        data: '=brData'
      },
      templateUrl: 'app/elements/auth/step9/vehicle.html',
      controller: 'VehicleStepController',
      controllerAs: 'step',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('VehicleStepController', VehicleStepController);

  /** @ngInject */
  function VehicleStepController($scope, $state, $timeout, $alert, RegexConstant) {
    var vm = this;
    vm.validated = false;
    $scope.$on('validated', function() {
      vm.validated = true;
    });
    vm.$onInit = function () {
      vm.rex = RegexConstant;
      vm.data.welcome2 = true;


      if (angular.isUndefined(vm.data.insurance)) {
        vm.data.insurance = {};
      }
      if (angular.isUndefined(vm.data.vehicles)) {
        vm.data.vehicles = {};
      }
      if (angular.isUndefined(vm.data.vehicles.common)) {
        vm.data.vehicles.common = {};
      }
      if (angular.isUndefined(vm.data.vehicles.wheelchair)) {
        vm.data.vehicles.wheelchair = {};
      }
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brCheerStep', CheerStepDirective);

  /** @ngInject */
  function CheerStepDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        data: '=brData'
      },
      templateUrl: 'app/elements/auth/step4/cheer.html',
      controller: 'CheerStepController',
      controllerAs: 'step',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('CheerStepController', CheerStepController);

  /** @ngInject */
  function CheerStepController($scope, $state, $timeout,$alert, RegexConstant) {
    var vm = this;
    vm.validated = false;
    $scope.$on('validated', function() {
      vm.validated = true;
    });
    vm.$onInit = function () {
      vm.rex = RegexConstant;
      vm.data.welcome = true;
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brRequestTypesStep', RequestTypesStepDirective);

  /** @ngInject */
  function RequestTypesStepDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        data: '=brData'
      },
      templateUrl: 'app/elements/auth/step8/requesttypes.html',
      controller: 'RequestTypesStepController',
      controllerAs: 'step',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('RequestTypesStepController', RequestTypesStepController);

  /** @ngInject */
  function RequestTypesStepController($scope, $state, $timeout, $alert, RegexConstant, $common) {
    var vm = this;
    vm.validated = false;
    $scope.$on('validated', function() {
      vm.validated = true;
    });
    $scope.$watch(function() {
      return $common.hasOne(vm.data.vehicles.common, vm.data.vehicles.wheelchair);
    }, function() {
      vm.invalid = !$common.hasOne(vm.data.vehicles.common, vm.data.vehicles.wheelchair);
    });
    vm.$onInit = function () {
      vm.rex = RegexConstant;

      if (angular.isUndefined(vm.data.insurance)) {
        vm.data.insurance = {};
      }
      if (angular.isUndefined(vm.data.vehicles)) {
        vm.data.vehicles = {};
      }
      if (angular.isUndefined(vm.data.vehicles.common)) {
        vm.data.vehicles.common = {};
      }
      if (angular.isUndefined(vm.data.vehicles.wheelchair)) {
        vm.data.vehicles.wheelchair = {};
      }
      vm.wheelchair = Object.keys(vm.data.vehicles.wheelchair).length !== 0;
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brNotificationStep', NotificationStepDirective);

  /** @ngInject */
  function NotificationStepDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        data: '=brData'
      },
      templateUrl: 'app/elements/auth/step7/notification.html',
      controller: 'NotificationStepController',
      controllerAs: 'step',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('NotificationStepController', NotificationStepController);

  /** @ngInject */
  function NotificationStepController($scope, $state, $timeout, $alert, RegexConstant) {
    var vm = this;
    vm.validated = false;
    $scope.$on('validated', function() {
      vm.validated = true;
    });
    vm.$onInit = function () {
      vm.rex = RegexConstant;

      if (angular.isUndefined(vm.data.contact)) {
        vm.data.contact = {};
      }
      if (angular.isUndefined(vm.data.contact.emails) || vm.data.contact.emails.length === 0) {
        vm.data.contact.emails = [vm.data.email || vm.data.temail];
      }
      if (angular.isUndefined(vm.data.contact.whatsapps) || !angular.isArray(vm.data.contact.whatsapps) || vm.data.contact.whatsapps.length === 0) {
        vm.data.contact.whatsapps = [''];
      }
      if (angular.isUndefined(vm.data.contact.canwhatsapp) || (vm.data.contact.canwhatsapp !== true && vm.data.contact.canwhatsapp !== false)) {
        vm.data.contact.canwhatsapp = true;
      }
      if (angular.isUndefined(vm.data.contact.cansos) || (vm.data.contact.cansos !== true && vm.data.contact.cansos !== false)) {
        vm.data.contact.cansos = true;
      }
      if (angular.isUndefined(vm.data.contact.sos) || !angular.isArray(vm.data.contact.sos) || vm.data.contact.sos.length === 0) {
        vm.data.contact.sos = [''];
      }
      vm.addEmail = function () {
        vm.data.contact.emails.push('');
      }
      vm.removeEmail = function (index) {
        vm.data.contact.emails.splice(index, 1);
      }
      vm.addWhatsapp = function () {
        vm.data.contact.whatsapps.push('');
      }
      vm.removeWhatsapp = function (index) {
        vm.data.contact.whatsapps.splice(index, 1);
      }
      vm.addPhone = function () {
        vm.data.contact.sos.push('');
      }
      vm.removePhone = function (index) {
        vm.data.contact.sos.splice(index, 1);
      }
    };


  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brFirstCompletedStep', FirstCompletedStepDirective);

  /** @ngInject */
  function FirstCompletedStepDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        data: '=brData'
      },
      templateUrl: 'app/elements/auth/step6/firstcompleted.html',
      controller: 'FirstCompletedStepController',
      controllerAs: 'step',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('FirstCompletedStepController', FirstCompletedStepController);

  /** @ngInject */
  function FirstCompletedStepController($scope, $state, $timeout, $alert, RegexConstant) {
    var vm = this;
    vm.validated = false;
    $scope.$on('validated', function() {
      vm.validated = true;
    });
    vm.$onInit = function () {
      vm.rex = RegexConstant;
      vm.data.welcome1 = true;
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brAdditionalStep', AdditionalStepDirective);

  /** @ngInject */
  function AdditionalStepDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        data: '=brData'
      },
      templateUrl: 'app/elements/auth/step5/additional.html',
      controller: 'AdditionalStepController',
      controllerAs: 'step',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('AdditionalStepController', AdditionalStepController);

  /** @ngInject */
  function AdditionalStepController($scope, $state, $timeout, $alert, RegexConstant) {
    var vm = this;
    vm.validated = false;
    $scope.$on('validated', function() {
      vm.validated = true;
    });
    vm.$onInit = function () {
      vm.rex = RegexConstant;

      if (angular.isUndefined(vm.data.legal)) {
        vm.data.legal = {};
      }
      if (angular.isUndefined(vm.data.legal.it)) {
        vm.data.legal.it = {};
      }
      if (angular.isUndefined(vm.data.contact)) {
        vm.data.contact = {};
      }
      if (angular.isUndefined(vm.data.contact.associations)) {
        vm.data.contact.associations = [];
      }
      vm.addAssociation = function () {
        vm.data.contact.associations.push('');
      }
      if (angular.isUndefined(vm.data.contact.unions)) {
        vm.data.contact.unions = [];
      }
      vm.addUnion = function () {
        vm.data.contact.unions.push('');
      }


      vm.removeUnion = function (index) {
        vm.data.contact.unions.splice(index, 1);
      }
      vm.removeAssociation = function (index) {
        vm.data.contact.associations.splice(index, 1);
      }

      vm.setHasAssociation = function (value) {
        if (value) {
          if (vm.data.contact.associations.length === 0) {
            vm.addAssociation();
          }
        }
        else {
          vm.data.contact.associations = [];
        }
      }
      vm.setHasUnion = function (value) {
        if (value) {
          if (vm.data.contact.unions.length === 0) {
            vm.addUnion();
          }
        }
        else {
          vm.data.contact.unions = [];
        }
      }
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brCompanyStep', CompanyStepDirective);

  /** @ngInject */
  function CompanyStepDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        data: '=brData'
      },
      templateUrl: 'app/elements/auth/step3/company.html',
      controller: 'CompanyStepController',
      controllerAs: 'step',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('CompanyStepController', CompanyStepController);

  /** @ngInject */
  function CompanyStepController($scope, $state, $timeout, $alert, RegexConstant) {
    var vm = this;
    vm.validated = false;
    $scope.$on('validated', function () {
      vm.validated = true;
    });
    vm.$onInit = function () {
      vm.rex = RegexConstant;
      if (angular.isUndefined(vm.data.company) || vm.data.company === '' || !vm.data.company) {
        vm.data.company = angular.copy(vm.data.tcompany);
      }
      if (angular.isUndefined(vm.data.legal)) {
        vm.data.legal = {};
      }
      if (angular.isUndefined(vm.data.legal.it)) {
        vm.data.legal.it = {};
      }
      if (angular.isUndefined(vm.data.contact)) {
        vm.data.contact = {};
      }
      if (angular.isUndefined(vm.data.contact.warehouses) || vm.data.contact.warehouses.length === 0) {
        vm.data.contact.warehouses = [{}];
      }
      if (angular.isUndefined(vm.data.legal.it.banking) || vm.data.legal.it.banking.length === 0) {
        vm.data.legal.it.banking = [{}];
      }
      vm.addWarehouse = function () {
        vm.data.contact.warehouses.push({});
      }
      vm.removeWarehouse = function (index) {
        vm.data.contact.warehouses.splice(index, 1);
      }
      vm.addBank = function () {
        vm.data.legal.it.banking.push({});
      }
      vm.removeBank = function (index) {
        vm.data.legal.it.banking.splice(index, 1);
      }
      vm.capitalizeIBAN = function (index) {
        vm.data.legal.it.banking[index].iban = vm.data.legal.it.banking[index].iban.toUpperCase();
        return vm.data.legal.it.banking[index].iban;
      }
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brPocStep', PocStepDirective);

  /** @ngInject */
  function PocStepDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        data: '=brData'
      },
      templateUrl: 'app/elements/auth/step2/poc.html',
      controller: 'PocStepController',
      controllerAs: 'step',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('PocStepController', PocStepController);

  /** @ngInject */
  function PocStepController($scope, $state, $timeout, $alert, RegexConstant) {
    var vm = this;
    vm.validated = false;
    $scope.$on('validated', function() {
      vm.validated = true;
    });
    vm.$onInit = function () {
      vm.rex = RegexConstant;
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brNameStep', NameStepDirective);

  /** @ngInject */
  function NameStepDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        data: '=brData',
        profile: '=brProfile',
      },
      templateUrl: 'app/elements/auth/step1/name.html',
      controller: 'NameStepController',
      controllerAs: 'step',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('NameStepController', NameStepController);

  /** @ngInject */
  function NameStepController($scope, $state, $timeout, $alert, RegexConstant) {
    var vm = this;
    vm.validated = false;
    $scope.$on('validated', function() {
      vm.validated = true;
    });
    vm.$onInit = function () {
      vm.rex = RegexConstant;
      if (vm.data) {
        vm.data.email = vm.data.email || vm.data.temail;
      }
      // vm.data.tcompany = vm.data.tcompany || vm.data.company;
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brQuoteDetailsTour', quoteDetailsTourDirective);

  /** @ngInject */
  function quoteDetailsTourDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        trip: '=brTrip',
        obj: '@brObject'
      },
      templateUrl: 'app/components/quote-details/tour/tour.html',
      controller: 'QuoteDetailsTourController',
      controllerAs: 'iter',
      bindToController: true
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('QuoteDetailsTourController', QuoteDetailsTourController);

  /** @ngInject */
  function QuoteDetailsTourController($scope, $timeout, $state, $supplier, cloudinary) {
    var vm = this;
    vm.cloudinary = cloudinary;

    vm.$onInit = function() {
      vm.id = $state.params.id;
      vm.scheduledMake = false;
      vm.times = {};
      function makeDays() {
        if (vm.scheduledMake) return;

        vm.scheduledMake = true;
        vm.days = {};
        var length = 0;
        var previous = -1;
        for (var day = 0; day < vm.trip.steps.length; day++) {
          vm.trip.steps[day].depart = new Date(vm.trip.steps[day].depart);
          vm.trip.steps[day].arrive = new Date(vm.trip.steps[day].arrive);


          if (length === 0
            || (vm.trip.steps[day].depart && vm.trip.steps[day].depart.getDate() !== vm.days[previous].date.getDate())) {


            vm.days[day] = {
              date: vm.trip.steps[day].depart || new Date(vm.trip.steps[day].arrive),
              step: day,
              distance: 0,
              duration: 0
            };
            previous = day;
            length++;

          }




          if (valid(day, vm.trip.legs) && vm.trip.legs[day].directions) {


            if (new Date(vm.trip.steps[vm.trip.legs[day].from].depart).getDate() != new Date(vm.trip.steps[vm.trip.legs[day].to].arrive).getDate()) {


              vm.days[previous].distance += vm.trip.legs[day].directions.total.distance;
              vm.days[previous].duration += vm.trip.legs[day].directions.total.duration;
            }
            else {


              vm.days[previous].distance += vm.trip.legs[day].directions.total.distance;
              vm.days[previous].duration += vm.trip.legs[day].directions.total.duration;
            }
          }
        }

        $timeout(function () {
          vm.scheduledMake = false;

        }, 500)

      }
      makeDays();
      function valid(pos, array) {
        if (pos < 0 || pos >= array.length) return false;
        return true;
      }
    };
    vm.formatDate = function(date){
      var dateOut = new Date(date);
      return dateOut.toLocaleString();
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .factory('$reject', rejectService);

  /** @ngInject */
  function rejectService(ModalService, $rootScope, $timeout, $window) {
    var tmt, mdl;
    var service = {
      show: function(data, cross, after, timeout, onCancel, onConfirm) {


        if(after) {
          tmt = $timeout(showModal, after);
        }
        else {
          showModal();
        }

        function showModal() {
          ModalService.showModal({
            templateUrl: "app/components/quote-details/reject/alert.modal.html",
            controller: 'RejectModalController',
            controllerAs: 'modal',
            inputs: {
              data: data,
              cross: cross,
              after: after,
              timeout: timeout
            }
          }).then(function(modal) {
            mdl = modal;
            modal.close.then(function(result) {
              if(result === -1) {
                if(angular.isFunction(onCancel)) onCancel(result);
              }
              else {
                if(angular.isFunction(onConfirm)) onConfirm(result);
              }
            });
          });
        }
      }
    };

    var deregistrationCallback1 = $rootScope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams) {
      $timeout.cancel(tmt);
      if(mdl && mdl.scope && angular.isFunction(mdl.scope.close)) {
        mdl.scope.close();
      }
    });
    $rootScope.$on('$destroy', deregistrationCallback1);

    $rootScope.$on('$destroy', function() {
      $timeout.cancel(tmt);
      if(mdl && mdl.scope && angular.isFunction(mdl.scope.close)) {
        mdl.scope.close();
      }
    });

    return service;
  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('RejectModalController', RejectModalController);

  /** @ngInject */
  function RejectModalController($scope, $timeout, close, data, cross, after, timeout, $supplier, $error, $segment, $state, $alert, $document) {
    var vm = this;
    vm.step = 0;
    vm.data = data;
    vm.submit = function ($event) {

      var form = ($event && $event.srcElement) || $document.find('form')[0]
      vm.validated = true;

      if (form.checkValidity()) {
        vm.closeIt('other')
      }
    }
    vm.closeIt = function (result) {
      if (angular.isFunction(close)) {
        close(result);
      }
    };

    if (timeout > 0) {
      var tmt = $timeout(function () {
        vm.closeIt(-2);
      }, timeout);
      $scope.$on('$destroy', function () {
        $timeout.cancel(tmt);
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brQuoteDetailsNew', quoteDetailsNewDirective);

  /** @ngInject */
  function quoteDetailsNewDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        trip: '=brTrip',
        serviceType: '=brServiceType',
        view: '=brView',
        obj: '@brObject',
        data: '@brData'
      },
      templateUrl: 'app/components/quote-details/new/new.html',
      controller: 'QuoteDetailsNewController',
      controllerAs: 'iter',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('QuoteDetailsNewController', QuoteDetailsNewController);

  /** @ngInject */
  function QuoteDetailsNewController($scope, $timeout, $state, $filter, cloudinary, $common) {
    var vm = this;
    vm.cloudinary = cloudinary;

    vm.$onInit = function () {
      vm.id = $state.params.id;
      vm.getRequestsString = function (requests) {
        return $common.getRequestFullDescription(requests, vm.data.service_type, vm.data.onlydate);
      }
    };
    vm.formatDate = function (date) {
      var dateOut = new Date(date);
      return dateOut.toLocaleString();
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brQuoteDetailsClassic', quoteDetailsClassicDirective);

  /** @ngInject */
  function quoteDetailsClassicDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        trip: '=brTrip',
        obj: '@brObject'
      },
      templateUrl: 'app/components/quote-details/classic/classic.html',
      controller: 'QuoteDetailsClassicController',
      controllerAs: 'iter',
      bindToController: true
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('QuoteDetailsClassicController', QuoteDetailsClassicController);

  /** @ngInject */
  function QuoteDetailsClassicController($scope, $timeout, $state, $supplier, cloudinary) {
    var vm = this;
    vm.cloudinary = cloudinary;

    vm.$onInit = function() {
      vm.id = $state.params.id;

    };
    vm.formatDate = function(date){
      var dateOut = new Date(date);
      return dateOut.toLocaleString();
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .factory('$registration', registrationService);

  /** @ngInject */
  function registrationService(ModalService, $rootScope, $timeout, $window) {
    var tmt, mdl;
    var service = {
      show: function(step, cross, after, timeout, onCancel, onConfirm) {


        if(after) {
          tmt = $timeout(showModal, after);
        }
        else {
          showModal();
        }

        function showModal() {
          ModalService.showModal({
            templateUrl: "app/components/complete/modal/alert.modal.html",
            controller: 'RegistrationModalController',
            controllerAs: 'auth',
            inputs: {
              step: step,
              cross: cross,
              after: after,
              timeout: timeout
            }
          }).then(function(modal) {
            mdl = modal;
            modal.close.then(function(result) {
              if(result === 1) {
                if(angular.isFunction(onConfirm)) onConfirm(result);
              }
              else {
                if(angular.isFunction(onCancel)) onCancel(result);
              }
            });
          });
        }
      }
    };

    var deregistrationCallback1 = $rootScope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams) {
      $timeout.cancel(tmt);
      if(mdl && mdl.scope && angular.isFunction(mdl.scope.close)) {
        mdl.scope.close();
      }
    });
    $rootScope.$on('$destroy', deregistrationCallback1);

    $rootScope.$on('$destroy', function() {
      $timeout.cancel(tmt);
      if(mdl && mdl.scope && angular.isFunction(mdl.scope.close)) {
        mdl.scope.close();
      }
    });

    return service;
  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('RegistrationModalController', RegistrationModalController);

  /** @ngInject */
  function RegistrationModalController($scope, $timeout, close, step, cross, after, timeout, $supplier, $error, $segment, $state, $alert, $document) {
    var vm = this;
    vm.step = step;
    vm.user = {
      signup: angular.copy($supplier.current()) || {}
    };

    vm.advanceSignup = function (oldStep, newStep, $event) {

      var form = ($event && $event.srcElement) || $document.find('form')[0];

      if (!form || form.checkValidity()) {
        if (oldStep === 1) {
          vm.processSignup().then(function(result) {

          });
        }
        else {
          vm.saveChanges(newStep);
        }
      }
      else {
        $scope.$broadcast('validated');
      }
    }
    vm.saveChanges = function(newStep) {
      vm.loaded = false;
      return $supplier.update({
        supplier: vm.user.signup
      }).then(function (user) {

        vm.step = newStep;
        $segment.track('[SIGNUP] Partner completed step ' + newStep);
        // vm.closeIt(1);
        if (newStep == 10) {
          $state.go('root.it.supplier.vehicles.list');
        }
        vm.loaded = true;
      }, function (err) {
        var str = $error.get(err, 'api');
        $alert.show(str.title, str.msg, 'Ricarica', '', true, 0, 5000,
          function (cancel) { $state.reload(); });
      });
    }

    vm.closeIt = function (result) {
      if (angular.isFunction(close)) {
        close(result);
      }
    };

    if (timeout > 0) {
      var tmt = $timeout(function () {
        vm.closeIt(-2);
      }, timeout);
      $scope.$on('$destroy', function () {
        $timeout.cancel(tmt);
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brSuccessstories', saysaboutusDirective);

  /** @ngInject */
  function saysaboutusDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/elements/successstories/saysaboutus.html'
    };

    return directive;
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brSignup', signupDirective);

  /** @ngInject */
  function signupDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        mode: '=brMode',
        data: '=?brData',
        onSignin: '&?brOnSignin',
        onSignup: '&?brOnSignup',
        onModeChange: '&?brOnModeChange'
      },
      templateUrl: 'app/elements/signup/signup.html',
      controller: 'SignupController',
      controllerAs: 'signup',
      bindToController: true
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('SignupController', SignupController);

  /** @ngInject */
  function SignupController($timeout, $rootScope, $validator, $error, $supplier, $state, $base64) {
    var vm = this;
    vm.$onInit = function() {
      vm.enabled = true;
      vm.$users = $rootScope.$users;
      vm.user = {
        signup: {},
        signin: {},
        recover: {},
        reset: {}
      };
      console.log('redirect')
      console.log($supplier.isAuthenticated())

      if($supplier.isAuthenticated()) {
        var redirect = {};
        if(angular.isString($state.params.goto) && $state.params.goto != '') {
          var string = decodeURIComponent(escape($base64.decode($state.params.goto)));
          try {
            redirect = angular.fromJson(string);
          }
          catch(err) {
            $state.go('root.it.supplier.signin', {goto: ''}, {reload: true});
            return;
          }
        }
        console.log('redirect')
        $state.go(redirect.name || 'root.it.supplier.quotes.list', redirect.params || {});
        return;
      }
      function resetSigninWarning(time) {
        $timeout(function() { vm.user.signin.warning = undefined; }, time);
      }
      function resetSignupWarning(time) {
        $timeout(function() { vm.user.signup.warning = undefined; }, time);
      }
      function resetRecoverWarning(time) {
        $timeout(function() { vm.user.recover.warning = undefined; }, time);
      }
      function resetResetWarning(time) {
        $timeout(function() { vm.user.reset.warning = undefined; }, time);
      }

      vm.changeMode = function(mode) {
        vm.mode = mode;
        $timeout(vm.onModeChange, 0);
      }
      vm.processSignup = function() {
        if($validator('name', vm.user.signup.name) === -1) vm.user.signup.warning = 'Ti sei dimenticato di inserire il nome.';
        else if(!$validator('name', vm.user.signup.name)) vm.user.signup.warning = 'Il nome inserito non è valido.';
        else if($validator('name', vm.user.signup.surname) === -1) vm.user.signup.warning = 'Ti sei dimenticato di inserire il cognome.';
        else if(!$validator('name', vm.user.signup.surname)) vm.user.signup.warning = 'Il cognome inserito non è valido.';
        else if($validator('phone', vm.user.signup.phone) === -1) vm.user.signup.warning = 'Ti sei dimenticato di inserire il numero di telefono.';
        else if(!$validator('phone', vm.user.signup.phone)) vm.user.signup.warning = 'Il numero di telefono inserito non è valido.';
        else if($validator('email', vm.user.signup.email) === -1) vm.user.signup.warning = 'Ti sei dimenticato di inserire l\'email.';
        else if(!$validator('email', vm.user.signup.email)) vm.user.signup.warning = 'L\'email inserita non è valida.';
        else if($validator('password', vm.user.signup.password) === -1) vm.user.signup.warning = 'Ti sei dimenticato di inserire la password.';
        else if(!$validator('password', vm.user.signup.password)) vm.user.signup.warning = 'La password inserita non è valida. La password deve contenere almeno 6 caratteri e non può contenere spazi.';

        else if($validator('company', vm.user.signup.company) === -1) vm.user.signup.warning = 'Ti sei dimenticato di inserire la ragione sociale della società.';
        else if(!$validator('company', vm.user.signup.company)) vm.user.signup.warning = 'La ragione sociale inserita non è valida.';
        else if($validator('phone', vm.user.signup.companyphone) === -1) vm.user.signup.warning = 'Ti sei dimenticato di inserire il numero di telefono della società.';
        else if(!$validator('phone', vm.user.signup.companyphone)) vm.user.signup.warning = 'Il numero di telefono della socieltà inserito non è valido.';
        else if($validator('phone', vm.user.signup.emergencyphone) === -1) vm.user.signup.warning = 'Ti sei dimenticato di inserire il numero di telefono di emergenza della società.';
        else if(!$validator('phone', vm.user.signup.emergencyphone)) vm.user.signup.warning = 'Il numero di telefono di emergenza della socieltà inserito non è valido.';
        else if($validator('taxcode', vm.user.signup.taxcode) === -1) vm.user.signup.warning = 'Ti sei dimenticato di inserire la partita IVA della società.';
        else if(!$validator('taxcode', vm.user.signup.taxcode)) vm.user.signup.warning = 'Il numero della partita IVA della società inserito non è valido.';
        else if($validator('place', vm.user.signup.place) === -1) vm.user.signup.warning = 'Ti sei dimenticato di inserire l\'indirizzo di fatturazione della società.';
        else if(!$validator('place', vm.user.signup.place)) vm.user.signup.warning = 'L\'indirizzo di fatturazione della società inserito non è valido.';

        if(vm.user.signup.warning) {
          resetSignupWarning(5000);
          return;
        }

        vm.enabled = false;
        $supplier.signup(vm.user.signup.email, vm.user.signup.password, vm.user.signup.name, vm.user.signup.surname, vm.user.signup.phone, vm.user.signup.company, vm.user.signup.companyphone, vm.user.signup.emergencyphone, vm.user.signup.taxcode, vm.user.signup.place).then(function() {
          $timeout(vm.onSignup, 0);
          $supplier.signin(vm.user.signup.email, vm.user.signup.password).then(function() {
            $timeout(vm.onSignin, 0);
          });
        }, function(err) {
          vm.enabled = true;
          var str = $error.get(err, 'api');
          vm.user.signup.warning = str.msg;
          resetSignupWarning(5000);
        });
      };

      vm.processSignin = function() {
        if($validator('email', vm.user.signin.email) === -1) vm.user.signin.warning = 'Ti sei dimenticato di inserire l\'email.';
        else if(!$validator('email', vm.user.signin.email)) vm.user.signin.warning = 'L\'email inserita non è valida.';
        else if($validator('password', vm.user.signin.password) === -1) vm.user.signin.warning = 'Ti sei dimenticato di inserire la password.';
        else if(!$validator('password', vm.user.signin.password)) vm.user.signin.warning = 'La password inserita non è valida.';
        if(vm.user.signin.warning) {
          resetSigninWarning(5000);
          return;
        }

        vm.enabled = false;
        $supplier.signin(vm.user.signin.email, vm.user.signin.password).then(function() {
          $timeout(vm.onSignin, 0);
        }, function(err) {
          vm.enabled = true;
          var str = $error.get(err, 'api');
          vm.user.signin.warning = str.msg;
          resetSigninWarning(5000);
        });
      };

      vm.processRecover = function() {
        if($validator('email', vm.user.recover.email) === -1) vm.user.recover.warning = 'Ti sei dimenticato di inserire l\'email.';
        else if(!$validator('email', vm.user.recover.email)) vm.user.recover.warning = 'L\'email inserita non è valida.';
        if(vm.user.recover.warning) {
          resetRecoverWarning(5000);
          return;
        }

        vm.enabled = false;
        $supplier.getReset(vm.user.recover.email).then(function() {
          vm.user.recover.warning = 'Un messaggio di posta con la procedura per reimpostare la password è stato inviato a ' + vm.user.recover.email + '. Ti invitiamo a controllare la tua casella di posta.';
          resetRecoverWarning(600000);
        }, function(err) {
          vm.enabled = true;
          var str = $error.get(err, 'api');
          vm.user.recover.warning = str.msg;
          resetRecoverWarning(5000);
        });
      };

      vm.processReset = function() {
        if($validator('password', vm.user.reset.password) === -1) vm.user.reset.warning = 'Ti sei dimenticato di inserire la nuova password.';
        else if(!$validator('password', vm.user.reset.password)) vm.user.reset.warning = 'La nuova password inserita non è valida. La password deve contenere almeno 6 caratteri e non può contenere spazi.';
        if(vm.warning) {
          resetResetWarning(5000);
          return;
        }

        vm.enabled = false;
        $supplier.reset(vm.data.id, vm.data.token, vm.user.reset.password).then(function() {
          vm.user.reset.warning = 'Password resettata correttamente. A breve verrai reindirizzato alla pagina per effettuare l\'accesso.';
          $timeout(function() {
            vm.changeMode('signin');
          }, 5000);
        }, function(err) {
          vm.enabled = true;
          var str = $error.get(err, 'api');
          vm.user.reset.warning = str.msg;
          resetResetWarning(5000);
        });
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brWhyus', whyusDirective);

  /** @ngInject */
  function whyusDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/elements/whyus/whyus.html'
    };

    return directive;
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brRequirements', requirementsDirective);

  /** @ngInject */
  function requirementsDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/elements/requirements/requirements.html'
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('ModalController', ModalController);

  /** @ngInject */
  function ModalController($scope, mode, close) {
    var vm = this;
    vm.mode = mode;
    vm.close = function(result) {
      close(result);
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brNavbar', navbarDirective);

  /** @ngInject */
  function navbarDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/elements/navbar/navbar.html',
      controller: 'NavbarController',
      controllerAs: 'navbar',
      bindToController: true
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('NavbarController', NavbarController);

  /** @ngInject */
  function NavbarController($state, $supplier, $scope, $rootScope, $document, ModalService) {
    var vm = this;
    vm.$onInit = function() {
      vm.sidebar = false;
      vm.isAuthenticated = $supplier.isAuthenticated;
      vm.signout = $supplier.signout;
      vm.supplier = $supplier.current();
      //console.log(vm.supplier)

      var unbind2 = $rootScope.$on('$supplierChange', function(event, oldSupplier, newSupplier) {
        vm.supplier = $supplier.current();
        //console.log(vm.supplier)
      });
      $rootScope.$on('$destroy', unbind2);
    }

    vm.openSidebar = function() {
      vm.sidebar = true;
      var myEl = angular.element($document[0].body);
      myEl.addClass('sidebar-open');
    };

    vm.closeSidebar = function() {
      vm.sidebar = false;
      var myEl = angular.element($document[0].body);
      myEl.removeClass('sidebar-open');
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .filter('labelText', labelTextFilter)
    .filter('labelArriveMetrics', labelArriveMetrics)
    .filter('labelLayover', labelLayover);

  function labelTextFilter() {
    return function(input, label1, label2, label3) {
      if(!input) {
        return label1;
      }
      if(input.length > 7) {
        return label2 + input.substring(0, 7)+'...' + label3;
      }
      return label2 + input + label3;
    }
  }
  /** @ngInject */
  function labelArriveMetrics($filter) {
    return function(date, duration, stopover, label1, distance, label2, leave, label3) {
      var distanceLabel = '';
      if (distance) {
        distanceLabel += label2 + $filter('distance')(distance);
      }
      var leaveLabel = '';
      if (leave) {
        leaveLabel += label3 + $filter('amDateFormat')(leave, 'D/MM HH:mm');
      }
      if(!date) {
        return undefined;
      }
      return label1 + $filter('amDateFormat')(date, 'D/MM HH:mm') + leaveLabel + ' Durata guida: ' + $filter('duration')(duration)  + ' ' + distanceLabel;
    }
  }
  /** @ngInject */
  function labelLayover($filter) {
    return function(duration, depart, label1) {
      if(!duration || !depart) {
        return undefined;
      }
      return label1 + $filter('duration')(duration);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brPlannerTour', plannerDirective);

  /** @ngInject */
  function plannerDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        data: '=brData',
        onSubmit: '&brOnSubmit',
        lowPassengersAlert: '=?brLowPassengersAlert'
      },
      templateUrl: 'app/elements/planner-tour/planner.html',
      controller: 'PlannerTourController',
      controllerAs: 'planner',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('PlannerTourController', PlannerController);

  /** @ngInject */
  function PlannerController($scope, $state, $timeout, $alert) {
    var vm = this;

    vm.$onInit = function () {
      /**
       * Scope Init
       */
      vm.date = new Date();
      vm.executed = false;
      vm.MAX_GOOGLE_STEPS = 26;
      vm.MIN_LAYOVER = 9e2;
      vm.MIN_HW_SPEED = 65;
      vm.MAX_VEHICLE_SPEED = 95;

      vm.MAX_DRIVING_TIME_UNINTERRUPTED = 4.5 * 60 * 60;
      vm.STOPOVER_TIME = 45 * 60;
      vm.STOPOVER_TIME_PART1 = 30 * 60;
      vm.STOPOVER_TIME_PART2 = 15 * 60;

      vm.MIN_DEPART_DATE = new Date();
      vm.BLACK_LISTED = [(new Date('12/31/2017')), (new Date('01/01/2018'))];

      function max(a, b) {
        if (a > b) return a;
        return b;
      }
      function min(a, b) {
        if (a > b) return b;
        return a;
      }
      if (angular.isUndefined(vm.data.trip)) {
        vm.data.trip = {
          info: getEmptyInfo(),
          legs: [getEmptyLeg(0, 1)],
          steps: [getEmptyStep(), getEmptyStep()]
        };
      }
      else {
        vm.maxStart = vm.data.trip.steps[0].depart ? new Date(vm.data.trip.steps[0].depart) : undefined;
        if (vm.data.trip.steps[vm.data.trip.steps.length - 1].arrive) {
          vm.minEnd = vm.minEnd ? new Date(max(vm.minEnd.getTime(), vm.data.trip.steps[vm.data.trip.steps.length - 1].arrive.getTime())) : new Date(vm.data.trip.steps[vm.data.trip.steps.length - 1].arrive);
        }
        vm.data.trip.steps[vm.data.trip.steps.length - 1].depart = new Date(vm.data.trip.steps[vm.data.trip.steps.length - 1].depart);
        if (vm.data.trip.steps[vm.data.trip.steps.length - 1].depart) {
          vm.minEnd = vm.minEnd ? new Date(max(vm.minEnd.getTime(), vm.data.trip.steps[vm.data.trip.steps.length - 1].depart.getTime())) : new Date(vm.data.trip.steps[vm.data.trip.steps.length - 1].depart);
        }
        vm.data.trip.steps[0].arrive = vm.data.start || vm.data.trip.steps[0].arrive;
      }
      vm.scheduledMake = false;
      vm.times = {};
      vm.history = {
        forward: [],
        backward: []
      };
      function makeDays() {
        if (vm.scheduledMake) return;
        ////console.log('sched')
        vm.data.trip.steps[0].arrive = vm.data.start || vm.data.trip.steps[0].arrive;
        vm.scheduledMake = true;
        vm.days = {};
        var length = 0;
        var previous = -1;
        for (var day = 0; day < vm.data.trip.steps.length; day++) {
          ////console.log(vm.days);
          ////console.log(previous);
          if (length === 0
            || (vm.data.trip.steps[day].depart && vm.data.trip.steps[day].depart.getDate() !== vm.days[previous].date.getDate())) {
            ////console.log('depart late')
            ////console.log(vm.data.trip.steps[day]);
            vm.days[day] = {
              date: vm.data.trip.steps[day].depart || new Date(vm.data.trip.steps[day].arrive),
              step: day,
              distance: 0,
              duration: 0
            };
            previous = day;
            length++;

          }
          ////console.log('day')
          ////console.log(day)
          ////console.log(vm.data.trip.legs[day]);
          ////console.log(vm.data.trip.legs);
          if (valid(day, vm.data.trip.legs) && vm.data.trip.legs[day].directions) {
            ////console.log('day')
            ////console.log(day)
            if (new Date(vm.data.trip.steps[vm.data.trip.legs[day].from].depart).getDate() != new Date(vm.data.trip.steps[vm.data.trip.legs[day].to].arrive).getDate()) {
              ////console.log('a cavallo')

              vm.days[previous].distance += vm.data.trip.legs[day].directions.total.distance;
              vm.days[previous].duration += vm.data.trip.legs[day].directions.total.duration;
            }
            else {
              ////console.log(vm.data.trip.legs[day].directions.total.distance)
              ////console.log(vm.data.trip.legs[day].directions.total.duration)
              vm.days[previous].distance += vm.data.trip.legs[day].directions.total.distance;
              vm.days[previous].duration += vm.data.trip.legs[day].directions.total.duration;
            }
          }
        }
        ////console.log(vm.days)
        $timeout(function () {
          vm.scheduledMake = false;
          ////console.log('free')
        }, 500)

      }
      makeDays();
      ////console.log(vm.days)
      ////console.log(vm.data.trip)
      vm.temp = [getEmptyTemp()];

      /**
       * Scope Functions
       */

      vm.resetWarning = function (time) {
        $timeout(function () {
          vm.warning = undefined;
        }, time);
      };
      vm.stepCreate = function (step) {
        ////console.log('following ' + step)
        ////console.log(vm.data.trip.legs)
        if (vm.data.trip.steps.length >= vm.MAX_GOOGLE_STEPS) return;

        var leg = step - 1;

        insert(step, getEmptyStep(), vm.data.trip.steps);
        if (step > 1) {

          vm.data.trip.steps[step - 1].keep = vm.data.trip.steps[step - 2].keep;
        }
        ////console.log(vm.data.trip.steps[step])
        ////console.log(vm.data.trip.steps[step - 1])
        // vm.data.trip.steps[step-1].depart = roundTime(new Date(vm.data.trip.steps[step-1].arrive.getTime() + vm.MIN_LAYOVER * 1000));
        ////console.log(vm.data.trip.steps[step - 1])

        insert(leg, getEmptyLeg(step - 1, step), vm.data.trip.legs);
        insert(leg, getEmptyTemp(), vm.temp);
      };
      vm.deleteStep = function (step) {
        vm.history.forward = [];
        var backupTrip = angular.copy(vm.data.trip, backupTrip);
        vm.history.backward.push(backupTrip);
        var nextTrip = {
          info: getEmptyInfo(),
          legs: [],
          steps: []
        };
        for (var i = 0; i < backupTrip.steps.length; i++) {
          if (i !== step)
            nextTrip.steps.push(angular.copy(backupTrip.steps[i]));
        }
        for (i = 0; i < backupTrip.legs.length; i++) {
          if (backupTrip.legs[i].from !== step && backupTrip.legs[i].from !== step) {
            nextTrip.legs.push(angular.copy(backupTrip.legs[i]));
            if (nextTrip.legs.length - 2 >= 0)
              nextTrip.legs[nextTrip.legs.length - 2].to = nextTrip.legs.length - 1;
            nextTrip.legs[nextTrip.legs.length - 1].from = nextTrip.legs.length - 1;
          }
        }
        vm.data.trip = nextTrip;
        $timeout(function () {
          computeArrive(step - 1);
        }, 0);
      }
      vm.createStep = function (step) {
      //console.log('Creating step ' + step)
        vm.history.forward = [];
        var backupTrip = angular.copy(vm.data.trip);
        vm.history.backward.push(backupTrip);
        var nextTrip = {
          info: getEmptyInfo(),
          legs: [],
          steps: []
        };
        var temp = [];
        for (var i = 0; i < backupTrip.steps.length; i++) {
          if (i === step)
            nextTrip.steps.push(getEmptyStep());
          nextTrip.steps.push(angular.copy(backupTrip.steps[i]));
        }
        if (i === step)
          nextTrip.steps.push(getEmptyStep());
        for (i = 0; i < backupTrip.legs.length; i++) {
          if (backupTrip.legs[i].to === step) {
            nextTrip.legs.push(getEmptyLeg(nextTrip.legs.length, nextTrip.legs.length + 1));
            nextTrip.legs.push(getEmptyLeg(nextTrip.legs.length, nextTrip.legs.length + 1));
            temp.push(getEmptyTemp());
            temp.push(getEmptyTemp());
          }
          else {
            nextTrip.legs.push(angular.copy(backupTrip.legs[i]));
            temp.push(angular.copy(backupTrip.legs[i]));

            if (nextTrip.legs.length - 2 >= 0)
              nextTrip.legs[nextTrip.legs.length - 2].to = nextTrip.legs.length - 1;
            nextTrip.legs[nextTrip.legs.length - 1].from = nextTrip.legs.length - 1;
          }
        }
        if (i + 1 === step) {
          nextTrip.legs.push(getEmptyLeg(nextTrip.legs.length, nextTrip.legs.length + 1))
        }
        vm.data.trip = nextTrip;
      //console.log(angular.copy(nextTrip))
        $timeout(function () {
          computeArrive(step - 1);
        }, 0);
      }
      vm.stepDelete = function (step) {
      //console.log('Deleting ' + step)
        if (!valid(step, vm.data.trip.steps)) return;
        if (vm.data.trip.steps.length <= 2) return;

        var leg = step - 1;
        if (leg < 0) leg = 0;
        if (vm.temp[leg].directions) {
          vm.data.trip.info.directions.total.duration -= vm.temp[leg].directions.total.duration;
          vm.data.trip.info.directions.total.distance -= vm.temp[leg].directions.total.distance;
          vm.data.trip.info.directions.highway.duration -= vm.temp[leg].directions.highway.duration;
          vm.data.trip.info.directions.highway.distance -= vm.temp[leg].directions.highway.distance;
          vm.data.trip.info.directions.ferry.duration -= vm.temp[leg].directions.ferry.duration;
          vm.data.trip.info.directions.ferry.distance -= vm.temp[leg].directions.ferry.distance;
          vm.data.trip.info.directions.city.duration -= vm.temp[leg].directions.city.duration;
          vm.data.trip.info.directions.city.distance -= vm.temp[leg].directions.city.distance;
        }
        vm.data.trip.info.stopover -= vm.data.trip.legs[leg].stopover;
        vm.data.trip.info.layover -= vm.data.trip.steps[step].layover;

        if (step === 0) {
          vm.data.trip.info.layover -= vm.data.trip.steps[step + 1].layover;
          vm.data.trip.steps[step + 1].layover = 0;
          vm.data.trip.steps[step + 1].arrive = null;
        }
        else if (step === vm.data.trip.steps.length - 1) {
          vm.data.trip.info.layover -= vm.data.trip.steps[step - 1].layover;
          vm.data.trip.steps[step - 1].layover = 0;
          vm.data.trip.steps[step - 1].depart = null;
          vm.data.trip.steps[step - 1].keep = false;
        }

        remove(step, vm.data.trip.steps);
        remove(leg, vm.data.trip.legs);
        remove(leg, vm.temp);
      };

      vm.switchStep = function (fromStep, toStep) {
        var from = {};
        angular.copy(vm.data.trip.steps[fromStep].place, from);
        vm.data.trip.steps[fromStep].place = vm.data.trip.steps[toStep].place;
        vm.data.trip.steps[toStep].place = from;
      };

      vm.stepPlaceSelect = function (step) {
        //////console.log("[CALL] PLANNER - PLACE SELECTED - STEP:", step);
      };

      vm.stepPlaceGeocode = function (step) {
        //////console.log("[CALL] PLANNER - PLACE GEOCODED - STEP:", step);
      };

      vm.stepPlaceCompute = function (step) {

        if (vm.scheduledMake) return;
        ////console.log("[CALL] PLANNER - PLACE COMPUTED - STEP:", step);
        var leg = step - 1;

        vm.data.trip.info.directions.total.distance += vm.data.trip.legs[leg].directions.total.distance;
        vm.data.trip.info.directions.total.duration += vm.data.trip.legs[leg].directions.total.duration;
        vm.data.trip.info.directions.highway.distance += vm.data.trip.legs[leg].directions.highway.distance;
        vm.data.trip.info.directions.highway.duration += vm.data.trip.legs[leg].directions.highway.duration;
        vm.data.trip.info.directions.ferry.distance += vm.data.trip.legs[leg].directions.ferry.distance;
        vm.data.trip.info.directions.ferry.duration += vm.data.trip.legs[leg].directions.ferry.duration;
        vm.data.trip.info.directions.city.distance += vm.data.trip.legs[leg].directions.city.distance;
        vm.data.trip.info.directions.city.duration += vm.data.trip.legs[leg].directions.city.duration;

        if (vm.temp[leg].directions) {
          vm.data.trip.info.directions.total.duration -= vm.temp[leg].directions.total.duration;
          vm.data.trip.info.directions.total.distance -= vm.temp[leg].directions.total.distance;
          vm.data.trip.info.directions.highway.duration -= vm.temp[leg].directions.highway.duration;
          vm.data.trip.info.directions.highway.distance -= vm.temp[leg].directions.highway.distance;
          vm.data.trip.info.directions.ferry.duration -= vm.temp[leg].directions.ferry.duration;
          vm.data.trip.info.directions.ferry.distance -= vm.temp[leg].directions.ferry.distance;
          vm.data.trip.info.directions.city.duration -= vm.temp[leg].directions.city.duration;
          vm.data.trip.info.directions.city.distance -= vm.temp[leg].directions.city.distance;
        }
        angular.copy(vm.data.trip.legs[leg].directions, vm.temp[leg].directions);

        if (!angular.isDate(vm.data.trip.steps[step - 1].depart)) return;
        // // // console.trace();
        $timeout(function () {
          computeArrive(step);
        }, 0);
      };

      vm.stepDepartChange = function (step) {
        ////console.log("[CALL] PLANNER - DEPART CHANGE - STEP:", step);
        vm.maxStart = vm.data.trip.steps[0].depart ? new Date(vm.data.trip.steps[0].depart) : undefined;
        if (vm.data.trip.steps[step].arrive) {
          vm.minEnd = vm.minEnd ? new Date(max(vm.minEnd.getTime(), vm.data.trip.steps[step].arrive.getTime())) : new Date(vm.data.trip.steps[step].arrive);
        }
        if (vm.data.trip.steps[step].depart) {
          vm.minEnd = vm.minEnd ? new Date(max(vm.minEnd.getTime(), vm.data.trip.steps[step].depart.getTime())) : new Date(vm.data.trip.steps[step].depart);
        }
        // // // console.trace();

        $timeout(function () {
          computeArrive(step);
        }, 0);
      };

      vm.passengersChange = function () {
        //////console.log("[CALL] PLANNER - PASSENGERS CHANGE");
      }

      vm.setToStart = function (step) {
        vm.data.trip.steps[step].place = vm.data.trip.steps[0].place;
      };

      vm.stepSend = function () {
        if (vm.alert) return;
        if (vm.data.trip.steps.length > vm.MAX_GOOGLE_STEPS) return;
        if (!angular.isDate(vm.data.trip.steps[vm.data.trip.steps.length - 1].arrive)) {
          if (!angular.isString(vm.data.trip.steps[vm.data.trip.steps.length - 2].place.address)) {
            vm.warning = 1;
            vm.resetWarning(5000);
          }
          else if (!vm.data.trip.steps[vm.data.trip.steps.length - 2].depart) {
            vm.warning = 2;
            vm.resetWarning(5000);
          }
          else if (!angular.isString(vm.data.trip.steps[vm.data.trip.steps.length - 1].place.address)) {
            vm.warning = 3;
            vm.resetWarning(5000);
          }
          else {
            vm.warning = 4;
            vm.resetWarning(5000);
          }
          return;
        }
        // if(!angular.isNumber(vm.data.onboard.passengers)) {
        //   vm.warning = 5;
        //   vm.resetWarning(5000);
        //   return;
        // }
        // if(vm.data.onboard.passengers < 1) {
        //   vm.warning = 6;
        //   vm.resetWarning(5000);
        //   return;
        // }
        // if(vm.data.onboard.passengers > 9999) {
        //   vm.warning = 7;
        //   vm.resetWarning(5000);
        //   return;
        // }
        //////console.log(vm.data);
        /*
        var blocked = false;
        var tn = new Date(null).setHours(8, 0, 0, 0);
        for (var s = 0; s < vm.data.trip.steps.length; s++) {
          var ta = new Date(vm.data.trip.steps[s].arrive).setHours(8, 0, 0, 0);
          var td = new Date(vm.data.trip.steps[s].depart).setHours(8, 0, 0, 0);
          for (var i = 0; i < vm.BLACK_LISTED.length; i++) {
            var tb = new Date(vm.BLACK_LISTED[i]).setHours(8, 0, 0, 0);
            if (ta == tn && td == tb) {
              blocked = true;
            } else if (td == tn && ta == tb) {
              blocked = true;
            } else if (ta != tn && td != tn && ta <= tb && tb <= td) {
              blocked = true;
            }
          }
        }

        if (blocked) {
          vm.alert = true;
          $alert.show('Avviso', 'La data da te selezionata è molto richiesta: ci sono pochi autisti disponibili. Non sarà dunque possibile prenotare online. Se desideri un preventivo scrivi ad info@busrapido.com Tieni conto che le tariffe nelle date selezionate possono essere fino a 10 volte superiori alla media.', 'Chiudi', '', false, 0, 0,
            function (cancel) { vm.alert = false; });
          return;
        }
        */
        /*
        if(angular.isNumber(vm.lowPassengersAlert) && vm.data.onboard.passengers < vm.lowPassengersAlert) {
          vm.alert = true;
          $alert.show('Avviso', 'Ti informiamo che i risultati che ti verranno mostrati sono per il noleggio dell\'intero pullman. Pertanto non è possibile l\'acquisto di biglietti singoli. Se desideri continuare premi "Ho capito"', 'Annulla', 'Ho capito', false, 0, 0,
            function(cancel) { vm.alert = false; },
            function(confirm) {
              vm.alert = false;
              sub1();
            });
        }
        else {
          sub1();
        }*/
        sub1();
        function sub1() {
          if (vm.data.trip.legs.length < 2) {
            vm.alert = true;
            $alert.show('Desideri inserire il ritorno?', 'Abbiamo notato che non hai inserito il ritorno a ' + vm.data.trip.steps[0].place.address + '. Se hai bisogno di tornare a ' + vm.data.trip.steps[0].place.address + ' premi "Si, voglio il ritorno"', 'Si, voglio il ritorno', 'No, viaggio di sola andata', false, 0, 0,
              function (cancel) {
                vm.alert = false;
                vm.stepCreate(vm.data.trip.steps.length)
                vm.setToStart(vm.data.trip.legs[vm.data.trip.legs.length - 1].to);
              },
              function (confirm) {
                vm.alert = false;
                $timeout(vm.onSubmit, 0);
              });
          }
          else {
            $timeout(vm.onSubmit, 0);
          }
        }
      };

      /**
      * Controller Functions;
      */

      function getEmptyInfo() {
        var temp = {
          stopover: 0,
          layover: 0,
          directions: {
            total: { duration: 0, distance: 0 },
            highway: { distance: 0, duration: 0 },
            ferry: { distance: 0, duration: 0 },
            city: { distance: 0, duration: 0 }
          }
        };
        return temp
      }
      function getEmptyStep() {
        var temp = {
          place: {
            address: '',
            location: { lat: -360, lng: -360 }
          },
          arrive: null,
          depart: null,
          layover: 0,
          keep: false
        };
        return temp
      }
      function getEmptyLeg(from, to) {
        var temp = {
          from: from,
          to: to,
          stopover: 0,
          directions: {
            total: { duration: 0, distance: 0 },
            highway: { distance: 0, duration: 0 },
            ferry: { distance: 0, duration: 0 },
            city: { distance: 0, duration: 0 }
          }
        };
        return temp
      }
      function getEmptyTemp() {
        var temp = {
          directions: {
            total: { duration: 0, distance: 0 },
            highway: { distance: 0, duration: 0 },
            ferry: { distance: 0, duration: 0 },
            city: { distance: 0, duration: 0 }
          },
          simulation: {
            uninterruptedDriving: 0,
            drivingInterruption: 0
          }
        };
        return temp
      }

      vm.dayCreate = function (step) {
        vm.data.trip.steps[step].depart = new Date((vm.data.trip.steps[step].arrive.getTime() / (1000 * 24 * 60 * 60) + 1) * (1000 * 24 * 60 * 60));
        ////console.log(vm.data.trip.steps[step].depart)
        // // // console.trace();

        $timeout(function () {
          computeArrive(step);
        }, 0);
      }
      vm.computedArrive = {};
      function computeArrive(step) {

        if (vm.scheduledMake) return;
        if (vm.computedArrive[step]) return;
        if (!valid(step - 1, vm.data.trip.steps)) {
          vm.data.trip.steps[step].arrive = new Date(max(new Date(vm.data.trip.steps[step].arrive).getTime(), new Date(vm.data.start).getTime()))
          return computeArrive(step + 1);
        }
        if (!valid(step, vm.data.trip.steps)) {
          if (step === vm.data.trip.steps.length) {
            // // console.trace();
            makeDays();
          }
          return;
        }

        var leg = step - 1;

        if (!angular.isNumber(vm.data.trip.legs[leg].directions.total.duration) || vm.data.trip.legs[leg].directions.total.duration <= 0) return;
        if (!angular.isDate(vm.data.trip.steps[step - 1].depart)) return;

        if (leg > 0) {
          angular.copy(vm.temp[leg - 1].simulation, vm.temp[leg].simulation);
        }
        else {
          vm.temp[leg].simulation = {
            uninterruptedDriving: vm.MAX_DRIVING_TIME_UNINTERRUPTED,
            drivingInterruption: vm.STOPOVER_TIME
          };
        }

        if (leg > 0) {
          vm.data.trip.info.stopover -= vm.data.trip.legs[leg].stopover;
          vm.data.trip.info.stopover += vm.data.trip.legs[leg].stopover;
        }
        else {
          vm.data.trip.info.stopover -= vm.data.trip.legs[leg].stopover;
          vm.data.trip.info.stopover += vm.data.trip.legs[leg].stopover;
        }
        if (!vm.data.trip.steps[step].arrive)
          vm.data.trip.steps[step].arrive = roundTime(new Date(vm.data.trip.steps[step - 1].depart.getTime() + (vm.data.trip.legs[leg].directions.total.duration + vm.data.trip.legs[leg].stopover) * 1000));
        else
          vm.data.trip.steps[step].arrive.setTime(roundTime(new Date(vm.data.trip.steps[step - 1].depart.getTime() + (vm.data.trip.legs[leg].directions.total.duration + vm.data.trip.legs[leg].stopover) * 1000)).getTime());
        if (!vm.data.trip.steps[step].depart)
          vm.data.trip.steps[step].depart = roundTime(new Date(vm.data.trip.steps[step].arrive.getTime() + vm.MIN_LAYOVER * 1000));
        else if (vm.data.trip.steps[step].depart.getTime() < roundTime(new Date(vm.data.trip.steps[step].arrive.getTime() + vm.MIN_LAYOVER * 1000)).getTime())
          vm.data.trip.steps[step].depart.setTime(roundTime(new Date(vm.data.trip.steps[step].arrive.getTime() + vm.MIN_LAYOVER * 1000)).getTime());


        vm.temp[leg].min = new Date(vm.data.trip.steps[step].arrive.getTime() + vm.MIN_LAYOVER * 1000);
        $scope.$apply();

        if (!angular.isDate(vm.data.trip.steps[step].depart)) return;
        vm.data.trip.info.layover -= vm.data.trip.steps[step].layover;
        vm.data.trip.steps[step].layover = Math.ceil((vm.data.trip.steps[step].depart - vm.data.trip.steps[step].arrive) / 1000);
        vm.data.trip.info.layover += vm.data.trip.steps[step].layover;
        // // console.trace();
        $timeout(function () { computeArrive(step + 1) }, 0);
        vm.computedArrive[step] = true;
        $timeout(function () { vm.computedArrive[step] = false }, 1000);
      }

      function roundTime(date) {
        date.setSeconds(0, 0);
        var min = date.getMinutes();
        var dif = 0;
        var mins = [0, 15, 30, 45, 60];

        for (var i = 0; i < mins.length; i++) {
          if (min <= mins[i]) {
            dif = mins[i];
            break;
          }
        }
        if (dif === 0) return date;
        return new Date(date.getTime() + (dif - min) * 6e4);
      }

      function valid(pos, array) {
        if (pos < 0 || pos >= array.length) return false;
        return true;
      }
      function insert(pos, data, array) {
        if (pos === array.length) {
          array.push(data);
        }
        else {
          array.splice(pos, 0, data);
        }
      }
      function remove(pos, array) {
        array.splice(pos, 1);
      }

      function getStopover(simulation, layover, duration) {
        var timeToDrive = duration;
        var totalStopover = 0;

        if (!angular.isObject(simulation) || simulation === null || !angular.isNumber(simulation.drivingInterruption) || !angular.isNumber(simulation.uninterruptedDriving)) {
          simulation = {
            uninterruptedDriving: vm.MAX_DRIVING_TIME_UNINTERRUPTED,
            drivingInterruption: vm.STOPOVER_TIME
          };
        }

        if (layover >= simulation.drivingInterruption) {
          simulation.uninterruptedDriving = vm.MAX_DRIVING_TIME_UNINTERRUPTED;
          simulation.drivingInterruption = vm.STOPOVER_TIME;
        }
        else if (layover >= vm.STOPOVER_TIME_PART1) {
          simulation.drivingInterruption -= vm.STOPOVER_TIME_PART1;
        }
        else if (layover >= vm.STOPOVER_TIME_PART2 && simulation.drivingInterruption > vm.STOPOVER_TIME_PART1) {
          simulation.drivingInterruption -= vm.STOPOVER_TIME_PART2;
        }

        do {
          var dailyDriving = timeToDrive;

          if (dailyDriving > simulation.uninterruptedDriving) {
            dailyDriving = simulation.uninterruptedDriving;
            totalStopover += simulation.drivingInterruption;
            simulation.uninterruptedDriving = vm.MAX_DRIVING_TIME_UNINTERRUPTED;
            simulation.drivingInterruption = vm.STOPOVER_TIME;
          }
          else {
            simulation.uninterruptedDriving -= duration;
          }

          timeToDrive -= dailyDriving;
        }
        while (timeToDrive > 0);

        return totalStopover;
      }

      /**
      * Controller watchers
      */
      $scope.$watch(function () { return vm.data.trip }, function () {
        if (vm.executed) return;
        vm.executed = true;
        ////console.log("[WATCH] PLANNER - DATA CHANGE", vm.data);

        if (!angular.isObject(vm.data) || angular.isArray(vm.data) || !angular.isObject(vm.data.trip) || !angular.isArray(vm.data.trip.steps) || !angular.isArray(vm.data.trip.legs)) {
          return;
        }
        for (var i = 0; i < vm.data.trip.legs.length; i++) {
          if (vm.temp.length === i) vm.temp.push({});
          vm.temp[i].directions = {};
          angular.copy(vm.data.trip.legs[i].directions, vm.temp[i].directions);
          vm.temp[i].simulation = {
            uninterruptedDriving: vm.MAX_DRIVING_TIME_UNINTERRUPTED,
            drivingInterruption: vm.STOPOVER_TIME
          };
        }
        var start = new Date(vm.data.trip.steps[0].depart);
        var toAdd = 0;
        if (start < vm.MIN_DEPART_DATE) {
          toAdd = vm.MIN_DEPART_DATE.getDate() - start.getDate();
          if (start.getHours() < vm.MIN_DEPART_DATE.getHours()) {
            toAdd++;
          }
          else if (start.getHours() == vm.MIN_DEPART_DATE.getHours() && start.getMinutes() < vm.MIN_DEPART_DATE.getMinutes()) {
            toAdd++;
          }
        }
        for (var j = 0; j < vm.data.trip.steps.length; j++) {
          if (vm.data.trip.steps[j].depart) {
            vm.data.trip.steps[j].depart = new Date(vm.data.trip.steps[j].depart);
            if (toAdd > 0) vm.data.trip.steps[j].depart = new Date(vm.data.trip.steps[j].depart.getTime() + (toAdd * 24 * 60 * 60 * 1000));
          }
          if (vm.data.trip.steps[j].arrive) {
            if (toAdd > 0) vm.data.trip.steps[j].arrive = new Date(vm.data.trip.steps[j].arrive.getTime() + (toAdd * 24 * 60 * 60 * 1000));
          }
        }

        $timeout(function () { computeArrive(1) }, 0);
      }, true);
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brSaysaboutus', saysaboutusDirective);

  /** @ngInject */
  function saysaboutusDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/elements/saysaboutus/saysaboutus.html'
    };

    return directive;
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .filter('labelText', labelTextFilter)
    .filter('labelArrive', labelArrive)
    .filter('labelLayover', labelLayover);

  function labelTextFilter() {
    return function(input, label1, label2, label3) {
      if(!input) {
        return label1;
      }
      if(input.length > 7) {
        return label2 + input.substring(0, 7)+'...' + label3;
      }
      return label2 + input + label3;
    }
  }
  /** @ngInject */
  function labelArrive($filter) {
    return function(date, duration, stopover, label1) {
      if(!date) {
        return undefined;
      }
      if(stopover > 0) {
        //var tooltip = '<span class="info icon icon-info" tooltips tooltip-template="Il tempo di percorrenza in pullman stimato per questo viaggio è di: ' + $filter('duration')(duration) + '.<br/>A questo tempo vanno aggiunti ' + $filter('duration')(stopover) + ' di pausa, da effettuare durante il viaggio, per la vostra sicurezza. Così come previsto dal regolamento CE n°561/2006" tooltip-side="top"></span>';
        return label1 + $filter('amDateFormat')(date, 'D MMM YYYY, HH:mm') + ' (' + $filter('duration')(duration+stopover)  + ' di viaggio)';
      }
      return label1 + $filter('amDateFormat')(date, 'D MMM YYYY, HH:mm') + ' (' + $filter('duration')(duration)  + ' di viaggio)';
    }
  }
  /** @ngInject */
  function labelLayover($filter) {
    return function(duration, depart, label1) {
      if(!duration || !depart) {
        return undefined;
      }
      return label1 + $filter('duration')(duration);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brPlanner', plannerDirective);

  /** @ngInject */
  function plannerDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        data: '=brData',
        onSubmit: '&brOnSubmit',
        lowPassengersAlert: '=?brLowPassengersAlert'
      },
      templateUrl: 'app/elements/planner/planner.html',
      controller: 'PlannerController',
      controllerAs: 'planner',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('PlannerController', PlannerController);

  /** @ngInject */
  function PlannerController($scope, $state, $timeout, $alert) {
    var vm = this;

    vm.$onInit = function () {
      /**
       * Scope Init
       */
      vm.executed = false;
      vm.MAX_GOOGLE_STEPS = 26;
      vm.MIN_LAYOVER = 9e2;
      vm.MIN_HW_SPEED = 65;
      vm.MAX_VEHICLE_SPEED = 95;

      vm.MAX_DRIVING_TIME_UNINTERRUPTED = 4.5 * 60 * 60;
      vm.STOPOVER_TIME = 45 * 60;
      vm.STOPOVER_TIME_PART1 = 30 * 60;
      vm.STOPOVER_TIME_PART2 = 15 * 60;



      vm.BLACK_LISTED = [(new Date('12/31/2017')), (new Date('01/01/2018'))];
      if (angular.isUndefined(vm.data.trip)) {
        vm.data.trip = {
          info: getEmptyInfo(),
          legs: [getEmptyLeg(0, 1)],
          steps: [getEmptyStep(), getEmptyStep()]
        };
      }

      vm.temp = [getEmptyTemp()];

      /**
       * Scope Functions
       */

      vm.resetWarning = function (time) {
        $timeout(function () {
          vm.warning = undefined;
        }, time);
      };
      vm.stepCreate = function (step) {
        if (vm.data.trip.steps.length >= vm.MAX_GOOGLE_STEPS) return;

        if (!angular.isDate(vm.data.trip.steps[vm.data.trip.steps.length - 1].arrive)) {
          if (angular.isString(vm.data.trip.steps[vm.data.trip.steps.length - 2].place.address)) {
            vm.warning = 1;
          }
          else if (!vm.data.trip.steps[vm.data.trip.steps.length - 2].depart) {
            vm.warning = 2;
          }
          else if (angular.isString(!vm.data.trip.steps[vm.data.trip.steps.length - 1].place.address)) {
            vm.warning = 3;
          }
          else {
            vm.warning = 4;
          }
          vm.resetWarning(5000);
          return;
        }

        var leg = step - 1;

        insert(step, getEmptyStep(), vm.data.trip.steps);
        if (step > 1) {
          vm.data.trip.steps[step - 1].keep = vm.data.trip.steps[step - 2].keep;
        }
        insert(leg, getEmptyLeg(step - 1, step), vm.data.trip.legs);
        insert(leg, getEmptyTemp(), vm.temp);
      };

      vm.stepDelete = function (step) {
        if (!valid(step, vm.data.trip.steps)) return;
        if (vm.data.trip.steps.length <= 2) return;

        var leg = step - 1;
        if (leg < 0) leg = 0;
        if (vm.temp[leg].directions) {
          vm.data.trip.info.directions.total.duration -= vm.temp[leg].directions.total.duration;
          vm.data.trip.info.directions.total.distance -= vm.temp[leg].directions.total.distance;
          vm.data.trip.info.directions.highway.duration -= vm.temp[leg].directions.highway.duration;
          vm.data.trip.info.directions.highway.distance -= vm.temp[leg].directions.highway.distance;
          vm.data.trip.info.directions.ferry.duration -= vm.temp[leg].directions.ferry.duration;
          vm.data.trip.info.directions.ferry.distance -= vm.temp[leg].directions.ferry.distance;
          vm.data.trip.info.directions.city.duration -= vm.temp[leg].directions.city.duration;
          vm.data.trip.info.directions.city.distance -= vm.temp[leg].directions.city.distance;
        }
        vm.data.trip.info.stopover -= vm.data.trip.legs[leg].stopover;
        vm.data.trip.info.layover -= vm.data.trip.steps[step].layover;
        if (step === 0) {
          vm.data.trip.info.layover -= vm.data.trip.steps[step + 1].layover;
          vm.data.trip.steps[step + 1].layover = 0;
          vm.data.trip.steps[step + 1].arrive = null;
        }
        else if (step === vm.data.trip.steps.length - 1) {
          vm.data.trip.info.layover -= vm.data.trip.steps[step - 1].layover;
          vm.data.trip.steps[step - 1].layover = 0;
          vm.data.trip.steps[step - 1].depart = null;
          vm.data.trip.steps[step - 1].keep = false;
        }

        remove(step, vm.data.trip.steps);
        remove(leg, vm.data.trip.legs);
        remove(leg, vm.temp);
      };

      vm.switchStep = function (fromStep, toStep) {
        var from = {};
        angular.copy(vm.data.trip.steps[fromStep].place, from);
        vm.data.trip.steps[fromStep].place = vm.data.trip.steps[toStep].place;
        vm.data.trip.steps[toStep].place = from;
      };

      vm.stepPlaceSelect = function (step) {
        //console.log("[CALL] PLANNER - PLACE SELECTED - STEP:", step);
      };

      vm.stepPlaceGeocode = function (step) {
        //console.log("[CALL] PLANNER - PLACE GEOCODED - STEP:", step);
      };

      vm.stepPlaceCompute = function (step) {
        //console.log("[CALL] PLANNER - PLACE COMPUTED - STEP:", step);
        var leg = step - 1;

        vm.data.trip.info.directions.total.distance += vm.data.trip.legs[leg].directions.total.distance - vm.temp[leg].directions.total.distance;
        vm.data.trip.info.directions.total.duration += vm.data.trip.legs[leg].directions.total.duration - vm.temp[leg].directions.total.duration;
        vm.data.trip.info.directions.highway.distance += vm.data.trip.legs[leg].directions.highway.distance - vm.temp[leg].directions.highway.distance;
        vm.data.trip.info.directions.highway.duration += vm.data.trip.legs[leg].directions.highway.duration - vm.temp[leg].directions.highway.duration;
        vm.data.trip.info.directions.ferry.distance += vm.data.trip.legs[leg].directions.ferry.distance - vm.temp[leg].directions.ferry.distance;
        vm.data.trip.info.directions.ferry.duration += vm.data.trip.legs[leg].directions.ferry.duration - vm.temp[leg].directions.ferry.duration;
        vm.data.trip.info.directions.city.distance += vm.data.trip.legs[leg].directions.city.distance - vm.temp[leg].directions.city.distance;
        vm.data.trip.info.directions.city.duration += vm.data.trip.legs[leg].directions.city.duration - vm.temp[leg].directions.city.duration;

        angular.copy(vm.data.trip.legs[leg].directions, vm.temp[leg].directions);

        if (!angular.isDate(vm.data.trip.steps[step - 1].depart)) return;

        $timeout(function () {
          computeArrive(step);
        }, 0);
      };

      vm.stepDepartChange = function (step) {
        //console.log("[CALL] PLANNER - DEPART CHANGE - STEP:", step);
        $timeout(function () {
          computeArrive(step);
        }, 0);
      };

      vm.passengersChange = function () {
        //console.log("[CALL] PLANNER - PASSENGERS CHANGE");
      }

      vm.setToStart = function (step) {
        vm.data.trip.steps[step].place = vm.data.trip.steps[0].place;
      };

      vm.stepSend = function () {
        if (vm.alert) return;
        if (vm.data.trip.steps.length > vm.MAX_GOOGLE_STEPS) return;
        if (!angular.isDate(vm.data.trip.steps[vm.data.trip.steps.length - 1].arrive)) {
          if (!angular.isString(vm.data.trip.steps[vm.data.trip.steps.length - 2].place.address)) {
            vm.warning = 1;
            vm.resetWarning(5000);
          }
          else if (!vm.data.trip.steps[vm.data.trip.steps.length - 2].depart) {
            vm.warning = 2;
            vm.resetWarning(5000);
          }
          else if (!angular.isString(vm.data.trip.steps[vm.data.trip.steps.length - 1].place.address)) {
            vm.warning = 3;
            vm.resetWarning(5000);
          }
          else {
            vm.warning = 4;
            vm.resetWarning(5000);
          }
          return;
        }
        // if(!angular.isNumber(vm.data.onboard.passengers)) {
        //   vm.warning = 5;
        //   vm.resetWarning(5000);
        //   return;
        // }
        // if(vm.data.onboard.passengers < 1) {
        //   vm.warning = 6;
        //   vm.resetWarning(5000);
        //   return;
        // }
        // if(vm.data.onboard.passengers > 9999) {
        //   vm.warning = 7;
        //   vm.resetWarning(5000);
        //   return;
        // }
        //console.log(vm.data);

        var blocked = false;
        var tn = new Date(null).setHours(8, 0, 0, 0);
        for (var s = 0; s < vm.data.trip.steps.length; s++) {
          var ta = new Date(vm.data.trip.steps[s].arrive).setHours(8, 0, 0, 0);
          var td = new Date(vm.data.trip.steps[s].depart).setHours(8, 0, 0, 0);
          for (var i = 0; i < vm.BLACK_LISTED.length; i++) {
            var tb = new Date(vm.BLACK_LISTED[i]).setHours(8, 0, 0, 0);
            if (ta == tn && td == tb) {
              blocked = true;
            } else if (td == tn && ta == tb) {
              blocked = true;
            } else if (ta != tn && td != tn && ta <= tb && tb <= td) {
              blocked = true;
            }
          }
        }

        if (blocked) {
          vm.alert = true;
          $alert.show('Avviso', 'La data da te selezionata è molto richiesta: ci sono pochi autisti disponibili. Non sarà dunque possibile prenotare online. Se desideri un preventivo scrivi ad info@busrapido.com Tieni conto che le tariffe nelle date selezionate possono essere fino a 10 volte superiori alla media.', 'Chiudi', '', false, 0, 0,
            function (cancel) { vm.alert = false; });
          return;
        }
        /*
        if(angular.isNumber(vm.lowPassengersAlert) && vm.data.onboard.passengers < vm.lowPassengersAlert) {
          vm.alert = true;
          $alert.show('Avviso', 'Ti informiamo che i risultati che ti verranno mostrati sono per il noleggio dell\'intero pullman. Pertanto non è possibile l\'acquisto di biglietti singoli. Se desideri continuare premi "Ho capito"', 'Annulla', 'Ho capito', false, 0, 0,
            function(cancel) { vm.alert = false; },
            function(confirm) {
              vm.alert = false;
              sub1();
            });
        }
        else {
          sub1();
        }*/
        sub1();
        function sub1() {
          if (vm.data.trip.legs.length < 2) {
            vm.alert = true;
            $alert.show('Desideri inserire il ritorno?', 'Abbiamo notato che non hai inserito il ritorno a ' + vm.data.trip.steps[0].place.address + '. Se hai bisogno di tornare a ' + vm.data.trip.steps[0].place.address + ' premi "Si, voglio il ritorno"', 'Si, voglio il ritorno', 'No, viaggio di sola andata', false, 0, 0,
              function (cancel) {
                vm.alert = false;
                vm.stepCreate(vm.data.trip.steps.length)
                vm.setToStart(vm.data.trip.legs[vm.data.trip.legs.length - 1].to);
              },
              function (confirm) {
                vm.alert = false;
                $timeout(vm.onSubmit, 0);
              });
          }
          else {
            $timeout(vm.onSubmit, 0);
          }
        }
      };

      /**
      * Controller Functions;
      */

      function getEmptyInfo() {
        var temp = {
          stopover: 0,
          layover: 0,
          directions: {
            total: { duration: 0, distance: 0 },
            highway: { distance: 0, duration: 0 },
            ferry: { distance: 0, duration: 0 },
            city: { distance: 0, duration: 0 }
          }
        };
        return temp
      }
      function getEmptyStep() {
        var temp = {
          place: {
            address: '',
            location: { lat: -360, lng: -360 }
          },
          arrive: null,
          depart: null,
          layover: 0,
          keep: false
        };
        return temp
      }
      function getEmptyLeg(from, to) {
        var temp = {
          from: from,
          to: to,
          stopover: 0,
          directions: {
            total: { duration: 0, distance: 0 },
            highway: { distance: 0, duration: 0 },
            ferry: { distance: 0, duration: 0 },
            city: { distance: 0, duration: 0 }
          }
        };
        return temp
      }
      function getEmptyTemp() {
        var temp = {
          directions: {
            total: { duration: 0, distance: 0 },
            highway: { distance: 0, duration: 0 },
            ferry: { distance: 0, duration: 0 },
            city: { distance: 0, duration: 0 }
          },
          simulation: {
            uninterruptedDriving: 0,
            drivingInterruption: 0
          }
        };
        return temp
      }

      function computeArrive(step) {
        if (!valid(step - 1, vm.data.trip.steps)) return computeArrive(step + 1);
        if (!valid(step, vm.data.trip.steps)) return;

        var leg = step - 1;

        if (!angular.isNumber(vm.data.trip.legs[leg].directions.total.duration) || vm.data.trip.legs[leg].directions.total.duration <= 0) return;
        if (!angular.isDate(vm.data.trip.steps[step - 1].depart)) return;

        if (leg > 0) {
          angular.copy(vm.temp[leg - 1].simulation, vm.temp[leg].simulation);
        }
        else {
          vm.temp[leg].simulation = {
            uninterruptedDriving: vm.MAX_DRIVING_TIME_UNINTERRUPTED,
            drivingInterruption: vm.STOPOVER_TIME
          };
        }

        if (leg > 0) {
          vm.data.trip.info.stopover -= vm.data.trip.legs[leg].stopover;
          vm.data.trip.legs[leg].stopover = getStopover(vm.temp[leg].simulation, vm.data.trip.steps[step - 1].layover, vm.data.trip.legs[leg].directions.total.duration);
          vm.data.trip.info.stopover += vm.data.trip.legs[leg].stopover;
        }
        else {
          vm.data.trip.info.stopover -= vm.data.trip.legs[leg].stopover;
          vm.data.trip.legs[leg].stopover = getStopover(vm.temp[leg].simulation, 0, vm.data.trip.legs[leg].directions.total.duration);
          vm.data.trip.info.stopover += vm.data.trip.legs[leg].stopover;
        }

        vm.data.trip.steps[step].arrive = roundTime(new Date(vm.data.trip.steps[step - 1].depart.getTime() + (vm.data.trip.legs[leg].directions.total.duration + vm.data.trip.legs[leg].stopover) * 1000));
        vm.temp[leg].min = new Date(vm.data.trip.steps[step].arrive.getTime() + vm.MIN_LAYOVER * 1000);
        $scope.$apply();

        if (!angular.isDate(vm.data.trip.steps[step].depart)) return;
        vm.data.trip.info.layover -= vm.data.trip.steps[step].layover;
        vm.data.trip.steps[step].layover = Math.ceil((vm.data.trip.steps[step].depart - vm.data.trip.steps[step].arrive) / 1000);
        vm.data.trip.info.layover += vm.data.trip.steps[step].layover;

        $timeout(function () { computeArrive(step + 1) }, 0);
      }

      function roundTime(date) {
        date.setSeconds(0, 0);
        var min = date.getMinutes();
        var dif = 0;
        var mins = [0, 15, 30, 45, 60];

        for (var i = 0; i < mins.length; i++) {
          if (min <= mins[i]) {
            dif = mins[i];
            break;
          }
        }
        if (dif === 0) return date;
        return new Date(date.getTime() + (dif - min) * 6e4);
      }

      function valid(pos, array) {
        if (pos < 0 || pos >= array.length) return false;
        return true;
      }
      function insert(pos, data, array) {
        if (pos === array.length) {
          array.push(data);
        }
        else {
          array.splice(pos, 0, data);
        }
      }
      function remove(pos, array) {
        array.splice(pos, 1);
      }

      function getStopover(simulation, layover, duration) {
        var timeToDrive = duration;
        var totalStopover = 0;

        if (!angular.isObject(simulation) || simulation === null || !angular.isNumber(simulation.drivingInterruption) || !angular.isNumber(simulation.uninterruptedDriving)) {
          simulation = {
            uninterruptedDriving: vm.MAX_DRIVING_TIME_UNINTERRUPTED,
            drivingInterruption: vm.STOPOVER_TIME
          };
        }

        if (layover >= simulation.drivingInterruption) {
          simulation.uninterruptedDriving = vm.MAX_DRIVING_TIME_UNINTERRUPTED;
          simulation.drivingInterruption = vm.STOPOVER_TIME;
        }
        else if (layover >= vm.STOPOVER_TIME_PART1) {
          simulation.drivingInterruption -= vm.STOPOVER_TIME_PART1;
        }
        else if (layover >= vm.STOPOVER_TIME_PART2 && simulation.drivingInterruption > vm.STOPOVER_TIME_PART1) {
          simulation.drivingInterruption -= vm.STOPOVER_TIME_PART2;
        }

        do {
          var dailyDriving = timeToDrive;

          if (dailyDriving > simulation.uninterruptedDriving) {
            dailyDriving = simulation.uninterruptedDriving;
            totalStopover += simulation.drivingInterruption;
            simulation.uninterruptedDriving = vm.MAX_DRIVING_TIME_UNINTERRUPTED;
            simulation.drivingInterruption = vm.STOPOVER_TIME;
          }
          else {
            simulation.uninterruptedDriving -= duration;
          }

          timeToDrive -= dailyDriving;
        }
        while (timeToDrive > 0);

        return totalStopover;
      }

      /**
      * Controller watchers
      */
      $scope.$watch(function () { return vm.data }, function () {
        //console.log("[WATCH] PLANNER - DATA CHANGE", vm.data);

        if (vm.executed) return;
        vm.executed = true;

        if (!angular.isObject(vm.data) || angular.isArray(vm.data) || !angular.isObject(vm.data.trip) || !angular.isArray(vm.data.trip.steps) || !angular.isArray(vm.data.trip.legs)) {
          return;
        }
        for (var i = 0; i < vm.data.trip.legs.length; i++) {
          if (vm.temp.length === i) vm.temp.push({});
          vm.temp[i].directions = {};
          angular.copy(vm.data.trip.legs[i].directions, vm.temp[i].directions);
          vm.temp[i].simulation = {
            uninterruptedDriving: vm.MAX_DRIVING_TIME_UNINTERRUPTED,
            drivingInterruption: vm.STOPOVER_TIME
          };
        }
        var start = new Date(vm.data.trip.steps[0].depart);
        var toAdd = 0;
        if (start < vm.MIN_DEPART_DATE) {
          toAdd = vm.MIN_DEPART_DATE.getDate() - start.getDate();
          if (start.getHours() < vm.MIN_DEPART_DATE.getHours()) {
            toAdd++;
          }
          else if (start.getHours() == vm.MIN_DEPART_DATE.getHours() && start.getMinutes() < vm.MIN_DEPART_DATE.getMinutes()) {
            toAdd++;
          }
        }
        for (var j = 0; j < vm.data.trip.steps.length; j++) {
          if (vm.data.trip.steps[j].depart) {
            vm.data.trip.steps[j].depart = new Date(vm.data.trip.steps[j].depart);
            if (toAdd > 0) vm.data.trip.steps[j].depart = new Date(vm.data.trip.steps[j].depart.getTime() + (toAdd * 24 * 60 * 60 * 1000));
          }
          if (vm.data.trip.steps[j].arrive) {
            vm.data.trip.steps[j].arrive = new Date(vm.data.trip.steps[j].arrive);
            if (toAdd > 0) vm.data.trip.steps[j].arrive = new Date(vm.data.trip.steps[j].arrive.getTime() + (toAdd * 24 * 60 * 60 * 1000));
          }
        }

        $timeout(function () { computeArrive(1) }, 0);
      }, true);
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .filter('labelText', labelTextFilter)
    .filter('labelArrive', labelArrive)
    .filter('labelLayover', labelLayover);

  function labelTextFilter() {
    return function(input, label1, label2, label3) {
      if(!input) {
        return label1;
      }
      if(input.length > 7) {
        return label2 + input.substring(0, 7)+'...' + label3;
      }
      return label2 + input + label3;
    }
  }
  /** @ngInject */
  function labelArrive($filter) {
    return function(date, duration, stopover, label1) {
      if(!date) {
        return undefined;
      }
      if(stopover > 0) {
        //var tooltip = '<span class="info icon icon-info" tooltips tooltip-template="Il tempo di percorrenza in pullman stimato per questo viaggio è di: ' + $filter('duration')(duration) + '.<br/>A questo tempo vanno aggiunti ' + $filter('duration')(stopover) + ' di pausa, da effettuare durante il viaggio, per la vostra sicurezza. Così come previsto dal regolamento CE n°561/2006" tooltip-side="top"></span>';
        return label1 + $filter('amDateFormat')(date, 'D MMM YYYY, HH:mm') + ' (' + $filter('duration')(duration+stopover)  + ' di viaggio)';
      }
      return label1 + $filter('amDateFormat')(date, 'D MMM YYYY, HH:mm') + ' (' + $filter('duration')(duration)  + ' di viaggio)';
    }
  }
  /** @ngInject */
  function labelLayover($filter) {
    return function(duration, depart, label1) {
      if(!duration || !depart) {
        return undefined;
      }
      return label1 + $filter('duration')(duration);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brPlannerTopic', plannerTopicDirective);

  /** @ngInject */
  function plannerTopicDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        data: '=brData',
        previous: '=brPrevious',
        current: '=brCurrent',
        request: '=brRequest',
        onSubmit: '&brOnSubmit',
        lowPassengersAlert: '=?brLowPassengersAlert'
      },
      templateUrl: 'app/elements/planner-topic/planner.html',
      controller: 'PlannerTopicController',
      controllerAs: 'planner',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('PlannerTopicController', PlannerTopicController);

  /** @ngInject */
  function PlannerTopicController($scope, $state, $timeout, $alert, $q, uiGmapGoogleMapApi, $filter, $common) {
    var vm = this;

    vm.$onInit = function () {
      vm.isOpen = false;
      vm.dropdown = false;
      vm.showMaps = false;
      vm.types = {
        pickup: [
          'transfer', 'disposal', 'city', 'bus', 'transit',
        ],
        transfer: [
          'return', 'transfer', 'disposal', 'city', 'bus', 'transit', 'shuttle', 'end',
        ],
        transit: [
          'return', 'transfer', 'transit',
        ],
        disposal: [
          'return', 'transfer', 'disposal', 'city', 'bus', 'transit', 'shuttle', 'end',
        ],
        city: [
          'return', 'transfer', 'disposal', 'city', 'bus', 'transit', 'shuttle', 'end',
        ],
        bus: [
          'return', 'transfer', 'disposal', 'city', 'bus', 'transit', 'shuttle', 'end',
        ],
        return: [
          'transfer', 'disposal', 'city', 'bus', 'transit', 'shuttle', 'end',
        ],
        end: [
          'pickup', 'pickup-last'
        ],
        shuttle: [
          'end'
        ],
      }
      if (vm.data.requests.length == 0) {
        vm.data.requests = [
          buildRequest()
        ];
      }
      else {
        for (var i = 0; i < vm.data.requests.length; i++) {
          for (var j = 0; j < vm.data.requests[i].services[j]; j++) {
            vm.data.requests[i][j].depart = new Date(vm.data.requests[i][j].depart);
          }
        }
        //console.log(vm.data.requests)
      }
      vm.addService = function (request, type, offset) {
        request.dropdown = false;
        var lastRequest;
        if (type === 'pickup') {
          lastRequest = vm.data.requests[vm.data.requests.length - 1];
          vm.data.requests.push(buildRequest(undefined, lastRequest.services[lastRequest.services.length - 2].depart));
        }
        else if (type === 'pickup-last') {
          lastRequest = vm.data.requests[vm.data.requests.length - 1];
          vm.data.requests.push(buildRequest(lastRequest.services[lastRequest.services.length - 2].place, lastRequest.services[lastRequest.services.length - 2].depart));
        }
        else {
          lastRequest = request;
          console.log(offset)
          if (!angular.isNumber(offset)) {
            console.log('push')

            lastRequest.services.push(buildService(type));
          }
          else {
            lastRequest.services.splice(lastRequest.services.length + offset, 0, buildService(type));
          }

        }
      }
      function getGoogleDirectionsService() {
        if (angular.isUndefined(vm.googleDirectionsService)) {
          uiGmapGoogleMapApi.then(function (maps) {
            if (angular.isUndefined(vm.maps)) {
              vm.maps = maps;
            }
            vm.googleDirectionsService = new maps.DirectionsService;
            vm.loaded = true;
          });
        }
        else {
          return vm.googleDirectionsService;
        }
        return undefined;
      }
      getGoogleDirectionsService();
      function buildRequest(place, depart) {
        // console.log(place)
        // console.log(depart)
        return {
          services: [
            buildService('pickup', place, depart)
          ],
        }
      }
      function buildService(type, place, depart) {
        // console.log(place)
        // console.log(depart)
        return {
          type: type,
          place: place ? angular.copy(place) : {
            address: '',
            location: { lat: -360, lng: -360 }
          },
          depart: depart ? new Date(depart) : (type === 'pickup' ? new Date() : undefined)
        }
      }
      var gracePeriod = false;
      vm.history = {
        forward: [],
        backward: [],
      };
      vm.undo = function () {
        if (vm.history.backward.length > 0) {
          gracePeriod = true;
          vm.history.forward.push(angular.copy(vm.data.requests));
          vm.data.requests = angular.copy(vm.history.backward.pop());
          //console.log(vm.history.forward);
          $timeout(function () {
            gracePeriod = false;

          }, 0);
        }
      }
      vm.redo = function () {
        if (vm.history.forward.length > 0) {
          gracePeriod = true;
          vm.history.backward.push(angular.copy(vm.data.requests));
          vm.data.requests = angular.copy(angular.copy(vm.history.forward.pop()));
          //console.log(vm.history.forward);
          $timeout(function () {
            gracePeriod = false;

          }, 0);
        }
      }
      vm.pop = function (index) {
        if (index == 0 && vm.data.requests[index].services.length == 1) return;
        if (index !== vm.data.requests.length - 1) {
          if (vm.data.requests[index].services.length === 2) {
            vm.data.requests.splice(index, 1);
          }
          else if (vm.data.requests[index].services.length > 2) {
            vm.data.requests[index].services.splice(vm.data.requests[index].services.length - 2, 1);
          }
        }
        else {
          if (vm.data.requests[index].services.length === 1) {
            vm.data.requests.splice(index, 1);
          }
          else if (vm.data.requests[index].services.length > 1) {
            vm.data.requests[index].services.pop();
          }
        }
      }
      vm.copyText = 'Copia itinerario';
      vm.copy = function () {
        vm.copyText = 'copiato!';
        $timeout(function () {
          vm.copyText = 'Copia itinerario';
        }, 1000);
      }
      vm.showDirections = function(request) {
        $common.showDirections(request);
        vm.showMaps = false;
      }
      vm.getDirectionsLink = $common.getDirectionsLink;
      function getRequestsString(requests) {
        return $common.getRequestFullDescription(requests, vm.data.service_type);
      }
      $scope.$watch(function () { return vm.data.requests }, function (newValue, oldValue, scope) {
        vm.text = getRequestsString(vm.data.requests);
        if (gracePeriod || angular.isUndefined(oldValue)) {
          return;
        }
        //console.log('old')
        //console.log(oldValue);
        gracePeriod = true;
        vm.history.backward.push(angular.copy(oldValue));
        if (vm.history.backward.length > 30) {
          vm.history.backward.splice(0, 5);
        }
        vm.history.forward = [];
        $timeout(function () {
          gracePeriod = false;
        }, 0);
      }, true);
      $scope.$on('directionsError', function (status) {
        // if (status == 'INVALID_REQUEST') {
        //   vm.warning = 8;
        //   resetWarning(2000);
        // }
        if (status == 'ZERO_RESULTS') {
          vm.warning = 9;
          resetWarning(10000);
        }
      })

      function resetWarning(time) {
        $timeout(function () { vm.warning = undefined; }, time);
      }

    };

  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .filter('labelText', labelTextFilter)
    .filter('labelArrive', labelArrive)
    .filter('labelLayover', labelLayover);

  function labelTextFilter() {
    return function(input, label1, label2, label3) {
      if(!input) {
        return label1;
      }
      if(input.length > 7) {
        return label2 + input.substring(0, 7)+'...' + label3;
      }
      return label2 + input + label3;
    }
  }
  /** @ngInject */
  function labelArrive($filter) {
    return function(date, duration, stopover, label1, distance, label2) {
      var distanceLabel = '';
      if (distance) {
        distanceLabel += label2 += $filter('distance')(distance);
      }
      if(!date) {
        return undefined;
      }
      if(stopover > 0) {
        //var tooltip = '<span class="info icon icon-info" tooltips tooltip-template="Il tempo di percorrenza in pullman stimato per questo viaggio è di: ' + $filter('duration')(duration) + '.<br/>A questo tempo vanno aggiunti ' + $filter('duration')(stopover) + ' di pausa, da effettuare durante il viaggio, per la vostra sicurezza. Così come previsto dal regolamento CE n°561/2006" tooltip-side="top"></span>';
        return label1 + $filter('amDateFormat')(date, 'D MMM YYYY, HH:mm') + ' (' + $filter('duration')(duration+stopover)  + ' di viaggio)' + distanceLabel;
      }
      return label1 + $filter('amDateFormat')(date, 'D MMM YYYY, HH:mm') + ' (' + $filter('duration')(duration)  + ' di viaggio)' + distanceLabel;
    }
  }
  /** @ngInject */
  function labelLayover($filter) {
    return function(duration, depart, label1) {
      if(!duration || !depart) {
        return undefined;
      }
      return label1 + $filter('duration')(duration);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brPlannerShuttle', plannerDirective);

  /** @ngInject */
  function plannerDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        data: '=brData',
        onSubmit: '&brOnSubmit',
        lowPassengersAlert: '=?brLowPassengersAlert'
      },
      templateUrl: 'app/elements/planner-shuttle/planner.html',
      controller: 'PlannerShuttleController',
      controllerAs: 'planner',
      bindToController: true
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('PlannerShuttleController', PlannerController);

  /** @ngInject */
  function PlannerController($scope, $state, $timeout, $alert) {
    var vm = this;

    vm.$onInit = function() {
      /**
       * Scope Init
       */
      vm.executed = false;
      vm.test = ['ciao', 'bau']
      vm.MAX_GOOGLE_STEPS = 26;
      vm.MIN_LAYOVER = 9e2;
      vm.MIN_HW_SPEED = 65;
      vm.MAX_VEHICLE_SPEED = 95;

      vm.MAX_DRIVING_TIME_UNINTERRUPTED = 4.5 * 60 * 60;
      vm.STOPOVER_TIME = 45 * 60;
      vm.STOPOVER_TIME_PART1 = 30 * 60;
      vm.STOPOVER_TIME_PART2 = 15 * 60;

      vm.MIN_DEPART_DATE = new Date();
      vm.MIN_DEPART_DATE = new Date(vm.MIN_DEPART_DATE.getTime() + 7*24*60*60*1000);

      vm.BLACK_LISTED = [(new Date('12/31/2017')),(new Date('01/01/2018'))];

      if(angular.isUndefined(vm.data.trip)) {
        vm.data.trip = {
          info: getEmptyInfo(),
          legs: [getEmptyLeg(0, 1)],
          steps: [getEmptyStep(), getEmptyStep()]
        };
      }
      vm.repeat = {minutes: -1, hours: -1};
      vm.timeSteps = {hours: [], minutes: []};
      for (var i = 5; i < 60; i += 5) {
        vm.timeSteps.minutes.push(i);
      }
      for (i = 1; i < 24; i++) {
        vm.timeSteps.hours.push(i);
      }
      vm.temp = [getEmptyTemp()];

      /**
       * Scope Functions
       */

      vm.resetWarning = function(time) {
        $timeout(function() {
          vm.warning = undefined;
        }, time);
      };
      vm.tmpTime = new Date();
      vm.timeCreate = function(time) {
      //console.log(time);
        if (angular.isDate(time)) {
          vm.data.times.push(angular.copy(time));
          vm.tmpTime = new Date(vm.tmpTime.getTime() + 1000 * 60 * 5);
        }
      };

      vm.timeDelete = function() {
        vm.data.times.pop();
      };
      vm.stepCreate = function(step) {
        if(vm.data.trip.steps.length >= vm.MAX_GOOGLE_STEPS) return;

        if(!angular.isDate(vm.data.trip.steps[vm.data.trip.steps.length-1].arrive)) {
          if(angular.isString(vm.data.trip.steps[vm.data.trip.steps.length-2].place.address)) {
            vm.warning = 1;
          }
          else if(!vm.data.trip.steps[vm.data.trip.steps.length-2].depart) {
            vm.warning = 2;
          }
          else if(angular.isString(!vm.data.trip.steps[vm.data.trip.steps.length-1].place.address)) {
            vm.warning = 3;
          }
          else {
            vm.warning = 4;
          }
          vm.resetWarning(5000);
          return;
        }

        var leg = step-1;

        insert(step, getEmptyStep(), vm.data.trip.steps);
        if(step > 1) {
          vm.data.trip.steps[step-1].keep = vm.data.trip.steps[step-2].keep;
        }
        insert(leg, getEmptyLeg(step-1, step), vm.data.trip.legs);
        insert(leg, getEmptyTemp(), vm.temp);
      };

      vm.stepDelete = function(step) {
        if(!valid(step, vm.data.trip.steps)) return;
        if(vm.data.trip.steps.length <= 2) return;

        var leg = step-1;
        if(leg < 0) leg = 0;

        vm.data.trip.info.directions.total.duration -= vm.temp[leg].directions.total.duration;
        vm.data.trip.info.directions.total.distance -= vm.temp[leg].directions.total.distance;
        vm.data.trip.info.directions.highway.duration -= vm.temp[leg].directions.highway.duration;
        vm.data.trip.info.directions.highway.distance -= vm.temp[leg].directions.highway.distance;
        vm.data.trip.info.directions.ferry.duration -= vm.temp[leg].directions.ferry.duration;
        vm.data.trip.info.directions.ferry.distance -= vm.temp[leg].directions.ferry.distance;
        vm.data.trip.info.directions.city.duration -= vm.temp[leg].directions.city.duration;
        vm.data.trip.info.directions.city.distance -= vm.temp[leg].directions.city.distance;
        vm.data.trip.info.stopover -= vm.data.trip.legs[leg].stopover;
        vm.data.trip.info.layover -= vm.data.trip.steps[step].layover;

        if(step === 0) {
          vm.data.trip.info.layover -= vm.data.trip.steps[step+1].layover;
          vm.data.trip.steps[step+1].layover = 0;
          vm.data.trip.steps[step+1].arrive = null;
        }
        else if(step === vm.data.trip.steps.length-1) {
          vm.data.trip.info.layover -= vm.data.trip.steps[step-1].layover;
          vm.data.trip.steps[step-1].layover = 0;
          vm.data.trip.steps[step-1].depart = null;
          vm.data.trip.steps[step-1].keep = false;
        }

        remove(step, vm.data.trip.steps);
        remove(leg, vm.data.trip.legs);
        remove(leg, vm.temp);
      };

      vm.switchStep = function(fromStep, toStep) {
        var from = {};
        angular.copy(vm.data.trip.steps[fromStep].place, from);
        vm.data.trip.steps[fromStep].place = vm.data.trip.steps[toStep].place;
        vm.data.trip.steps[toStep].place = from;
      };

      vm.stepPlaceSelect = function(step) {
        //console.log("[CALL] PLANNER - PLACE SELECTED - STEP:", step);
      };

      vm.stepPlaceGeocode = function(step) {
        //console.log("[CALL] PLANNER - PLACE GEOCODED - STEP:", step);
      };

      vm.stepPlaceCompute = function(step) {
        //console.log("[CALL] PLANNER - PLACE COMPUTED - STEP:", step);
        var leg = step-1;

        vm.data.trip.info.directions.total.distance += vm.data.trip.legs[leg].directions.total.distance - vm.temp[leg].directions.total.distance;
        vm.data.trip.info.directions.total.duration += vm.data.trip.legs[leg].directions.total.duration - vm.temp[leg].directions.total.duration;
        vm.data.trip.info.directions.highway.distance += vm.data.trip.legs[leg].directions.highway.distance - vm.temp[leg].directions.highway.distance;
        vm.data.trip.info.directions.highway.duration += vm.data.trip.legs[leg].directions.highway.duration - vm.temp[leg].directions.highway.duration;
        vm.data.trip.info.directions.ferry.distance += vm.data.trip.legs[leg].directions.ferry.distance - vm.temp[leg].directions.ferry.distance;
        vm.data.trip.info.directions.ferry.duration += vm.data.trip.legs[leg].directions.ferry.duration - vm.temp[leg].directions.ferry.duration;
        vm.data.trip.info.directions.city.distance += vm.data.trip.legs[leg].directions.city.distance - vm.temp[leg].directions.city.distance;
        vm.data.trip.info.directions.city.duration += vm.data.trip.legs[leg].directions.city.duration - vm.temp[leg].directions.city.duration;

        angular.copy(vm.data.trip.legs[leg].directions, vm.temp[leg].directions);

        if(!angular.isDate(vm.data.trip.steps[step-1].depart)) return;

        $timeout(function() {
          computeArrive(step);
        }, 0);
      };

      vm.stepDepartChange = function(step) {
        //console.log("[CALL] PLANNER - DEPART CHANGE - STEP:", step);
        $timeout(function() {
          computeArrive(step);
        }, 0);
      };

      vm.passengersChange = function() {
        //console.log("[CALL] PLANNER - PASSENGERS CHANGE");
      }

      vm.setToStart = function(step) {
        vm.data.trip.steps[step].place = vm.data.trip.steps[0].place;
      };

      vm.stepSend = function() {
        if(vm.alert) return;
        if(vm.data.trip.steps.length > vm.MAX_GOOGLE_STEPS) return;
        if(!angular.isDate(vm.data.trip.steps[vm.data.trip.steps.length-1].arrive)) {
          if(!angular.isString(vm.data.trip.steps[vm.data.trip.steps.length-2].place.address)) {
            vm.warning = 1;
            vm.resetWarning(5000);
          }
          else if(!vm.data.trip.steps[vm.data.trip.steps.length-2].depart) {
            vm.warning = 2;
            vm.resetWarning(5000);
          }
          else if(!angular.isString(vm.data.trip.steps[vm.data.trip.steps.length-1].place.address)) {
            vm.warning = 3;
            vm.resetWarning(5000);
          }
          else {
            vm.warning = 4;
            vm.resetWarning(5000);
          }
          return;
        }
        // if(!angular.isNumber(vm.data.onboard.passengers)) {
        //   vm.warning = 5;
        //   vm.resetWarning(5000);
        //   return;
        // }
        // if(vm.data.onboard.passengers < 1) {
        //   vm.warning = 6;
        //   vm.resetWarning(5000);
        //   return;
        // }
        // if(vm.data.onboard.passengers > 9999) {
        //   vm.warning = 7;
        //   vm.resetWarning(5000);
        //   return;
        // }
        //console.log(vm.data);

        var blocked = false;
        var tn = new Date(null).setHours(8, 0, 0, 0);
        for (var s = 0; s < vm.data.trip.steps.length; s++) {
          var ta = new Date(vm.data.trip.steps[s].arrive).setHours(8, 0, 0, 0);
          var td = new Date(vm.data.trip.steps[s].depart).setHours(8, 0, 0, 0);
          for (var i = 0; i < vm.BLACK_LISTED.length; i++) {
            var tb = new Date(vm.BLACK_LISTED[i]).setHours(8, 0, 0, 0);
            if (ta == tn && td == tb) {
              blocked = true;
            } else if (td == tn && ta == tb) {
              blocked = true;
            } else if (ta != tn && td != tn && ta <= tb && tb <= td) {
              blocked = true;
            }
          }
        }

        if(blocked) {
          vm.alert = true;
          $alert.show('Avviso', 'La data da te selezionata è molto richiesta: ci sono pochi autisti disponibili. Non sarà dunque possibile prenotare online. Se desideri un preventivo scrivi ad info@busrapido.com Tieni conto che le tariffe nelle date selezionate possono essere fino a 10 volte superiori alla media.', 'Chiudi', '', false, 0, 0,
            function(cancel) { vm.alert = false; });
          return;
        }
        /*
        if(angular.isNumber(vm.lowPassengersAlert) && vm.data.onboard.passengers < vm.lowPassengersAlert) {
          vm.alert = true;
          $alert.show('Avviso', 'Ti informiamo che i risultati che ti verranno mostrati sono per il noleggio dell\'intero pullman. Pertanto non è possibile l\'acquisto di biglietti singoli. Se desideri continuare premi "Ho capito"', 'Annulla', 'Ho capito', false, 0, 0,
            function(cancel) { vm.alert = false; },
            function(confirm) {
              vm.alert = false;
              sub1();
            });
        }
        else {
          sub1();
        }*/
        sub1();
        function sub1() {
          if(vm.data.trip.legs.length < 2) {
            vm.alert = true;
            $alert.show('Desideri inserire il ritorno?', 'Abbiamo notato che non hai inserito il ritorno a '+vm.data.trip.steps[0].place.address+'. Se hai bisogno di tornare a '+vm.data.trip.steps[0].place.address+' premi "Si, voglio il ritorno"', 'Si, voglio il ritorno', 'No, viaggio di sola andata', false, 0, 0,
              function(cancel) {
                vm.alert = false;
                vm.stepCreate(vm.data.trip.steps.length)
                vm.setToStart(vm.data.trip.legs[vm.data.trip.legs.length-1].to);
              },
              function(confirm) {
                vm.alert = false;
                $timeout(vm.onSubmit, 0);
              });
          }
          else {
            $timeout(vm.onSubmit, 0);
          }
        }
      };

       /**
       * Controller Functions;
       */

      function getEmptyInfo() {
        var temp = {
          stopover: 0,
          layover: 0,
          directions: {
            total: {duration: 0, distance: 0},
            highway: {distance: 0, duration: 0},
            ferry: {distance: 0, duration: 0},
            city: {distance: 0, duration: 0}
          }
        };
        return temp
      }
      function getEmptyStep() {
        var temp = {
          place: {
            address: '',
            location: {lat: -360, lng: -360}
          },
          arrive: null,
          depart: null,
          layover: 0,
          keep: false
        };
        return temp
      }
      function getEmptyLeg(from, to) {
        var temp = {
          from: from,
          to: to,
          stopover: 0,
          directions: {
            total: {duration: 0, distance: 0},
            highway: {distance: 0, duration: 0},
            ferry: {distance: 0, duration: 0},
            city: {distance: 0, duration: 0}
          }
        };
        return temp
      }
      function getEmptyTemp() {
        var temp = {
          directions: {
            total: {duration: 0, distance: 0},
            highway: {distance: 0, duration: 0},
            ferry: {distance: 0, duration: 0},
            city: {distance: 0, duration: 0}
          },
          simulation: {
            uninterruptedDriving: 0,
            drivingInterruption: 0
          }
        };
        return temp
      }

      function computeArrive(step) {
        if(!valid(step-1, vm.data.trip.steps)) return computeArrive(step+1);
        if(!valid(step, vm.data.trip.steps)) return;

        var leg = step-1;

        if(!angular.isNumber(vm.data.trip.legs[leg].directions.total.duration) || vm.data.trip.legs[leg].directions.total.duration <= 0) return;
        if(!angular.isDate(vm.data.trip.steps[step-1].depart)) return;

        if(leg > 0) {
          angular.copy(vm.temp[leg-1].simulation, vm.temp[leg].simulation);
        }
        else {
          vm.temp[leg].simulation = {
            uninterruptedDriving: vm.MAX_DRIVING_TIME_UNINTERRUPTED,
            drivingInterruption: vm.STOPOVER_TIME
          };
        }

        if(leg > 0) {
          vm.data.trip.info.stopover -= vm.data.trip.legs[leg].stopover;
          vm.data.trip.legs[leg].stopover = getStopover(vm.temp[leg].simulation, vm.data.trip.steps[step-1].layover, vm.data.trip.legs[leg].directions.total.duration);
          vm.data.trip.info.stopover += vm.data.trip.legs[leg].stopover;
        }
        else {
          vm.data.trip.info.stopover -= vm.data.trip.legs[leg].stopover;
          vm.data.trip.legs[leg].stopover = getStopover(vm.temp[leg].simulation, 0, vm.data.trip.legs[leg].directions.total.duration);
          vm.data.trip.info.stopover += vm.data.trip.legs[leg].stopover;
        }

        vm.data.trip.steps[step].arrive = roundTime(new Date(vm.data.trip.steps[step-1].depart.getTime() + (vm.data.trip.legs[leg].directions.total.duration + vm.data.trip.legs[leg].stopover) * 1000));
        vm.temp[leg].min = new Date(vm.data.trip.steps[step].arrive.getTime() + vm.MIN_LAYOVER * 1000);
        $scope.$apply();

        if(!angular.isDate(vm.data.trip.steps[step].depart)) return;
        vm.data.trip.info.layover -= vm.data.trip.steps[step].layover;
        vm.data.trip.steps[step].layover = Math.ceil((vm.data.trip.steps[step].depart - vm.data.trip.steps[step].arrive) / 1000);
        vm.data.trip.info.layover += vm.data.trip.steps[step].layover;

        $timeout(function() {computeArrive(step+1)}, 0);
      }

      function roundTime(date) {
        date.setSeconds(0, 0);
        var min = date.getMinutes();
        var dif = 0;
        var mins = [0, 15, 30, 45, 60];

        for(var i = 0; i < mins.length; i++) {
          if(min <= mins[i]) {
            dif = mins[i];
            break;
          }
        }
        if(dif === 0) return date;
        return new Date(date.getTime() + (dif-min) * 6e4);
      }

      function valid(pos, array) {
        if(pos < 0 || pos >= array.length) return false;
        return true;
      }
      function insert(pos, data, array) {
        if(pos === array.length) {
          array.push(data);
        }
        else {
          array.splice(pos, 0, data);
        }
      }
      function remove(pos, array) {
        array.splice(pos, 1);
      }

      function getStopover(simulation, layover, duration) {
        var timeToDrive = duration;
        var totalStopover = 0;

        if(!angular.isObject(simulation) || simulation === null || !angular.isNumber(simulation.drivingInterruption) || !angular.isNumber(simulation.uninterruptedDriving)) {
          simulation = {
            uninterruptedDriving: vm.MAX_DRIVING_TIME_UNINTERRUPTED,
            drivingInterruption: vm.STOPOVER_TIME
          };
        }

        if(layover >= simulation.drivingInterruption) {
          simulation.uninterruptedDriving = vm.MAX_DRIVING_TIME_UNINTERRUPTED;
          simulation.drivingInterruption = vm.STOPOVER_TIME;
        }
        else if(layover >= vm.STOPOVER_TIME_PART1) {
          simulation.drivingInterruption -= vm.STOPOVER_TIME_PART1;
        }
        else if(layover >= vm.STOPOVER_TIME_PART2 && simulation.drivingInterruption > vm.STOPOVER_TIME_PART1) {
          simulation.drivingInterruption -= vm.STOPOVER_TIME_PART2;
        }

        do {
          var dailyDriving = timeToDrive;

          if(dailyDriving > simulation.uninterruptedDriving) {
            dailyDriving = simulation.uninterruptedDriving;
            totalStopover += simulation.drivingInterruption;
            simulation.uninterruptedDriving = vm.MAX_DRIVING_TIME_UNINTERRUPTED;
            simulation.drivingInterruption = vm.STOPOVER_TIME;
          }
          else {
            simulation.uninterruptedDriving -= duration;
          }

          timeToDrive -= dailyDriving;
        }
        while(timeToDrive > 0);

        return totalStopover;
      }

      /**
      * Controller watchers
      */
      $scope.$watch(function() { return vm.data }, function() {
        //console.log("[WATCH] PLANNER - DATA CHANGE", vm.data);

        if(vm.executed) return;
        vm.executed = true;

        if(!angular.isObject(vm.data) || angular.isArray(vm.data) || !angular.isObject(vm.data.trip) || !angular.isArray(vm.data.trip.steps) || !angular.isArray(vm.data.trip.legs)) {
          return;
        }
        for(var i = 0; i < vm.data.trip.legs.length; i++) {
          if(vm.temp.length === i) vm.temp.push({});
          vm.temp[i].directions = {};
          angular.copy(vm.data.trip.legs[i].directions, vm.temp[i].directions);
          vm.temp[i].simulation = {
            uninterruptedDriving: vm.MAX_DRIVING_TIME_UNINTERRUPTED,
            drivingInterruption: vm.STOPOVER_TIME
          };
        }
        var start = new Date(vm.data.trip.steps[0].depart);
        var toAdd = 0;
        if(start < vm.MIN_DEPART_DATE) {
          toAdd = vm.MIN_DEPART_DATE.getDate() - start.getDate();
          if(start.getHours() < vm.MIN_DEPART_DATE.getHours()) {
            toAdd++;
          }
          else if(start.getHours() == vm.MIN_DEPART_DATE.getHours() && start.getMinutes() < vm.MIN_DEPART_DATE.getMinutes()) {
            toAdd++;
          }
        }
        for(var j = 0; j < vm.data.trip.steps.length; j++) {
          if(vm.data.trip.steps[j].depart) {
            vm.data.trip.steps[j].depart = new Date(vm.data.trip.steps[j].depart);
            if(toAdd > 0) vm.data.trip.steps[j].depart = new Date(vm.data.trip.steps[j].depart.getTime() + (toAdd * 24 * 60 * 60 * 1000));
          }
          if(vm.data.trip.steps[j].arrive) {
            vm.data.trip.steps[j].arrive = new Date(vm.data.trip.steps[j].arrive);
            if(toAdd > 0) vm.data.trip.steps[j].arrive = new Date(vm.data.trip.steps[j].arrive.getTime() + (toAdd * 24 * 60 * 60 * 1000));
          }
        }

        $timeout(function() {computeArrive(1)}, 0);
      }, true);
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brOfferingSupplier', offeringDirective);

  /** @ngInject */
  function offeringDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/elements/offering-supplier/offering.html'
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brHowitoworks', howitworksDirective);

  /** @ngInject */
  function howitworksDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/elements/howitworks/howitworks.html'
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brOffering', offeringDirective);

  /** @ngInject */
  function offeringDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/elements/offering/offering.html'
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brFooter', footerDirective);

  /** @ngInject */
  function footerDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/elements/footer/footer.html'
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brDashboard', dashboardDirective);

  /** @ngInject */
  function dashboardDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        header: '=brHeader',
        action: '=brAction',
        target: '=brTarget',
      },
      controller: 'DashboardBoxController',
      controllerAs: 'vm',
      templateUrl: 'app/elements/dashboard/dashboard.html',
      bindToController: true

    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('DashboardBoxController', DashboardBoxController);

  /** @ngInject */
  function DashboardBoxController($rootScope, $supplier, $timeout) {
    var vm = this;

    vm.$onInit = function() {

    }

  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brConfirmemail', confirmemailDirective);

  /** @ngInject */
  function confirmemailDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/elements/confirmemail/confirmemail.html',
      controller: 'ConfirmemailController',
      controllerAs: 'confirmemail',
      bindToController: true
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('ConfirmemailController', ConfirmemailController);

  /** @ngInject */
  function ConfirmemailController($rootScope, $supplier, $timeout) {
    var vm = this;

    vm.$onInit = function() {
      vm.emailConfirmed = true;
      vm.updating = false;
      vm.sent = '';

      vm.isAuthenticated = $supplier.isAuthenticated;
      $supplier.ready().then(function() {
        if($supplier.current()) {
          vm.emailConfirmed = $supplier.current().email != '';
        }
        vm.sendConfirmation = function() {
          if(!$supplier.isAuthenticated()) return;
          $supplier.sendConfirmation().then(function() {
            vm.sent = $supplier.current().temail;
          });
        }
        vm.updateConfirmation = function() {
          if(!$supplier.isAuthenticated()) return;
          vm.updating = true;
          $supplier.refresh().then(function() {
            $timeout(function () {
              vm.updating = false;
              vm.sent = '';
            }, 500);
          }, function() {
            $timeout(function () {
              vm.updating = false;
            }, 500);
          });
        }

        var unbind2 = $rootScope.$on('$supplierChange', function(event, oldSupplier, newSupplier) {
          if(!$supplier.current()) return;
          vm.emailConfirmed = $supplier.current().email != '';
        });
        $rootScope.$on('$destroy', unbind2);
      });
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brClients', clientsDirective);

  /** @ngInject */
  function clientsDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/elements/clients/clients.html',
      controller: 'ClientsController',
      controllerAs: 'clients',
      bindToController: true
    };

    return directive;
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('ClientsController', ClientsController);

  /** @ngInject */
  function ClientsController($scope, $timeout, $common) {
    var vm = this;

    vm.$onInit = function() {
      function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }
      function randomizeFlow() {
        $timeout(function() {
          vm.peoples = getRandomInt($common.max(95, vm.peoples - getRandomInt(1, 4)), $common.min(135, vm.peoples + getRandomInt(1, 4)));
          randomizeFlow();
        }, 2000 + getRandomInt(0, 3000));
      }
      randomizeFlow();
      vm.peoples = getRandomInt(95, 135);
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('SupplierVehiclesEditController', SupplierVehiclesEditController);

  /** @ngInject */
  function SupplierVehiclesEditController($state, $timeout, $alert, $validator, $error, $supplier, Upload, cloudinary) {
    var vm = this;
    vm.$onInit = function() {
      vm.loaded = false;
      vm.vehicle = {};

      var id = $state.params.id;

      if($validator('id', id) != 1) {
        $state.go('root.it.supplier.vehicles.list');
        return;
      }

      $supplier.getPlaces().then(function(response1) {
        $supplier.getUploadSign().then(function(response2) {
          $supplier.getVehicle(id).then(function(response3) {
            onControllerLoaded(response2, response1, response3);
          }, function(err) {
            var str = $error.get(err, 'api');
            $alert.show(str.title, str.msg, 'Torna ai veicoli', '', true, 0, 5000,
              function(cancel) { $state.go('root.it.supplier.vehicles.list'); });
          });
        }, function(err) {
          var str = $error.get(err, 'api');
          $alert.show(str.title, str.msg, 'Ricarica', '', true, 0, 5000,
            function(cancel) { $state.reload(); });
        });
      }, function(err) {
        var str = $error.get(err, 'api');
        $alert.show(str.title, str.msg, 'Ricarica', '', true, 0, 5000,
          function(cancel) { $state.reload(); });
      });

      function onControllerLoaded(responseUpload, responsePlaces, responseVehicle) {
        function roundToTwo(num) {
          return +(Math.round(num + "e+2")  + "e-2");
        }
        vm.files = [];
        vm.vehicle = responseVehicle.vehicle;

        vm.vehicle.specs.axis = vm.vehicle.specs.axis ? vm.vehicle.specs.axis.toString() : '';
        vm.vehicle.specs.lengthiness = vm.vehicle.specs.lengthiness ? vm.vehicle.specs.lengthiness.toString() : '';
        vm.vehicle.specs.largeness = vm.vehicle.specs.largeness ? vm.vehicle.specs.largeness.toString() : '';
        vm.vehicle.specs.highness = vm.vehicle.specs.highness ? vm.vehicle.specs.highness.toString() : '';
        vm.vehicle.specs.matriculation = vm.vehicle.specs.matriculation ? vm.vehicle.specs.matriculation.toString() : '';
        vm.vehicle.specs.seats.passengers = vm.vehicle.specs.seats.passengers ? vm.vehicle.specs.seats.passengers.toString() : '';
        vm.vehicle.specs.seats.drivers = vm.vehicle.specs.seats.drivers ? vm.vehicle.specs.seats.drivers.toString() : '';

        vm.inputs = {
          places: [],
          axis: [],
          lengthiness: [],
          largeness: [],
          highness: [],
          years: [],
          emissions: [],
          drivers: [],
          passengers: [],
          insurance: [],
          seatbelts: [
            {name: 'all', value: 'all'},
            {name: 'rear', value: 'rear'},
            {name: 'none', value: 'none'}
          ]
        };
        var i = 0;
        for(i = 2; i <= 4; i++) {
          vm.inputs.axis.push({value: i, name: i + ' Assi'});
        }
        for(i = 4.5; i <= 15; i+=0.5) {
          vm.inputs.lengthiness.push({value: roundToTwo(i), name: roundToTwo(i) + ' metri'});
        }
        for(i = 1.80; i <= 3; i+=0.10) {
          vm.inputs.largeness.push({value: roundToTwo(i), name: roundToTwo(i) + ' metri'});
        }
        for(i = 1.80; i <= 4.5; i+=0.10) {
          vm.inputs.highness.push({value: roundToTwo(i), name: roundToTwo(i) + ' metri'});
        }
        var curYear = new Date().getFullYear();
        for(i = curYear; i >= curYear-15; i--) {
          vm.inputs.years.push({value: i, name: 'Anno ' + i});
        }
        for(i = 6; i >= 2; i--) {
          vm.inputs.emissions.push({value: 'EUR'+i, name: 'EURO ' + i});
        }
        for(i = 0; i <= 4; i++) {
          vm.inputs.drivers.push({value: i + 1, name: i + ' Posti'});
        }
        for(i = 3; i <= 120; i++) {
          vm.inputs.passengers.push({value: i, name: i + ' Posti'});
        }
        for(i = 0; i < responsePlaces.places.length; i++) {
          vm.inputs.places.push({value: responsePlaces.places[i]._id, name: responsePlaces.places[i].place.address});
        }

        vm.services = {
          audio: {icon: 'icon-music-player', name: 'Impianto stereo'},
          coffeMachine: {icon: 'icon-coffee-machine', name: 'Macchina del caffè'},
          conditioner: {icon: 'icon-air-conditioner', name: 'Aria condizionata'},
          display: {icon: 'icon-monitor', name: 'Schermo TV'},
          dvdPlayer: {icon: 'icon-dvd', name: 'Lettore DVD'},
          electricity: {icon: 'icon-plug', name: 'Prese elettriche'},
          fridge: {icon: 'icon-fridge', name: 'Mini Frigorifero'},
          kitchen: {icon: 'icon-oven', name: 'Cucina a bordo'},
          leatherSeats: {icon: 'icon-leather', name: 'Sedili in pelle'},
          light: {icon: 'icon-idea', name: 'Luce da lettura'},
          luggage: {icon: 'icon-luggage', name: 'Vano valige'},
          microphone: {icon: 'icon-karaoke', name: 'Microfono'},
          panoramicWindows: {icon: 'icon-window', name: 'Vetri panoramici'},
          radio: {icon: 'icon-radio', name: 'Radio'},
          tintedWindows: {icon: 'icon-window-tinted', name: 'Vetri oscurati'},
          toilet: {icon: 'icon-toilet', name: 'Toilet'},
          tvAerial: {icon: 'icon-television', name: 'Antenna TV'},
          usb: {icon: 'icon-usb', name: 'Carica USB'},
          wheelchair: {icon: 'icon-wheelchair', name: 'Pedana carrozzine'},
          wifi: {icon: 'icon-connection', name: 'Wi-Fi'},
        };

        function resetWarning(time) {
          $timeout(function() { vm.warning = undefined; }, time);
        }

        vm.removeFile = function(idx) {
          vm.files.splice(idx, 1);
          if(vm.files.length == 0) {
            vm.files = null;
            vm.files = [];
          }
        }

        vm.addRule = function() {
          if(!vm.vehicle.costs.rules) {
            vm.vehicle.costs.rules = [];
          }
          if(vm.vehicle.costs.rules.length >= 25) return;
          vm.vehicle.costs.rules.push({
            type: 'kilometric'
          });
        }

        vm.moveRuleUP = function(index) {
          if(!vm.vehicle.costs.rules || vm.vehicle.costs.rules.length < 1 || index < 1 || index >= vm.vehicle.costs.rules.length) return;
          vm.vehicle.costs.rules[index] = vm.vehicle.costs.rules.splice(index-1, 1, vm.vehicle.costs.rules[index])[0];
        }
        vm.moveRuleDOWN = function(index) {
          if(!vm.vehicle.costs.rules || vm.vehicle.costs.rules.length < 1 || index < 0 || index >= vm.vehicle.costs.rules.length-1) return;
          vm.vehicle.costs.rules[index] = vm.vehicle.costs.rules.splice(index+1, 1, vm.vehicle.costs.rules[index])[0];
        }

        vm.removeRule = function(index) {
          if(!vm.vehicle.costs.rules || vm.vehicle.costs.rules.length < 1 || index < 0 || index >= vm.vehicle.costs.rules.length) return;
          vm.vehicle.costs.rules.splice(index, 1);
        }

        vm.updateVehicle = function() {
          if($validator('vehicle', vm.vehicle.specs.manufacturer) === -1) vm.warning = 'Ti sei dimenticato di inserire la marca del veicolo.';
          else if(!$validator('vehicle', vm.vehicle.specs.manufacturer)) vm.warning = 'La marca del veicolo inserita non è valida.';
          else if($validator('vehicle', vm.vehicle.specs.model) === -1) vm.warning = 'Ti sei dimenticato di inserire il modello del veicolo.';
          else if(!$validator('vehicle', vm.vehicle.specs.model)) vm.warning = 'Il modello del veicolo inserito non è valido.';
          else if(!vm.vehicle.specs.axis) vm.warning = 'Ti sei dimenticato di inserire il numero di assi del veicolo.';
          else if($validator('plate', vm.vehicle.specs.plate) === -1) vm.warning = 'Ti sei dimenticato di inserire la targa del veicolo.';
          else if(!$validator('plate', vm.vehicle.specs.plate)) vm.warning = 'La targa del veicolo inserita non è valida.';
          // else if(!vm.vehicle.specs.lengthiness) vm.warning = 'Ti sei dimenticato di inserire la lunghezza del veicolo.';
          // else if(!vm.vehicle.specs.largeness) vm.warning = 'Ti sei dimenticato di inserire la larghezza del veicolo.';
          // else if(!vm.vehicle.specs.highness) vm.warning = 'Ti sei dimenticato di inserire l\'altezza del veicolo.';
          else if(!vm.vehicle.specs.matriculation) vm.warning = 'Ti sei dimenticato di inserire l\'anno di prima immatricolazione del veicolo.';
          else if(!vm.vehicle.specs.emissionClass) vm.warning = 'Ti sei dimenticato di inserire la classe di emissione del veicolo.';
          else if(!vm.vehicle.specs.seats.passengers) vm.warning = 'Ti sei dimenticato di inserire il numero di posti passeggero del veicolo.';
          //else if(!vm.vehicle.specs.seats.drivers) vm.warning = 'Ti sei dimenticato di inserire il numero di posti accompagnatore del veicolo.';
          else if(!vm.vehicle.place_id) vm.warning = 'Ti sei dimenticato di inserire la sede del veicolo.';
          // else if(!vm.files.length && !vm.vehicle.imgs.length) vm.warning = 'Ti sei dimenticato di inserire le immagini del veicolo.';
          else if($validator('costkilometric', vm.vehicle.costs.trip.kilometric) === -1) vm.warning = 'Ti sei dimenticato di inserire il rimborso chilometrico del veicolo.';
          else if(!$validator('costkilometric', vm.vehicle.costs.trip.kilometric)) vm.warning = 'Il rimborso chilometrico del veicolo inserito non è valido. Inserisci un numero compreso tra 0.0 e 5.0';
          else if($validator('costhourly', vm.vehicle.costs.trip.hourly) === -1) vm.warning = 'Ti sei dimenticato di inserire il rimborso orario del veicolo.';
          else if(!$validator('costhourly', vm.vehicle.costs.trip.hourly)) vm.warning = 'Il rimborso orario del veicolo inserito non è valido. Inserisci un numero compreso tra 0.0 e 250.0';
          else if($validator('costdrivers', vm.vehicle.costs.trip.drivers) === -1) vm.warning = 'Ti sei dimenticato di inserire il costo di un\'autista extra per il veicolo.';
          else if(!$validator('costdrivers', vm.vehicle.costs.trip.drivers)) vm.warning = 'Il costo di un\'autista extra per il veicolo inserito non è valido.  Inserisci un numero compreso tra 0.0 e 500.0';
          else if(vm.vehicle.costs.rules) {
            for(var i = 0; i < vm.vehicle.costs.rules.length; i++) {
              if(vm.vehicle.costs.rules[i].type == 'kilometric' && $validator('kms', vm.vehicle.costs.rules[i].from) === -1) vm.warning = 'Ti sei dimenticato di inserire il campo Da di una regola.';
              else if(vm.vehicle.costs.rules[i].type == 'kilometric' && !$validator('kms', vm.vehicle.costs.rules[i].from)) vm.warning = 'Il campo Da inserito di una regola non è valido. Inserisci un numero compreso tra 0.0 a 100000.0.';
              else if(vm.vehicle.costs.rules[i].type == 'kilometric' && $validator('kms', vm.vehicle.costs.rules[i].to) === -1) vm.warning = 'Ti sei dimenticato di inserire il campo A di una regola.';
              else if(vm.vehicle.costs.rules[i].type == 'kilometric' && !$validator('kms', vm.vehicle.costs.rules[i].to)) vm.warning = 'Il campo A inserito di una regola non è valido. Inserisci un numero compreso tra 0.0 a 100000.0.';
              else if(vm.vehicle.costs.rules[i].type == 'hourly' && $validator('hours', vm.vehicle.costs.rules[i].from) === -1) vm.warning = 'Ti sei dimenticato di inserire il campo Da di una regola.';
              else if(vm.vehicle.costs.rules[i].type == 'hourly' && !$validator('hours', vm.vehicle.costs.rules[i].from)) vm.warning = 'Il campo Da inserito di una regola non è valido. Inserisci un numero compreso tra 0.0 a 25000.0.';
              else if(vm.vehicle.costs.rules[i].type == 'hourly' && $validator('hours', vm.vehicle.costs.rules[i].to) === -1) vm.warning = 'Ti sei dimenticato di inserire il campo A di una regola.';
              else if(vm.vehicle.costs.rules[i].type == 'hourly' && !$validator('hours', vm.vehicle.costs.rules[i].to)) vm.warning = 'Il campo A inserito di una regola non è valido. Inserisci un numero compreso tra 0.0 a 25000.0.';
              else if($validator('costkilometric', vm.vehicle.costs.rules[i].kilometric) === -1) vm.warning = 'Ti sei dimenticato di inserire il rimborso chilometrico del veicolo per una regola.';
              else if(!$validator('costkilometric', vm.vehicle.costs.rules[i].kilometric)) vm.warning = 'Il rimborso chilometrico del veicolo inserito per una regola non è valido. Inserisci un numero compreso tra 0.0 e 5.0';
              else if($validator('costhourly', vm.vehicle.costs.rules[i].hourly) === -1) vm.warning = 'Ti sei dimenticato di inserire il rimborso orario del veicolo per una regola.';
              else if(!$validator('costhourly', vm.vehicle.costs.rules[i].hourly)) vm.warning = 'Il rimborso orario del veicolo inserito per una regola non è valido. Inserisci un numero compreso tra 0.0 e 250.0';
              else if(vm.vehicle.costs.rules[i].from >= vm.vehicle.costs.rules[i].to) vm.warning = 'Il campo Da di una regola deve essere più piccolo del corrispettivo campo A.';
              if(vm.warning) break;
            }
          }

          if(vm.warning) {
            resetWarning(5000);
            return;
          }

          for(var j = 0; j < vm.files.length; j++) {
            if(!vm.files[j]) {
              vm.files.splice(j, 1);
              continue;
            }
            if(vm.files[j].$error) {
              vm.warning = vm.files[j].$error;
              resetWarning(5000);
              return;
            }
          }
          // if(!vm.files.length && !vm.vehicle.imgs.length) {
          //   vm.warning = 'Ti sei dimenticato di inserire le immagini del veicolo.';
          //   resetWarning(5000);
          //   return;
          // }

          var toSend = {};
          angular.copy(vm.vehicle, toSend);
          toSend.specs.axis = parseInt(toSend.specs.axis);
          toSend.specs.lengthiness = parseFloat(toSend.specs.lengthiness);
          toSend.specs.largeness = parseFloat(toSend.specs.largeness);
          toSend.specs.highness = parseFloat(toSend.specs.highness);
          toSend.specs.matriculation = parseInt(toSend.specs.matriculation);
          toSend.specs.seats.passengers = parseInt(toSend.specs.seats.passengers);
          toSend.specs.seats.drivers = parseInt(toSend.specs.seats.drivers);

          vm.loaded = false;
          var fileToUpload = vm.files.length;
          if(fileToUpload > 0) {
            angular.forEach(vm.files, function(file) {
              var upload = {};
              angular.copy(responseUpload.upload, upload);
              upload.file = file;
              Upload.upload({
                url: cloudinary.config().cloud_upload,
                data: upload
              }).progress(function (e) {
                file.progress = Math.round((e.loaded * 100.0) / e.total);
              }).success(function (data, status, headers, config) {
                file.result = data;
                toSend.imgs.push(data.public_id);
                fileToUpload--;
                if(fileToUpload === 0) {
                  onUploadComplete();
                }
              }).error(function (data, status, headers, config) {
                var str = $error.get(data);
                vm.warning = str.msg;
                fileToUpload--;
              });
            });
          }
          else {
            onUploadComplete();
          }
          function onUploadComplete() {
            if(vm.warning) {
              vm.loaded = true;
              resetWarning(5000);
              return;
            }
            $supplier.updateVehicle(id, toSend).then(function(vehicle) {
              $state.go($state.current.parent+'.list');
            }, function(err) {
              vm.loaded = true;
              var str = $error.get(err, 'api');
              $alert.show(str.title, str.msg, 'Chiudi', '', true, 0, 5000);
            });
          }
        }
        $timeout(function() { vm.loaded = true; }, 500);
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('SupplierVehiclesController', SupplierVehiclesController);

  /** @ngInject */
  function SupplierVehiclesController($state, $timeout, $alert, $validator, $error, $supplier) {
    var vm = this;
    vm.$onInit = function() {
      vm.loaded = false;
      vm.filters = "enabled";

      $supplier.getVehicles().then(function(response) {
        onControllerLoaded(response);
      }, function(err) {
        var str = $error.get(err, 'api');
        $alert.show(str.title, str.msg, 'Ricarica', '', true, 0, 5000,
          function(cancel) { $state.reload(); });
      });

      function onControllerLoaded(response) {
        vm.vehicles = response.vehicles;
        vm.services = {
          audio: {icon: 'icon-music-player', name: 'Impianto stereo'},
          coffeMachine: {icon: 'icon-coffee-machine', name: 'Macchina del caffè'},
          conditioner: {icon: 'icon-air-conditioner', name: 'Aria condizionata'},
          display: {icon: 'icon-monitor', name: 'Schermo TV'},
          dvdPlayer: {icon: 'icon-dvd', name: 'Lettore DVD'},
          electricity: {icon: 'icon-plug', name: 'Prese elettriche'},
          fridge: {icon: 'icon-fridge', name: 'Mini Frigorifero'},
          kitchen: {icon: 'icon-oven', name: 'Cucina a bordo'},
          leatherSeats: {icon: 'icon-leather', name: 'Sedili in pelle'},
          light: {icon: 'icon-idea', name: 'Luce da lettura'},
          luggage: {icon: 'icon-luggage', name: 'Vano valige'},
          microphone: {icon: 'icon-karaoke', name: 'Microfono'},
          panoramicWindows: {icon: 'icon-window', name: 'Vetri panoramici'},
          radio: {icon: 'icon-radio', name: 'Radio'},
          tintedWindows: {icon: 'icon-window-tinted', name: 'Vetri oscurati'},
          toilet: {icon: 'icon-toilet', name: 'Toilet'},
          tvAerial: {icon: 'icon-television', name: 'Antenna TV'},
          usb: {icon: 'icon-usb', name: 'Carica USB'},
          wheelchair: {icon: 'icon-wheelchair', name: 'Pedana carrozzine'},
          wifi: {icon: 'icon-connection', name: 'Wi-Fi'},
        };
        $timeout(function() { vm.loaded = true; }, 500);

        vm.applyFilter = function(vehicle) {
          if(vm.filters == "enabled" && (vehicle.disabled || vehicle.place_id.disabled) || vm.filters == "disabled" && !vehicle.disabled && !vehicle.place_id.disabled) {
            return false;
          }
          return true;
        };

        vm.setVehicleDisabledState = function(vehicle, state) {
          $supplier.updateVehicle(vehicle._id, {'disabled': state}).then(function(response) {
            vehicle.disabled = response.vehicle.disabled;
          }, function(err) {
            var str = $error.get(err, 'api');
            $alert.show(str.title, str.msg, 'Ricarica', '', true, 0, 5000,
              function(cancel) { $state.reload(); });
          });
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('SupplierVehiclesAddController', SupplierVehiclesAddController);

  /** @ngInject */
  function SupplierVehiclesAddController($state, $timeout, $alert, $validator, $error, $supplier, Upload, cloudinary) {
    var vm = this;
    vm.$onInit = function() {
      vm.loaded = false;

      var id = $state.params.id;

      if(id && $validator('id', id) !== 1) {
        $state.go('root.it.supplier.vehicles.list');
        return;
      }

      $supplier.getPlaces().then(function(response1) {
        $supplier.getUploadSign().then(function(response2) {
          if(!id) {
            onControllerLoaded(response2, response1);
          }
          else {
            $supplier.getVehicle(id).then(function(response3) {
              onControllerLoaded(response2, response1, response3);
            }, function(err) {
              var str = $error.get(err, 'api');
              $alert.show(str.title, str.msg, 'Torna ai veicoli', '', true, 0, 5000,
                function(cancel) { $state.go('root.it.supplier.vehicles.list'); });
            });
          }
        }, function(err) {
          var str = $error.get(err, 'api');
          $alert.show(str.title, str.msg, 'Ricarica', '', true, 0, 5000,
            function(cancel) { $state.reload(); });
        });
      }, function(err) {
        var str = $error.get(err, 'api');
        $alert.show(str.title, str.msg, 'Ricarica', '', true, 0, 5000,
          function(cancel) { $state.reload(); });
      });

      function onControllerLoaded(responseUpload, responsePlaces, responseVehicle) {
        function roundToTwo(num) {
          return +(Math.round(num + "e+2")  + "e-2");
        }
        vm.files = [];
        if(responseVehicle) {
          vm.vehicle = responseVehicle.vehicle;

          vm.vehicle.specs.axis = vm.vehicle.specs.axis.toString();
          vm.vehicle.specs.lengthiness = vm.vehicle.specs.lengthiness.toString();
          vm.vehicle.specs.largeness = vm.vehicle.specs.largeness.toString();
          vm.vehicle.specs.highness = vm.vehicle.specs.highness.toString();
          vm.vehicle.specs.matriculation = vm.vehicle.specs.matriculation.toString();
          vm.vehicle.specs.seats.passengers = vm.vehicle.specs.seats.passengers.toString();
          vm.vehicle.specs.seats.drivers = vm.vehicle.specs.seats.drivers.toString();
        }
        else {
          vm.vehicle = {
            place_id: "",
            specs: {
              seats: {}
            },
            services: {
              audio: false,
              coffeMachine: false,
              conditioner: false,
              display: false,
              dvdPlayer: false,
              electricity: false,
              fridge: false,
              kitchen: false,
              leatherSeats: false,
              light: false,
              luggage: false,
              microphone: false,
              panoramicWindows: false,
              radio: false,
              tintedWindows: false,
              toilet: false,
              tvAerial: false,
              usb: false,
              wheelchair: false,
              wifi: false
            },
            costs: {
              trip: {
                kilometric: 0.5,
                hourly: 50,
                drivers: 200
              },
              rules: [],
              services: {
                audio: {hourly: 0},
                coffeMachine: {hourly: 0},
                conditioner: {hourly: 0},
                display: {hourly: 0},
                dvdPlayer: {hourly: 0},
                electricity: {hourly: 0},
                fridge: {hourly: 0},
                kitchen: {hourly: 0},
                leatherSeats: {hourly: 0},
                light: {hourly: 0},
                luggage: {hourly: 0},
                microphone: {hourly: 0},
                panoramicWindows: {hourly: 0},
                radio: {hourly: 0},
                tintedWindows: {hourly: 0},
                toilet: {hourly: 0},
                tvAerial: {hourly: 0},
                usb: {hourly: 0},
                wheelchair: {hourly: 0},
                wifi: {hourly: 0},
              }
            },
            imgs: []
          };
        }
        vm.inputs = {
          places: [],
          axis: [],
          lengthiness: [],
          largeness: [],
          highness: [],
          years: [],
          emissions: [],
          drivers: [],
          passengers: [],
          insurance: [],
          seatbelts: [
            {name: 'all', value: 'all'},
            {name: 'rear', value: 'rear'},
            {name: 'none', value: 'none'}
          ]
        };
        var i = 0;
        for(i = 2; i <= 4; i++) {
          vm.inputs.axis.push({value: i, name: i + ' Assi'});
        }
        for(i = 4.5; i <= 15; i+=0.5) {
          vm.inputs.lengthiness.push({value: roundToTwo(i), name: roundToTwo(i) + ' metri'});
        }
        for(i = 1.80; i <= 3; i+=0.10) {
          vm.inputs.largeness.push({value: roundToTwo(i), name: roundToTwo(i) + ' metri'});
        }
        for(i = 1.80; i <= 4.5; i+=0.10) {
          vm.inputs.highness.push({value: roundToTwo(i), name: roundToTwo(i) + ' metri'});
        }
        var curYear = new Date().getFullYear();
        for(i = curYear; i >= curYear-15; i--) {
          vm.inputs.years.push({value: i, name: 'Anno ' + i});
        }
        for(i = 6; i >= 2; i--) {
          vm.inputs.emissions.push({value: 'EUR'+i, name: 'EURO ' + i});
        }
        for(i = 0; i <= 4; i++) {
          vm.inputs.drivers.push({value: i + 1, name: i + ' Posti'});
        }
        for(i = 3; i <= 120; i++) {
          vm.inputs.passengers.push({value: i, name: i + ' Posti'});
        }
        for(i = 0; i < responsePlaces.places.length; i++) {
          vm.inputs.places.push({value: responsePlaces.places[i]._id, name: responsePlaces.places[i].place.address});
        }

        vm.services = {
          audio: {icon: 'icon-music-player', name: 'Impianto stereo'},
          coffeMachine: {icon: 'icon-coffee-machine', name: 'Macchina del caffè'},
          conditioner: {icon: 'icon-air-conditioner', name: 'Aria condizionata'},
          display: {icon: 'icon-monitor', name: 'Schermo TV'},
          dvdPlayer: {icon: 'icon-dvd', name: 'Lettore DVD'},
          electricity: {icon: 'icon-plug', name: 'Prese elettriche'},
          fridge: {icon: 'icon-fridge', name: 'Mini Frigorifero'},
          kitchen: {icon: 'icon-oven', name: 'Cucina a bordo'},
          leatherSeats: {icon: 'icon-leather', name: 'Sedili in pelle'},
          light: {icon: 'icon-idea', name: 'Luce da lettura'},
          luggage: {icon: 'icon-luggage', name: 'Vano valige'},
          microphone: {icon: 'icon-karaoke', name: 'Microfono'},
          panoramicWindows: {icon: 'icon-window', name: 'Vetri panoramici'},
          radio: {icon: 'icon-radio', name: 'Radio'},
          tintedWindows: {icon: 'icon-window-tinted', name: 'Vetri oscurati'},
          toilet: {icon: 'icon-toilet', name: 'Toilet'},
          tvAerial: {icon: 'icon-television', name: 'Antenna TV'},
          usb: {icon: 'icon-usb', name: 'Carica USB'},
          wheelchair: {icon: 'icon-wheelchair', name: 'Pedana carrozzine'},
          wifi: {icon: 'icon-connection', name: 'Wi-Fi'},
        };

        function resetWarning(time) {
          $timeout(function() { vm.warning = undefined; }, time);
        }

        vm.removeFile = function(idx) {
          vm.files.splice(idx, 1);
          if(vm.files.length == 0) {
            vm.files = null;
            vm.files = [];
          }
        }

        vm.addRule = function() {
          if(!vm.vehicle.costs.rules) {
            vm.vehicle.costs.rules = [];
          }
          if(vm.vehicle.costs.rules.length >= 25) return;
          vm.vehicle.costs.rules.push({
            type: 'kilometric'
          });
        }

        vm.moveRuleUP = function(index) {
          if(!vm.vehicle.costs.rules || vm.vehicle.costs.rules.length < 1 || index < 1 || index >= vm.vehicle.costs.rules.length) return;
          vm.vehicle.costs.rules[index] = vm.vehicle.costs.rules.splice(index-1, 1, vm.vehicle.costs.rules[index])[0];
        }
        vm.moveRuleDOWN = function(index) {
          if(!vm.vehicle.costs.rules || vm.vehicle.costs.rules.length < 1 || index < 0 || index >= vm.vehicle.costs.rules.length-1) return;
          vm.vehicle.costs.rules[index] = vm.vehicle.costs.rules.splice(index+1, 1, vm.vehicle.costs.rules[index])[0];
        }

        vm.removeRule = function(index) {
          if(!vm.vehicle.costs.rules || vm.vehicle.costs.rules.length < 1 || index < 0 || index >= vm.vehicle.costs.rules.length) return;
          vm.vehicle.costs.rules.splice(index, 1);
        }

        vm.addVehicle = function() {
          if($validator('vehicle', vm.vehicle.specs.manufacturer) === -1) vm.warning = 'Ti sei dimenticato di inserire la marca del veicolo.';
          else if(!$validator('vehicle', vm.vehicle.specs.manufacturer)) vm.warning = 'La marca del veicolo inserita non è valida.';
          else if($validator('vehicle', vm.vehicle.specs.model) === -1) vm.warning = 'Ti sei dimenticato di inserire il modello del veicolo.';
          else if(!$validator('vehicle', vm.vehicle.specs.model)) vm.warning = 'Il modello del veicolo inserito non è valido.';
          else if(!vm.vehicle.specs.axis) vm.warning = 'Ti sei dimenticato di inserire il numero di assi del veicolo.';
          else if($validator('plate', vm.vehicle.specs.plate) === -1) vm.warning = 'Ti sei dimenticato di inserire la targa del veicolo.';
          else if(!$validator('plate', vm.vehicle.specs.plate)) vm.warning = 'La targa del veicolo inserita non è valida.';
          // else if(!vm.vehicle.specs.lengthiness) vm.warning = 'Ti sei dimenticato di inserire la lunghezza del veicolo.';
          // else if(!vm.vehicle.specs.largeness) vm.warning = 'Ti sei dimenticato di inserire la larghezza del veicolo.';
          // else if(!vm.vehicle.specs.highness) vm.warning = 'Ti sei dimenticato di inserire l\'altezza del veicolo.';
          else if(!vm.vehicle.specs.matriculation) vm.warning = 'Ti sei dimenticato di inserire l\'anno di prima immatricolazione del veicolo.';
          else if(!vm.vehicle.specs.emissionClass) vm.warning = 'Ti sei dimenticato di inserire la classe di emissione del veicolo.';
          else if(!vm.vehicle.specs.seats.passengers) vm.warning = 'Ti sei dimenticato di inserire il numero di posti passeggero del veicolo.';
          //else if(!vm.vehicle.specs.seats.drivers) vm.warning = 'Ti sei dimenticato di inserire il numero di posti accompagnatore del veicolo.';
          else if(!vm.vehicle.place_id) vm.warning = 'Ti sei dimenticato di inserire la sede del veicolo.';
          // else if(!vm.files.length && !vm.vehicle.imgs.length) vm.warning = 'Ti sei dimenticato di inserire le immagini del veicolo.';
          else if($validator('costkilometric', vm.vehicle.costs.trip.kilometric) === -1) vm.warning = 'Ti sei dimenticato di inserire il rimborso chilometrico del veicolo.';
          else if(!$validator('costkilometric', vm.vehicle.costs.trip.kilometric)) vm.warning = 'Il rimborso chilometrico del veicolo inserito non è valido. Inserisci un numero compreso tra 0.0 e 5.0';
          else if($validator('costhourly', vm.vehicle.costs.trip.hourly) === -1) vm.warning = 'Ti sei dimenticato di inserire il rimborso orario del veicolo.';
          else if(!$validator('costhourly', vm.vehicle.costs.trip.hourly)) vm.warning = 'Il rimborso orario del veicolo inserito non è valido. Inserisci un numero compreso tra 0.0 e 250.0';
          else if($validator('costdrivers', vm.vehicle.costs.trip.drivers) === -1) vm.warning = 'Ti sei dimenticato di inserire il costo di un\'autista extra per il veicolo.';
          else if(!$validator('costdrivers', vm.vehicle.costs.trip.drivers)) vm.warning = 'Il costo di un\'autista extra per il veicolo inserito non è valido.  Inserisci un numero compreso tra 0.0 e 500.0';
          else if(vm.vehicle.costs.rules) {
            for(var i = 0; i < vm.vehicle.costs.rules.length; i++) {
              if(vm.vehicle.costs.rules[i].type === 'kilometric' && $validator('kms', vm.vehicle.costs.rules[i].from) === -1) vm.warning = 'Ti sei dimenticato di inserire il campo Da di una regola.';
              else if(vm.vehicle.costs.rules[i].type === 'kilometric' && !$validator('kms', vm.vehicle.costs.rules[i].from)) vm.warning = 'Il campo Da inserito di una regola non è valido. Inserisci un numero compreso tra 0.0 a 100000.0.';
              else if(vm.vehicle.costs.rules[i].type === 'kilometric' && $validator('kms', vm.vehicle.costs.rules[i].to) === -1) vm.warning = 'Ti sei dimenticato di inserire il campo A di una regola.';
              else if(vm.vehicle.costs.rules[i].type === 'kilometric' && !$validator('kms', vm.vehicle.costs.rules[i].to)) vm.warning = 'Il campo A inserito di una regola non è valido. Inserisci un numero compreso tra 0.0 a 100000.0.';
              else if(vm.vehicle.costs.rules[i].type === 'hourly' && $validator('hours', vm.vehicle.costs.rules[i].from) === -1) vm.warning = 'Ti sei dimenticato di inserire il campo Da di una regola.';
              else if(vm.vehicle.costs.rules[i].type === 'hourly' && !$validator('hours', vm.vehicle.costs.rules[i].from)) vm.warning = 'Il campo Da inserito di una regola non è valido. Inserisci un numero compreso tra 0.0 a 25000.0.';
              else if(vm.vehicle.costs.rules[i].type === 'hourly' && $validator('hours', vm.vehicle.costs.rules[i].to) === -1) vm.warning = 'Ti sei dimenticato di inserire il campo A di una regola.';
              else if(vm.vehicle.costs.rules[i].type === 'hourly' && !$validator('hours', vm.vehicle.costs.rules[i].to)) vm.warning = 'Il campo A inserito di una regola non è valido. Inserisci un numero compreso tra 0.0 a 25000.0.';
              else if($validator('costkilometric', vm.vehicle.costs.rules[i].kilometric) === -1) vm.warning = 'Ti sei dimenticato di inserire il rimborso chilometrico del veicolo per una regola.';
              else if(!$validator('costkilometric', vm.vehicle.costs.rules[i].kilometric)) vm.warning = 'Il rimborso chilometrico del veicolo inserito per una regola non è valido. Inserisci un numero compreso tra 0.0 e 5.0';
              else if($validator('costhourly', vm.vehicle.costs.rules[i].hourly) === -1) vm.warning = 'Ti sei dimenticato di inserire il rimborso orario del veicolo per una regola.';
              else if(!$validator('costhourly', vm.vehicle.costs.rules[i].hourly)) vm.warning = 'Il rimborso orario del veicolo inserito per una regola non è valido. Inserisci un numero compreso tra 0.0 e 250.0';
              else if(vm.vehicle.costs.rules[i].from >= vm.vehicle.costs.rules[i].to) vm.warning = 'Il campo Da di una regola deve essere più piccolo del corrispettivo campo A.';
              if(vm.warning) break;
            }
          }

          if(vm.warning) {
            resetWarning(5000);
            return;
          }

          for(var j = 0; j < vm.files.length; j++) {
            if(!vm.files[j]) {
              vm.files.splice(j, 1);
              continue;
            }
            if(vm.files[j].$error) {
              vm.warning = vm.files[j].$error;
              resetWarning(5000);
              return;
            }
          }
          // if(!vm.files.length && !vm.vehicle.imgs.length) {
          //   vm.warning = 'Le immagini del veicolo selezionate presentano dei problemi. Riprova.';
          //   resetWarning(5000);
          //   return;
          // }

          var toSend = {};
          angular.copy(vm.vehicle, toSend);
          toSend.specs.axis = parseInt(toSend.specs.axis);
          toSend.specs.lengthiness = parseFloat(toSend.specs.lengthiness);
          toSend.specs.largeness = parseFloat(toSend.specs.largeness);
          toSend.specs.highness = parseFloat(toSend.specs.highness);
          toSend.specs.matriculation = parseInt(toSend.specs.matriculation);
          toSend.specs.seats.passengers = parseInt(toSend.specs.seats.passengers);
          toSend.specs.seats.drivers = parseInt(toSend.specs.seats.drivers);

          vm.loaded = false;
          var fileToUpload = vm.files.length;
          if(fileToUpload > 0) {
            angular.forEach(vm.files, function(file) {
              var upload = {};
              angular.copy(responseUpload.upload, upload);
              upload.file = file;
              Upload.upload({
                url: cloudinary.config().cloud_upload,
                data: upload
              }).progress(function (e) {
                file.progress = Math.round((e.loaded * 100.0) / e.total);
              }).success(function (data, status, headers, config) {
                file.result = data;
                toSend.imgs.push(data.public_id);
                fileToUpload--;
                if(fileToUpload === 0) {
                  onUploadComplete();
                }
              }).error(function (data, status, headers, config) {
                var str = $error.get(data);
                vm.warning = str.msg;
                fileToUpload--;
              });
            });
          }
          else {
            onUploadComplete();
          }
          function onUploadComplete() {
            if(vm.warning) {
              vm.loaded = true;
              resetWarning(5000);
              return;
            }
            $supplier.addVehicle(toSend.place_id, toSend.specs, toSend.services, toSend.costs, toSend.imgs).then(function(vehicle) {
              $state.go($state.current.parent+'.list');
            }, function(err) {
              vm.loaded = true;
              var str = $error.get(err, 'api');
              $alert.show(str.title, str.msg, 'Chiudi', '', true, 0, 5000);
            });
          }
        }
        $timeout(function() { vm.loaded = true; }, 500);
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('SupplierTripsReviewController', SupplierTripsReviewController);

  /** @ngInject */
  function SupplierTripsReviewController($state, $timeout, $alert, $validator, $error, $supplier, $solutions) {
    var vm = this;
    vm.$onInit = function() {
      vm.loaded = false;
      vm.today = new Date();

      var id = $state.params.id;

      if($validator('id', id) != 1) {
        $state.go('root.it.supplier.quotes.list');
        return;
      }

      $supplier.getTrip(id).then(function(response) {
        onControllerLoaded(response);
      }, function(err) {
        var str = $error.get(err, 'api');
        $alert.show(str.title, str.msg, 'Torna alle prenotazioni', '', true, 0, 5000,
          function(cancel) { $state.go('root.it.supplier.quotes.list'); });
      });

      function onControllerLoaded(response) {
        vm.id = id;
        vm.trip = response.trip;
        vm.supplier_id = $supplier.current()._id;

        vm.reviews = 0;
        if(vm.trip.Reviews) {
          for(var j = 0; j < vm.trip.Reviews.length; j++) {
            if((vm.trip.Reviews[j].status == 'tomoderate' || vm.trip.Reviews[j].status == 'published') && vm.trip.Reviews[j].supplier_id == vm.supplier_id && !vm.trip.Reviews[j].answer) {
              vm.reviews++;
            }
          }
        }
        if(!vm.reviews) {
          $state.go('root.it.supplier.trips.details', {id: id});
          return;
        }

        function resetWarning(time) {
          $timeout(function() { vm.warning = undefined; }, time);
        }

        vm.sendReview = function() {
          for(var i = 0; i < vm.trip.Reviews.length; i++) {
            if(vm.trip.Reviews[i].status != 'pending') continue;
            if(!vm.trip.Reviews[i].rating) vm.warning = 'Ti sei dimenticato la valutazione per un partner.';
          }

          if(vm.warning) {
            resetWarning(5000);
            return;
          }

          var toSend = [];
          angular.copy(vm.trip.Reviews, toSend);
          vm.loaded = false;
          sendIt(0);

          function sendIt(i) {
            if(i >= toSend.length) {
              $state.go('root.it.supplier.trips.details', {id: id});
              return;
            }
            if(toSend[i].supplier_id != vm.supplier_id) return sendIt(i+1);
            $supplier.answerReview(toSend[i]._id, toSend[i].answer).then(function(response) {
              sendIt(i+1);
            }, function(err) {
              vm.loaded = true;
              var str = $error.get(err, 'api');
              $alert.show(str.title, str.msg, 'Ricarica', '', false, 0, 0,
                function(cancel) { $state.reload(); });
            });
          }
        };

        vm.solution = $solutions.get(response.trip.Orders);
        vm.loaded = true;
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('SupplierTripsOrderController', SupplierTripsOrderController);

  /** @ngInject */
  function SupplierTripsOrderController($state, $timeout, $alert, $validator, $error, $supplier) {
    var vm = this;
    vm.$onInit = function() {
      vm.loaded = false;
      vm.today = new Date();

      var id = $state.params.id;

      if($validator('id', id) != 1) {
        $state.go('root.it.supplier.quotes.list');
        return;
      }

      $supplier.getOrder(id).then(function(response) {
        onControllerLoaded(response)
      }, function(err) {
        var str = $error.get(err, 'api');
        $alert.show(str.title, str.msg, 'Torna alla prenotazione', '', true, 0, 5000,
          function(cancel) { $state.go('root.it.supplier.quotes.list'); });
      });

      function onControllerLoaded(response) {
        vm.order = response.order;

        vm.emissionClass = {
          EUR0: 'EURO 0',
          EUR1: 'EURO 1',
          EUR2: 'EURO 2',
          EUR3: 'EURO 3',
          EUR4: 'EURO 4',
          EUR5: 'EURO 5',
          EUR6: 'EURO 6'
        }
        vm.services = {
          audio: {icon: 'icon-music-player', name: 'Impianto stereo'},
          coffeMachine: {icon: 'icon-coffee-machine', name: 'Macchina del caffè'},
          conditioner: {icon: 'icon-air-conditioner', name: 'Aria condizionata'},
          display: {icon: 'icon-monitor', name: 'Schermo TV'},
          dvdPlayer: {icon: 'icon-dvd', name: 'Lettore DVD'},
          electricity: {icon: 'icon-plug', name: 'Prese elettriche'},
          fridge: {icon: 'icon-fridge', name: 'Mini Frigorifero'},
          kitchen: {icon: 'icon-oven', name: 'Cucina a bordo'},
          leatherSeats: {icon: 'icon-leather', name: 'Sedili in pelle'},
          light: {icon: 'icon-idea', name: 'Luce da lettura'},
          luggage: {icon: 'icon-luggage', name: 'Vano valige'},
          microphone: {icon: 'icon-karaoke', name: 'Microfono'},
          panoramicWindows: {icon: 'icon-window', name: 'Vetri panoramici'},
          radio: {icon: 'icon-radio', name: 'Radio'},
          tintedWindows: {icon: 'icon-window-tinted', name: 'Vetri oscurati'},
          toilet: {icon: 'icon-toilet', name: 'Toilet'},
          tvAerial: {icon: 'icon-television', name: 'Antenna TV'},
          usb: {icon: 'icon-usb', name: 'Carica USB'},
          wheelchair: {icon: 'icon-wheelchair', name: 'Pedana carrozzine'},
          wifi: {icon: 'icon-connection', name: 'Wi-Fi'},
        };

        vm.loaded = true;
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('SupplierTripsDetailsController', SupplierTripsDetailsController);

  /** @ngInject */
  function SupplierTripsDetailsController($rootScope, $state, $timeout, $alert, $validator, $error, $supplier, $solutions, $segment, $base64) {
    var vm = this;
    vm.$onInit = function() {
      vm.loaded = false;
      vm.today = new Date();
      vm.year = new Date().getFullYear();

      var id = $state.params.id;

      if($validator('id', id) != 1) {
        $state.go('root.it.supplier.quotes.list');
        return;
      }

      $supplier.getTrip(id).then(function(response) {
        onControllerLoaded(response);
      }, function(err) {
        var str = $error.get(err, 'api');
        $alert.show(str.title, str.msg, 'Torna alle prenotazioni', '', true, 0, 5000,
          function(cancel) { $state.go('root.it.supplier.quotes.list'); });
      });

      function onControllerLoaded(response) {
        vm.id = id;
        vm.trip = response.trip;
        vm.supplier_id = $supplier.current()._id;
        vm.acceptable = 0;
        vm.reviews = 0;
        for(var  i = 0; i < vm.trip.Orders.length; i++) {
          if(vm.trip.Orders[i].status == 'pending' && vm.trip.Orders[i].supplier_id == vm.supplier_id) {
            vm.acceptable++;
          }
        }
        if(vm.trip.Reviews) {
          for(var j = 0; j < vm.trip.Reviews.length; j++) {
            if((vm.trip.Reviews[j].status == 'tomoderate' || vm.trip.Reviews[j].status == 'published') && vm.trip.Reviews[j].supplier_id == vm.supplier_id) {
              vm.reviews++;
            }
          }
        }

        vm.emissionClass = {
          EUR0: 'EURO 0',
          EUR1: 'EURO 1',
          EUR2: 'EURO 2',
          EUR3: 'EURO 3',
          EUR4: 'EURO 4',
          EUR5: 'EURO 5',
          EUR6: 'EURO 6'
        }
        vm.services = {
          audio: {icon: 'icon-music-player', name: 'Impianto stereo'},
          coffeMachine: {icon: 'icon-coffee-machine', name: 'Macchina del caffè'},
          conditioner: {icon: 'icon-air-conditioner', name: 'Aria condizionata'},
          display: {icon: 'icon-monitor', name: 'Schermo TV'},
          dvdPlayer: {icon: 'icon-dvd', name: 'Lettore DVD'},
          electricity: {icon: 'icon-plug', name: 'Prese elettriche'},
          fridge: {icon: 'icon-fridge', name: 'Mini Frigorifero'},
          kitchen: {icon: 'icon-oven', name: 'Cucina a bordo'},
          leatherSeats: {icon: 'icon-leather', name: 'Sedili in pelle'},
          light: {icon: 'icon-idea', name: 'Luce da lettura'},
          luggage: {icon: 'icon-luggage', name: 'Vano valige'},
          microphone: {icon: 'icon-karaoke', name: 'Microfono'},
          panoramicWindows: {icon: 'icon-window', name: 'Vetri panoramici'},
          radio: {icon: 'icon-radio', name: 'Radio'},
          tintedWindows: {icon: 'icon-window-tinted', name: 'Vetri oscurati'},
          toilet: {icon: 'icon-toilet', name: 'Toilet'},
          tvAerial: {icon: 'icon-television', name: 'Antenna TV'},
          usb: {icon: 'icon-usb', name: 'Carica USB'},
          wheelchair: {icon: 'icon-wheelchair', name: 'Pedana carrozzine'},
          wifi: {icon: 'icon-connection', name: 'Wi-Fi'},
        };

        vm.acceptAllOrder = function() {
          if(vm.alert) return;
          vm.alert = true;
          var str = 'Confermando tutti gli ordini stipuli un contratto di trasporto con l\'utente finale, che ha per oggetto la prestazione di trasporto così come richiesta, secondo le Condizioni <a href="' + $rootScope.$users + '/it/termini-condizioni/trasporto/">Generali di Trasporto</a>.';
          $alert.show("Accetta tutti gli ordini", str, 'Chiudi', 'Accetta Ordini', true, 0, 0,
            function(cancel) { vm.alert = false; },
            function(success) {
              vm.loaded = false;
              $supplier.acceptTrip(vm.trip._id).then(function(response) {
                vm.alert = false;
                $state.reload();
              }, function(err) {
                vm.alert = false;
                vm.loaded = true;
                var str = $error.get(err, 'api');
                $alert.show(str.title, str.msg, 'Chiudi', '', false, 0, 0);
              });
            });
        }

        vm.rejectAllOrder = function() {
          if(vm.alert) return;
          vm.alert = true;
          var str = 'Rifiutando annullli in modo definitivo tutti gli ordini e l\'intera prenotazione. Sei sicuro di voler rifiutare?';
          $alert.show("Rifiuta tutti gli ordini", str, 'Chiudi', 'Rifiuta Ordini', true, 0, 0,
            function(cancel) { vm.alert = false; },
            function(success) {
              vm.loaded = false;
              $supplier.rejectTrip(vm.trip._id).then(function(response) {
                vm.alert = false;
                $state.reload();
              }, function(err) {
                vm.alert = false;
                vm.loaded = true;
                var str = $error.get(err, 'api');
                $alert.show(str.title, str.msg, 'Chiudi', '', false, 0, 0);
              });
            });
        }

        vm.solution = $solutions.get(response.trip.Orders);
        vm.loaded = true;
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('SupplierTripsController', SupplierTripsController);

  /** @ngInject */
  function SupplierTripsController($state, $timeout, $alert, $validator, $error, $supplier, $solutions) {
    var vm = this;
    vm.$onInit = function() {
      vm.type = $state.params.type;
      vm.order = "-createdAt";
      vm.filters = 'active';
      vm.loaded = false;
      vm.year = new Date().getFullYear();

      $supplier.getTrips().then(function(response) {
        onControllerLoaded(response);
      }, function(err) {
        var str = $error.get(err, 'api');
        $alert.show(str.title, str.msg, 'Ricarica', '', true, 0, 5000,
          function(cancel) { $state.reload(); });
      });

      function onControllerLoaded(response) {
        vm.trips = response.trips;
        vm.emissionClass = {
          EUR0: 'EURO 0',
          EUR1: 'EURO 1',
          EUR2: 'EURO 2',
          EUR3: 'EURO 3',
          EUR4: 'EURO 4',
          EUR5: 'EURO 5',
          EUR6: 'EURO 6'
        }
        vm.services = {
          audio: {icon: 'icon-music-player', name: 'Impianto stereo'},
          coffeMachine: {icon: 'icon-coffee-machine', name: 'Macchina del caffè'},
          conditioner: {icon: 'icon-air-conditioner', name: 'Aria condizionata'},
          display: {icon: 'icon-monitor', name: 'Schermo TV'},
          dvdPlayer: {icon: 'icon-dvd', name: 'Lettore DVD'},
          electricity: {icon: 'icon-plug', name: 'Prese elettriche'},
          fridge: {icon: 'icon-fridge', name: 'Mini Frigorifero'},
          kitchen: {icon: 'icon-oven', name: 'Cucina a bordo'},
          leatherSeats: {icon: 'icon-leather', name: 'Sedili in pelle'},
          light: {icon: 'icon-idea', name: 'Luce da lettura'},
          luggage: {icon: 'icon-luggage', name: 'Vano valige'},
          microphone: {icon: 'icon-karaoke', name: 'Microfono'},
          panoramicWindows: {icon: 'icon-window', name: 'Vetri panoramici'},
          radio: {icon: 'icon-radio', name: 'Radio'},
          tintedWindows: {icon: 'icon-window-tinted', name: 'Vetri oscurati'},
          toilet: {icon: 'icon-toilet', name: 'Toilet'},
          tvAerial: {icon: 'icon-television', name: 'Antenna TV'},
          usb: {icon: 'icon-usb', name: 'Carica USB'},
          wheelchair: {icon: 'icon-wheelchair', name: 'Pedana carrozzine'},
          wifi: {icon: 'icon-connection', name: 'Wi-Fi'},
        };

        for(var i = 0; i < vm.trips.length; i++) {
          vm.trips[i].solution = $solutions.get(vm.trips[i].Orders);
        }

        var now = new Date();
        vm.applyFilter = function(trip) {
          if(vm.filters == "pending" && (trip.status != 'pending' && trip.status != 'waitingtransfer') ||
             vm.filters == "refundpending" && trip.status != 'refundpending' ||
             vm.filters == "accepted" && trip.status != 'accepted' ||
             vm.filters == "rejected" && trip.status != 'rejected' ||
             vm.filters == "voided" && trip.status != 'voided' ||
             vm.filters == "action" && (trip.status != 'waitingtransfer' && trip.status != 'paymentfailed') ||
             vm.filters == "expired" && trip.status != 'expired' ||
             vm.filters == "ended" && (trip.status != 'accepted' || new Date(trip.endedAt) >= now) ||
             vm.filters == "active" && (trip.status == 'rejected' || trip.status == 'voided' || trip.status == 'refundpending' || trip.status == 'expired' || (trip.status == 'accepted' && new Date(trip.endedAt) < now))) {
            return false;
          }
          return true;
        };
        vm.loaded = true;
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('SupplierQuotesController', SupplierQuotesController);

  /** @ngInject */
  function SupplierQuotesController($filter, $scope, $state, $timeout, $alert, $validator, $error, $supplier, $solutions, uiGridConstants, $common, Filtersave, $window) {
    var vm = this;

    vm.reload = function() {
      vm.loaded = false;

      $supplier.isVerified().then(function (response) {
        vm.verified = response.verified;
      });
      vm.search = function (number) {

        var data = [];
        for (var i = 0; i < vm.unfiltered.length; i++) {
          if (vm.unfiltered[i].Quote.number.indexOf(number) !== -1) {
            data.push(vm.unfiltered[i]);
          }
        }
        vm.gridOptions.data = data;
        vm.gridApi.core.refresh();
      }
      vm.numPax = [];
      vm.minPax = 10000;
      vm.maxPax = 0;
      vm.saveFilter = function (filter) {
        //
        $supplier.saveFilter(filter).then(function (response) {
          $alert.show('Salvato', '', '', '', true, 0, 1200);
        });
      }
      vm.hasSubscription = function() {
        var current = $supplier.current();
        if (current.subscription && current.gocardless) {
          return true;
        }
        return false;
      }
      $supplier.getQuotes().then(function (response) {
        vm.current = $supplier.current();

        vm.quotes = response.quotes;
        for (var i = 0; i < response.quotes.length; i++) {
          vm.quotes[i].Quote.partnerTotal = $common.getPartnerPrice(vm.quotes[i].Quote);
          if (angular.isDefined(vm.quotes[i].Quote.onboard)) {
            vm.numPax.push(vm.quotes[i].Quote.onboard.passengers);
            vm.minPax = vm.minPax > vm.quotes[i].Quote.onboard.passengers ? vm.quotes[i].Quote.onboard.passengers : vm.minPax;
            vm.maxPax = vm.maxPax < vm.quotes[i].Quote.onboard.passengers ? vm.quotes[i].Quote.onboard.passengers : vm.maxPax;
            vm.numPax.sort();
          }
          if (angular.isDefined(vm.quotes[i].Quote.requests) && angular.isDefined(vm.quotes[i].Quote.requests[0])) {
            if (angular.isDefined(vm.quotes[i].Quote.requests[0].services)) {
              vm.quotes[i].Quote.pickup = vm.quotes[i].Quote.requests[0].services[0].place.address;
              vm.quotes[i].Quote.dropoff = '';

              for (var j = 0; j < vm.quotes[i].Quote.requests[vm.quotes[i].Quote.requests.length - 1].services.length; j++)
              if (vm.quotes[i].Quote.requests[vm.quotes[i].Quote.requests.length - 1].services[j].place.address)
                vm.quotes[i].Quote.dropoff = vm.quotes[i].Quote.requests[vm.quotes[i].Quote.requests.length - 1].services[j].place.address;
            } else {
              vm.quotes[i].Quote.pickup = '';
              vm.quotes[i].Quote.dropoff = '';
            }
            for (var requestIndex = 0; requestIndex < vm.quotes[i].Quote.requests.length; requestIndex++) {
              var request = vm.quotes[i].Quote.requests[requestIndex];
              for (var serviceIndex = 0; serviceIndex < request.services.length; serviceIndex++) {
                var service = request.services[serviceIndex];
                if (service.depart)
                  vm.quotes[i].Quote.startdate = vm.quotes[i].Quote.startdate ? new Date($common.min(vm.quotes[i].Quote.startdate.getTime(), new Date(service.depart).getTime())) : new Date(service.depart);
                if (service.depart)
                  vm.quotes[i].Quote.enddate = vm.quotes[i].Quote.enddate ? new Date($common.max(vm.quotes[i].Quote.enddate.getTime(), new Date(service.depart).getTime())) : new Date(service.depart);
              }
            }
          }
        }



        vm.pickups = {
          selected: []
        };
        vm.dropoffs = {
          selected: []
        };
        vm.places = $common.places;
        vm.goodPickup = {};
        vm.goodDropoff = {};
        for (var placesIndex = 0; placesIndex < vm.places.length; placesIndex++) {
          vm.goodPickup[vm.places[placesIndex].code] = 0;
          vm.goodDropoff[vm.places[placesIndex].code] = 0;
        }
        for (var quoteIndex = 0; quoteIndex < vm.quotes.length; quoteIndex++) {
          vm.quotes[quoteIndex].Quote.number = $filter('quoteId')(vm.quotes[quoteIndex].Quote.id);
          if (vm.quotes[quoteIndex].Quote.pickup) {
            var addressTokens = vm.quotes[quoteIndex].Quote.pickup.split(/[^\w]/);
            for (var addressIndex = 0; addressIndex < addressTokens.length; addressIndex++) {
              if (vm.goodPickup[addressTokens[addressIndex]] === 0) {
                vm.goodPickup[addressTokens[addressIndex]] = 1;
              }
            }
            addressTokens = vm.quotes[quoteIndex].Quote.dropoff.split(/[^\w]/);
            for (addressIndex = 0; addressIndex < addressTokens.length; addressIndex++) {
              if (vm.goodDropoff[addressTokens[addressIndex]] === 0) {
                vm.goodDropoff[addressTokens[addressIndex]] = 1;
              }
            }
          }
        }
        for (var paxIndex = 1; paxIndex < vm.numPax.length;) {
          if (vm.numPax[paxIndex] == vm.numPax[paxIndex - 1]) {
            vm.numPax.splice(paxIndex, 1);
          } else {
            paxIndex++;
          }
        }
        vm.placePickups = vm.places;
        vm.placeDropoffs = vm.places;
        vm.gridOptions = {
          paginationPageSizes: [20, 40, 80, 120],
          paginationPageSize: 20,
          minRowsToShow: 23,
          enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
          enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
          onRegisterApi: function (gridApi) {
            vm.gridApi = gridApi;
            vm.gridStyle.height = getTableHeight(1, 20, vm.gridOptions.data.length);

            vm.gridApi.grid.handleWindowResize();
            vm.gridApi.core.refresh();

            vm.gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
              vm.gridStyle.height = getTableHeight(newPage, pageSize, vm.gridOptions.data.length);

              vm.gridApi.grid.handleWindowResize();
              vm.gridApi.core.refresh();

            });
          }
        };

        function filterPlaceSelection(unfiltered, field, selected, available) {
          // handle filter changes
          var filtered = [];
          var other = false;
          for (var j = 0; j < selected.length; j++) {
            if (selected[j].code === '') other = true;
          }
          for (var i = 0; i < unfiltered.length; i++) {
            var ok = true;
            if (other) {
              ok = true;
              for (j = 0; j < available.length; j++) {
                if (available[j].code !== '' &&
                  angular.isString(unfiltered[i].Quote[field]) &&
                  unfiltered[i].Quote[field].indexOf(available[j].code) !== -1) {
                  ok = false;
                }
              }
              for (j = 0; j < selected.length; j++) {
                if (selected[j].code !== '' &&
                  angular.isString(unfiltered[i].Quote[field]) &&
                  unfiltered[i].Quote[field].indexOf(selected[j].code) !== -1) {
                  ok = true;
                }
              }
            } else {
              ok = false;
              for (j = 0; j < selected.length; j++) {
                if (selected[j].code !== '' &&
                  angular.isString(unfiltered[i].Quote[field]) &&
                  unfiltered[i].Quote[field].indexOf(selected[j].code) !== -1) {
                  ok = true;
                }
              }
            }
            if (ok) {
              filtered.push(unfiltered[i]);
            }
          }
          return filtered;
        }

        function filterDate(unfiltered, field, min, max) {
          var filtered = [];
          if (!max) {
            if (!min) return unfiltered;
            for (var i = 0; i < unfiltered.length; i++) {
              if (!new Date(unfiltered[i].Quote[field]).getTime) continue;
              if (new Date(unfiltered[i].Quote[field]).getTime() >= min.getTime())
                filtered.push(unfiltered[i]);
            }
          } else if (!min) {
            for (i = 0; i < unfiltered.length; i++) {
              if (!new Date(unfiltered[i].Quote[field]).getTime) continue;
              if (new Date(unfiltered[i].Quote[field]).getTime() <= max.getTime())
                filtered.push(unfiltered[i]);
            }
          } else {
            for (i = 0; i < unfiltered.length; i++) {
              if (!new Date(unfiltered[i].Quote[field]).getTime) continue;
              if (new Date(unfiltered[i].Quote[field]).getTime() <= max.getTime() && new Date(unfiltered[i][field]).getTime() >= min.getTime())
                filtered.push(unfiltered[i]);
            }
          }
          return filtered;
        }

        function filterPassengerNumber(unfiltered, minPassengers, maxPassengers) {
          // handle filter changes
          var filtered = [];
          for (var i = 0; i < unfiltered.length; i++) {
            var pax = unfiltered[i].Quote.onboard.passengers || 0;
            //
            if ((!minPassengers || pax >= minPassengers) && (!maxPassengers || pax <= maxPassengers)) {
              filtered.push(unfiltered[i]);
            }
          }
          return filtered;
        }

        function filterNumber(unfiltered, field, min, max) {
          var filtered = [];
          if (!max) {
            if (!min) return unfiltered;
            for (var i = 0; i < unfiltered.length; i++) {
              if (unfiltered[i].Quote[field] >= min)
                filtered.push(unfiltered[i]);
            }
          } else if (!min) {
            for (i = 0; i < unfiltered.length; i++) {
              if (unfiltered[i].Quote[field] <= max)
                filtered.push(unfiltered[i]);
            }
          } else {
            for (i = 0; i < unfiltered.length; i++) {
              if (unfiltered[i].Quote[field] <= max && unfiltered[i].Quote[field] >= min)
                filtered.push(unfiltered[i]);
            }
          }
          return filtered;
        }

        function filterIn(unfiltered, field, values) {
          var filtered = [];
          var other = false;
          for (var i = 0; i < unfiltered.length; i++) {
            var ok = false;
            var notOk = false;
            for (var j = 0; j < values.length; j++) {
              if (values[j].code === '' && values[j].selected) other = true;
              if (unfiltered[i].Quote[field] === values[j].code) {
                ok = values[j].selected;
                notOk = !values[j].selected;
              }
            }
            if (ok || (!notOk && other))
              filtered.push(unfiltered[i]);
          }
          return filtered;
        }

        function filterContains(unfiltered, field, value) {
          var filtered = [];
          console.log(field)
          for (var i = 0; i < unfiltered.length; i++) {
            console.log(unfiltered[i][field])
            console.log(value)
            if (unfiltered[i][field] && unfiltered[i][field].indexOf(value) !== -1) {
              filtered.push(unfiltered[i])
            }
          }
          console.log(filtered)
          return filtered;
        }

        function filterNotContains(unfiltered, field, value) {
          var filtered = [];
          for (var i = 0; i < unfiltered.length; i++) {
            if (unfiltered[i][field] && unfiltered[i][field].indexOf(value) === -1) {
              filtered.push(unfiltered[i])
            }
          }
          return filtered;
        }

        function filterDeepContains(unfiltered, field, field1, value) {
          var filtered = [];
          for (var i = 0; i < unfiltered.length; i++) {
            if (unfiltered[i][field][field1].indexOf(value) !== -1) {
              filtered.push(unfiltered[i])
            }
          }
          return filtered;
        }

        function filterShow(unfiltered, value) {
          console.log(unfiltered)
          var data = unfiltered;
          data = filterDeepContains(data, 'Quote', 'status', 'public');
          if (value === 'rejected') {
            data = filterContains(data, 'status', 'rejected');
          } else if (value === '') {
            data = filterNotContains(data, 'status', 'rejected');
            data = filterNotContains(data, 'status', 'voided');
          } else {
            data = filterDeepContains(data, 'Quote', 'request_type', value);
          }
          return data;
        }

        function filterAll() {

          var data = filterShow(vm.unfiltered, vm.show);

          var updated = vm.currentFilter.between.find(function (element) {
            return element.field === 'updatedAt';
          });

          data = filterDate(data, 'updatedAt', updated.min, updated.max);

          var serviceType = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'service_type';
          });

          data = filterIn(data, 'service_type', serviceType.values);

          //console.log(startdateData)
          var passengers = vm.currentFilter.between.find(function (element) {
            return element.field === 'passengers';
          });
          data = filterPassengerNumber(data, passengers.min, passengers.max);


          var start = vm.currentFilter.between.find(function (element) {
            return element.field === 'startdate';
          });
          data = filterDate(data, 'startdate', start.min, start.max);


          //console.log(data);
          //console.log(enddateData)
          var end = vm.currentFilter.between.find(function (element) {
            return element.field === 'enddate';
          });
          data = filterDate(data, 'enddate', end.min, end.max);


          //console.log(data);
          var pickup = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'pickup';
          });


          data = filterPlaceSelection(data, 'pickup', pickup.values.filter(function (v) {
            return v.selected;
          }), vm.placePickups);


          //console.log(data);
          var dropoff = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'dropoff';
          });

          data = filterPlaceSelection(data, 'dropoff', dropoff.values.filter(function (v) {
            return v.selected;
          }), vm.placeDropoffs);

          var partnerPrice = vm.currentFilter.between.find(function (element) {
            return element.field === 'partnerTotal';
          });
          data = filterNumber(data, 'partnerTotal', partnerPrice.min, partnerPrice.max);

          vm.gridOptions.data = data;
          vm.gridApi.core.refresh();
        }


        $scope.$watch(function () {
          return vm.show;
        }, function () {
          if (vm.gridApi && vm.gridApi.core) {
            filterAll();
          }
        });
        vm.filterData = {};

        vm.export = function () {
          var selected = vm.gridApi.selection.getSelectedRows();

          var csvRow = [
            [
              '"Tipo di Richiesta"',
              '"Numero Prenotazione"',
              '"Tipologia"',
              '"Pax"',
              '"Pick-Up"',
              '"Drop-Off"',
              '"Prezzo"',
              '"Servizio"',
              '"Ora d\'Inizio"',
              '"Data d\'Inizio"',
              '"Ora di Fine"',
              '"Data di Fine"',
            ]
          ];

          function identityFunction(v) {
            return v;
          }
          for (var i = 0; i < selected.length; i++) {
            csvRow.push('"' +
              $common.convertQuoteToCSV(selected[i], [
                ['Quote', 'request_type'],
                ['Quote', '_id'],
                ['Quote', 'service_type'],
                ['Quote', 'onboard', 'passengers'],
                ['Quote', 'pickup'],
                ['Quote', 'dropoff'],
                ['Quote', 'partnerTotal'],
                ['Quote', 'info'],
                ['Quote', 'startdate'],
                ['Quote', 'startdate'],
                ['Quote', 'enddate'],
                ['Quote', 'enddate'],
              ], [
                $filter('requestType'),
                $filter('quoteId'),
                $filter('serviceType'),
                identityFunction,
                identityFunction,
                identityFunction,
                $filter('currency'),
                identityFunction,
                $filter('time'),
                $filter('calendar'),
                $filter('time'),
                $filter('calendar'),
              ]).join('","') + '"')
          }


          var blob = new Blob([csvRow.join('\n')], {
            type: 'text/plain'
          });
          var url = $window.URL;
          vm.url = url.createObjectURL(blob);
          var link = angular.element('<a/>');

          link.css({
            display: 'none'
          });
          link.attr({
            href: url.createObjectURL(blob),
            target: '_blank',
            download: 'Prenotazioni_Busrapido_' + $filter('dates')(new Date()) + '.csv'
          })
          link[0].click();
          // clean up
          link.remove();
          url.revokeObjectURL(blob);
        }

        vm.gridStyle = {
          height: '600px'
        };

        function getTableHeight(currentPage, pageSize, dataLen) {
          var rowHeight = 30; // row height
          var headerHeight = 50; // header height
          var footerHeight = 60; // bottom scroll bar height
          var totalH = 0;
          var totalPage = Math.floor(dataLen / pageSize) + (dataLen % pageSize > 0 ? 1 : 0)
          if (totalPage > 1) {
            if (currentPage < totalPage) {
              totalH = pageSize * rowHeight + headerHeight + footerHeight;
            } else {
              var lastPageSize = dataLen % pageSize;
              if (lastPageSize === 0) {
                totalH = pageSize * rowHeight + headerHeight + footerHeight;
              } else {
                totalH = lastPageSize * rowHeight + headerHeight + footerHeight;
              }
            }

          } else {
            totalH = dataLen * rowHeight + headerHeight + footerHeight;
          }
          return $common.max(totalH, 300) + 'px';
        }
        vm.updateFilters = function () {
          vm.possible = {
            passengers: vm.numPassengers,
            service_type: $common.serviceType
          };
          vm.options = [{
            between: [{
                field: 'passengers',
                type: 'number',
                //values: vm.possible.passengers,
              },
              {
                field: 'partnerTotal',
                type: 'number',
                //values: vm.possible.client_price,
              },
              {
                field: 'updatedAt',
                type: 'date',
              },
              {
                field: 'startdate',
                type: 'date',
              },
              {
                field: 'starttime',
                type: 'time',
                min: 0,
                max: 24
              }, {
                field: 'enddate',
                type: 'date',
              },
              {
                field: 'endtime',
                type: 'time',
                min: 0,
                max: 24
              },
            ],
            equals: [],
            belongs: [{
                field: 'service_type',
                type: 'service',
                values: vm.possible.service_type,
                value: [],
              },
              {
                field: 'dropoff',
                type: 'place',
                values: angular.copy(vm.places),
                value: [],
              },
              {
                field: 'pickup',
                type: 'place',
                values: angular.copy(vm.places),
                value: [],
              },
            ],
            name: 'Filtro creato il ' + $filter('dates')(new Date())
          }];
          vm.filterData.currentFilter = vm.options[0];
          vm.currentFilter = vm.options[0];
          vm.filterData.currentFilter = vm.currentFilter;
          return $supplier.getFilters().then(function (response) {

            vm.options = vm.options.concat(response.filters.map(function (value) {
              for (var i = 0; i < value.between.length; i++) {
                switch (value.between[i].field) {
                  case 'partnerTotal':
                    value.between[i].values = vm.possible.partnerTotal;
                    break;
                  case 'passengers':
                    value.between[i].values = vm.possible.passengers;
                    break;
                  default:
                    break;
                }
                switch (value.between[i].type) {
                  case 'date':
                    value.between[i].min = value.between[i].min ? new Date(value.between[i].min) : value.between[i].min;
                    value.between[i].max = value.between[i].max ? new Date(value.between[i].max) : value.between[i].max;

                    break;
                }
              }
              return value;
            }));
            vm.filterData.options = vm.options;
          }, function (err) {});
        }

        vm.openFilters = function () {
          var value = vm.currentFilter;
          var data;
          for (var i = 0; i < value.between.length; i++) {
            switch (value.between[i].field) {
              case 'passengers':
                data = passengersData;
                break;
              case 'partnerTotal':
                data = partnerPriceData;
                break;
              case 'endtime':
                data = endtimeData;
                break;
              case 'starttime':
                data = starttimeData;
                break;
              case 'startdate':
                data = startdateData;
                break;
              case 'updatedAt':
                data = updatedData;
                break;
              case 'enddate':
                data = enddateData;
                break;
              default:
                data = {};
                break;
            }
          }
          vm.filterData.currentFilter = angular.copy(value);
          Filtersave.show('Gestisci filtri', vm.filterData, undefined, 'Salva sul sito', true, 0, 0,
            function (cancel) {
              // vm.filterData.currentFilter = currentFilter;
            },
            function (response) {
              // in any case update our current filter
              //
              vm.currentFilter = angular.copy(response.filter);
              vm.filterData.currentFilter = vm.currentFilter;
              if (response.action === 'save') {
                vm.saveFilter(vm.currentFilter);
              }
              filterAll();
            });
        }

        var columns = {};
        var startData = {
          label: 'Partenza',
          show: false,
          onFilter: function () {
            startData.show = false;
            filterAll();
          }
        };
        var endData = {
          label: 'Arrivo',
          show: false,
          onFilter: function () {
            endData.show = false;
            filterAll();
          }
        };
        var paxData = {
          minPax: vm.minPax,
          maxPax: vm.maxPax,
          numPax: vm.numPax,
          onFilter: function () {
            this.show = false;
            filterAll();
          }
        };
        var updatedData = {
          label: 'Modificato il',
          filterType: 'between',
          dataType: 'date',
          filterData: vm.filterData,
          field: 'updatedAt',
          show: false,
          onApply: function () {
            updatedData.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },
          sort: {
            direction: uiGridConstants.DESC,
            priority: 0,
          },
        };
        var startdateData = {
          sort: function (col, direction) {


            vm.gridApi.sortColumn(col, direction);
          },
          label: 'Partenza',
          show: false,
          filterType: 'between',
          dataType: 'date',
          filterData: vm.filterData,
          field: 'startdate',
          onApply: function () {
            updatedData.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },
        };
        var enddateData = {

          label: 'Arrivo',
          filterType: 'between',
          dataType: 'date',
          filterData: vm.filterData,
          field: 'enddate',
          show: false,
          onApply: function () {
            updatedData.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },
        };
        var starttimeData = {
          label: 'Partenza',
          show: false,
          filterType: 'between',
          dataType: 'time',
          filterData: vm.filterData,
          field: 'starttime',

          onApply: function () {
            updatedData.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },
        };
        var endtimeData = {

          sort: function (col, direction) {


            vm.gridApi.sortColumn(col, direction);
          },
          label: 'Arrivo',
          filterType: 'between',
          dataType: 'time',
          filterData: vm.filterData,
          field: 'endtime',
          show: false,

          onApply: function () {
            updatedData.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },
        };
        var serviceTypeData = {
          show: false,
          label: 'Tipo di servizio',
          filterType: 'belongs',
          filterData: vm.filterData,
          lang: {
            selectAll: "Seleziona visibili",
            selectNone: "Deseleziona visibili",
            reset: "Riprestina filtri precedenti",
            search: "Cerca...",
            nothingSelected: "Nessun filtro" //default-label is deprecated and replaced with this.
          },
          nameFilter: function (item) {
            if (item.code === '') {
              return 'Altro';
            }
            return item.code;
          },
          field: 'service_type',

          onApply: function () {
            updatedData.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },
        };
        var pickupData = {
          show: false,
          label: 'Pick-up',
          filterType: 'belongs',
          dataType: 'place',
          filterData: vm.filterData,
          lang: {
            selectAll: "Seleziona visibili",
            selectNone: "Deseleziona visibili",
            reset: "Riprestina filtri precedenti",
            search: "Cerca...",
            nothingSelected: "Nessun filtro" //default-label is deprecated and replaced with this.
          },
          nameFilter: function (item) {
            return item.name;
          },
          field: 'pickup',

          onApply: function () {
            updatedData.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },
        };
        var dropoffData = {
          show: false,
          label: 'Drop-off',
          filterType: 'belongs',
          dataType: 'place',
          lang: {
            selectAll: "Seleziona visibili",
            selectNone: "Deseleziona visibili",
            reset: "Riprestina filtri precedenti",
            search: "Cerca...",
            nothingSelected: "Nessun filtro" //default-label is deprecated and replaced with this.
          },
          nameFilter: function (item) {
            return item.name;
          },
          filterData: vm.filterData,
          field: 'dropoff',

          onApply: function () {
            updatedData.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },
        };

        var passengersData = {
          show: false,
          filterType: 'between',
          dataType: 'number',
          filterData: vm.filterData,
          field: 'passengers',
          onApply: function () {
            updatedData.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },
        };
        var partnerPriceData = {
          show: false,
          nameFilter: function (item) {
            return item;
          },
          filterType: 'between',
          dataType: 'number',
          filterData: vm.filterData,
          field: 'partnerTotal',
          onApply: function () {
            updatedData.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },

        };

        var quoteNumberData = {
          show: false,
          label: 'N° Prenotazione',
          filterData: vm.filterData,
          lang: {
            selectAll: "Seleziona visibili",
            selectNone: "Deseleziona visibili",
            reset: "Riprestina filtri precedenti",
            search: "Cerca provincia...",
            nothingSelected: "Nessun filtro" //default-label is deprecated and replaced with this.
          },
          onApply: function () {
            updatedData.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },
          field: 'id',
        };
        function rawSort(a, b, rowA, rowB, direction) {



          var nulls = vm.gridApi.core.sortHandleNulls(a, b);
          if (nulls !== null) {
            return nulls;
          } else {
            if (a === b) {
              return 0;
            }
            if (a > b) {
              return 1;
            }
            if (a < b) {
              return -1;
            }
            return 0;
          }
        }
        columns.requestType = {
          enableColumnMenu: false,
          field: 'Quote.request_type',
          name: 'Tipo di richiesta',
          cellTooltip: true,
          cellTemplate: '<div class="ui-grid-cell-contents"  title="{{row.entity.Quote.request_type + row.entity.Quote.owner_type | onlyTooltip}}"><span class="icon icon-heart heart-red" ng-if="row.entity.Quote.owner_type == \'supplier\'"></span><span class="icon icon-star" ng-if="row.entity.Quote.request_type.indexOf(\'only\') !== -1"></span>{{COL_FIELD CUSTOM_FILTERS}}</div>',
          cellFilter: 'requestType',
          minWidth: 140,
          maxWidth: 150,
        };
        columns.quoteNumber = {
          data: quoteNumberData,
          enableColumnMenu: false,
          field: 'Quote.id',
          name: 'N° prenotazione',
          headerCellTemplate: 'app/components/header-filter/generic.html',
          cellFilter: 'quoteId',
          width: 120,
            cellTemplate: '<div class="ui-grid-cell-contents"  title="{{COL_FIELD CUSTOM_FILTERS}}"><a ui-sref="root.it.supplier.quotes.details({\'id\': COL_FIELD})">{{COL_FIELD CUSTOM_FILTERS}}</a></div>',
        };
        columns.createdAt = {
          enableColumnMenu: false,
          field: 'Quote.createdAt',
          name: 'Data creazione',
          sort: {
            direction: uiGridConstants.DESC,
            priority: 1,
          },
          visible: false,
          cellTooltip: true,
          width: 60,
        };
        columns.serviceType = {
          enableColumnMenu: false,
          field: 'Quote.service_type',
          name: 'Tipologia',
          headerCellTemplate: 'app/components/header-filter/generic.html',
          data: serviceTypeData,

          cellTooltip: true,
          width: 60,
        };
        columns.passengers = {
          enableColumnMenu: false,
          cellTooltip: true,
          field: 'Quote.onboard.passengers',
          headerCellTemplate: 'app/components/header-filter/generic.html',
          name: 'PAX',
          width: 60,
          data: passengersData,
          sortingAlgorithm: rawSort
        };
        columns.pickup = {
          enableColumnMenu: false,
          field: 'Quote.pickup',
          cellTooltip: true,
          name: 'Pick-up',
          minWidth: 120,
          maxWidth: 150,
          // sortable: true,
          headerCellTemplate: 'app/components/header-filter/generic.html',
          data: pickupData,
        };
        columns.dropoff = {
          enableColumnMenu: false,
          field: 'Quote.dropoff',
          cellTooltip: true,
          minWidth: 120,
          maxWidth: 150,
          // sortable: true,
          headerCellTemplate: 'app/components/header-filter/generic.html',
          data: dropoffData,
          name: 'Drop-off',
        };
        columns.partnerPrice = {
          enableColumnMenu: false,
          field: 'Quote.partnerTotal',
          name: 'Prezzo',
          cellTooltip: true,
          cellFilter: 'currency',
          // sortable: true,
          headerCellTemplate: 'app/components/header-filter/generic.html',
          data: partnerPriceData,
          width: 100,
          sortingAlgorithm: rawSort
        };
        columns.info = {
          enableColumnMenu: false,
          field: 'Quote.info',
          cellTooltip: true,
          minWidth: 300,
          name: 'Servizio',
        };
        columns.starttime = {
          enableColumnMenu: false,
          field: 'Quote.startdate',
          cellTooltip: true,
          minWidth: 80,
          maxWidth: 100,
          name: 'Ora d\'inizio',
          cellFilter: 'time',
          headerCellTemplate: 'app/components/header-filter/generic.html',
          sortingAlgorithm: function (a, b, rowA, rowB, direction) {

            var nulls = vm.gridApi.core.sortHandleNulls(a, b);
            if (nulls !== null) {
              return nulls;
            } else {
              if (a === b) {
                return 0;
              }
              if ($filter('time')(a) > $filter('time')(b)) {
                return 1;
              }
              if ($filter('time')(a) < $filter('time')(b)) {
                return -1;
              }
              return 0;
            }
          },
          data: starttimeData
        };
        columns.startdate = {
          enableColumnMenu: false,
          field: 'Quote.startdate',
          cellTooltip: true,
          minWidth: 100,
          maxWidth: 120,
          name: 'Data d\'inizio',
          cellFilter: 'calendar',
          headerCellTemplate: 'app/components/header-filter/generic.html',
          data: startdateData
        };
        columns.endtime = {
          enableColumnMenu: false,
          field: 'Quote.enddate',
          cellTooltip: true,
          minWidth: 80,
          maxWidth: 100,
          name: 'Ora di fine',
          cellFilter: 'time',
          headerCellTemplate: 'app/components/header-filter/generic.html',
          data: endtimeData,
          sortingAlgorithm: function (a, b, rowA, rowB, direction) {

            var nulls = vm.gridApi.core.sortHandleNulls(a, b);
            if (nulls !== null) {
              return nulls;
            } else {
              if (a === b) {
                return 0;
              }
              if ($filter('time')(a) > $filter('time')(b)) {
                return 1;
              }
              if ($filter('time')(a) < $filter('time')(b)) {
                return -1;
              }
              return 0;
            }
          }

          // data: startdateData
        };
        columns.enddate = {
          enableColumnMenu: false,
          cellTooltip: true,
          field: 'Quote.enddate',
          minWidth: 100,
          maxWidth: 120,
          name: 'Data di fine',
          cellFilter: 'calendar',
          headerCellTemplate: 'app/components/header-filter/generic.html',
          data: enddateData
        };
        vm.defaultColumnDefs = [
          columns.requestType,
          columns.quoteNumber,
          columns.createdAt,
          columns.serviceType,
          columns.passengers,
          columns.pickup,
          columns.dropoff,
          /*
            {
              field: 'status',
              name: 'Status',
              cellTemplate: '<div class="ui-grid-cell-contents"  title="TOOLTIP"><span class="tag tag-sm" ng-class="{\'tag-green\':COL_FIELD == \'accepted\', \'tag-yellow\':COL_FIELD == \'hidden\'}">{{COL_FIELD CUSTOM_FILTERS}}</span></div>',
              cellTooltip: true,
              cellFilter: 'adminStatus',
              pinnedLeft: true,
              width: 80,
              sort: {
                direction: uiGridConstants.DESC,
                priority: 3,
              },
            },
          */
          columns.partnerPrice,
          columns.info,
          columns.starttime,
          columns.startdate,
          columns.endtime,
          columns.enddate,
          /*
            {
              field: 'id',
              name: 'Status',
              cellTemplate: '<button class="btn btn-md btn-outline" ng-click="col.colDef.data.onClick(COL_FIELD)"><span class="icon icon-logout"></span>Apri</button>',
              width: 120,
              pinnedRight: true,
              data: {
                onClick: function (id) {
                  $state.go('root.it.admin.quotes.new', { id: id });
                }
              }
            },
          */
        ];
        vm.show = '';
        vm.gridOptions.columnDefs = vm.defaultColumnDefs;
        vm.zoom = 100;
        var referenceColumnDefs = angular.copy(vm.defaultColumnDefs);
        vm.resize = function (percentage) {
          var columnDefs = referenceColumnDefs;
          for (var i = 0; i < columnDefs.length; i++) {
            if (columnDefs[i].width) {
              vm.gridOptions.columnDefs[i].width = columnDefs[i].width * percentage / 100;
            }
            if (columnDefs[i].minWidth) {
              vm.gridOptions.columnDefs[i].minWidth = columnDefs[i].minWidth * percentage / 100;
            }
            if (columnDefs[i].maxWidth) {
              vm.gridOptions.columnDefs[i].maxWidth = columnDefs[i].maxWidth * percentage / 100;
            }
          }
          vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
          if (percentage < 80) {

            vm.gridStyle['font-size'] = (percentage + 10) + '%';
          } else {
            vm.gridStyle['font-size'] = (percentage) + '%';
          }


        }
        vm.unfiltered = angular.copy(vm.quotes);

        vm.gridOptions.data = filterShow(vm.quotes, vm.show);
        vm.updateFilters().then(function (result) {
          vm.loaded = true;
          vm.filtersLoaded = true;
          // vm.gridApi.core.refresh();
        });
      }, function (err) {
        var str = $error.get(err, 'api');
        $alert.show(str.title, str.msg, 'Ricarica', '', true, 0, 5000,
          function (cancel) {
            $state.reload();
          });
      });

    }
    vm.$onInit = function () {
      vm.reload();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('SupplierProfileController', SupplierProfileController);

  /** @ngInject */
  function SupplierProfileController($scope, $rootScope, $state, $supplier, $timeout, $alert, $validator, $error, $document, $window, $common) {
    var vm = this;
    vm.$onInit = function () {
      vm.loaded = false;
      vm.section = $state.params.section;
      vm.type = $state.params.type;
      vm.step = parseInt(vm.section);
      vm.warning = undefined;
      vm.tsupplier = {};
      vm.original = angular.copy($supplier.current());
      vm.user = {
        signup: angular.copy($supplier.current())
      };
      updateStatus($supplier.current());
      //console.log(vm.section)
      //console.log($supplier.current())
      vm.supplier = angular.copy($supplier.current());
      angular.copy(vm.supplier, vm.tsupplier);
      if (vm.tsupplier.temail == '') {
        vm.tsupplier.temail = vm.tsupplier.email;
      }

      function resetWarning(time) {
        $timeout(function () {
          vm.warning = undefined;
        }, time);
      }
      vm.sendConfirmation = function () {
        vm.loaded = false;
        $supplier.sendConfirmation().then(function (response) {
          vm.loaded = true;
        }, function (err) {
          vm.loaded = true;
        });
      }
      vm.saveChanges = function ($event) {
        if (vm.section === 'password') {
          return vm.savePassword();
        }
        var form = ($event && $event.srcElement) || $document.find('form')[0];
        var vehicles = !(vm.step === 8 && !$common.hasOne(vm.user.signup.vehicles.common, vm.user.signup.vehicles.wheelchair));
        if (form.checkValidity() && vehicles) {
          return $supplier.update({
            supplier: vm.user.signup
          }).then(function (user) {
            // $state.go($state.current.parent);
            if (vm.ok2 && vm.ok3 && vm.ok4 && vm.ok5 && vm.ok6 && vm.ok7 && vm.ok8 && vm.ok9) {
              $state.go('root.it.supplier.quotes.list');
            }
            else {
              $state.reload();
            }
          }, function (err) {
            var str = $error.get(err, 'api');
            vm.warning = str.msg;
            resetWarning(5000);
          });
        } else {
          $scope.$broadcast('validated');
          var firstInvalid = form.querySelector('.ng-invalid');
          // if we find one, set focus
          if (firstInvalid) {
            //$document.find('body')[0].animate({
            //  scrollTop: $common.offset([firstInvalid], $window, $document).top
            //});
            $window.scrollBy(0, $common.offset([firstInvalid], $window, $document).top);
            // firstInvalid.focus();
          }
          return false;
        }
      };
      vm.resetChanges = function () {
        $state.reload();
      };
      vm.savePassword = function () {
        if ($validator('password', vm.tsupplier.opsswrd) === -1) vm.warning = 'Ti sei dimenticato di inserire la vecchia password.';
        else if (!$validator('password', vm.tsupplier.opsswrd)) vm.warning = 'La vecchia password inserita non è valida.';
        else if ($validator('password', vm.tsupplier.psswrd) === -1) vm.warning = 'Ti sei dimenticato di inserire la nuova password.';
        else if (!$validator('password', vm.tsupplier.psswrd)) vm.warning = 'La nuova password inserita non è valida.';
        else if ($validator('password', vm.tsupplier.psswrd) === -1) vm.warning = 'Ti sei dimenticato di inserire la nuova password.';
        else if (vm.tsupplier.opsswrd === vm.tsupplier.psswrd) vm.warning = 'La nuova password deve essere differente dalla vecchia.';
        if (vm.warning) {
          resetWarning(5000);
          return false;
        }
        return $supplier.update(vm.tsupplier).then(function (user) {
          vm.warning = 'La password è stata cambiata correttamente.';
          $timeout(function () {
            $state.go('root.it.supplier.profile.name');
          }, 2500);
        }, function (err) {
          var str = $error.get(err, 'api');
          vm.warning = str.msg;
          resetWarning(5000);
        });
      };
      vm.resetPassword = function () {
        $state.go('root.it.supplier.profile.name')
      };
      var unbind = $rootScope.$on('$supplierChange', function (event, oldSupplier, newSupplier) {
        vm.supplier = angular.copy($supplier.current());
        angular.copy(vm.supplier, vm.tsupplier);
        if (vm.tsupplier.temail == '') {
          vm.tsupplier.temail = vm.tsupplier.email;
        }
        updateStatus(vm.supplier);
      });
      vm.navigateTo = function (state) {
        if (!angular.equals(vm.original, vm.user.signup)) {
          var ans = confirm('Changes you made may not be saved');
        }
        else {
          ans = true;
        }
        if (ans)
          $state.go(state);
      }

      function updateStatus(current) {
        //console.log(current);
        vm.ok2 = !$common.getRegistrationStep(current, 2);
        vm.ok3 = !$common.getRegistrationStep(current, 3);
        vm.ok4 = !$common.getRegistrationStep(current, 4);
        vm.ok5 = !$common.getRegistrationStep(current, 5);
        vm.ok6 = !$common.getRegistrationStep(current, 6);
        vm.ok7 = !$common.getRegistrationStep(current, 7);
        vm.ok8 = !$common.getRegistrationStep(current, 8);
        vm.ok9 = !$common.getRegistrationStep(current, 9);
        vm.ok = vm.ok2 && vm.ok3 && vm.ok4 && vm.ok5 && vm.ok6 && vm.ok7 && vm.ok8 && vm.ok9;
      }
      $scope.$on('$destroy', unbind);
      $timeout(function () {
        vm.loaded = true;
      }, 500);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('SupplierPlacesEditController', SupplierPlacesEditController);

  /** @ngInject */
  function SupplierPlacesEditController($state, $timeout, $alert, $validator, $error, $supplier) {
    var vm = this;
    vm.$onInit = function() {
      vm.loaded = false;
      vm.place = {
        place: {
          address: '',
          location: {}
        }
      };

      var id = $state.params.id;

      if($validator('id', id) != 1) {
        $state.go('root.it.supplier.places.list');
        return;
      }

      $supplier.getPlace(id).then(function(response) {
        onControllerLoaded(response);
      }, function(err) {
        var str = $error.get(err, 'api');
        $alert.show(str.title, str.msg, 'Torna alle sedi', '', true, 0, 5000,
          function(cancel) { $state.go('root.it.supplier.places.list'); });
      });

      function onControllerLoaded(response) {
        vm.place = response.place;

        function resetWarning(time) {
          $timeout(function() { vm.warning = undefined; }, time);
        }
        vm.updatePlace = function() {
          if($validator('place', vm.place.place) === -1) vm.warning = 'Ti sei dimenticato di inserire l\'indirizzo della nuova sede.';
          else if(!$validator('place', vm.place.place)) vm.warning = 'L\'indirizzo della nuova sede inserito non è valido.';

          if(vm.warning) {
            resetWarning(5000);
            return;
          }

          $supplier.updatePlace(vm.place._id, vm.place).then(function(response) {
            $state.go($state.current.parent+'.list');
          }, function(err) {
            var str = $error.get(err, 'api');
            $alert.show(str.title, str.msg, 'Chiudi', '', true, 0, 5000);
          });
        }
        $timeout(function() { vm.loaded = true; }, 500);
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('SupplierPlacesController', SupplierPlacesController);

  /** @ngInject */
  function SupplierPlacesController($state, $timeout, $alert, $validator, $error, $supplier) {
    var vm = this;
    vm.$onInit = function() {
      vm.loaded = false;
      vm.filters = "enabled";

      $supplier.getPlaces().then(function(response) {
        onControllerLoaded(response);
      }, function(err) {
        var str = $error.get(err, 'api');
        $alert.show(str.title, str.title, 'Ricarica', '', true, 0, 5000,
          function(cancel) { $state.reload(); });
      });

      function onControllerLoaded(response) {
        vm.places = response.places;

        $supplier.ready().then(function() {
          vm.activated = $supplier.current().temail == '';
          vm.loaded = true;
        });

        vm.applyFilter = function(place) {
          if(vm.filters == "enabled" && place.disabled || vm.filters == "disabled" && !place.disabled) {
            return false;
          }
          return true;
        };

        vm.setPlaceDisabledState = function(place, state) {
          $supplier.updatePlace(place._id, {'disabled': state}).then(function(response) {
            place.disabled = response.place.disabled;
          }, function(err) {
            var str = $error.get(err, 'api');
            $alert.show(str.title, str.title, 'Ricarica', '', true, 0, 5000,
              function(cancel) { $state.reload(); });
          });
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('SupplierPlacesAddController', SupplierPlacesAddController);

  /** @ngInject */
  function SupplierPlacesAddController($state, $timeout, $alert, $validator, $error, $supplier) {
    var vm = this;
    vm.$onInit = function() {
      vm.loaded = false;
      vm.activated = true;
      vm.place = {
        address: '',
        location: {}
      };

      function resetWarning(time) {
        $timeout(function() { vm.warning = undefined; }, time);
      }

      vm.addPlace = function() {
        if($validator('place', vm.place) === -1) vm.warning = 'Ti sei dimenticato di inserire l\'indirizzo della nuova sede.';
        else if(!$validator('place', vm.place)) vm.warning = 'L\'indirizzo della nuova sede inserito non è valido.';

        if(vm.warning) {
          resetWarning(5000);
          return;
        }

        $supplier.addPlace(vm.place).then(function(response) {
          $state.go($state.current.parent+'.list');
        }, function(err) {
          var str = $error.get(err, 'api');
          $alert.show(str.title, str.msg, 'Chiudi', '', true, 0, 5000);
        });
      }
      $supplier.ready().then(function() {
        // vm.activated = $supplier.current().temail == '';
        vm.loaded = true;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('DetailsController', DetailsController);

  /** @ngInject */
  function DetailsController($scope, $state, $timeout, $alert, $validator, $error, $supplier, $solutions, cloudinary, Vehiclepicker, $segment, $common) {
    var vm = this;
    vm.$onInit = function () {
      vm.loaded = false;
      if (angular.isUndefined($state.params.id)) {
        $state.go($state.current.parent)
      }
      function refresh() {
        $supplier.getQuote($state.params.id).then(function (response) {
          vm.quote = response.quote;
          vm.loaded = true;
        }, function (err) {
          var str = $error.get(err, 'api');
          $alert.show(str.title, str.msg, 'Ricarica', '', true, 0, 5000,
            function (cancel) { $state.reload(); });
        });
        $supplier.getVehicles().then(function (response) {
          vm.vehicles = response.vehicles;
        }, function (err) {

        });
      }
      refresh();
      $scope.$on('respond', function (event, data) {
        var reason = data.reason;
        var response = data.response;
        if (vm.working) return;

        vm.working = true;
        if (response.indexOf('rejected') === -1) {
          if (vm.vehicles) {
            pickVehicle(response);
          }
          else {
            $supplier.getVehicles().then(function (response2) {
              vm.vehicles = response2.vehicles;
              pickVehicle(response);
            }, function (err) {
              vm.working = false;

              var str = $error.get(err, 'api');
              $alert.show(str.title, str.msg, 'Ricarica', '', true, 0, 5000,
                function (cancel) { $state.reload(); });

            });
          }
        }
        else {
          $segment.track('[REQUESTS] Partner wants to refuse because: ' + response);
          $supplier.respondQuote(vm.quote.quote_id, { response: response, reason: reason }).then(function (response) {
            vm.working = false;

            refresh();
          }, function (err) {
            var str = $error.get(err, 'api');
            vm.working = false;

            $alert.show(str.title, str.msg, 'Ricarica', '', true, 0, 5000,
              function (cancel) { $state.reload(); });
          });

        }

        function pickVehicle(response) {
          if (response === 'optioned')
            $segment.track('[REQUESTS] Vehicle selection, partner wants to option');
          else
            $segment.track('[REQUESTS] Vehicle selection, partner wants to accept');
          var requested = vm.quote.Quote.onboard.passengers + vm.quote.Quote.onboard.others;
          if (vm.quote.Quote.vehicle.specs && vm.quote.Quote.vehicle.specs.seats && vm.quote.Quote.vehicle.specs.seats.passengers > requested) {
            requested = vm.quote.Quote.vehicle.specs.seats.passengers;
          }
          Vehiclepicker.show(response === 'optioned' ? 'Seleziona un veicolo da opzionare' : 'Assegna un veicolo per accettare', getCompliant(vm.vehicles), getNonCompliant(vm.vehicles), requested, 'Annulla', '', true, 0, 0,
            function (cancel) {
              vm.working = false;

            },
            function (vehicles) {
              var selected = [];
              for (var i = 0; i < vehicles.length; i++) {
                if (vehicles[i].selected) {
                  selected.push(vehicles[i].id);
                }
              }

              $supplier.respondQuote(vm.quote.quote_id, { response: response, vehicle_id: vehicles[0].id, vehicles: selected, requestString:   $common.getRequestFullDescription(vm.quote.Quote.requests, vm.quote.Quote.service_type) }).then(function (response) {
                $segment.track('[REQUESTS] Vehicle selected, request completed');
                vm.working = false;
                refresh();
              }, function (err) {
                var str = $error.get(err, 'api');
                vm.working = false;
                $alert.show(str.title, str.msg, 'Ricarica', '', true, 0, 5000,
                  function (cancel) { $state.reload(); });
              });
            });
        }
        function getCompliant(vehicles) {
          return vehicles.filter(function (vehicle) {
            return isCompliant(vehicle);
          });
        }
        function getNonCompliant(vehicles) {
          return vehicles.filter(function (vehicle) {
            return !isCompliant(vehicle);
          });
        }
        function isCompliant(vehicle) {
          if (vm.quote.Quote.vehicle) {
            if (vm.quote.Quote.vehicle.specs) {
              var keys = Object.keys(vm.quote.Quote.vehicle.specs)
              for (var i = 0; i < keys.length; i++) {
                var key = keys[i];

                if (key === 'seats') {
                  /*
                  if (vm.quote.Quote.vehicle.specs[key].drivers > vehicle.specs[key].drivers || vm.quote.Quote.vehicle.specs[key].passengers > vehicle.specs[key].passengers) {
                    return false;
                  }
                  */
                }
                else if (key === 'emissionClass') {


                  if (vm.quote.Quote.vehicle.specs[key].substring(0, 3) === 'EUR') {


                    if (parseInt(vm.quote.Quote.vehicle.specs[key][3]) > parseInt(vehicle.specs[key][3])) {
                      return false;
                    }
                  }
                }
                else {
                  if (vm.quote.Quote.vehicle.specs[key] > vehicle.specs[key]) {
                    return false;
                  }
                }
              }
            }
            if (vm.quote.Quote.vehicle.services) {
              keys = Object.keys(vm.quote.Quote.vehicle.services)
              for (i = 0; i < keys.length; i++) {
                key = keys[i];
                if (vm.quote.Quote.vehicle.services[key] && !vehicle.services[key]) {
                  return false;
                }
              }
            }
          }
          return true;
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('SupplierCredentialsController', SupplierCredentialsController);

  /** @ngInject */
  function SupplierCredentialsController($rootScope, $scope, $state, $supplier, $base64, $common) {
    var vm = this;
    vm.$onInit = function() {
      var redirect = {};
      if(angular.isString($state.params.goto) && $state.params.goto != '') {
        var string = decodeURIComponent(escape($base64.decode($state.params.goto)));
        try {
          redirect = angular.fromJson(string);
        }
        catch(err) {
          $state.go('root.it.supplier.signin', {goto: ''}, {reload: true});
          return;
        }
      }

      vm.data = $state.params;
      vm.mode = $state.params.mode || 'signup';

      vm.onAuthModeChange = function() {
        $state.go($state.current.parent + '.' + vm.mode);
      }

      if($supplier.isAuthenticated()) {


        if (redirect.name) {
          $state.go(redirect.name, redirect.params || {});
        }
        else {
          $common.load($supplier.current());
        }
        return;
      }

      var unbind = $rootScope.$on('$supplierChange', function(event, oldSupplier, newSupplier) {
        if($supplier.isAuthenticated()) {

          if (redirect.name) {
            $state.go(redirect.name, redirect.params || {});
          }
          else {
            $common.load($supplier.current());
          }
        }
      });
      $scope.$on('$destroy', unbind);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('SupplierConfirmController', SupplierConfirmController);

  /** @ngInject */
  function SupplierConfirmController($state, $timeout, $validator, $supplier) {
    var vm = this;
    vm.$onInit = function() {
      vm.loaded = false;

      var id = $state.params.id;
      if($validator('id', id) != 1) {
        $state.go('root.it.supplier.profile.name');
        return;
      }

      vm.sendConfirmation = function() {
        vm.loaded = false;
        $supplier.sendConfirmation().then(function(response) {
          $state.go('root.it.supplier.profile.name');
        }, function(err) {
          $state.go('root.it.supplier.profile.name');
        });
      }
      $supplier.ready().then(function() {
        if($supplier.current().temail == '') {
          vm.already = true;
          onControllerLoaded();
        }
        else {
          $supplier.confirm($state.params.token).then(function(response) {
            vm.confirmed = true;
            onControllerLoaded();
          }, function(err) {
            vm.failed = true;
            onControllerLoaded();
          });
        }
      });

      function onControllerLoaded() {
        vm.loaded = true;
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('SupplierAcceptedController', SupplierAcceptedController);

  /** @ngInject */
  function SupplierAcceptedController($filter, $scope, $state, $timeout, $alert, $validator, $error, $supplier, $solutions, uiGridConstants, $common, $window, Filtersave) {
    var vm = this;
    vm.$onInit = function () {
      vm.loaded = false;
      $supplier.isVerified().then(function (response) {
        vm.verified = response.verified;
      });
      vm.search = function (number) {

        var data = [];
        for (var i = 0; i < vm.unfiltered.length; i++) {
          if (vm.unfiltered[i].Quote.number.indexOf(number) !== -1) {
            data.push(vm.unfiltered[i]);
          }
        }
        vm.gridOptions.data = data;
        vm.gridApi.core.refresh();
      }

      vm.hasSubscription = function() {
        var current = $supplier.current();
        if (current.subscription && current.gocardless) {
          return true;
        }
        return false;
      }
      vm.numPax = [];
      vm.minPax = 10000;
      vm.maxPax = 0;
      vm.saveFilter = function (filter) {
        //
        $supplier.saveFilter(filter).then(function (response) {
          $alert.show('Salvato', '', '', '', true, 0, 1200);
        });
      }
      $supplier.getQuotes().then(function (response) {


        vm.quotes = response.quotes;
        for (var i = 0; i < response.quotes.length; i++) {
          vm.quotes[i].Quote.partnerTotal = $common.getPartnerPrice(vm.quotes[i].Quote);
          if (angular.isDefined(vm.quotes[i].Quote.onboard)) {
            vm.numPax.push(vm.quotes[i].Quote.onboard.passengers);
            vm.minPax = vm.minPax > vm.quotes[i].Quote.onboard.passengers ? vm.quotes[i].Quote.onboard.passengers : vm.minPax;
            vm.maxPax = vm.maxPax < vm.quotes[i].Quote.onboard.passengers ? vm.quotes[i].Quote.onboard.passengers : vm.maxPax;
            vm.numPax.sort();
          }
          if (angular.isDefined(vm.quotes[i].Quote.requests) && angular.isDefined(vm.quotes[i].Quote.requests[0])) {
            if (angular.isDefined(vm.quotes[i].Quote.requests[0].services)) {
              vm.quotes[i].Quote.pickup = vm.quotes[i].Quote.requests[0].services[0].place.address;
              vm.quotes[i].Quote.dropoff = '';

              for (var j = 0; j < vm.quotes[i].Quote.requests[vm.quotes[i].Quote.requests.length - 1].services.length; j++)
                  if (vm.quotes[i].Quote.requests[vm.quotes[i].Quote.requests.length - 1].services[j].place.address)
                    vm.quotes[i].Quote.dropoff = vm.quotes[i].Quote.requests[vm.quotes[i].Quote.requests.length - 1].services[j].place.address;

            } else {
              vm.quotes[i].Quote.pickup = '';
              vm.quotes[i].Quote.dropoff = '';
            }
            for (var requestIndex = 0; requestIndex < vm.quotes[i].Quote.requests.length; requestIndex++) {
              var request = vm.quotes[i].Quote.requests[requestIndex];
              for (var serviceIndex = 0; serviceIndex < request.services.length; serviceIndex++) {
                var service = request.services[serviceIndex];
                vm.quotes[i].Quote.startdate = vm.quotes[i].Quote.startdate ? new Date($common.min(vm.quotes[i].Quote.startdate.getTime(), new Date(service.depart).getTime())) : new Date(service.depart);
                vm.quotes[i].Quote.enddate = vm.quotes[i].Quote.enddate ? new Date($common.max(vm.quotes[i].Quote.enddate.getTime(), new Date(service.depart).getTime())) : new Date(service.depart);
              }
            }
          }
        }



        vm.pickups = {
          selected: []
        };
        vm.dropoffs = {
          selected: []
        };
        vm.places = $common.places;
        vm.goodPickup = {};
        vm.goodDropoff = {};
        for (var placesIndex = 0; placesIndex < vm.places.length; placesIndex++) {
          vm.goodPickup[vm.places[placesIndex].code] = 0;
          vm.goodDropoff[vm.places[placesIndex].code] = 0;
        }
        for (var quoteIndex = 0; quoteIndex < vm.quotes.length; quoteIndex++) {
          vm.quotes[quoteIndex].Quote.number = $filter('quoteId')(vm.quotes[quoteIndex].Quote.id);
          if (vm.quotes[quoteIndex].Quote.pickup) {
            var addressTokens = vm.quotes[quoteIndex].Quote.pickup.split(/[^\w]/);
            for (var addressIndex = 0; addressIndex < addressTokens.length; addressIndex++) {
              if (vm.goodPickup[addressTokens[addressIndex]] === 0) {
                vm.goodPickup[addressTokens[addressIndex]] = 1;
              }
            }
            addressTokens = vm.quotes[quoteIndex].Quote.dropoff.split(/[^\w]/);
            for (addressIndex = 0; addressIndex < addressTokens.length; addressIndex++) {
              if (vm.goodDropoff[addressTokens[addressIndex]] === 0) {
                vm.goodDropoff[addressTokens[addressIndex]] = 1;
              }
            }
          }
        }

        for (var paxIndex = 1; paxIndex < vm.numPax.length;) {
          if (vm.numPax[paxIndex] == vm.numPax[paxIndex - 1]) {
            vm.numPax.splice(paxIndex, 1);
          } else {
            paxIndex++;
          }
        }
        vm.placePickups = vm.places;
        vm.placeDropoffs = vm.places;
        vm.gridOptions = {
          paginationPageSizes: [20, 40, 80, 120],
          paginationPageSize: 20,
          minRowsToShow: 23,
          enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
          enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
          onRegisterApi: function (gridApi) {
            vm.gridApi = gridApi;
            vm.gridStyle.height = getTableHeight(1, 20, vm.gridOptions.data.length);

            vm.gridApi.grid.handleWindowResize();
            vm.gridApi.core.refresh();

            vm.gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
              vm.gridStyle.height = getTableHeight(newPage, pageSize, vm.gridOptions.data.length);

              vm.gridApi.grid.handleWindowResize();
              vm.gridApi.core.refresh();

            });
          }
        };

        function filterRange(unfiltered, field, lower, upper) {
          var filtered = [];
          for (var j = 0; j < unfiltered.length; j++) {
            if (unfiltered[j].Quote[field] > lower && unfiltered[j].Quote[field] < upper) {

            }
          }
        }

        function filterPlaceSelection(unfiltered, field, selected, available) {
          // handle filter changes
          var filtered = [];
          var other = false;
          for (var j = 0; j < selected.length; j++) {
            if (selected[j].code === '') other = true;
          }
          for (var i = 0; i < unfiltered.length; i++) {
            var ok = true;
            if (other) {
              ok = true;
              for (j = 0; j < available.length; j++) {
                if (available[j].code !== '' &&
                  angular.isString(unfiltered[i].Quote[field]) &&
                  unfiltered[i].Quote[field].indexOf(available[j].code) !== -1) {
                  ok = false;
                }
              }
              for (j = 0; j < selected.length; j++) {
                if (selected[j].code !== '' &&
                  angular.isString(unfiltered[i].Quote[field]) &&
                  unfiltered[i].Quote[field].indexOf(selected[j].code) !== -1) {
                  ok = true;
                }
              }
            } else {
              ok = false;
              for (j = 0; j < selected.length; j++) {
                if (selected[j].code !== '' &&
                  angular.isString(unfiltered[i].Quote[field]) &&
                  unfiltered[i].Quote[field].indexOf(selected[j].code) !== -1) {
                  ok = true;
                }
              }
            }
            if (ok) {
              filtered.push(unfiltered[i]);
            }
          }
          return filtered;
        }

        function filterDate(unfiltered, field, min, max) {
          var filtered = [];
          if (!max) {
            if (!min) return unfiltered;
            for (var i = 0; i < unfiltered.length; i++) {
              if (!new Date(unfiltered[i].Quote[field]).getTime) continue;
              if (new Date(unfiltered[i].Quote[field]).getTime() >= min.getTime())
                filtered.push(unfiltered[i]);
            }
          } else if (!min) {
            for (i = 0; i < unfiltered.length; i++) {
              if (!new Date(unfiltered[i].Quote[field]).getTime) continue;
              if (new Date(unfiltered[i].Quote[field]).getTime() <= max.getTime())
                filtered.push(unfiltered[i]);
            }
          } else {
            for (i = 0; i < unfiltered.length; i++) {
              if (!new Date(unfiltered[i].Quote[field]).getTime) continue;
              if (new Date(unfiltered[i].Quote[field]).getTime() <= max.getTime() && new Date(unfiltered[i][field]).getTime() >= min.getTime())
                filtered.push(unfiltered[i]);
            }
          }
          return filtered;
        }

        function filterPassengerNumber(unfiltered, minPassengers, maxPassengers) {
          // handle filter changes


          var filtered = [];
          for (var i = 0; i < unfiltered.length; i++) {
            var pax = unfiltered[i].Quote.onboard.passengers || 0;
            //
            if ((!minPassengers || pax >= minPassengers) && (!maxPassengers || pax <= maxPassengers)) {
              filtered.push(unfiltered[i]);
            }
          }
          return filtered;
        }

        function filterNumber(unfiltered, field, min, max) {
          var filtered = [];
          if (!max) {
            if (!min) return unfiltered;
            for (var i = 0; i < unfiltered.length; i++) {
              if (unfiltered[i].Quote[field] >= min)
                filtered.push(unfiltered[i]);
            }
          } else if (!min) {
            for (i = 0; i < unfiltered.length; i++) {
              if (unfiltered[i].Quote[field] <= max)
                filtered.push(unfiltered[i]);
            }
          } else {
            for (i = 0; i < unfiltered.length; i++) {
              if (unfiltered[i].Quote[field] <= max && unfiltered[i].Quote[field] >= min)
                filtered.push(unfiltered[i]);
            }
          }
          return filtered;
        }

        function filterIn(unfiltered, field, values) {
          var filtered = [];
          var other = false;
          for (var i = 0; i < unfiltered.length; i++) {
            var ok = false;
            var notOk = false;
            for (var j = 0; j < values.length; j++) {
              if (values[j].code === '' && values[j].selected) other = true;
              if (unfiltered[i].Quote[field] === values[j].code) {
                ok = values[j].selected;
                notOk = !values[j].selected;
              }
            }
            if (ok || (!notOk && other))
              filtered.push(unfiltered[i]);
          }
          return filtered;
        }

        function filterContains(unfiltered, field, value) {
          var filtered = [];
          for (var i = 0; i < unfiltered.length; i++) {
            if (unfiltered[i][field] && unfiltered[i][field].indexOf(value) !== -1) {
              filtered.push(unfiltered[i])
            }
          }
          return filtered;
        }

        function filterNotContains(unfiltered, field, value) {
          var filtered = [];
          for (var i = 0; i < unfiltered.length; i++) {
            if (unfiltered[i][field] && unfiltered[i][field].indexOf(value) === -1) {
              filtered.push(unfiltered[i])
            }
          }
          return filtered;
        }

        function filterDeepContains(unfiltered, field, field1, value) {
          var filtered = [];
          for (var i = 0; i < unfiltered.length; i++) {
            if (unfiltered[i][field][field1].indexOf(value) !== -1) {
              filtered.push(unfiltered[i])
            }
          }
          return filtered;
        }

        function filterShow(unfiltered, value) {
          var data = unfiltered;
          data = filterNotContains(data, 'status', 'rejected');
          data = filterNotContains(data, 'status', 'voided');
          data = filterNotContains(data, 'status', 'pending');
          if (value !== '') {
            data = filterDeepContains(data, 'Quote', 'request_type', value);
          }
          return data;
        }

        function filterAll() {

          var data = filterShow(vm.unfiltered, vm.show);

          var updated = vm.currentFilter.between.find(function (element) {
            return element.field === 'updatedAt';
          });

          data = filterDate(data, 'updatedAt', updated.min, updated.max);

          var serviceType = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'service_type';
          });

          data = filterIn(data, 'service_type', serviceType.values);

          //console.log(startdateData)
          var passengers = vm.currentFilter.between.find(function (element) {
            return element.field === 'passengers';
          });
          data = filterPassengerNumber(data, passengers.min, passengers.max);


          var start = vm.currentFilter.between.find(function (element) {
            return element.field === 'startdate';
          });
          data = filterDate(data, 'startdate', start.min, start.max);


          //console.log(data);
          //console.log(enddateData)
          var end = vm.currentFilter.between.find(function (element) {
            return element.field === 'enddate';
          });
          data = filterDate(data, 'enddate', end.min, end.max);


          //console.log(data);
          var pickup = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'pickup';
          });


          data = filterPlaceSelection(data, 'pickup', pickup.values.filter(function (v) {
            return v.selected;
          }), vm.placePickups);


          //console.log(data);
          var dropoff = vm.currentFilter.belongs.find(function (element) {
            return element.field === 'dropoff';
          });

          data = filterPlaceSelection(data, 'dropoff', dropoff.values.filter(function (v) {
            return v.selected;
          }), vm.placeDropoffs);

          var partnerPrice = vm.currentFilter.between.find(function (element) {
            return element.field === 'partnerTotal';
          });
          data = filterNumber(data, 'partnerTotal', partnerPrice.min, partnerPrice.max);


          vm.gridOptions.data = data;
          vm.gridApi.core.refresh();
        }


        $scope.$watch(function () {
          return vm.show
        }, function () {
          if (vm.gridApi && vm.gridApi.core) {
            filterAll();
          }
        });
        vm.filterData = {};
        vm.export = function () {
          var selected = vm.gridApi.selection.getSelectedRows();

          var csvRow = [
            [
              '"Tipo di Richiesta"',
              '"N° Prenotazione"',
              '"Tipologia"',
              '"Pax"',
              '"Pick-Up"',
              '"Drop-Off"',
              '"Prezzo"',
              '"Servizio"',
              '"Ora d\'Inizio"',
              '"Data d\'Inizio"',
              '"Ora di Fine"',
              '"Data di Fine"',
            ]
          ];

          function identityFunction(v) {
            return v
          }
          for (var i = 0; i < selected.length; i++) {
            csvRow.push('"' +
              $common.convertQuoteToCSV(selected[i], [
                ['Quote', 'request_type'],
                ['Quote', '_id'],
                ['Quote', 'service_type'],
                ['Quote', 'onboard', 'passengers'],
                ['Quote', 'pickup'],
                ['Quote', 'dropoff'],
                ['Quote', 'partnerTotal'],
                ['Quote', 'info'],
                ['Quote', 'startdate'],
                ['Quote', 'startdate'],
                ['Quote', 'enddate'],
                ['Quote', 'enddate'],
              ], [
                $filter('requestType'),
                $filter('quoteId'),
                $filter('serviceType'),
                identityFunction,
                identityFunction,
                identityFunction,
                $filter('currency'),
                identityFunction,
                $filter('time'),
                $filter('calendar'),
                $filter('time'),
                $filter('calendar'),
              ]).join('","') + '"')
          }


          var blob = new Blob([csvRow.join('\n')], {
            type: 'text/plain'
          });
          var url = $window.URL;
          vm.url = url.createObjectURL(blob);
          var link = angular.element('<a/>');

          link.css({
            display: 'none'
          });
          link.attr({
            href: url.createObjectURL(blob),
            target: '_blank',
            download: 'Prenotazioni_Busrapido_' + $filter('dates')(new Date()) + '.csv'
          })
          link[0].click();
          // clean up
          link.remove();
          url.revokeObjectURL(blob);
        }
        vm.gridStyle = {
          height: '600px'
        };

        function getTableHeight(currentPage, pageSize, dataLen) {
          var rowHeight = 30; // row height
          var headerHeight = 50; // header height
          var footerHeight = 60; // bottom scroll bar height
          var totalH = 0;
          var totalPage = Math.floor(dataLen / pageSize) + (dataLen % pageSize > 0 ? 1 : 0)
          if (totalPage > 1) {
            if (currentPage < totalPage) {
              totalH = pageSize * rowHeight + headerHeight + footerHeight;
            } else {
              var lastPageSize = dataLen % pageSize;
              if (lastPageSize === 0) {
                totalH = pageSize * rowHeight + headerHeight + footerHeight;
              } else {
                totalH = lastPageSize * rowHeight + headerHeight + footerHeight;
              }
            }

          } else {
            totalH = dataLen * rowHeight + headerHeight + footerHeight;
          }
          return ($common.max(totalH, 300)) + 'px';
        }
        vm.updateFilters = function () {
          vm.possible = {
            passengers: vm.numPassengers,
            service_type: $common.serviceType
          };
          vm.options = [{
            between: [{
                field: 'passengers',
                type: 'number',
                //values: vm.possible.passengers,
              },
              {
                field: 'partnerTotal',
                type: 'number',
                //values: vm.possible.client_price,
              },
              {
                field: 'updatedAt',
                type: 'date',
              },
              {
                field: 'startdate',
                type: 'date',
              },
              {
                field: 'starttime',
                type: 'time',
                min: 0,
                max: 24
              }, {
                field: 'enddate',
                type: 'date',
              },
              {
                field: 'endtime',
                type: 'time',
                min: 0,
                max: 24
              },
            ],
            equals: [],
            belongs: [{
                field: 'service_type',
                type: 'service',
                values: vm.possible.service_type,
                value: [],
              },
              {
                field: 'dropoff',
                type: 'place',
                values: angular.copy(vm.places),
                value: [],
              },
              {
                field: 'pickup',
                type: 'place',
                values: angular.copy(vm.places),
                value: [],
              },
            ],
            name: 'Filtro creato il ' + $filter('dates')(new Date())
          }];
          vm.filterData.currentFilter = vm.options[0];
          vm.currentFilter = vm.options[0];
          vm.filterData.currentFilter = vm.currentFilter;
          return $supplier.getFilters().then(function (response) {

            vm.options = vm.options.concat(response.filters.map(function (value) {
              for (var i = 0; i < value.between.length; i++) {
                switch (value.between[i].field) {
                  case 'partnerTotal':
                    value.between[i].values = vm.possible.partnerTotal;
                    break;
                  case 'passengers':
                    value.between[i].values = vm.possible.passengers;
                    break;
                  default:
                    break;
                }
                switch (value.between[i].type) {
                  case 'date':
                    value.between[i].min = value.between[i].min ? new Date(value.between[i].min) : value.between[i].min;
                    value.between[i].max = value.between[i].max ? new Date(value.between[i].max) : value.between[i].max;

                    break;
                }
              }
              return value;
            }));
            vm.filterData.options = vm.options;
          }, function (err) {});
        }
        vm.openFilters = function () {
          var value = vm.currentFilter;
          var data;
          for (var i = 0; i < value.between.length; i++) {
            switch (value.between[i].field) {
              case 'passengers':
                data = passengersData;
                break;
              case 'partnerTotal':
                data = partnerPriceData;
                break;
              case 'endtime':
                data = endtimeData;
                break;
              case 'starttime':
                data = starttimeData;
                break;
              case 'startdate':
                data = startdateData;
                break;
              case 'updatedAt':
                data = updatedData;
                break;
              case 'enddate':
                data = enddateData;
                break;
              default:
                data = {};
                break;
            }
          }
          vm.filterData.currentFilter = angular.copy(value);
          Filtersave.show('Gestisci filtri', vm.filterData, undefined, 'Salva sul sito', true, 0, 0,
            function (cancel) {
              // vm.filterData.currentFilter = currentFilter;
            },
            function (response) {
              // in any case update our current filter
              //
              vm.currentFilter = angular.copy(response.filter);
              vm.filterData.currentFilter = vm.currentFilter;
              if (response.action === 'save') {
                vm.saveFilter(vm.currentFilter);
              }
              filterAll();
            });
        }


        var columns = {};

        var startData = {
          label: 'Partenza',
          show: false,
          onFilter: function () {
            startData.show = false;
            filterAll();
          }
        };

        var endData = {
          label: 'Arrivo',
          show: false,
          onFilter: function () {
            endData.show = false;
            filterAll();
          }
        };

        var paxData = {
          minPax: vm.minPax,
          maxPax: vm.maxPax,
          numPax: vm.numPax,
          onFilter: function () {
            this.show = false;
            filterAll();
          }
        };
        var updatedData = {
          label: 'Modificato il',
          filterType: 'between',
          dataType: 'date',
          filterData: vm.filterData,
          field: 'updatedAt',
          show: false,
          onApply: function () {
            updatedData.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },
        };
        var startdateData = {
          label: 'Partenza',
          show: false,
          filterType: 'between',
          dataType: 'date',
          filterData: vm.filterData,
          field: 'startdate',
          onApply: function () {
            updatedData.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },
        };
        var enddateData = {

          label: 'Arrivo',
          filterType: 'between',
          dataType: 'date',
          filterData: vm.filterData,
          field: 'enddate',
          show: false,
          onApply: function () {
            updatedData.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },
        };
        var starttimeData = {
          label: 'Partenza',
          show: false,
          filterType: 'between',
          dataType: 'time',
          filterData: vm.filterData,
          field: 'starttime',

          onApply: function () {
            updatedData.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },
        };
        var endtimeData = {
          label: 'Arrivo',
          filterType: 'between',
          dataType: 'time',
          filterData: vm.filterData,
          field: 'endtime',
          show: false,

          onApply: function () {
            updatedData.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },
        };
        var serviceTypeData = {
          show: false,
          label: 'Tipo di servizio',
          filterType: 'belongs',
          filterData: vm.filterData,
          lang: {
            selectAll: "Seleziona visibili",
            selectNone: "Deseleziona visibili",
            reset: "Riprestina filtri precedenti",
            search: "Cerca...",
            nothingSelected: "Nessun filtro" //default-label is deprecated and replaced with this.
          },
          nameFilter: function (item) {
            if (item.code === '') {
              return 'Altro';
            }
            return item.code;
          },
          field: 'service_type',

          onApply: function () {
            updatedData.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },
        };
        var pickupData = {
          show: false,
          label: 'Pick-up',
          filterType: 'belongs',
          dataType: 'place',
          filterData: vm.filterData,
          lang: {
            selectAll: "Seleziona visibili",
            selectNone: "Deseleziona visibili",
            reset: "Riprestina filtri precedenti",
            search: "Cerca...",
            nothingSelected: "Nessun filtro" //default-label is deprecated and replaced with this.
          },
          nameFilter: function (item) {
            return item.name;
          },
          field: 'pickup',

          onApply: function () {
            updatedData.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },
        };
        var dropoffData = {
          show: false,
          label: 'Drop-off',
          filterType: 'belongs',
          dataType: 'place',
          lang: {
            selectAll: "Seleziona visibili",
            selectNone: "Deseleziona visibili",
            reset: "Riprestina filtri precedenti",
            search: "Cerca...",
            nothingSelected: "Nessun filtro" //default-label is deprecated and replaced with this.
          },
          nameFilter: function (item) {
            return item.name;
          },
          filterData: vm.filterData,
          field: 'dropoff',
          onApply: function () {
            updatedData.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },
        };

        var passengersData = {
          show: false,
          filterType: 'between',
          dataType: 'number',
          filterData: vm.filterData,
          field: 'passengers',
          onApply: function () {
            updatedData.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },
        };
        var partnerPriceData = {
          show: false,
          nameFilter: function (item) {
            return item;
          },
          filterType: 'between',
          dataType: 'number',
          filterData: vm.filterData,
          field: 'partnerTotal',
          onApply: function () {
            updatedData.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },

        };

        var quoteNumberData = {
          show: false,
          label: 'N° Prenotazione',
          filterData: vm.filterData,
          lang: {
            selectAll: "Seleziona visibili",
            selectNone: "Deseleziona visibili",
            reset: "Riprestina filtri precedenti",
            search: "Cerca provincia...",
            nothingSelected: "Nessun filtro" //default-label is deprecated and replaced with this.
          },
          onApply: function () {
            updatedData.show = false;
            vm.currentFilter = angular.copy(vm.filterData.currentFilter);
            filterAll();
          },
          field: 'id',
        };
        function rawSort(a, b, rowA, rowB, direction) {



          var nulls = vm.gridApi.core.sortHandleNulls(a, b);
          if (nulls !== null) {
            return nulls;
          } else {
            if (a === b) {
              return 0;
            }
            if (a > b) {
              return 1;
            }
            if (a < b) {
              return -1;
            }
            return 0;
          }
        }
        columns.requestType = {
          enableColumnMenu: false,
          field: 'Quote.request_type',
          name: 'Tipo di richiesta',
          cellTooltip: true,
          cellTemplate: '<div class="ui-grid-cell-contents"  title="{{row.entity.Quote.request_type + row.entity.Quote.owner_type | onlyTooltip}}"><span class="icon icon-heart heart-red" ng-if="row.entity.Quote.owner_type == \'supplier\'"></span><span class="icon icon-star" ng-if="row.entity.Quote.request_type.indexOf(\'only\') !== -1"></span>{{COL_FIELD CUSTOM_FILTERS}}</div>',
          cellFilter: 'requestType',
          minWidth: 140,
          maxWidth: 150,
        };
        columns.quoteNumber = {
          data: quoteNumberData,
          enableColumnMenu: false,
          field: 'Quote.id',
          name: 'N° prenotazione',
          width: 120,
          headerCellTemplate: 'app/components/header-filter/generic.html',

          cellFilter: 'quoteId',
          cellTemplate: '<div class="ui-grid-cell-contents"  title="{{COL_FIELD CUSTOM_FILTERS}}"><a ui-sref="root.it.supplier.quotes.details({\'id\': COL_FIELD})">{{COL_FIELD CUSTOM_FILTERS}}</a></div>',
        };
        columns.serviceType = {
          enableColumnMenu: false,
          field: 'Quote.service_type',
          name: 'Tipologia',
          headerCellTemplate: 'app/components/header-filter/generic.html',
          data: serviceTypeData,

          cellTooltip: true,
          width: 60,
        };
        columns.passengers = {
          enableColumnMenu: false,
          cellTooltip: true,
          field: 'Quote.onboard.passengers',
          headerCellTemplate: 'app/components/header-filter/generic.html',
          name: 'PAX',
          width: 60,
          data: passengersData,
          sortingAlgorithm: rawSort
        };
        columns.pickup = {
          enableColumnMenu: false,
          field: 'Quote.pickup',
          cellTooltip: true,
          name: 'Pick-up',
          minWidth: 120,
          maxWidth: 150,
          // sortable: true,
          headerCellTemplate: 'app/components/header-filter/generic.html',
          data: pickupData,
        };
        columns.dropoff = {
          enableColumnMenu: false,
          field: 'Quote.dropoff',
          cellTooltip: true,
          minWidth: 120,
          maxWidth: 150,
          // sortable: true,
          headerCellTemplate: 'app/components/header-filter/generic.html',
          data: dropoffData,
          name: 'Drop-off',
        };
        columns.partnerPrice = {
          enableColumnMenu: false,
          field: 'Quote.partnerTotal',
          name: 'Prezzo',
          cellTooltip: true,
          cellFilter: 'currency',
          // sortable: true,
          headerCellTemplate: 'app/components/header-filter/generic.html',
          data: partnerPriceData,
          width: 100,
          sortingAlgorithm: rawSort
        };
        columns.info = {
          enableColumnMenu: false,
          field: 'Quote.info',
          cellTooltip: true,
          minWidth: 300,
          name: 'Servizio',
        };
        columns.starttime = {
          enableColumnMenu: false,
          field: 'Quote.startdate',
          cellTooltip: true,
          minWidth: 80,
          maxWidth: 100,
          name: 'Ora d\'inizio',
          cellFilter: 'time',
          headerCellTemplate: 'app/components/header-filter/generic.html',
          sortingAlgorithm: function (a, b, rowA, rowB, direction) {

            var nulls = vm.gridApi.core.sortHandleNulls(a, b);
            if (nulls !== null) {
              return nulls;
            } else {
              if (a === b) {
                return 0;
              }
              if ($filter('time')(a) > $filter('time')(b)) {
                return 1;
              }
              if ($filter('time')(a) < $filter('time')(b)) {
                return -1;
              }
              return 0;
            }
          },
          data: starttimeData
        };
        columns.startdate = {
          enableColumnMenu: false,
          field: 'Quote.startdate',
          cellTooltip: true,
          minWidth: 100,
          maxWidth: 120,
          name: 'Data d\'inizio',
          sort: {
            direction: uiGridConstants.DESC,
            priority: 1,
          },
          cellFilter: 'calendar',
          headerCellTemplate: 'app/components/header-filter/generic.html',
          data: startdateData
        };
        columns.endtime = {
          enableColumnMenu: false,
          field: 'Quote.enddate',
          cellTooltip: true,
          minWidth: 80,
          maxWidth: 100,
          name: 'Ora di fine',
          cellFilter: 'time',
          headerCellTemplate: 'app/components/header-filter/generic.html',
          data: endtimeData,
          sortingAlgorithm: function (a, b, rowA, rowB, direction) {

            var nulls = vm.gridApi.core.sortHandleNulls(a, b);
            if (nulls !== null) {
              return nulls;
            } else {
              if (a === b) {
                return 0;
              }
              if ($filter('time')(a) > $filter('time')(b)) {
                return 1;
              }
              if ($filter('time')(a) < $filter('time')(b)) {
                return -1;
              }
              return 0;
            }
          }

          // data: startdateData
        };
        columns.enddate = {
          enableColumnMenu: false,
          cellTooltip: true,
          field: 'Quote.enddate',
          minWidth: 100,
          maxWidth: 120,
          name: 'Data di fine',
          cellFilter: 'calendar',
          headerCellTemplate: 'app/components/header-filter/generic.html',
          data: enddateData
        };
        vm.defaultColumnDefs = [
          columns.requestType,
          columns.quoteNumber,
          columns.serviceType,
          columns.passengers,
          columns.pickup,
          columns.dropoff,
          /*
            {
              field: 'status',
              name: 'Status',
              cellTemplate: '<div class="ui-grid-cell-contents"  title="TOOLTIP"><span class="tag tag-sm" ng-class="{\'tag-green\':COL_FIELD == \'accepted\', \'tag-yellow\':COL_FIELD == \'hidden\'}">{{COL_FIELD CUSTOM_FILTERS}}</span></div>',
              cellTooltip: true,
              cellFilter: 'adminStatus',
              pinnedLeft: true,
              width: 80,
              sort: {
                direction: uiGridConstants.DESC,
                priority: 3,
              },
            },
          */
          columns.partnerPrice,
          columns.info,
          columns.starttime,
          columns.startdate,
          columns.endtime,
          columns.enddate,
          /*
            {
              field: 'id',
              name: 'Status',
              cellTemplate: '<button class="btn btn-md btn-outline" ng-click="col.colDef.data.onClick(COL_FIELD)"><span class="icon icon-logout"></span>Apri</button>',
              width: 120,
              pinnedRight: true,
              data: {
                onClick: function (id) {
                  $state.go('root.it.admin.quotes.new', { id: id });
                }
              }
            },
          */
        ];
        vm.show = '';
        vm.gridOptions.columnDefs = vm.defaultColumnDefs;
        vm.zoom = 100;
        var referenceColumnDefs = angular.copy(vm.defaultColumnDefs);
        vm.resize = function (percentage) {
          var columnDefs = referenceColumnDefs;
          for (var i = 0; i < columnDefs.length; i++) {
            if (columnDefs[i].width) {
              vm.gridOptions.columnDefs[i].width = columnDefs[i].width * percentage / 100;
            }
            if (columnDefs[i].minWidth) {
              vm.gridOptions.columnDefs[i].minWidth = columnDefs[i].minWidth * percentage / 100;
            }
            if (columnDefs[i].maxWidth) {
              vm.gridOptions.columnDefs[i].maxWidth = columnDefs[i].maxWidth * percentage / 100;
            }
          }
          vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
          if (percentage < 80) {

            vm.gridStyle['font-size'] = (percentage + 10) + '%';
          } else {
            vm.gridStyle['font-size'] = (percentage) + '%';
          }


        }
        vm.unfiltered = angular.copy(vm.quotes);

        vm.gridOptions.data = filterShow(vm.quotes, vm.show);

        vm.updateFilters().then(function (result) {
          vm.loaded = true;
          vm.filtersLoaded = true;

        });
      }, function (err) {
        var str = $error.get(err, 'api');
        $alert.show(str.title, str.msg, 'Ricarica', '', true, 0, 5000,
          function (cancel) {
            $state.reload();
          });
      });

    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brAuth', authDirective);

  /** @ngInject */
  function authDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        mode: '=brMode',
        data: '=?brData',
        onSignin: '&?brOnSignin',
        onSignup: '&?brOnSignup',
        onModeChange: '&?brOnModeChange'
      },
      templateUrl: 'app/elements/auth/auth.html',
      controller: 'AuthController',
      controllerAs: 'auth',
      bindToController: true
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('AuthController', AuthController);

  /** @ngInject */
  function AuthController($timeout, $rootScope, $validator, $error, $supplier, $scope, $document, $state) {
    var vm = this;
    vm.$onInit = function() {
      vm.enabled = true;
      vm.$users = $rootScope.$users;
      vm.user = {
        signup: {},
        signin: {},
        recover: {},
        reset: {}
      };
      function resetSigninWarning(time) {
        $timeout(function() { vm.user.signin.warning = undefined; }, time);
      }
      function resetSignupWarning(time) {
        $timeout(function() { vm.user.signup.warning = undefined; }, time);
      }
      function resetRecoverWarning(time) {
        $timeout(function() { vm.user.recover.warning = undefined; }, time);
      }
      function resetResetWarning(time) {
        $timeout(function() { vm.user.reset.warning = undefined; }, time);
      }

      function resetWarning(time) {
        $timeout(function() { vm.warning = undefined; }, time);
      }

      vm.changeMode = function(mode) {
        vm.mode = mode;
        $timeout(vm.onModeChange, 0);
      }

      vm.step = 1;
      vm.onSignin = function () {
        $state.go('root.it.supplier.quotes.list');
      }
      vm.advanceSignup = function (oldStep, newStep, $event) {


        var form = ($event && $event.srcElement) || $document.find('form')[0];
        if (form.checkValidity()) {
          if (oldStep === 1) {
            vm.processSignup().then(function(result) {

            });
          }
          else {
            vm.saveChanges(newStep);
          }
        }
        else {
          $scope.$broadcast('validated');
        }
      }

      vm.saveChanges = function(newStep) {
        //if (vm.warning) {
        //  resetWarning(5000);
        //  return;
        //}
        vm.loaded = false;
        return $supplier.update({supplier: vm.signup}).then(function(user) {

          vm.step = newStep;
          vm.loaded = true;

        }, function(err) {
          var str = $error.get(err, 'api');
          vm.warning = str.msg;
          resetWarning(5000);
        });
      };
      vm.processSignup = function() {
        // if($validator('name', vm.user.signup.name) === -1) vm.user.signup.warning = 'Ti sei dimenticato di inserire il nome.';
        // else if(!$validator('name', vm.user.signup.name)) vm.user.signup.warning = 'Il nome inserito non è valido.';
        // else if($validator('name', vm.user.signup.surname) === -1) vm.user.signup.warning = 'Ti sei dimenticato di inserire il cognome.';
        // else if(!$validator('name', vm.user.signup.surname)) vm.user.signup.warning = 'Il cognome inserito non è valido.';
        // else if($validator('phone', vm.user.signup.phone) === -1) vm.user.signup.warning = 'Ti sei dimenticato di inserire il numero di telefono.';
        // else if(!$validator('phone', vm.user.signup.phone)) vm.user.signup.warning = 'Il numero di telefono inserito non è valido.';

        if($validator('company', vm.user.signup.tcompany) === -1) vm.user.signup.warning = 'Ti sei dimenticato di inserire il nome della società.';
        else if(!$validator('company', vm.user.signup.tcompany)) vm.user.signup.warning = 'Il nome dell\'azienda non è valido.';
        else if($validator('email', vm.user.signup.email) === -1) vm.user.signup.warning = 'Ti sei dimenticato di inserire l\'email.';
        else if(!$validator('email', vm.user.signup.email)) vm.user.signup.warning = 'L\'email inserita non è valida.';
        else if($validator('password', vm.user.signup.password) === -1) vm.user.signup.warning = 'Ti sei dimenticato di inserire la password.';
        else if(!$validator('password', vm.user.signup.password)) vm.user.signup.warning = 'La password inserita non è valida. La password deve contenere almeno 6 caratteri e non può contenere spazi.';

        // else if($validator('phone', vm.user.signup.companyphone) === -1) vm.user.signup.warning = 'Ti sei dimenticato di inserire il numero di telefono della società.';
        // else if(!$validator('phone', vm.user.signup.companyphone)) vm.user.signup.warning = 'Il numero di telefono della socieltà inserito non è valido.';
        // else if($validator('phone', vm.user.signup.emergencyphone) === -1) vm.user.signup.warning = 'Ti sei dimenticato di inserire il numero di telefono di emergenza della società.';
        // else if(!$validator('phone', vm.user.signup.emergencyphone)) vm.user.signup.warning = 'Il numero di telefono di emergenza della socieltà inserito non è valido.';
        // else if($validator('taxcode', vm.user.signup.taxcode) === -1) vm.user.signup.warning = 'Ti sei dimenticato di inserire la partita IVA della società.';
        // else if(!$validator('taxcode', vm.user.signup.taxcode)) vm.user.signup.warning = 'Il numero della partita IVA della società inserito non è valido.';
        // else if($validator('place', vm.user.signup.place) === -1) vm.user.signup.warning = 'Ti sei dimenticato di inserire l\'indirizzo di fatturazione della società.';
        // else if(!$validator('place', vm.user.signup.place)) vm.user.signup.warning = 'L\'indirizzo di fatturazione della società inserito non è valido.';

        if(vm.user.signup.warning) {
          resetSignupWarning(5000);
          return;
        }
        vm.loaded = false;

        vm.enabled = false;
        return $supplier.signup(vm.user.signup.email, vm.user.signup.password, vm.user.signup.name, vm.user.signup.surname, vm.user.signup.phone, vm.user.signup.company, vm.user.signup.tcompany, vm.user.signup.companyphone, vm.user.signup.emergencyphone, vm.user.signup.taxcode, vm.user.signup.place).then(function() {
          // $timeout(vm.onSignup, 0);
          return $supplier.signin(vm.user.signup.email, vm.user.signup.password).then(function() {
            // $timeout(vm.onSignin, 0);
            vm.loaded = true;

          });
        }, function(err) {
          vm.enabled = true;
          var str = $error.get(err, 'api');
          vm.user.signup.warning = str.msg;
          resetSignupWarning(5000);
        });
      };

      vm.processSignin = function() {
        if($validator('email', vm.user.signin.email) === -1) vm.user.signin.warning = 'Ti sei dimenticato di inserire l\'email.';
        else if(!$validator('email', vm.user.signin.email)) vm.user.signin.warning = 'L\'email inserita non è valida.';
        else if($validator('password', vm.user.signin.password) === -1) vm.user.signin.warning = 'Ti sei dimenticato di inserire la password.';
        else if(!$validator('password', vm.user.signin.password)) vm.user.signin.warning = 'La password inserita non è valida.';
        if(vm.user.signin.warning) {
          resetSigninWarning(5000);
          return;
        }

        vm.enabled = false;
        $supplier.signin(vm.user.signin.email, vm.user.signin.password).then(function() {
          $timeout(vm.onSignin, 0);
        }, function(err) {
          vm.enabled = true;
          var str = $error.get(err, 'api');
          vm.user.signin.warning = str.msg;
          resetSigninWarning(5000);
        });
      };

      vm.processRecover = function() {
        if($validator('email', vm.user.recover.email) === -1) vm.user.recover.warning = 'Ti sei dimenticato di inserire l\'email.';
        else if(!$validator('email', vm.user.recover.email)) vm.user.recover.warning = 'L\'email inserita non è valida.';
        if(vm.user.recover.warning) {
          resetRecoverWarning(5000);
          return;
        }

        vm.enabled = false;
        $supplier.getReset(vm.user.recover.email).then(function() {
          vm.user.recover.warning = 'Un messaggio di posta con la procedura per reimpostare la password è stato inviato a ' + vm.user.recover.email + '. Ti invitiamo a controllare la tua casella di posta.';
          resetRecoverWarning(600000);
        }, function(err) {
          vm.enabled = true;
          var str = $error.get(err, 'api');
          vm.user.recover.warning = str.msg;
          resetRecoverWarning(5000);
        });
      };

      vm.processReset = function() {
        if($validator('password', vm.user.reset.password) === -1) vm.user.reset.warning = 'Ti sei dimenticato di inserire la nuova password.';
        else if(!$validator('password', vm.user.reset.password)) vm.user.reset.warning = 'La nuova password inserita non è valida. La password deve contenere almeno 6 caratteri e non può contenere spazi.';
        if(vm.warning) {
          resetResetWarning(5000);
          return;
        }

        vm.enabled = false;
        $supplier.reset(vm.data.id, vm.data.token, vm.user.reset.password).then(function() {
          vm.user.reset.warning = 'Password resettata correttamente. A breve verrai reindirizzato alla pagina per effettuare l\'accesso.';
          $timeout(function() {
            vm.changeMode('signin');
          }, 5000);
        }, function(err) {
          vm.enabled = true;
          var str = $error.get(err, 'api');
          vm.user.reset.warning = str.msg;
          resetResetWarning(5000);
        });
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brAdvantages', advantagesDirective);

  /** @ngInject */
  function advantagesDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/elements/advantages/advantages.html'
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('TmpQuoteController', TmpQuoteController);

  /** @ngInject */
  function TmpQuoteController($scope, $state, $timeout, $alert, $segment, $validator, $error, $supplier, $solutions, cloudinary, Vehiclepicker) {
    var vm = this;
    vm.$onInit = function () {
      $segment.track('[REQUESTS] [EXTERN] Partner click on request email');

      vm.loaded = false;
      if (angular.isUndefined($state.params.quote) || angular.isUndefined($state.params.supplier)) {
        $state.go('root.it.home')
      }
      if ($supplier.isAuthenticated()) {
        $state.go('root.it.supplier.quotes.details', {id: $state.params.quote});
      }
      function refresh() {
        $supplier.getTmpQuote($state.params.quote, $state.params.supplier).then(function (response) {
          vm.quote = response.quote;
          vm.loaded = true;
        }, function (err) {
          var str = $error.get(err, 'api');
          $alert.show(str.title, str.msg, 'Ricarica', '', true, 0, 5000,
            function (cancel) { $state.reload(); });
        });
      }
      refresh();
      $scope.$on('respond', function (event, response) {
        if (vm.working) return;
        vm.working = true;
        $alert.show('Diventa partner', 'Registrati per accettare questa ed molte altre richieste', '', 'Registrati', true, 0, -1, function() {
          vm.working = false;
        }, function(accept) {
          $segment.track('[REQUESTS] [EXTERN] Partner wants to signup from email');
          $state.go('root.it.supplier.signup');
        });
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('SuppliersController', SuppliersController);

  /** @ngInject */
  function SuppliersController($rootScope, $location, $anchorScroll, $scope, $state, $supplier, $prerender, $common, $registration) {
    $prerender.start();
    var vm = this;
    vm.$onInit = function() {
      vm.mode = 'signup';

      if($supplier.isAuthenticated()) {
        vm.auth = true;
        load();
      }

      onControllerLoaded();

      function onControllerLoaded() {
        vm.scrollTo = function(hash) {
          $location.hash(hash);
          $anchorScroll();
        }
        $prerender.done(500, true);
      }

      function load() {
        var current = $supplier.current();
        if ($common.getRegistrationStep(current, 2)) {
          // $registration.show(2, true, 500, -1);
          $state.go('root.it.supplier.profile.poc', {
            section: '2'
          });

        } else if ($common.getRegistrationStep(current, 3)) {
          // $registration.show(3, true, 500, -1);
          $state.go('root.it.supplier.profile.company', {
            section: '3'
          });

        }
        else if ($common.getRegistrationStep(current, 5)) {

          $state.go('root.it.supplier.profile.additional', {
            section: '5'
          });
        }
        else if ($common.getRegistrationStep(current, 7)) {
          $state.go('root.it.supplier.profile.notification', {
            section: '7'
          });
        } else if ($common.getRegistrationStep(current, 8)) {
          $state.go('root.it.supplier.profile.requesttypes', {
            section: '8'
          });
        } else if ($common.getRegistrationStep(current, 9)) {
          $state.go('root.it.supplier.subscribe.list');
        }

      }
      var unbind = $rootScope.$on('$supplierChange', function(event, oldSupplier, newSupplier) {
        if($supplier.isAuthenticated()) {
          load();
        }
      });
      $scope.$on('$destroy', unbind);

    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('E404Controller', E404Controller);

  /** @ngInject */
  function E404Controller($rootScope, $prerender, $timeout) {
    $prerender.start();
    var vm = this;
    vm.$onInit = function() {
      onControllerLoaded();

      function onControllerLoaded() {
        $prerender.done(500, true);
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .filter('articles', articlesFilter);

  function articlesFilter() {
    return function(name, deep, lang) {
      if(!name || !lang || !deep) {
        return '';
      }
      switch(lang) {
        case 'it': {
          if(deep >= 3) {
            if(name[0] == 'A' || name[0] == 'E' || name[0] == 'I' || name[0] == 'O' || name[0] == 'U') {
              return 'ad';
            }
            return 'a';
          }
          else if(deep <= 2) {
            if(name == 'Lazio' || name == 'Veneto') {
              return 'nel';
            }
            else if(name == 'Marche') {
              return 'nelle';
            }
            return 'in';
          }
          break;
        }
      }
      return '';
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .factory('Vehiclepicker', vehicleService);

  /** @ngInject */
  function vehicleService(ModalService, $rootScope, $timeout, $window) {
    var tmt, mdl;
    var service = {
      show: function(title, vehicles, badvehicles, requested, cancel, confirm, cross, after, timeout, onCancel, onConfirm) {
        if(after) {
          tmt = $timeout(showModal, after);
        }
        else {
          showModal();
        }

        function showModal() {
          ModalService.showModal({
            templateUrl: "app/components/vehiclepicker/vehiclepicker.modal.html",
            controller: 'VehiclepickerController',
            controllerAs: 'vehiclepicker',
            inputs: {
              title: title,
              msg: '',
              cancel: cancel,
              confirm: confirm,
              cross: cross,
              timeout: timeout,
              vehicles: vehicles,
              badvehicles: badvehicles,
              requested: requested
            }
          }).then(function(modal) {
            mdl = modal;
            modal.close.then(function(result) {

              if(angular.isObject(result)) {
                if(angular.isFunction(onConfirm)) onConfirm(result);
              }
              else {
                if(angular.isFunction(onCancel)) onCancel(result);
              }
            });
          });
        }
      }
    };

    var deregistrationCallback1 = $rootScope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams) {
      $timeout.cancel(tmt);
      if(mdl && mdl.scope && angular.isFunction(mdl.scope.close)) {
        mdl.scope.close();
      }
    });
    $rootScope.$on('$destroy', deregistrationCallback1);

    $rootScope.$on('$destroy', function() {
      $timeout.cancel(tmt);
      if(mdl && mdl.scope && angular.isFunction(mdl.scope.close)) {
        mdl.scope.close();
      }
    });

    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('VehiclepickerController', VehiclepickerController);

  /** @ngInject */
  function VehiclepickerController($scope, $timeout, close, title, requested, vehicles, badvehicles, msg, confirm, cancel, cross, timeout) {
    var vm = this;


    vm.modal = {
      title: title,
      confirm: confirm,
      cancel: cancel,
      cross: cross,
      vehicles: vehicles,
      badvehicles: badvehicles,
      requested: requested
    };
    vm.modal.services = {
      audio: {icon: 'icon-music-player', name: 'Impianto stereo'},
      coffeMachine: {icon: 'icon-coffee-machine', name: 'Macchina del caffè'},
      conditioner: {icon: 'icon-air-conditioner', name: 'Aria condizionata'},
      display: {icon: 'icon-monitor', name: 'Schermo TV'},
      dvdPlayer: {icon: 'icon-dvd', name: 'Lettore DVD'},
      electricity: {icon: 'icon-plug', name: 'Prese elettriche'},
      fridge: {icon: 'icon-fridge', name: 'Mini Frigorifero'},
      kitchen: {icon: 'icon-oven', name: 'Cucina a bordo'},
      leatherSeats: {icon: 'icon-leather', name: 'Sedili in pelle'},
      light: {icon: 'icon-idea', name: 'Luce da lettura'},
      luggage: {icon: 'icon-luggage', name: 'Vano valige'},
      microphone: {icon: 'icon-karaoke', name: 'Microfono'},
      panoramicWindows: {icon: 'icon-window', name: 'Vetri panoramici'},
      radio: {icon: 'icon-radio', name: 'Radio'},
      tintedWindows: {icon: 'icon-window-tinted', name: 'Vetri oscurati'},
      toilet: {icon: 'icon-toilet', name: 'Toilet'},
      tvAerial: {icon: 'icon-television', name: 'Antenna TV'},
      usb: {icon: 'icon-usb', name: 'Carica USB'},
      wheelchair: {icon: 'icon-wheelchair', name: 'Pedana carrozzine'},
      wifi: {icon: 'icon-connection', name: 'Wi-Fi'},
    };

    vm.closeIt = function(result) {
      console.log(result)
      if(angular.isFunction(close)) {
        close(result);
      }
    };
    vm.capacity = 0;
    vm.choose = function(vehicles) {
      if (vm.capacity >= vm.modal.requested) {
        vm.closeIt(vehicles);
      }
    }

    vm.updateCapacity = function(index) {
      vm.modal.vehicles[index].selected = !vm.modal.vehicles[index].selected;
      if (vm.modal.vehicles[index].selected) {
        vm.capacity += vm.modal.vehicles[index].specs.seats.passengers;
      }
      else {
        vm.capacity -= vm.modal.vehicles[index].specs.seats.passengers;
      }
    }

    if(timeout > 0) {
      var tmt = $timeout(function() {
        vm.closeIt(-2);
      }, timeout);
      $scope.$on('$destroy', function() {
        $timeout.cancel(tmt);
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brUploaderDoc', uploaderDirective);

  /** @ngInject */
  function uploaderDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        label: '@?brLabel',
        info: '@?brInfo',
        tags: '=?brTags',
        docs: '=?brDocs',
        files: '=?brFiles',
        single: '=?brSingle'
      },
      templateUrl: 'app/components/uploader-doc/uploader.html',
      controller: 'UploaderDocController',
      controllerAs: 'uploader',
      bindToController: true
    };
    return directive;
  }

})();

(function() {
  'use strict';

  angular
  .module('busrapidoAppWeb')
    .controller('UploaderDocController', UploaderDocController);

    /** @ngInject */
    function UploaderDocController($window, $timeout) {
      var vm = this;
      vm.$onInit = function() {
        vm.files = [];
        vm.picking = [];
        vm.timeout = [];
        vm.pickcount = 0;

        if(!angular.isNumber(vm.current)) {
          vm.current = 0;
        }
        if(!angular.isArray(vm.docs)) {
          vm.docs = [];
        }
        /**
         * Scope Functions
         */
        vm.selectFile = function(files) {
          for(var i = 0; i < files.length; i++) {
            vm.files.push(files[i]);
            vm.picking.push(true);
            vm.pickcount++;
          vm.timeout.push($timeout(function(index) {
            vm.picking[index] = false;
            vm.pickcount--;
          }, (vm.pickcount)*10000, true, vm.files.length-1));
        }
      }
      vm.removeFile = function(index) {
        if(vm.picking[index]) {
          vm.pickcount--;
          $timeout.cancel(vm.timeout[index]);
        }
        vm.files.splice(index, 1);
        vm.picking.splice(index, 1);
        vm.timeout.splice(index, 1);
      }
      vm.removeImage = function(index) {
        vm.docs.splice(index, 1);
      }

      vm.moveImageLeft = function(index) {
        if(!vm.docs || vm.docs.length < 1 || index < 1 || index >= vm.docs.length) return;
        vm.docs[index] = vm.docs.splice(index-1, 1, vm.docs[index])[0];
      }
      vm.moveImageRight = function(index) {
        if(!vm.docs || vm.docs.length < 1 || index < 0 || index >= vm.docs.length-1) return;
        vm.docs[index] = vm.docs.splice(index+1, 1, vm.docs[index])[0];
      }

      vm.moveFileLeft = function(index) {
        if(!vm.files || vm.files.length < 1 || index < 1 || index >= vm.files.length) return;

        if(vm.picking[index]) {
          $timeout.cancel(vm.timeout[index]);
          vm.timeout[index] = $timeout(function(index) {
            vm.picking[index] = false;
            vm.pickcount--;
          }, (vm.pickcount)*10000, true, index-1);
        }
        if(vm.picking[index-1]) {
          $timeout.cancel(vm.timeout[index-1]);
          vm.timeout[index-1] = $timeout(function(index) {
            vm.picking[index] = false;
            vm.pickcount--;
          }, (vm.pickcount)*10000, true, index);
        }
        vm.files[index] = vm.files.splice(index-1, 1, vm.files[index])[0];
        vm.picking[index] = vm.picking.splice(index-1, 1, vm.picking[index])[0];
        vm.timeout[index] = vm.timeout.splice(index-1, 1, vm.timeout[index])[0];
      }
      vm.moveFileRight = function(index) {
        if(!vm.files || vm.files.length < 1 || index < 0 || index >= vm.files.length-1) return;
        vm.files[index] = vm.files.splice(index+1, 1, vm.files[index])[0];
        vm.picking[index] = vm.picking.splice(index+1, 1, vm.picking[index])[0];
        vm.timeout[index] = vm.timeout.splice(index+1, 1, vm.timeout[index])[0];
      }
      /**
       * Controller Functions
       */

      /**
       * Controller watchers
       */
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brUploaderDirective', uploaderDirective);

  /** @ngInject */
  function uploaderDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        label: '@?brLabel',
        info: '@?brInfo',
        imgs: '=?brImgs',
        files: '=?brFiles',
        single: '=?brSingle'
      },
      templateUrl: 'app/components/uploader-directive/uploader.html',
      controller: 'UploaderDirectiveController',
      controllerAs: 'uploader',
      bindToController: true
    };
    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('UploaderDirectiveController', UploaderController);

  /** @ngInject */
  function UploaderController($window, $timeout) {
    var vm = this;
    vm.$onInit = function() {
      vm.files = [];
      vm.picking = [];
      vm.timeout = [];
      vm.pickcount = 0;

      if(!angular.isNumber(vm.current)) {
        vm.current = 0;
      }
      if(!angular.isArray(vm.imgs)) {
        vm.imgs = [];
      }
      /**
       * Scope Functions
       */
      vm.selectFile = function(files) {
        for(var i = 0; i < files.length; i++) {
          vm.files.push(files[i]);
          vm.picking.push(true);
          vm.pickcount++;
          vm.timeout.push($timeout(function(index) {
            vm.picking[index] = false;
            vm.pickcount--;
          }, (vm.pickcount)*10000, true, vm.files.length-1));
        }
      }
      vm.removeFile = function(index) {
        if(vm.picking[index]) {
          vm.pickcount--;
          $timeout.cancel(vm.timeout[index]);
        }
        vm.files.splice(index, 1);
        vm.picking.splice(index, 1);
        vm.timeout.splice(index, 1);
      }
      vm.removeImage = function(index) {
        vm.imgs.splice(index, 1);
      }

      vm.moveImageLeft = function(index) {
        if(!vm.imgs || vm.imgs.length < 1 || index < 1 || index >= vm.imgs.length) return;
        vm.imgs[index] = vm.imgs.splice(index-1, 1, vm.imgs[index])[0];
      }
      vm.moveImageRight = function(index) {
        if(!vm.imgs || vm.imgs.length < 1 || index < 0 || index >= vm.imgs.length-1) return;
        vm.imgs[index] = vm.imgs.splice(index+1, 1, vm.imgs[index])[0];
      }

      vm.moveFileLeft = function(index) {
        if(!vm.files || vm.files.length < 1 || index < 1 || index >= vm.files.length) return;

        if(vm.picking[index]) {
          $timeout.cancel(vm.timeout[index]);
          vm.timeout[index] = $timeout(function(index) {
            vm.picking[index] = false;
            vm.pickcount--;
          }, (vm.pickcount)*10000, true, index-1);
        }
        if(vm.picking[index-1]) {
          $timeout.cancel(vm.timeout[index-1]);
          vm.timeout[index-1] = $timeout(function(index) {
            vm.picking[index] = false;
            vm.pickcount--;
          }, (vm.pickcount)*10000, true, index);
        }
        vm.files[index] = vm.files.splice(index-1, 1, vm.files[index])[0];
        vm.picking[index] = vm.picking.splice(index-1, 1, vm.picking[index])[0];
        vm.timeout[index] = vm.timeout.splice(index-1, 1, vm.timeout[index])[0];
      }
      vm.moveFileRight = function(index) {
        if(!vm.files || vm.files.length < 1 || index < 0 || index >= vm.files.length-1) return;
        vm.files[index] = vm.files.splice(index+1, 1, vm.files[index])[0];
        vm.picking[index] = vm.picking.splice(index+1, 1, vm.picking[index])[0];
        vm.timeout[index] = vm.timeout.splice(index+1, 1, vm.timeout[index])[0];
      }
      /**
       * Controller Functions
       */

      /**
      * Controller watchers
      */
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brUploader', uploaderDirective);

  /** @ngInject */
  function uploaderDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        label: '@?brLabel',
        info: '@?brInfo',
        imgs: '=?brImgs',
        files: '=?brFiles',
        single: '=?brSingle'
      },
      templateUrl: 'app/components/uploader/uploader.html',
      controller: 'UploaderController',
      controllerAs: 'uploader',
      bindToController: true
    };
    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('UploaderController', UploaderController);

  /** @ngInject */
  function UploaderController($window, $timeout) {
    var vm = this;
    vm.$onInit = function() {
      vm.files = [];
      vm.picking = [];
      vm.timeout = [];
      vm.pickcount = 0;

      if(!angular.isNumber(vm.current)) {
        vm.current = 0;
      }
      if(!angular.isArray(vm.imgs)) {
        vm.imgs = [];
      }
      /**
       * Scope Functions
       */
      vm.selectFile = function(files) {
        for(var i = 0; i < files.length; i++) {
          vm.files.push(files[i]);
          vm.picking.push(true);
          vm.pickcount++;
          vm.timeout.push($timeout(function(index) {
            vm.picking[index] = false;
            vm.pickcount--;
          }, (vm.pickcount)*10000, true, vm.files.length-1));
        }
      }
      vm.removeFile = function(index) {
        if(vm.picking[index]) {
          vm.pickcount--;
          $timeout.cancel(vm.timeout[index]);
        }
        vm.files.splice(index, 1);
        vm.picking.splice(index, 1);
        vm.timeout.splice(index, 1);
      }
      vm.removeImage = function(index) {
        vm.imgs.splice(index, 1);
      }

      vm.moveImageLeft = function(index) {
        if(!vm.imgs || vm.imgs.length < 1 || index < 1 || index >= vm.imgs.length) return;
        vm.imgs[index] = vm.imgs.splice(index-1, 1, vm.imgs[index])[0];
      }
      vm.moveImageRight = function(index) {
        if(!vm.imgs || vm.imgs.length < 1 || index < 0 || index >= vm.imgs.length-1) return;
        vm.imgs[index] = vm.imgs.splice(index+1, 1, vm.imgs[index])[0];
      }

      vm.moveFileLeft = function(index) {
        if(!vm.files || vm.files.length < 1 || index < 1 || index >= vm.files.length) return;

        if(vm.picking[index]) {
          $timeout.cancel(vm.timeout[index]);
          vm.timeout[index] = $timeout(function(index) {
            vm.picking[index] = false;
            vm.pickcount--;
          }, (vm.pickcount)*10000, true, index-1);
        }
        if(vm.picking[index-1]) {
          $timeout.cancel(vm.timeout[index-1]);
          vm.timeout[index-1] = $timeout(function(index) {
            vm.picking[index] = false;
            vm.pickcount--;
          }, (vm.pickcount)*10000, true, index);
        }
        vm.files[index] = vm.files.splice(index-1, 1, vm.files[index])[0];
        vm.picking[index] = vm.picking.splice(index-1, 1, vm.picking[index])[0];
        vm.timeout[index] = vm.timeout.splice(index-1, 1, vm.timeout[index])[0];
      }
      vm.moveFileRight = function(index) {
        if(!vm.files || vm.files.length < 1 || index < 0 || index >= vm.files.length-1) return;
        vm.files[index] = vm.files.splice(index+1, 1, vm.files[index])[0];
        vm.picking[index] = vm.picking.splice(index+1, 1, vm.picking[index])[0];
        vm.timeout[index] = vm.timeout.splice(index+1, 1, vm.timeout[index])[0];
      }
      /**
       * Controller Functions
       */

      /**
      * Controller watchers
      */
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brTable', tableDirective);

  /** @ngInject */
  function tableDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        rows: '=brRows',
        columns: '=brColumns',
        obj: '@brObject'
      },
      templateUrl: 'app/components/table/table.html',
      controller: 'TableController',
      controllerAs: 'table',
      bindToController: true
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('TableController', TableController);

  /** @ngInject */
  function TableController($scope, $timeout) {
    var vm = this;
    vm.$onInit = function() {
      
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brTrip', tripDirective);

  /** @ngInject */
  function tripDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        steps: '=brSteps'
      },
      templateUrl: 'app/components/trip/trip.html',
      controller: 'TripController',
      controllerAs: 'trip',
      bindToController: true
    };
    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('TripController', TripController);

  /** @ngInject */
  function TripController() {
    var vm = this;

    vm.$onInit = function() {
      if(!angular.isArray(vm.steps)) {
        vm.steps = [];
      }
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brTimepicker', timepickerDirective);

  /** @ngInject */
  function timepickerDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        label: '@brLabel',
        labelBottom: '@brLabelBottom',
        placeholder: '@brPlaceholder',
        info: '@brInfo',
        change: '&brChange',
        model: '=brModel',
        disabled: '=?brDisabled',
        refDate: '=?brRefDate',
        minDate: '=?brMinDate',
        maxDate: '=?brMaxDate',
        stepMinute: '=?brStepMinute',
        stepHour: '=?brStepHour'
      },
      templateUrl: 'app/components/timepicker/timepicker.html',
      controller: 'TimepickerController',
      controllerAs: 'timepicker',
      bindToController: true
    };
    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('TimepickerController', TimepickerController);

  /** @ngInject */
  function TimepickerController($scope, $timeout) {
    var vm = this;

    vm.$onInit = function() {
      vm.internalModel = false;

      if(angular.isUndefined(vm.model)) {
        vm.model = '';
      }
      if(angular.isUndefined(vm.selected)) {
        vm.selected = '';
      }
      if(angular.isUndefined(vm.refDate)) {
        vm.refDate = null;
      }
      if(angular.isUndefined(vm.minDate)) {
        vm.minDate = null;
      }
      if(angular.isUndefined(vm.maxDate)) {
        vm.maxDate = null;
      }

      /**
       * Scope Functions
       */
      vm.populate = function() {
        var list = [];

        var state = -1;

        var divisorMinute = [1, 2, 3, 4, 5, 6, 10, 12, 15, 20, 30, 60];
        var divisorHour = [1, 2, 3, 4, 6, 8, 12, 24];
        var minMinute = 0, minHour = 0, maxMinute = 60, maxHour = 24, stepHourFix = 1, stepMinuteFix = 15;

        var minMinuteBound, minHourBound, maxMinuteBound, maxHourBound;
        var h, m;
        if(angular.isNumber(vm.stepHour) && isFinite(vm.stepHour)) {
          stepHourFix = binaryClosestSearch(vm.stepHour, divisorHour);
        }
        if(angular.isNumber(vm.stepMinute) && isFinite(vm.stepMinute)) {
          stepMinuteFix = binaryClosestSearch(vm.stepMinute, divisorMinute);
        }

        if(!angular.isDate(vm.refDate) || !angular.isDate(vm.minDate) && !angular.isDate(vm.maxDate)) {
          state = 0;
        }
        else if(angular.isDate(vm.minDate) && angular.isDate(vm.maxDate)) {
          if(vm.minDate.getFullYear() < vm.refDate.getFullYear() || vm.refDate.getFullYear() < vm.maxDate.getFullYear()) {
            if(vm.minDate.getFullYear() < vm.refDate.getFullYear()) {
              state = 20;
            }
            else {
              state = 10;
            }
          }
          else if(vm.minDate.getFullYear() > vm.refDate.getFullYear() || vm.refDate.getFullYear() > vm.maxDate.getFullYear()) {
            state = -2;
          }
          else if(vm.minDate.getMonth() < vm.refDate.getMonth() || vm.refDate.getMonth() < vm.maxDate.getMonth()) {
            if(vm.minDate.getMonth() < vm.refDate.getMonth()) {
              state = 20;
            }
            else {
              state = 10;
            }
          }
          else if(vm.minDate.getMonth() > vm.refDate.getMonth() || vm.refDate.getMonth() > vm.maxDate.getMonth()) {
            state = -3;
          }
          else if(vm.minDate.getDate() < vm.refDate.getDate() || vm.refDate.getDate() < vm.maxDate.getDate()) {
            if(vm.minDate.getDate() < vm.refDate.getDate()) {
              state = 20;
            }
            else {
              state = 10;
            }
          }
          else if(vm.minDate.getDate() > vm.refDate.getDate() || vm.refDate.getDate() > vm.maxDate.getDate()) {
            state = -4;
          }
          else {
            state = 3;
          }
        }

        if((!angular.isDate(vm.maxDate) && state === -1) || state === 10) {
          if(vm.minDate.getFullYear() < vm.refDate.getFullYear()) {
            state = 0;
          }
          else if(vm.minDate.getFullYear() > vm.refDate.getFullYear()) {
            state = -5;
          }
          else if(vm.minDate.getMonth() < vm.refDate.getMonth()) {
            state = 0;
          }
          else if(vm.minDate.getMonth() > vm.refDate.getMonth()) {
            state = -6;
          }
          else if(vm.minDate.getDate() < vm.refDate.getDate()) {
            state = 0;
          }
          else if(vm.minDate.getDate() > vm.refDate.getDate()) {
            state = -7;
          }
          else {
            state = 1;
          }
        }
        else if((!angular.isDate(vm.minDate) && state === -1) || state === 20) {
          if(vm.refDate.getFullYear() < vm.maxDate.getFullYear()) {
            state = 0;
          }
          else if(vm.refDate.getFullYear() > vm.maxDate.getFullYear()) {
            state = -8;
          }
          else if(vm.refDate.getMonth() < vm.maxDate.getMonth()) {
            state = 0;
          }
          else if(vm.refDate.getMonth() > vm.maxDate.getMonth()) {
            state = -9;
          }
          else if(vm.refDate.getDate() < vm.maxDate.getDate()) {
            state = 0;
          }
          else if(vm.refDate.getDate() > vm.maxDate.getDate()) {
            state = -10;
          }
          else {
            state = 2;
          }
        }

        switch(state) {
          case 0: {
            for(h = minHour; h < maxHour; h+=stepHourFix) {
              for(m = minMinute; m < maxMinute; m+=stepMinuteFix) {
                list.push(zeroFill(h) + ':' + zeroFill(m));
              }
            }
            break;
          }
          case 1: {
            minMinuteBound = vm.minDate.getMinutes();
            minHourBound = vm.minDate.getHours();
            minMinuteBound -= mod(minMinuteBound, -stepMinuteFix);
            minHourBound -= mod(minHourBound, -stepHourFix);
            for(m = minMinuteBound; m < maxMinute; m += stepMinuteFix) {
              list.push(zeroFill(minHourBound) + ':' + zeroFill(m));
            }
            for(h = minHourBound+1; h < maxHour; h += stepHourFix) {
              for(m = minMinute; m < maxMinute; m += stepMinuteFix) {
                list.push(zeroFill(h) + ':' + zeroFill(m));
              }
            }
            break;
          }
          case 2: {
            maxMinuteBound = vm.maxDate.getMinutes();
            maxHourBound = vm.maxDate.getHours();
            maxMinuteBound -= mod(maxMinuteBound, stepMinuteFix);
            maxHourBound -= mod(maxHourBound, stepHourFix);
            for(h = minHour; h < maxHourBound; h += stepHourFix) {
              for(m = minMinute; m < maxMinute; m += stepMinuteFix) {
                list.push(zeroFill(h) + ':' + zeroFill(m));
              }
            }
            for(m = minMinute; m <= maxMinuteBound; m += stepMinuteFix) {
              list.push(zeroFill(maxHourBound) + ':' + zeroFill(m));
            }
            break;
          }
          case 3: {
            minMinuteBound = vm.minDate.getMinutes();
            minHourBound = vm.minDate.getHours();
            maxMinuteBound = vm.maxDate.getMinutes();
            maxHourBound = vm.maxDate.getHours();
            minMinuteBound -= mod(minMinuteBound, -stepMinuteFix);
            minHourBound -= mod(minHourBound, -stepHourFix);
            maxMinuteBound -= mod(maxMinuteBound, stepMinuteFix);
            maxHourBound -= mod(maxHourBound, stepHourFix);
            for(m = minMinuteBound; m < maxMinute; m += stepMinuteFix) {
              list.push(zeroFill(minHourBound) + ':' + zeroFill(m));
            }
            for(h = minHourBound+1; h < maxHourBound; h += stepHourFix) {
              for(m = minMinute; m < maxMinute; m += stepMinuteFix) {
                list.push(zeroFill(h) + ':' + zeroFill(m));
              }
            }
            for(m = minMinute; m <= maxMinuteBound; m += stepMinuteFix) {
              list.push(zeroFill(maxHourBound) + ':' + zeroFill(m));
            }
          }
        }
        return list;
      };

      vm.adjustSelection = function(input) {
        if(!angular.isString(vm.model) || vm.items.length <= 0) return;
        var midVal = vm.model.split(':');
        if(midVal.length !== 2) return;
        var toSet = vm.items[0];
        if(input > vm.items[0] || input < vm.items[vm.items.length-1]) {
          toSet = binaryClosestSearch(input, vm.items);
        }
        //console.log("[FUNC] TIMEPICKER - UPDATING SELECTED", vm.selected, toSet, vm.model);
        vm.selected = toSet;
        $timeout(function() {
         $scope.$apply(function() {
           $timeout(vm.onSelectedChange, 0);
         });
        }, 0);
      };
      /**
       * Controller Functions
       */
      function binaryClosestSearch(element, arr) {
        var mid;
        var lo = 0;
        var hi = arr.length - 1;
        while(hi - lo > 1) {
          mid = Math.floor ((lo + hi) / 2);
          if(arr[mid] < element) {
            lo = mid;
          }
          else {
            hi = mid;
          }
        }
        if(element == arr[lo] || angular.isNumber(element) && element - arr[lo] <= arr[hi] - element) {
          return arr[lo];
        }
        return arr[hi];
      }
      function zeroFill(number) {
        if(number.toString().length < 2) {
          return '0' + number;
        }
        return '' + number;
      }
      function mod(n, mod) {
        return ((n % mod + mod) % mod);
      }

      /**
      * Controller watchers
      */
      $scope.$watch(function() { return vm.refDate }, function() {
        //console.log("[WATCH] TIMEPICKER - REFDATE CHANGE", vm.refDate);
        if(!angular.isDate(vm.refDate)) return;
        var items = vm.populate();
        if(angular.equals(items, vm.items)) return;
        vm.items = items;
        vm.adjustSelection(vm.selected);
      });

      $scope.$watch(function() { return vm.minDate }, function() {
        //console.log("[WATCH] TIMEPICKER - MINDATE CHANGE", vm.minDate);
        if(!angular.isDate(vm.minDate)) return;
        var items = vm.populate();
        if(angular.equals(items, vm.items)) return;
        vm.items = items;
        vm.adjustSelection(vm.selected);
      });

      $scope.$watch(function() { return vm.maxDate }, function() {
        //console.log("[WATCH] TIMEPICKER - MAXDATE CHANGE", vm.maxDate);
        if(!angular.isDate(vm.maxDate)) return;
        var items = vm.populate();
        if(angular.equals(items, vm.items)) return;
        vm.items = items;
        vm.adjustSelection(vm.selected);
      });

      $scope.$watch(function() { return vm.model }, function() {
        if(vm.internalModel) {
          //console.log("[WATCH] TIMEPICKER - INTERNAL MODEL CHANGE", vm.model, vm.selected);
          vm.internalModel = false;
          $timeout(vm.change, 0);
          return;
        }
        //console.log("[WATCH] TIMEPICKER - EXTERNAL MODEL CHANGE", vm.model, vm.selected);
        if(vm.model === vm.selected) return;
        if(angular.isString(vm.model) && vm.model !== '') {
          vm.adjustSelection(vm.model);
        }
        else {
          vm.selected = '';
        }
      });

      vm.onSelectedChange = function() {
        if(angular.isUndefined(vm.selected)) {
          if(angular.isUndefined(vm.model) || vm.model == '') return;
          vm.adjustSelection(vm.model);
        }
        if(vm.model === vm.selected) {
          //console.log("[WATCH] TIMEPICKER - INTERNAL SELECTED CHANGE", vm.model, vm.selected);
          vm.internalModel = false;
          $timeout(vm.change, 0);
          return;
        }
        vm.internalModel = true;
        vm.model = vm.selected;
      };


      /**
      * Run Once
      */
      vm.items = vm.populate();
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brTrack', track);

  /** @ngInject */
  function track($segment) {
    var directive = {
      restrict: 'A',
      link: function($scope, $element, $attrs) {
        angular.element($element[0]).bind('click', function ($event) {
          $segment.track($attrs.brTrack);
        });
      }
    };

    return directive;
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brSlider', sliderDirective);

  /** @ngInject */
  function sliderDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        alt: '@?brAlt',
        imgs: '=brImgs',
        sizes: '=?brSizes',
        current: '=?brCurrent',
        path: '@brPath',
        thumbnails: '@?brThumbnails',
        cloudinary: '=?brCloudinary',
        link: '@?brLink',
        click: '&?brClick'
      },
      templateUrl: 'app/components/slider/slider.html',
      controller: 'SliderController',
      controllerAs: 'slider',
      bindToController: true
    };
    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('SliderController', SliderController);

  /** @ngInject */
  function SliderController() {
    var vm = this;

    vm.$onInit = function() {
      if(!angular.isNumber(vm.current)) {
        vm.current = 0;
      }
      if(!angular.isArray(vm.imgs)) {
        vm.imgs = [];
      }
      /**
       * Scope Functions
       */
      vm.nextImg = function() {
        if(!angular.isNumber(vm.current)) vm.current = 0;
        vm.current = (vm.current + 1) % vm.imgs.length;
      };
      vm.prevImg = function() {
        if(!angular.isNumber(vm.current)) vm.current = 0;
        vm.current = (vm.current - 1 + vm.imgs.length) % vm.imgs.length;
      }
      vm.setImg = function(idx) {
        if(!angular.isNumber(idx)) idx = 0;
        if(idx >= vm.imgs.length) idx = 0;
        vm.current = idx;
      }
      vm.filter = function(idx) {
        return idx != vm.current && idx != (vm.current + 1) % vm.imgs.length && idx != (vm.current - 1 + vm.imgs.length) % vm.imgs.length;
      }
      /**
       * Controller Functions
       */

      /**
      * Controller watchers
      */

    };

  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brRequest', requestDirective);

  /** @ngInject */
  function requestDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        requests: '=brRequests'
      },
      templateUrl: 'app/components/request/request.html',
      controller: 'RequestController',
      controllerAs: 'request',
      bindToController: true
    };
    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('RequestController', RequestController);

  /** @ngInject */
  function RequestController() {
    var vm = this;

    vm.$onInit = function() {
      if(!angular.isArray(vm.requests)) {
        vm.requests = [];
      }
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brQuoteDetails', quoteDetailsDirective);

  /** @ngInject */
  function quoteDetailsDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        quote: '=brQuote',
        prefix: '=brPrefix',
        vehicles: '=brVehicles',
        obj: '@brObject'
      },
      templateUrl: 'app/components/quote-details/quote-details.html',
      controller: 'QuoteDetailsController',
      controllerAs: 'details',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('QuoteDetailsController', QuoteDetailsController);

  /** @ngInject */
  function QuoteDetailsController($scope, $timeout, $state, $reject, cloudinary, $filter, $alert, $window, $common, $data) {
    var vm = this;
    vm.cloudinary = cloudinary;

    vm.$onInit = function () {
      console.log(vm.quote)
      vm.id = $state.params.id;
      vm.services = {
        audio: {
          icon: 'icon-music-player',
          name: 'Impianto stereo'
        },
        coffeMachine: {
          icon: 'icon-coffee-machine',
          name: 'Macchina del caffè'
        },
        conditioner: {
          icon: 'icon-air-conditioner',
          name: 'Aria condizionata'
        },
        display: {
          icon: 'icon-monitor',
          name: 'Schermo TV'
        },
        dvdPlayer: {
          icon: 'icon-dvd',
          name: 'Lettore DVD'
        },
        electricity: {
          icon: 'icon-plug',
          name: 'Prese elettriche'
        },
        fridge: {
          icon: 'icon-fridge',
          name: 'Mini Frigorifero'
        },
        kitchen: {
          icon: 'icon-oven',
          name: 'Cucina a bordo'
        },
        leatherSeats: {
          icon: 'icon-leather',
          name: 'Sedili in pelle'
        },
        light: {
          icon: 'icon-idea',
          name: 'Luce da lettura'
        },
        luggage: {
          icon: 'icon-luggage',
          name: 'Vano valige'
        },
        microphone: {
          icon: 'icon-karaoke',
          name: 'Microfono'
        },
        panoramicWindows: {
          icon: 'icon-window',
          name: 'Vetri panoramici'
        },
        radio: {
          icon: 'icon-radio',
          name: 'Radio'
        },
        tintedWindows: {
          icon: 'icon-window-tinted',
          name: 'Vetri oscurati'
        },
        toilet: {
          icon: 'icon-toilet',
          name: 'Toilet'
        },
        tvAerial: {
          icon: 'icon-television',
          name: 'Antenna TV'
        },
        usb: {
          icon: 'icon-usb',
          name: 'Carica USB'
        },
        wheelchair: {
          icon: 'icon-wheelchair',
          name: 'Pedana carrozzine'
        },
        wifi: {
          icon: 'icon-connection',
          name: 'Wi-Fi'
        },
      };
      var serviceList = [
        'audio',
        'coffeMachine',
        'conditioner',
        'display',
        'dvdPlayer',
        'electricity',
        'fridge',
        'kitchen',
        'leatherSeats',
        'light',
        'luggage',
        'microphone',
        'panoramicWindows',
        'radio',
        'tintedWindows',
        'toilet',
        'tvAerial',
        'usb',
        'wheelchair',
        'wifi',
      ];
      vm.hasServices = function () {
        if (vm.quote.Quote.vehicle) {
          for (var i = 0; i < serviceList.length; i++)
            if (vm.quote.Quote.vehicle.services[serviceList[i]])
              return true;
        }
        return false;
      }
      vm.respond = function (response, reason) {
        console.log(reason)
        $scope.$emit('respond', {
          response: response,
          reason: reason
        });
      }

      function min(a, b) {


        if (a > b) return b;
        return a;
      }

      function max(a, b) {


        if (a < b) return b;
        return a;
      }
      vm.reject = function () {
        var data = {};
        $reject.show(data, true, 0, -1, function (cancel) {}, function (accept) {
          vm.respond('rejected-' + accept, data.reason);
        });
      }
      $scope.$watch(function () {
        return vm.quote
      }, function () {

        if (angular.isDefined(vm.quote.Quote.requests)) {
          vm.quote.Quote.total = {
            distance: 0,
            duration: 0,
          }
          vm.quote.Quote.trip = {
            steps: []
          };
          for (var requestIndex = 0; requestIndex < vm.quote.Quote.requests.length; requestIndex++) {
            var request = vm.quote.Quote.requests[requestIndex];
            for (var serviceIndex = 0; serviceIndex < request.services.length; serviceIndex++) {
              var service = request.services[serviceIndex];
              if (service.depart)
                vm.quote.Quote.startdate = vm.quote.Quote.startdate ? new Date(min(vm.quote.Quote.startdate.getTime(), new Date(service.depart).getTime())) : new Date(service.depart);
              if (service.depart)
                vm.quote.Quote.enddate = vm.quote.Quote.enddate ? new Date(max(vm.quote.Quote.enddate.getTime(), new Date(service.depart).getTime())) : new Date(service.depart);
              if (service.type === 'pickup' || service.type === 'transfer' || service.type === 'transit') {
                vm.quote.Quote.trip.steps.push({
                  place: service.place
                });
              }
              if (service.type === 'transfer' && service.directions.total) {

                vm.quote.Quote.total.distance += service.directions.total.distance;
                vm.quote.Quote.total.duration += service.directions.total.duration;
              }
            }
          }

        }
      }, true);
      vm.text = $common.getRequestFullDescription(vm.quote.Quote.requests, vm.quote.Quote.service_type);

      vm.items = [];
      for (var i = 0; i < vm.quote.Quote.requests.length; i++) {
        var request = vm.quote.Quote.requests[i];
        vm.items.push({
          text: 'Itinerario del ' + $filter('dates')(request.services[0].depart),
          link: $common.getDirectionsLink(request)
        })
      }

      vm.copyText = 'Copia itinerario';

      vm.copy = function () {
        vm.copyText = 'copiato!';
        $timeout(function () {
          vm.copyText = 'Copia itinerario';
        }, 1000);
      }
    };
    vm.has = function (role) {
      if (vm.quote.Quote.costs) {
        for (var k = 0; k < vm.quote.Quote.costs.length; k++) {
          if (vm.quote.Quote.costs[k].who === role) return true;
        }
      }
      return false;
    };
    vm.getCosts = function () {
      var total = 0;
      if (vm.quote.Quote.costs) {

        for (var k = 0; k < vm.quote.Quote.costs.length; k++) {
          if (vm.quote.Quote.costs[k].who === 'us') {
            total += vm.quote.Quote.costs[k].value;
          }
        }
      }
      return total;
    }
    vm.getPrice = function () {
      return vm.quote.Quote.partner_price;
    }
    vm.getTotal = function () {
      return vm.getPrice() + vm.getPriceVat() + vm.getCosts() + vm.getCostsVat();
    }

    function roundToTwo(num) {
      return Number(Math.round(num + 'e+2') + 'e-2');
    }

    vm.getPriceVat = function () {
      var total = vm.quote.Quote.partner_price * vm.quote.Quote.vat / 100;
      return roundToTwo(total);
    }
    vm.getCostsVat = function () {
      var total = 0;
      if (vm.quote.Quote.costs) {

        for (var k = 0; k < vm.quote.Quote.costs.length; k++) {
          if (vm.quote.Quote.costs[k].who !== 'partner') {
            total += vm.quote.Quote.costs[k].value * vm.quote.Quote.costs[k].vat / 100;
          }
        }
      }
      return roundToTwo(total);
    }
    function createPDF() {
      pdfMake.vfs['Fontello.ttf'] = $data.Fontello;
      pdfMake.fonts = {
        Fontello: {
          normal: 'Fontello.ttf',
          bold: 'Fontello.ttf',
          italics: 'Fontello.ttf',
          bolditalics: 'Fontello.ttf'
        },
        Roboto: {
          normal: 'Roboto-Regular.ttf',
          bold: 'Roboto-Medium.ttf',
          italics: 'Roboto-Italic.ttf',
          bolditalics: 'Roboto-MediumItalic.ttf'
        }
      }
      var iconContent = {
        "icon-quote-right": "\uf10e",
        "icon-users": "\ue858",
        "icon-arrows-cw": "\ue848",
        "icon-chat-empty": "\uf0e6",
        "icon-logout": "\ue833",
        "icon-user-male": "\ue836",
        "icon-luggage": "\ue80e",
        "icon-eye": "\ue845",
        "icon-window-tinted": "\ue827",
        "icon-cookie": "\ue82f",
        "icon-menu": "\ue81d",
        "icon-thick": "\ue81e",
        "icon-open-down": "\ue81a",
        "icon-music-player": "\ue810",
        "icon-comment": "\ue825",
        "icon-flash": "\ue83a",
        "icon-air-conditioner": "\ue82b",
        "icon-open-right": "\ue819",
        "icon-emo-unhappy": "\ue82a",
        "icon-idea": "\ue806",
        "icon-phone": "\ue828",
        "icon-bus": "\ue83e",
        "icon-leather": "\ue808",
        "icon-lock-open": "\ue82e",
        "icon-cog": "\ue823",
        "icon-arrow-down": "\ue816",
        "icon-open-up": "\ue818",
        "icon-location": "\ue80b",
        "icon-arrow-up": "\ue814",
        "icon-arrow-left": "\ue817",
        "icon-updown-circle": "\ue846",
        "icon-leaf": "\ue837",
        "icon-karaoke": "\ue807",
        "icon-window": "\ue824",
        "icon-spin": "\ue839",
        "icon-open-left": "\ue81b",
        "icon-cancel": "\ue831",
        "icon-child": "\ue83f",
        "icon-clock": "\ue809",
        "icon-star": "\ue80d",
        "icon-dvd": "\ue804",
        "icon-tree": "\uf1bb",
        "icon-docs": "\uf0c5",
        "icon-info": "\ue829",
        "icon-calendar": "\ue841",
        "icon-ok-circle": "\ue859",
        "icon-driver": "\ue826",
        "icon-map": "\ue80a",
        "icon-peoples": "\ue835",
        "icon-facebook-squared": "\uf30e",
        "icon-shield": "\uf132",
        "icon-whatsapp": "\uf232",
        "icon-emo-happy": "\ue82c",
        "icon-login": "\ue832",
        "icon-toilet": "\ue820",
        "icon-plug": "\ue812",
        "icon-heart": "\ue800",
        "icon-television": "\ue81f",
        "icon-credit-card": "\ue83d",
        "icon-oven": "\ue811",
        "icon-pencil": "\ue842",
        "icon-chat": "\ue838",
        "icon-quote-left": "\uf10d",
        "icon-sliders": "\uf1de",
        "icon-basket": "\ue801",
        "icon-twitter": "\uf309",
        "icon-search": "\ue834",
        "icon-coffee-machine": "\ue802",
        "icon-fridge": "\ue805",
        "icon-chart-bar": "\ue843",
        "icon-print": "\ue849",
        "icon-eye-off": "\ue844",
        "icon-globe": "\ue857",
        "icon-monitor": "\ue80f",
        "icon-connection": "\ue803",
        "icon-wheelchair": "\ue822",
        "icon-mail-alt": "\uf0e0",
        "icon-download": "\ue83b",
        "icon-warn": "\ue82d",
        "icon-usb": "\ue821",
        "icon-share": "\ue80c",
        "icon-star-half": "\ue81c",
        "icon-add": "\ue830",
        "icon-arrow-right": "\ue815",
        "icon-radio": "\ue813"
      }
      var services = [];
      var row = [];
      for (var key in vm.services) {
        if (vm.quote.Quote.vehicle.services[key]) {

          row = row.concat([{
            text: iconContent[vm.services[key].icon],
            style: 'icon',
            color: 'red'
          }, {
            text: vm.services[key].name,
            margin: [0, 3, 0, 0]
          }])
          if (row.length == 4) {
            services.push(row)
            row = []
          }
        }
      }
      if (row.length == 2)
        services.push(row.concat(['', '']))
      var content = [{
          // under NodeJS (or in case you use virtual file system provided by pdfmake)
          // you can also pass file names here
          width: 200,
          alignment: 'center',
          image: 'brand',
          margin: [0, 2, 0, 40],

        },
        {
          text: 'Dettagli ordine',
          style: 'header',
          margin: [0, 2, 0, 10],
        },
        {
          layout: 'noBorders', // optional
          margin: [0, 2, 0, 20],
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 0,
            widths: ['*', 200],
            body: [
              ['', ''],

              ['Stato', {
                text: $filter('status')(vm.quote.status),
                style: 'alignR'
              }],
              ['Codice ordine', {
                text: $filter('quoteId')(vm.quote.Quote.id),
                style: 'alignR'
              }],
              ['', ''],
              ['Inizio noleggio', {
                text: $filter('dates')(vm.quote.Quote.startdate),
                style: 'alignR'
              }],
              ['Termine noleggio', {
                text: $filter('dates')(vm.quote.Quote.enddate),
                style: 'alignR'
              }],
              ['', ''],
              ['Totale posti passeggero', {
                text: '' + vm.quote.Quote.onboard.passengers,
                style: 'alignR'
              }],
              ['Totale posti accompagnatore/guida', {
                text: '' + vm.quote.Quote.onboard.others,
                style: 'alignR'
              }],
              ['Totale posti autisti', {
                text: '' + vm.quote.Quote.onboard.drivers,
                style: 'alignR'
              }],
              ['Totale chilometri', {
                text: $filter('distance')(vm.quote.Quote.total.distance),
                style: 'alignR'
              }],
              ['Totale tempo in viaggio', {
                text: $filter('duration')(vm.quote.Quote.total.duration),
                style: 'alignR'
              }],
              ['', ''],
              ['Netto per il noleggio', {
                text: $filter('currency')(vm.getPrice()),
                style: 'alignR'
              }],
              ['IVA noleggio', {
                text: $filter('currency')(vm.getPriceVat()),
                style: 'alignR'
              }],
              ['', ''],
              ['Rimborso spese', {
                text: $filter('currency')(vm.getCosts()),
                style: 'alignR'
              }],
              ['IVA spese', {
                text: $filter('currency')(vm.getCostsVat()),
                style: 'alignR'
              }],
              ['', ''],
              ['Totale', {
                text: $filter('currency')(vm.getTotal()),
                style: 'alignR'
              }],
            ]
          }
        },
        {
          text: 'Itinerario',
          style: 'header',
          margin: [0, 2, 0, 10],
        },
        {
          text: 'Tipologia servizio: ' + vm.quote.Quote.service_type
        },
        {
          text: 'Numero passeggeri: ' + vm.quote.Quote.onboard.passengers
        },
        {
          text: '\n'
        },
        {
          text: $common.getRequestFullDescription(vm.quote.Quote.requests, vm.quote.Quote.service_type)
        },
        {
          text: 'Standard da rispettare',
          style: 'header',
          margin: [0, 2, 0, 10],

        },
        {
          layout: 'noBorders', // optional
          margin: [0, 2, 0, 20],
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 0,
            widths: ['*', 100],
            body: [
              ['Massimale assicurativo minimo', {
                text: $filter('insurance')(vm.quote.Quote.insurance),
                style: 'alignR'
              }],
              ['Minimo classe', {
                text: (vm.quote.Quote.vehicle && vm.quote.Quote.vehicle.specs && vm.quote.Quote.vehicle.specs && vm.quote.Quote.vehicle.specs.emissionClass) || 'EUR2',
                style: 'alignR'
              }],
              ['Anno minimo di immatricolazione', {
                text: (vm.quote.Quote.vehicle && vm.quote.Quote.vehicle.specs && vm.quote.Quote.vehicle.specs && vm.quote.Quote.vehicle.specs.matriculation) || '2012',
                style: 'alignR'
              }],
              ['Posti passeggero', {
                text: '' + ((vm.quote.Quote.vehicle && vm.quote.Quote.vehicle.specs && vm.quote.Quote.vehicle.specs.seats && vm.quote.Quote.vehicle.specs.seats.passengers) ||
                  vm.quote.Quote.onboard.passengers || 1),
                style: 'alignR'
              }],
              ['Numero richiesto di autisti', {
                text: '' + (vm.quote.Quote.onboard.drivers || 1),
                style: 'alignR'
              }],
            ]
          }
        },

      ];
      if (vm.hasServices()) {
        content.push({
          text: 'Minimi servizi a bordo',
          style: 'header1',
          margin: [0, 2, 0, 10],

        });
        content.push({
          layout: 'noBorders', // optional
          margin: [0, 2, 0, 20],
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 0,
            widths: ['auto', '*', 'auto', '*'],
            body: services
          },
        })
      }
      if (vm.quote.Quote.vehicle && vm.quote.Quote.vehicle.specs && (vm.quote.Quote.vehicle.specs.axis || vm.quote.Quote.vehicle.specs.lengthiness || vm.quote.Quote.vehicle.specs.largeness || vm.quote.Quote.vehicle.specs.highness || vm.quote.Quote.vehicle.specs.drivers)) {
        content.push({
          text: 'Specifiche minime veicolo',
          style: 'header1',
          margin: [0, 2, 0, 10],
        });
        var vehicle = []

        if (vm.quote.Quote.vehicle.specs.axis) {
          vehicle.push([
            'Numero di assi',
            vm.quote.Quote.vehicle.specs.axis
          ])
        }
        if (vm.quote.Quote.vehicle.specs.lengthiness) {
          vehicle.push([
            'Lunghezza',
            vm.quote.Quote.vehicle.specs.lengthiness
          ])
        }
        if (vm.quote.Quote.vehicle.specs.largeness) {
          vehicle.push([
            'Larghezza',
            vm.quote.Quote.vehicle.specs.largeness
          ])
        }
        if (vm.quote.Quote.vehicle.specs.highness) {
          vehicle.push([
            'Altezza',
            vm.quote.Quote.vehicle.specs.highness
          ])
        }
        if (vm.quote.Quote.vehicle.specs.drivers) {
          vehicle.push([
            'Posti accompagnatore',
            vm.quote.Quote.vehicle.specs.drivers
          ])
        }
        content.push({
          layout: 'noBorders', // optional
          margin: [0, 2, 0, 20],
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 0,
            widths: ['*', '*'],
            body: vehicle
          },
        });
      }
      if ((vm.quote.Quote.driver_gender && vm.quote.Quote.driver_gender != 'other') || (vm.quote.Quote.driver_dresscode && vm.quote.Quote.driver_dresscode != 'other') || !vm.quote.Quote.driver_smoking || vm.quote.Quote.driver_language || vm.quote.Quote.driver_halal || vm.quote.Quote.driver_other) {

        content.push({
          text: 'Requisiti autista',
          style: 'header1',
          margin: [0, 2, 0, 10],
        });
        if (vm.quote.Quote.driver_gender != 'other') {
          content.push({
            text: $filter('gender')(vm.quote.Quote.driver_gender)
          })
        }
        if (vm.quote.Quote.driver_dresscode != 'other') {
          content.push({
            text: $filter('dresscode')(vm.quote.Quote.driver_dresscode)
          })
        }
        if (vm.quote.Quote.driver_smoking != true) {
          content.push({
            text: $filter('smoking')(vm.quote.Quote.driver_smoking)
          })
        }
        if (vm.quote.Quote.driver_language) {
          content.push({
            text: 'Deve saper parlare:\n' + vm.quote.Quote.driver_language,
            margin: [0, 1]
          })
        }
        if (vm.quote.Quote.driver_halal) {
          content.push({
            text: 'Deve avere la Certificazione Halal'
          })
        }
        if (vm.quote.Quote.driver_other) {
          content.push({
            text: 'Altri requisiti:'
          })
          content.push({
            text: vm.quote.Quote.driver_other
          })
        }
      }
      content.push({
        text: 'Incluso nel prezzo',
        style: 'header',
        margin: [0, 20, 0, 10]

      })
      content.push({
        text: 'Carburante, Pedaggi Autostradali, Assicurazione RCA, Noleggio veicolo, Autisti, IVA',
        margin: [0, 1]

      })
      content.push({
        text: 'Vitto e Alloggio degli Autisti (se necessari)',
        margin: [0, 1]

      })
      content.push({
        text: 'Parcheggi, Checkpoint e ZTL (se necessari)',
        margin: [0, 1]

      })
      content.push({
        text: 'Altri costi aggiuntivi (se necessari)',
        margin: [0, 1]

      })

      for (var i = 0; i < vm.quote.Quote.costs.length; i++) {
        if (vm.quote.Quote.costs[i].who === 'partner') {
          content.push({
            columns: [
              {
                width: '*',
                text: vm.quote.Quote.costs[i].name
              },
              {
                width: '*',
                text: $filter('currency')(vm.quote.Quote.costs[i].value)
              },
              {
                width: '*',
                text: '+ ' + $filter('currency')(vm.quote.Quote.costs[i].value * vm.quote.Quote.costs[i].vat / 100) + ' IVA'
              }
            ]
          })
        }
      }
      var quoteSpec = {
        footer: {
          text: 'Busrapido.com - Richiesta ' + $filter('quoteId')(vm.quote.Quote.id),
          alignment: 'center'
        },
        header: {
          text: 'Busrapido.com - Richiesta ' + $filter('quoteId')(vm.quote.Quote.id),
          margin: [0, 10, 0, 0],
          alignment: 'center'
        },
        content: content,
        styles: {
          header: {
            fontSize: 22,
            bold: true
          },
          header1: {
            fontSize: 14,
            bold: true
          },
          alignR: {
            alignment: 'right'
          },
          icon: {
            fontSize: 22,

            font: 'Fontello'
          }
        },

        images: {
          brand: $data.brand
        }
      }
      console.log(quoteSpec)
      return pdfMake.createPdf(quoteSpec);
      // var pdf = new jsPDF('p', 'pt', 'a4');
      //
      // pdf.fromHTML(
      //   document.getElementById('itinerary')
      // )
      // pdf.save()
    }

    vm.save = function () {
      createPDF().download($filter('quoteId')(vm.quote.Quote.id) + '_Richiesta_Busrapido.pdf')
    }
    vm.print = function () {
      createPDF().print();

    }
    vm.formatDate = function (date) {
      var dateOut = new Date(date);
      return dateOut.toLocaleString();
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brPlacepickerSlim', placepickerDirective);

  /** @ngInject */
  function placepickerDirective(uiGmapGoogleMapApi, $document, $window, $timeout) {

    function triggerKeyboardEvent(element, keyCode) {
      var eventObj;
      if($window.document.createEventObject) {
        eventObj = $window.document.createEventObject();
      }
      else {
        eventObj = $window.document.createEvent("Events");
      }

      if(eventObj.initEvent) {
        eventObj.initEvent("keydown", true, true);
      }
      eventObj.keyCode = keyCode;
      eventObj.which = keyCode;

      if(element.dispatchEvent) {
        element.dispatchEvent(eventObj)
      }
      else {
        element.fireEvent("onkeydown", eventObj);
      }
    }

    function selectFirstOnEnter($scope, input) {
      var listener = function(event) {
        if(input.value) {
          if(event.which == 13 || event.which == 9) { // If enter or tab is pressed
            if(event.which == 13) event.preventDefault();
            var suggestions_avaible = $window.document.getElementsByClassName("pac-item").length;
            if(!suggestions_avaible) {  // If no suggestion is available
              if($scope.placepicker.to && $scope.placepicker.to.address) {
                input.value = $scope.placepicker.to.address;
              }
              else {
                input.value = '';
              }
            }
            else {
              var suggestion_selected = $window.document.getElementsByClassName("pac-item-selected").length;
              if(!suggestion_selected) { // if no suggestion selected
                triggerKeyboardEvent(input, 40);
              }
            }
          }
        }
      };
      if(input.addEventListener) {
        input.addEventListener("keydown", listener);
      }
      else if(input.attachEvent) {
        input.attachEvent("onkeydown", listener);
      }
      $scope.$on('$destroy', function () {
        if(input.removeEventListener) {
          input.removeEventListener("keydown", listener);
        }
        else if (input.detachEvent) {
          input.detachEvent("onkeydown", listener);
        }
      });
    }
    function selectFirstOnPaste($scope, input) {
      var listener = function(event) {
        $timeout(function () {
          var suggestions_avaible = $window.document.getElementsByClassName("pac-item").length;
          if(!suggestions_avaible) {  // If no suggestion is available
            if($scope.placepicker.to && $scope.placepicker.to.address) {
              input.value = $scope.placepicker.to.address;
            }
            else {
              input.value = '';
            }
          }
          else {
            var suggestion_selected = $window.document.getElementsByClassName("pac-item-selected").length;
            if(!suggestion_selected) { // if no suggestion selected
              triggerKeyboardEvent(input, 40);
            }
          }
        }, 250);
      };
      if(input.addEventListener) {
        input.addEventListener("paste", listener);
      }
      else if(input.attachEvent) {
        input.attachEvent("onpaste", listener);
      }
      $scope.$on('$destroy', function () {
        if(input.removeEventListener) {
          input.removeEventListener("paste", listener);
        }
        else if (input.detachEvent) {
          input.detachEvent("onpaste", listener);
        }
      });
    }

    function enableAutocomplete($scope, input, maps) {
      var options = {
        types: [],
        componentRestrictions: {'country': []}
      };
      var autocomplete = new maps.places.Autocomplete(input, options);
      maps.event.addListener(autocomplete, 'place_changed', function() {
        var place = autocomplete.getPlace();
        //console.log("PLACEPICKER: ", place);
        if(angular.isObject(place.geometry)) {
          $scope.placepicker.placeSelected(place.formatted_address, {lat: place.geometry.location.lat(), lng: place.geometry.location.lng()});
        }
      });
      $scope.$on('$destroy', function () {
        maps.event.clearListeners(input);
      });
    }

    var link = function($scope, $elem, $attr) {
      $scope.placepicker.loaded = false;
      uiGmapGoogleMapApi.then(function(maps) {
        var input = $elem.find("input")[0];
        $timeout(function () {
          $scope.placepicker.loaded = true;
        }, 0);

        enableAutocomplete($scope, input, maps);
        selectFirstOnEnter($scope, input);
        selectFirstOnPaste($scope, input);
      });
    };

    var directive = {
      restrict: 'E',
      scope: {
        label: '@brLabel',
        labelBottom: '@brLabelBottom',
        placeholder: '@brPlaceholder',
        info: '@brInfo',
        disabled: '=?brDisabled',
        from: '=?brFrom',
        to: '=brTo',
        enableEmpty: '=brEnableEmpty',
        directions: '=?brDirections',
        departTime: '=?brDepartTime',
        speedLimit: '=?brSpeedLimit',
        hwSpeed: '=?brHwSpeed',
        onCompute: '&?brOnCompute',
        onGeocode: '&?brOnGeocode',
        onSelect: '&?brOnSelect'
      },
      templateUrl: 'app/components/placepicker-slim/placepicker.html',
      controller: 'PlacepickerSlimController',
      controllerAs: 'placepicker',
      bindToController: true,
      link: link
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('PlacepickerSlimController', PlacepickerController);

  /** @ngInject */
  function PlacepickerController($scope, $timeout, $q, uiGmapGoogleMapApi) {
    var vm = this;

    vm.$onInit = function() {
      vm.geocodingCall = 0;
      vm.directionsCall = 0;
      vm.internalTo = false;
      vm.internalFrom = false;
      vm.internalDepart = false;
      vm.validFrom = {address: '', location: {lat: -360, lng: -360}};
      vm.validTo = {address: '', location: {lat: -360, lng: -360}};
      vm.validDirections = {
        total: {duration: 0, distance: 0},
        highway: {distance: 0, duration: 0},
        ferry: {distance: 0, duration: 0},
        city: {distance: 0, duration: 0}
      };
      vm.ignore = {
        to: false,
        from: false,
        departTime: false
      };
      vm.selected = '';

      function validPlace(place) {
        return angular.isObject(place) && place !== null && !angular.isArray(vm.from) && angular.isString(vm.from.address);
      }
      function emptyPlace(place) {
        if(validPlace(place)) return place.address == '';
        return true;
      }
      function validDirections(directions) {
        return (angular.isObject(directions) && directions != null &&
          angular.isObject(directions.total) && directions.total != null &&
          angular.isNumber(directions.total.distance) && angular.isNumber(directions.total.duration) &&
          angular.isObject(directions.highway) && directions.highway != null &&
          angular.isNumber(directions.highway.distance) && angular.isNumber(directions.highway.duration) &&
          angular.isObject(directions.ferry) && directions.ferry != null &&
          angular.isNumber(directions.ferry.distance) && angular.isNumber(directions.ferry.duration) &&
          angular.isObject(directions.city) && directions.city != null &&
          angular.isNumber(directions.city.distance) && angular.isNumber(directions.city.duration));
      }

      if(!angular.isNumber(vm.hwSpeed)) {
        vm.hwSpeed = 80;
      }
      if(!validPlace(vm.from)) {
        vm.from = {address: '', location: {lat: -360, lng: -360}};
      }
      else {
        vm.ignore.from = true
      }
      if(!validPlace(vm.to)) {
        vm.to = {address: '', location: {lat: -360, lng: -360}};
      }
      else {
        vm.ignore.to = true
      }
      if(!angular.isDate(vm.departTime)) {
        vm.departTime = null;
      }
      else {
        vm.ignore.departTime = true
      }
      if(!angular.isObject(vm.directions)) {
        angular.copy(vm.validDirections, vm.directions);
      }

      /**
       * Scope Functions
       */
      vm.placeSelected = function(address, location) {
        //console.log("[FUNC] PLACEPICKER - PLACE SELECTED");
        if(!emptyPlace(vm.from) && vm.from.address == address) {
          vm.selected = vm.to.address;
          $scope.$apply();
          return;
        }
        vm.selected = address;
        vm.geocodingCall = 0;
        vm.directionsCall = 0;
        vm.internalTo = true;
        vm.to = {
          address: address,
          location: {
            lat: location.lat,
            lng: location.lng
          }
        }
        $scope.$apply();
        if(angular.isFunction(vm.onSelect)) vm.onSelect();

        if(angular.isFunction(vm.onGeocode)) vm.onGeocode();

        if(!emptyPlace(vm.from)) {
          $timeout(function() {
            vm.computeDirections(0);
          }, 0);
        }
      };
      vm.resetTo = function() {
        $timeout(function() {
          $scope.$apply(function() {
            vm.internalTo = true;
            angular.copy(vm.validTo, vm.to);
            angular.copy(vm.validDirections, vm.directions);
            vm.selected = vm.to.address;
          });
        }, 0);
      };
      vm.resetFrom = function() {
        $timeout(function() {
          $scope.$apply(function() {
            vm.internalFrom = true;
            angular.copy(vm.validFrom, vm.from);
          });
        }, 0);
      };
      /*vm.computeGeolocation = function() {
        vm.geocodingCall++;
        geocode(vm.geocodingCall, 0);

        function geocode(req, recall) {
          if(vm.geocodingCall !== req) return;
          //console.log("[FUNC] PLACEPICKER - GEOCODE START - req:", req, " - rec", recall);

          getGoogleGeocoding().then(function(service) {
            if(vm.geocodingCall !== req) return;

            var options = {
              address : vm.to
            };
            service.geocode(options, function(response, status) {
              if(vm.geocodingCall !== req) return;

              if(status == vm.maps.GeocoderStatus.OK) {
                vm.geocodingCall = 0;
                vm.location = {lat: response[0].geometry.location.lat(), lng: response[0].geometry.location.lng()};

                if(!angular.isString(vm.from) || vm.from === '') {
                  angular.copy(vm.to, vm.validTo);
                }
                //console.log("[FUNC] PLACEPICKER - GEOCODE END - req:", req, " - rec", recall);

                $scope.$apply();
                if(angular.isFunction(vm.onGeocode)) vm.onGeocode();
              }
              else if(status == vm.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
                recall++;
                $timeout(function() {
                  geocode(vm.geocodingCall, recall)
                }, recall * Math.floor(Math.random() * 200));
              }
              else {
                vm.geocodingCall = 0;
                vm.resetTo();
              }
            });
          });
        }
      };*/
      vm.computeDirections = function(fromorto) {
        vm.directionsCall++;
        directions(vm.directionsCall, 0);

        function directions(req, recall) {
          if(vm.directionsCall !== req) return;
          //console.log("[FUNC] PLACEPICKER - DIRECTIONS START - type:", fromorto, " - req:", req, " - rec", recall);

          getGoogleDirectionsService().then(function(service) {
            if(vm.directionsCall !== req) return;

            var options = {
              origin: vm.from.location,
              destination: vm.to.location,
              travelMode: vm.maps.TravelMode.DRIVING,
              unitSystem: vm.maps.UnitSystem.METRIC,
              avoidHighways: false,
              avoidTolls: false,
              avoidFerries: true
            };
            if(angular.isDate(vm.departTime)) {
              options.drivingOptions = {
                departureTime: vm.departTime,
                trafficModel: google.maps.TrafficModel.PESSIMISTIC
              };
            }
            service.route(options, function(response, status) {
              if(vm.directionsCall !== req) return;

              if(status == vm.maps.DirectionsStatus.OK) {

                var leg = response.routes[0].legs[0];

                if(angular.isNumber(vm.speedLimit)) {
                  setMaxSpeedDuration(leg, vm.speedLimit);
                }
                vm.directionsCall = 0;

                vm.directions = getDirections(leg);
                angular.copy(vm.to, vm.validTo);
                angular.copy(vm.from, vm.validFrom);
                angular.copy(vm.directions, vm.validDirections);

                //console.log("[FUNC] PLACEPICKER - DIRECTIONS DONE - type:", fromorto, " - req:", req, " - rec", recall);

                $scope.$apply();
                if(angular.isFunction(vm.onCompute)) vm.onCompute();
              }
              else if(status == vm.maps.DirectionsStatus.OVER_QUERY_LIMIT) {
                recall++;
                $timeout(function(req, recall) {
                  directions(req, recall)
                }, recall * Math.floor(Math.random() * 200, true, req, recall));
              }
              else {
                vm.directionsCall = 0;
                if(fromorto == 0) {
                  vm.resetTo();
                }
                else if(fromorto == 1) {
                  vm.resetFrom();
                }
              }
            });
          });
        }
      };

      /**
       * Controller Functions
       */
      /*function getGoogleGeocoding() {
        var deferred = $q.defer();
        if(angular.isUndefined(vm.googleGeocodingService)) {
          uiGmapGoogleMapApi.then(function(maps) {
            if(angular.isUndefined(vm.maps)) {
              vm.maps = maps;
            }
            vm.googleGeocodingService = new maps.Geocoder();
            deferred.resolve(vm.googleGeocodingService);
          });
        }
        else {
          deferred.resolve(vm.googleGeocodingService);
        }
        return deferred.promise;
      }*/
      function getGoogleDirectionsService() {
        var deferred = $q.defer();
        if(angular.isUndefined(vm.googleDirectionsService)) {
          uiGmapGoogleMapApi.then(function(maps) {
            if(angular.isUndefined(vm.maps)) {
              vm.maps = maps;
            }
            vm.googleDirectionsService = new maps.DirectionsService();
            deferred.resolve(vm.googleDirectionsService);
          });
        }
        else {
          deferred.resolve(vm.googleDirectionsService);
        }
        return deferred.promise;
      }
      function getDirections(leg) {
        var total = {
          distance: leg.distance.value,
          duration: leg.duration.value
        };
        var highway = {
          distance: 0,
          duration: 0
        };
        var ferry = {
          distance: 0,
          duration: 0
        };
        var city = {
          distance: 0,
          duration: 0
        };
        var hwSpeed = vm.hwSpeed / 3.6;
        for(var i = 0; i < leg.steps.length; i++) {
          if(leg.steps[i].maneuver === 'ferry') {
            ferry.distance += leg.steps[i].distance.value;
            ferry.duration += leg.steps[i].duration.value;
          }
          else {
            var metersecond = leg.steps[i].distance.value / leg.steps[i].duration.value;
            if(metersecond >= hwSpeed) {
              highway.distance += leg.steps[i].distance.value;
              highway.duration += leg.steps[i].duration.value;
            }
          }
        }

        return roundDuration({
          total: total,
          highway: highway,
          ferry: ferry,
          city: city
        });
      }
      function roundDuration(directions) {
        var adjTotal = roundMinutes(directions.total.duration, 15*60);
        var factor = adjTotal / directions.total.duration;
        directions.total.duration = adjTotal;
        directions.highway.duration = Math.ceil(directions.highway.duration*factor);
        directions.ferry.duration = Math.ceil(directions.ferry.duration*factor);

        directions.city.distance = directions.total.distance - directions.ferry.distance - directions.highway.distance;
        directions.city.duration = directions.total.duration - directions.ferry.duration - directions.highway.duration;
        return directions;
      }
      function roundMinutes(seconds, multiple) {
        if(seconds === 0) return seconds;
        if(seconds < multiple) return multiple;
        return (seconds + (multiple - seconds % multiple));
      }
      function setMaxSpeedDuration(leg, speed) {
        var duration = 0;
        var speedLimit = speed / 3.6;
        for(var i = 0; i < leg.steps.length; i++) {
          var metersecond = leg.steps[i].distance.value / leg.steps[i].duration.value;
          if(metersecond > speedLimit) {
            duration += leg.steps[i].distance.value / speedLimit;
            leg.steps[i].duration.value = Math.round(leg.steps[i].distance.value / speedLimit);
          }
          else {
            duration += leg.steps[i].duration.value;
          }
        }
        leg.duration.value = Math.round(duration);
      }
      /**
      * Controller watchers
      */
      $scope.$watch(function() { return vm.selected }, function() {
        if(vm.enableEmpty && vm.selected === '' && !emptyPlace(vm.to) && !vm.ignore.to) {
          vm.internalTo = true;
          vm.to = {address: '', location: {lat: -360, lng: -360}};
          vm.validFrom = {address: '', location: {lat: -360, lng: -360}};
          vm.validTo = {address: '', location: {lat: -360, lng: -360}};
          vm.validDirections = {
            total: {duration: 0, distance: 0},
            highway: {distance: 0, duration: 0},
            ferry: {distance: 0, duration: 0},
            city: {distance: 0, duration: 0}
          };
        }
      });

      $scope.$watch(function() { return vm.from.address }, function() {
        if(vm.internalFrom) {
          //console.log("[WATCH] PLACEPICKER - INTERNAL FROM MODEL CHANGE", vm.from);
          vm.internalFrom = false;
          return;
        }
        //console.log("[WATCH] PLACEPICKER - EXTERNAL FROM MODEL CHANGE", vm.from);
        if(emptyPlace(vm.from) || emptyPlace(vm.to)) {
          vm.ignore.from = false;
          return;
        }
        if(vm.from.address === vm.to.address) {
          vm.ignore.from = false;
          vm.resetFrom();
          return;
        }
        if(!vm.ignore.from || !validDirections(vm.directions)) {
          $timeout(function() {
            vm.computeDirections(1);
          }, 0);
        }
        vm.ignore.from = false;
      });
      $scope.$watch(function() { return vm.departTime }, function() {
        if(vm.internalDepart) {
          //console.log("[WATCH] PLACEPICKER - INTERNAL DEPART TIME CHANGE", vm.departTime);
          vm.internalDepart = false;
          return;
        }
        //console.log("[WATCH] PLACEPICKER - EXTERNAL DEPART TIME CHANGE", vm.departTime);
        if(emptyPlace(vm.from) || emptyPlace(vm.to)) {
          vm.ignore.departTime = false;
          return;
        }

        if(!vm.ignore.departTime || !validDirections(vm.directions)) {
          $timeout(function() {
            vm.computeDirections(0);
          }, 0);
        }
        vm.ignore.departTime = false;
      });
      $scope.$watch(function() { return vm.to }, function() {
        if(vm.internalTo) {
          //console.log("[WATCH] PLACEPICKER - INTERNAL TO ADDRESS CHANGE", vm.to);
          vm.internalTo = false;
          return;
        }
        //console.log("[WATCH] PLACEPICKER - EXTERNAL TO ADDRESS CHANGE", vm.to);

        if(validPlace(vm.to) && vm.to.address === vm.selected) {
          vm.ignore.to = false;
          return;
        }
        if(!validPlace(vm.to) || vm.to.address === '' && vm.to.address !== vm.selected) {
          vm.validTo = {address: '', location: {lat: -360, lng: -360}};
          vm.validDirections = {
            total: {duration: 0, distance: 0},
            highway: {distance: 0, duration: 0},
            ferry: {distance: 0, duration: 0},
            city: {distance: 0, duration: 0}
          };
          if(vm.to.address !== '') {
            vm.internalTo = true;
            vm.to = {address: '', location: {lat: -360, lng: -360}};
          }
          angular.copy(vm.validTo, vm.to);
          angular.copy(vm.validDirections, vm.directions);
          vm.ignore.to = false;
          return;
        }

        vm.selected = vm.to.address;

        if(emptyPlace(vm.from)) {
          angular.copy(vm.to, vm.validTo);
          vm.ignore.to = false;
          return;
        }

        if(vm.ignore.to) {
          angular.copy(vm.to, vm.validTo);
        }

        if(!vm.ignore.to || !validDirections(vm.directions)) {
          $timeout(function() {
            vm.computeDirections(0);
          }, 0);
        }
        else if(vm.ignore.to) {
          angular.copy(vm.from, vm.validFrom);
          angular.copy(vm.directions, vm.validDirections);
        }
        vm.ignore.to = false;
      });
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brplacepickernice', placepickerDirective);

  /** @ngInject */
  function placepickerDirective(uiGmapGoogleMapApi, $document, $window, $timeout) {

    function triggerKeyboardEvent(element, keyCode) {
      var eventObj;
      if($window.document.createEventObject) {
        eventObj = $window.document.createEventObject();
      }
      else {
        eventObj = $window.document.createEvent("Events");
      }

      if(eventObj.initEvent) {
        eventObj.initEvent("keydown", true, true);
      }
      eventObj.keyCode = keyCode;
      eventObj.which = keyCode;

      if(element.dispatchEvent) {
        element.dispatchEvent(eventObj)
      }
      else {
        element.fireEvent("onkeydown", eventObj);
      }
    }

    function selectFirstOnEnter($scope, input) {
      var listener = function(event) {
        if(input.value) {
          if(event.which == 13 || event.which == 9) { // If enter or tab is pressed
            if(event.which == 13) event.preventDefault();
            var suggestions_avaible = $window.document.getElementsByClassName("pac-item").length;
            if(!suggestions_avaible) {  // If no suggestion is available
              if($scope.placepicker.to && $scope.placepicker.to.address) {
                input.value = $scope.placepicker.to.address;
              }
              else {
                input.value = '';
              }
            }
            else {
              var suggestion_selected = $window.document.getElementsByClassName("pac-item-selected").length;
              if(!suggestion_selected) { // if no suggestion selected
                triggerKeyboardEvent(input, 40);
              }
            }
          }
          else {
            $scope.placepicker.to.address = input.value;
          }

        }
      };
      if(input.addEventListener) {
        input.addEventListener("keydown", listener);
      }
      else if(input.attachEvent) {
        input.attachEvent("onkeydown", listener);
      }
      $scope.$on('$destroy', function () {
        if(input.removeEventListener) {
          input.removeEventListener("keydown", listener);
        }
        else if (input.detachEvent) {
          input.detachEvent("onkeydown", listener);
        }
      });
    }
    function selectFirstOnPaste($scope, input) {
      var listener = function(event) {
        $timeout(function () {
          var suggestions_avaible = $window.document.getElementsByClassName("pac-item").length;
          if(!suggestions_avaible) {  // If no suggestion is available
            if($scope.placepicker.to && $scope.placepicker.to.address) {
              input.value = $scope.placepicker.to.address;
            }
            else {
              input.value = '';
            }
          }
          else {
            var suggestion_selected = $window.document.getElementsByClassName("pac-item-selected").length;
            if(!suggestion_selected) { // if no suggestion selected
              triggerKeyboardEvent(input, 40);
            }
          }
        }, 250);
      };
      if(input.addEventListener) {
        input.addEventListener("paste", listener);
      }
      else if(input.attachEvent) {
        input.attachEvent("onpaste", listener);
      }
      $scope.$on('$destroy', function () {
        if(input.removeEventListener) {
          input.removeEventListener("paste", listener);
        }
        else if (input.detachEvent) {
          input.detachEvent("onpaste", listener);
        }
      });
    }

    function enableAutocomplete($scope, input, maps) {
      var options = {
        types: [],
        componentRestrictions: {'country': []}
      };
      var autocomplete = new maps.places.Autocomplete(input, options);
      maps.event.addListener(autocomplete, 'place_changed', function() {
        var place = autocomplete.getPlace();
        //console.log("PLACEPICKER: ", place);
        if(angular.isObject(place.geometry)) {
          $scope.placepicker.placeSelected(place.formatted_address, {lat: place.geometry.location.lat(), lng: place.geometry.location.lng()});
        }
      });
      $scope.$on('$destroy', function () {
        maps.event.clearListeners(input);
      });
    }

    var link = function($scope, $elem, $attr) {
      $scope.placepicker.loaded = false;
      uiGmapGoogleMapApi.then(function(maps) {
        var input = $elem.find("input")[0];
        $timeout(function () {
          $scope.placepicker.loaded = true;
        }, 0);

        enableAutocomplete($scope, input, maps);
        selectFirstOnEnter($scope, input);
        selectFirstOnPaste($scope, input);
      });
    };

    var directive = {
      restrict: 'E',
      scope: {
        label: '@brLabel',
        labelBottom: '@brLabelBottom',
        placeholder: '@brPlaceholder',
        info: '@brInfo',
        disabled: '=?brDisabled',
        from: '=?brFrom',
        to: '=brTo',
        enableEmpty: '=brEnableEmpty',
        directions: '=?brDirections',
        departTime: '=?brDepartTime',
        speedLimit: '=?brSpeedLimit',
        hwSpeed: '=?brHwSpeed',
        onCompute: '&?brOnCompute',
        onGeocode: '&?brOnGeocode',
        onSelect: '&?brOnSelect'
      },
      templateUrl: 'app/components/placepicker-nice/placepicker.html',
      controller: 'PlacepickerNiceController',
      controllerAs: 'placepicker',
      bindToController: true,
      link: link
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('PlacepickerNiceController', PlacepickerController);

  /** @ngInject */
  function PlacepickerController($scope, $timeout, $q, uiGmapGoogleMapApi) {
    var vm = this;

    vm.$onInit = function() {
      vm.geocodingCall = 0;
      vm.directionsCall = 0;
      vm.internalTo = false;
      vm.internalFrom = false;
      vm.internalDepart = false;
      vm.validFrom = {address: '', location: {lat: -360, lng: -360}};
      vm.validTo = {address: '', location: {lat: -360, lng: -360}};
      vm.validDirections = {
        total: {duration: 0, distance: 0},
        highway: {distance: 0, duration: 0},
        ferry: {distance: 0, duration: 0},
        city: {distance: 0, duration: 0}
      };
      vm.ignore = {
        to: false,
        from: false,
        departTime: false
      };
      vm.selected = '';

      function validPlace(place) {
        return angular.isObject(place) && place !== null && !angular.isArray(vm.from) && angular.isString(vm.from.address);
      }
      function emptyPlace(place) {
        if(validPlace(place)) return place.address == '';
        return true;
      }
      function validDirections(directions) {
        return (angular.isObject(directions) && directions != null &&
          angular.isObject(directions.total) && directions.total != null &&
          angular.isNumber(directions.total.distance) && angular.isNumber(directions.total.duration) &&
          angular.isObject(directions.highway) && directions.highway != null &&
          angular.isNumber(directions.highway.distance) && angular.isNumber(directions.highway.duration) &&
          angular.isObject(directions.ferry) && directions.ferry != null &&
          angular.isNumber(directions.ferry.distance) && angular.isNumber(directions.ferry.duration) &&
          angular.isObject(directions.city) && directions.city != null &&
          angular.isNumber(directions.city.distance) && angular.isNumber(directions.city.duration));
      }

      if(!angular.isNumber(vm.hwSpeed)) {
        vm.hwSpeed = 80;
      }
      if(!validPlace(vm.from)) {
        vm.from = {address: '', location: {lat: -360, lng: -360}};
      }
      else {
        vm.ignore.from = true
      }
      if(!validPlace(vm.to)) {
        vm.to = {address: '', location: {lat: -360, lng: -360}};
      }
      else {
        vm.ignore.to = true
      }
      if(!angular.isDate(vm.departTime)) {
        vm.departTime = null;
      }
      else {
        vm.ignore.departTime = true
      }
      if(!angular.isObject(vm.directions)) {
        angular.copy(vm.validDirections, vm.directions);
      }

      /**
       * Scope Functions
       */
      vm.placeSelected = function(address, location) {
        //console.log("[FUNC] PLACEPICKER - PLACE SELECTED");
        if(!emptyPlace(vm.from) && vm.from.address == address) {
          vm.selected = vm.to.address;
          $scope.$apply();
          return;
        }
        vm.selected = address;
        vm.geocodingCall = 0;
        vm.directionsCall = 0;
        vm.internalTo = true;
        vm.to = {
          address: address,
          location: {
            lat: location.lat,
            lng: location.lng
          }
        }
        $scope.$apply();
        if(angular.isFunction(vm.onSelect)) vm.onSelect();

        if(angular.isFunction(vm.onGeocode)) vm.onGeocode();

        if(!emptyPlace(vm.from)) {
          $timeout(function() {
            vm.computeDirections(0);
          }, 0);
        }
      };
      vm.resetTo = function() {
        $timeout(function() {
          $scope.$apply(function() {
            vm.internalTo = true;
            angular.copy(vm.validTo, vm.to);
            angular.copy(vm.validDirections, vm.directions);
            vm.selected = vm.to.address;
          });
        }, 0);
      };
      vm.resetFrom = function() {
        $timeout(function() {
          $scope.$apply(function() {
            vm.internalFrom = true;
            angular.copy(vm.validFrom, vm.from);
          });
        }, 0);
      };
      /*
        vm.computeGeolocation = function() {
        vm.geocodingCall++;
        geocode(vm.geocodingCall, 0);

        function geocode(req, recall) {
          if(vm.geocodingCall !== req) return;
          //console.log("[FUNC] PLACEPICKER - GEOCODE START - req:", req, " - rec", recall);

          getGoogleGeocoding().then(function(service) {
            if(vm.geocodingCall !== req) return;

            var options = {
              address : vm.to
            };
            service.geocode(options, function(response, status) {
              if(vm.geocodingCall !== req) return;

              if(status == vm.maps.GeocoderStatus.OK) {
                vm.geocodingCall = 0;
                vm.location = {lat: response[0].geometry.location.lat(), lng: response[0].geometry.location.lng()};

                if(!angular.isString(vm.from) || vm.from === '') {
                  angular.copy(vm.to, vm.validTo);
                }
                //console.log("[FUNC] PLACEPICKER - GEOCODE END - req:", req, " - rec", recall);

                $scope.$apply();
                if(angular.isFunction(vm.onGeocode)) vm.onGeocode();
              }
              else if(status == vm.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
                recall++;
                $timeout(function() {
                  geocode(vm.geocodingCall, recall)
                }, recall * Math.floor(Math.random() * 200));
              }
              else {
                vm.geocodingCall = 0;
                vm.resetTo();
              }
            });
          });
        }
        };
      */
      vm.computeDirections = function(fromorto) {
        vm.directionsCall++;
        directions(vm.directionsCall, 0);

        function directions(req, recall) {
          if(vm.directionsCall !== req) return;
          //console.log("[FUNC] PLACEPICKER - DIRECTIONS START - type:", fromorto, " - req:", req, " - rec", recall);

          getGoogleDirectionsService().then(function(service) {
            if(vm.directionsCall !== req) return;

            var options = {
              origin: vm.from.location,
              destination: vm.to.location,
              travelMode: vm.maps.TravelMode.DRIVING,
              unitSystem: vm.maps.UnitSystem.METRIC,
              avoidHighways: false,
              avoidTolls: false,
              avoidFerries: true
            };
            if(angular.isDate(vm.departTime)) {
              options.drivingOptions = {
                departureTime: vm.departTime,
                trafficModel: google.maps.TrafficModel.PESSIMISTIC
              };
            }
            service.route(options, function(response, status) {
              if(vm.directionsCall !== req) return;

              if(status == vm.maps.DirectionsStatus.OK) {

                var leg = response.routes[0].legs[0];

                if(angular.isNumber(vm.speedLimit)) {
                  setMaxSpeedDuration(leg, vm.speedLimit);
                }
                vm.directionsCall = 0;

                vm.directions = getDirections(leg);
                angular.copy(vm.to, vm.validTo);
                angular.copy(vm.from, vm.validFrom);
                angular.copy(vm.directions, vm.validDirections);

                //console.log("[FUNC] PLACEPICKER - DIRECTIONS DONE - type:", fromorto, " - req:", req, " - rec", recall);

                $scope.$apply();
                if(angular.isFunction(vm.onCompute)) vm.onCompute();
              }
              else if(status == vm.maps.DirectionsStatus.OVER_QUERY_LIMIT) {
                recall++;
                $timeout(function(req, recall) {
                  directions(req, recall)
                }, recall * Math.floor(Math.random() * 200, true, req, recall));
              }
              else {
                vm.directionsCall = 0;
                if(fromorto == 0) {
                  vm.resetTo();
                }
                else if(fromorto == 1) {
                  vm.resetFrom();
                }
              }
            });
          });
        }
      };

      /**
       * Controller Functions
       */
      /*function getGoogleGeocoding() {
        var deferred = $q.defer();
        if(angular.isUndefined(vm.googleGeocodingService)) {
          uiGmapGoogleMapApi.then(function(maps) {
            if(angular.isUndefined(vm.maps)) {
              vm.maps = maps;
            }
            vm.googleGeocodingService = new maps.Geocoder();
            deferred.resolve(vm.googleGeocodingService);
          });
        }
        else {
          deferred.resolve(vm.googleGeocodingService);
        }
        return deferred.promise;
      }*/
      function getGoogleDirectionsService() {
        var deferred = $q.defer();
        if(angular.isUndefined(vm.googleDirectionsService)) {
          uiGmapGoogleMapApi.then(function(maps) {
            if(angular.isUndefined(vm.maps)) {
              vm.maps = maps;
            }
            vm.googleDirectionsService = new maps.DirectionsService();
            deferred.resolve(vm.googleDirectionsService);
          });
        }
        else {
          deferred.resolve(vm.googleDirectionsService);
        }
        return deferred.promise;
      }
      function getDirections(leg) {
        var total = {
          distance: leg.distance.value,
          duration: leg.duration.value
        };
        var highway = {
          distance: 0,
          duration: 0
        };
        var ferry = {
          distance: 0,
          duration: 0
        };
        var city = {
          distance: 0,
          duration: 0
        };
        var hwSpeed = vm.hwSpeed / 3.6;
        for(var i = 0; i < leg.steps.length; i++) {
          if(leg.steps[i].maneuver === 'ferry') {
            ferry.distance += leg.steps[i].distance.value;
            ferry.duration += leg.steps[i].duration.value;
          }
          else {
            var metersecond = leg.steps[i].distance.value / leg.steps[i].duration.value;
            if(metersecond >= hwSpeed) {
              highway.distance += leg.steps[i].distance.value;
              highway.duration += leg.steps[i].duration.value;
            }
          }
        }

        return roundDuration({
          total: total,
          highway: highway,
          ferry: ferry,
          city: city
        });
      }
      function roundDuration(directions) {
        var adjTotal = roundMinutes(directions.total.duration, 15*60);
        var factor = adjTotal / directions.total.duration;
        directions.total.duration = adjTotal;
        directions.highway.duration = Math.ceil(directions.highway.duration*factor);
        directions.ferry.duration = Math.ceil(directions.ferry.duration*factor);

        directions.city.distance = directions.total.distance - directions.ferry.distance - directions.highway.distance;
        directions.city.duration = directions.total.duration - directions.ferry.duration - directions.highway.duration;
        return directions;
      }
      function roundMinutes(seconds, multiple) {
        if(seconds === 0) return seconds;
        if(seconds < multiple) return multiple;
        return (seconds + (multiple - seconds % multiple));
      }
      function setMaxSpeedDuration(leg, speed) {
        var duration = 0;
        var speedLimit = speed / 3.6;
        for(var i = 0; i < leg.steps.length; i++) {
          var metersecond = leg.steps[i].distance.value / leg.steps[i].duration.value;
          if(metersecond > speedLimit) {
            duration += leg.steps[i].distance.value / speedLimit;
            leg.steps[i].duration.value = Math.round(leg.steps[i].distance.value / speedLimit);
          }
          else {
            duration += leg.steps[i].duration.value;
          }
        }
        leg.duration.value = Math.round(duration);
      }
      /**
      * Controller watchers
      */
      $scope.$watch(function() { return vm.selected }, function() {
        if(vm.enableEmpty && vm.selected === '' && !emptyPlace(vm.to) && !vm.ignore.to) {
          vm.internalTo = true;
          vm.to = {address: '', location: {lat: -360, lng: -360}};
          vm.validFrom = {address: '', location: {lat: -360, lng: -360}};
          vm.validTo = {address: '', location: {lat: -360, lng: -360}};
          vm.validDirections = {
            total: {duration: 0, distance: 0},
            highway: {distance: 0, duration: 0},
            ferry: {distance: 0, duration: 0},
            city: {distance: 0, duration: 0}
          };
        }
      });

      $scope.$watch(function() { return vm.from.address }, function() {
        if(vm.internalFrom) {
          //console.log("[WATCH] PLACEPICKER - INTERNAL FROM MODEL CHANGE", vm.from);
          vm.internalFrom = false;
          return;
        }
        //console.log("[WATCH] PLACEPICKER - EXTERNAL FROM MODEL CHANGE", vm.from);
        if(emptyPlace(vm.from) || emptyPlace(vm.to)) {
          vm.ignore.from = false;
          return;
        }
        if(vm.from.address === vm.to.address) {
          vm.ignore.from = false;
          vm.resetFrom();
          return;
        }
        if(!vm.ignore.from || !validDirections(vm.directions)) {
          $timeout(function() {
            vm.computeDirections(1);
          }, 0);
        }
        vm.ignore.from = false;
      });
      $scope.$watch(function() { return vm.departTime }, function() {
        if(vm.internalDepart) {
          //console.log("[WATCH] PLACEPICKER - INTERNAL DEPART TIME CHANGE", vm.departTime);
          vm.internalDepart = false;
          return;
        }
        //console.log("[WATCH] PLACEPICKER - EXTERNAL DEPART TIME CHANGE", vm.departTime);
        if(emptyPlace(vm.from) || emptyPlace(vm.to)) {
          vm.ignore.departTime = false;
          return;
        }

        if(!vm.ignore.departTime || !validDirections(vm.directions)) {
          $timeout(function() {
            vm.computeDirections(0);
          }, 0);
        }
        vm.ignore.departTime = false;
      });
      $scope.$watch(function() { return vm.to }, function() {
        if(vm.internalTo) {
          //console.log("[WATCH] PLACEPICKER - INTERNAL TO ADDRESS CHANGE", vm.to);
          vm.internalTo = false;
          return;
        }
        //console.log("[WATCH] PLACEPICKER - EXTERNAL TO ADDRESS CHANGE", vm.to);

        if(validPlace(vm.to) && vm.to.address === vm.selected) {
          vm.ignore.to = false;
          return;
        }
        if(!validPlace(vm.to) || vm.to.address === '' && vm.to.address !== vm.selected) {
          vm.validTo = {address: '', location: {lat: -360, lng: -360}};
          vm.validDirections = {
            total: {duration: 0, distance: 0},
            highway: {distance: 0, duration: 0},
            ferry: {distance: 0, duration: 0},
            city: {distance: 0, duration: 0}
          };
          if(vm.to.address !== '') {
            vm.internalTo = true;
            vm.to = {address: '', location: {lat: -360, lng: -360}};
          }
          angular.copy(vm.validTo, vm.to);
          angular.copy(vm.validDirections, vm.directions);
          vm.ignore.to = false;
          return;
        }

        vm.selected = vm.to.address;

        if(emptyPlace(vm.from)) {
          angular.copy(vm.to, vm.validTo);
          vm.ignore.to = false;
          return;
        }

        if(vm.ignore.to) {
          angular.copy(vm.to, vm.validTo);
        }

        if(!vm.ignore.to || !validDirections(vm.directions)) {
          $timeout(function() {
            vm.computeDirections(0);
          }, 0);
        }
        else if(vm.ignore.to) {
          angular.copy(vm.from, vm.validFrom);
          angular.copy(vm.directions, vm.validDirections);
        }
        vm.ignore.to = false;
      });
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brPlacepickerFast', placepickerFastDirective);

  /** @ngInject */
  function placepickerFastDirective($document, $window, $timeout) {

    function triggerKeyboardEvent(element, keyCode) {
      var eventObj;
      if($window.document.createEventObject) {
        eventObj = $window.document.createEventObject();
      }
      else {
        eventObj = $window.document.createEvent("Events");
      }

      if(eventObj.initEvent) {
        eventObj.initEvent("keydown", true, true);
      }
      eventObj.keyCode = keyCode;
      eventObj.which = keyCode;

      if(element.dispatchEvent) {
        element.dispatchEvent(eventObj)
      }
      else {
        element.fireEvent("onkeydown", eventObj);
      }
    }

    function selectFirstOnEnter($scope, input) {
      var listener = function(event) {
        if(input.value) {
          if(event.which == 13 || event.which == 9) { // If enter or tab is pressed
            if(event.which == 13) event.preventDefault();
            var suggestions_avaible = $window.document.getElementsByClassName("pac-item").length;
            if(!suggestions_avaible) {  // If no suggestion is available
              console.log($scope.placepicker.to)
              if($scope.placepicker.to && $scope.placepicker.to.address) {
                input.value = $scope.placepicker.to.address;
              }
              else {
                input.value = '';
              }
            }
            else {
              var suggestion_selected = $window.document.getElementsByClassName("pac-item-selected").length;
              if(!suggestion_selected) { // if no suggestion selected
                triggerKeyboardEvent(input, 40);
              }
            }
          }
        }
      };
      if(input.addEventListener) {
        input.addEventListener("keydown", listener);
      }
      else if(input.attachEvent) {
        input.attachEvent("onkeydown", listener);
      }
      $scope.$on('$destroy', function () {
        if(input.removeEventListener) {
          input.removeEventListener("keydown", listener);
        }
        else if (input.detachEvent) {
          input.detachEvent("onkeydown", listener);
        }
      });
    }
    function selectFirstOnPaste($scope, input) {
      var listener = function(event) {
        $timeout(function () {
          var suggestions_avaible = $window.document.getElementsByClassName("pac-item").length;
          if(!suggestions_avaible) {  // If no suggestion is available
            if($scope.placepicker.to && $scope.placepicker.to.address) {
              input.value = $scope.placepicker.to.address;
            }
            else {
              input.value = '';
            }
          }
          else {
            var suggestion_selected = $window.document.getElementsByClassName("pac-item-selected").length;
            if(!suggestion_selected) { // if no suggestion selected
              triggerKeyboardEvent(input, 40);
            }
          }
        }, 250);
      };
      if(input.addEventListener) {
        input.addEventListener("paste", listener);
      }
      else if(input.attachEvent) {
        input.attachEvent("onpaste", listener);
      }
      $scope.$on('$destroy', function () {
        if(input.removeEventListener) {
          input.removeEventListener("paste", listener);
        }
        else if (input.detachEvent) {
          input.detachEvent("onpaste", listener);
        }
      });
    }

    function enableAutocomplete($scope, input, maps) {
      var options = {
        types: [],
        componentRestrictions: {'country': []}
      };
      var autocomplete = new maps.places.Autocomplete(input, options);
      maps.event.addListener(autocomplete, 'place_changed', function() {
        var place = autocomplete.getPlace();
        console.log("PLACEPICKER: ", place);
        if(angular.isObject(place.geometry)) {
          console.log(place)
          $scope.placepicker.placeSelected(place.formatted_address, {lat: place.geometry.location.lat(), lng: place.geometry.location.lng()}, place.address_components);
        }
      });
      $scope.$on('$destroy', function () {
        maps.event.clearListeners(input);
      });
    }

    var link = function($scope, $elem, $attr) {
      var maps = $scope.placepicker.maps;
    //console.log($scope.placepicker)
      $scope.placepicker.loaded = true;
      var input = $elem.find("input")[0];
      enableAutocomplete($scope, input, maps);
      selectFirstOnEnter($scope, input);
        selectFirstOnPaste($scope, input);
    };

    var directive = {
      restrict: 'E',
      scope: {
        label: '@brLabel',
        labelBottom: '@brLabelBottom',
        placeholder: '@brPlaceholder',
        info: '@brInfo',
        disabled: '=?brDisabled',
        from: '=?brFrom',
        to: '=brTo',
        enableEmpty: '=brEnableEmpty',
        directions: '=?brDirections',
        departTime: '=?brDepartTime',
        speedLimit: '=?brSpeedLimit',
        hwSpeed: '=?brHwSpeed',
        onCompute: '&?brOnCompute',
        onGeocode: '&?brOnGeocode',
        onSelect: '&?brOnSelect',
        waypoints: '=brWaypoints',
        maps: '=brMaps',
        googleDirectionsService: '=brGoogleDirectionsService'
      },
      templateUrl: 'app/components/placepicker-fast/placepicker.html',
      controller: 'PlacepickerFastController',
      controllerAs: 'placepicker',
      bindToController: true,
      link: link
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('PlacepickerFastController', PlacepickerFastController);

  /** @ngInject */
  function PlacepickerFastController($scope, $timeout, $q, uiGmapGoogleMapApi, $window) {
    var vm = this;

    vm.$onInit = function() {
      vm.geocodingCall = 0;
      vm.directionsCall = 0;
      vm.internalTo = false;
      vm.internalFrom = false;
      vm.internalDepart = false;
      vm.validFrom = {address: '', location: {lat: -360, lng: -360}};
      vm.validTo = {address: '', location: {lat: -360, lng: -360}};
      vm.validDirections = {
        total: {duration: 0, distance: 0},
        highway: {distance: 0, duration: 0},
        ferry: {distance: 0, duration: 0},
        city: {distance: 0, duration: 0}
      };
      vm.ignore = {
        to: false,
        from: false,
        departTime: false
      };
      vm.selected = '';

      function validPlace(place) {
        return angular.isObject(place) && place !== null && !angular.isArray(vm.from) && angular.isString(vm.from.address);
      }
      function emptyPlace(place) {
        if(validPlace(place)) return place.address == '';
        return true;
      }
      function validDirections(directions) {
        return (angular.isObject(directions) && directions != null &&
          angular.isObject(directions.total) && directions.total != null &&
          angular.isNumber(directions.total.distance) && angular.isNumber(directions.total.duration) &&
          angular.isObject(directions.highway) && directions.highway != null &&
          angular.isNumber(directions.highway.distance) && angular.isNumber(directions.highway.duration) &&
          angular.isObject(directions.ferry) && directions.ferry != null &&
          angular.isNumber(directions.ferry.distance) && angular.isNumber(directions.ferry.duration) &&
          angular.isObject(directions.city) && directions.city != null &&
          angular.isNumber(directions.city.distance) && angular.isNumber(directions.city.duration));
      }

      if(!angular.isNumber(vm.hwSpeed)) {
        vm.hwSpeed = 80;
      }
      if(!validPlace(vm.from)) {
        vm.from = {address: '', location: {lat: -360, lng: -360}};
      }
      else {
        vm.ignore.from = true
      }
      if(!validPlace(vm.to)) {
        vm.to = {address: '', location: {lat: -360, lng: -360}};
      }
      else {
        vm.ignore.to = true
      }
      if(!angular.isDate(vm.departTime)) {
        vm.departTime = null;
      }
      else {
        vm.ignore.departTime = true
      }
      if(!angular.isObject(vm.directions)) {
        angular.copy(vm.validDirections, vm.directions);
      }

      vm.showStreetView = function() {
        var link = angular.element('<a/>');

        link.css({ display: 'none' });
        link.attr({
          href: 'https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=' + vm.to.location.lat + ',' + vm.to.location.lng + '&heading=-45&pitch=38&fov=80',
          target: '_blank',
          // download: 'aziende.csv'
        })
        link[0].click();
        // clean up
        link.remove();
      }

      /**
       * Scope Functions
       */
      vm.placeSelected = function(address, location, components) {
        console.log("[FUNC] PLACEPICKER - PLACE SELECTED", components);

        console.log(address)
        console.log("PLACEPICKER - PLACE SELECTED");
        if(!emptyPlace(vm.from) && vm.from.address == address) {
          vm.selected = vm.to.address;
          $scope.$apply();
          return;
        }
        vm.selected = address;
        vm.geocodingCall = 0;
        vm.directionsCall = 0;
        vm.internalTo = true;
        vm.to = {
          address: address,
          location: {
            lat: location.lat,
            lng: location.lng
          },
          components: components
        }
        $scope.$apply();
        if(angular.isFunction(vm.onSelect)) vm.onSelect();

        if(angular.isFunction(vm.onGeocode)) vm.onGeocode();

        if(!emptyPlace(vm.from)) {
          $timeout(function() {
            vm.computeDirections(0);
          }, 0);
        }
      };
      vm.resetTo = function() {
        $timeout(function() {
          $scope.$apply(function() {
            vm.internalTo = true;
            angular.copy(vm.validTo, vm.to);
            angular.copy(vm.validDirections, vm.directions);
            vm.selected = vm.to.address;
          });
        }, 0);
      };
      vm.resetFrom = function() {
        $timeout(function() {
          $scope.$apply(function() {
            vm.internalFrom = true;
            angular.copy(vm.validFrom, vm.from);
          });
        }, 0);
      };
      /*vm.computeGeolocation = function() {
        vm.geocodingCall++;
        geocode(vm.geocodingCall, 0);

        function geocode(req, recall) {
          if(vm.geocodingCall !== req) return;
          //console.log("[FUNC] PLACEPICKER - GEOCODE START - req:", req, " - rec", recall);

          getGoogleGeocoding().then(function(service) {
            if(vm.geocodingCall !== req) return;

            var options = {
              address : vm.to
            };
            service.geocode(options, function(response, status) {
              if(vm.geocodingCall !== req) return;

              if(status == vm.maps.GeocoderStatus.OK) {
                vm.geocodingCall = 0;
                vm.location = {lat: response[0].geometry.location.lat(), lng: response[0].geometry.location.lng()};

                if(!angular.isString(vm.from) || vm.from === '') {
                  angular.copy(vm.to, vm.validTo);
                }
                //console.log("[FUNC] PLACEPICKER - GEOCODE END - req:", req, " - rec", recall);

                $scope.$apply();
                if(angular.isFunction(vm.onGeocode)) vm.onGeocode();
              }
              else if(status == vm.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
                recall++;
                $timeout(function() {
                  geocode(vm.geocodingCall, recall)
                }, recall * Math.floor(Math.random() * 200));
              }
              else {
                vm.geocodingCall = 0;
                vm.resetTo();
              }
            });
          });
        }
      };*/

      function getGoogleDirectionsService() {
        var deferred = $q.defer();
        if(angular.isUndefined(vm.googleDirectionsService)) {
          uiGmapGoogleMapApi.then(function(maps) {
            if(angular.isUndefined(vm.maps)) {
              vm.maps = maps;
            }
            vm.googleDirectionsService = new maps.DirectionsService();
            deferred.resolve(vm.googleDirectionsService);
          });
        }
        else {
          deferred.resolve(vm.googleDirectionsService);
        }
        return deferred.promise;
      }
      vm.computeDirections = function(fromorto) {
      //console.log(fromorto)
        vm.directionsCall++;
        directions(vm.directionsCall, 0);

        function directions(req, recall) {
          if(vm.directionsCall !== req) return;
          //console.log("[FUNC] PLACEPICKER - DIRECTIONS START - type:", fromorto, " - req:", req, " - rec", recall);

          getGoogleDirectionsService().then(function(service) {
            if(vm.directionsCall !== req) return;

            var options = {
              origin: vm.from.location,
              destination: vm.to.location,
              travelMode: vm.maps.TravelMode.DRIVING,
              unitSystem: vm.maps.UnitSystem.METRIC,
              avoidHighways: false,
              avoidTolls: false,
              avoidFerries: true,
              waypoints: vm.waypoints
            };
            if(angular.isDate(vm.departTime)) {
              options.drivingOptions = {
                departureTime: vm.departTime,
                trafficModel: google.maps.TrafficModel.PESSIMISTIC
              };
            }
          //console.log(options)
            function sumDirections(a, b) {
              return roundDuration({
                total: {
                  distance: a.total.distance + b.total.distance,
                  duration: a.total.duration + b.total.duration,
                },
                highway: {
                  distance: a.highway.distance + b.highway.distance,
                  duration: a.highway.duration + b.highway.duration,

                },
                ferry: {
                  distance: a.ferry.distance + b.ferry.distance,
                  duration: a.ferry.duration + b.ferry.duration,

                },
                city: {
                  distance: a.city.distance + b.city.distance,
                  duration: a.city.duration + b.city.duration,

                }
              });
            }
            service.route(options, function(response, status) {
              if(vm.directionsCall !== req) return;
            console.log('AAAAAAAAAA ')
            console.log(response)

              if(status == vm.maps.DirectionsStatus.OK) {
                var computedDirections = {
                  total: {distance: 0, duration: 0},
                  highway: {distance: 0, duration: 0},
                  ferry: {distance: 0, duration: 0},
                  city: {distance: 0, duration: 0},
                };
                for (var legIndex = 0; legIndex < response.routes[0].legs.length; legIndex++) {
                  var leg = response.routes[0].legs[0];

                  if(angular.isNumber(vm.speedLimit)) {
                    setMaxSpeedDuration(leg, vm.speedLimit);
                  }

                //console.log(response)
                  computedDirections = sumDirections(computedDirections, getDirections(leg));
                }
                vm.directionsCall = 0;
                vm.directions = computedDirections;
              //console.log(vm.directions)
                angular.copy(vm.to, vm.validTo);
                angular.copy(vm.from, vm.validFrom);
                angular.copy(vm.directions, vm.validDirections);
                //console.log("[FUNC] PLACEPICKER - DIRECTIONS DONE - type:", fromorto, " - req:", req, " - rec", recall);

                $scope.$apply();
                if(angular.isFunction(vm.onCompute)) vm.onCompute();
              }
              else if(status == vm.maps.DirectionsStatus.OVER_QUERY_LIMIT) {
              //console.log('AAAAAAAAAA ' + status)

                recall++;
                $timeout(function(req, recall) {
                  directions(req, recall)
                }, recall * Math.floor(Math.random() * 200, true, req, recall));
              }
              else {
                vm.directionsCall = 0;
                $scope.$emit('directionsError', status);
                console.log('AAAAAAAAAA ' + status)
                if(fromorto == 0) {
                  vm.resetTo();
                }
                else if(fromorto == 1) {
                  vm.resetFrom();
                }
              }
            });
          });
        }
      };

      /**
       * Controller Functions
       */
      /*function getGoogleGeocoding() {
        var deferred = $q.defer();
        if(angular.isUndefined(vm.googleGeocodingService)) {
          uiGmapGoogleMapApi.then(function(maps) {
            if(angular.isUndefined(vm.maps)) {
              vm.maps = maps;
            }
            vm.googleGeocodingService = new maps.Geocoder();
            deferred.resolve(vm.googleGeocodingService);
          });
        }
        else {
          deferred.resolve(vm.googleGeocodingService);
        }
        return deferred.promise;
      }*/
      function getDirections(leg) {
        var total = {
          distance: leg.distance.value,
          duration: leg.duration.value
        };
        var highway = {
          distance: 0,
          duration: 0
        };
        var ferry = {
          distance: 0,
          duration: 0
        };
        var city = {
          distance: 0,
          duration: 0
        };
        var hwSpeed = vm.hwSpeed / 3.6;
        for(var i = 0; i < leg.steps.length; i++) {
          if(leg.steps[i].maneuver === 'ferry') {
            ferry.distance += leg.steps[i].distance.value;
            ferry.duration += leg.steps[i].duration.value;
          }
          else {
            var metersecond = leg.steps[i].distance.value / leg.steps[i].duration.value;
            if(metersecond >= hwSpeed) {
              highway.distance += leg.steps[i].distance.value;
              highway.duration += leg.steps[i].duration.value;
            }
          }
        }

        return roundDuration({
          total: total,
          highway: highway,
          ferry: ferry,
          city: city
        });
      }
      function roundDuration(directions) {
        var adjTotal = roundMinutes(directions.total.duration, 15*60);
        var factor = adjTotal / directions.total.duration;
        directions.total.duration = adjTotal;
        directions.highway.duration = Math.ceil(directions.highway.duration*factor);
        directions.ferry.duration = Math.ceil(directions.ferry.duration*factor);

        directions.city.distance = directions.total.distance - directions.ferry.distance - directions.highway.distance;
        directions.city.duration = directions.total.duration - directions.ferry.duration - directions.highway.duration;
        return directions;
      }
      function roundMinutes(seconds, multiple) {
        if(seconds === 0) return seconds;
        if(seconds < multiple) return multiple;
        return (seconds + (multiple - seconds % multiple));
      }
      function setMaxSpeedDuration(leg, speed) {
        var duration = 0;
        var speedLimit = speed / 3.6;
        for(var i = 0; i < leg.steps.length; i++) {
          var metersecond = leg.steps[i].distance.value / leg.steps[i].duration.value;
          if(metersecond > speedLimit) {
            duration += leg.steps[i].distance.value / speedLimit;
            leg.steps[i].duration.value = Math.round(leg.steps[i].distance.value / speedLimit);
          }
          else {
            duration += leg.steps[i].duration.value;
          }
        }
        leg.duration.value = Math.round(duration);
      }
      /**
      * Controller watchers
      */
      $scope.$watch(function() { return vm.selected }, function() {
        if(vm.enableEmpty && vm.selected === '' && !emptyPlace(vm.to) && !vm.ignore.to) {
          vm.internalTo = true;
          vm.to = {address: '', location: {lat: -360, lng: -360}};
          vm.validFrom = {address: '', location: {lat: -360, lng: -360}};
          vm.validTo = {address: '', location: {lat: -360, lng: -360}};
          vm.validDirections = {
            total: {duration: 0, distance: 0},
            highway: {distance: 0, duration: 0},
            ferry: {distance: 0, duration: 0},
            city: {distance: 0, duration: 0}
          };
        }
      });

      $scope.$watch(function() { return vm.from.address }, function() {
        if(vm.internalFrom) {
          //console.log("[WATCH] PLACEPICKER - INTERNAL FROM MODEL CHANGE", vm.from);
          vm.internalFrom = false;
          return;
        }
        //console.log("[WATCH] PLACEPICKER - EXTERNAL FROM MODEL CHANGE", vm.from);
        if(emptyPlace(vm.from) || emptyPlace(vm.to)) {
          vm.ignore.from = false;
          return;
        }
        if(vm.from.address === vm.to.address) {
          vm.ignore.from = false;
          vm.resetFrom();
          return;
        }
        if(!vm.ignore.from || !validDirections(vm.directions)) {
          $timeout(function() {
            vm.computeDirections(1);
          }, 0);
        }
        vm.ignore.from = false;
      });
      $scope.$watch(function() { return vm.departTime }, function() {
        vm.computeDirections(0);
        if(vm.internalDepart) {
          //console.log("[WATCH] PLACEPICKER - INTERNAL DEPART TIME CHANGE", vm.departTime);
          vm.internalDepart = false;
          return;
        }
        //console.log("[WATCH] PLACEPICKER - EXTERNAL DEPART TIME CHANGE", vm.departTime);
        if(emptyPlace(vm.from) || emptyPlace(vm.to)) {
          vm.ignore.departTime = false;
          return;
        }

        if(!vm.ignore.departTime || !validDirections(vm.directions)) {
          $timeout(function() {
            vm.computeDirections(0);
          }, 0);
        }
        vm.ignore.departTime = false;
      })
      $scope.$watch(function() { return vm.to }, function() {
        if(vm.internalTo) {
          //console.log("[WATCH] PLACEPICKER - INTERNAL TO ADDRESS CHANGE", vm.to);
          vm.internalTo = false;
          return;
        }
        //console.log("[WATCH] PLACEPICKER - EXTERNAL TO ADDRESS CHANGE", vm.to);

        if(validPlace(vm.to) && vm.to.address === vm.selected) {
          vm.ignore.to = false;
          return;
        }
        if(!validPlace(vm.to) || vm.to.address === '' && vm.to.address !== vm.selected) {
          vm.validTo = {address: '', location: {lat: -360, lng: -360}};
          vm.validDirections = {
            total: {duration: 0, distance: 0},
            highway: {distance: 0, duration: 0},
            ferry: {distance: 0, duration: 0},
            city: {distance: 0, duration: 0}
          };
          if(vm.to.address !== '') {
            vm.internalTo = true;
            vm.to = {address: '', location: {lat: -360, lng: -360}};
          }
          angular.copy(vm.validTo, vm.to);
          angular.copy(vm.validDirections, vm.directions);
          vm.ignore.to = false;
          return;
        }

        vm.selected = vm.to.address;

        if(emptyPlace(vm.from)) {
          angular.copy(vm.to, vm.validTo);
          vm.ignore.to = false;
          return;
        }

        if(vm.ignore.to) {
          angular.copy(vm.to, vm.validTo);
        }

        if(!vm.ignore.to || !validDirections(vm.directions)) {
          $timeout(function() {
            vm.computeDirections(0);
          }, 0);
        }
        else if(vm.ignore.to) {
          angular.copy(vm.from, vm.validFrom);
          angular.copy(vm.directions, vm.validDirections);
        }
        vm.ignore.to = false;
      });
      $scope.$watch(function() {return vm.waypoints}, function() {
        vm.computeDirections(0);
        if(vm.internalDepart) {
          //console.log("[WATCH] PLACEPICKER - INTERNAL DEPART TIME CHANGE", vm.departTime);
          vm.internalDepart = false;
          return;
        }
        //console.log("[WATCH] PLACEPICKER - EXTERNAL DEPART TIME CHANGE", vm.departTime);
        if(emptyPlace(vm.from) || emptyPlace(vm.to)) {
          vm.ignore.departTime = false;
          return;
        }

        if(!vm.ignore.departTime || !validDirections(vm.directions)) {
          $timeout(function() {
            vm.computeDirections(0);
          }, 0);
        }
        vm.ignore.departTime = false;
      })
      $scope.$watch(function() { return vm.to }, function() {
        if(vm.internalTo) {
          //console.log("[WATCH] PLACEPICKER - INTERNAL TO ADDRESS CHANGE", vm.to);
          vm.internalTo = false;
          return;
        }
        //console.log("[WATCH] PLACEPICKER - EXTERNAL TO ADDRESS CHANGE", vm.to);

        if(validPlace(vm.to) && vm.to.address === vm.selected) {
          vm.ignore.to = false;
          return;
        }
        if(!validPlace(vm.to) || vm.to.address === '' && vm.to.address !== vm.selected) {
          vm.validTo = {address: '', location: {lat: -360, lng: -360}};
          vm.validDirections = {
            total: {duration: 0, distance: 0},
            highway: {distance: 0, duration: 0},
            ferry: {distance: 0, duration: 0},
            city: {distance: 0, duration: 0}
          };
          if(vm.to.address !== '') {
            vm.internalTo = true;
            vm.to = {address: '', location: {lat: -360, lng: -360}};
          }
          angular.copy(vm.validTo, vm.to);
          angular.copy(vm.validDirections, vm.directions);
          vm.ignore.to = false;
          return;
        }

        vm.selected = vm.to.address;

        if(emptyPlace(vm.from)) {
          angular.copy(vm.to, vm.validTo);
          vm.ignore.to = false;
          return;
        }

        if(vm.ignore.to) {
          angular.copy(vm.to, vm.validTo);
        }

        if(!vm.ignore.to || !validDirections(vm.directions)) {
          $timeout(function() {
            vm.computeDirections(0);
          }, 0);
        }
        else if(vm.ignore.to) {
          angular.copy(vm.from, vm.validFrom);
          angular.copy(vm.directions, vm.validDirections);
        }
        vm.ignore.to = false;
      });
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .filter("placeFilter", placeFilter);
  placeFilter.$inject = [];

  function placeFilter() {
    return function(data, placeCriteria) {
      var column = Object.keys(placeCriteria)[0];
      return (data || []).filter(function(item) {
        if (!item[column]) return false;
        if (placeCriteria[column].length == 0) return true;
        for (var i = 0; i < placeCriteria[column].length; i++) {
          if (item[column].indexOf(placeCriteria[column][i]) != -1) {
            return true;
          }
        }
        return false;
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brPlacepicker', placepickerDirective);

  /** @ngInject */
  function placepickerDirective(uiGmapGoogleMapApi, $document, $window, $timeout) {

    function triggerKeyboardEvent(element, keyCode) {
      var eventObj;
      if($window.document.createEventObject) {
        eventObj = $window.document.createEventObject();
      }
      else {
        eventObj = $window.document.createEvent("Events");
      }

      if(eventObj.initEvent) {
        eventObj.initEvent("keydown", true, true);
      }
      eventObj.keyCode = keyCode;
      eventObj.which = keyCode;

      if(element.dispatchEvent) {
        element.dispatchEvent(eventObj)
      }
      else {
        element.fireEvent("onkeydown", eventObj);
      }
    }

    function selectFirstOnEnter($scope, input) {
      var listener = function(event) {
        if(input.value) {
          if(event.which == 13 || event.which == 9) { // If enter or tab is pressed
            if(event.which == 13) event.preventDefault();
            var suggestions_avaible = $window.document.getElementsByClassName("pac-item").length;
            if(!suggestions_avaible) {  // If no suggestion is available
              if($scope.placepicker.to && $scope.placepicker.to.address) {
                input.value = $scope.placepicker.to.address;
              }
              else {
                input.value = '';
              }
            }
            else {
              var suggestion_selected = $window.document.getElementsByClassName("pac-item-selected").length;
              if(!suggestion_selected) { // if no suggestion selected
                triggerKeyboardEvent(input, 40);
              }
            }
          }
        }
      };
      if(input.addEventListener) {
        input.addEventListener("keydown", listener);
      }
      else if(input.attachEvent) {
        input.attachEvent("onkeydown", listener);
      }
      $scope.$on('$destroy', function () {
        if(input.removeEventListener) {
          input.removeEventListener("keydown", listener);
        }
        else if (input.detachEvent) {
          input.detachEvent("onkeydown", listener);
        }
      });
    }
    function selectFirstOnPaste($scope, input) {
      var listener = function(event) {
        $timeout(function () {
          var suggestions_avaible = $window.document.getElementsByClassName("pac-item").length;
          if(!suggestions_avaible) {  // If no suggestion is available
            if($scope.placepicker.to && $scope.placepicker.to.address) {
              input.value = $scope.placepicker.to.address;
            }
            else {
              input.value = '';
            }
          }
          else {
            var suggestion_selected = $window.document.getElementsByClassName("pac-item-selected").length;
            if(!suggestion_selected) { // if no suggestion selected
              triggerKeyboardEvent(input, 40);
            }
          }
        }, 250);
      };
      if(input.addEventListener) {
        input.addEventListener("paste", listener);
      }
      else if(input.attachEvent) {
        input.attachEvent("onpaste", listener);
      }
      $scope.$on('$destroy', function () {
        if(input.removeEventListener) {
          input.removeEventListener("paste", listener);
        }
        else if (input.detachEvent) {
          input.detachEvent("onpaste", listener);
        }
      });
    }

    function enableAutocomplete($scope, input, maps) {
      var options = {
        types: [],
        componentRestrictions: {'country': []}
      };
      var autocomplete = new maps.places.Autocomplete(input, options);
      maps.event.addListener(autocomplete, 'place_changed', function() {
        var place = autocomplete.getPlace();
        //console.log("PLACEPICKER: ", place);
        if(angular.isObject(place.geometry)) {
          $scope.placepicker.placeSelected(angular.element(input).val(), {lat: place.geometry.location.lat(), lng: place.geometry.location.lng()});
        }
      });
      $scope.$on('$destroy', function () {
        maps.event.clearListeners(input);
      });
    }

    var link = function($scope, $elem, $attr) {
      $scope.placepicker.loaded = false;
      uiGmapGoogleMapApi.then(function(maps) {
        var input = $elem.find("input")[0];
        $timeout(function () {
          $scope.placepicker.loaded = true;
        }, 0);

        enableAutocomplete($scope, input, maps);
        selectFirstOnEnter($scope, input);
        selectFirstOnPaste($scope, input);
      });
    };

    var directive = {
      restrict: 'E',
      scope: {
        label: '@brLabel',
        labelBottom: '@brLabelBottom',
        placeholder: '@brPlaceholder',
        info: '@brInfo',
        disabled: '=?brDisabled',
        from: '=?brFrom',
        to: '=brTo',
        enableEmpty: '=brEnableEmpty',
        directions: '=?brDirections',
        departTime: '=?brDepartTime',
        speedLimit: '=?brSpeedLimit',
        hwSpeed: '=?brHwSpeed',
        onCompute: '&?brOnCompute',
        onGeocode: '&?brOnGeocode',
        onSelect: '&?brOnSelect'
      },
      templateUrl: 'app/components/placepicker/placepicker.html',
      controller: 'PlacepickerController',
      controllerAs: 'placepicker',
      bindToController: true,
      link: link
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('PlacepickerController', PlacepickerController);

  /** @ngInject */
  function PlacepickerController($scope, $timeout, $q, uiGmapGoogleMapApi) {
    var vm = this;

    vm.$onInit = function() {
      vm.geocodingCall = 0;
      vm.directionsCall = 0;
      vm.internalTo = false;
      vm.internalFrom = false;
      vm.internalDepart = false;
      vm.validFrom = {address: '', location: {lat: -360, lng: -360}};
      vm.validTo = {address: '', location: {lat: -360, lng: -360}};
      vm.validDirections = {
        total: {duration: 0, distance: 0},
        highway: {distance: 0, duration: 0},
        ferry: {distance: 0, duration: 0},
        city: {distance: 0, duration: 0}
      };
      vm.ignore = {
        to: false,
        from: false,
        departTime: false
      };
      vm.selected = '';

      function validPlace(place) {
        return angular.isObject(place) && place !== null && !angular.isArray(vm.from) && angular.isString(vm.from.address);
      }
      function emptyPlace(place) {
        if(validPlace(place)) return place.address == '';
        return true;
      }
      function validDirections(directions) {
        return (angular.isObject(directions) && directions != null &&
          angular.isObject(directions.total) && directions.total != null &&
          angular.isNumber(directions.total.distance) && angular.isNumber(directions.total.duration) &&
          angular.isObject(directions.highway) && directions.highway != null &&
          angular.isNumber(directions.highway.distance) && angular.isNumber(directions.highway.duration) &&
          angular.isObject(directions.ferry) && directions.ferry != null &&
          angular.isNumber(directions.ferry.distance) && angular.isNumber(directions.ferry.duration) &&
          angular.isObject(directions.city) && directions.city != null &&
          angular.isNumber(directions.city.distance) && angular.isNumber(directions.city.duration));
      }

      if(!angular.isNumber(vm.hwSpeed)) {
        vm.hwSpeed = 80;
      }
      if(!validPlace(vm.from)) {
        vm.from = {address: '', location: {lat: -360, lng: -360}};
      }
      else {
        vm.ignore.from = true
      }
      if(!validPlace(vm.to)) {
        vm.to = {address: '', location: {lat: -360, lng: -360}};
      }
      else {
        vm.ignore.to = true
      }
      if(!angular.isDate(vm.departTime)) {
        vm.departTime = null;
      }
      else {
        vm.ignore.departTime = true
      }
      if(!angular.isObject(vm.directions)) {
        angular.copy(vm.validDirections, vm.directions);
      }

      /**
       * Scope Functions
       */
      vm.placeSelected = function(address, location) {
        //console.log("[FUNC] PLACEPICKER - PLACE SELECTED");
        if(!emptyPlace(vm.from) && vm.from.address == address) {
          vm.selected = vm.to.address;
          $scope.$apply();
          return;
        }
        vm.selected = address;
        vm.geocodingCall = 0;
        vm.directionsCall = 0;
        vm.internalTo = true;
        vm.to = {
          address: address,
          location: {
            lat: location.lat,
            lng: location.lng
          }
        }
        $scope.$apply();
        if(angular.isFunction(vm.onSelect)) vm.onSelect();

        if(angular.isFunction(vm.onGeocode)) vm.onGeocode();

        if(!emptyPlace(vm.from)) {
          $timeout(function() {
            vm.computeDirections(0);
          }, 0);
        }
      };
      vm.resetTo = function() {
        $timeout(function() {
          $scope.$apply(function() {
            vm.internalTo = true;
            angular.copy(vm.validTo, vm.to);
            angular.copy(vm.validDirections, vm.directions);
            vm.selected = vm.to.address;
          });
        }, 0);
      };
      vm.resetFrom = function() {
        $timeout(function() {
          $scope.$apply(function() {
            vm.internalFrom = true;
            angular.copy(vm.validFrom, vm.from);
          });
        }, 0);
      };
      /*vm.computeGeolocation = function() {
        vm.geocodingCall++;
        geocode(vm.geocodingCall, 0);

        function geocode(req, recall) {
          if(vm.geocodingCall !== req) return;
          //console.log("[FUNC] PLACEPICKER - GEOCODE START - req:", req, " - rec", recall);

          getGoogleGeocoding().then(function(service) {
            if(vm.geocodingCall !== req) return;

            var options = {
              address : vm.to
            };
            service.geocode(options, function(response, status) {
              if(vm.geocodingCall !== req) return;

              if(status == vm.maps.GeocoderStatus.OK) {
                vm.geocodingCall = 0;
                vm.location = {lat: response[0].geometry.location.lat(), lng: response[0].geometry.location.lng()};

                if(!angular.isString(vm.from) || vm.from === '') {
                  angular.copy(vm.to, vm.validTo);
                }
                //console.log("[FUNC] PLACEPICKER - GEOCODE END - req:", req, " - rec", recall);

                $scope.$apply();
                if(angular.isFunction(vm.onGeocode)) vm.onGeocode();
              }
              else if(status == vm.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
                recall++;
                $timeout(function() {
                  geocode(vm.geocodingCall, recall)
                }, recall * Math.floor(Math.random() * 200));
              }
              else {
                vm.geocodingCall = 0;
                vm.resetTo();
              }
            });
          });
        }
      };*/
      vm.computeDirections = function(fromorto) {
        vm.directionsCall++;
        directions(vm.directionsCall, 0);

        function directions(req, recall) {
          if(vm.directionsCall !== req) return;
          //console.log("[FUNC] PLACEPICKER - DIRECTIONS START - type:", fromorto, " - req:", req, " - rec", recall);

          getGoogleDirectionsService().then(function(service) {
            if(vm.directionsCall !== req) return;

            var options = {
              origin: vm.from.location,
              destination: vm.to.location,
              travelMode: vm.maps.TravelMode.DRIVING,
              unitSystem: vm.maps.UnitSystem.METRIC,
              avoidHighways: false,
              avoidTolls: false,
              avoidFerries: true
            };
            if(angular.isDate(vm.departTime)) {
              options.drivingOptions = {
                departureTime: vm.departTime,
                trafficModel: google.maps.TrafficModel.PESSIMISTIC
              };
            }
            service.route(options, function(response, status) {
              if(vm.directionsCall !== req) return;

              if(status == vm.maps.DirectionsStatus.OK) {

                var leg = response.routes[0].legs[0];

                if(angular.isNumber(vm.speedLimit)) {
                  setMaxSpeedDuration(leg, vm.speedLimit);
                }
                vm.directionsCall = 0;

                vm.directions = getDirections(leg);
                angular.copy(vm.to, vm.validTo);
                angular.copy(vm.from, vm.validFrom);
                angular.copy(vm.directions, vm.validDirections);

                //console.log("[FUNC] PLACEPICKER - DIRECTIONS DONE - type:", fromorto, " - req:", req, " - rec", recall);

                $scope.$apply();
                if(angular.isFunction(vm.onCompute)) vm.onCompute();
              }
              else if(status == vm.maps.DirectionsStatus.OVER_QUERY_LIMIT) {
                recall++;
                $timeout(function(req, recall) {
                  directions(req, recall)
                }, recall * Math.floor(Math.random() * 200, true, req, recall));
              }
              else {
                vm.directionsCall = 0;
                if(fromorto == 0) {
                  vm.resetTo();
                }
                else if(fromorto == 1) {
                  vm.resetFrom();
                }
              }
            });
          });
        }
      };

      /**
       * Controller Functions
       */
      /*function getGoogleGeocoding() {
        var deferred = $q.defer();
        if(angular.isUndefined(vm.googleGeocodingService)) {
          uiGmapGoogleMapApi.then(function(maps) {
            if(angular.isUndefined(vm.maps)) {
              vm.maps = maps;
            }
            vm.googleGeocodingService = new maps.Geocoder();
            deferred.resolve(vm.googleGeocodingService);
          });
        }
        else {
          deferred.resolve(vm.googleGeocodingService);
        }
        return deferred.promise;
      }*/
      function getGoogleDirectionsService() {
        var deferred = $q.defer();
        if(angular.isUndefined(vm.googleDirectionsService)) {
          uiGmapGoogleMapApi.then(function(maps) {
            if(angular.isUndefined(vm.maps)) {
              vm.maps = maps;
            }
            vm.googleDirectionsService = new maps.DirectionsService();
            deferred.resolve(vm.googleDirectionsService);
          });
        }
        else {
          deferred.resolve(vm.googleDirectionsService);
        }
        return deferred.promise;
      }
      function getDirections(leg) {
        var total = {
          distance: leg.distance.value,
          duration: leg.duration.value
        };
        var highway = {
          distance: 0,
          duration: 0
        };
        var ferry = {
          distance: 0,
          duration: 0
        };
        var city = {
          distance: 0,
          duration: 0
        };
        var hwSpeed = vm.hwSpeed / 3.6;
        for(var i = 0; i < leg.steps.length; i++) {
          if(leg.steps[i].maneuver === 'ferry') {
            ferry.distance += leg.steps[i].distance.value;
            ferry.duration += leg.steps[i].duration.value;
          }
          else {
            var metersecond = leg.steps[i].distance.value / leg.steps[i].duration.value;
            if(metersecond >= hwSpeed) {
              highway.distance += leg.steps[i].distance.value;
              highway.duration += leg.steps[i].duration.value;
            }
          }
        }

        return roundDuration({
          total: total,
          highway: highway,
          ferry: ferry,
          city: city
        });
      }
      function roundDuration(directions) {
        var adjTotal = roundMinutes(directions.total.duration, 15*60);
        var factor = adjTotal / directions.total.duration;
        directions.total.duration = adjTotal;
        directions.highway.duration = Math.ceil(directions.highway.duration*factor);
        directions.ferry.duration = Math.ceil(directions.ferry.duration*factor);

        directions.city.distance = directions.total.distance - directions.ferry.distance - directions.highway.distance;
        directions.city.duration = directions.total.duration - directions.ferry.duration - directions.highway.duration;
        return directions;
      }
      function roundMinutes(seconds, multiple) {
        if(seconds === 0) return seconds;
        if(seconds < multiple) return multiple;
        return (seconds + (multiple - seconds % multiple));
      }
      function setMaxSpeedDuration(leg, speed) {
        var duration = 0;
        var speedLimit = speed / 3.6;
        for(var i = 0; i < leg.steps.length; i++) {
          var metersecond = leg.steps[i].distance.value / leg.steps[i].duration.value;
          if(metersecond > speedLimit) {
            duration += leg.steps[i].distance.value / speedLimit;
            leg.steps[i].duration.value = Math.round(leg.steps[i].distance.value / speedLimit);
          }
          else {
            duration += leg.steps[i].duration.value;
          }
        }
        leg.duration.value = Math.round(duration);
      }
      /**
      * Controller watchers
      */
      $scope.$watch(function() { return vm.selected }, function() {
        if(vm.enableEmpty && vm.selected === '' && !emptyPlace(vm.to) && !vm.ignore.to) {
          vm.internalTo = true;
          vm.to = {address: '', location: {lat: -360, lng: -360}};
          vm.validFrom = {address: '', location: {lat: -360, lng: -360}};
          vm.validTo = {address: '', location: {lat: -360, lng: -360}};
          vm.validDirections = {
            total: {duration: 0, distance: 0},
            highway: {distance: 0, duration: 0},
            ferry: {distance: 0, duration: 0},
            city: {distance: 0, duration: 0}
          };
        }
      });

      $scope.$watch(function() { return vm.from.address }, function() {
        if(vm.internalFrom) {
          //console.log("[WATCH] PLACEPICKER - INTERNAL FROM MODEL CHANGE", vm.from);
          vm.internalFrom = false;
          return;
        }
        //console.log("[WATCH] PLACEPICKER - EXTERNAL FROM MODEL CHANGE", vm.from);
        if(emptyPlace(vm.from) || emptyPlace(vm.to)) {
          vm.ignore.from = false;
          return;
        }
        if(vm.from.address === vm.to.address) {
          vm.ignore.from = false;
          vm.resetFrom();
          return;
        }
        if(!vm.ignore.from || !validDirections(vm.directions)) {
          $timeout(function() {
            vm.computeDirections(1);
          }, 0);
        }
        vm.ignore.from = false;
      });
      $scope.$watch(function() { return vm.departTime }, function() {
        if(vm.internalDepart) {
          //console.log("[WATCH] PLACEPICKER - INTERNAL DEPART TIME CHANGE", vm.departTime);
          vm.internalDepart = false;
          return;
        }
        //console.log("[WATCH] PLACEPICKER - EXTERNAL DEPART TIME CHANGE", vm.departTime);
        if(emptyPlace(vm.from) || emptyPlace(vm.to)) {
          vm.ignore.departTime = false;
          return;
        }

        if(!vm.ignore.departTime || !validDirections(vm.directions)) {
          $timeout(function() {
            vm.computeDirections(0);
          }, 0);
        }
        vm.ignore.departTime = false;
      });
      $scope.$watch(function() { return vm.to }, function() {
        if(vm.internalTo) {
          //console.log("[WATCH] PLACEPICKER - INTERNAL TO ADDRESS CHANGE", vm.to);
          vm.internalTo = false;
          return;
        }
        //console.log("[WATCH] PLACEPICKER - EXTERNAL TO ADDRESS CHANGE", vm.to);

        if(validPlace(vm.to) && vm.to.address === vm.selected) {
          vm.ignore.to = false;
          return;
        }
        if(!validPlace(vm.to) || vm.to.address === '' && vm.to.address !== vm.selected) {
          vm.validTo = {address: '', location: {lat: -360, lng: -360}};
          vm.validDirections = {
            total: {duration: 0, distance: 0},
            highway: {distance: 0, duration: 0},
            ferry: {distance: 0, duration: 0},
            city: {distance: 0, duration: 0}
          };
          if(vm.to.address !== '') {
            vm.internalTo = true;
            vm.to = {address: '', location: {lat: -360, lng: -360}};
          }
          angular.copy(vm.validTo, vm.to);
          angular.copy(vm.validDirections, vm.directions);
          vm.ignore.to = false;
          return;
        }

        vm.selected = vm.to.address;

        if(emptyPlace(vm.from)) {
          angular.copy(vm.to, vm.validTo);
          vm.ignore.to = false;
          return;
        }

        if(vm.ignore.to) {
          angular.copy(vm.to, vm.validTo);
        }

        if(!vm.ignore.to || !validDirections(vm.directions)) {
          $timeout(function() {
            vm.computeDirections(0);
          }, 0);
        }
        else if(vm.ignore.to) {
          angular.copy(vm.from, vm.validFrom);
          angular.copy(vm.directions, vm.validDirections);
        }
        vm.ignore.to = false;
      });
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brNoEmailValidation', noEmailValidationDirective);

  /** @ngInject */
  function noEmailValidationDirective() {
    var directive = {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, elm, attr, ctrl) {
        ctrl.$validators['email'] = function() {
          return true;
        };
      }
    };

    return directive;
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brPassword', passwordDirective);

  /** @ngInject */
  function passwordDirective(uiGmapGoogleMapApi, $templateRequest, $document, $window, $compile, $timeout) {

    var link = function($scope, $elem, $attr) {
      $scope.visible = false;
      $templateRequest("app/components/password/password.html").then(function(html){
        var template = angular.element(html);

        $elem.attr('type','password');
        $elem.css('padding-right', 36 + 5 + 'px');
        $scope.toggle = $compile(template)($scope);
        $elem.after($scope.toggle);
     });

      $scope.mouseDown = function() {
        $scope.toggle.removeClass('icon-eye-off');
        $scope.toggle.addClass('icon-eye');
        $elem.attr('type','text');
        $timeout($scope.moussUp, 10000);
      };

      $scope.mouseUp = function() {
        $scope.toggle.removeClass('icon-eye');
        $scope.toggle.addClass('icon-eye-off');
        $elem.attr('type','password');
      };

      $elem.bind("propertychange change click keyup input paste", function(event) {
        $timeout(function() {
          if($elem.val().length > 0) $scope.visible = true;
          else $scope.visible = false;
        }, 0);
      });
    };

    var directive = {
      restrict: 'A',
      scope: {},
      link: link
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brMaps', mapsDirective);

  /** @ngInject */
  function mapsDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        waypoints: '=brWaypoints',
        obj: '@brObject'
      },
      templateUrl: 'app/components/maps/maps.html',
      controller: 'MapsController',
      controllerAs: 'maps',
      bindToController: true
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('MapsController', MapsController);

  /** @ngInject */
  function MapsController($scope, $timeout, $q, uiGmapGoogleMapApi, uiGmapIsReady) {
    var vm = this;

    vm.$onInit = function() {
      vm.points = [];
      vm.requests = 0;
      vm.splittedConut = 0;
      vm.splittedDone = 0;
      vm.splittedResults = [];
      vm.bounds = {};

      vm.center = {
        latitude: 41.902783,
        longitude: 12.496366
      };
      vm.options = {
        backgroundColor: '#b3d1ff',
        scrollwheel: false,
        zoomControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false
      };
      vm.control = {};

      vm.marker = null
      vm.zoom = 3;
      vm.done = false;
      vm.map = null;
      vm.MAX_GOOGLE_WAYPOINTS = 10;

      /**
       * Controller Functions
       */
      uiGmapGoogleMapApi.then(function(maps) {
        uiGmapIsReady.promise().then(function() {
          maps.event.trigger(vm.control.getGMap(), 'resize');
        }).catch(function(error) {});
      });

      function displayDirections() {
        if(!angular.isArray(vm.points)) return;
        if(vm.points.length === 0) return;
        if(!validAddress(vm.points[0]) && !validLocation(vm.points[0])) return;

        uiGmapGoogleMapApi.then(function(maps) {
          if(angular.isUndefined(vm.googleDirectionsService)) {
            vm.googleDirectionsService = new maps.DirectionsService();
          }
          if(angular.isUndefined(vm.googleGeocoder)) {
            vm.googleGeocoder = new maps.Geocoder();
          }
          center(vm.points);

          if(vm.points.length < 2) return;
          if(!validAddress(vm.points[vm.points.length-1]) && !validLocation(vm.points[vm.points.length-1])) return;

          vm.splittedDone = 0;
          vm.splittedConut = 0

          vm.requests++;
          for(var i = 0; i < vm.points.length-1; i += vm.MAX_GOOGLE_WAYPOINTS-1) {
            var points = vm.points.slice(i, i + vm.MAX_GOOGLE_WAYPOINTS);
            $timeout(function(points, parallel) {
              directions(points, parallel, vm.requests)
            }, (i+1) * 200, true, points, vm.splittedConut);
            vm.splittedConut++;
          }

          vm.splittedResults = Array.apply(null, Array(vm.splittedConut)).map(function() {});

          function removeMarker() {
            if(vm.marker) {
              vm.marker.setMap(null);
              vm.marker = null;
            }
          }

          function center(points) {
            if(points.length < 1 || points.length > 2 || points.length === 2 && validLocation(points[1])) {
              removeMarker();
              return;
            }

            if(validAddress(points[0])) {
              vm.googleGeocoder.geocode({'address': points[0]}, function(results, status) {
                  if(status === maps.GeocoderStatus.OK) {
                    $timeout(function(results) {
                      $scope.$apply(function() {
                        removeMarker();
                        vm.center = {
                          latitude: results[0].geometry.lat(),
                          longitude: results[0].geometry.lng()
                        }
                        vm.zoom = 10;
                        vm.marker = new maps.Marker({
                          position: { lat: vm.center.latitude, lng: vm.center.longitude },
                          map: vm.control.getGMap()
                        });
                      });
                    }, 0, true, results);
                  }
                  else {
                    removeMarker();
                  }
              });
            }
            else if(validLocation(points[0])) {
              $timeout(function(points) {
                $scope.$apply(function() {
                  removeMarker();
                  vm.center = {
                    latitude: points[0].lat,
                    longitude: points[0].lng
                  };
                  vm.zoom = 10;
                  vm.marker = new maps.Marker({
                    position: {lat: vm.center.latitude, lng: vm.center.longitude},
                    map: vm.control.getGMap()
                  });
                });
              }, 0, true, points);
            }
            else {
              removeMarker();
            }
          }

          function directions(points, parallel, req, recall) {


            if(vm.requests !== req) return;
            if(points.length === 0) return;
            if(points.length < 2) return;
            if(!validAddress(points[0]) && !validLocation(points[0])) return;
            if(!validAddress(points[points.length-1]) && !validLocation(points[points.length-1])) return;

            var options = {
              origin: getGoogleOrigin(points),
              destination: getGoogleDestination(points),
              travelMode: maps.DirectionsTravelMode.DRIVING,
              optimizeWaypoints: false,
              avoidHighways: false,
              avoidTolls: false,
              avoidFerries: true
            };

            if(points.length > 2) {
              options.waypoints = getGoogleWaypoints(points, true);
            }

            vm.googleDirectionsService.route(options, function(response, status) {
              if(vm.requests !== req) return;
              if(angular.isUndefined(vm.googleDirectionsRenderer)) {
                vm.googleDirectionsRenderer = new maps.DirectionsRenderer();
                vm.googleDirectionsRenderer.setMap(vm.control.getGMap());
              }
              if(status === maps.DirectionsStatus.OK) {
                vm.splittedResults[parallel] = response;
                vm.splittedDone++;
                if(vm.splittedDone === vm.splittedConut) {
                  var dir = vm.splittedResults[0];

                  if(vm.splittedResults.length > 1) {
                    if(angular.isUndefined(dir.request.waypoints)) {
                      dir.request.waypoints = [];
                    }
                    dir.request.waypoints = dir.request.waypoints.concat(getGoogleWaypoints([dir.request.destination]));
                    dir.request.destination = vm.splittedResults[vm.splittedConut-1].request.destination;

                    for(var i = 1; i < vm.splittedResults.length; i++) {

                      dir.request.waypoints = dir.request.waypoints.concat(getGoogleWaypoints([vm.splittedResults[i].request.origin]));
                      if(angular.isDefined(vm.splittedResults[i].request.waypoints)) {
                        dir.request.waypoints = dir.request.waypoints.concat(vm.splittedResults[i].request.waypoints);
                      }
                      if(i < vm.splittedConut-1) {
                        dir.request.waypoints = dir.request.waypoints.concat(getGoogleWaypoints([vm.splittedResults[i].request.origin]));
                      }

                      dir.geocoded_waypoints = dir.geocoded_waypoints.concat(vm.splittedResults[i].geocoded_waypoints);

                      dir.routes[0].warnings = dir.routes[0].warnings.concat(vm.splittedResults[i].routes[0].warnings);
                      dir.routes[0].legs = dir.routes[0].legs.concat(vm.splittedResults[i].routes[0].legs);
                      dir.routes[0].overview_path = dir.routes[0].overview_path.concat(vm.splittedResults[i].routes[0].overview_path);
                      dir.routes[0].bounds = dir.routes[0].bounds.extend(vm.splittedResults[i].routes[0].bounds.getNorthEast());
                      dir.routes[0].bounds = dir.routes[0].bounds.extend(vm.splittedResults[i].routes[0].bounds.getSouthWest());
                    }
                    if(angular.isUndefined(dir.routes[0].waypoint_order)) {
                      dir.routes[0].waypoint_order = [];
                    }
                    for(var j = dir.routes[0].waypoint_order.length; j < dir.request.waypoints.length; j++) {
                      dir.routes[0].waypoint_order.push(j);
                    }
                  }

                  vm.googleDirectionsRenderer.setDirections(dir);
                  maps.event.trigger(vm.control.getGMap(), 'resize');

                  vm.requests = 0;
                  vm.splittedDone = 0;
                  vm.splittedConut = 0;
                  vm.splittedResults = [];
                  vm.done = true;
                  //console.log("[FUNC] MAPS - DIRECTIONS END - parallel:", parallel, " - req:", req, " - rec", recall);
                }
              }
              else if(status === maps.DirectionsStatus.OVER_QUERY_LIMIT) {
                if(!angular.isNumber(recall)) {
                  recall = 1;
                }
                else {
                  recall++;
                }
                $timeout(function(points, parallel, req, recall) {directions(points, parallel, req, recall)}, recall * Math.floor(Math.random() * 200, true, points, parallel, req, recall));
              }
            });
          }
        });
      }
      function getGoogleOrigin(arr) {
        return arr[0];
      }
      function getGoogleDestination(arr) {
        return arr[arr.length-1]
      }
      function getGoogleWaypoints(arr, center) {
        var list = [];
        var min = 0;
        var max = arr.length;
        if(center) {
          min++;
          max--;
        }
        for(var i = min; i < max; i++) {
          list.push({
            location: angular.copy(arr[i]),
            stopover: true
          });
        }
        return list;
      }
      function deep_value(obj, path) {
        for(var k = 0, keys = path.split('.'), len = keys.length; k < len; k++) {
          if(!angular.isObject(obj)) return null;
          obj = obj[keys[k]];
        }
        return obj;
      }

      function validAddress(address) {
        return (angular.isString(address) && address !== '');
      }
      function validLocation(location) {
        return (angular.isObject(location) && location.lat <= 85 && location.lat >= -85 && location.lng <= 180 && location.lng >= -180);
      }

      $scope.$watch(function() { return vm.waypoints }, function(newValue, oldValue) {
        //console.log("[WATCH] MAPS - WAYPOINTS", vm.waypoints);
        if(!angular.isArray(vm.waypoints)) {
          return;
        }
        if(angular.isDefined(oldValue) && newValue.length === oldValue.length && vm.done) {
          var flag = false;
          for(var i = 0; i < newValue.length; i++) {
            if(!angular.equals(newValue[i], oldValue[i])) {
              flag = true;
            }
          }
          if(flag === false) {
            return;
          }
        }
        angular.copy(vm.waypoints, vm.points);

        if(vm.obj != 'self') {
          for(var j = 0; j < vm.points.length; j++) {
           vm.points[j] = deep_value(vm.points[j], vm.obj);
          }
        }
        $timeout(function() {
          displayDirections();
        }, 1000);
      }, true);
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brHtrip', htripDirective);

  /** @ngInject */
  function htripDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        legs: '=brLegs',
        steps: '=brSteps'
      },
      templateUrl: 'app/components/htrip/htrip.html',
      controller: 'HtripController',
      controllerAs: 'htrip',
      bindToController: true
    };
    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('HtripController', HtripController);

  /** @ngInject */
  function HtripController() {
    var vm = this;

    vm.$onInit = function() {
      if(!angular.isArray(vm.steps)) {
        vm.steps = [];
      }
      if(!angular.isArray(vm.legs)) {
        vm.legs = [];
      }
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brMenu', menuDirective);

  /** @ngInject */
  function menuDirective($window, $common, $document) {
    var directive = {
      restrict: 'EA',
      scope: {
        open: '=brOpen',
        items: '=brItems',
      },
      templateUrl: 'app/components/menu/menu.html',
      controller: 'MenuController',
      controllerAs: 'menu',
      bindToController: true,
      compile: function (tElement, tAttrs) {
        return function (scope, element, attrs, ctrls, transcludeFn) {
          //
          //
          var menu = ctrls;
          menu.id = 0;
          menu.open = false;
          function onDocumentClick(e) {
            if (!menu.open) return; //Skip it if menu is close
            var contains = false;
            if ($window.jQuery) {
              // Firefox 3.6 does not support element.contains()
              // See Node.contains https://developer.mozilla.org/en-US/docs/Web/API/Node.contains
              contains = $window.jQuery.contains(element[0], e.target);
            } else {
              contains = element[0].contains(e.target);
            }
            if (!contains && !menu.clickTriggeredSelect) {
              // menu.close();
              menu.open = false;
              scope.$digest();
            }
            menu.clickTriggeredSelect = false;
          }

          // See Click everywhere but here. Similar approach to http://stackoverflow.com/questions/12931369
          // but using the capture phase instead of bubble phase of the event propagation.
          //
          // Using the capture phase avoids problems that araise when event.stopPropatagion()
          // is called before the event reaches the `document`.
          $window.document.addEventListener('click', onDocumentClick, true);
          //
          scope.$on('$destroy', function () {
            $window.document.removeEventListener('click', onDocumentClick, true);
          });
          // Support for appending the select field to the body when its open
          scope.$watch('menu.open', function (isOpen) {

            if (isOpen) {
              positionMenu();
            } else {
              resetMenu();
            }
          });

          // Move the menu back to its original location when the scope is destroyed. Otherwise
          // it might stick around when the user routes away or the select field is otherwise removed
          scope.$on('$destroy', function () {
            resetMenu();
          });

          // Hold on to a reference to the .ui-select-container element for appendToBody support
          var placeholder = null,
            originalWidth = '';

          function positionMenu() {
            // Remember the absolute position of the element
            var offset = $common.offset(element, $window, $document);

            // Clone the element into a placeholder element to take its original place in the DOM
            placeholder = angular.element('<div class="br-menu-placeholder"></div>');
            placeholder[0].style.width = offset.width + 'px';
            placeholder[0].style.height = offset.height + 'px';
            element.after(placeholder);

            // Remember the original value of the element width inline style, so it can be restored
            // when the menu is closed
            originalWidth = element[0].style.width;

            // Now move the actual menu element to the end of the body
            $document.find('body').append(element);

            element[0].style.position = 'absolute';
            element[0].style.left = offset.left + 'px';
            element[0].style.top = offset.top + 'px';
            element[0].style.width = 400 + 'px';
            element[0].style['margin-top'] = 20 + 'px';
            if (offset.left + 400 > $window.innerWidth) {
              element[0].style.left = $window.innerWidth - 400 + 'px';
            }
          }

          function resetMenu() {
            if (placeholder === null) {
              // The menu has not actually been display yet, so there's nothing to reset
              return;
            }

            // Move the menu element back to its original location in the DOM
            placeholder.replaceWith(element);
            placeholder = null;

            element[0].style.position = '';
            element[0].style.left = '';
            element[0].style.top = '';
            element[0].style.width = originalWidth;

            // Set focus back on to the moved element
            // menu.setFocus();
          }
          menu.open = false;
        };
      }
    };
    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('MenuController', MenuController);

  /** @ngInject */
  function MenuController($timeout, $common, $scope, uiGridConstants) {
    var vm = this;
    vm.$onInit = function () {
      vm.open = false;
        // vm.onSortDesc('desc');
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brMarkers', markersDirective);

  /** @ngInject */
  function markersDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        waypoints: '=brWaypoints',
        obj: '@brObject',
        defaultzoom: '@?brZoom'
      },
      templateUrl: 'app/components/markers/markers.html',
      controller: 'MarkersController',
      controllerAs: 'markers',
      bindToController: true
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('MarkersController', MarkersController);

  /** @ngInject */
  function MarkersController($scope, $timeout, $q) {
    var vm = this;

    vm.$onInit = function() {
      vm.loaded = false;
      vm.points = [];

      vm.center = {
        latitude: 41.902783,
        longitude: 12.496366
      };
      vm.options = {
        backgroundColor: '#b3d1ff',
        scrollwheel: false,
        zoomControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        clickable: false
      };

      vm.bounds = {};
      if(!angular.isNumber(vm.defaultzoom)) {
        vm.defaultzoom = parseInt(vm.defaultzoom);
      }
      vm.zoom = vm.defaultzoom || 10;
      vm.locations = [];

      function generateMarkers(single) {
        vm.locations = [];

        if(single) {
          vm.list = [vm.points];
        } else {
          vm.list = vm.points;
        }

        vm.center = {
          latitude: vm.list[0].lat,
          longitude: vm.list[0].lng
        };
        $timeout(function () {
          for(var i = 0; i < vm.list.length; i++) {
            vm.locations.push({
              'id': i,
              'latitude': vm.list[i].lat,
              'longitude': vm.list[i].lng
            });
          }
        }, 0);
        vm.loaded = true;
      }

      function deep_value(obj, path) {
        for(var k = 0, keys = path.split('.'), len = keys.length; k < len; k++) {
          if(!angular.isObject(obj)) return null;
          obj = obj[keys[k]];
        }
        return obj;
      }

      function validLocation(location) {
        return (angular.isObject(location) && location.lat <= 85 && location.lat >= -85 && location.lng <= 180 && location.lng >= -180);
      }

      $scope.$watch(function() { return vm.waypoints }, function(newValue, oldValue) {
        if(!angular.isArray(vm.waypoints) && !angular.isObject(vm.waypoints) || vm.waypoints == null) {
          return;
        }
        if(!angular.isArray(vm.waypoints)) {
          vm.points = {};
          angular.copy(vm.waypoints, vm.points);
          if(vm.obj != 'self') {
            vm.points = deep_value(vm.points, vm.obj);
            if(!validLocation(vm.points)) return;
          }
          generateMarkers(true);
          return;
        }
        if(vm.waypoints.length < 1) {
          return;
        }
        if(angular.isDefined(oldValue) && newValue.length === oldValue.length) {
          var flag = false;
          for(var i = 0; i < newValue.length; i++) {
            if(!angular.equals(newValue[i].location, oldValue[i].location)) {
              flag = true;
            }
          }
          if(flag === false && vm.loaded) {
            return;
          }
        }
        vm.points = [];
        angular.copy(vm.waypoints, vm.points);
        if(vm.obj != '\'self\'') {
          for(var j = vm.points.length-1; j >= 0; j--) {
           vm.points[j] = deep_value(vm.points[j], vm.obj);
           if(!validLocation(vm.points[j])) vm.points.splice(j, 1);
          }
          if(vm.points.length < 1) return;
        }
        generateMarkers(false);
      }, true);
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('jsonld', jsonld);

  /** @ngInject */
  function jsonld($filter, $sce) {
    var directive = {
      restrict: 'E',
      template: function() {
        return '<script type="application/ld+json" ng-bind-html="onGetJson()"></script>';
      },
      link: function($scope, $element, $attrs) {
        $scope.onGetJson = function() {
          return $sce.trustAsHtml($filter('json')($scope.json));
        }
      },
      scope: {
        json: '=json'
      },
      replace: true
    };

    return directive;
  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brDropdown', dropdownDirective);

  /** @ngInject */
  function dropdownDirective($window, $common, $document) {
    var directive = {
      restrict: 'EA',
      scope: {
        open: '=brOpen',
        onSortAsc: '=brOnSortAsc',
        onSortDesc: '=brOnSortDesc',
        col: '=brCol',
        filterType: '=brFilterType',
        field: '=brField',
        dataType: '=brDataType',
        values: '=brValues',
        filterData: '=brFilterData',
        nameFilter: '=brNameFilter',
        onApply: '=brOnApply'
      },
      templateUrl: 'app/components/dropdown/dropdown.html',
      controller: 'DropdownController',
      controllerAs: 'dropdown',
      bindToController: true,
      compile: function (tElement, tAttrs) {
        return function (scope, element, attrs, ctrls, transcludeFn) {
          //
          //
          var dropdown = ctrls;
          dropdown.id = 0;
          dropdown.open = false;
          function onDocumentClick(e) {
            if (!dropdown.open) return; //Skip it if dropdown is close
            var contains = false;
            if ($window.jQuery) {
              // Firefox 3.6 does not support element.contains()
              // See Node.contains https://developer.mozilla.org/en-US/docs/Web/API/Node.contains
              contains = $window.jQuery.contains(element[0], e.target);
            } else {
              contains = element[0].contains(e.target);
            }
            if (!contains && !dropdown.clickTriggeredSelect) {
              // dropdown.close();
              dropdown.open = false;
              scope.$digest();
            }
            dropdown.clickTriggeredSelect = false;
          }

          // See Click everywhere but here. Similar approach to http://stackoverflow.com/questions/12931369
          // but using the capture phase instead of bubble phase of the event propagation.
          //
          // Using the capture phase avoids problems that araise when event.stopPropatagion()
          // is called before the event reaches the `document`.
          $window.document.addEventListener('click', onDocumentClick, true);
          //
          scope.$on('$destroy', function () {
            $window.document.removeEventListener('click', onDocumentClick, true);
          });
          // Support for appending the select field to the body when its open
          scope.$watch('dropdown.open', function (isOpen) {

            if (isOpen) {
              positionDropdown();
            } else {
              resetDropdown();
            }
          });

          // Move the dropdown back to its original location when the scope is destroyed. Otherwise
          // it might stick around when the user routes away or the select field is otherwise removed
          scope.$on('$destroy', function () {
            resetDropdown();
          });

          // Hold on to a reference to the .ui-select-container element for appendToBody support
          var placeholder = null,
            originalWidth = '';

          function positionDropdown() {
            // Remember the absolute position of the element
            var offset = $common.offset(element, $window, $document);

            // Clone the element into a placeholder element to take its original place in the DOM
            placeholder = angular.element('<div class="br-dropdown-placeholder"></div>');
            placeholder[0].style.width = offset.width + 'px';
            placeholder[0].style.height = offset.height + 'px';
            element.after(placeholder);

            // Remember the original value of the element width inline style, so it can be restored
            // when the dropdown is closed
            originalWidth = element[0].style.width;

            // Now move the actual dropdown element to the end of the body
            $document.find('body').append(element);

            element[0].style.position = 'absolute';
            element[0].style.left = offset.left + 'px';
            element[0].style.top = offset.top + 'px';
            element[0].style.width = 400 + 'px';
            element[0].style['margin-top'] = 20 + 'px';
            if (offset.left + 400 > $window.innerWidth) {
              element[0].style.left = $window.innerWidth - 400 + 'px';
            }
          }

          function resetDropdown() {
            if (placeholder === null) {
              // The dropdown has not actually been display yet, so there's nothing to reset
              return;
            }

            // Move the dropdown element back to its original location in the DOM
            placeholder.replaceWith(element);
            placeholder = null;

            element[0].style.position = '';
            element[0].style.left = '';
            element[0].style.top = '';
            element[0].style.width = originalWidth;

            // Set focus back on to the moved element
            // dropdown.setFocus();
          }
          dropdown.open = false;
        };
      }
    };
    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('DropdownController', DropdownController);

  /** @ngInject */
  function DropdownController($timeout, $common, $scope, uiGridConstants) {
    var vm = this;
    vm.$onInit = function () {
      vm.open = false;
      $scope.$watch(function () {
        if (vm.filterData)
          return vm.filterData.currentFilter;
        return null;
      }, function() {
        if (vm.filterData && vm.filterData.currentFilter[vm.filterType]) {
          vm.filter = angular.copy(vm.filterData.currentFilter[vm.filterType].find(function (element) {
            return element.field === vm.field;
          }));
        }
        //
        //
      });
      vm.lang = {
        selectAll: "Seleziona visibili",
        selectNone: "Deseleziona visibili",
        reset: "Riprestina filtri precedenti",
        search: "Cerca...",
        nothingSelected: "Nessun filtro" //default-label is deprecated and replaced with this.
      }
      vm.apply = function(filter) {
        vm.open = false;
        var currentFilter = vm.filterData.currentFilter[vm.filterType].find(function (element) {
          return element.field === vm.field;
        });
        if (vm.filterType === 'between') {
          currentFilter.min = vm.filter.min;
          currentFilter.max = vm.filter.max;
        }
        else if (vm.filterType === 'belongs') {
          currentFilter.value = vm.filter.values;
          currentFilter.values = vm.filter.values;
        }
        vm.onApply(currentFilter);
      }
      vm.sortAsc = function() {



        vm.col.grid.sortColumn(vm.col, uiGridConstants.ASC).then(function(response) {
          vm.open = false;
          vm.col.grid.api.core.refresh();
        });
        // vm.onSortAsc('asc');
      }
      vm.sortDesc = function() {



        vm.col.grid.sortColumn(vm.col, uiGridConstants.DESC).then(function(response) {
          vm.open = false;
          vm.col.grid.api.core.refresh();

        });
        // vm.onSortDesc('desc');
      }
      /**
       * Controller Functions
       */

      /**
       * Controller watchers
       */
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .factory('Filtersave', filterService);

  /** @ngInject */
  function filterService(ModalService, $rootScope, $timeout, $window) {
    var tmt, mdl;
    var service = {
      show: function(title, filters, cancel, confirm, cross, after, timeout, onCancel, onConfirm) {
        if(after) {
          tmt = $timeout(showModal, after);
        }
        else {
          showModal();
        }

        function showModal() {
          ModalService.showModal({
            templateUrl: "app/components/filter-save/filter.modal.html",
            controller: 'FiltersaveController',
            controllerAs: 'filter',
            inputs: {
              title: title,
              msg: '',
              cancel: cancel,
              confirm: confirm,
              cross: cross,
              timeout: timeout,
              filters: filters,
              // badfilters: badfilters
            }
          }).then(function(modal) {
            mdl = modal;
            modal.close.then(function(result) {

              if(angular.isObject(result)) {
                if(angular.isFunction(onConfirm)) onConfirm(result);
              }
              else {
                if(angular.isFunction(onCancel)) onCancel(result);
              }
            });
          });
        }
      }
    };

    var deregistrationCallback1 = $rootScope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams) {
      $timeout.cancel(tmt);
      if(mdl && mdl.scope && angular.isFunction(mdl.scope.close)) {
        mdl.scope.close();
      }
    });
    $rootScope.$on('$destroy', deregistrationCallback1);

    $rootScope.$on('$destroy', function() {
      $timeout.cancel(tmt);
      if(mdl && mdl.scope && angular.isFunction(mdl.scope.close)) {
        mdl.scope.close();
      }
    });

    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('FiltersaveController', FiltersaveController);

  /** @ngInject */
  function FiltersaveController($scope, $timeout, close, title, filters, /*badfilters,*/ msg, confirm, cancel, cross, timeout) {
    var vm = this;

    //
    vm.modal = {
      title: title,
      confirm: confirm,
      cancel: cancel,
      cross: cross,
      filters: filters,
      // badfilters: badfilters
    };
    vm.lang = {
      selectAll: "Seleziona visibili",
      selectNone: "Deseleziona visibili",
      reset: "Riprestina filtri precedenti",
      search: "Cerca...",
      nothingSelected: "Nessun filtro" //default-label is deprecated and replaced with this.
    };
    vm.times = [];
    for (var i = 0; i <= 24; i++) {
      vm.times.push(i);
    }

    vm.closeIt = function(result) {
      if(angular.isFunction(close)) {
        close(result);
      }
    };

    if(timeout > 0) {
      var tmt = $timeout(function() {
        vm.closeIt(-2);
      }, timeout);
      $scope.$on('$destroy', function() {
        $timeout.cancel(tmt);
      });
    }
  }
})();

/* eslint-disable */
(function() {
  'use strict';
  var Module = angular.module('datePicker', []);

  Module.constant('datePickerConfig', {
    template: 'app/components/datepicker/datepicker-template.html',
    view: 'month',
    views: ['year', 'month', 'date', 'hours', 'minutes'],
    momentNames: {
      year: 'year',
      month: 'month',
      date: 'day',
      hours: 'hours',
      minutes: 'minutes',
    },
    viewConfig: {
      year: ['years', 'isSameYear'],
      month: ['months', 'isSameMonth'],
      hours: ['hours', 'isSameHour'],
      minutes: ['minutes', 'isSameMinutes'],
    },
    step: 5
  });

  //Moment format filter.
  Module.filter('mFormat', function () {
    return function (m, format, tz) {
      if (!(moment.isMoment(m))) {
        return moment(m).format(format);
      }
      return tz ? moment.tz(m, tz).format(format) : m.format(format);
    };
  });

  Module.directive('datePicker', ['datePickerConfig', 'datePickerUtils', function datePickerDirective(datePickerConfig, datePickerUtils) {

    //noinspection JSUnusedLocalSymbols
    return {
      // this is a bug ?
      require: '?ngModel',
      template: '<div ng-include="template"></div>',
      scope: {
        model: '=datePicker',
        after: '=?',
        before: '=?'
      },
      link: function (scope, element, attrs, ngModel) {
        function prepareViews() {
          scope.views = datePickerConfig.views.concat();
          scope.view = attrs.view || datePickerConfig.view;

          scope.views = scope.views.slice(
            scope.views.indexOf(attrs.maxView || 'year'),
            scope.views.indexOf(attrs.minView || 'minutes') + 1
          );

          if (scope.views.length === 1 || scope.views.indexOf(scope.view) === -1) {
            scope.view = scope.views[0];
          }
        }

        function getDate(name) {
          return datePickerUtils.getDate(scope, attrs, name);
        }

        var arrowClick = false,
          tz = scope.tz = attrs.timezone,
          createMoment = datePickerUtils.createMoment,
          eventIsForPicker = datePickerUtils.eventIsForPicker,
          step = parseInt(attrs.step || datePickerConfig.step, 10),
          partial = !!attrs.partial,
          minDate = getDate('minDate'),
          maxDate = getDate('maxDate'),
          now = scope.now = createMoment(),
          selected = scope.date = createMoment(scope.model || minDate || now),
          autoclose = attrs.autoClose === 'true',
        // Either gets the 1st day from the attributes, or asks moment.js to give it to us as it is localized.
          firstDay = attrs.firstDay && attrs.firstDay >= 0 && attrs.firstDay <= 6 ? parseInt(attrs.firstDay, 10) : moment().weekday(0).day(),
          setDate,
          prepareViewData,
          isSame,
          clipDate,
          isNow,
          inValidRange;

        datePickerUtils.setParams(tz, firstDay);

        if (!scope.model) {
          selected.minute(Math.ceil(selected.minute() / step) * step).second(0);
        }

        scope.template = attrs.template || datePickerConfig.template;

        scope.watchDirectChanges = attrs.watchDirectChanges !== undefined;
        scope.callbackOnSetDate = attrs.dateChange ? datePickerUtils.findFunction(scope, attrs.dateChange) : undefined;

        prepareViews();

        scope.setView = function (nextView) {
          if (scope.views.indexOf(nextView) !== -1) {
            scope.view = nextView;
          }
        };

        scope.selectDate = function (date) {
          if (attrs.disabled) {
            return false;
          }
          if (isSame(scope.date, date)) {
            date = scope.date;
          }
          date = clipDate(date);
          if (!date) {
            return false;
          }
          scope.date = date;

          var nextView = scope.views[scope.views.indexOf(scope.view) + 1];
          if ((!nextView || partial) || scope.model) {
            setDate(date);
          }

          if (nextView) {
            scope.setView(nextView);
          } else if (autoclose) {
            element.addClass('hidden');
            scope.$emit('hidePicker');
          } else {
            prepareViewData();
          }
        };

        setDate = function (date) {
          if (date) {
            scope.model = date;
            if (ngModel) {
              ngModel.$setViewValue(date);
            }
          }
          scope.$emit('setDate', scope.model, scope.view);

          //This is duplicated in the new functionality.
          if (scope.callbackOnSetDate) {
            scope.callbackOnSetDate(attrs.datePicker, scope.date);
          }
        };

        function update() {
          var view = scope.view;
          datePickerUtils.setParams(tz, firstDay);

          if (scope.model && !arrowClick) {
            scope.date = createMoment(scope.model);
            arrowClick = false;
          }

          var date = scope.date;

          switch (view) {
            case 'year':
              scope.years = datePickerUtils.getVisibleYears(date);
              break;
            case 'month':
              scope.months = datePickerUtils.getVisibleMonths(date);
              break;
            case 'date':
              scope.weekdays = scope.weekdays || datePickerUtils.getDaysOfWeek();
              scope.weeks = datePickerUtils.getVisibleWeeks(date);
              break;
            case 'hours':
              scope.hours = datePickerUtils.getVisibleHours(date);
              break;
            case 'minutes':
              scope.minutes = datePickerUtils.getVisibleMinutes(date, step);
              break;
          }

          prepareViewData();
        }

        function watch() {
          if (scope.view !== 'date') {
            return scope.view;
          }
          return scope.date ? scope.date.month() : null;
        }

        scope.$watch(watch, update);

        if (scope.watchDirectChanges) {
          scope.$watch('model', function () {
            arrowClick = false;
            update();
          });
        }

        prepareViewData = function () {
          var view = scope.view,
            date = ngModel.$viewValue,
            classes = [], classList = '',
            i, j;

          datePickerUtils.setParams(tz, firstDay);

          if(view === 'date') {
            var weeks = scope.weeks, week;
            for (i = 0; i < weeks.length; i++) {
              week = weeks[i];
              classes.push([]);
              for (j = 0; j < week.length; j++) {
                classList = '';
                if (datePickerUtils.isSameDay(date, week[j])) {
                  classList += 'active';
                }
                if (isNow(week[j], view)) {
                  classList += ' now';
                }
                //if (week[j].month() !== date.month()) classList += ' disabled';
                if (!inValidRange(week[j])) {
                  classList += ' disabled';
                }
                if (!datePickerUtils.isSameMonth(scope.date, week[j])) {
                  classList += ' muted';
                }
                classes[i].push(classList);
              }
            }
          } else {
            var params = datePickerConfig.viewConfig[view],
              dates = scope[params[0]],
              compareFunc = params[1];

            for (i = 0; i < dates.length; i++) {
              classList = '';
              if (datePickerUtils[compareFunc](date, dates[i])) {
                classList += 'active';
              }
              if (isNow(dates[i], view)) {
                classList += ' now';
              }
              if (!inValidRange(dates[i])) {
                classList += ' disabled';
              }
              classes.push(classList);
            }
          }
          scope.classes = classes;
        };

        scope.next = function (delta) {
          var date = moment(scope.date);
          delta = delta || 1;
          switch (scope.view) {
            case 'year':
            /*falls through*/
            case 'month':
              date.year(date.year() + delta);
              break;
            case 'date':
              date.month(date.month() + delta);
              break;
            case 'hours':
            /*falls through*/
            case 'minutes':
              date.hours(date.hours() + delta);
              break;
          }
          date = clipDate(date);
          if (date) {
            scope.date = date;
            arrowClick = true;
            update();
          }
        };

        inValidRange = function (date) {
          var valid = true;
          if (minDate && minDate.isAfter(date)) {
            valid = isSame(minDate, date);
          }
          if (maxDate && maxDate.isBefore(date)) {
            valid &= isSame(maxDate, date);
          }
          return valid;
        };

        isSame = function (date1, date2) {
          return date1.isSame(date2, datePickerConfig.momentNames[scope.view]) ? true : false;
        };

        clipDate = function (date) {
          if (minDate && minDate.isAfter(date)) {
            return minDate;
          } else if (maxDate && maxDate.isBefore(date)) {
            return maxDate;
          } else {
            return date;
          }
        };

        isNow = function (date, view) {
          var is = true;

          switch (view) {
            case 'minutes':
              is &= ~~(now.minutes() / step) === ~~(date.minutes() / step);
            /* falls through */
            case 'hours':
              is &= now.hours() === date.hours();
            /* falls through */
            case 'date':
              is &= now.date() === date.date();
            /* falls through */
            case 'month':
              is &= now.month() === date.month();
            /* falls through */
            case 'year':
              is &= now.year() === date.year();
          }
          return is;
        };

        scope.prev = function (delta) {
          return scope.next(-delta || -1);
        };

        scope.$on('pickerUpdate', function (event, pickerIDs, data) {
          if (eventIsForPicker(pickerIDs, element[0].id)) {
            var updateViews = false, updateViewData = false;

            if (angular.isDefined(data.minDate)) {
              minDate = data.minDate ? data.minDate : false;
              updateViewData = true;
            }
            if (angular.isDefined(data.maxDate)) {
              maxDate = data.maxDate ? data.maxDate : false;
              updateViewData = true;
            }

            if (angular.isDefined(data.minView)) {
              attrs.minView = data.minView;
              updateViews = true;
            }
            if (angular.isDefined(data.maxView)) {
              attrs.maxView = data.maxView;
              updateViews = true;
            }
            attrs.view = data.view || attrs.view;

            if (updateViews) {
              prepareViews();
            }

            if (updateViewData) {
              update();
            }
          }
        });
      }
    };
  }]);

})();

/* eslint-disable */
(function() {
  'use strict';
  var PRISTINE_CLASS = 'ng-pristine',
    DIRTY_CLASS = 'ng-dirty';

  var Module = angular.module('datePicker');

  Module.constant('dateTimeConfig', {
    template: function (attrs, id) {
      return '' +
        '<div ' +
        (id ? 'id="' + id + '" ' : '') +
        'date-picker="' + attrs.ngModel + '" ' +
        (attrs.view ? 'view="' + attrs.view + '" ' : '') +
        (attrs.maxView ? 'max-view="' + attrs.maxView + '" ' : '') +
        (attrs.maxDate ? 'max-date="' + attrs.maxDate + '" ' : '') +
        (attrs.autoClose ? 'auto-close="' + attrs.autoClose + '" ' : '') +
        (attrs.template ? 'template="' + attrs.template + '" ' : '') +
        (attrs.minView ? 'min-view="' + attrs.minView + '" ' : '') +
        (attrs.minDate ? 'min-date="' + attrs.minDate + '" ' : '') +
        (attrs.partial ? 'partial="' + attrs.partial + '" ' : '') +
        (attrs.step ? 'step="' + attrs.step + '" ' : '') +
        (attrs.onSetDate ? 'date-change="' + attrs.onSetDate + '" ' : '') +
        (attrs.ngModel ? 'ng-model="' + attrs.ngModel + '" ' : '') +
        (attrs.firstDay ? 'first-day="' + attrs.firstDay + '" ' : '') +
        (attrs.timezone ? 'timezone="' + attrs.timezone + '" ' : '') +
        'class="date-picker-date-time"></div>';
    },
    format: 'YYYY-MM-DD HH:mm',
    views: ['date', 'year', 'month', 'hours', 'minutes'],
    autoClose: false,
    position: 'relative'
  });

  Module.directive('dateTimeAppend', function () {
    return {
      link: function (scope, element) {
        element.bind('click', function () {
          element.find('input')[0].focus();
        });
      }
    };
  });


  Module.directive('dateTime', ['$compile', '$timeout', '$document', '$filter', 'dateTimeConfig', '$parse', 'datePickerUtils', function ($compile, $timeout, $document, $filter, dateTimeConfig, $parse, datePickerUtils) {
    var body = $document.find('body');
    var dateFilter = $filter('mFormat');


    return {
      require: 'ngModel',
      scope: true,
      link: function (scope, element, attrs, ngModel) {
        var format = attrs.format || dateTimeConfig.format,
          parentForm = element.inheritedData('$formController'),
          views = $parse(attrs.views)(scope) || dateTimeConfig.views.concat(),
          view = attrs.view || views[0],
          index = views.indexOf(view),
          dismiss = attrs.autoClose ? $parse(attrs.autoClose)(scope) : dateTimeConfig.autoClose,
          picker = null,
          position = attrs.position || dateTimeConfig.position,
          container = null,
          minDate = null,
          minValid = null,
          maxDate = null,
          maxValid = null,
          timezone = attrs.timezone || false,
          eventIsForPicker = datePickerUtils.eventIsForPicker,
          dateChange = null,
          shownOnce = false,
          template;

        if (index === -1) {
          views.splice(index, 1);
        }

        views.unshift(view);

        function formatter(value) {
          if (value) {
            return dateFilter(value, format, timezone);
          }
        }

        function parser(viewValue) {
          if (!viewValue) {
            return '';
          }
          var parsed = moment(viewValue, format);
          if (parsed.isValid()) {
            return parsed;
          }
        }

        function setMin(date) {
          minDate = date;
          attrs.minDate = date ? date.format() : date;
          minValid = moment.isMoment(date);
        }

        function setMax(date) {
          maxDate = date;
          attrs.maxDate = date ? date.format() : date;
          maxValid = moment.isMoment(date);
        }

        ngModel.$formatters.push(formatter);
        ngModel.$parsers.unshift(parser);

        if (angular.isDefined(attrs.minDate)) {
          setMin(datePickerUtils.findParam(scope, attrs.minDate));

          ngModel.$validators.min = function (value) {
            //If we don't have a min / max value, then any value is valid.
            return minValid ? moment.isMoment(value) && (minDate.isSame(value) || minDate.isBefore(value)) : true;
          };
        }

        if (angular.isDefined(attrs.maxDate)) {
          setMax(datePickerUtils.findParam(scope, attrs.maxDate));

          ngModel.$validators.max = function (value) {
            return maxValid ? moment.isMoment(value) && (maxDate.isSame(value) || maxDate.isAfter(value)) : true;
          };
        }

        if (angular.isDefined(attrs.dateChange)) {
          dateChange = datePickerUtils.findFunction(scope, attrs.dateChange);
        }

        function getTemplate() {
          template = dateTimeConfig.template(attrs);
        }


        function updateInput(event) {
          event.stopPropagation();
          if (ngModel.$pristine) {
            ngModel.$dirty = true;
            ngModel.$pristine = false;
            element.removeClass(PRISTINE_CLASS).addClass(DIRTY_CLASS);
            if (parentForm) {
              parentForm.$setDirty();
            }
            ngModel.$render();
          }
        }

        function clear() {
          if (picker) {
            picker.remove();
            picker = null;
          }
          if (container) {
            container.remove();
            container = null;
          }
        }

        scope.$on('pickerUpdate', function (event, pickerIDs, data) {
          if (eventIsForPicker(pickerIDs, element[0].id)) {
            if (picker) {
              //Need to handle situation where the data changed but the picker is currently open.
              //To handle this, we can create the inner picker with a random ID, then forward
              //any events received to it.
            } else {
              var validateRequired = false;
              if (angular.isDefined(data.minDate)) {
                setMin(data.minDate);
                validateRequired = true;
              }
              if (angular.isDefined(data.maxDate)) {
                setMax(data.maxDate);
                validateRequired = true;
              }

              if (angular.isDefined(data.minView)) {
                attrs.minView = data.minView;
              }
              if (angular.isDefined(data.maxView)) {
                attrs.maxView = data.maxView;
              }
              attrs.view = data.view || attrs.view;

              if (validateRequired) {
                ngModel.$validate();
              }
              if (angular.isDefined(data.format)) {
                format = attrs.format = data.format || dateTimeConfig.format;
                ngModel.$modelValue = -1; //Triggers formatters. This value will be discarded.
              }
              getTemplate();
            }
          }
        });

        function showPicker() {
          if (picker) {
            return;
          }
          // create picker element
          picker = $compile(template)(scope);
          scope.$digest();

          //If the picker has already been shown before then we shouldn't be binding to events, as these events are already bound to in this scope.
          if (!shownOnce) {
            scope.$on('setDate', function (event, date, view) {
              updateInput(event);
              if (dateChange) {
                dateChange(attrs.ngModel, date);
              }
              if (dismiss && views[views.length - 1] === view) {
                clear();
              }
            });

            scope.$on('hidePicker', function () {
              element.triggerHandler('blur');
            });

            scope.$on('$destroy', clear);

            shownOnce = true;
          }


          // move picker below input element

          if (position === 'absolute') {
            var pos = element[0].getBoundingClientRect();
            // Support IE8
            var height = pos.height || element[0].offsetHeight;
            picker.css({top: (pos.top + height) + 'px', left: pos.left + 'px', display: 'block', position: position});
            body.append(picker);
          } else {
            // relative
            container = angular.element('<div date-picker-wrapper></div>');
            element[0].parentElement.insertBefore(container[0], element[0]);
            container.append(picker);
            //          this approach doesn't work
            //          element.before(picker);
            picker.css({top: element[0].offsetHeight + 'px', display: 'block'});
          }
          picker.bind('mousedown', function (evt) {
            evt.preventDefault();
          });
        }

        element.bind('mousedown', showPicker);
        element.bind('focus', showPicker);
        element.bind('blur', clear);
        getTemplate();
      }
    };
  }]);

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brDatepicker', datepickerDirective);

  /** @ngInject */
  function datepickerDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        label: '@brLabel',
        labelBottom: '@brLabelBottom',
        placeholder: '@brPlaceholder',
        info: '@brInfo',
        change: '&brChange',
        model: '=brModel',
        disabled: '=?brDisabled',
        minDate: '=?brMinDate',
        maxDate: '=?brMaxDate'
      },
      templateUrl: 'app/components/datepicker/datepicker.html',
      controller: 'DatepickerController',
      controllerAs: 'datepicker',
      bindToController: true
    };
    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('DatepickerController', DatepickerController);

  /** @ngInject */
  function DatepickerController($scope, $timeout, $filter) {
    var vm = this;

    vm.$onInit = function() {
      vm.internalModel = false;
      vm.ignoreSelected = false;

      vm.minDateM = null;
      vm.maxDateM = null;

      vm.id = (new String(new Date().getTime().toString() + Math.random().toString())).replace('.', '');

      if(angular.isUndefined(vm.model)) {
        vm.model = null;
      }
      if(angular.isUndefined(vm.selected)) {
        vm.selected = null;
      }
      if(angular.isDate(vm.minDate)) {
        vm.minDateM = moment(vm.minDate);
      }
      else {
        vm.maxDate = null;
      }
      if(angular.isDate(vm.maxDate)) {
        vm.maxDateM = moment(vm.maxDate);
      }
      else {
        vm.maxDate = null;
      }

      /**
      * Controller functions
      */
      vm.onSelectedChange = function() {
        if(!moment.isMoment(vm.selected)) {
          return;
        }
        if(vm.model === vm.selected.toDate()) return;
        vm.internalModel = true;
        vm.model = vm.selected.toDate();
      }

      /**
      * Controller watchers
      */
      $scope.$watch(function() { return vm.minDate }, function() {
        //console.log("[WATCH] DATEPICKER - MIN DATE CHANGE", vm.minDate);
        if(!angular.isDate(vm.minDate)) {
          vm.minDateM = null;
          $scope.$broadcast('pickerUpdate', [vm.id], {minDate: vm.minDateM});
          return;
        }

        vm.minDateM = moment(vm.minDate);
        $scope.$broadcast('pickerUpdate', [vm.id], {minDate: vm.minDateM});

        if(!angular.isDate(vm.model) || vm.minDate <= vm.model) {
          return;
        }
        vm.selected = moment(vm.minDate);
        $timeout(vm.onSelectedChange, 0);
      });

      $scope.$watch(function() { return vm.maxDate }, function() {
        //console.log("[WATCH] DATEPICKER - MAX DATE CHANGE", vm.maxDate);
        if(!angular.isDate(vm.maxDate)) {
          vm.maxDateM = null;
          $scope.$broadcast('pickerUpdate', [vm.id], {maxDate: vm.maxDateM});
          return;
        }

        vm.maxDateM = moment(vm.maxDate);
        $scope.$broadcast('pickerUpdate', [vm.id], {maxDate: vm.maxDateM});

        if(!angular.isDate(vm.model) || vm.maxDate <= vm.model) {
          return;
        }
        vm.selected = moment(vm.maxDate);
        $timeout(vm.onSelectedChange, 0);
      });

      $scope.$watch(function() { return vm.selected }, function() {
        if(vm.ignoreSelected) {
          //console.log("[WATCH] DATEPICKER - SELECTED CHANGE NT", vm.model, vm.selected);
          vm.ignoreSelected = false;
          return;
        }
        //console.log("[WATCH] DATEPICKER - SELECTED CHANGE", vm.model, vm.selected);
        $timeout(vm.onSelectedChange, 0);
      });

      $scope.$watch(function() { return vm.model }, function() {
        if(vm.internalModel) {
          //console.log("[WATCH] DATEPICKER - INTERNAL MODEL CHANGE", vm.model, vm.selected);
          vm.internalModel = false;
          $timeout(vm.change, 0);
          return;
        }
        //console.log("[WATCH] DATEPICKER - EXTERNAL MODEL CHANGE", vm.model, vm.selected);
        if(!angular.isDate(vm.model)) {
          if(vm.selected !== null) {
            vm.ignoreSelected = true;
            vm.selected = null;
          }
          return;
        }
        if(angular.isDate(vm.minDate) && vm.minDate > vm.model) {
          vm.model = vm.minDate;
          vm.internalModel = true;
        }
        if(angular.isDate(vm.maxDate) && vm.maxDate < vm.model) {
          vm.model = vm.maxDate;
          vm.internalModel = true;
        }
        var date = moment(vm.model);
        if(vm.selected !== date) {
          vm.ignoreSelected = true;
          //console.log("B");
          vm.selected = moment(vm.model);
        }
      });
    };

  }
})();

/* eslint-disable */
(function() {
  'use strict';
  var Module = angular.module('datePicker');

  Module.directive('dateRange', ['$compile', 'datePickerUtils', 'dateTimeConfig', function ($compile, datePickerUtils, dateTimeConfig) {
    function getTemplate(attrs, id, model, min, max) {
      return dateTimeConfig.template(angular.extend(attrs, {
        ngModel: model,
        minDate: min && moment.isMoment(min) ? min.format() : false,
        maxDate: max && moment.isMoment(max) ? max.format() : false
      }), id);
    }

    function randomName() {
      return 'picker' + Math.random().toString().substr(2);
    }

    return {
      scope: {
        start: '=',
        end: '='
      },
      link: function (scope, element, attrs) {
        var dateChange = null,
          pickerRangeID = element[0].id,
          pickerIDs = [randomName(), randomName()],
          createMoment = datePickerUtils.createMoment,
          eventIsForPicker = datePickerUtils.eventIsForPicker;

        scope.dateChange = function (modelName, newDate) {
          //Notify user if callback exists.
          if (dateChange) {
            dateChange(modelName, newDate);
          }
        };

        function setMax(date) {
          scope.$broadcast('pickerUpdate', pickerIDs[0], {
            maxDate: date
          });
        }

        function setMin(date) {
          scope.$broadcast('pickerUpdate', pickerIDs[1], {
            minDate: date
          });
        }

        if (pickerRangeID) {
          scope.$on('pickerUpdate', function (event, targetIDs, data) {
            if (eventIsForPicker(targetIDs, pickerRangeID)) {
              //If we received an update event, dispatch it to the inner pickers using their IDs.
              scope.$broadcast('pickerUpdate', pickerIDs, data);
            }
          });
        }

        datePickerUtils.setParams(attrs.timezone);

        scope.start = createMoment(scope.start);
        scope.end = createMoment(scope.end);

        scope.$watchGroup(['start', 'end'], function (dates) {
          //Scope data changed, update picker min/max
          setMin(dates[0]);
          setMax(dates[1]);
        });

        if (angular.isDefined(attrs.dateChange)) {
          dateChange = datePickerUtils.findFunction(scope, attrs.dateChange);
        }

        attrs.onSetDate = 'dateChange';

        var template = '<div><table class="date-range"><tr><td valign="top">' +
          getTemplate(attrs, pickerIDs[0], 'start', false, scope.end) +
          '</td><td valign="top">' +
          getTemplate(attrs, pickerIDs[1], 'end', scope.start, false) +
          '</td></tr></table></div>';

        var picker = $compile(template)(scope);
        element.append(picker);
      }
    };
  }]);

})();

/* eslint-disable */
(function() {
  'use strict';
  angular.module('datePicker').factory('datePickerUtils', function () {
    var tz, firstDay;
    var createNewDate = function (year, month, day, hour, minute) {
      var utc = Date.UTC(year | 0, month | 0, day | 0, hour | 0, minute | 0);
      return tz ? moment.tz(utc, tz) : moment(utc);
    };

    return {
      getVisibleMinutes: function (m, step) {
        var year = m.year(),
          month = m.month(),
          day = m.date(),
          hour = m.hours(), pushedDate,
          offset = m.utcOffset() / 60,
          minutes = [], minute;

        for (minute = 0; minute < 60; minute += step) {
          pushedDate = createNewDate(year, month, day, hour - offset, minute);
          minutes.push(pushedDate);
        }
        return minutes;
      },
      getVisibleWeeks: function (m) {
        m = moment(m);
        var startYear = m.year(),
          startMonth = m.month();

        //Set date to the first day of the month
        m.date(1);

        //Grab day of the week
        var day = m.day();

        //Go back the required number of days to arrive at the previous week start
        m.date(firstDay - (day + (firstDay >= day ? 6 : -1)));

        var weeks = [];

        while (weeks.length < 6) {
          if (m.year() === startYear && m.month() > startMonth) {
            break;
          }
          weeks.push(this.getDaysOfWeek(m));
          m.add(7, 'd');
        }
        return weeks;
      },
      getVisibleYears: function (d) {
        var m = moment(d),
          year = m.year();

        m.year(year - (year % 10));
        year = m.year();

        var offset = m.utcOffset() / 60,
          years = [],
          pushedDate,
          actualOffset;

        for (var i = 0; i < 12; i++) {
          pushedDate = createNewDate(year, 0, 1, 0 - offset);
          actualOffset = pushedDate.utcOffset() / 60;
          if (actualOffset !== offset) {
            pushedDate = createNewDate(year, 0, 1, 0 - actualOffset);
            offset = actualOffset;
          }
          years.push(pushedDate);
          year++;
        }
        return years;
      },
      getDaysOfWeek: function (m) {
        m = m ? m : (tz ? moment.tz(tz).day(firstDay) : moment().day(firstDay));

        var year = m.year(),
          month = m.month(),
          day = m.date(),
          days = [],
          pushedDate,
          offset = m.utcOffset() / 60,
          actualOffset;

        for (var i = 0; i < 7; i++) {
          pushedDate = createNewDate(year, month, day, 0 - offset, 0, false);
          actualOffset = pushedDate.utcOffset() / 60;
          if (actualOffset !== offset) {
            pushedDate = createNewDate(year, month, day, 0 - actualOffset, 0, false);
          }
          days.push(pushedDate);
          day++;
        }
        return days;
      },
      getVisibleMonths: function (m) {
        var year = m.year(),
          offset = m.utcOffset() / 60,
          months = [],
          pushedDate,
          actualOffset;

        for (var month = 0; month < 12; month++) {
          pushedDate = createNewDate(year, month, 1, 0 - offset, 0, false);
          actualOffset = pushedDate.utcOffset() / 60;
          if (actualOffset !== offset) {
            pushedDate = createNewDate(year, month, 1, 0 - actualOffset, 0, false);
          }
          months.push(pushedDate);
        }
        return months;
      },
      getVisibleHours: function (m) {
        var year = m.year(),
          month = m.month(),
          day = m.date(),
          hours = [],
          hour, pushedDate, actualOffset,
          offset = m.utcOffset() / 60;

        for (hour = 0; hour < 24; hour++) {
          pushedDate = createNewDate(year, month, day, hour - offset, 0, false);
          actualOffset = pushedDate.utcOffset() / 60;
          if (actualOffset !== offset) {
            pushedDate = createNewDate(year, month, day, hour - actualOffset, 0, false);
          }
          hours.push(pushedDate);
        }

        return hours;
      },
      isAfter: function (model, date) {
        return model && model.unix() >= date.unix();
      },
      isBefore: function (model, date) {
        return model.unix() <= date.unix();
      },
      isSameYear: function (model, date) {
        return model && model.year() === date.year();
      },
      isSameMonth: function (model, date) {
        return this.isSameYear(model, date) && model.month() === date.month();
      },
      isSameDay: function (model, date) {
        return this.isSameMonth(model, date) && model.date() === date.date();
      },
      isSameHour: function (model, date) {
        return this.isSameDay(model, date) && model.hours() === date.hours();
      },
      isSameMinutes: function (model, date) {
        return this.isSameHour(model, date) && model.minutes() === date.minutes();
      },
      setParams: function (zone, fd) {
        tz = zone;
        firstDay = fd;
      },
      scopeSearch: function (scope, name, comparisonFn) {
        var parentScope = scope,
          nameArray = name.split('.'),
          target, i, j = nameArray.length;

        do {
          target = parentScope = parentScope.$parent;

          //Loop through provided names.
          for (i = 0; i < j; i++) {
            target = target[nameArray[i]];
            if (!target) {
              break;
            }
          }

          //If we reached the end of the list for this scope,
          //and something was found, trigger the comparison
          //function. If the comparison function is happy, return
          //found result. Otherwise, continue to the next parent scope
          if (target && comparisonFn(target)) {
            return target;
          }

        } while (parentScope.$parent);

        return false;
      },
      findFunction: function (scope, name) {
        //Search scope ancestors for a matching function.
        return this.scopeSearch(scope, name, function (target) {
          //Property must also be a function
          return angular.isFunction(target);
        });
      },
      findParam: function (scope, name) {
        //Search scope ancestors for a matching parameter.
        return this.scopeSearch(scope, name, function () {
          //As long as the property exists, we're good
          return true;
        });
      },
      createMoment: function (m) {
        if (tz) {
          return moment.tz(m, tz);
        } else {
          //If input is a moment, and we have no TZ info, we need to remove TZ
          //info from the moment, otherwise the newly created moment will take
          //the timezone of the input moment. The easiest way to do that is to
          //take the unix timestamp, and use that to create a new moment.
          //The new moment will use the local timezone of the user machine.
          return moment.isMoment(m) ? moment.unix(m.unix()) : moment(m);
        }
      },
      getDate: function (scope, attrs, name) {
        var result = false;
        if (attrs[name]) {
          result = this.createMoment(attrs[name]);
          if (!result.isValid()) {
            result = this.findParam(scope, attrs[name]);
            if (result) {
              result = this.createMoment(result);
            }
          }
        }

        return result;
      },
      //Checks if an event targeted at a specific picker, via either a string name, or an array of strings.
      eventIsForPicker: function (targetIDs, pickerID) {
        function matches(id) {
          if (id instanceof RegExp) {
            return id.test(pickerID);
          }
          return id === pickerID;
        }

        if (angular.isArray(targetIDs)) {
          return targetIDs.some(matches);
        }
        return matches(targetIDs);
      }
    };
  });

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brDatetimepicker', datetimepickerDirective);

  /** @ngInject */
  function datetimepickerDirective() {
    var directive = {
      restrict: 'E',
      scope: {
        date: '=brDate',
        disabled: '=?brDisabled',
        labelDatepicker: '@brLabelDate',
        labelTimepicker: '@brLabelTime',
        labelBottomDatepicker: '@brLabelBottomDate',
        labelBottomTimepicker: '@brLabelBottomTime',
        infoDatepicker: '@brInfoDate',
        infoTimepicker: '@brInfoTime',
        placeholderDatepicker: '@brPlaceholderDate',
        placeholderTimepicker: '@brPlaceholderTime',
        minDate: '=?brMinDate',
        maxDate: '=?brMaxDate',
        defTime: '@?brDefTime',
        onChange: '&?brOnChange'
      },
      templateUrl: 'app/components/datetimepicker/datetimepicker.html',
      controller: 'DatetimepickerController',
      controllerAs: 'datetimepicker',
      bindToController: true
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('DatetimepickerController', DatetimepickerController);

  /** @ngInject */
  function DatetimepickerController($scope, $timeout) {
    var vm = this;

    vm.$onInit = function() {
      vm.internalDate = false;
      vm.modelTimepicker = '';
      vm.modelDatepicker = null;

      if(angular.isUndefined(vm.date)) {
        vm.date = null;
      }
      if(angular.isUndefined(vm.defTime)) {
        vm.defTime = '';
      }

      /**
       * Scope Functions
       */
      vm.onDateChange = function() {
        //console.log("[CALL] DATETIMEPICKER - DATECHANGE", vm.modelDatepicker);
        if(!angular.isDate(vm.modelDatepicker)) return;
        if(!angular.isDate(vm.date)) {
          vm.internalDate = true;
          vm.date = new Date(vm.modelDatepicker);
        }
        else {
          var date = new Date(vm.date);
          date.setFullYear(vm.modelDatepicker.getFullYear());
          date.setMonth(vm.modelDatepicker.getMonth());
          date.setDate(vm.modelDatepicker.getDate());

          if(vm.date !== date) {
            vm.internalDate = true;
            vm.date = date;
          }
        }
        if(!angular.isString(vm.modelTimepicker) || vm.modelTimepicker === '') {
          var time;
          if(angular.isString(vm.defTime) && vm.defTime !== '') {
            time = vm.defTime.split(':');
            var def = new Date(vm.date);
            def.setHours(time[0], time[1], 0, 0);

            if(angular.isDate(vm.minDate) && vm.minDate > def) {
              time = zeroFill(vm.minDate.getHours()) + ':' + zeroFill(vm.minDate.getMinutes());
              vm.modelTimepicker = time;
              if(vm.date !== vm.minDate) {
                vm.internalDate = true;
                vm.date = vm.minDate;
              }
            }
            else {
              vm.modelTimepicker = vm.defTime;
              if(vm.date !== def) {
                vm.internalDate = true;
                vm.date = def;
              }
            }
          }
          else {
            if(angular.isDate(vm.minDate)) {
              time = zeroFill(vm.minDate.getHours()) + ':' + zeroFill(vm.minDate.getMinutes());
              vm.modelTimepicker = time;
              if(vm.date !== vm.date) {
                vm.internalDate = true;
                vm.date = vm.minDate;
              }
            }
            else {
              time = zeroFill(vm.date.getHours()) + ':' + zeroFill(vm.date.getMinutes());
              vm.modelTimepicker = time;
            }
          }
        }
      };
      vm.onTimeChange = function() {
        //console.log("[CALL] DATETIMEPICKER - TIMECHANGE", vm.modelTimepicker);
        if(!angular.isDate(vm.modelDatepicker) || !angular.isString(vm.modelTimepicker) || vm.modelTimepicker === '') {
          return;
        }
        var time = vm.modelTimepicker.split(':');
        if(time.length !== 2) return;
        var date = new Date(vm.date);
        date.setHours(time[0], time[1], 0, 0);

        if(vm.date !== date) {
          vm.internalDate = true;
          vm.date = date;
        }
      };
      /**
      * Controller function
      */
      function zeroFill(number) {
        if(number.toString().length < 2) {
          return '0' + number;
        }
        return '' + number;
      }
      /**
      * Controller watchers
      */
      $scope.$watch(function() { return vm.date }, function() {
        if(vm.internalDate) {
          //console.log("[WATCH] DATETIMEPICKER - INTERNAL DATE CHANGE", vm.date);
          vm.internalDate = false;
          $timeout(vm.onChange, 0);
          return;
        }
        //console.log("[WATCH] DATETIMEPICKER - EXTERNAL DATE CHANGE", vm.date);
        if(!angular.isDate(vm.date)) {
          vm.modelTimepicker = '';
          vm.modelDatepicker = null;
          return;
        }
        var time = zeroFill(vm.date.getHours()) + ':' + zeroFill(vm.date.getMinutes());

        if(vm.modelDatepicker === vm.date && vm.modelTimepicker === time) return;

        vm.modelTimepicker = time;
        vm.modelDatepicker = new Date(vm.date);
      });
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brCompleteRegistration', CompleteRegistrationDirective);

  /** @ngInject */
  function CompleteRegistrationDirective() {
    var directive = {
      restrict: 'E',
      templateUrl:
      'app/components/complete/complete.html',
      controller: 'CompleteRegistrationController',
      controllerAs: 'registration',
      bindToController: true
    };

    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('CompleteRegistrationController', CompleteRegistrationController);

  /** @ngInject */
  function CompleteRegistrationController($rootScope, $cookies, $registration, $supplier, $scope, $state, $location, $common, $alert) {
    var vm = this;

    vm.$onInit = function () {

      function load() {
        var current = $supplier.current();
        if ($common.getRegistrationStep(current, 2)) {
          // $registration.show(2, true, 500, -1);
          $state.go('root.it.supplier.profile.poc', {
            section: '2'
          });

        } else if ($common.getRegistrationStep(current, 3)) {
          // $registration.show(3, true, 500, -1);
          $state.go('root.it.supplier.profile.company', {
            section: '3'
          });

        } else if ($common.getRegistrationStep(current, 5)) {

          $state.go('root.it.supplier.profile.additional', {
            section: '5'
          });
        } else if ($common.getRegistrationStep(current, 7)) {
          $state.go('root.it.supplier.profile.notification', {
            section: '7'
          });
        } else if ($common.getRegistrationStep(current, 8)) {
          $state.go('root.it.supplier.profile.requesttypes', {
            section: '8'
          });
        } else if ($common.getRegistrationStep(current, 9)) {
          $state.go('root.it.supplier.subscribe.list');
        }

      }

      $scope.$on('$supplierSignin', function (supplier) {
        load();
      })
      // $scope.$on('$supplierSignup', function(supplier) {
      //   load();
      // })
      //$supplier.ready().then(function() {
      //  load();
      //});
      var deregister = $scope.$watch($supplier.current,
        function (auth) {
          if (angular.isDefined(auth)) {

            deregister();
            load();
          }
        }, true);
      //load();
      $scope.$on('$stateChangeStart',
        function (event, toState, toParams, fromState, fromParams) {
          // do something
          var current = $supplier.current();
          if ($supplier.isAuthenticated() && toState && toState.name.indexOf('profile') === -1) {
            var isNotOk = ($common.getRegistrationStep(current, 2) ||
              $common.getRegistrationStep(current, 3) ||
              //$common.getRegistrationStep(current, 4) ||
              $common.getRegistrationStep(current, 5) ||
              //$common.getRegistrationStep(current, 6) ||
              $common.getRegistrationStep(current, 7) ||
              $common.getRegistrationStep(current, 8) ||
              ($common.getRegistrationStep(current, 9) && toState.name.indexOf('subscribe') === -1));
            if (isNotOk) {
              event.preventDefault();

              $alert.show('Completa il tuo profilo e scegli un piano', 'Per visualizzare ' + toState.ename + ', completa il tuo profilo e scegli un piano', 'Completa il tuo profilo', '', true, 0, 5000,
                function (cancel) {
                  load();
                });
            }
          }

        });
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .directive('brCookielaw', cookielawDirective);

  /** @ngInject */
  function cookielawDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/cookielaw/cookielaw.html',
      controller: 'CookielawController',
      controllerAs: 'cookielaw',
      bindToController: true
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('CookielawController', CookielawController);

  /** @ngInject */
  function CookielawController($rootScope, $cookies) {
    var vm = this;

    vm.$onInit = function() {
      var cookieLawStatus = $cookies.get('consent');
      $rootScope.cookieLawStatus = cookieLawStatus == 'true' || cookieLawStatus == true;

      vm.setCookielaw = function() {
        $cookies.put('consent', true, {expires: new Date((new Date()).getTime() + 12 * 24 * 3600 * 1000)});
        $rootScope.cookieLawStatus = true;
      };
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .factory('$alert', alertService);

  /** @ngInject */
  function alertService(ModalService, $rootScope, $timeout, $window) {
    var tmt, mdl;
    var service = {
      show: function(title, msg, cancel, confirm, cross, after, timeout, onCancel, onConfirm) {
        if(after) {
          tmt = $timeout(showModal, after);
        }
        else {
          showModal();
        }

        function showModal() {
          ModalService.showModal({
            templateUrl: "app/components/alert/alert.modal.html",
            controller: 'AlertController',
            controllerAs: 'alert',
            inputs: {
              title: title,
              msg: msg,
              cancel: cancel,
              confirm: confirm,
              cross: cross,
              timeout: timeout
            }
          }).then(function(modal) {
            mdl = modal;
            modal.close.then(function(result) {
              if(result === 1) {
                if(angular.isFunction(onConfirm)) onConfirm(result);
              }
              else {
                if(angular.isFunction(onCancel)) onCancel(result);
              }
            });
          });
        }
      }
    };

    var deregistrationCallback1 = $rootScope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams) {
      $timeout.cancel(tmt);
      if(mdl && mdl.scope && angular.isFunction(mdl.scope.close)) {
        mdl.scope.close();
      }
    });
    $rootScope.$on('$destroy', deregistrationCallback1);

    $rootScope.$on('$destroy', function() {
      $timeout.cancel(tmt);
      if(mdl && mdl.scope && angular.isFunction(mdl.scope.close)) {
        mdl.scope.close();
      }
    });

    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .controller('AlertController', AlertController);

  /** @ngInject */
  function AlertController($scope, $timeout, close, title, msg, confirm, cancel, cross, timeout) {
    var vm = this;

    vm.modal = {
      title: title,
      msg: msg,
      confirm: confirm,
      cancel: cancel,
      cross: cross
    };

    vm.closeIt = function(result) {
      if(angular.isFunction(close)) {
        close(result);
      }
    };

    if(timeout > 0) {
      var tmt = $timeout(function() {
        vm.closeIt(-2);
      }, timeout);
      $scope.$on('$destroy', function() {
        $timeout.cancel(tmt);
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .factory('$validator', validatorService);

  /** @ngInject */
  function validatorService(RegexConstant) {
    var rex = RegexConstant;
    var service = function(type, data) {
      if(angular.isUndefined(data) || !angular.isNumber(data) && data !== true && data !== false && !data) return -1;
      switch(type) {
        case 'id': return angular.isString(data) && rex.id.test(data);
        case 'passengers': return angular.isNumber(data) && valBound(data, 1, 9999);
        case 'email': return angular.isString(data) && lenBound(data, 7, 254) && rex.email.test(data);
        case 'password': return angular.isString(data) && lenBound(data, 6, 254) && rex.password.test(data);
        case 'name': return angular.isString(data) && lenBound(data, 3, 254) && rex.name.test(data);
        case 'company': return angular.isString(data) && lenBound(data, 2, 254);
        case 'phone': return angular.isString(data) && lenBound(data, 3, 254) && rex.phone.test(data);
        case 'slug': return angular.isString(data) && rex.slug.test(data);
        case 'taxcode': return angular.isString(data) && (rex.cf.test(data) || rex.pi.test(data));
        case 'place': {
          if(angular.isObject(data) && data.address == '' && angular.isObject(data.location) && angular.isNumber(data.location.lat) && data.location.lat == -360 && data.location.lng == -360) return -1;
          return angular.isObject(data) && angular.isString(data.address) && lenBound(data.address, 2, 127) && angular.isObject(data.location) && angular.isNumber(data.location.lat) && valBound(data.location.lat, -85, 85) && angular.isNumber(data.location.lng) && valBound(data.location.lng, -180, 180);
        }
        case 'plate': return angular.isString(data) && lenBound(data, 2, 20);
        case 'vehicle': return angular.isString(data) && lenBound(data, 2, 31);
        case 'costkilometric': return angular.isNumber(data) && valBound(data, 0, 5);
        case 'costhourly': return angular.isNumber(data) && valBound(data, 0, 250);
        case 'costdrivers': return angular.isNumber(data) && valBound(data, 0, 500);
        case 'kms': return angular.isNumber(data) && valBound(data, 0, 100000);
        case 'hours': return angular.isNumber(data) && valBound(data, 0, 25000);
      }
      return 0;
    };
    function valBound(val, num1, num2) {
      return val >= num1 && val <= num2;
    }
    function lenBound(val, num1, num2) {
      return val.length >= num1 && val.length <= num2;
    }
    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .factory('$supplier', supplierService);

  /** @ngInject */
  function supplierService($rootScope, $state, $q, $timeout, $localStorage, $sessionStorage, Restangular, jwtHelper, $error, $session) {
    var Supplier = Restangular.all("suppliers");

    function broadcast(oldSupplier, newSupplier) {
      if(angular.equals(oldSupplier, newSupplier)) return;
      $rootScope.$broadcast('$supplierChange', oldSupplier, newSupplier);
    }

    var service = {
      init: function() {
        var self = this;
        if($sessionStorage.supplier) {
          if(!$localStorage.supplierAuth) {
            $sessionStorage.supplier = null;
            $localStorage.supplierAuth = null;
          }
          broadcast(undefined, $sessionStorage.supplier);
          launchWatcher();
        }
        else if($localStorage.supplierAuth) {
          self.refresh().then(function() {
            broadcast(undefined, $sessionStorage.supplier);
            launchWatcher();
          }, function(err) {
            $sessionStorage.supplier = null;
            $localStorage.supplierAuth = null;
            broadcast(undefined, $sessionStorage.supplier);
            launchWatcher();
          });
        }
        else {
          $sessionStorage.supplier = null;
          $localStorage.supplierAuth = null;
          broadcast(undefined, null);
          launchWatcher();
        }

        function launchWatcher() {
          $timeout(function() {
            var deregistrationCallback = $rootScope.$watch(function() { return $localStorage.supplierAuth; }, function(newVal, oldVal) {
              if(newVal === oldVal) return;
              if(newVal) {
                if(!$sessionStorage.supplier) {
                  self.refresh().then(function() {
                    broadcast(null, $sessionStorage.supplier);
                  }, function(err) {
                    $sessionStorage.supplier = null;
                    $localStorage.supplierAuth = null;
                  });
                  return;
                }
              }
              else {
                if($sessionStorage.supplier) {
                  var old = {};
                  angular.copy($sessionStorage.supplier, old);
                  $sessionStorage.supplier = null;
                  $localStorage.supplierAuth = null;
                  broadcast(old, $sessionStorage.supplier);
                }
              }
            }, true);
            $rootScope.$on('$destroy', deregistrationCallback);
          }, 0);
        }
      },
      ready: function() {
        var deferred = $q.defer();
        if($sessionStorage.supplier) {
          deferred.resolve();
          return deferred.promise;
        }
        var deregistrationCallback = $rootScope.$watch(function() { return $sessionStorage.supplier; }, function(newVal, oldVal) {
          if(!newVal) return;
          deregistrationCallback();
          deferred.resolve();
        }, true);
        return deferred.promise;
      },
      current: function() {
        return $sessionStorage.supplier || null;
      },
      supplierAuthBearer: function() {
        if(!$localStorage.supplierAuth) return '';
        var decoded = jwtHelper.decodeToken($localStorage.supplierAuth);
        if(new Date() >= new Date(decoded.exp*1000)) {
          this.signout();
          return this.supplierAuthBearer();
        }
        return $localStorage.supplierAuth;
      },
      supplierAuth: function() {
        if(!$localStorage.supplierAuth) return '';
        var decoded = jwtHelper.decodeToken($localStorage.supplierAuth);
        if(new Date() >= new Date(decoded.exp*1000)) {
          this.signout();
          return this.supplierAuth();
        }
        return decoded;
      },
      isAuthenticated: function() {
        return $localStorage.supplierAuth != null;
      },
      signup: function(email, password, name, surname, phone, company, tcompany, companyphone, emergencyphone, taxcode, place) {
        var deferred = $q.defer();
        var request = {
          name: name, surname: surname, email: email, psswrd: password, phone: phone, tcompany: tcompany, company: company, companyphone: companyphone, emergencyphone: emergencyphone, taxcode: taxcode, place: place
        };
        $session.ready().then(function() {
          Supplier.post(request).then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              $rootScope.$broadcast('$supplierSignup', response.supplier);
              deferred.resolve(response.supplier);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      signin: function(email, password) {
        var deferred = $q.defer();
        var request = {
          email: email, psswrd: password
        };
        $session.ready().then(function() {
          Supplier.all('auth').post(request).then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              $sessionStorage.supplier = response.supplier;
              $localStorage.supplierAuth = response.bearer;
              broadcast(null, $sessionStorage.supplier);
              $rootScope.$broadcast('$supplierSignin', $sessionStorage.supplier);
              deferred.resolve($sessionStorage.supplier);
            }
            else {
              $session.refresh();
              $localStorage.supplierAuth = null;
              deferred.reject();
            }
          }, function(err) {
            $session.refresh();
            $localStorage.supplierAuth = null;
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      signout: function() {
        var old;
        if(!$sessionStorage.supplier) {
          old = null;
        }
        else {
          old = {};
          angular.copy($sessionStorage.supplier, old);
        }
        $sessionStorage.supplier = null
        $localStorage.supplierAuth = null;
        broadcast(old, $sessionStorage.supplier);
        $rootScope.$broadcast('$supplierSignout');
      },
      update: function(data) {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).post('', data).then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              var old = {};
              angular.copy($sessionStorage.supplier, old);
              $sessionStorage.supplier = response.supplier;
              broadcast(old, $sessionStorage.supplier);
              $rootScope.$broadcast('$supplierUpdate', old, $sessionStorage.supplier);
              deferred.resolve($sessionStorage.supplier);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      refresh: function() {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).get().then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              var old = {};
              angular.copy($sessionStorage.supplier, old);
              $sessionStorage.supplier = response.supplier;
              broadcast(old, $sessionStorage.supplier);
              $rootScope.$broadcast('$supplierUpdate', old, $sessionStorage.supplier);
              deferred.resolve($sessionStorage.supplier);
            }
            else {
              $session.refresh();
              $localStorage.supplierAuth = null;
              self.signout();
              deferred.reject();
            }
          }, function(err) {
            $session.refresh();
            $localStorage.supplierAuth = null;
            self.signout();
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      getReset: function(email) {
        var deferred = $q.defer();
        var request = {
          email: email
        };
        $session.ready().then(function() {
          Supplier.all('reset').post(request).then(function(response) {
            if(response && response.plain) response = response.plain();
            deferred.resolve();
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      reset: function(supplier_id, token_id, password) {
        var deferred = $q.defer();
        var request = {
          psswrd: password
        };
        $session.ready().then(function() {
          Supplier.one('reset', supplier_id).post(token_id, request).then(function(response) {
            if(response && response.plain) response = response.plain();
            deferred.resolve();
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      confirm: function(token_id) {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var id;
        if(!$sessionStorage.supplier) {
          id = self.supplierAuth().sub;
        }
        else {
          id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', id).one('confirm').post(token_id).then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              self.refresh().then(function() {
                deferred.resolve();
              }, function() {
                deferred.resolve();
              });
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      sendConfirmation: function() {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var id;
        if(!$sessionStorage.supplier) {
          id = self.supplierAuth().sub;
        }
        else {
          id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', id).one('confirm').get().then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve();
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      getTransactions: function() {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('transactions').get().then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      getTrips: function() {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('trips').get().then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      getSentQuotes: function() {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('sent').one('list').get().then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      updateQuote: function(quote) {
        console.log(angular.copy(quote))
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('sent').one('update').post('', {quote: angular.copy(quote)}).then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      duplicateQuote: function(quote_id) {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('sent').one('duplicate').post('', {quote_id: quote_id}).then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      getSentQuote: function(quote_id) {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('sent').one('get', quote_id).get().then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },

      getNetwork: function() {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('network').get().then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      updateNetwork: function(network) {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('network').one('update').post('', {network: network}).then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      getQuotes: function() {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('quotes').get().then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      completeMandate: function(mandate) {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('mandate/complete').post('', {mandate: mandate}).then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      getMandateLink: function(plans) {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('mandate').post('', {
            plans: plans,
          }).then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      changeStatusQuote: function(quote_id, status, request, scope) {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('quotes-status').post('', {quote_ids: [quote_id], status: status, requestString: request, scope: scope}).then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      getQuote: function(quote_id) {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('quote', quote_id).get().then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      getTmpQuote: function(quote_id, supplier_id) {
        var self = this;
        var deferred = $q.defer();
        if($localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        $session.ready().then(function() {
          Supplier.one('external', supplier_id).one('quote', quote_id).get().then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      isVerified: function(supplier_id) {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('verified', supplier_id).get().then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      respondQuote: function(quote_id, response) {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('response', quote_id).post('', {quote_id: quote_id, response: response}).then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      getTrip: function(trip_id) {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('trips', trip_id).get().then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      getOrder: function(order_id) {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('orders', order_id).get().then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      acceptTrip: function(trip_id) {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('trips', trip_id).one('confirm').post().then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      rejectTrip: function(trip_id) {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('trips', trip_id).one('reject').post().then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      addPlace: function(place) {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        var data = {
          place: place
        };
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).post('places', data).then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      getPlaces: function() {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('places').get().then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      getPlace: function(place_id) {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('places', place_id).get().then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      updatePlace: function(place_id, data) {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('places', place_id).post('', data).then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      addVehicle: function(place_id, specs, services, costs, imgs) {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        var data = {
          place_id: place_id,
          specs: specs,
          services: services,
          costs: costs,
          imgs: imgs
        };
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).post('vehicles', data).then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      getVehicles: function() {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('vehicles').get().then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      getVehicle: function(vehicle_id) {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('vehicles', vehicle_id).get().then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      updateVehicle: function(vehicle_id, data) {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('vehicles', vehicle_id).post('', data).then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      saveFilter: function(filter) {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('filters').post('add', {filter: filter, owner: supplier_id}).then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },

      getFilters: function() {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('filters/list').get().then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      getUploadSign: function() {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var supplier_id;
        if(!$sessionStorage.supplier) {
          supplier_id = self.supplierAuth().sub;
        }
        else {
          supplier_id = $sessionStorage.supplier._id;
        }
        $session.ready().then(function() {
          Supplier.one('id', supplier_id).one('upload').get().then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });
        return deferred.promise;
      },
      answerReview: function(review_id, answer) {
        var self = this;
        var deferred = $q.defer();
        if(!$localStorage.supplierAuth) {
          self.signout();
          deferred.reject();
          return deferred.promise;
        }
        var id;
        if(!$sessionStorage.supplier) {
          id = self.supplierAuth().sub;
        }
        else {
          id = $sessionStorage.supplier._id;
        }
        var request = {
          answer: answer
        };
        $session.ready().then(function() {
          Supplier.one('id', id).one('reviews').post(review_id, request).then(function(response) {
            if(response && response.plain) response = response.plain();
            if(response && response.success) {
              deferred.resolve(response.transaction);
            }
            else {
              deferred.reject();
            }
          }, function(err) {
            deferred.reject(err);
          });
        });

        return deferred.promise;
      }
    };

    var deregistrationCallback1 = $rootScope.$on('$error', function(event, err, url) {
      if($error.needsLogout(err, url, 'supplier')) {
        service.signout();
      }
    });
    $rootScope.$on('$destroy', deregistrationCallback1);

    var deregistrationCallback2 = $rootScope.$on('$sessionChange', function(event, oldValue, newValue) {
      var cur = $session.session();
      if(!cur) {
        service.signout();
      }
      else {
        var supplierAuth = service.supplierAuth();
        if(supplierAuth) {
          if(cur.session != supplierAuth.session) {
            service.signout();
          }
        }
      }
    });
    $rootScope.$on('$destroy', deregistrationCallback2);

    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .factory('$solutions', solutionsService);

  /** @ngInject */
  function solutionsService($rootScope, $timeout) {
    var srvList = ['audio', 'coffeMachine', 'conditioner', 'display', 'dvdPlayer', 'electricity', 'fridge', 'kitchen', 'leatherSeats', 'light', 'luggage', 'microphone', 'panoramicWindows', 'radio', 'tintedWindows', 'toilet', 'tvAerial', 'usb', 'wheelchair', 'wifi'];

    function getEmptySolution() {
      var empty = {
        items: [],
        orders: [],
        valid: [],
        imgs: [],
        services: {
          audio: true, coffeMachine: true, conditioner: true, display: true, dvdPlayer: true, electricity: true, fridge: true, kitchen: true, leatherSeats: true, light: true, luggage: true, microphone: true, panoramicWindows: true, radio: true, tintedWindows: true, toilet: true, tvAerial: true, usb: true, wheelchair: true, wifi: true
        },
        computed: {
          seats: {
            drivers: 0,
            passengers: 0
          },
          drivers: 0,
          costs: {
            trip: {
              taxes: 0, total: 0
            },
            services: {
              taxes: 0, total: 0
            }
          }
        }
      };
      /*for(var i = 0; i < srvList.length; i++) {
        var key = srvList[i];
        empty.services[key] = true;
      }*/
      return empty;
    }
    function sumItem(solution, item) {
      solution.items.push(item._idx);
      solution.orders.push(item);
      if(item.status == 'voided') return;
      solution.valid.push(item);
      solution.imgs = solution.imgs.concat(item.Vehicle.imgs);
      solution.imgs = solution.imgs.filter(function (item, pos) {return solution.imgs.indexOf(item) == pos});
      solution.computed.seats.drivers += item.computed.seats.drivers;
      solution.computed.seats.passengers += item.computed.seats.passengers;

      solution.computed.drivers += item.computed.drivers;

      solution.computed.costs.trip.taxes = roundToTwo(solution.computed.costs.trip.taxes + item.computed.costs.trip.taxes);
      solution.computed.costs.trip.total = roundToTwo(solution.computed.costs.trip.total + item.computed.costs.trip.total);
      /*for(var i = 0; i < srvList.length; i++) {
        var key = srvList[i];
        solution.computed.costs.services.taxes = roundToTwo(solution.computed.costs.services.taxes + item.computed.costs.services[key].taxes);
        solution.computed.costs.services.total = roundToTwo(solution.computed.costs.services.total + item.computed.costs.services[key].total);
        //solution.services[key] = solution.services[key] && item.Vehicle.services[key];
      } */
      function roundToTwo(num) {
        return +(Math.round(num + "e+2")  + "e-2");
      }
    }

    var service = {
      generate: function(orig_items, filters, passengers, cb) {
        var solutions = [];
        var suppliers = 0;
        var ValidItems = orig_items.filter(filterByService).map(costsByServices);
        ValidItems = ValidItems.filter(filterBySeats);
        var ValidGroups = groupBySupplier(ValidItems);
        if(!suppliers) {
          cb(solutions);
          return solutions;
        }
        for(var key in ValidGroups) {
          getSolutions(ValidGroups[key], passengers, {}, {}, ended);
        }
        var count = 0;
        function ended() {
          count++;
          if(count == suppliers) {
            cb(solutions);
          }
        }
        return solutions;

        function groupBySupplier(items) {
          var groups = {};
          for(var i = 0; i < items.length; i++) {
            if(groups[items[i].supplier_id]) {
              groups[items[i].supplier_id].push(items[i]);
            }
            else {
              groups[items[i].supplier_id] = [items[i]];
              suppliers++;
            }
          }
          return groups;
        }
        function filterBySeats(item) {
          if(item.computed.seats.passengers >= passengers) {
            if(!solutions.length) {
              var solution = getEmptySolution();
              sumItem(solution, item);
              solutions.push(solution);
            }
            else {
              $timeout(function(item) {
                var solution = getEmptySolution();
                sumItem(solution, item);
                solutions.push(solution);
              }, 250*solutions.length, true, item);
            }
            return false;
          }
          return true;
        }
        function filterByService(item) {
          for(var i = 0; i < srvList.length; i++) {
            var key = srvList[i];
            if(item.Vehicle.services[key] == false && filters.services[key] == true) {
              return false;
            }
          }
          return true;
        }
        function costsByServices(item) {
          var newitem = {};
          angular.copy(item, newitem);
          var taxes = 0;
          var total = 0;
          for(var i = 0; i < srvList.length; i++) {
            var key = srvList[i];
            if(item.Vehicle.services[key] == true && filters.services[key] == true) {
              taxes += item.computed.costs.services[key].taxes;
              total += item.computed.costs.services[key].total;
            }
          }
          newitem.computed.costs.services = {
            taxes: taxes,
            total: total
          };
          return newitem;
        }

        function localBest(items, passengers, ignored) {
          var best = -1;
          var min = NaN;

          for(var i = 0; i < items.length; i++) {
            if(ignored[items[i]._idx]) continue;
            var cost = getPricePerSeat(items[i]);
            if(best == -1 || cost < min) {
              min = cost;
              best = i;
            }
          }
          if(best == -1) return null;
          return items[best];

          function getPricePerSeat(item) {
            return (item.computed.costs.trip.total + item.computed.costs.services.total) / Math.min(passengers, item.computed.seats.passengers);
          }
        }

        function getSolutions(items, passengers, ignore, used, callback) {
          if(passengers <= 0) {
            var set = Object.keys(used);
            var solution = getEmptySolution();
            for(var i = 0; i < set.length; i++) {
              sumItem(solution, orig_items[set[i]]);
            }
            solutions.push(solution);
            return callback();
          }
          var item = localBest(items, passengers, ignore);
          if(item == null) {
            return callback();
          }
          ignore[item._idx] = true;
          used[item._idx] = true;
          getSolutions(items, passengers - item.computed.seats.passengers, ignore, used, function() {
            $timeout(function() {
              delete used[item._idx];
              getSolutions(items, passengers, ignore, used, function() {
                delete ignore[item._idx];
                return callback();
              });
            }, 500, true);
          });
        }
      },
      get: function(items, indexes) {
        var filtered = [];
        if(indexes) {
          for(var i = 0; i < indexes.length; i++) {
            filtered.push(items[indexes[i]]);
          }
        }
        else {
          filtered = items;
        }

        var solution = getEmptySolution();
        for(var j = 0; j < filtered.length; j++) {
          sumItem(solution, filtered[j]);
        }
        return solution;
      }
    };
    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .factory('$session', sessionService);

  /** @ngInject */
  function sessionService($rootScope, $state, $q, $timeout, $localStorage, $sessionStorage, Restangular, jwtHelper) {
    var Session = Restangular.one("sessions");

    function broadcast(oldSession, newSession) {
      if(angular.equals(oldSession, newSession)) return;
      $rootScope.$broadcast('$sessionChange', oldSession, newSession);
    }

    var service = {
      init: function() {
        var self = this;
        if($localStorage.session) {
          broadcast(undefined, $localStorage.session);
          launchWatcher();
        }
        else {
          self.getSession().then(function(response) {
            launchWatcher();
          }, function(err) {
            launchWatcher();
          });
        }

        function launchWatcher() {
          $timeout(function() {
            var deregistrationCallback = $rootScope.$watch(function() { return $localStorage.session; }, function(newVal, oldVal) {
              if(newVal === oldVal) return;
              broadcast(oldVal, newVal);
              if(newVal) return;
              self.getSession();
            }, true);
            $rootScope.$on('$destroy', deregistrationCallback);
          }, 0);
        }
      },
      ready: function() {
        var deferred = $q.defer();
        if($localStorage.session) {
          deferred.resolve();
          return deferred.promise;
        }
        var deregistrationCallback = $rootScope.$watch(function() { return $localStorage.session; }, function(newVal, oldVal) {
          if(!newVal) return;
          deregistrationCallback();
          deferred.resolve();
        }, true);
        return deferred.promise;
      },
      sessionBearer: function() {
        if(!$localStorage.session) return '';
        return $localStorage.session;
      },
      session: function() {
        if(!$localStorage.session) return null;
        return jwtHelper.decodeToken($localStorage.session);
      },
      refresh: function(){
        var self = this;
        $localStorage.session = undefined;
        return self.getSession();
      },
      getSession: function() {
        var self = this;
        var deferred = $q.defer();
        if($localStorage.session) {
          deferred.reject();
          return deferred.promise;
        }
        Session.get().then(function(response) {
          if(response && response.plain) response = response.plain();
          if(response && response.success) {
            $localStorage.session = response.bearer;
            deferred.resolve();
          }
          else {
            $timeout(function () {
              self.getSession();
            }, 5000);
            deferred.reject();
          }
        }, function(err) {
          $timeout(function () {
            self.getSession();
          }, 5000);
          deferred.reject(err);
        });
        return deferred.promise;
      }
    };

    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .factory('$segment', segmentService);

  /** @ngInject */
  function segmentService($env, $window) {
    var segment = {};
    var i, key;
    var methods = [
      'trackSubmit',
      'trackClick',
      'trackLink',
      'trackForm',
      'pageview',
      'identify',
      'reset',
      'group',
      'track',
      'ready',
      'alias',
      'debug',
      'page',
      'once',
      'off',
      'on',
      'load',
      'ready',
      'reset'
    ];
    if(!$env.isProduction()) {
      for(i = 0; i < methods.length; i++) {
        key = methods[i];
        (function(key) {
          segment[key] = function() {
            /* eslint-disable */

            /* eslint-enable */
          };
        } (key));
      }
    }
    else {
      for(i = 0; i < methods.length; i++) {
        key = methods[i];
        (function(key) {
          segment[key] = function() {
            /* eslint-disable */
            $window.analytics[key].apply(analytics, arguments);
            /* eslint-enable */
          };
        } (key));
      }
    }
    return segment;
  }
})();

/*eslint angular/window-service: 0 */
(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .factory('$prerender', prerenderService);

  /** @ngInject */
  function prerenderService($timeout, uiGmapGoogleMapApi) {
    var service = {
      start: function() {
        window.prerenderReady = false;
      },
      done: function(delay, waitgm) {
        if(waitgm) {
          uiGmapGoogleMapApi.then(function(maps) {
            letsDoIt();
          });
          return;
        }
        letsDoIt();

        function letsDoIt() {
          if(!delay) {
            window.prerenderReady = true;
            return;
          }
          $timeout(function() {
            window.prerenderReady = true;
          }, delay);
        }
      }
    };

    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .factory('$error', errorService);

  /** @ngInject */
  function errorService($rootScope) {
    var service = {
      throw: function(error, from) {
        var err;
        if(from == 'api') {
          if(!angular.isObject(error) || angular.isArray(error)) {
            err = {code: 'UnknownError', errno: 'UNKNOWN', message: 'Unknown error'};
          }
          else {
            err = error.data;
            if(!err || !err.code || !err.errno || !err.message) {
              err = {code: 'ConnectionError', errno: 'CONNECTION', message: 'Connection error'};
            }
          }
          $rootScope.$broadcast('$error', err, error.config.url);
        }
      },
      needsLogout: function(err, url) {
        if(!err || !angular.isObject(err) || angular.isArray(err)) {
          return false;
        }
        var errors;
        if(url.indexOf('/suppliers/id/')) {
          errors = ['R.OVERALL.0.1', 'R.OVERALL.0.2', 'R.OVERALL.0.3', 'R.OVERALL.0.4', 'R.OVERALL.0.5', 'R.OVERALL.0.6', 'R.OVERALL.0.9', 'R.OVERALL.0.10', 'R.OVERALL.0.11'];
          if(errors.indexOf(err.errno) !== -1) {
            return true;
          }
          errors = ['R.SUPPLIER.4.0','R.SUPPLIER.5.0','R.SUPPLIER.6.0','R.SUPPLIER.7.0','R.SUPPLIER.8.0','R.SUPPLIER.9.0','R.SUPPLIER.10.0','R.SUPPLIER.11.0','R.SUPPLIER.12.0','R.SUPPLIER.13.0','R.SUPPLIER.14.0','R.SUPPLIER.15.0','R.SUPPLIER.16.0','R.SUPPLIER.17.0','R.SUPPLIER.18.0','R.SUPPLIER.19.0','R.SUPPLIER.20.0','R.SUPPLIER.21.0','R.SUPPLIER.22.0','R.SUPPLIER.23.0','R.SUPPLIER.24.0','R.SUPPLIER.25.0'];
          if(errors.indexOf(err.errno) !== -1) {
            return true;
          }
        }
        return false;
      },
      get: function(error, from) {
        var err;
        var errors;
        var response = {};

        if(from == 'api') {
          if(!angular.isObject(error) || angular.isArray(error)) {
            err = {code: 'UnknownError', errno: 'UNKNOWN', message: 'Unknown error'};
          }
          else {
            err = error.data;
            if(!err || !err.code || !err.errno || !err.message) {
              err = {code: 'ConnectionError', errno: 'CONNECTION', message: 'Connection error'};
            }
          }

          if(!err.errno) {
            err.errno = 'UNKNOWN';
          }

          response.errno = err.errno;

          // General errors
          errors = ['UNKNOWN'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Errore sconosciuto';
            response.msg = 'C\'è stato un problema con il caricamento della tua richiesta, ti invitiamo a riprovare nuovamente.';
            return response;
          }
          errors = ['CONNECTION'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Errore di connessione';
            response.msg = 'C\'è stato un problema nell\'invio della tua richiesta, ti invitiamo a controllare la tua connessione a internet.';
            return response;
          }

          // Overalls errors
          errors = ['R.OVERALL.0.1', 'R.OVERALL.0.2', 'R.OVERALL.0.3', 'R.OVERALL.0.4', 'R.OVERALL.0.5', 'R.OVERALL.0.6'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Autorizzazione non valida';
            response.msg = 'Per motivi di sicurezza abbiamo bisogno di farti eseguire nuovamente l\'accesso.';
            return response;
          }
          errors = ['R.OVERALL.0.7', 'R.OVERALL.0.8'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Autorizzazione insufficienti';
            response.msg = 'Ci dispiace ma sembra che tu non abbia il permesso di effettuare questa operazione.';
            return response;
          }
          errors = ['R.OVERALL.0.9', 'R.OVERALL.0.10', 'R.OVERALL.0.11'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Autorizzazione scaduta';
            response.msg = 'Per motivi di sicurezza abbiamo bisogno di farti eseguire nuovamente l\'accesso.';
            return response;
          }

          //Suppliers errors
          errors = ['R.SUPPLIER.0.0', 'R.SUPPLIER.5.3'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Email già registrata';
            response.msg = 'Un account è già stato registrato utilizzando la mail da te indicata.';
            return response;
          }
          errors = ['R.SUPPLIER.1.0', 'R.SUPPLIER.2.0'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Email non registrata';
            response.msg = 'L\'indirizzo email da te fornito non risulta essere registrato.';
            return response;
          }
          errors = ['R.SUPPLIER.6.1', 'R.SUPPLIER.7.5'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Email già verificata';
            response.msg = 'L\'indirizzo email associato a questo account risulta essere già verificato.';
            return response;
          }
          errors = ['R.SUPPLIER.7.4'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Conferma scaduta';
            response.msg = 'Il codice di conferma da te utilizzato è scaduto, richiedi una nuova conferma dal pannello e riprova.';
            return response;
          }
          errors = ['R.SUPPLIER.7.1', 'R.SUPPLIER.7.2', 'R.SUPPLIER.7.3'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Conferma invalida';
            response.msg = 'Il codice di conferma da te utilizzato è invalido, richiedi una nuova conferma dal pannello e riprova.';
            return response;
          }
          errors = ['R.SUPPLIER.1.1'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Password errata';
            response.msg = 'La password da te inserita non è corretta.';
            return response;
          }
          errors = ['R.SUPPLIER.4.0','R.SUPPLIER.5.0','R.SUPPLIER.6.0','R.SUPPLIER.7.0','R.SUPPLIER.8.0','R.SUPPLIER.9.0','R.SUPPLIER.10.0','R.SUPPLIER.11.0','R.SUPPLIER.12.0','R.SUPPLIER.13.0','R.SUPPLIER.14.0','R.SUPPLIER.15.0','R.SUPPLIER.16.0','R.SUPPLIER.17.0','R.SUPPLIER.18.0','R.SUPPLIER.19.0','R.SUPPLIER.20.0','R.SUPPLIER.21.0','R.SUPPLIER.22.0','R.SUPPLIER.23.0','R.SUPPLIER.24.0','R.SUPPLIER.25.0'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Errore';
            response.msg = 'Sembra ci sia un problema con questo utente, ti invitiamo a contattarci o a riprovare più tardi.';
            return response;
          }
          errors = ['R.SUPPLIER.3.1', 'R.SUPPLIER.3.2', 'R.SUPPLIER.3.3'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Richiesta non valida';
            response.msg = 'Questa richiesta di reimpostazione password non è valida.';
            return response;
          }
          errors = ['R.SUPPLIER.3.4'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Richiesta scaduta';
            response.msg = 'Questa richiesta di reimpostazione password è scaduta.';
            return response;
          }
          errors = ['R.SUPPLIER.5.1'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Password di verifica errata';
            response.msg = 'La password di verifica inserita è errata.';
            return response;
          }
          errors = ['R.SUPPLIER.5.2'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Password non valida';
            response.msg = 'Devi inserira una password differente da quella attualmente in uso.';
            return response;
          }

          errors = ['R.SUPPLIER.10.1', 'R.SUPPLIER.10.2', 'R.SUPPLIER.11.1', 'R.SUPPLIER.11.2', 'R.SUPPLIER.12.1', 'R.SUPPLIER.12.2'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Codice prenotazione errato';
            response.msg = 'La prenotazione da te richiesta non esiste.';
            return response;
          }
          errors = ['R.SUPPLIER.11.3', 'R.SUPPLIER.11.4'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Impossibile confermare';
            response.msg = 'Questo ordine non può essere più confermato.';
            return response;
          }
          errors = ['R.SUPPLIER.12.3', 'R.SUPPLIER.12.4'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Impossibile rifiutare';
            response.msg = 'Questo ordine non può essere più rifiutato.';
            return response;
          }
          errors = ['R.SUPPLIER.14.1', 'R.SUPPLIER.14.2'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Codice ordine errato';
            response.msg = 'L\'ordine da te richiesto non esiste.';
            return response;
          }
          errors = ['R.SUPPLIER.17.1', 'R.SUPPLIER.17.2', 'R.SUPPLIER.18.1', 'R.SUPPLIER.18.2','R.SUPPLIER.22.3'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Codice sede errato';
            response.msg = 'La sede da te richiesta non esiste.';
            return response;
          }
          errors = ['R.SUPPLIER.20.2', 'R.SUPPLIER.20.3', 'R.SUPPLIER.21.1', 'R.SUPPLIER.21.2', 'R.SUPPLIER.22.1', 'R.SUPPLIER.22.2'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Codice veicolo errato';
            response.msg = 'Il veicolo da te richiesto non esiste.';
            return response;
          }
          errors = ['R.SUPPLIER.16.1', 'R.SUPPLIER.20.1'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Account non verificato';
            response.msg = 'L\'operazione non può essere eseguita fino a che non verifichi la mail del tuo account.';
            return response;
          }
          errors = ['R.SUPPLIER.24.1', 'R.SUPPLIER.24.2', 'R.SUPPLIER.24.3', 'R.SUPPLIER.24.4', 'R.SUPPLIER.25.1', 'R.SUPPLIER.25.2', 'R.SUPPLIER.25.4', 'R.SUPPLIER.25.5'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Codice recensione errato';
            response.msg = 'La recensione da te richiesto non esiste.';
            return response;
          }
          errors = ['R.SUPPLIER.25.3'];
          if(errors.indexOf(err.errno) !== -1) {
            response.title = 'Recensione già risposta';
            response.msg = 'Hai già risposto a questa recensione.';
            return response;
          }

          //Validator errors
          if(err.errno.indexOf('L.VALIDATOR.') !== -1) {
            response.title = 'Dati forniti non validi';
            response.msg = 'I dati da te forniti presentano dei problemi. Ti invitiamo a correggerli e a riprovare.';
            return response;
          }

          response.title = 'Errore';
          response.msg = 'C\'è stato un problema con il caricamento della richiesta, se il problema persiste contatta il supporto Busrapido.';
          return response;
        }
      }
    };
    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .factory('$env', envService);

  /** @ngInject */
  function envService($timeout, $window) {
    var service = {
      isLocalhost: function() {
        return $window.env === 'localhost';
      },
      isProduction: function() {
        return $window.env === 'production';
      }
    };

    return service;
  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .factory('$data', dataService);

  /** @ngInject */
  function dataService() {
    return {
      brand: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAABQCAYAAACj6kh7AAAb3UlEQVR42uzdCXgURd7H8Z4cJOROuAIJRFHkZkVQUeQGEQEPUBBQRFxvXHRdo67CqqCiggKrIqIcIrrogqCLgKKouKwucgRQREXlCDcYjgBJSGq/z/uUr3l6p6u6Z7pncNP/5/k8PjhdXZ1k5jd9VHUbQgifz+f7TajyvwCfz+cHls/n8/mB5fP5/MDy+Xy+305g7epz0akigDhUQ3uMwnysQTkqgijBF3gT96KNbB+LAIxQiKu6Gb2yaxh++eVX1OqUDawYVEc7PI99EGHYgWfRHokI+IHll19+YIUrgFRcjvUQHvgnuiIFMX5g+eWXH1ihSEFXrIGIgJXohiQ/sPzyyw8suwKoh9kQUTAJtRDwA8svv/zAUqmGLvgGwoEKFKMoiGMQDq1DF8T7geWXX35gBZOE3+MwhA3HsBObMQ9/wQ0mwzEW72ITduOEzfUfxFAk+IHll19+YFWWgj+jDEKjCBvxGNo57KcrJmA9jkJoHMWtSPQDy69TsNLQBK3REvUQgNsVg/o4E2eYNJKvxVaVwErE/Si1ER6rMAKBMPusjgdQgGJNv8W4BQnmwOpSK9MIUtVwJpqhaYgaoy7SDb/8Cl4N8CwOQUjLMRBJcLNSsRjbsdVkJ5agdlUIrACuxQEIhR8wGnEeHIY+jJ80/e/HgMpBWdKvi5HfOM/IjI8zTJWHz7EL20OwA9/jXUzCIJyH2oZfflHU6fgQwsLNSIBblY6vFP19jZyqEFjt8K2NcVIXwPBQJ6yDUNiAtr+02dG7vSEG9zQu/e/DwjOwE8Jlb6AHMgy/qnLFYRSEwha0cTmw1in6K0C9//XAqo0PIBQ+kMsZEdAQi3BSsT3voOavh4VdjXZZaYapGuInCI88h4aGX1W1cvAuhMYAP7DcE4+HIRQW/BIOJnXRAwNCdDW6Wqw7A3MgFO5BNRjHr+xsjGne0KiVEB+xwJKWIs/wqypWY3wCoXGtH1juuQg/KELhfdSDYdIRb6EMIgzFmIWzYZhkY4mi7Xdo+/+HhUN6Gt1rZ0U0sKQpSDT8qmqVhpkQCuXo6weWO5LwgiIQCpAHw+Q8bIFw0Vq0hmHSUjN4dRySfjks7FAzw2lglaLY5BiEA7twseFXVaxrUQxhYRHy/MByRydstwiCvehlMfRhBYQHFiMDhslwHLJosw1twgisd3GzyS24D1OwHsKGxw2/qmKlYzR+hjD5FC1h+IEVvjiMVYTHZFSHYdIZ+yE8sBOXwDBJxwxFuz+hmri6m9E8LdlJYFXgXqjqAiyE0JiDBMOvqlhxGIIpeBuz8DDOgOEHljuaYpVFAOxGJ9PyrZCOsSiG8MARGT410dR8zkyxN7gCpx+5opPxcpumRm71BCeB9RfoqjUOQCgs9oc5+EVVr/wPP7DcC6zBKLEIgIlIgSGNwL/RG9NMcwBLMBczMcuBmUGGUhRjDK7DSgwxHYpOUZy4v7hQjsfqUDPd7cCqhaUQCu+h8nD7AJKQiTSTDKRqplBUQ5oCr9uqGjgPl2E4bkA/dEAjm1NBUpCBNCldsTfZGddLQ3AWAlBVfXSXyw+r1P46XCpft1uJv26jeltlNULfSn0OxRXIc7B3lYoMpMj+k2TfmSFcjGmEIbi+kqvQVL6e5EFgpaAV+uEG2ecw+e9OyIx2YCVgPEQQP5vOXaWiAAI34UUch5BuQxaSkeJAMhqatuMoHsVDEFhiOiwdhCKL7b4f8XI8ltuBVQOzIBTmmT4YSXgAC/G2yQK8ggawqj5409xWelO+rqoumIB3UYBCHMcx7MEmrMBL+ANyFT/7RCwwbf9ctEecXK4tpuFbHJUO4X2LD38qbsRkfIAtcvli2bYYh7ENyzAOv4OuhuMtLDBt65WmL4h2GI9PUVip3yPYhY9wP06Hqtpgzi/9mbyDG21+uXTCc1hR+fcg7cNK5KMuvnApsM7DKMzDKuzBMRyt9D7ZjIV4DL2iFVgNsFgxjKEBDKke1kJgmCmwlrswRac+NpkCKx8CS5FpGubwvsV2z0NdjwKrtmr6hTQtyK77MsXyR9AKVpWv6S/fol0mnsJ3EDaVYznuQHyQvZ8fLdotQACdsdpimTKcg8p1uwzSoxAOrMYNUNWLFm0LK4X8SGyw2ecStIVVXa5pPxVJmr2bMTLohUYF3sPeMAOrKaZY/A5UtuI1tIx0YHXAjxBmQeYJZmO1RWA9hxQYYaiDeebAUlw1HK8Yk9XSo8A6H4cU6zmAoeYxOpqT9YVoDqsaieMWbY9jpMXh0ASIEB3DJNNctBzFldKjaIa1inUWoU2lD8oCFEOE6ABGIB7B6lmUWLT9BM9YvK6yQvHlcimKFG0nKs5r1cFsCNfoA6s3VoXZxxrcFsnA6m8x7aUEV5mWzcEGi8CahlQYYcjG3y0C60NkmZa/02LbS9EthMC638bk1iUQCu8jI8qBFUBfbRjorUMTO4ElLdesby8ykI1vIFywDz1DCKyTYfT5JuJdDqwpEBEMrL7Y6lI/RbghUoF1o2IvxTy5ObHS4eMdmOp2YJn2sMZIAtOD3Gm0m2LQ6sVOAkuajV6VXILL8Sim2fg22oQ2MKIcWA0Vh4FO3I3qisByag8oAksegrjkPeSqAstlhzHYxcAahsMRDKyW2OJyX3vRBgGvA+tOiCC+QEsYJq3wZzTG8zjhUWAVYzTOQT4awTBpjdUW2z+SwIp3GFhF2FrJT9iOUgiNlWgHI8qBlYA/2NhzGoUrcS1eCPIGXogsGC4G1j65nljN+Z5iGUIz5bYVatZ7Av3DDKyP8RLe0g1bkf7hUmAlYSWExmeYgIfxCn4MMbBqYYaNttvk9j6Ap7DWRptPVHtYXl8hXIw8xSRpA5NRCoEXkQAjDFl4CwLHZTAaiLW6s4TigsEjBFaCIrDcsh4Df31jRD2w0jFdc86hrelqVQZa4Bq8hnE4DUaYgVUo7UQpnjJ9UMeZlt+BfJyPXNREBn6HqZq+nkBiCIF1FL1xGjKRjQvwjqbdj+joQmBdp2ojvYxGSEUCaqA1ZoQQWP1snCqYgFayv3gk4yyMsnFxpDsCXgVWEp6HCGK6Zo/JHFh/QzPUR4MQ5KAN3jMHlkIaFlhdMIhQYB3Ac2h0igRWBmZrzjNV04wzS4YRRmAtRHs0k5qjNTKDDGfoifswSC4brxiwW6DpM9dhYK1UXPVrgSOKtiUY7UJgLUKFos2/FV+GedjsILDS8AKEwkykKgbCztds7weI8SqwkhUTnmcgzUFgFeE7bA7RN9iCIw4CKxVvRzOwpBPYgvGofooH1lFMRRr05TywlqEBnFQCdJWGOYp+v0Qzh4F1rXKUuv6q3RthBlYONqr60IyxS8YaB4HVGl8rlj9oY0xfD+zW3EAgx6vAilHMIfwYZ9kNLDc5CKwG+EhxSJioCCyvgut11IryIeHLEAol2Ihp6OpyYJ0LT0rzc+1CO4eB1QsxCFYB9LFxXikrjMDqga2aixRZLk7NuRInNT9PE6gqXhV6Ui8vT7qPUMzJa+IwsF5De9xs87mDJ/EqLsQfUeowsM5RPIF6KIEVcBhYazA9iFcwS74uNMrwdBQDKwaDIWxu6x5sxHNoFWZgfYVUuFXNcD6G4Hb8U9H3flzoMLD6IAZWdSaEwueoE0ZgPaQ5n/QWklwLLP37YobNPe8ZKFOsZ5SXgTUcIog96O4gsJaiAQzEY6jmWYMV+BDpMJCAoQ4D6wrstlh/nxDGYT2ONAvpqIPBNoLve3SO4rCG+lgJ4UAJ9uAdNA0xsFaHGVj98DIKsBW7sRdFOKy5WrvPg8A6DULhX6gdRmCNxQnF8n9FdZcCKyADUiiMQwC6el7ztxjrZWD1wWGLQBnqILBGopppzNZRzd1F803ra47DDgLrLpRDmJzARSEE1mgoSn9JXirH6CgPHO0FEYJy7MeQEAJrTQiBlY1pKMQh5Tc3IhxYp3scWGM0gTXZxcBKwNMQCnfBTr2gCawxXgZWW2ywCJXHHATWR6apOQNt7GEtNa3vGlTYDSzFBYONaO7N1Bz5Rpbz5RT+GuWpOXHohf0QITiITh4GVhzuwkHzm98PLE8CKxHPQCiM+C0EVk28ARHE52hhM7BOYhH64kEUQWicwHzZ5hEcc3BI2BifWax3Jmp5GFjZmA+hMB+p0QosWTHIw0QUhTiC/HQPAisVs8Ifhe79IWGUA2uSW4ElaxiEwguofqofEgZkwIggytFfF1im5UvsPIxC20YfWCNQbrHOOxDwMLBysdTGJe+4iAWWuuKRhQFYgmMOJkB3dzmwquFWm3P5NmESHsJtWBzhwOpgY2R3koeB9TaSXQys6yAUXkMW1KUfVHuTZ4El9cBOiCD+hjoW7R718I6jm9HeasCoYq/wGDrCONm/i3G+N4F1Dsp1o4UjfkiorwBikYohKLDxcwxyObCysFIzNGQWGiAWMVIKZkUwsJLwtG4vOsxxWJejUDMoOdPFwOqimXa0Fq1dGNZwrteBlYOFivDoj4BF21koRoXFsIWyIErlf8st2uzAMMUe4RDFCf03f7kX1kXyIRQuBlYA2TamRFQg30Fg7UQLRZ/3aAMrtIrF46iIYGDlKtofV/wNkj0IrL4IKLZTNQ3lEO4MM7DOsTFJ/WLFNtbBTw4C6wws0z03UXOl8DrNedEiJHgaWNIfcVIxr/A0Rds87LCY3nMf8k3uxSh8YVq+DLORonkS9DLF4eX1IT41pwJjkWwhDRfrRiZLm9HJdM7mbU2b4Yg1BVUCLsLXqAjhpHsWcpGi2JPoiB8Uv5NrXAysGPTW7GlepgiQBS4H1hiLcUdpsq1Q2IiWYU/N0Q8/+RQ1TH+/eJyJRSHMJcy3cV7u7F9Dy/FE7emIi0RgNcGnEBbyEatovzlImx6K5RPxYpB7cI1TtInXPN1nFZrpAkthJ1abfIkCHHYwLGAqzPWUZk/mKAajJmqhK6Yr2qgCqxpGQEhb0B+ZSESclIybcFIxery9i4EVi0GasWDjkSiXjUMSWmCR2yfdpU/QGFlIR46NsCrHHJfu1vCMjaEci9ATtXEW7sPWEO/W0BG7bIRWN2QiDVlog3/ZmOnRMJJPfr4bZYphCJchxqLt31FhCp+2ikPJJDxiarMfwxWPIrte8bCMUtwKAwaP+TI6KgLLQ6vR2mJQ5B7X+5OBZXMM1jY8XenhAnPws+bCQbbLgdXPRvA8hoFyO6dhZ9hXCfUOOrhH1w/o7FJgtcS3EBG8H9YoXUhKO/C5zSvMFXgScZEMrMb4GMLCD+hkEUKpWIpd2I5nVXtkUi7exw7pRcWyva1GtUsLkANjb98O/9fm3My0SAdWEYYrngaz1OPACqAhClxY7zEM8GAcVk3FuSHPhjW4qAzPunyL5Ckoj2BgNcBCVLjY10pk6O6H5YWBmhHqW9FJc44pzWGfGci0eC0WHbFKsU2H0PvXvauuRttM+bmJXGBtxS26qSchDuQsxkkbgRWHYRBhOolJSPMgsKpjdBhfCD9HMbDK8CoCLgdWLr4McbL9+hBvkdwMHyveV058jxbe3SJZ7wmUaEKrB2JheKgarsIBxbaUYRQCMHZCDOhm9KiTFSywtkG4bBcWoRns1GgUOfyQPorPFOd97jKFyuthjHA/hLmoD1m2b4eyzubA0WSscvgNvwM34z6LvZEDIQTWQYd7nLOhqt44HOJA0D4Obxu9G1NQVzGIc4MisAzZ9jXsC+O9slSux4hmYNXFfFRoRqn/HnVgeCAbI22M81pY+VFk+y/rYGzu2Y7DwdRg0yy+QylKQnQCP6MQGzEXXeG07sB6FGvuG/4lbpdtusk2J0zbdMhiSsVA/APf4wiExn4U4E5YVT2sRhlKTErxBVId3IlhLnbb+EJYgvNkuyZYiuMordR3YQi3l3kQy3BA86HcjEcRgKouwV6L91g5JmhGkp+NZdiv+Tt9iStlmyRMxV7T36VMLlcXuuqP5diG4xAKpZUuTo2MzpOfobpfusY8XIhUl/rNQCe8A6GxynwLHHF1dzlYNOhDQB/CREwIwTN4UoZNLyQjnKqJUVgug+hrbMBKvI57EBtkD+fJINvUAVbVGA9gHj7DamyS/a2T/+9VXI9EqCodf8JkTDCZiLuRACfVH/OwyrRdK+R2XRYkKJrgsUp/y0l4BHkOA6uHXG44FqMAX0lrsQx34yzYqaYYi0mYYPISLkc8dDUUC7BWbksBPsNcxbMYB5n+LpNxj8MbNXbAE1iCVfhK2iTD72NMRO9oP6o+BTVgmFyK7RAaxRiPrsgJcXpQA3TDFJTbHAnf0bwucVU3o1c22fTbqkzkoRa8rhjkSck4lSpPSkJo5Xyke8AUyLmoh+qIdiUhBxmIRtVDLvJgqugFViIexHRkwzDpi40QNv2nvTsPrrK6wzj+XhLICpFQIJBFQiCiaVBQoCObbJIQwErZChSmg0pwGaEjWhZLRaAiMrZQAsk4DFqsM1Rsa8CUJbKIVBBCCJGIrENYWrayDRJyc3/9/nGZ+c0Z7wYxMJPzzHwmk+QubzLkuee89+WcQryAnsjA/YhUIhCNVGSiD6ZiIyRI5egBx1dh2dgE/V9zbALmXimsKExBFQTLEOtjZc8iSAiqUIYizMNcZQE24QA8kBAUowscW1g2trDqT2GFIxffGyfS3/BRWsnIx2XIXXARi5EAxxaWjS2s+lVYT+M0xODGHET7uN8k7IDUoe36CnhbWDa2sOpXYWWhIsDmEO/4Gc2k4m2UQ35EuzEX98OxhWVjC6v+FdYgfAsJwiqkwPGhG+ajuBbXxarCZsxDRzhwbGHZ1NK2YNovbGHd24WVrcoqGGvRFk4AKZiAP2EzzkBCcAKbkIdn9FI2trBs7iA5eBPzfegAl2NzTxbWIByEBGmdKqtQpCEHk/E6CrAKpmWYhecw0Jz22cKysam/hTUI34UysqqtAkEDxBpi4JhsYdnY2MLKDrGsCtWU7EdjC8vGxhbWnY6s9iANji0smx9IIzRFAsJRV4lEK8SF+LzRiEecPbnuuBCNBDTWy3ffK4WVjUOQIJWiCxxbWDY+0h2rsQXpqKs8ha3ID/F5n0cxVqE56mv09mpbMQ8NMRIbsBzpd7OwsnEEEqR96AzHFpaNnwzHZQi6oa7yMgTfhfi8eRD8Fymoz4nEEgg2IAEfQrxG363CysaxEMuqExxbWDYB8nOcguAx1FWeh2BviM/7LgRHkYz6XljvQFCIGIxBJT5G6t0orKwQy6oMj8CxhWUTSmGpKURzxMNfEtESgdIGcSEUVkOkohUiAhRWtFplMxw6zdAazYxleFqgNcxjao7W8JdU837mc95GSbRCAsxEo6VRTklw+SisdYhEPEagM1yIQrJxv0REw1cikIiwUAsrCycgQdqPjnBsYdncRmHNRSH2oxR/Nf5h34c87FSLExahL3TisBw78S32Yi2yfBRWV7Vd1TYcxQyE+ymsg1iE7diPXZiORuqK+DIsM47/nyjDbLVwYCG+wWF8jYVoodarn4ed3u+XYw0yjQULi3EAR/Elpvkptxi8i69QgTJsRI5ax38wyrAKL6mFCP+tVqNtZBRWGEZjN95HC+R477cUs/GF9/M9WGIcY0usxG4cRglWICGYwspCZYjrSWXCsYVlc5uFVYMbEGWBGulsRg3EcFAt7xuPrRCYjqjbvQBBKdohCVsg2IeufqaEN/E9xFh6+ComoQG2QVBsjKKOQFCAKHwKwTWUqg1CuqMx8nFTrbl+BYIvkYpMlEBwDnshuIx0mAnDOvWY+vd9TJXWeIi6zXXjdgPgMgrLIa+o32uSepwqiLG0djUmIwyx2GBsdiFexYEKKwunQyyrh+DYwrK5g8L6Gx5FJgrhxjVE4DWI12RkYCAOQFCKWFVElzETGchBCQRFaIiJEGxHL3Xy+BSy4QpQWIKZaO+9/zEITiICm+BBkV7CWh3vYqTAjYvIRVM8hn6IwUhU4QKeQwI6oBiC8XgW1biEvmiKbuiNaJiZqo5/KjqgP/ZAUIEmGAPBJbyKBzAC1fCokaNZWFMg2IVEjFWluBQdkIkyCFbChcUQuNED8UjDWQj6+CqsOBwNsaw6wLGFZXOHhdXb2Hzhf+rr/0ANrhhrmI9V79o9obbvLzOWJJ4AQQXa4VcQnMEuXMcpDEfDACfdPag0zhfNUn+YkSEUlqAaJZiApnBIuCqDo5iOURimRiK/w6u4Bjc2YVyA4/8UguNoYqzfLriCDIyG4ATaqynbegjWBFtY6oWnP24lH4LDiMBX6oXnWYzFaFRAMNtXYfWGBOkbpMOxhWVTC4XV2dgU4hwEOaq8tkEnAYILmKWmVZ9AZygEFzEEoyCGvXgoyHcJjyAJt/Kimia2DKKw8hCOpcauRicwB81QAPFjOdric2NHnuN4EVEwcxKC9ep8mwsD1dR0PIarvTHbqsL6+DYL64rxgjRXFWc/VUwwBCisJ0Moq3ZwbGHZ1FJhPWoUzCUIeqEEHlQYV1o/DsFZTMQmCHZAZ7AarXRWI7M9eB9nUIX5CA+ysPRlDZNVYcXgc3hQaLyLVw5BARwSi974CDfUz/IbzFHT2AfRxitFbSThwk8wGqtRrYrnpzBTCsE+o7D6qylgd4xUhZWmXhw+uYPC0lvxvwlBJZqrKWme8bMmIxGNfRVWFiSAA0iDYwvLphYLS+8BuBzVEMRhDWpQhTbqdkvU1C4TeapQMtTlBPPUH2qCOhm8Gx2xAILrGB7ElPCs8bb/FnhwHBH4AIKLxm7Ml1CDAuhEopOaGs3EMHVebIBx4rw5GkEnCkNQ6ee6tg/h9tIjxIVqhJaAX9ZRYZ1EHD6D4BBioJPs76R7DM4FGFmlwrGFZVPLhVWJ2ViMyxC8hwi0Q40qgT+jHFVwYwUaoDs8XpX4CF+o0ctbcGGymgZmIBr/gqAEmUGsOLoN07BWfW0awrwfBTXYiPk4BMFNLENbHEQRhmIKzuMGJqIVdqmR4QK8gp24gvGYhJNYjf7IV0XfEWYycF2NppaiVG3Mmg8XxtZhYaWgC87Cg0OYiYU4hKvo66uwXOiDKoihHClwbGHZ1FKexjlcxAXcVMW0A2lq2jJCFVmN+rgSUeraoDE4D4FH3W4F4o3LGvapkUg2jkGwDHEw80d48B/cVOUg+Ati1cWP5ep7bpxXBVSArnBDUKUeaxXC4VK7cwvc6jblSMUkVMGjSkcwDVEw48JgnNW/R6/VaIIwjIOg0iisvxvnCBdB8Jl6F1KwG4kYBw+uoQ/Mc1inkQ4XcnEVArc6tq+R4O+yBheS8Dp2YD1+jRg4trBsajEt0Bs9kIpn8AcMQwxcMK8UH4i5eBkPIxw6DdAUY/EWcpFp3C4ZT+FnaKKucu+EHPTCfTDzAJ5EBlLwW8xAT0RAJxKjMAdDEY8kDMSD6ufJxduYgW7GcbrQAkMwHfORg1i4EIYkvIRFyEV7/Rhm1HmvfngDE9EZ4er7rTAIPRGtXgwexmA1ekvHUDwCh6RgKLqpFTH6q0subqUdBhiP3wApGILf4zU8jogfmhJalmXdq2xhWZZlC8uyLMsWlmVZluD/5+XQqoohSNwAAAAASUVORK5CYII=',
      Fontello: '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'
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .factory('$common', commonService);

  /** @ngInject */
  function commonService($filter, $document, $window, PlacesConstants, $state, $registration) {
    function hasOne(a, b) {
      var k = Object.keys(a);
      for (var i = 0; i < k.length; i++) {
        if (a[k[i]]) return true;
      }
      a = b;
      k = Object.keys(a);
      for (i = 0; i < k.length; i++) {
        if (a[k[i]]) return true;
      }
      return false;
    }


    function load(current) {
      if (getRegistrationStep(current, 2)) {
        // $registration.show(2, true, 500, -1);
        $state.go('root.it.supplier.profile.poc', {
          section: '2'
        });

      } else if (getRegistrationStep(current, 3)) {
        // $registration.show(3, true, 500, -1);
        $state.go('root.it.supplier.profile.company', {
          section: '3'
        });

      }
      else if (getRegistrationStep(current, 5)) {

        $state.go('root.it.supplier.profile.additional', {
          section: '5'
        });
      }
      else if (getRegistrationStep(current, 7)) {
        $state.go('root.it.supplier.profile.notification', {
          section: '7'
        });
      } else if (getRegistrationStep(current, 8)) {
        $state.go('root.it.supplier.profile.requesttypes', {
          section: '8'
        });
      } else if (getRegistrationStep(current, 9)) {
        $state.go('root.it.supplier.subscribe.list');
      } else {
        $state.go('root.it.supplier.quotes.list');

      }

    }

    function registrationComplete(current, step) {

    }

    function getRegistrationStep(current, step) {
      if (!current) return false;
      if (step == 2) {
        return ((!current || angular.isUndefined(current.name) || current.name === '' || angular.isUndefined(current.surname) || current.surname === '' || angular.isUndefined(current.phone) || current.phone === ''));
      }
      if (step == 3) {
        return (angular.isUndefined(current.company) || current.company === '' || angular.isUndefined(current.taxcode) || current.taxcode === '' || angular.isUndefined(current.companyphone) || current.companyphone === '' || angular.isUndefined(current.emergencyphone) || current.emergencyphone === '' || angular.isUndefined(current.place) || current.place.address === '' || angular.isUndefined(current.pec) || current.pec === '' ||  /*angular.isUndefined(current.sdi) || current.sdi === '' ||*/ angular.isUndefined(current.legal) || angular.isUndefined(current.legal.it) /*|| angular.isUndefined(current.legal.it.ren)*/ || angular.isUndefined(current.legal.it.banking) || angular.isUndefined(current.legal.it.banking[0].iban) || angular.isUndefined(current.legal.it.banking[0].bank) || current.legal.it.banking.length === 0);
      }
      if (step == 5) {
        return (angular.isUndefined(current.cansoftware) || angular.isUndefined(current.contact) || angular.isUndefined(current.legal) || angular.isUndefined(current.legal.it) || angular.isUndefined(current.legal.it.einvoice) || angular.isUndefined(current.legal.it.mepa));
      }
      if (step == 7) {
        return (angular.isUndefined(current.contact) || angular.isUndefined(current.contact.cansos) || angular.isUndefined(current.contact.canwhatsapp));
      }
      if (step == 8) {
        return (angular.isUndefined(current.insurance) || angular.isUndefined(current.insurance) || angular.isUndefined(current.vehicles) || angular.isUndefined(current.vehicles) || (angular.isUndefined(current.vehicles.common) && angular.isUndefined(current.vehicles.wheelchair)) || (angular.isUndefined(current.vehicles.fleet)) || (!hasOne(current.vehicles.common, current.vehicles.wheelchair)));
      }
      if (step == 9) {
        return (!current.subscription || !current.gocardless);
      }
    }
    function min(a, b) {
      if (a > b) return b;
      return a;
    }

    function max(a, b) {
      if (a < b) return b;
      return a;
    }

    function roundToTwo(num) {
      return Number(Math.round(num + 'e+2') + 'e-2');
    }
    function get(p, o) {
      for (var i = 0; i < p.length; i++) {
        o = o[p[i]];
      }
      return o;
    }
    function convertQuoteToCSV(quote, properties, formatters) {
      var row = [];
      for (var i = 0; i < properties.length; i++) {


        row.push(formatters[i](get(properties[i], quote)));
      }
      return row;
    }
    function addVat(value, vat) {
      return roundToTwo(value + value * vat / 100);
    }
    function getPartnerPrice(quote) {
      var price = addVat(quote.partner_price, quote.vat);
      for (var i = 0; i < quote.costs.length; i++) {
        if (quote.costs[i].who === 'us') {
          price += addVat(quote.costs[i].value, quote.costs[i].vat);
        }
      }
      return price;
    }

    /**
     * Computes the position of the element relative to the page view port
     * @param {Element} element
     * @param {} $window
     * @param {} $document
     */
    function offset(element, $window, $document) {
      var boundingClientRect = element[0].getBoundingClientRect();
      return {
        width: boundingClientRect.width || element.prop('offsetWidth'),
        height: boundingClientRect.height || element.prop('offsetHeight'),
        top: boundingClientRect.top + ($document[0].body.scrollTop),
        left: boundingClientRect.left + ($document[0].body.scrollLeft)
      };
    }

    /**
     * Returns the value in the object at the specified path
     * @param {Object} obj
     * @param {String} path
     */
    function getDeep(obj, path) {
      var properties = path.split('.');
      for (var i = 0; i < properties.length; i++) {
        if (angular.isDefined(obj)) {
          obj = obj[properties[i]];
        }
        else {
          return obj;
        }
      }
      return obj;
    }

    /**
     * Returns the elements in unfiltered that have field set to true or false depending on
     * which values are selected
     * @param {Array} unfiltered
     * @param {String} field
     * @param {Array} selected
     */
    function filterBoolean(unfiltered, field, selected) {
      var filtered = [];
      for (var i = 0; i < unfiltered.length; i++) {
        var prop = getDeep(unfiltered[i], field);
        var ok = false;
        for (var j = 0; j < selected.length; j++) {
          if (selected[j].selected) {
            if ((selected[j].code === 'Y' && prop === true) || (selected[j].code === 'N' && prop === false) || (prop === undefined && selected[j].code === 'N/A')) {
              ok = true;
            }
          }
        }
        if (ok) {
          filtered.push(unfiltered[i]);
        }
      }
      return filtered;
    }

    function filterContained(unfiltered, field, selected) {
      var filtered = [];
      for (var i = 0; i < unfiltered.length; i++) {
        var prop = '' + getDeep(unfiltered[i], field);
        var ok = false;
        var other = false;
        var unsel = false;
        for (var j = 0; j < selected.length; j++) {
          if (selected[j].selected) {
            if (selected[j].code === prop) {
              ok = true;
            }
            if (!ok && selected[j].code === '') {
              ok = true;
            }
          }
        }
        for (j = 0; j < selected.length; j++) {
          if (!selected[j].selected) {
            if (selected[j].code === prop) {
              ok = false;
            }
          }
        }
        if (ok) {
          filtered.push(unfiltered[i]);
        }
      }
      return filtered;
    }

    function filterIntersection(unfiltered, field, selected) {


      var filtered = [];
      for (var i = 0; i < unfiltered.length; i++) {
        var prop = getDeep(unfiltered[i], field);

        var ok = false;
        for (var j = 0; j < selected.length; j++) {
          if (selected[j].selected) {
            if (prop)
              for (var k = 0; k < prop.length; k++) {
                if (selected[j].code === prop[k]) {
                  ok = true;
                }
              }
            if (!ok && selected[j].code === '') {
              ok = true;
            }
          }
        }
        for (j = 0; j < selected.length; j++) {
          if (!selected[j].selected) {
            if (prop)
              for (k = 0; k < prop.length; k++) {
                if (selected[j].code === prop[k]) {
                  ok = false;
                }
            }
          }
        }
        if (ok) {
          filtered.push(unfiltered[i]);
        }
      }
      return filtered;
    }

    function filterDefined(unfiltered, field, selected) {
      var filtered = [];
      for (var i = 0; i < unfiltered.length; i++) {
        var prop = getDeep(unfiltered[i], field);
        var ok = false;
        for (var j = 0; j < selected.length; j++) {
          if (selected[j].selected) {
            if ((selected[j].code === 'Y' && angular.isDefined(prop)) || (selected[j].code === 'N/A' && prop === undefined)) {
              ok = true;
            }
          }
        }
        if (ok) {
          filtered.push(unfiltered[i]);
        }
      }
      return filtered;
    }

    function filterNumber(unfiltered, field, min, max) {



      var filtered = [];
      if (!max) {
        if (!min) return unfiltered;
        for (var i = 0; i < unfiltered.length; i++) {
          if (getDeep(unfiltered[i], field) >= min)
            filtered.push(unfiltered[i]);
        }
      } else if (!min) {
        for (i = 0; i < unfiltered.length; i++) {
          if (getDeep(unfiltered[i], field) <= max)
            filtered.push(unfiltered[i]);
        }
      } else {
        for (i = 0; i < unfiltered.length; i++) {
          if (getDeep(unfiltered[i], field) <= max && getDeep(unfiltered[i], field) >= min)
            filtered.push(unfiltered[i]);
        }
      }
      return filtered;
    }

    function filterPlace(unfiltered, field, selected, available) {

      // handle filter changes
      selected = selected.filter(function(val) {
        return val.selected;
      });


      var filtered = [];
      var other = false;
      for (var j = 0; j < selected.length; j++) {
        if (selected[j].code === '') other = true;
      }

      for (var i = 0; i < unfiltered.length; i++) {

        var ok = true;
        if (other) {
          ok = true;
          for (j = 0; j < available.length; j++) {
            if (available[j].code !== '' &&
              angular.isString(getDeep(unfiltered[i], field)) &&
              getDeep(unfiltered[i], field).indexOf(available[j].code) !== -1) {
              ok = false;
            }
          }
          for (j = 0; j < selected.length; j++) {
            if (selected[j].code !== '' &&
              angular.isString(getDeep(unfiltered[i], field)) &&
              getDeep(unfiltered[i], field).indexOf(selected[j].code) !== -1) {
              ok = true;
            }
          }
        } else {
          ok = false;
          for (j = 0; j < selected.length; j++) {
            if (selected[j].code !== '' &&
              angular.isString(getDeep(unfiltered[i], field)) &&
              getDeep(unfiltered[i], field).indexOf(selected[j].code) !== -1) {
              ok = true;
            }
          }
        }
        if (ok) {
          filtered.push(unfiltered[i]);
        }
      }
      return filtered;
    }
    var serviceType = [{
        name: 'Altro',
        code: '',
        selected: true
      },
      {
        code: 'TRF',
        name: 'TRF',
        selected: true
      }, {
        code: 'DISPO',
        name: 'DISPO',
        selected: true
      }, {
        code: 'FD',
        name: 'FD',
        selected: true
      }, {
        code: 'TOUR',
        name: 'TOUR',
        selected: true
      }, {
        code: 'INT',
        name: 'INT',
        selected: true
      }, {
        code: 'SHUTTLE',
        name: 'SHUTTLE',
        selected: true
      }, {
        code: 'OTHER',
        name: 'OTHER',
        selected: true
      }
    ];
    var places = PlacesConstants;
    var service = {
      min: min,
      max: max,
      getRegistrationStep: getRegistrationStep,
      serviceType: serviceType,
      roundToTwo: roundToTwo,
      getDeep: getDeep,
      get: get,
      load: load,
      hasOne: hasOne,
      getPartnerPrice: getPartnerPrice,
      convertQuoteToCSV: convertQuoteToCSV,

      getRequestFullDescription: function (requests, serviceType, onlydate) {
        // console.log(requests)
        // console.log(serviceType)
        var text = 'Itinerario\n\n';
        var dayNum = 0;
        var pickupDay;
        var old;
        var prevDepart;
        for (var i = 0; i < requests.length; i++) {
          var request = requests[i];

          for (var j = 0; j < request.services.length; j++) {
            var service = request.services[j];
            switch (service.type) {
              case 'pickup':
                if ($filter('day')(service.depart) != old) {
                  dayNum++;
                  old = $filter('day')(service.depart);
                }
                pickupDay = service.depart;
                if (serviceType && serviceType.toLocaleLowerCase() === 'tour')
                  text += 'DAY ' + (i + 1) + ' (' + $filter('calendar')(service.depart) + ')\n\n';
                else
                  text += 'SERVIZIO ' + (i + 1) + '\n\n';

                break;
                //   text += 'partenza alle ' + $filter('time')(service.depart) + '\n';
                //   text += 'luogo pickup ' + service.place.address + '\n';
                //   text += '\n';
                //   pickupDay = $filter('day')(service.depart);
                //   break;
              case 'transfer':
                text += 'TRF\n';
                var departDate;
                var departPlace;
                var transit = [];
                for (var k = j - 1; k >= 0; k--) {
                  if (request.services[k].type !== 'transit') {
                    departDate = request.services[k].depart;
                    departPlace = request.services[k].place.address;
                    break;
                  } else {
                    var transitDetails = 'passaggio per ' + request.services[k].place.address;
                    if (request.services[k].more && request.services[k].notes) {
                      transitDetails += ' - ' + request.services[k].notes;
                    }
                    transitDetails += '\n';
                    transit.push(transitDetails);
                  }
                }
                transit.reverse();

                if (!onlydate)
                  text += 'Data e ora di partenza: ' + $filter('dates')(departDate) + '\n';
                else
                  text += 'Data di partenza: ' + $filter('calendar')(departDate) + '\n';
                text += 'Punto di partenza: ' + departPlace + '\n';
                for (var x = 0; x < transit.length; x++)
                  text += transit[x];
                text += 'Destinazione: ' + service.place.address + '\n';
                text += '\n';
                break;
              case 'disposal':
                text += 'DISPO - (Disposizione Oraria)\n';
                if (!onlydate)
                  text += 'Data e ora di partenza: ' + $filter('dates')(service.arrive || prevDepart) + '\n';
                else
                  text += 'Data di partenza: ' + $filter('calendar')(service.arrive || prevDepart) + '\n';
                text += 'Punto di partenza: ' + service.place.address + '\n';
                text += 'fino alle ' + $filter('time')(service.depart) + ' del ' + $filter('calendar')(service.depart) + '\n';
                //text += 'Fine disposizione presso: ' + service.place.address + ' alle ' + $filter('time')(service.depart) + '\n';
                if (service.more && service.notes) {
                  text += 'Dettagli della Disposizione:\n';
                  text += service.notes + '\n';
                }
                text += '\n';
                break;
              case 'city':
                text += 'CITY TOUR - (Giro Città/Panoramica)\n';
                if (!onlydate)
                  text += 'Data e ora di partenza: ' + $filter('dates')(service.arrive || prevDepart) + '\n';
                else
                  text += 'Data di partenza: ' + $filter('calendar')(service.arrive || prevDepart) + '\n';
                text += 'Punto di partenza: ' + service.place.address + '\n';
                text += 'fino alle ' + $filter('time')(service.depart) + ' del ' + $filter('calendar')(service.depart) + '\n';
                //text += 'Fine city tour presso: ' + service.place.address + ' alle ' + $filter('time')(service.depart) + '\n';
                if (service.more && service.notes) {
                  text += 'Dettagli del City Tour:\n';
                  text += service.notes + '\n';
                }
                text += '\n';
                break;
              case 'bus':
                text += 'BUS IN LOCO - (Il bus sosta nelle immediate vicinanze)\n';
                if (!onlydate)
                  text += 'Data e ora di partenza: ' + $filter('dates')(service.arrive || prevDepart) + '\n';
                else
                  text += 'Data di partenza: ' + $filter('calendar')(service.arrive || prevDepart) + '\n';
                text += 'Punto di partenza: ' + service.place.address + '\n';
                text += 'fino alle ' + $filter('time')(service.depart) + ' del ' + $filter('calendar')(service.depart) + '\n';
                text += '\n';
                break;
              case 'return':
                text += 'RITORNO\n';
                departDate;
                departPlace;
                transit = [];
                for (k = j - 1; k >= 0; k--) {
                  if (request.services[k].type !== 'transit') {
                    departDate = request.services[k].depart || request.services[k].arrive;
                    departPlace = request.services[k].place.address;
                    break;
                  } else {
                    var transitDetails = 'passaggio per ' + request.services[k].place.address;
                    if (request.services[k].more && request.services[k].notes) {
                      transitDetails += ' - ' + request.services[k].notes;
                    }
                    transitDetails += '\n';
                    transit.push(transitDetails);
                  }
                }
                transit.reverse();
                if (!onlydate)
                  text += 'Partenza alle ' + $filter('time')(departDate) + ' del ' + $filter('calendar')(departDate) + '\n';
                else
                  text += 'Partenza il ' + $filter('calendar')(departDate) + '\n';
                text += 'Luogo di partenza ' + departPlace + '\n';
                for (x = 0; x < transit.length; x++)
                  text += transit[x];

                if (!onlydate)
                  text += 'Dropoff a ' + service.place.address + ' arrivo previsto ' + $filter('dates')(service.arrive) + '\n';
                else
                  text += 'Dropoff a ' + service.place.address + ' arrivo previsto ' + $filter('calendar')(service.arrive) + '\n';
                text += '\n';
                break;
              case 'shuttle':
                text += 'RIPETERE:\n';
                text += 'Ripetere il servizio ogni ' + $filter('interval')(service.delta) + '\n';
                text += 'Dalle ore: ' + $filter('timeDate')(request.services[0].depart) + '\n';
                text += 'Alle ore: ' + $filter('timeDate')(service.depart) + '\n';
                text += '\n';
                break;
              case 'end':
                if (service.more) {
                  text += 'Fine servizio presso: ' + service.place.address + ' alle ' + $filter('time')(service.depart) + ' del ' + $filter('calendar')(service.depart) + '\n';
                  if (service.notes)
                    text += service.notes + '\n';
                }
                break
              default:
                break;

            }
            prevDepart = service.depart;
          }
          text += '\n';
        }
        return text;
      },
      getRequestShortDescription: function (passengers, requests, serviceType) {
        var types = {
          pickup: {
            duration: 0,
            count: 0,
          },
          stop: {
            duration: 0,
            count: 0,
          },
          transfer: {
            duration: 0,
            count: 0,
          },
          transit: {
            duration: 0,
            count: 0,
          },
          disposal: {
            duration: 0,
            count: 0,
          },
          city: {
            duration: 0,
            count: 0,
          },
          bus: {
            duration: 0,
            count: 0,
          },
          return: {
            duration: 0,
            count: 0,
          },
          end: {
            duration: 0,
            count: 0,
          },
          shuttle: {
            duration: 0,
            count: 0,
          },
        }
        var duration = 0;
        var count = 0;
        var steps = '';

        var prev = ''
        for (var i = 0; i < requests.length; i++) {
          var request = requests[i];
          for (var j = 0; j < request.services.length; j++) {
            var service = request.services[j];
            types[service.type].count += 1;
            if (service.type === 'pickup' || service.type === 'transfer' || service.type === 'transit' || service.type === 'return') {
              var name = prev;
              for (var k = 0; k < service.place.components.length; k++) {
                var component = service.place.components[k];
                if (component.types.indexOf('administrative_area_level_3') !== -1) {
                  name = component.short_name;
                }
              }
              for (k = 0; k < service.place.components.length; k++) {
                component = service.place.components[k];
                if (component.types.indexOf('locality') !== -1) {
                  name = component.short_name;
                }
              }
              for (k = 0; k < service.place.components.length; k++) {
                component = service.place.components[k];
                if (component.types.indexOf('establishment') !== -1) {
                  name = component.short_name;
                }
              }
              if (prev !== name) {
                steps += ' - ' + name;
              }
              prev = name;
            }

            if (service.type === 'transfer') {
              var delta = new Date(service.depart).getTime() - new Date(request.services[j - 1].depart).getTime();
              types[service.type].duration += delta / 1000;
              duration += delta / 1000;
              count++;
            } else if (service.type === 'disposal' || service.type === 'city' || service.type === 'bus') {
              delta = new Date(service.depart).getTime() - new Date(service.arrive || service.depart || prevDepart).getTime();
              types[service.type].duration += delta / 1000;
              duration += delta / 1000;
              count++;

            }
          }
        }
        duration = 0;
        if (angular.isDefined(requests)) {
          for (var requestIndex = 0; requestIndex < requests.length; requestIndex++) {
            request = requests[requestIndex];
            for (var serviceIndex = 0; serviceIndex < request.services.length; serviceIndex++) {
              service = request.services[serviceIndex];
              request.startdate = request.startdate ? new Date(min(request.startdate.getTime(), new Date(service.depart).getTime())) : new Date(service.depart);
              request.enddate = request.enddate ? new Date(max(request.enddate.getTime(), new Date(service.depart).getTime())) : new Date(service.depart);
            }
          }
          duration += Math.ceil((request.enddate.getTime() - request.startdate.getTime()) / 1000);
        }
        var most = {
          type: 0,
          duration: 0,
          count: 0,
        }
        var keys = Object.keys(types);
        for (var keyIndex = 0; keyIndex < keys.length; keyIndex++) {
          var key = keys[keyIndex];
          if (types[key].duration > most.duration) {
            most = {
              type: key,
              duration: types[key].duration,
              count: types[key].count,
            }
          }
        }
        if (duration >= 6 * 3600 && duration <= 16 * 3600 && count > types['transfer'].count) {
          most.type = 'FULL DAY';
        } else if (duration >= 16 * 3600) {
          most.type = 'TOUR ' + Math.ceil(duration / 3600 / 24) + ' giorni';
        }
        return (serviceType ? serviceType.toUpperCase() : most.type.toUpperCase()) + steps;
      },
      showDirections: function (request) {
        var link = angular.element('<a/>');
        // var href = 'https://www.google.com/maps/dir/?api=1&origin=' + request.services[0].place.location.lat + ',' + request.services[0].place.location.lng;
        var href = 'https://www.google.com/maps/dir/?api=1&travelmode=driving&origin=' + request.services[0].place.address;
        var steps = [];
        for (var i = 1; i < request.services.length; i++) {
          if (request.services[i].type.match('transit|transfer|return')) {
            //console.log(request.services[i].place.address)
            steps.push(request.services[i].place);
          }
        }
        // href += '&destination=' + steps[0].location.lat + ',' + steps[0].location.lng;
        href += '&destination=' + steps[steps.length - 1].address;

        href += '&waypoints=';
        for (i = 0; i < steps.length - 1; i++) {
          if (i != 0) href += '|';
          // href += steps[i].location.lat + ',' + steps[i].location.lng;
          href += steps[i].address;
        }
        link.css({
          display: 'none'
        });
        link.attr({
          href: href,
          target: '_blank',
        })
        link[0].click();
        // clean up
        link.remove();
      },
      places: places,
      offset: offset,
      getDirectionsLink: function (request) {
        // var href = 'https://www.google.com/maps/dir/?api=1&origin=' + request.services[0].place.location.lat + ',' + request.services[0].place.location.lng;
        try {
          var href = 'https://www.google.com/maps/dir/?api=1&travelmode=driving&origin=' + request.services[0].place.address;
          var steps = [];
          for (var i = 1; i < request.services.length; i++) {
            if (request.services[i].type.match('transit|transfer|return')) {
              steps.push(request.services[i].place);
            }
          }
          // href += '&destination=' + steps[0].location.lat + ',' + steps[0].location.lng;
          href += '&destination=' + steps[steps.length - 1].address;

          href += '&waypoints=';
          for (i = 0; i < steps.length - 1; i++) {
            if (i != 0) href += '|';
            // href += steps[i].location.lat + ',' + steps[i].location.lng;
            href += steps[i].address;
          }
          return href;
        } catch (error) {
          return 'https://www.google.com/maps/dir/?api=1';
        }
      },
      filterBoolean: filterBoolean,
      filterNumber: filterNumber,
      filterDefined: filterDefined,
      filterPlace: filterPlace,
      filterIntersection: filterIntersection,
      filterContained: filterContained,
    };
    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .config(translateConfig);

  /** @ngInject */
  function translateConfig($translateProvider) {
    $translateProvider
      .preferredLanguage('it');
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .config(translateItConfig);

  /** @ngInject */
  function translateItConfig($translateProvider, $provide) {
    $provide.value("$locale", {
      "NUMBER_FORMATS": {
        "CURRENCY_SYM": "\u20ac",
        "DECIMAL_SEP": ",",
        "GROUP_SEP": ".",
        "PATTERNS": [
          {
            "gSize": 3,
            "lgSize": 3,
            "maxFrac": 3,
            "minFrac": 0,
            "minInt": 1,
            "negPre": "-",
            "negSuf": "",
            "posPre": "",
            "posSuf": ""
          },
          {
            "gSize": 3,
            "lgSize": 3,
            "maxFrac": 2,
            "minFrac": 2,
            "minInt": 1,
            "negPre": "-",
            "negSuf": "\u00a0\u00a4",
            "posPre": "",
            "posSuf": "\u00a0\u00a4"
          }
        ]
      }
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .run(sentryRun);

  /** @ngInject */
  function sentryRun($window, $rootScope, $state, $log, $timeout, Restangular, $supplier, $session, $env) {
    if($env.isProduction()) {
      productionRun();
    }
    else {
      debugRun();
    }

    function debugRun() {
      var deregistrationCallback1 = $rootScope.$on('$error', function(event, err) {
        $timeout(function () {
          $log.warn(err.message, {code: err.code, errno: err.errno});
        }, 1000);
      });
      $rootScope.$on('$destroy', deregistrationCallback1);

      Restangular.setFullRequestInterceptor(function(element, operation, route, url, headers, params, httpConfig) {
        $log.debug("TX >> "+operation.toUpperCase() + ' ' + url, {
          data: angular.toJson(element, true)
        });

        return {
          element: element,
          params: params,
          headers: headers,
          httpConfig: httpConfig
        };
      });
      Restangular.addResponseInterceptor(function(data, operation, what, url, response, deferred) {
        $log.debug("RX << "+operation.toUpperCase() + ' ' + url, {
          data: angular.toJson(data, true)
        });
        return data;
      });
      Restangular.setErrorInterceptor(function(response, deferred, responseHandler) {
        $log.debug("RX << "+response.config.method.toUpperCase() + ' ' + response.config.url, {
          data: angular.toJson(response.data, true)
        });
        return true;
      });
    }

    function productionRun() {
      var Raven = $window.Raven;

      function setUserContext(state) {
        var supplierAuthBearer = $supplier.supplierAuthBearer();
        var sessionBearer = $session.sessionBearer();

        if(supplierAuthBearer && $supplier.current()) {
          Raven.setUserContext({ id: $supplier.current()._id, email: $supplier.current().email || $supplier.current().temail, role: $supplier.supplierAuth().role });
          Raven.setTagsContext({ session: $session.session().session });
        }
        else if(sessionBearer) {
          Raven.setUserContext({});
          Raven.setTagsContext({ session: $session.session().session });
        }
      }

      setUserContext($state.current);

      var deregistrationCallback2 = $rootScope.$on('$supplierChange', function(event, oldUser, newUser) {
        setUserContext($state.current);
      });
      $rootScope.$on('$destroy', deregistrationCallback2);

      var deregistrationCallback4 = $rootScope.$on('$sessionChange', function(event, oldValue, newValue) {
        setUserContext($state.current);
      });
      $rootScope.$on('$destroy', deregistrationCallback4);

      var deregistrationCallback5 = $rootScope.$on('$error', function(event, err, url) {
        $timeout(function () {
          Raven.captureException(err.message, {level: 'warning', tags: {code: err.code, errno: err.errno}});
        }, 1000);
      });
      $rootScope.$on('$destroy', deregistrationCallback5);

      Restangular.setFullRequestInterceptor(function(element, operation, route, url, headers, params, httpConfig) {
        Raven.captureBreadcrumb({
          message: "TX >> "+operation.toUpperCase() + ' ' + url,
          category: 'api', level: 'debug',
          data: {
            data: angular.toJson(element, true)
          }
        });

        return {
          element: element,
          params: params,
          headers: headers,
          httpConfig: httpConfig
        };
      });
      Restangular.addResponseInterceptor(function(data, operation, what, url, response, deferred) {
        Raven.captureBreadcrumb({
          message: "RX << "+operation.toUpperCase() + ' ' + url,
          category: 'api', level: 'debug',
          data: {
            data: angular.toJson(data, true)
          }
        });
        return data;
      });

      Restangular.setErrorInterceptor(function(response, deferred, responseHandler) {
        Raven.captureBreadcrumb({
          message: "RX << "+response.config.method.toUpperCase() + ' ' + response.config.url,
          category: 'api', level: 'debug',
          data: {
            data: angular.toJson(response.data, true)
          }
        });
        return true;
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .config(segmentConfig)
    .run(segmentRun);

  /** @ngInject */
  function segmentConfig($envProvider, $segmentProvider) {
    var $env = $envProvider.$get();
    var $segment = $segmentProvider.$get();

    if(!$env.isLocalhost()) {
      $segment.load('4jhCEmwfeDppOyork3Ekm9xpp1A2msXO');
      if(!$env.isProduction()) {
        $segment.debug();
      }
    }
  }

  /** @ngInject */
  function segmentRun($rootScope, $state, $location, $window, $supplier, $segment) {

    function setUserContext() {
      var supplierAuthBearer = $supplier.supplierAuthBearer();
      if(supplierAuthBearer) {
        $supplier.ready().then(function() {
          $segment.identify($supplier.current()._id, {
            firstName: $supplier.current().name,
            lastName: $supplier.current().surname,
            company: $supplier.current().company,
            email: $supplier.current().email || $supplier.current().temail,
            phone: $supplier.current().phone
          });
        });
      }
      else {
        $segment.identify(null);
      }
    }

    var deregistrationCallback0 = $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
      var url = $location.url();
      var path = $location.path();
      var querystring = '';
      var referrer = $window.document.referrer || '';
      var name = toState.ename;

      // Check if there is a query string
      var question = url.indexOf('?');
      if(question !== -1) {
        querystring = url.substring(question, url.length);
      }

      // Check if there is referrer
      if(fromState.name) {
        referrer = $state.href(fromState.name, fromParams, {absolute: true});
      }
      // track the page event
      $segment.page(name, {
        path: path,
        referrer: referrer,
        search: querystring,
        url: $location.absUrl()
      });
    });
    $rootScope.$on('$destroy', deregistrationCallback0);

    setUserContext();

    var deregistrationCallback2 = $rootScope.$on('$supplierChange', function(event, oldUser, newUser) {
      if(newUser) {
        setUserContext();
      }
    });
    $rootScope.$on('$destroy', deregistrationCallback2);

    var deregistrationCallback5 = $rootScope.$on('$supplierSignin', function(event, supplier) {
      $supplier.ready().then(function() {
        $segment.track('Logged In');
      });
    });
    $rootScope.$on('$destroy', deregistrationCallback5);

    var deregistrationCallback6 = $rootScope.$on('$supplierSignout', function(event) {
      $segment.track('Logged Out');

      // See https://github.com/segmentio/analytics.js/issues/128
      $segment.reset();
      $segment.ready(function() {
        $window.mixpanel.reset();
      });
    });
    $rootScope.$on('$destroy', deregistrationCallback6);

    var deregistrationCallback7 = $rootScope.$on('$supplierSignup', function(event, supplier) {
      $segment.alias(supplier._id);
      $segment.track('Registered');
    });
    $rootScope.$on('$destroy', deregistrationCallback7);
    for (var stepIndex = 1; stepIndex <= 8; stepIndex++) {
      var deregistrationCallbackN = $rootScope.$on('$supplierSignup-step-' + stepIndex, function(event, supplier) {
        $segment.alias(supplier._id);
        $segment.track('Registered step ' + stepIndex);
      });
      $rootScope.$on('$destroy', deregistrationCallbackN);
    }

    var deregistrationCallback8 = $rootScope.$on('$supplierUpdate', function(event) {
      $segment.track('Profile Updated');
    });
    $rootScope.$on('$destroy', deregistrationCallback8);
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .config(routerConfig)
    .run(routerRun);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $locationProvider, $urlMatcherFactoryProvider) {
    $urlMatcherFactoryProvider.strictMode(false);

    $urlRouterProvider.rule(function($injector, $location) {
      var $rootScope = $injector.get('$rootScope');
      var path = $location.path(), normalized = path;
      // check to see if the path already has a slash where it should be
      if(normalized[normalized.length - 1] !== '/' && normalized.indexOf('/?') === -1) {
        if(normalized.indexOf('?') > -1) {
          normalized = normalized.replace('?', '/?');
        }
        else {
          normalized += '/';
        }

      }
      //the URL should be case insensitive
      normalized = normalized.toLowerCase();

      if(path != normalized) {
        //instead of returning a new url string, I'll just change the $location.path directly so I don't have to worry about constructing a new url string and so a new state change is not triggered
        $location.replace().path(normalized);
        $rootScope.$rewritten = true;
      }
    });

    $locationProvider.html5Mode(true).hashPrefix('!');

    $urlRouterProvider.when('', '/it/');

    $stateProvider
      .state('root', {
        url: '',
        abstract: true,
        templateUrl: 'app/views/abstracts/general.html'
      })
        .state('root.it', {
          parent: 'root',
          abstract: true,
          url: '/it',
          templateUrl: 'app/views/abstracts/root.html'
        })
        .state('root.it.e404', {
          ename: '404',
          parent: 'root.it',
          url: '/404',
          templateUrl: 'app/views/landing/e404.html',
          controller: 'E404Controller',
          controllerAs: 'vm'
        })
        .state('root.it.license', {
          ename: '404',
          parent: 'root.it',
          url: '/licenza',
          templateUrl: 'app/views/landing/loading.html',
          controllerAs: 'vm'
        })
          .state('root.it.home', {
            ename: 'Home',
            parent: 'root.it',
            url: '/',
            templateUrl: 'app/views/landing/suppliers.html',
            controller: 'SuppliersController',
            controllerAs: 'vm',
            onlyguests: true
          })
          .state('root.it.requests', {
            ename: 'Richieste',
            parent: 'root.it',
            url: '/richieste/:quote/:supplier',
            templateUrl: 'app/views/external/details.html',
            controller: 'TmpQuoteController',
            controllerAs: 'vm',
          })
          .state('root.it.supplier', {
            parent: 'root.it',
            abstract: true,
            url: '/partner',
            templateUrl: 'app/views/abstracts/supplier.html'
          })
            .state('root.it.supplier.signin', {
              ename: 'Login',
              parent: 'root.it.supplier',
              url: '/accesso?goto',
              params: {
                goto: '',
                mode: 'signin'
              },
              templateUrl: 'app/views/supplier/credentials.html',
              controller: 'SupplierCredentialsController',
              controllerAs: 'vm',
              onlyguests: true
            })
            .state('root.it.supplier.signup', {
              ename: 'Registration',
              parent: 'root.it.supplier',
              url: '/registrazione/',
              params: {
                mode: 'signup'
              },
              templateUrl: 'app/views/supplier/credentials.html',
              controller: 'SupplierCredentialsController',
              controllerAs: 'vm',
              onlyguests: true
            })
            .state('root.it.supplier.recover', {
              ename: 'Password Recover',
              parent: 'root.it.supplier',
              url: '/reimposta/',
              params: {
                mode: 'recover'
              },
              templateUrl: 'app/views/supplier/credentials.html',
              controller: 'SupplierCredentialsController',
              controllerAs: 'vm',
              onlyguests: true
            })
            .state('root.it.supplier.reset', {
              ename: 'Password Reset',
              parent: 'root.it.supplier',
              url: '/reimposta/:id/:token/',
              params: {
                mode: 'reset'
              },
              templateUrl: 'app/views/supplier/credentials.html',
              controller: 'SupplierCredentialsController',
              controllerAs: 'vm',
              onlyguests: true
            })
            .state('root.it.supplier.confirm', {
              ename: 'Email Confirmation',
              parent: 'root.it.supplier',
              url: '/conferma/:id/:token/',
              templateUrl: 'app/views/supplier/confirm.html',
              controller: 'SupplierConfirmController',
              controllerAs: 'vm',
              authenticate: true
            })
            .state('root.it.supplier.profile', {
              parent: 'root.it.supplier',
              abstract: true,
              url: '/profilo',
              templateUrl: 'app/views/abstracts/general.html'
            })
            .state('root.it.supplier.profile.name', {
              ename: 'Profile Account Info',
              parent: 'root.it.supplier.profile',
              url: '/account/',
              params: {
                section: '1',
                type: 'visualizza'
              },
              templateUrl: 'app/views/supplier/profile.html',
              controller: 'SupplierProfileController',
              controllerAs: 'vm',
              authenticate: true
            })
            .state('root.it.supplier.profile.poc', {
              ename: 'Profile Personal Info',
              parent: 'root.it.supplier.profile',
              url: '/responsabile/',
              params: {
                section: '2',
                type: 'visualizza'
              },
              templateUrl: 'app/views/supplier/profile.html',
              controller: 'SupplierProfileController',
              controllerAs: 'vm',
              authenticate: true
            })
            .state('root.it.supplier.profile.company', {
              ename: 'Profile Company Info',
              parent: 'root.it.supplier.profile',
              url: '/azienda/',
              params: {
                section: '3',
                type: 'visualizza'
              },
              templateUrl: 'app/views/supplier/profile.html',
              controller: 'SupplierProfileController',
              controllerAs: 'vm',
              authenticate: true
            })
            .state('root.it.supplier.profile.additional', {
              ename: 'Profile Additional Info',
              parent: 'root.it.supplier.profile',
              url: '/aggiuntivi/',
              params: {
                section: '5',
                type: 'visualizza'
              },
              templateUrl: 'app/views/supplier/profile.html',
              controller: 'SupplierProfileController',
              controllerAs: 'vm',
              authenticate: true
            })
            .state('root.it.supplier.profile.notification', {
              ename: 'Profile Notification Info',
              parent: 'root.it.supplier.profile',
              url: '/notifiche/',
              params: {
                section: '7',
                type: 'visualizza'
              },
              templateUrl: 'app/views/supplier/profile.html',
              controller: 'SupplierProfileController',
              controllerAs: 'vm',
              authenticate: true
            })
            .state('root.it.supplier.profile.requesttypes', {
              ename: 'Profile Vehicles Info',
              parent: 'root.it.supplier.profile',
              url: '/veicoli/',
              params: {
                section: '8',
                type: 'visualizza'
              },
              templateUrl: 'app/views/supplier/profile.html',
              controller: 'SupplierProfileController',
              controllerAs: 'vm',
              authenticate: true
            })
            .state('root.it.supplier.black-list', {
              parent: 'root.it.supplier',
              url: '/black-list',
              templateUrl: 'app/views/supplier/black-list.html',
              controllerAs: 'vm',
              authenticate: true
            })
              .state('root.it.supplier.profile.info', {
                parent: 'root.it.supplier.profile',
                abstract: true,
                url: '/info',
                templateUrl: 'app/views/abstracts/general.html'
              })
                .state('root.it.supplier.profile.info.view', {
                  ename: 'Profile Personal Info',
                  parent: 'root.it.supplier.profile.info',
                  url: '/visualizza/',
                  params: {
                    section: 'info',
                    type: 'visualizza'
                  },
                  templateUrl: 'app/views/supplier/profile.html',
                  controller: 'SupplierProfileController',
                  controllerAs: 'vm',
                  authenticate: true
                })
                .state('root.it.supplier.profile.info.edit', {
                  ename: 'Edit Profile Personal Info',
                  parent: 'root.it.supplier.profile.info',
                  url: '/modifica/',
                  params: {
                    section: 'info',
                    type: 'modifica'
                  },
                  templateUrl: 'app/views/supplier/profile.html',
                  controller: 'SupplierProfileController',
                  controllerAs: 'vm',
                  authenticate: true
                })
              .state('root.it.supplier.profile.billing', {
                parent: 'root.it.supplier.profile',
                abstract: true,
                url: '/fatturazione',
                templateUrl: 'app/views/abstracts/general.html'
              })
                .state('root.it.supplier.profile.billing.view', {
                  ename: 'Profile Billing Info',
                  parent: 'root.it.supplier.profile.billing',
                  url: '/visualizza/',
                  params: {
                    section: 'fatturazione',
                    type: 'visualizza'
                  },
                  templateUrl: 'app/views/supplier/profile.html',
                  controller: 'SupplierProfileController',
                  controllerAs: 'vm',
                  authenticate: true
                })
                .state('root.it.supplier.profile.billing.edit', {
                  ename: 'Edit Profile Billing Info',
                  parent: 'root.it.supplier.profile.billing',
                  url: '/modifica/',
                  params: {
                    section: 'fatturazione',
                    type: 'modifica'
                  },
                  templateUrl: 'app/views/supplier/profile.html',
                  controller: 'SupplierProfileController',
                  controllerAs: 'vm',
                  authenticate: true
                })
              .state('root.it.supplier.profile.password', {
                parent: 'root.it.supplier.profile',
                abstract: true,
                url: '/password',
                templateUrl: 'app/views/abstracts/general.html'
              })
                .state('root.it.supplier.profile.password.edit', {
                  ename: 'Edit Profile Password',
                  parent: 'root.it.supplier.profile.password',
                  url: '/modifica/',
                  params: {
                    section: 'password',
                    type: 'modifica'
                  },
                  templateUrl: 'app/views/supplier/profile.html',
                  controller: 'SupplierProfileController',
                  controllerAs: 'vm',
                  authenticate: true
                })

            .state('root.it.supplier.pricing', {
              parent: 'root.it.supplier',
              abstract: true,
              url: '/pricing',
              templateUrl: 'app/views/abstracts/general.html'
            })
              .state('root.it.supplier.pricing.list', {
                ename: 'Tariffario',
                parent: 'root.it.supplier.pricing',
                url: '/',
                templateUrl: 'app/views/supplier/tables/pricing/pricing.html',
                controller: 'PricingTableController',
                controllerAs: 'vm',
                authenticate: true
                })

                .state('root.it.supplier.network', {
                  parent: 'root.it.supplier',
                  abstract: true,
                  url: '/network',
                  templateUrl: 'app/views/abstracts/general.html'
                })
                  .state('root.it.supplier.network.list', {
                    ename: 'Tariffario',
                    parent: 'root.it.supplier.network',
                    url: '/',
                    templateUrl: 'app/views/supplier/tables/network/network.html',
                    controller: 'NetworkTableController',
                    controllerAs: 'vm',
                    authenticate: true
                    })
            .state('root.it.supplier.subscribe', {
              parent: 'root.it.supplier',
              abstract: true,
              url: '/subscription',
              templateUrl: 'app/views/abstracts/general.html'
            })
              .state('root.it.supplier.subscribe.list', {
                ename: 'Abbonati',
                parent: 'root.it.supplier.subscribe',
                url: '/?redirect_flow_id',
                params: {
                  redirect_flow_id: ''
                },
                templateUrl: 'app/views/supplier/subscribe/subscribe.html',
                controller: 'SupplierSubscribeController',
                controllerAs: 'vm',
                authenticate: true
              })
            .state('root.it.supplier.quotes', {
              parent: 'root.it.supplier',
              abstract: true,
              url: '/richieste',
              templateUrl: 'app/views/abstracts/general.html'
            })
              .state('root.it.supplier.quotes.list', {
                ename: 'Nuove Richieste',
                parent: 'root.it.supplier.quotes',
                url: '/',
                templateUrl: 'app/views/supplier/quotes.html',
                controller: 'SupplierQuotesController',
                controllerAs: 'vm',
                authenticate: true
              })
              .state('root.it.supplier.quotes.details', {
                ename: 'Nuove Richieste',
                parent: 'root.it.supplier.quotes',
                url: '/details/:id/',
                templateUrl: 'app/views/supplier/details.html',
                controller: 'DetailsController',
                controllerAs: 'vm',
                authenticate: true
              })
            .state('root.it.supplier.quotes.accepted', {
              ename: 'Prenotazioni',
              parent: 'root.it.supplier.quotes',
              url: '/accettate/',
              templateUrl: 'app/views/supplier/accepted.html',
              controller: 'SupplierAcceptedController',
              controllerAs: 'vm',
              authenticate: true
            })
            .state('root.it.supplier.trips', {
              parent: 'root.it.supplier',
              abstract: true,
              url: '/prenotazioni',
              templateUrl: 'app/views/abstracts/general.html'
            })
                .state('root.it.supplier.trips.list', {
                  ename: 'Trips List',
                  parent: 'root.it.supplier.trips',
                  url: '/',
                  templateUrl: 'app/views/supplier/trips.html',
                  controller: 'SupplierTripsController',
                  controllerAs: 'vm',
                  authenticate: true
                })
                .state('root.it.supplier.trips.details', {
                  ename: 'Trip Details',
                  parent: 'root.it.supplier.trips',
                  url: '/dettagli/:id/',
                  templateUrl: 'app/views/supplier/trips.details.html',
                  controller: 'SupplierTripsDetailsController',
                  controllerAs: 'vm',
                  authenticate: true
                })
                .state('root.it.supplier.trips.order', {
                  ename: 'Order Details',
                  parent: 'root.it.supplier.trips',
                  url: '/ordine/:id/',
                  templateUrl: 'app/views/supplier/trips.order.html',
                  controller: 'SupplierTripsOrderController',
                  controllerAs: 'vm',
                  authenticate: true
                })
                .state('root.it.supplier.trips.review', {
                  ename: 'Trip Review',
                  parent: 'root.it.supplier.trips',
                  url: '/rispondi/:id/',
                  templateUrl: 'app/views/supplier/trips.review.html',
                  controller: 'SupplierTripsReviewController',
                  controllerAs: 'vm',
                  authenticate: true
                })
            .state('root.it.supplier.places', {
              parent: 'root.it.supplier',
              abstract: true,
              url: '/sedi',
              templateUrl: 'app/views/abstracts/general.html'
            })
              .state('root.it.supplier.places.list', {
                ename: 'Places List',
                parent: 'root.it.supplier.places',
                url: '/',
                templateUrl: 'app/views/supplier/places.html',
                controller: 'SupplierPlacesController',
                controllerAs: 'vm',
                authenticate: true
              })
              .state('root.it.supplier.places.add', {
                ename: 'Add Place',
                parent: 'root.it.supplier.places',
                url: '/aggiungi/',
                templateUrl: 'app/views/supplier/places.add.html',
                controller: 'SupplierPlacesAddController',
                controllerAs: 'vm',
                authenticate: true
              })
              .state('root.it.supplier.places.edit', {
                ename: 'Edit Place',
                parent: 'root.it.supplier.places',
                url: '/modifica/:id/',
                templateUrl: 'app/views/supplier/places.edit.html',
                controller: 'SupplierPlacesEditController',
                controllerAs: 'vm',
                authenticate: true
              })
            .state('root.it.supplier.sentquotes', {
              parent: 'root.it.supplier',
              abstract: true,
              url: '/servizi',
              templateUrl: 'app/views/abstracts/general.html'
            })
            .state('root.it.supplier.sentquotes.list', {
              ename: 'Gira servizi',
              parent: 'root.it.supplier.sentquotes',
              url: '/',
              templateUrl: 'app/views/supplier/tables/sent-quote/list.html',
              controller: 'SentQuotesController',
              controllerAs: 'vm',
              authenticate: true
            })
            .state('root.it.supplier.sentquotes.edit', {
              ename: 'Nuovo servizio',
              parent: 'root.it.supplier.sentquotes',
              url: '/dettagli/:id',
              templateUrl: 'app/views/supplier/book/newquote.html',
              controller: 'BookQuoteController',
              controllerAs: 'vm',
              authenticate: true
            })
            .state('root.it.supplier.vehicles', {
              parent: 'root.it.supplier',
              abstract: true,
              url: '/veicoli',
              templateUrl: 'app/views/abstracts/general.html'
            })
              .state('root.it.supplier.vehicles.list', {
                ename: 'Veicoli',
                parent: 'root.it.supplier.vehicles',
                url: '/',
                templateUrl: 'app/views/supplier/tables/vehicles/vehicles.html',
                controller: 'VehiclesTableController',
                controllerAs: 'vm',
                authenticate: true
              })
              .state('root.it.supplier.vehicles.add', {
                ename: 'Add Vehicle',
                parent: 'root.it.supplier.vehicles',
                url: '/aggiungi/',
                templateUrl: 'app/views/supplier/vehicles.add.html',
                controller: 'SupplierVehiclesAddController',
                controllerAs: 'vm',
                authenticate: true
              })
              .state('root.it.supplier.vehicles.duplicate', {
                ename: 'Add Vehicle',
                parent: 'root.it.supplier.vehicles',
                url: '/aggiungi/:id/',
                templateUrl: 'app/views/supplier/vehicles.add.html',
                controller: 'SupplierVehiclesAddController',
                controllerAs: 'vm',
                authenticate: true
              })
              .state('root.it.supplier.vehicles.edit', {
                ename: 'Edit Vehicle',
                parent: 'root.it.supplier.vehicles',
                url: '/modifica/:id/',
                templateUrl: 'app/views/supplier/vehicles.edit.html',
                controller: 'SupplierVehiclesEditController',
                controllerAs: 'vm',
                authenticate: true
              });

    $urlRouterProvider.otherwise(function ($injector, $location) {
      var $state = $injector.get('$state');
      $state.go('root.it.e404', null, {location: false});
    });
  }


  /** @ngInject */
  function routerRun($env, $rootScope, $window, $state, $supplier, $base64, $location) {
    $rootScope.$state = $state;
    $rootScope.$status = 0;
    $rootScope.$url = $location.absUrl().split('?')[0];
    $rootScope.$tel = "0694804020";
    $rootScope.$phone = "06-94804020";
    $rootScope.$year = new Date().getFullYear();
    $rootScope.$intphone = "+39-06-94804020";

    $rootScope.$globaljsonld = [{
      "@context": "http://schema.org",
      "@type": "WebSite",
      "url": "https://partner.busrapido.com"
    }];
    $rootScope.$jsonld = angular.copy($rootScope.$globaljsonld);

    if($env.isLocalhost()) {
      $rootScope.$users = location.protocol+'//localhost:3000';
    }
    else {
      var host = location.host.split('.'); host.shift();
      $rootScope.$users = location.protocol+'//'+host.join('.');
    }

    var deregistrationCallback0 = $rootScope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {
      $rootScope.$url = $location.absUrl().split('?')[0];
      $rootScope.$jsonld = angular.copy($rootScope.$globaljsonld);

      if(fromState.name) {
        $window.document.body.scrollTop = $window.document.documentElement.scrollTop = 0;
      }
      if(!$rootScope.$status) {
        $rootScope.$status = $rootScope.$rewritten ? 303 : 0;
      }
      $rootScope.$rewritten = false;
    });
    $rootScope.$on('$destroy', deregistrationCallback0);

    var deregistrationCallback1 = $rootScope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams) {
      $rootScope.$status = (toState.name === 'root.it.e404') ? 404 : 0;

      if(!toState.authenticate || $supplier.isAuthenticated()) {
        return;
      }

      event.preventDefault();
      var string = angular.toJson({name: toState.name, params: toParams});
      var redirect = $base64.encode(unescape(encodeURIComponent(string)));
      $state.go('root.it.supplier.signin', {goto: redirect});
    });
    $rootScope.$on('$destroy', deregistrationCallback1);

    var deregistrationCallback2 = $rootScope.$on('$supplierChange', function(event, oldUser, newUser) {
      if(!$state.current.authenticate || $supplier.isAuthenticated()) {
        return;
      }

      var string = angular.toJson({name: $state.current.name, params: $state.params});
      var redirect = $base64.encode(unescape(encodeURIComponent(string)));
      $state.go('root.it.supplier.signin', {goto: redirect});
    });
    $rootScope.$on('$destroy', deregistrationCallback2);
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .config(restConfig);

  /** @ngInject */
  function restConfig($windowProvider, $envProvider, RestangularProvider, $sessionProvider, $supplierProvider, $errorProvider, $locationProvider) {
    var $window = $windowProvider.$get();
    var $session = $sessionProvider.$get();
    var $supplier = $supplierProvider.$get();
    var $env = $envProvider.$get();
    var $error = $errorProvider.$get();

    var base;
    if($env.isLocalhost()) {
      base = 'http://127.0.0.1:5000';
    }
    else {
      if(!$window.location.origin) {
        $window.location.origin = $window.location.protocol + "//" + $window.location.hostname + ($window.location.port ? ':' + $window.location.port : '');
      }
      //base = $window.location.origin + '/api';
      base = 'https://api.busrapido.com';
    }

    console.log("url ", base)

    RestangularProvider.setBaseUrl(base);

    RestangularProvider.setFullRequestInterceptor(function(element, operation, route, url, headers, params, httpConfig) {
      var supplierAuthBearer = $supplier.supplierAuthBearer();
      var sessionBearer = $session.sessionBearer();

      if(!(url.indexOf(base+'/sessions') !== -1)) {
        if(supplierAuthBearer) {
          headers.Authorization = 'Bearer ' + supplierAuthBearer;
        }
        else if(sessionBearer) {
          headers.Authorization = 'Bearer ' + sessionBearer;
        }
      }
      return {
        element: element,
        params: params,
        headers: headers,
        httpConfig: httpConfig
      };
    });

    RestangularProvider.setErrorInterceptor(function(response, deferred, responseHandler) {
      $error.throw(response, 'api');
      return true;
    });

    $session.init();
    $supplier.init();
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .config(ngConfig);

  /** @ngInject */
  function ngConfig($compileProvider, $httpProvider, $qProvider, $envProvider, $logProvider) {
    var $env = $envProvider.$get();

    if(!$env.isLocalhost()) {
      $logProvider.debugEnabled(false);
      $compileProvider.debugInfoEnabled(false);
    }

    $compileProvider.commentDirectivesEnabled(false);
    $compileProvider.cssClassDirectivesEnabled(false);

    $httpProvider.useLegacyPromiseExtensions = false;

    $qProvider.errorOnUnhandledRejections(false);
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .run(momentRun);

  /** @ngInject */
  function momentRun(amMoment) {
    amMoment.changeLocale('it');
  }

})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .config(mapsConfig);

  /** @ngInject */
  function mapsConfig($envProvider, uiGmapGoogleMapApiProvider) {
    var $env = $envProvider.$get();
    var apikey;

    if($env.isProduction()) {
      apikey = 'AIzaSyDVyBECQOLzpB7eoKtcH5Hh2186UpVwu68';
    }
    else {
      apikey = 'AIzaSyDVyBECQOLzpB7eoKtcH5Hh2186UpVwu68';
    }
    uiGmapGoogleMapApiProvider.configure({
      key: apikey,
      v: '3',
      libraries: 'drawing,geometry,visualization,places',
      language: 'it-IT'
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .config(cloudinaryConfig);

  /** @ngInject */
  function cloudinaryConfig($envProvider, cloudinaryProvider) {
    var $env = $envProvider.$get();
    var cloud;

    if($env.isProduction()) {
      cloud = 'busrapidohq';
    }
    else {
      cloud = 'busrapidodev';
    }
    cloudinaryProvider.set('cloud_name', cloud);
    cloudinaryProvider.set('cloud_upload', 'https://api.cloudinary.com/v1_1/'+cloud+'/upload');
  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .filter('adminStatus', adminStatusFilter)
    .filter('array', arrayFilter)
    .filter('calendar', calendarFilter)
    .filter('chargeType', chargeTypeFilter)
    .filter('city', citiesFilter)
    .filter('costPayer', costPayerFilter)
    .filter('dates', dateFilter)
    .filter('day', dayFilter)
    .filter('distance', distanceFilter)
    .filter('dresscode', dresscodeFilter)
    .filter('drivers', driversFilter)
    .filter('duration', durationFilter)
    .filter('field', fieldFilter)
    .filter('gender', genderFilter)
    .filter('insurance', insuranceFilter)
    .filter('interval', intervalFilter)
    .filter('margin', marginFilter)
    .filter('notificationStatus', notificationStatusFilter)

    .filter('onlyTooltip', onlyTooltipFilter)
    .filter('partnerTotal', partnerTotalFilter)
    .filter('passengers', passengersFilter)
    .filter('quoteId', quoteIdFilter)
    .filter('requestType', requestTypeFilter)
    .filter('seatbelts', seatbeltsFilter)
    .filter('serviceDuration', serviceDurationFilter)
    .filter('serviceLength', serviceLengthFilter)
    .filter('servicePriceType', servicePriceTypeFilter)
    .filter('serviceType', serviceTypeFilter)
    .filter('status', statusFilter)
    .filter('subscriptionUrl', subscriptionUrlFilter)
    .filter('subscriptionInterval', subscriptionIntervalFilter)
    .filter('subscriptionType', subscriptionTypeFilter)
    .filter('smoking', smokingFilter)
    .filter('time', timeFilter)
    .filter('timeDate', timeDateFilter)
    .filter('vehicles', vehiclesFilter);
    //.filter('boolean', booleanFilter)


    function adminStatusFilter() {
      return function (input) {
        if (!input) {
          return 'N/D';
        }
        if (input === 'hidden') {
          return 'bozza'
        }
        if (input === 'public') {
          return 'inviata'
        }
        if (input === 'accepted') {
          return 'accettata'
        }
      }
    }
    function notificationStatusFilter() {
      return function (input) {
        var status = '';
        if (input['email']) status += '📧'
        if (input['sms']) status += '💬'
        if (input['phone']) status += '📞'
        return status;
      }
    }
    function genderFilter() {
      return function (input) {
        if (!input) {
          return 'Nessun requisito specifico';
        }
        if (input === 'other') {
          return 'Nessun requisito specifico'
        }
        if (input === 'male') {
          return 'Uomo'
        }
        if (input === 'female') {
          return 'Donna'
        }
      }
    }
    function dresscodeFilter() {
      return function (input) {
        if (!input) {
          return 'Nessun requisito specifico';
        }
        if (input === 'other') {
          return 'Nessun requisito specifico'
        }
        if (input === 'formal') {
          return 'Giacca e Cravatta'
        }
        if (input === 'shirt') {
          return 'Camicia'
        }
      }
    }
    function smokingFilter() {
      return function (input) {
        if (input) {
          return 'Nessun requisito specifico';
        }
        return 'Non fumatore';
      }
    }


    function seatbeltsFilter() {
      return function (input) {
        if (!input) {
          return 'non specificato';
        }
        if (input === 'all') {
          return 'Il veicolo è dotato di cinture di sicurezza su tutti i sedili'
        }
        if (input === 'rear') {
          return 'Il veicolo è dotato di cinture di sicurezza solo sui sedili posteriori'
        }
        if (input === 'none') {
          return 'Il veicolo non è dotato di cinture di sicurezza'
        }
      }
    }

    function chargeTypeFilter($filter) {
      return function (input) {
        switch (input) {
          case 'hour':
            return 'Sovrapprezzo per ogni ora extra:'
          case 'km':
            return 'Sovrapprezzo per ogni km extra:'
          case 'driver':
            return 'Sovrapprezzo per un autista aggiuntivo:'

        }
      }
    }
    function subscriptionTypeFilter($filter) {
      return function (input) {
        switch (input) {
          case 'monthly':
            return 'mensilmente';
            case 'yearly':
              return 'annualmente';
            case 'biannual':
              return 'ogni due anni';
        }
        return input;
      }
    }

    function subscriptionIntervalFilter($filter) {
      return function (input) {
        switch (input) {
          case 'monthly':
            return 'Mensile';
            case 'yearly':
              return 'Annuale';
            case 'biannual':
              return 'Biennale';
        }
        return input;
      }
    }

    function timeDateFilter($filter) {
      return function (input) {
        return $filter('time')(input) + ' del ' + $filter('calendar')(input);
      }
    }

    function subscriptionUrlFilter($filter, $env) {
      return function (input) {
        console.log(input)
        console.log(input.indexOf('/'))
        console.log(input.indexOf('http'))
        if (!input) return '';
        if (input.indexOf('/') !== -1 && input.indexOf('http') === -1) {
          var cloud;

          if ($env.isProduction()) {
            cloud = 'busrapidohq';
          } else {
            cloud = 'busrapidodev';
          }
          return 'https://res.cloudinary.com/' + cloud + '/upload/v1/' + input;
        }
        return input;
      }
    }

    function serviceDurationFilter($filter) {

      return function (input) {
        var regex = /[0-9]+h/g;
        if (!input.match(regex)) {
          return '12 ore';
        }
        else {
          return input.match(regex)[0].substring(0, input.match(regex)[0].length - 1) + ' ore';
        }
      }
    }
    function serviceLengthFilter($filter) {
      return function (input) {
        var regex = /[0-9]+k/g;
        return input.match(regex)[0] + 'm'
      }
    }
    function servicePriceTypeFilter($filter) {
      return function (input) {
        switch (input) {
          case 'monthly':
            return 'Mensile';
            case 'yearly':
              return 'Annuale';
            case 'biannual':
              return 'Biennale';
        }
        return input;
      }
    }
    function arrayFilter($filter) {
      return function (input) {

        if (angular.isArray(input))
          return input.join(', ');
        return input;
      }
    }

  function booleanFilter($filter) {
    return function (input) {
      if (input) {
        return '<span class="icon icon-thick></span>';
      }
      if (!input) {
        return '<span class="icon icon-cancel></span>';
      }
    }
  }

  function partnerTotalFilter($filter, $common) {
    return function (input) {
      return $filter('currency')($common.getPrice(input));
    }
  }

  function fieldFilter($filter) {
    return function (input) {
      switch (input) {
        case 'request_type':
          return 'Tipo di Richiesta';
        case 'id':
          return 'N° Prenotazione';
        case 'partner_price':
          return 'Prezzo partner';
        case 'client_price':
          return 'Prezzo cliente';
        case 'updatedAt':
          return 'Data di ultima modifica';
        case 'startdate':
          return 'Data di partenza';
        case 'enddate':
          return 'Data di fine';
        case 'starttime':
          return 'Ora di partenza';
        case 'endtime':
          return 'Ora di fine';
        case 'passengers':
          return 'Pax';
        case 'pickup':
          return 'Pick-up';
        case 'dropoff':
          return 'Drop-off';
        case 'service_type':
          return 'Tipo di servizio';
        case 'specs.plate':
          return 'Targa';
        case 'specs.manufacturer':
          return 'Marca';
        case 'specs.model':
          return 'Modello';
        case 'specs.matriculation':
          return 'Immatricolazione';
        case 'specs.axis':
          return 'Assi';
        case 'specs.seats.drivers':
          return 'Posti autista';
        case 'specs.seats.passengers':
          return 'Posti passeggero';
        case 'specs.emissionClass':
          return 'Euro';
        case 'specs.highness':
          return 'Altezza';
        case 'specs.lengthiness':
          return 'Lunghezza';
        case 'specs.largeness':
          return 'Larghezza';
        case 'services.audio':
          return 'Impianto stereo';
        case 'services.coffeMachine':
          return 'Macchina del caff&egrave;';
        case 'services.conditioner':
          return 'Aria condizionata';
        case 'services.display':
          return 'Schermo TV';
        case 'services.dvdPlayer':
          return 'Lettore DVD';
        case 'services.electricity':
          return 'Prese elettriche';
        case 'services.fridge':
          return 'Mini Frigorifero';
        case 'services.kitchen':
          return 'Cucina a bordo';
        case 'services.leatherSeats':
          return 'Sedili in pelle';
        case 'services.light':
          return 'Luce da lettura';
        case 'services.luggage':
          return 'Vano valige';
        case 'services.microphone':
          return 'Microfono';
        case 'services.panoramicWindows':
          return 'Vetri panoramici';
        case 'services.radio':
          return 'Radio';
        case 'services.tintedWindows':
          return 'Vetri oscurati';
        case 'services.toilet':
          return 'Toilet';
        case 'services.tvAerial':
          return 'Antenna TV';
        case 'services.usb':
          return 'Carica USB';
        case 'services.wheelchair':
          return 'Pedana carrozzine';
        case 'services.wifi':
          return 'Wi-Fi';
        default:
          return input;
      }
    }
  }

  function costPayerFilter($filter) {
    return function (input) {
      if (input === 'us') {
        return 'A carico nostro in fattura';
      } else if (input === 'partner') {
        return 'A carico del collaboratore';
      } else if (input === 'client') {
        return 'A carico del gruppo';
      } else {
        return 'A carico del collaboratore';
      }
    }
  }

  function onlyTooltipFilter($filter) {
    return function (input) {
      if (input.indexOf('only') !== -1) {
        return 'Questa è una richiesta speciale inviata in esclusiva a te!';
      }
      if (input.indexOf('supplier') !== -1) {
        return 'Questa è una richiesta speciale inviata dal tuo network di collaboratori!';
      }
      return $filter('requestType')(input);
    }
  }

  function requestTypeFilter($filter) {
    return function (input) {
      if (input === 'request') return 'Prenotazione';
      if (input === 'other') return 'Opzione';
      if (input === 'onlyrequest') return 'Prenotazione';
      if (input === 'onlyother') return 'Opzione';
      return input;
    }
  }

  function insuranceFilter($filter) {
    return function (input) {
      if (!input) {
        return '30 M';
      }
      if (input > 1000000) {
        return Math.ceil(input / 1000000) + ' M';
      } else {
        return Math.floor(input / 1000) + '.' + input % 1000;
      }
    }
  }

  function marginFilter($filter) {
    return function (input) {
      if (!input) {
        return '0';
      }
      if (input > 0) {
        return '+ ' + $filter('currency')(input);
      } else if (input < 0) {
        return $filter('currency')(input);
      } else {
        return $filter('currency')(input);
      }
    }
  }

  function intervalFilter($filter) {
    return function (input) {
      if (!input) {
        return 'N/A';
      }
      var hh = Math.floor(input / 60);
      var mm = input % 60;
      var output = '';
      if (hh === 1) {
        output += 'ora'
      }
      if (hh > 1) {
        output += hh + ' ore';
      }
      if (mm > 0 && hh > 0) {
        output += ' e ';
      }
      if (mm > 0) {
        output += mm + ' minuti';
      }
      return output;
    }
  }

  function serviceTypeFilter($filter) {
    return function (input) {
      if (!input) {
        return undefined;
      }
      switch (input) {
        case 'transfer':
          return 'Transfer';
        case 'city':
          return 'City Tour';
        case 'disposal':
          return 'Disposizione';
        case 'bus':
          return 'Bus in loco';
        case 'pickup':
          return 'Pickup';
        case 'pickup-last':
          return 'Pickup proseguimento';
        case 'end':
          return 'End';
        case 'return':
          return 'Ritorno';
        case 'transit':
          return 'Punto di transito';
        default:
          return input;
      }
    }
  }

  function dayFilter($filter) {
    return function (input) {
      if (!input) {
        return undefined;
      }
      var date = new Date(input);
      return $filter('amDateFormat')(input, 'D MMM');
    }
  }

  function calendarFilter($filter) {
    return function (input) {
      if (!input) {
        return undefined;
      }
      var date = new Date(input);
      return $filter('amDateFormat')(input, 'D MMM YYYY');
    }
  }

  function timeFilter($filter) {
    return function (input) {
      if (!input) {
        return undefined;
      }
      var date = new Date(input);
      return $filter('amDateFormat')(input, 'HH:mm');
    }
  }

  function statusFilter() {
    return function (input) {
      if (!input) {
        return 'N/D';
      }
      if (input === 'pending') {
        return 'in attesa di conferma'
      }
      if (input === 'viewed') {
        return 'in attesa di conferma'
      }
      if (input === 'accepted') {
        return 'confermata'
      }
      if (input === 'optioned') {
        return 'opzionata'
      }
      if (input.indexOf('rejected') !== -1) {
        return 'rifiutata'
      }
      if (input.indexOf('voided') !== -1) {
        return 'non disponibile'
      }
    }
  }

  function quoteIdFilter() {
    return function (input) {
      if (!input) {
        return 'N/D';
      }
      var s = input.toString();

      return new String(parseInt(s.substring(2, 6) + s.substring(12, 14) + s.substring(22, 24), 16)).padStart(10, '0');
    }
  }


  function distanceFilter() {
    return function (input) {
      if (!input || input < 1) {
        return 'N/D';
      }
      if (input >= 1000) {
        return (input / 1000).toFixed(0) + ' km';
      } else {
        return input + 'm';
      }
    }
  }

  function citiesFilter() {
    return function (input) {
      if (angular.isUndefined(input)) return;
      var cities = input.split(',');
      return cities[0];
    }
  }
  /** @ngInject */
  function dateFilter($filter) {
    return function (now, previous) {
      if (!now) {
        return undefined;
      }
      var date1 = new Date(now);

      if (angular.isUndefined(previous)) {
        return $filter('amDateFormat')(now, 'D MMM YYYY, HH:mm');
      }
      var date2 = new Date(previous);
      if (date1.getFullYear() === date2.getFullYear()) {
        if (date1.getMonth() === date2.getMonth()) {
          if (date1.getDate() === date2.getDate()) {
            return $filter('amDateFormat')(now, 'HH:mm');
          } else {
            return $filter('amDateFormat')(now, 'D, HH:mm');
          }
        } else {
          return $filter('amDateFormat')(now, 'D MMM, HH:mm');
        }
      } else {
        return $filter('amDateFormat')(now, 'D MMM YYYY, HH:mm');
      }
    }
  }
  /** @ngInject */
  function durationFilter($filter) {
    return function (input) {
      if (!input || input < 1) {
        return 'N/D';
      }
      return moment.duration(input, "seconds").format("d[d] h[h] mm[m]");
    }
  }

  function passengersFilter() {
    return function (input) {
      if (!input || input < 1) {
        return 'N/D';
      }
      if (input === 1) {
        return input + ' passeggero';
      } else {
        return input + ' passeggeri';
      }
    }
  }

  function driversFilter() {
    return function (input) {
      if (!input || input < 1) {
        return 'N/D';
      }
      if (input === 1) {
        return input + ' autista';
      } else {
        return input + ' autisti';
      }
    }
  }

  function vehiclesFilter() {
    return function (input) {
      if (!input || input < 1) {
        return 'N/D';
      }
      if (input === 1) {
        return input + ' veicolo';
      } else {
        return input + ' veicoli';
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .constant('RegexConstant', {
      id: /^[0-9a-fA-F]{24}$/,
      email: /^[-a-zA-Z0-9~!$%^&*_=+}{'?]+(\.[-a-zA-Z0-9~!$%^&*_=+}{'?]+)*@([a-zA-Z0-9_][-a-zA-Z0-9_]*(\.[-a-zA-Z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i,
      password: /^[^ \s]{6,254}$/,
      name: /^[^+=*<>?@%!?#:;()[\]{}_/\\|\n\r\t]+$/,
      phone: /^[ \(\)\d+-]{3,254}$/,
      slug: /^[a-z0-9-]+$/,
      idx: /^-?[0-9]+$/,
      cf: /^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/,
      pi: /^[0-9]{11}$/,
      iban: /^[0-9A-Z ]{16,32}$/,
    });
})();

(function () {
  'use strict';

  angular
    .module('busrapidoAppWeb')
    .constant('PlacesConstants', [{
        name: 'Altro',
        code: '',
        selected: true
      },
      {
        name: 'Torino, Piemonte',
        code: 'TO',
        selected: true
      },
      {
        name: 'Vercelli, Piemonte',
        code: 'VC',
        selected: true
      },
      {
        name: 'Novara, Piemonte',
        code: 'NO',
        selected: true
      },
      {
        name: 'Cuneo, Piemonte',
        code: 'CN',
        selected: true
      },
      {
        name: 'Asti, Piemonte',
        code: 'AT',
        selected: true
      },
      {
        name: 'Alessandria, Piemonte',
        code: 'AL',
        selected: true
      },
      {
        name: 'Biella, Piemonte',
        code: 'BI',
        selected: true
      },
      {
        name: 'Verbano-Cusio-Ossola, Piemonte',
        code: 'VB',
        selected: true
      },
      {
        name: "Aosta, Valle d'Aosta",
        code: 'AO',
        selected: true
      },
      {
        name: 'Varese, Lombardia',
        code: 'VA',
        selected: true
      },
      {
        name: 'Como, Lombardia',
        code: 'CO',
        selected: true
      },
      {
        name: 'Sondrio, Lombardia',
        code: 'SO',
        selected: true
      },
      {
        name: 'Milano, Lombardia',
        code: 'MI',
        selected: true
      },
      {
        name: 'Bergamo, Lombardia',
        code: 'BG',
        selected: true
      },
      {
        name: 'Brescia, Lombardia',
        code: 'BS',
        selected: true
      },
      {
        name: 'Pavia, Lombardia',
        code: 'PV',
        selected: true
      },
      {
        name: 'Cremona, Lombardia',
        code: 'CR',
        selected: true
      },
      {
        name: 'Mantova, Lombardia',
        code: 'MN',
        selected: true
      },
      {
        name: 'Lecco, Lombardia',
        code: 'LC',
        selected: true
      },
      {
        name: 'Lodi, Lombardia',
        code: 'LO',
        selected: true
      },
      {
        name: 'Bolzano, Trentino-Alto Adige',
        code: 'BZ',
        selected: true
      },
      {
        name: 'Trento, Trentino-Alto Adige',
        code: 'TN',
        selected: true
      },
      {
        name: 'Verona, Veneto',
        code: 'VR',
        selected: true
      },
      {
        name: 'Vicenza, Veneto',
        code: 'VI',
        selected: true
      },
      {
        name: 'Belluno, Veneto',
        code: 'BL',
        selected: true
      },
      {
        name: 'Treviso, Veneto',
        code: 'TV',
        selected: true
      },
      {
        name: 'Venezia, Veneto',
        code: 'VE',
        selected: true
      },
      {
        name: 'Padova, Veneto',
        code: 'PD',
        selected: true
      },
      {
        name: 'Rovigo, Veneto',
        code: 'RO',
        selected: true
      },
      {
        name: 'Udine, Friuli-Venezia Giulia',
        code: 'UD',
        selected: true
      },
      {
        name: 'Gorizia, Friuli-Venezia Giulia',
        code: 'GO',
        selected: true
      },
      {
        name: 'Trieste, Friuli-Venezia Giulia',
        code: 'TS',
        selected: true
      },
      {
        name: 'Pordenone, Friuli-Venezia Giulia',
        code: 'PN',
        selected: true
      },
      {
        name: 'Imperia, Liguria',
        code: 'IM',
        selected: true
      },
      {
        name: 'Savona, Liguria',
        code: 'SV',
        selected: true
      },
      {
        name: 'Genova, Liguria',
        code: 'GE',
        selected: true
      },
      {
        name: 'La Spezia, Liguria',
        code: 'SP',
        selected: true
      },
      {
        name: 'Piacenza, Emilia-Romagna',
        code: 'PC',
        selected: true
      },
      {
        name: 'Parma, Emilia-Romagna',
        code: 'PR',
        selected: true
      },
      {
        name: "Reggio nell'Emilia, Emilia-Romagna",
        code: 'RE',
        selected: true
      },
      {
        name: 'Modena, Emilia-Romagna',
        code: 'MO',
        selected: true
      },
      {
        name: 'Bologna, Emilia-Romagna',
        code: 'BO',
        selected: true
      },
      {
        name: 'Ferrara, Emilia-Romagna',
        code: 'FE',
        selected: true
      },
      {
        name: 'Ravenna, Emilia-Romagna',
        code: 'RA',
        selected: true
      },
      {
        name: "Forli'-Cesena, Emilia-Romagna",
        code: 'FO',
        selected: true
      },
      {
        name: 'Rimini, Emilia-Romagna',
        code: 'RN',
        selected: true
      },
      {
        name: 'Massa-Carrara, Toscana',
        code: 'MS',
        selected: true
      },
      {
        name: 'Lucca, Toscana',
        code: 'LU',
        selected: true
      },
      {
        name: 'Pistoia, Toscana',
        code: 'PT',
        selected: true
      },
      {
        name: 'Firenze, Toscana',
        code: 'FI',
        selected: true
      },
      {
        name: 'Livorno, Toscana',
        code: 'LI',
        selected: true
      },
      {
        name: 'Pisa, Toscana',
        code: 'PI',
        selected: true
      },
      {
        name: 'Arezzo, Toscana',
        code: 'AR',
        selected: true
      },
      {
        name: 'Siena, Toscana',
        code: 'SI',
        selected: true
      },
      {
        name: 'Grosseto, Toscana',
        code: 'GR',
        selected: true
      },
      {
        name: 'Prato, Toscana',
        code: 'PO',
        selected: true
      },
      {
        name: 'Perugia, Umbria',
        code: 'PG',
        selected: true
      },
      {
        name: 'Terni, Umbria',
        code: 'TR',
        selected: true
      },
      {
        name: 'Pesaro e Urbino, Marche',
        code: 'PS',
        selected: true
      },
      {
        name: 'Ancona, Marche',
        code: 'AN',
        selected: true
      },
      {
        name: 'Macerata, Marche',
        code: 'MC',
        selected: true
      },
      {
        name: 'Ascoli Piceno, Marche',
        code: 'AP',
        selected: true
      },
      {
        name: 'Viterbo, Lazio',
        code: 'VT',
        selected: true
      },
      {
        name: 'Rieti, Lazio',
        code: 'RI',
        selected: true
      },
      {
        name: 'Roma, Lazio',
        code: 'RM',
        selected: true
      },
      {
        name: 'Latina, Lazio',
        code: 'LT',
        selected: true
      },
      {
        name: 'Frosinone, Lazio',
        code: 'FR',
        selected: true
      },
      {
        name: "L'Aquila, Abruzzo",
        code: 'AQ',
        selected: true
      },
      {
        name: 'Teramo, Abruzzo',
        code: 'TE',
        selected: true
      },
      {
        name: 'Pescara, Abruzzo',
        code: 'PE',
        selected: true
      },
      {
        name: 'Chieti, Abruzzo',
        code: 'CH',
        selected: true
      },
      {
        name: 'Campobasso, Molise',
        code: 'CB',
        selected: true
      },
      {
        name: 'Isernia, Molise',
        code: 'IS',
        selected: true
      },
      {
        name: 'Caserta, Campania',
        code: 'CE',
        selected: true
      },
      {
        name: 'Benevento, Campania',
        code: 'BN',
        selected: true
      },
      {
        name: 'Napoli, Campania',
        code: 'NA',
        selected: true
      },
      {
        name: 'Avellino, Campania',
        code: 'AV',
        selected: true
      },
      {
        name: 'Salerno, Campania',
        code: 'SA',
        selected: true
      },
      {
        name: 'Foggia, Puglia',
        code: 'FG',
        selected: true
      },
      {
        name: 'Bari, Puglia',
        code: 'BA',
        selected: true
      },
      {
        name: 'Taranto, Puglia',
        code: 'TA',
        selected: true
      },
      {
        name: 'Brindisi, Puglia',
        code: 'BR',
        selected: true
      },
      {
        name: 'Lecce, Puglia',
        code: 'LE',
        selected: true
      },
      {
        name: 'Potenza, Basilicata',
        code: 'PZ',
        selected: true
      },
      {
        name: 'Matera, Basilicata',
        code: 'MT',
        selected: true
      },
      {
        name: 'Cosenza, Calabria',
        code: 'CS',
        selected: true
      },
      {
        name: 'Catanzaro, Calabria',
        code: 'CZ',
        selected: true
      },
      {
        name: 'Reggio di Calabria, Calabria',
        code: 'RC',
        selected: true
      },
      {
        name: 'Crotone, Calabria',
        code: 'KR',
        selected: true
      },
      {
        name: 'Vibo Valentia, Calabria',
        code: 'VV',
        selected: true
      },
      {
        name: 'Trapani, Sicilia',
        code: 'TP',
        selected: true
      },
      {
        name: 'Palermo, Sicilia',
        code: 'PA',
        selected: true
      },
      {
        name: 'Messina, Sicilia',
        code: 'ME',
        selected: true
      },
      {
        name: 'Agrigento, Sicilia',
        code: 'AG',
        selected: true
      },
      {
        name: 'Caltanissetta, Sicilia',
        code: 'CL',
        selected: true
      },
      {
        name: 'Enna, Sicilia',
        code: 'EN',
        selected: true
      },
      {
        name: 'Catania, Sicilia',
        code: 'CT',
        selected: true
      },
      {
        name: 'Ragusa, Sicilia',
        code: 'RG',
        selected: true
      },
      {
        name: 'Siracusa, Sicilia',
        code: 'SR',
        selected: true
      },
      {
        name: 'Sassari, Sardegna',
        code: 'SS',
        selected: true
      },
      {
        name: 'Nuoro, Sardegna',
        code: 'NU',
        selected: true
      },
      {
        name: 'Cagliari, Sardegna',
        code: 'CA',
        selected: true
      },
      {
        name: 'Oristano, Sardegna',
        code: 'OR',
        selected: true
      },
    ]);
})();

angular.module('busrapidoAppWeb').run(['$templateCache', function($templateCache) {$templateCache.put('app/components/complete/complete.html','<div></div>');
$templateCache.put('app/components/alert/alert.modal.html','<div class="modal"><div class="modal-dialog"><div class="close" data-ng-click="alert.closeIt(-1)" data-ng-show="alert.modal.cross"><i class="icon icon-cancel"></i></div><h3 class="top-title" data-ng-bind-html="alert.modal.title"></h3><p class="message" data-ng-bind-html="alert.modal.msg"></p><div class="row"><div class="col-xs" data-ng-if="alert.modal.cancel"><button class="btn btn-md btn-toactive" data-ng-click="alert.closeIt(0)" data-ng-bind-html="alert.modal.cancel"></button></div><div class="col-xs" data-ng-if="alert.modal.confirm"><button class="btn btn-md btn-primary" data-ng-click="alert.closeIt(1)" data-ng-bind-html="alert.modal.confirm"></button></div></div></div></div>');
$templateCache.put('app/components/cookielaw/cookielaw.html','<div class="cookielaw" data-ng-if="!cookieLawStatus"><p><i class="icon icon-cookie"></i> Continuando a navigare in questo sito, acconsenti all\'uso dei <a href="{{$users}}/it/termini-condizioni/privacy/"><u>cookie</u></a>.</p><button type="button" class="close" data-ng-click="cookielaw.setCookielaw()"><i class="icon icon-cancel"></i></button></div>');
$templateCache.put('app/components/datetimepicker/datetimepicker.html','<div class="datetimepicker row"><div class="col-md-6 col-xs-8"><data-br-datepicker class="picker-date" data-br-label="{{datetimepicker.labelDatepicker}}" data-br-label-bottom="{{datetimepicker.labelBottomDatepicker}}" data-br-placeholder="{{datetimepicker.placeholderDatepicker}}" data-br-info="{{datetimepicker.infoDatepicker}}" data-br-disabled="datetimepicker.disabled" data-br-min-date="datetimepicker.minDate" data-br-max-date="datetimepicker.maxDate" data-br-model="datetimepicker.modelDatepicker" data-br-change="datetimepicker.onDateChange()"></data-br-datepicker></div><div class="col-md-6 col-xs-4"><data-br-timepicker class="picker-time" data-br-label="{{datetimepicker.labelTimepicker}}" data-br-label-bottom="{{datetimepicker.labelBottomTimepicker}}" data-br-placeholder="{{datetimepicker.placeholderTimepicker}}" data-br-info="{{datetimepicker.infoTimepicker}}" data-br-disabled="datetimepicker.disabled" data-br-ref-date="datetimepicker.modelDatepicker" data-br-min-date="datetimepicker.minDate" data-br-max-date="datetimepicker.maxDate" data-br-model="datetimepicker.modelTimepicker" data-br-change="datetimepicker.onTimeChange()"></data-br-timepicker></div></div>');
$templateCache.put('app/components/datepicker/datepicker-template.html','<div data-ng-switch="view"><div class="date" data-ng-switch-when="date"><table><thead><tr><th class="prev"><span data-ng-click="prev()">\u2039</span></th><th colspan="5" class="switch"><span data-ng-bind="date|mFormat:\'MMMM YYYY\':tz" data-ng-click="setView(\'month\')"></span></th><th class="next"><span data-ng-click="next()">\u203A</span></th></tr><tr><th class="weekday" style="overflow: hidden" data-ng-repeat="day in weekdays"><span data-ng-bind="day|mFormat:\'ddd\':tz"></span></th></tr></thead><tbody><tr data-ng-repeat="week in weeks" data-ng-init="$index2 = $index"><td data-ng-repeat="day in week"><span data-ng-class="classes[$index2][$index]" data-ng-click="selectDate(day)" data-ng-bind="day|mFormat:\'DD\':tz"></span></td></tr></tbody></table></div><div class="year" data-ng-switch-when="year"><table><thead><tr><th class="prev"><span data-ng-click="prev(10)">\u2039</span></th><th colspan="5" class="switch"><span data-ng-bind="years[0].year()+\' - \'+years[years.length-1].year()"></span></th><th class="next"><span data-ng-click="next(10)">\u203A</span></th></tr></thead><tbody><tr><td colspan="7"><span data-ng-class="classes[$index]" data-ng-repeat="year in years" data-ng-click="selectDate(year)" data-ng-bind="year.year()"></span></td></tr></tbody></table></div><div class="month" data-ng-switch-when="month"><table><thead><tr><th class="prev"><span data-ng-click="prev()">\u2039</span></th><th colspan="5" class="switch"><span data-ng-click="setView(\'year\')" data-ng-bind="date|mFormat:\'YYYY\':tz"></span></th><th class="next"><span data-ng-click="next()">\u203A</span></th></tr></thead><tbody><tr><td colspan="7"><span data-ng-repeat="month in months" data-ng-class="classes[$index]" data-ng-click="selectDate(month)" data-ng-bind="month|mFormat:\'MMM\':tz"></span></td></tr></tbody></table></div><div class="hours" data-ng-switch-when="hours"><table><thead><tr><th class="prev"><span data-ng-click="prev(24)">\u2039</span></th><th colspan="5" class="switch"><span data-ng-click="setView(\'date\')" data-ng-bind="date|mFormat:\'DD MMMM YYYY\':tz"></span></th><th class="next"><span data-ng-click="next(24)">\u203A</span></th></tr></thead><tbody><tr><td colspan="7"><span data-ng-repeat="hour in hours" data-ng-class="classes[$index]" data-ng-click="selectDate(hour)" data-ng-bind="hour|mFormat:\'HH:mm\':tz"></span></td></tr></tbody></table></div><div class="mintes" data-ng-switch-when="minutes"><table><thead><tr><th><span data-ng-click="prev()">\u2039</span></th><th colspan="5" class="switch"><span data-ng-click="setView(\'hours\')" data-ng-bind="date|mFormat:\'DD MMMM YYYY\':tz"></span></th><th><span data-ng-click="next()">\u203A</span></th></tr></thead><tbody><tr><td colspan="7"><span data-ng-repeat="minute in minutes" data-ng-class="classes[$index]" data-ng-click="selectDate(minute)" data-ng-bind="minute|mFormat:\'HH:mm\':tz"></span></td></tr></tbody></table></div></div>');
$templateCache.put('app/components/datepicker/datepicker.html','<div class="datepicker"><label><div class="top"><span class="label" data-ng-bind-html="datepicker.label"></span> <span class="info icon icon-info" tooltips="" tooltip-template="{{datepicker.info}}" tooltip-side="right" data-ng-if="datepicker.info"></span></div><input tabindex="1" type="text" readonly="readonly" data-date-time="" data-view="date" data-min-view="date" data-max-view="year" data-min-date="datepicker.minDateM" data-max-date="datepicker.maxDateM" data-format="ddd D MMM YYYY" data-auto-close="true" data-watch-direct-changes="true" data-ng-attr-id="{{datepicker.id}}" data-ng-attr-placeholder="{{::datepicker.placeholder}}" data-ng-model="datepicker.selected"></label><div class="bottom" data-ng-if="datepicker.labelBottom"><i class="icon icon-clock"></i><span data-ng-bind-html="datepicker.labelBottom"></span></div></div>');
$templateCache.put('app/components/dropdown/dropdown.html','<div class="br-dropdown container" data-ng-class="{\'br-dropdown-open\': dropdown.open, \'br-dropdown-close\': !dropdown.open}"><div class="whiteframe-container br-no-margin"><div class="whiteframe"><div class="header"><h4>{{dropdown.filter.field | field}}</h4></div><div class="content"><div data-ng-switch="dropdown.dataType"><div data-ng-switch-when="time"><div class="content" data-ng-click="dropdown.sortAsc()"><p>Ordina dalle 00:00 alle 23:59</p></div><div class="content" data-ng-click="dropdown.sortDesc()"><p>Ordina dalle 23:59 alle 00:00</p></div></div><div data-ng-switch-when="date"><div class="content" data-ng-click="dropdown.sortDesc()"><p>Ordina dal pi\xF9 recente al pi\xF9 meno recente</p></div><div class="content" data-ng-click="dropdown.sortAsc()"><p>Ordina dal meno recente al pi\xF9 recente</p></div></div><div data-ng-switch-when="number"><div class="content" data-ng-click="dropdown.sortAsc()"><p>Ordina in senso crescente</p></div><div class="content" data-ng-click="dropdown.sortDesc()"><p>Ordina in senso decrescente</p></div></div><div data-ng-switch-default=""><div class="content" data-ng-click="dropdown.sortAsc()"><p>Ordina A \u27F6 Z</p></div><div class="content" data-ng-click="dropdown.sortDesc()"><p>Ordina Z \u27F6 A</p></div></div></div><div class="content" data-ng-if="dropdown.filterType === \'between\'" data-ng-switch="dropdown.dataType"><div data-ng-switch-when="date"><div class="col-xs">Filtra per {{dropdown.filter.field | field}}</div><div class="col-xs"><data-br-datepicker data-br-label="Mostra successivi al" data-br-model="dropdown.filter.min"></data-br-datepicker></div><div class="col-xs"><data-br-datepicker data-br-label="Mostra precedenti al" data-br-model="dropdown.filter.max"></data-br-datepicker></div></div><div class="form-row" data-ng-switch-when="number"><div class="row"><div class="col-xs type">Filtra per {{dropdown.filter.field | field}}</div><div class="col-xs"><label><div class="top"><span class="label">Maggiore di</span></div><input type="number" data-ng-model="dropdown.filter.min"></label></div><div class="col-xs"><label><div class="top"><span class="label">Minore di</span></div><input type="number" data-ng-model="dropdown.filter.max"></label></div></div></div><div data-ng-switch-when="time"><div class="row"><div class="col-xs">Filtra per {{dropdown.filter.field | field}}</div><div class="col-xs"><label><div class="top"><span class="label">Dalle ore</span></div><select data-ng-model="dropdown.filter.min"><option data-ng-value="time" data-ng-repeat="time in filter.values">{{time}}:00</option></select></label></div><div class="col-xs"><label><div class="top"><span class="label">Alle ore</span></div><select data-ng-model="dropdown.filter.max"><option data-ng-value="time" data-ng-repeat="time in filter.values">{{time}}:00</option></select></label></div></div></div></div><div class="content" data-ng-if="dropdown.filterType === \'belongs\'"><label><div class="top"><span>Filtra per {{dropdown.filter.field | field}}</span></div><div style="display: inline;" max-labels="6" class="col-xs-8" isteven-multi-select="" input-model="dropdown.filter.values" output-model="dropdown.filter.value" button-label="code" item-label="name" tick-property="selected" group-property="msGroup" translation="dropdown.lang" max-height="200px" on-close="dropdown.onClose()"></div></label></div><div class="row br-no-margin"><button class="btn btn-green btn-md col-xs" data-ng-click="dropdown.apply(dropdown.filter)">Applica filtro</button> <button class="btn btn-primary btn-md col-xs" data-ng-click="dropdown.open = false">Annulla</button></div></div></div></div></div>');
$templateCache.put('app/components/filter-save/filter.modal.html','<div class="modal filter-save"><div class="modal-dialog"><div class="close" data-ng-click="filter.closeIt(-1)" data-ng-show="filter.modal.cross"><i class="icon icon-cancel"></i></div><div class="container"><div class="row"><div class="col-xs-12"><div class="whiteframe-container"><div class="whiteframe"><div class="header"><h4 data-ng-bind-html="filter.modal.title"></h4></div><div class="content"><label><div class="top"><span class="label">Scegli un filtro salvato</span></div><select data-ng-model="filter.modal.filters.currentFilter"><option data-ng-value="option" data-ng-repeat="option in filter.modal.filters.options">{{option.name}}</option></select></label></div><div class="content"><label><div class="top"><span class="label">Scegli un nome</span></div><input type="text" data-ng-model="filter.modal.filters.currentFilter.name"></label><div data-ng-repeat="option in filter.modal.filters.currentFilter.belongs"><div class="row"><div class="col-xs">{{option.field | field}}</div><div style="display: inline;" max-labels="6" class="col-xs-8" isteven-multi-select="" input-model="option.values" output-model="option.value" button-label="code" item-label="name" tick-property="selected" group-property="msGroup" translation="filter.lang" max-height="200px" on-close="col.colDef.data.onClose()"></div></div></div><div class="filter-list" data-ng-repeat="option in filter.modal.filters.currentFilter.between"><div data-ng-switch="option.type"><div data-ng-switch-when="date"><div class="row"><div class="col-xs">{{option.field | field}}</div><div class="col-xs"><data-br-datepicker data-br-label="Dal" data-br-model="option.min"></data-br-datepicker></div><div class="col-xs"><data-br-datepicker data-br-label="Al" data-br-model="option.max"></data-br-datepicker></div></div></div><div data-ng-switch-when="number"><div class="row"><div class="col-xs">{{option.field | field}}</div><div class="col-xs"><label><div class="top"><span class="label">Maggiore di</span></div><input type="number" data-ng-model="option.min"></label></div><div class="col-xs"><label><div class="top"><span class="label">Minore di</span></div><input type="number" data-ng-model="option.max"></label></div></div></div><div data-ng-switch-when="time"><div class="row"><div class="col-xs">{{option.field | field}}</div><div class="col-xs"><label><div class="top"><span class="label">Dalle ore</span></div><select data-ng-model="option.min"><option data-ng-value="time" data-ng-repeat="time in filter.times">{{time}}:00</option></select></label></div><div class="col-xs"><label><div class="top"><span class="label">Alle ore</span></div><select data-ng-model="option.max"><option data-ng-value="time" data-ng-repeat="time in filter.times">{{time}}:00</option></select></label></div></div></div></div></div><div data-ng-repeat="option in filter.modal.filters.currentFilter.equals"><div class="row"><div class="col-xs">{{option.field | field}}</div><div class="col-xs"><label><select data-ng-model="option.value"><option value="val" data-ng-repeat="val in option.values">{{val}}</option></select></label></div></div></div></div></div></div></div></div></div><div class="row"><div class="col-xs"><button class="btn btn-md btn-primary" data-ng-click="filter.closeIt({filter: filter.modal.filters.currentFilter, action: \'apply\'})">Applica filtro</button></div><div class="col-xs"><button class="btn btn-md btn-primary" data-ng-click="filter.closeIt({filter: filter.modal.filters.currentFilter, action: \'save\'})">Salva questo filtro online</button></div></div></div></div>');
$templateCache.put('app/components/header-filter/generic.html','<div data-ng-class="{ \'sortable\': sortable }"><div class="ui-grid-cell-contents" col-index="renderIndex" title="TOOLTIP"><span class="header-icon icon" tooltips="" tooltip-template="{{col.colDef.name}}" tooltip-append-to-body="true" tooltip-side="bottom" tooltip-size="large" data-ng-if="col.colDef.data.icon" data-ng-class="col.colDef.data.icon"></span> <span data-ng-show="!col.colDef.data.icon">{{col.displayName CUSTOM_FILTERS }}</span><data-br-dropdown data-br-open="col.colDef.data.show" data-br-field="col.colDef.data.field" data-br-col="col" data-br-sort-asc="col.sort" data-br-sort-desc="col.sort" data-br-filter-data="col.colDef.data.filterData" data-br-filter-type="col.colDef.data.filterType" data-br-name-filter="col.colDef.data.nameFilter" data-br-on-apply="col.colDef.data.onApply" data-br-data-type="col.colDef.data.dataType"></data-br-dropdown><span data-ui-grid-visible="col.sort.direction" data-ng-class="{ \'ui-grid-icon-up-dir\': col.sort.direction == asc, \'ui-grid-icon-down-dir\': col.sort.direction == desc, \'ui-grid-icon-blank\': !col.sort.direction }">\xA0</span></div><div class="ui-grid-column-menu-button" data-ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"><span style="position: absolute; right: 1px; margin-top: 4px" class="multiSelect"><span style="position:relative; padding: 8px" class="caret" data-ng-click="$event.stopPropagation(); col.colDef.data.show = !col.colDef.data.show;"></span></span></div></div>');
$templateCache.put('app/components/htrip/htrip.html','<div class="horizontal-trip-steps" drag-scroll="true" data-ng-if="htrip.steps.length > 1"><ul><li><div class="horizontal-trip-steps-timeline" data-ng-class="{\'warehouse\' : htrip.steps[0].warehouse || htrip.steps[1].warehouse}"><div class="horizontal-trip-steps-from"><div class="horizontal-trip-steps-top">{{htrip.steps[0].place.address | city}}</div><div class="horizontal-trip-steps-dot" data-ng-class="{\'warehouse\' : htrip.steps[0].warehouse}"></div><div class="horizontal-trip-steps-bottom">{{htrip.steps[0].depart | dates}}</div></div><div class="horizontal-trip-steps-info"><div class="horizontal-trip-steps-top">{{htrip.legs[0].directions.total.distance | distance}}</div><div class="horizontal-trip-steps-bottom">{{1*htrip.legs[0].directions.total.duration | duration : \'seconds\'}}</div></div><div class="horizontal-trip-steps-to"><div class="horizontal-trip-steps-top">{{htrip.steps[1].place.address | city}}</div><div class="horizontal-trip-steps-dot" data-ng-class="{\'warehouse\' : htrip.steps[0].warehouse || htrip.steps[1].warehouse}"></div><div class="horizontal-trip-steps-bottom">{{htrip.steps[1].arrive | dates : htrip.steps[0].depart}}</div></div></div><div class="horizontal-trip-steps-timeline layover" data-ng-if="htrip.steps.length > 2"><div class="horizontal-trip-steps-info"><div class="horizontal-trip-steps-top">Sosta <i class="icon icon-clock"></i> {{1*htrip.steps[1].layover | duration : \'seconds\'}}</div><div class="horizontal-trip-steps-bottom" data-ng-if="htrip.steps[1].keep && (!htrip.steps[0].warehouse && !htrip.steps[1].warehouse && !htrip.steps[2].warehouse)">con pullman in loco</div><div class="horizontal-trip-steps-bottom" data-ng-if="!htrip.steps[1].keep && (!htrip.steps[0].warehouse && !htrip.steps[1].warehouse && !htrip.steps[2].warehouse)">in loco senza pullman</div><div class="horizontal-trip-steps-bottom" data-ng-if="htrip.steps[1].warehouse">in deposito</div><div class="horizontal-trip-steps-bottom" data-ng-if="!htrip.steps[1].warehouse && htrip.steps[0].warehouse">carico</div><div class="horizontal-trip-steps-bottom" data-ng-if="!htrip.steps[1].warehouse && htrip.steps[2].warehouse">scarico</div></div></div></li><li data-ng-repeat="step in htrip.steps" data-ng-if="htrip.steps.length > 2 && $index > 0 && $index < htrip.steps.length-2"><div class="horizontal-trip-steps-timeline" data-ng-class="{\'warehouse\' : htrip.steps[$index].warehouse || htrip.steps[$index+1].warehouse}"><div class="horizontal-trip-steps-from"><div class="horizontal-trip-steps-top">{{htrip.steps[$index].place.address | city}}</div><div class="horizontal-trip-steps-dot" data-ng-class="{\'warehouse\' : htrip.steps[$index].warehouse || htrip.steps[$index+1].warehouse}"></div><div class="horizontal-trip-steps-bottom">{{htrip.steps[$index].depart | dates : htrip.steps[$index].arrive}}</div></div><div class="horizontal-trip-steps-info"><div class="horizontal-trip-steps-top">{{htrip.legs[$index].directions.total.distance | distance}}</div><div class="horizontal-trip-steps-bottom">{{1*htrip.legs[$index].directions.total.duration | duration : \'seconds\'}}</div></div><div class="horizontal-trip-steps-to"><div class="horizontal-trip-steps-top">{{htrip.steps[$index+1].place.address | city}}</div><div class="horizontal-trip-steps-dot" data-ng-class="{\'warehouse\' : htrip.steps[$index].warehouse || htrip.steps[$index+1].warehouse}"></div><div class="horizontal-trip-steps-bottom">{{htrip.steps[$index+1].arrive | dates : htrip.steps[$index].depart}}</div></div></div><div class="horizontal-trip-steps-timeline layover"><div class="horizontal-trip-steps-info"><div class="horizontal-trip-steps-top">Sosta <i class="icon icon-clock"></i> {{1*htrip.steps[$index+1].layover | duration : \'seconds\'}}</div><div class="horizontal-trip-steps-bottom" data-ng-if="htrip.steps[$index].keep && (!htrip.steps[$index].warehouse && !htrip.steps[$index+1].warehouse && !htrip.steps[$index+2].warehouse)">con pullman in loco</div><div class="horizontal-trip-steps-bottom" data-ng-if="!htrip.steps[$index].keep && (!htrip.steps[$index].warehouse && !htrip.steps[$index+1].warehouse && !htrip.steps[$index+2].warehouse)">in loco senza pullman</div><div class="horizontal-trip-steps-bottom" data-ng-if="htrip.steps[$index+1].warehouse">in deposito</div><div class="horizontal-trip-steps-bottom" data-ng-if="!htrip.steps[$index+1].warehouse && htrip.steps[$index].warehouse">carico</div><div class="horizontal-trip-steps-bottom" data-ng-if="!htrip.steps[$index+1].warehouse && htrip.steps[$index+2].warehouse">scarico</div></div></div></li><li data-ng-if="htrip.steps.length > 2"><div class="horizontal-trip-steps-timeline" data-ng-class="{\'warehouse\' : htrip.steps[htrip.steps.length-2].warehouse || htrip.steps[htrip.steps.length-1].warehouse}"><div class="horizontal-trip-steps-from"><div class="horizontal-trip-steps-top">{{htrip.steps[htrip.steps.length-2].place.address | city}}</div><div class="horizontal-trip-steps-dot" data-ng-class="{\'warehouse\' : htrip.steps[htrip.steps.length-2].warehouse || htrip.steps[htrip.steps.length-1].warehouse}"></div><div class="horizontal-trip-steps-bottom">{{htrip.steps[htrip.steps.length-2].depart | dates : htrip.steps[htrip.steps.length-2].arrive}}</div></div><div class="horizontal-trip-steps-info"><div class="horizontal-trip-steps-top">{{htrip.legs[htrip.steps.length-2].directions.total.distance | distance}}</div><div class="horizontal-trip-steps-bottom">{{1*htrip.legs[htrip.steps.length-2].directions.total.duration | duration : \'seconds\'}}</div></div><div class="horizontal-trip-steps-to"><div class="horizontal-trip-steps-top">{{htrip.steps[htrip.steps.length-1].place.address | city}}</div><div class="horizontal-trip-steps-dot" data-ng-class="{\'warehouse\' : htrip.steps[htrip.steps.length-1].warehouse}"></div><div class="horizontal-trip-steps-bottom">{{htrip.steps[htrip.steps.length-1].arrive | dates : htrip.steps[htrip.steps.length-2].depart}}</div></div></div></li></ul></div>');
$templateCache.put('app/components/maps/maps.html','<data-ui-gmap-google-map data-center="maps.center" data-control="maps.control" data-zoom="maps.zoom" data-options="maps.options" data-dragging="false" data-pan="true" data-bounds="maps.bounds"></data-ui-gmap-google-map>');
$templateCache.put('app/components/markers/markers.html','<data-ui-gmap-google-map data-center="markers.center" data-zoom="markers.zoom" data-draggable="false" data-options="markers.options" data-bounds="markers.bounds"><data-ui-gmap-markers data-models="markers.locations" data-coords="\'self\'" data-fit="true"></data-ui-gmap-markers></data-ui-gmap-google-map>');
$templateCache.put('app/components/menu/menu.html','<div class="br-menu container" data-ng-class="{\'br-menu-open\': menu.open, \'br-menu-close\': !menu.open}"><div class="whiteframe-container br-no-margin"><div class="whiteframe"><div class="content"><ul><li data-ng-repeat="item in menu.items"><a target="_blank" rel="noreferrer" data-ng-href="{{item.link}}">{{item.text}}</a></li></ul></div></div></div></div>');
$templateCache.put('app/components/password/password.html','<span class="password-toggle icon icon-eye-off" data-ng-mousedown="mouseDown()" data-ng-mouseup="mouseUp()" data-ng-show="visible"></span>');
$templateCache.put('app/components/place-filter/place.html','<div style="padding: 5px"><span class="ui-grid-header-cell-label ng-binding" data-ui-grid-one-bind-id-grid="col.uid + \'-header-text\'">{{col.colDef.data.label}}</span> <span style="position: absolute;right:1px"><div style="display: inline;" max-labels="-1" isteven-multi-select="" input-model="col.colDef.data.input" output-model="col.colDef.data.output.selected" button-label="" item-label="name maker" tick-property="ticked" group-property="msGroup" translation="col.colDef.data.lang" max-height="200px" on-close="col.colDef.data.onClose()" on-item-click="col.colDef.data.onClose()"></div></span></div>');
$templateCache.put('app/components/placepicker-fast/placepicker.html','<div class="placepicker row"><div class="col-xs-12"><label><div class="top"><span class="label" data-ng-bind-html="placepicker.label"></span> <span class="info icon icon-info" tooltips="" tooltip-template="{{placepicker.info}}" tooltip-side="bottom" data-ng-if="placepicker.info"></span></div><input tabindex="1" type="text" data-ng-model="placepicker.selected" data-ng-attr-placeholder="{{placepicker.placeholder}}" data-ng-disabled="placepicker.disabled || !placepicker.loaded"> <span data-ng-if="!placepicker.loaded"><span class="loading-filed icon icon-spin animate-spin"></span></span> <span data-ng-click="placepicker.showStreetView()"><span class="loading-filed icon icon-eye"></span></span></label><div class="bottom" data-ng-if="placepicker.labelBottom"><i class="icon icon-calendar"></i><span data-ng-bind-html="placepicker.labelBottom"></span></div></div></div>');
$templateCache.put('app/components/placepicker/placepicker.html','<div class="placepicker row"><div class="col-xs-12"><label><div class="top"><span class="label" data-ng-bind-html="placepicker.label"></span> <span class="info icon icon-info" tooltips="" tooltip-template="{{placepicker.info}}" tooltip-side="bottom" data-ng-if="placepicker.info"></span></div><input type="text" data-ng-model="placepicker.selected" data-ng-attr-placeholder="{{placepicker.placeholder}}" data-ng-disabled="placepicker.disabled || !placepicker.loaded"> <span data-ng-if="!placepicker.loaded"><span class="loading-filed icon icon-spin animate-spin"></span></span></label><div class="bottom" data-ng-if="placepicker.labelBottom"><i class="icon icon-calendar"></i><span data-ng-bind-html="placepicker.labelBottom"></span></div></div></div>');
$templateCache.put('app/components/placepicker-nice/placepicker.html','<div class="placepicker-slim"><input class="form-control form-control-sm input-sm" type="text" required data-ng-model="placepicker.selected" data-ng-attr-placeholder="{{placepicker.placeholder}}" data-ng-disabled="placepicker.disabled || !placepicker.loaded"> <span data-ng-if="!placepicker.loaded"><span class="load ing-filed icon icon-spin animate-spin"></span></span></div>');
$templateCache.put('app/components/placepicker-slim/placepicker.html','<div class="placepicker-slim"><input class="form-control form-control-sm input-sm" type="text" required data-ng-model="placepicker.selected" data-ng-attr-placeholder="{{placepicker.placeholder}}" data-ng-disabled="placepicker.disabled || !placepicker.loaded"><div class="invalid-feedback">Inserisci l\'indirizzo della sede</div><span data-ng-if="!placepicker.loaded"><span class="load ing-filed icon icon-spin animate-spin"></span></span></div>');
$templateCache.put('app/components/quote-details/quote-details.html','<div class="row quote-details" id="request"><div class="whiteframe-container whiteframe print-only"><div class="header"><h4>NUMERO PRENOTAZIONE {{details.quote.Quote.id | quoteId}}</h4></div></div><div class="col-xs-12 col-md-8"><div class="whiteframe-container" id="itinerary"><div class="whiteframe"><div class="header"><div class="row"><h4>{{details.prefix}} Itinerario cliente</h4><div class="content-float col-xs"><div class="right"><div><button tooltips="" tooltip-template="{{details.copyText}}" class="btn btn-md btn-primary" ngclipboard="" ngclipboard-success="details.copy()" data-clipboard-text="{{details.text}}"><span class="icon icon-docs"></span> Copia</button> <button class="btn btn-md btn-primary" data-ng-click="details.save()"><span class="icon icon-download"></span> Download</button> <button class="btn btn-md btn-primary" data-ng-click="details.print()"><span class="icon icon-print"></span> Stampa</button></div></div></div></div></div><div class="content"><span class="left">Tipologia servizio <span class="tag tag-sm">{{details.quote.Quote.service_type}}</span> </span><span class="left">Numero passeggeri <span class="tag tag-sm">{{details.quote.Quote.onboard.passengers}}</span></span></div><data-br-quote-details-classic data-br-trip="details.quote.Quote.trip" data-ng-if="details.quote.Quote.view === \'classic\'"></data-br-quote-details-classic><data-br-quote-details-tour data-br-trip="details.quote.Quote.trip" data-ng-if="details.quote.Quote.view === \'tour\'"></data-br-quote-details-tour><data-br-quote-details-new data-br-trip="details.quote.Quote.requests" data-br-service-type="details.quote.Quote.service_type" data-br-data="details.quote.Quote" data-ng-if="details.quote.Quote.view === \'new\'"></data-br-quote-details-new><div class="content" data-ng-if="details.quote.Quote.details && details.quote.Quote.details.length > 0"><h4>{{details.prefix}} Informazioni aggiuntive</h4><br><p>{{details.quote.Quote.details}}</p></div></div><div class="whiteframe noprint" data-ng-if="details.quote.Quote.requests && details.quote.Quote.requests.length > 0"><div class="header"><div class="row"><h4>{{details.prefix}} Itinerario grafico</h4><div class="content-float col-xs"><div class="right"><div><button class="btn btn-md btn-primary" data-ng-click="details.open = !details.open"><span class="icon icon-eye"></span> Visualizza su google maps<data-br-menu data-br-open="details.open" data-br-items="details.items"></data-br-menu></button></div></div></div></div></div><div class="row"><div class="col-xs-12 col-md-6"><data-br-request data-br-requests="details.quote.Quote.requests"></data-br-request></div><div class="col-xs-12 col-md-6"><data-br-maps data-br-waypoints="details.quote.Quote.trip.steps" data-br-object="place.location"></data-br-maps></div></div></div><div class="whiteframe"><div class="header"><h4>{{details.prefix}} Standard da rispettare</h4></div><div class="content content-services-text row"><div class="col-md-7"><div class="content-line content-float"><p class="left specs-label">MASSIMALE ASSICURATIVO MINIMO</p><p class="tag right tag-narrow">{{details.quote.Quote.insurance | insurance}}</p></div></div><div class="col-md-5"><div class="content-line content-float"><p class="left specs-label">MINIMO CLASSE</p><p class="tag right tag-narrow">{{details.quote.Quote.vehicle.specs.emissionClass || "EUR2"}}</p></div></div><div class="col-md-7"><div class="content-line content-float"><p class="left specs-label">ANNO MINIMO DI IMMATRICOLAZIONE</p><p class="tag right tag-narrow">{{details.quote.Quote.vehicle.specs.matriculation || 2012}}</p></div></div><div class="col-md-5"><div class="content-line content-float"><p class="left specs-label">POSTI PASSEGGERO</p><p class="tag right tag-narrow">{{details.quote.Quote.vehicle.specs.seats.passengers || details.quote.Quote.onboard.passengers || 1}}</p></div></div><div class="col-md-7"><div class="content-line content-float"><p class="left specs-label">NUMERO RICHIESTO DI AUTISTI</p><p class="tag right tag-narrow">{{details.quote.Quote.onboard.drivers || 1}}</p></div></div></div><div class="content content-services-text" data-ng-if="details.hasServices()"><div class="row"><div class="col-xs-12"><p class="subtitle">MINIMI SERVIZI A BORDO</p><ul class="services-2"><li data-ng-repeat="(key, service) in details.services track by key" data-ng-class="{\'active\': details.quote.Quote.vehicle.services[key]}" data-ng-if="details.quote.Quote.vehicle.services[key]"><div class="row"><span class="icon" data-ng-class="service.icon"></span><p>{{service.name}}</p></div></li></ul></div></div></div><div class="content"><div class="row"><div class="col-xs-12"><div class="content" data-ng-if="details.quote.Quote.vehicle.specs.axis || details.quote.Quote.vehicle.specs.lengthiness || details.quote.Quote.vehicle.specs.largeness || details.quote.Quote.vehicle.specs.highness || details.quote.Quote.vehicle.specs.drivers"><br><p class="subtitle">SPECIFICHE MINIME VEICOLO</p><br><div class="col-md-6"><div class="content-line content-float" data-ng-if="details.quote.Quote.vehicle.specs.axis"><span class="left">Numero di assi</span> <span class="right">{{details.quote.Quote.vehicle.specs.axis}}</span></div><div class="content-line content-float" data-ng-if="details.quote.Quote.vehicle.specs.lengthiness"><span class="left">Lunghezza</span> <span class="right">{{details.quote.Quote.vehicle.specs.lengthiness}}</span></div><div class="content-line content-float" data-ng-if="details.quote.Quote.vehicle.specs.largeness"><span class="left">Larghezza</span> <span class="right">{{details.quote.Quote.vehicle.specs.largeness}}</span></div><div class="content-line content-float" data-ng-if="details.quote.Quote.vehicle.specs.highness"><span class="left">Altezza</span> <span class="right">{{details.quote.Quote.vehicle.specs.highness}}</span></div><div class="content-line content-float" data-ng-if="details.quote.Quote.vehicle.specs.drivers"><span class="left">Posti accompagnatore</span> <span class="right">{{details.quote.Quote.vehicle.specs.drivers}}</span></div></div></div></div></div></div><div class="content"><div class="row"><div class="col-xs-12"><div class="content" data-ng-if="(details.quote.Quote.driver_gender && details.quote.Quote.driver_gender != \'other\') || (details.quote.Quote.driver_dresscode && details.quote.Quote.driver_dresscode != \'other\') || !details.quote.Quote.driver_smoking || details.quote.Quote.driver_language || details.quote.Quote.driver_halal || details.quote.Quote.driver_other"><br><p class="subtitle">REQUISITI AUTISTA</p><br><div class="col-md-6"><div class="content-line content-float" data-ng-if="details.quote.Quote.driver_gender != \'other\'"><span class="left">Sesso</span> <span class="right">{{details.quote.Quote.driver_gender | gender}}</span></div><div class="content-line content-float" data-ng-if="details.quote.Quote.driver_dresscode != \'other\'"><span class="left">Abbigliamento/divisa</span> <span class="right">{{details.quote.Quote.driver_dresscode | dresscode}}</span></div><div class="content-line content-float" data-ng-if="details.quote.Quote.driver_smoking != true"><span class="left">Smoking policy</span> <span class="right">{{details.quote.Quote.driver_smoking | smoking}}</span></div><div class="content-line content-float" data-ng-if="details.quote.Quote.driver_language"><span class="left">Lingua</span> <span class="right">{{details.quote.Quote.driver_language}}</span></div><div class="content-line content-float" data-ng-if="details.quote.Quote.driver_halal"><span class="left">Certificazione Halal</span> <span class="right">S\xEC</span></div><div class="content-line" data-ng-if="details.quote.Quote.driver_other"><p>Altri requisiti:</p><p>{{details.quote.Quote.driver_other}}</p></div></div></div></div></div></div><div class="content"><div class="row"><div class="col-xs-12"><div class="content"><br><p class="subtitle">INCLUSO NEL PREZZO</p><br><div class="col-xs"><p>Carburante, Pedaggi Autostradali, Assicurazione RCA, Noleggio veicolo, Autisti, IVA</p></div><div class="col-xs"><p>Vitto e Alloggio degli Autisti (se necessari)</p></div><div class="col-xs"><p>Parcheggi, Checkpoint e ZTL (se necessari)</p></div><div class="col-xs"><p>Altri costi aggiuntivi (se necessari)</p></div><div class="col-xs" data-ng-repeat="cost in details.quote.Quote.costs" data-ng-if="cost.who === \'partner\'"><div class="row"><p class="col-xs">{{cost.name}}</p><p class="col-xs">{{cost.value | currency}}</p><p class="col-xs">+ {{(cost.value * cost.vat / 100) | currency}} IVA</p></div></div></div></div></div></div><div class="content" data-ng-if="details.has(\'us\')"><div class="row"><div class="col-xs-12"><div class="content"><br><p class="subtitle">A CARICO DI BUSRAPIDO</p><br><div class="col-xs" data-ng-repeat="cost in details.quote.Quote.costs" data-ng-if="cost.who === \'us\'"><div class="row"><p class="col-xs">{{cost.name}}</p><p class="col-xs">{{cost.value | currency}}</p><p class="col-xs">+ {{(cost.value * cost.vat / 100) | currency}} IVA</p></div></div></div></div></div></div><div class="content" data-ng-if="details.has(\'client\')"><div class="row"><div class="col-xs-12"><div class="content"><br><p class="subtitle">A CARICO DEL GRUPPO</p><br><div class="col-xs" data-ng-repeat="cost in details.quote.Quote.costs" data-ng-if="cost.who === \'client\'"><div class="row"><p class="col-xs">{{cost.name}}</p><p class="col-xs">{{cost.value | currency}}</p><p class="col-xs">+ {{(cost.value * cost.vat / 100) | currency}} IVA</p></div></div></div></div></div></div></div></div></div><div class="col-xs-12 col-md-4"><div class="whiteframe-container"><div class="whiteframe"><div class="header"><h4>{{details.prefix}} Dettagli ordine</h4></div><div class="row"><div class="col-xs-12"><div class="content-line content-float"><span class="left">Stato</span> <span class="right tag tag-sm" data-ng-class="{\'tag-green\':details.quote.status == \'accepted\', \'tag-yellow\':details.quote.status == \'pending\' || details.quote.status == \'viewed\', \'tag-red\':details.quote.status == \'rejected\'}">{{details.quote.status | status}}</span></div><div class="content-line content-float"><div><span class="left">Codice ordine</span></div><div><span class="right">{{details.quote.Quote.id | quoteId}}</span></div></div><div class="content-line content-float"><div><span class="left">Inizio noleggio</span></div><div><span class="right">{{details.quote.Quote.startdate | dates}}</span></div></div><div class="content-line content-float"><div><span class="left">Termine noleggio</span></div><div><span class="right">{{details.quote.Quote.enddate | dates}}</span></div></div><br><div class="content-line content-float"><div><span class="left">Totale posti passeggero</span></div><div><span class="right">{{details.quote.Quote.onboard.passengers || 0}}</span></div></div><div class="content-line content-float"><div><span class="left">Totale posti accompagnatore/guida</span></div><div><span class="right">{{details.quote.Quote.onboard.others || 0}}</span></div></div><div class="content-line content-float"><div><span class="left">Totale autisti</span></div><div><span class="right">{{details.quote.Quote.onboard.drivers || 0}}</span></div></div><div class="content-line content-float"><div><span class="left">Totale chilometri</span></div><div><span class="right">{{details.quote.Quote.total.distance | distance}}</span></div></div><div class="content-line content-float"><div><span class="left">Totale tempo in viaggio</span></div><div><span class="right">{{details.quote.Quote.total.duration | duration}}</span></div></div><br><div class="content-line content-float"><div><span class="left">Netto per il noleggio</span></div><div><span class="right">{{details.getPrice() | currency}}</span></div></div><div class="content-line content-float"><div><span class="left">IVA noleggio</span></div><div><span class="right">{{details.getPriceVat() | currency}}</span></div></div><br><div class="content-line content-float"><div><span class="left">Rimborso spese</span></div><div><span class="right">{{details.getCosts() | currency}}</span></div></div><div class="content-line content-float"><div><span class="left">IVA spese</span></div><div><span class="right">{{details.getCostsVat() | currency}}</span></div></div><br><div class="content-line content-float"><div><span class="left">Totale</span></div><div><span class="right">{{details.getTotal() | currency}}</span></div></div><br></div></div></div><div class="whiteframe" data-ng-if="details.quote.Vehicle && details.quote.vehicles.length <= 1"><div class="header"><h4>{{details.prefix}} Veicolo scelto</h4></div><article class="content-items"><div class="row no-margin"><div class="content"><div class="image-supplier col-xs-12"><data-br-slider data-br-alt="Noleggio Pullman" data-br-imgs="::details.quote.Vehicle.imgs" data-br-sizes="{width: 250, height: 150}" data-br-cloudinary="true"></data-br-slider></div><div class="col-xs re-padding-left-xs rm-padding-left-sm"><div class="row"><div class="col-xs"><div class="details"><h3>{{::details.quote.Vehicle.specs.manufacturer}} {{::details.quote.Vehicle.specs.model}} {{::details.quote.Vehicle.specs.type}}</h3><p><span class="icon icon-bus"></span> Targa: {{::details.quote.Vehicle.specs.plate}}</p><p><span class="icon icon-calendar"></span> Anno: {{::details.quote.Vehicle.specs.matriculation}} <span class="icon icon-tree"></span> {{::details.quote.Vehicle.specs.emissionClass}} - {{::details.quote.Vehicle.specs.axis}} assi</p><p><span class="icon icon-user-male"></span> Posti passeggero: {{::details.quote.Vehicle.specs.seats.passengers}}</p></div></div></div><div class="row"><div class="col-xs-12"><div class="services-20"><ul><li data-ng-repeat="(key, service) in ::details.services track by key" data-ng-class="::{\'active\': details.quote.Vehicle.services[key]}"><span class="tooltip"><span class="icon" data-ng-class="::service.icon"></span> <span class="tip">{{::service.name}}</span></span></li></ul></div></div></div></div></div></div></article></div><div class="whiteframe" data-ng-if="details.quote.vehicles.length > 1"><div class="header"><h4>{{details.prefix}} Veicoli scelti</h4></div><article class="content-items"><div class="row no-margin" data-ng-repeat="vehicle in ::details.quote.vehicles"><div class="content border-bottom"><div class="image-supplier col-xs-12"><data-br-slider data-br-alt="Noleggio Pullman" data-br-imgs="::vehicle.imgs" data-br-sizes="{width: 250, height: 150}" data-br-cloudinary="true"></data-br-slider></div><div class="col-xs re-padding-left-xs rm-padding-left-sm"><div class="row"><div class="col-xs"><div class="details"><h3>{{::vehicle.specs.manufacturer}} {{::vehicle.specs.model}} {{::vehicle.specs.type}}</h3><p><span class="icon icon-bus"></span> Targa: {{::vehicle.specs.plate}}</p><p><span class="icon icon-calendar"></span> Anno: {{::vehicle.specs.matriculation}} <span class="icon icon-tree"></span> {{::vehicle.specs.emissionClass}} - {{::vehicle.specs.axis}} assi</p><p><span class="icon icon-user-male"></span> Posti passeggero: {{::vehicle.specs.seats.passengers}}</p></div></div></div><div class="row"><div class="col-xs"><div class="services-20"><ul><li data-ng-repeat="(key, service) in ::details.services track by key" data-ng-class="::{\'active\': vehicle.services[key]}"><span class="tooltip"><span class="icon" data-ng-class="::service.icon"></span> <span class="tip">{{::service.name}}</span></span></li></ul></div></div></div></div></div></div></article></div><div class="whiteframe"><div data-ng-if="details.quote.Quote.status === \'accepted\' && details.quote.status !== \'accepted\'"><button class="btn btn-lg btn-grey btn-block">La richiesta non \xE8 pi\xF9 disponibile</button></div><div data-ng-if="details.quote.Quote.status !== \'accepted\' || details.quote.status === \'accepted\'"><div class="content" data-ng-if="details.quote.status === \'pending\' || details.quote.status === \'viewed\' || details.quote.status === \'clicked\' || details.quote.status.indexOf(\'rejected\') !== -1"><div class="foot" data-ng-if="details.quote.Quote.request_type.indexOf(\'request\') !== -1"><button class="btn btn-lg btn-green btn-block" data-ng-click="details.respond(\'accepted\')">Accetta</button></div><div class="foot" data-ng-if="details.quote.Quote.request_type.indexOf(\'other\') !== -1"><button class="btn btn-lg btn-green btn-block" data-ng-click="details.respond(\'optioned\')">Opziona veicolo</button></div><div class="foot"><button class="btn btn-sm btn-primary btn-block" data-ng-click="details.reject()" data-ng-if="details.quote.status.indexOf(\'rejected\') === -1">Rifiuta</button></div></div><div class="content" data-ng-if="details.quote.status === \'accepted\'"><div class="foot"><button class="btn btn-lg btn-green btn-block">Ordine accettato</button></div></div><div class="content" data-ng-if="details.quote.status === \'optioned\'"><div class="foot"><div class="foot"><button class="btn btn-lg btn-green btn-block">Veicolo opzionato</button></div></div></div><div class="content" data-ng-if="details.quote.status.indexOf(\'rejected\') !== -1"><div class="foot"><button class="btn btn-sm btn-grey btn-block">Ordine rifiutato</button></div></div><div class="content" data-ng-if="details.quote.status === \'optioned\'"><div class="foot"><button class="btn btn-sm btn-grey btn-block">Ordine opzionato</button></div></div></div><div data-ng-if="details.quote.Quote.status === \'voided\'"><button class="btn btn-lg btn-grey btn-block">La richiesta non \xE8 pi\xF9 disponibile</button></div></div><div class="whiteframe" data-ng-if="details.quote.Quote.attachments.length > 0"><div class="header"><h4>{{details.prefix}} Allegati</h4></div><div data-ng-repeat="attachment in details.quote.Quote.attachments"><a href="{{details.cloudinary.url(attachment.url)}}" download="{{attachment.name}}" target="_blank" rel="noopener noreferrer"><div class="content content-float"><p class="left">{{attachment.name}}</p><p class="right"><i class="icon icon-download"></i></p></div></a></div></div></div></div></div>');
$templateCache.put('app/components/request/request.html','<div class="trip-steps trip-steps-show" data-ng-if="request.requests.length > 0"><ul data-ng-repeat="request in request.requests"><li data-ng-repeat="service in request.services" data-ng-if="service.type !== \'end\'"><div class="trip-steps-timeline" data-ng-if="$index !== request.services.length - 1 && request.services[$index + 1].type !== \'end\'"></div><div class="trip-steps-dot bottom"></div><div class="trip-steps-content"><div class="row"><div class="col-xs-7"><div class="city">{{service.type | serviceType}} {{service.place.address | city}}</div></div><div class="col-xs-5"><div class="date">{{service.depart | dates}}</div></div></div><div class="row"><div class="col-xs-7"><div class="address">{{service.place.address}}</div></div></div></div></li></ul></div>');
$templateCache.put('app/components/slider/slider.html','<div class="slider"><div class="active-container" data-ng-if="::slider.link && !slider.cloudinary"><div class="thumbnail" data-ng-repeat="image in slider.imgs | filter: vm.filter($index) track by image" data-ng-show="$index == slider.current"><a target="_blank" data-ui-sref="{{::slider.link}}" data-ng-click="slider.click()"><img alt="{{::slider.alt}}" data-ng-src="{{::slider.path + image}}"></a></div><div class="arrows-container" data-ng-show="slider.imgs.length > 1"><div class="prev" data-ng-click="slider.prevImg()"></div><div class="next" data-ng-click="slider.nextImg()"></div></div></div><div class="active-container" data-ng-if="::!slider.link && !slider.cloudinary"><div class="thumbnail" data-ng-repeat="image in slider.imgs | filter: vm.filter($index) track by image" data-ng-show="$index == slider.current"><img alt="{{::slider.alt}}" data-ng-src="{{::slider.path + image}}" data-ng-click="slider.click()"></div><div class="arrows-container" data-ng-show="slider.imgs.length > 1"><div class="prev" data-ng-click="slider.prevImg()"></div><div class="next" data-ng-click="slider.nextImg()"></div></div></div><div class="active-container" data-ng-if="::slider.link && slider.cloudinary && slider.sizes"><div class="thumbnail" data-ng-repeat="image in slider.imgs | filter: vm.filter($index) track by image" data-ng-show="$index == slider.current"><a target="_blank" data-ui-sref="{{::slider.link}}" data-ng-click="slider.click()"><data-cl-image data-alt="" data-public-id="{{::image}}" data-format="jpg"><data-cl-transformation height="{{::slider.sizes.height}}" width="{{::slider.sizes.width}}" crop="fit"></data-cl-transformation></data-cl-image></a></div><div class="arrows-container" data-ng-show="slider.imgs.length > 1"><div class="prev" data-ng-click="slider.prevImg()"></div><div class="next" data-ng-click="slider.nextImg()"></div></div></div><div class="active-container" data-ng-if="::!slider.link && slider.cloudinary && slider.sizes"><div class="thumbnail" data-ng-repeat="image in slider.imgs | filter: vm.filter($index) track by image" data-ng-show="$index == slider.current"><data-cl-image data-alt="" data-public-id="{{::image}}" data-format="jpg" data-ng-click="slider.click()"><data-cl-transformation height="{{::slider.sizes.height}}" width="{{::slider.sizes.width}}" crop="fit"></data-cl-transformation></data-cl-image></div><div class="arrows-container" data-ng-show="slider.imgs.length > 1"><div class="prev" data-ng-click="slider.prevImg()"></div><div class="next" data-ng-click="slider.nextImg()"></div></div></div><div class="active-container" data-ng-if="::slider.link && slider.cloudinary && !slider.sizes"><div class="thumbnail" data-ng-repeat="image in slider.imgs | filter: vm.filter($index) track by image" data-ng-show="$index == slider.current"><a target="_blank" data-ui-sref="{{::slider.link}}" data-ng-click="slider.click()"><data-cl-image data-alt="{{::slider.alt}}" data-public-id="{{::image}}" data-format="jpg"></data-cl-image></a></div><div class="arrows-container" data-ng-show="slider.imgs.length > 1"><div class="prev" data-ng-click="slider.prevImg()"></div><div class="next" data-ng-click="slider.nextImg()"></div></div></div><div class="active-container" data-ng-if="::!slider.link && slider.cloudinary && !slider.sizes"><div class="thumbnail" data-ng-repeat="image in slider.imgs | filter: vm.filter($index) track by image" data-ng-show="$index == slider.current"><data-cl-image data-alt="{{::slider.alt}}" data-public-id="{{::image}}" data-format="jpg" data-ng-click="slider.click()"></data-cl-image></div><div class="arrows-container" data-ng-show="slider.imgs.length > 1"><div class="prev" data-ng-click="slider.prevImg()"></div><div class="next" data-ng-click="slider.nextImg()"></div></div></div><div class="thumbnails-container" data-ng-if="::slider.thumbnails && slider.cloudinary"><div class="thumbnail" data-ng-repeat="image in slider.imgs track by image" data-ng-class="{\'active\': slider.current == $index}" data-ng-click="slider.setImg($index)"><data-cl-image data-alt="{{::slider.alt}}" data-public-id="{{::image}}" data-format="jpg"><data-cl-transformation height="80" width="120" crop="thumb"></data-cl-transformation></data-cl-image></div></div><div class="thumbnails-container" data-ng-if="::slider.thumbnails && !slider.cloudinary"><div class="thumbnail" data-ng-repeat="image in slider.imgs track by image" data-ng-class="{\'active\': slider.current == $index}" data-ng-click="slider.setImg($index)"><img alt="{{::slider.alt}}" data-ng-src="{{::slider.path + image}}"></div></div></div>');
$templateCache.put('app/components/table/table.html','<div class="whiteframe-container whiteframe"><div class="content content-float"><div class="br-table"><table><thead><tr><th data-ng-repeat="column in table.columns"><a href="#" data-ng-click="table.sortBy = column.name">{{column.name}} <span class="fa fa-caret-down" data-ng-show="table.sortBy === column.name"></span></a></th></tr></thead><tbody><tr data-ng-repeat="row in table.rows"><td data-ng-repeat="column in table.columns"><button class="btn btn-md btn-outline" data-ng-if="column.type === \'button\'" data-ng-click="column.action(row)">{{row[column.key]}}</button><p data-ng-if="column.type === \'text\'">{{row[column.key]}}</p></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/components/timepicker/timepicker.html','<div class="timepicker"><label><div class="top"><span class="label" data-ng-bind-html="timepicker.label"></span> <span class="info icon icon-info" tooltips="" tooltip-template="{{timepicker.info}}" tooltip-side="left" data-ng-if="timepicker.info"></span></div><select tabindex="1" required data-ng-disabled="timepicker.disabled" data-ng-model="timepicker.selected" data-ng-change="timepicker.onSelectedChange()"><option value="" disabled="disabled" selected="selected" hidden>{{::timepicker.placeholder}}</option><option data-ng-repeat="item in timepicker.items" data-ng-attr-value="{{::item}}">{{::item}}</option></select></label><div class="bottom" data-ng-if="timepicker.labelBottom"><i class="icon icon-clock"></i><span data-ng-bind-html="timepicker.labelBottom"></span></div></div>');
$templateCache.put('app/components/trip/trip.html','<div class="trip-steps trip-steps-show" data-ng-if="trip.steps.length > 1"><ul><li><div class="trip-steps-timeline" data-ng-class="{\'warehouse\' : trip.steps[0].warehouse}"></div><div class="trip-steps-dot bottom" data-ng-class="{\'warehouse\' : trip.steps[0].warehouse}"></div><div class="trip-steps-content"><div class="row"><div class="col-xs-7"><div class="city">{{trip.steps[0].place.address | city}}</div></div><div class="col-xs-5"><div class="date">{{trip.steps[0].depart | dates}}</div></div></div><div class="row"><div class="col-xs-7"><div class="address">{{trip.steps[0].place.address}}</div></div></div></div></li><li data-ng-repeat="step in trip.steps" data-ng-if="$index > 0 && $index < trip.steps.length-1"><div class="trip-steps-timeline" data-ng-class="{\'warehouse\' : trip.steps[$index].warehouse || trip.steps[$index+1].warehouse}"></div><div class="trip-steps-dot" data-ng-class="{\'warehouse\' : trip.steps[$index].warehouse}"></div><div class="trip-steps-content"><div class="row"><div class="col-xs-7"><div class="city">{{trip.steps[$index].place.address | city}}</div></div><div class="col-xs-5"><div class="date">{{trip.steps[$index].arrive | dates : trip.steps[$index-1].depart}}<i class="icon icon-arrow-right"></i>{{trip.steps[$index].depart | dates : trip.steps[$index].arrive}}</div></div></div><div class="row"><div class="col-xs-6"><div class="address">{{trip.steps[$index].place.address}}</div></div><div class="col-xs-6"><div class="layover">Sosta<i class="icon icon-clock"></i>{{+trip.steps[$index].layover | duration : \'seconds\'}}<br><span data-ng-if="trip.steps[$index].tour && (!trip.steps[$index-1].warehouse && !trip.steps[$index].warehouse && !trip.steps[$index+1].warehouse)">giro della citt\xE0</span> <span data-ng-if="trip.steps[$index].keep && !trip.steps[$index].tour && (!trip.steps[$index-1].warehouse && !trip.steps[$index].warehouse && !trip.steps[$index+1].warehouse)">con pullman in loco</span> <span data-ng-if="!(trip.steps[$index].keep || trip.steps[$index].tour) && (!trip.steps[$index-1].warehouse && !trip.steps[$index].warehouse && !trip.steps[$index+1].warehouse)">in loco senza pullman</span> <span data-ng-if="trip.steps[$index].warehouse">in deposito</span> <span data-ng-if="trip.steps[$index-1].warehouse">carico</span> <span data-ng-if="trip.steps[$index+1].warehouse">scarico</span></div></div></div></div></li><li><div class="trip-steps-dot top" data-ng-class="{\'warehouse\' : trip.steps[trip.steps.length-1].warehouse}"></div><div class="trip-steps-content"><div class="row"><div class="col-xs-7"><div class="city">{{trip.steps[trip.steps.length-1].place.address | city}}</div></div><div class="col-xs-5"><div class="date">{{trip.steps[trip.steps.length-1].arrive | dates : trip.steps[trip.steps.length-2].place.depart}}</div></div></div><div class="row"><div class="col-xs-7"><div class="address">{{trip.steps[trip.steps.length-1].place.address}}</div></div></div></div></li></ul></div>');
$templateCache.put('app/components/uploader-directive/uploader.html','<div class="label-tag"><div class="top"><span class="label" data-ng-bind-html="uploader.label"></span> <span class="info icon icon-info" tooltips="" tooltip-template="{{uploader.info}}" tooltip-side="bottom" data-ng-if="uploader.info"></span></div><div class="uploader"><div class="thumbnails-container"><div class="thumbnail" data-ng-if="uploader.imgs" data-ng-repeat="image in uploader.imgs"><data-cl-image alt="" public-id="{{image}}" format="jpg"></data-cl-image><div class="arrows-container"><div class="prev" data-ng-click="uploader.moveImageLeft($index)" data-ng-class="{\'disabled\': $index == 0}"></div><div class="next" data-ng-click="uploader.moveImageRight($index)" data-ng-class="{\'disabled\': $index == uploader.imgs.length-1}"></div></div><span class="del icon icon-cancel" data-ng-click="uploader.removeImage($index)"></span></div><div class="thumbnail" data-ng-if="uploader.files" data-ng-repeat="file in uploader.files"><img alt="" data-ngf-thumbnail="file" data-ng-if="!uploader.picking[$index]"><div class="pick icon icon-spin animate-spin" data-ng-if="uploader.picking[$index]"></div><div class="arrows-container"><div class="prev" data-ng-click="uploader.moveFileLeft($index)" data-ng-class="{\'disabled\': $index == 0}"></div><div class="next" data-ng-click="uploader.moveFileRight($index)" data-ng-class="{\'disabled\': $index == uploader.files.length-1}"></div></div><span class="del icon icon-cancel" data-ng-click="uploader.removeFile($index)"></span></div><button type="button" class="add img icon icon-add" data-ngf-accept="\'image/*\'" data-ngf-multiple="true" data-ngf-allow-dir="true" data-ngf-pattern="\'.png,.jpg,.gif,.jpeg\'" data-ngf-select="uploader.selectFile($files)" data-ngf-max-size="16MB" data-ngf-drop="uploader.selectFile($files)" data-ngf-drag-over-class="\'dragover\'"></button> <button type="button" class="add img icon icon-add" data-ngf-accept="\'image/*\'" data-ngf-multiple="true" data-ngf-allow-dir="true" data-ngf-pattern="\'.png,.jpg,.gif,.jpeg\'" data-ngf-select="uploader.selectFile($files)" data-ngf-max-size="16MB" data-ngf-no-file-drop=""></button></div></div></div>');
$templateCache.put('app/components/uploader/uploader.html','<div class="label-tag"><div class="top"><span class="label" data-ng-bind-html="uploader.label"></span> <span class="info icon icon-info" tooltips="" tooltip-template="{{uploader.info}}" tooltip-side="bottom" data-ng-if="uploader.info"></span></div><div class="uploader"><div class="thumbnails-container"><div class="thumbnail" data-ng-if="uploader.imgs" data-ng-repeat="image in uploader.imgs"><data-cl-image alt="" public-id="{{image}}" format="jpg"></data-cl-image><div class="arrows-container"><div class="prev" data-ng-click="uploader.moveImageLeft($index)" data-ng-class="{\'disabled\': $index == 0}"></div><div class="next" data-ng-click="uploader.moveImageRight($index)" data-ng-class="{\'disabled\': $index == uploader.imgs.length-1}"></div></div><span class="del icon icon-cancel" data-ng-click="uploader.removeImage($index)"></span></div><div class="thumbnail" data-ng-if="uploader.files" data-ng-repeat="file in uploader.files"><img alt="" data-ngf-thumbnail="file" data-ng-if="!uploader.picking[$index]"><div class="pick icon icon-spin animate-spin" data-ng-if="uploader.picking[$index]"></div><div class="arrows-container"><div class="prev" data-ng-click="uploader.moveFileLeft($index)" data-ng-class="{\'disabled\': $index == 0}"></div><div class="next" data-ng-click="uploader.moveFileRight($index)" data-ng-class="{\'disabled\': $index == uploader.files.length-1}"></div></div><span class="del icon icon-cancel" data-ng-click="uploader.removeFile($index)"></span></div><button type="button" class="add img icon icon-add" data-ngf-accept="\'image/*\'" data-ngf-multiple="true" data-ngf-allow-dir="true" data-ngf-pattern="\'.png,.jpg,.gif,.jpeg\'" data-ngf-select="uploader.selectFile($files)" data-ngf-max-size="16MB" data-ngf-drop="uploader.selectFile($files)" data-ngf-drag-over-class="\'dragover\'"></button> <button type="button" class="add img icon icon-add" data-ngf-accept="\'image/*\'" data-ngf-multiple="true" data-ngf-allow-dir="true" data-ngf-pattern="\'.png,.jpg,.gif,.jpeg\'" data-ngf-select="uploader.selectFile($files)" data-ngf-max-size="16MB" data-ngf-no-file-drop=""></button></div></div></div>');
$templateCache.put('app/components/vehiclepicker/vehiclepicker.modal.html','<div class="modal"><div class="modal-dialog"><div class="close" data-ng-click="vehiclepicker.closeIt(-1)" data-ng-show="vehiclepicker.modal.cross"><i class="icon icon-cancel"></i></div><div class="container"><div class="row"><div class="col-xs-12"><div class="whiteframe-container"><div class="whiteframe"><div class="header"><h4 data-ng-bind-html="vehiclepicker.modal.title"></h4></div></div><ol class="vehicle-list"><li class="whiteframe" data-ng-show="::vehiclepicker.modal.vehicles.length < 1"><article class="content content-nocontent"><p><span class="icon icon-emo-happy"></span></p><p class="message">Non hai aggiunto ancora nessun veicolo che rispetta gli standard richiesti.</p><p>Aggiungi subito un <a target="_blank" data-ui-sref="root.it.supplier.vehicles.add" data-ng-click="vehiclepicker.closeIt(-1)">nuovo veicolo </a>.</p></article></li><li class="whiteframe" data-ng-repeat="vehicle in vehiclepicker.modal.vehicles"><article class="content-items"><div class="row"><div class="image-supplier col-xs-12 col-sm-3"><data-br-slider data-br-alt="Noleggio Pullman" data-br-imgs="::vehicle.imgs" data-br-sizes="{width: 250, height: 150}" data-br-cloudinary="true"></data-br-slider></div><div class="col-xs re-padding-left-xs rm-padding-left-sm"><div class="row"><div class="col-xs"><div class="details"><h3>{{::vehicle.specs.manufacturer}} {{::vehicle.specs.model}} {{::vehicle.specs.type}}</h3><p><span class="icon icon-bus"></span> Targa: {{::vehicle.specs.plate}} <span class="icon icon-calendar"></span> Anno: {{::vehicle.specs.matriculation}} <span class="icon icon-tree"></span> {{::vehicle.specs.emissionClass}} - {{::vehicle.specs.axis}} assi</p><p><span class="icon icon-location"></span> Sede: {{::vehicle.Place.place.address}}</p><p><span class="icon icon-user-male"></span> Posti passeggero: {{::vehicle.specs.seats.passengers}}</p></div></div></div><div class="row"><div class="col-sm-8 co-xs-12"><div class="services-20"><ul><li data-ng-repeat="(key, service) in ::vehiclepicker.modal.services track by key" data-ng-class="::{\'active\': vehicle.services[key]}"><span class="tooltip"><span class="icon" data-ng-class="::service.icon"></span> <span class="tip">{{::service.name}}</span></span></li></ul></div></div></div><div class="row"><div class="col-xs-12 bootstrap"><button class="btn btn-md" data-ng-class="{\'btn-outline-success\': !vehicle.selected, \'btn-success\': vehicle.selected}" data-ng-click="vehiclepicker.updateCapacity($index)">{{vehicle.selected ? \'Selezionato\' : \'Seleziona\'}}</button></div></div></div></div></article></li><li class="whiteframe" data-ng-repeat="vehicle in vehiclepicker.modal.badvehicles" data-ng-if="vehiclepicker.modal.vehicles.length < 1"><article class="content-items"><div class="row"><div class="image-supplier col-xs-12 col-sm-3"><data-br-slider data-br-alt="Noleggio Pullman" data-br-imgs="::vehicle.imgs" data-br-sizes="{width: 250, height: 150}" data-br-cloudinary="true"></data-br-slider></div><div class="col-xs re-padding-left-xs rm-padding-left-sm"><div class="row"><div class="col-xs"><div class="details"><h3>{{::vehicle.specs.manufacturer}} {{::vehicle.specs.model}} {{::vehicle.specs.type}}</h3><p><span class="icon icon-bus"></span> Targa: {{::vehicle.specs.plate}} <span class="icon icon-calendar"></span> Anno: {{::vehicle.specs.matriculation}} <span class="icon icon-tree"></span> {{::vehicle.specs.emissionClass}} - {{::vehicle.specs.axis}} assi</p><p><span class="icon icon-location"></span> Sede: {{::vehicle.Place.place.address}}</p><p><span class="icon icon-user-male"></span> Posti passeggero: {{::vehicle.specs.seats.passengers}}</p></div></div></div><div class="row"><div class="col-sm-8 co-xs-12"><div class="services-20"><ul><li data-ng-repeat="(key, service) in ::vehiclepicker.modal.services track by key" data-ng-class="::{\'active\': vehicle.services[key]}"><span class="tooltip"><span class="icon" data-ng-class="::service.icon"></span> <span class="tip">{{::service.name}}</span></span></li></ul></div></div></div><div class="row"><div class="col-xs-12"><button class="btn btn-md btn-grey">Non compatibile</button></div></div></div></div></article></li></ol></div></div></div></div><div class="container"><div class="content"><div class="whiteframe-container"><div class="whiteframe"><div class="content"><div class="row bootstrap align-vertical"><div class="col-xs-6">Posti {{vehiclepicker.capacity}} su {{vehiclepicker.modal.requested}}</div><div class="col-xs-6" data-ng-if="vehiclepicker.modal.cancel"><button class="btn btn-md" data-ng-class="{\'btn-secondary\': vehiclepicker.capacity < vehiclepicker.modal.requested, \'btn-success\': vehiclepicker.capacity >= vehiclepicker.modal.requested}" data-ng-disabled="vehiclepicker.capacity < vehiclepicker.modal.requested" data-ng-click="vehiclepicker.choose(vehiclepicker.modal.vehicles)">Conferma</button></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/components/uploader-doc/uploader.html','<div class="label-tag"><div class="top"><span class="label" data-ng-bind-html="uploader.label"></span> <span class="info icon icon-info" tooltips="" tooltip-template="{{uploader.info}}" tooltip-side="bottom" data-ng-if="uploader.info"></span></div><div class="uploader"><div class="thumbnails-container"><div class="container"><div data-ng-if="uploader.docs" data-ng-repeat="doc in uploader.docs"><div class="container col-xs-12"><div class="row"><div class="thumnail col-xs-3"><span class="del icon icon-cancel" data-ng-click="uploader.removeImage($index)"></span> <a target="_blank" data-cl-href="{{doc.url}}"><data-cl-image alt="" public-id="{{doc.url}}" format="jpg" data-ng-if="doc.provider === \'cloudinary\'"><data-cl-transformation height="80" width="80" crop="thumb" gravity="face"></data-cl-transformation></data-cl-image></a></div><div class="col-xs-9"><label>Nome <input type="text" data-ng-model="doc.name"></label> <label data-ng-if="uploader.tags"><select tabindex="1" name="status" data-ng-model="doc.authorization"><option value="{{tag}}" data-ng-repeat="tag in uploader.tags">{{tag}}</option></select></label></div></div></div></div><div data-ng-if="uploader.files" data-ng-repeat="file in uploader.files"><div class="container col-xs-12"><div class="row"><div class="thumnail col-xs-3"><span class="del icon icon-cancel" data-ng-click="uploader.removeImage($index)"></span> <img alt="" data-ngf-thumbnail="file" data-ng-if="!uploader.picking[$index]"><md-progress-circular class="icon" md-mode="indeterminate" data-ng-if="uploader.picking[$index]"></md-progress-circular></div><div class="col-xs-9"><label>Nome <input type="text" data-ng-model="file.fname" data-ng-init="file.fname=file.name"></label> <label data-ng-if="uploader.tags"><select tabindex="1" name="status" data-ng-model="file.authorization" data-ng-init="file.authorization=uploader.tags[0]"><option value="{{tag}}" data-ng-repeat="tag in uploader.tags">{{tag}}</option></select></label></div></div></div></div></div><button tabindex="1" type="button" class="add img icon icon-add" data-ngf-accept="\'image/*, application/*, text/*\'" data-ngf-multiple="true" data-ngf-allow-dir="true" data-ngf-pattern="\'.png,.jpg,.gif,.jpeg,.pdf,.docx,.doc,.xls,.xlsx,.ppt,.pptx,.odf,.txt,.rtf\'" data-ngf-select="uploader.selectFile($files)" data-ngf-max-size="16MB" data-ngf-drop="uploader.selectFile($files)" data-ngf-drag-over-class="\'dragover\'"></button> <button tabindex="1" type="button" class="add img icon icon-add" data-ngf-accept="\'image/*, application/*, text/*\'" data-ngf-multiple="true" data-ngf-allow-dir="true" data-ngf-pattern="\'.png,.jpg,.gif,.jpeg,.pdf,.docx,.doc,.xls,.xlsx,.ppt,.pptx,.odf,.txt,.rtf\'" data-ngf-select="uploader.selectFile($files)" data-ngf-max-size="16MB" data-ngf-no-file-drop=""></button></div></div></div>');
$templateCache.put('app/elements/advantages/advantages.html','<section class="advantages" id="advantages"><div class="container"><div class="intro"><h3>Entra a far parte del Club di Busrapido</h3><p>Busrapido seleziona solo le migliori aziende di noleggio del territorio, offrendo ai suoi Partner:</p></div><div class="row"><div class="col-xs-12 col-sm-4"><div class="icon-circle icon-visibility firt-circle"></div><div class="whiteframe-container whiteframe arrow-top"><div class="content content-evidence"><h4>Ottieni visibilit\xE0</h4><p>Busrapido pubblicizza attivamente la tua azienda e i tuoi pullman sui motori di ricerca come Google e Bing, rendendola visibile ad un numero di clienti in continua crescita. Verrai scelto da tutti i clienti che vogliono noleggiare online.</p></div></div></div><div class="col-xs-12 col-sm-4"><div class="icon-circle"><img src="./assets/images/icons/icona-bus.svg" alt="Bus"/></div><div class="whiteframe-container whiteframe arrow-top"><div class="content content-evidence"><h4>Ricevi pi\xF9 prenotazioini</h4><p>Busrapido ti invier\xE0 solo prenotazioni sicure e pronte per essere accettate. Non dovrai pi\xF9 perdere tempo prezioso per gestire richieste che poi non si concretizzeranno in una prenotazione.</p></div></div></div><div class="col-xs-12 col-sm-4"><div class="icon-circle icon-optimize"></div><div class="whiteframe-container whiteframe arrow-top"><div class="content content-evidence"><h4>Aumenta il fatturato</h4><p>Aumenta il tuo fatturato accettando tutte le prenotazioni aggiuntive alla tua programmazione. Potrai cos\xEC utilizzare al meglio la tua flotta sfruttando tutte le opportunit\xE0 che ti proporremo.</p></div></div></div></div></div></section>');
$templateCache.put('app/elements/clients/clients.html','<section class="jumbo-container clients"><div class="jumbo-content"><div class="container"><div class="used row"><div class="col-xs-5" style="text-align: right"><span><img class="icon-circle" src="./assets/images/icons/icona-lente.svg" alt="Ricerche"/></span></div><div class="col-xs-7" style="text-align: left"><p>In questo momento</p><p class="medium">{{clients.peoples}} potenziali clienti</p><p>stanno cercando un pullman come il tuo.</p><br/><a ur-sref="root.it.supplier.signup"><p>Registrati oggi stesso!</p></a></div></div></div></div></section>');
$templateCache.put('app/elements/auth/auth.html','<div class="auth"><form class="auth" novalidate="" data-ng-if="auth.mode === \'signin\'" data-ng-submit="auth.processSignin()"><div class="form-group"><div class="col-xs-12"><label><div class="top"><span class="label">La tua email</span></div><input type="email" name="email" placeholder="Email" data-ng-model="auth.user.signin.email" data-br-no-email-validation=""></label></div><div class="col-xs-12"><label><div class="top"><span class="label">La tua password</span></div><input type="password" name="password" placeholder="Password" data-br-password="" data-ng-model="auth.user.signin.password"></label></div></div><div class="warn collapse-step" data-ng-if="auth.user.signin.warning"><p>{{auth.user.signin.warning}}</p></div><div class="form-group"><div class="col-xs-12" data-ng-class="{\'disabled\': (!auth.user.signin.email || !auth.user.signin.password || !auth.enabled) }"><button type="submit" class="btn btn-lg btn-primary btn-block" data-ng-disabled="!auth.enabled">Accedi</button></div></div><div class=""><div class="col-xs-12 col-sm-6"><p class="bottom left">Non hai un account? <a data-ng-click="auth.changeMode(\'signup\')">Registrati</a></p></div><div class="col-xs-12 col-sm-6"><p class="bottom left">Non ricordi la password? <a data-ng-click="auth.changeMode(\'recover\')">Recuperala</a></p></div></div></form><form class="auth" novalidate="" data-ng-if="auth.mode === \'recover\'" data-ng-submit="auth.processRecover()"><div class="form-group"><div class="col-xs-12"><label><div class="top"><span class="label">La tua email</span></div><input type="email" name="email" placeholder="Email" data-ng-model="auth.user.recover.email" data-br-no-email-validation=""></label></div></div><div class="warn collapse-step" data-ng-if="auth.user.recover.warning"><p>{{auth.user.recover.warning}}</p></div><div class="form-group"><div class="col-xs-12" data-ng-class="{\'disabled\': (!auth.user.recover.email || !auth.enabled)}"><button type="submit" class="btn btn-lg btn-primary btn-block" data-ng-disabled="!auth.enabled">Recupera password</button></div></div><div class="form-group"><div class="col-xs-12 col-sm-6"><p class="bottom left">Non hai un account? <a data-ng-click="auth.changeMode(\'signup\')">Registrati</a></p></div><div class="col-xs-12 col-sm-6"><p class="bottom right">Sei gi\xE0 un membro di Busrapido? <a data-ng-click="auth.changeMode(\'signin\')">Accedi</a></p></div></div></form><form class="auth" novalidate="" data-ng-if="auth.mode === \'reset\'" data-ng-submit="auth.processReset()"><div class="form-group"><div class="col-xs-12"><label><div class="top"><span class="label">Password</span></div><input type="password" name="password" placeholder="Inserisci la nuova password" data-br-password="" data-ng-model="auth.user.reset.password"></label></div></div><div class="warn collapse-step" data-ng-if="auth.user.reset.warning"><p>{{auth.user.reset.warning}}</p></div><div class="form-group"><div class="col-xs-12" data-ng-class="{\'disabled\': (!auth.user.reset.password || !auth.enabled)}"><button type="submit" class="btn btn-lg btn-primary btn-block" data-ng-disabled="!auth.enabled">Reimposta password</button></div></div><div class="form-group"><div class="col-xs-12 col-sm-5"><p class="bottom left">Ti sei ricordato la password? <a data-ng-click="auth.changeMode(\'signin\')">Accedi</a></p></div><div class="col-xs-12 col-sm-7"><p class="bottom right">La reimpostazione \xE8 fallita? <a data-ng-click="auth.changeMode(\'recover\')">Recuperala</a></p></div></div></form><form class="auth bootstrap" novalidate="" data-ng-if="auth.mode === \'signup\'" data-ng-submit="auth.advanceSignup(auth.step, auth.step + 1, $event);"><div data-ng-switch="auth.step"><data-br-name-step data-br-data="auth.user.signup" data-ng-switch-when="1"></data-br-name-step><data-br-poc-step data-br-data="auth.user.signup" data-ng-switch-when="2"></data-br-poc-step><data-br-company-step data-br-data="auth.user.signup" data-ng-switch-when="3"></data-br-company-step><data-br-cheer-step data-br-data="auth.user.signup" data-ng-switch-when="4"></data-br-cheer-step><data-br-additional-step data-br-data="auth.user.signup" data-ng-switch-when="5"></data-br-additional-step><data-br-first-completed-step data-br-data="auth.user.signup" data-ng-switch-when="6"></data-br-first-completed-step><data-br-notification-step data-br-data="auth.user.signup" data-ng-switch-when="7"></data-br-notification-step><data-br-request-types-step data-br-data="auth.user.signup" data-ng-switch-when="8"></data-br-request-types-step></div><div class="warn collapse-step" data-ng-if="auth.user.signup.warning"><p>{{auth.user.signup.warning}}</p></div><div class="form-group"><div class="col-xs-12"><span class="terms">*Creando un account come partner, accetti automaticamente i <a href="{{auth.$users}}/it/termini-condizioni/generali/" target="_blank">Termini e Condizioni</a> e l\'<a href="{{auth.$users}}/it/termini-condizioni/privacy/" target="_blank">Informativa sulla Privacy</a> di Busrapido.</span></div></div><div class="form-group"><div class="row"><div class="col-sm"><button class="btn btn-success" type="submit" data-ng-show="auth.step === 1" data-ng-cloak="">Registrati</button> <button class="btn btn-success" type="submit" data-ng-show="auth.step !== 1" data-ng-cloak="">Avanti</button></div></div></div><div class="form-group"><div class="col-xs-12"><p class="bottom">Sei gi\xE0 un partner di Busrapido? <a data-ng-click="auth.changeMode(\'signin\')">Accedi</a></p></div></div></form></div>');
$templateCache.put('app/elements/confirmemail/confirmemail.html','<div class="confirmemail" data-ng-if="confirmemail.isAuthenticated() && !confirmemail.emailConfirmed"><p><i class="icon icon-warn"></i> Non hai ancora verificato il tuo indirizzo email. <span data-ng-if="!confirmemail.sent"><span class="a" data-ng-click="confirmemail.sendConfirmation()">Clicca qui</span> per inviare nuovamente la mail di conferma.</span><span data-ng-if="confirmemail.sent">Una nuova email di conferma \xE8 stata inviata a {{confirmemail.sent}}.</span> <span class="a" data-ng-if="!confirmemail.updating" data-ng-click="confirmemail.updateConfirmation()">Aggiorna stato</span> <span data-ng-if="confirmemail.updating"><span class="icon icon-spin animate-spin"></span></span></p></div>');
$templateCache.put('app/elements/dashboard/dashboard.html','<section class="dashboard" id="dashboard"><div class="whiteframe-container"><div class="whiteframe"><div class="row"><div class="col-xs-12 col-sm-7"><div class="content"><div class="image" style="padding: 5em;"><img src="assets/images/icons/icona-pc.svg" alt="Dashboard Busrapido"></div></div></div><div class="col-xs-12 col-sm-5"><div class="content"><div class="content content-evidence"><div style="text-align: left;"><h4>{{vm.header}}</h4><span class="big">Partner<br>Dashboard</span><p></p><span>La nuova Partner Dashboard, creata sulla base dei feedback e delle esigenze di aziende come la tua, ti consentir\xE0 sia di ricevere richieste di prenotazioni, pronte da accettare, da parte del team di Busrapido sia di creare richieste di servizi. Grazie a questa novit\xE0, potrai decidere di assegnare direttamente il servizio ad uno dei tuoi collaboratori oppure lasciare che sia Busrapido a trovare per te una ditta disponibile!</span><p></p><div class="row"><div class="col-xs-12"><a data-ui-sref="{{vm.target}}" data-br-track="Click Subscribe"><button class="btn btn-lg btn-primary" style="text-align: center; width: 100%;">{{vm.action}}</button></a></div></div></div></div></div></div></div></div></div></section>');
$templateCache.put('app/elements/footer/footer.html','<footer class="footer"><div class="container"><div class="info row"><div class="col-xs-12 col-md-4"><img src="assets/images/brand/busrapido-brand-white.png" alt="Busrapido" class="img-responsive"><div class="contacts"><a href="mailto:info@busrapido.com">info@busrapido.com</a> - <a data-ng-href="tel:{{$tel}}">{{$phone}}</a></div></div><div class="col-xs-12 col-md-2"><h5>Busrapido</h5><ul class="list"><li><a href="{{$users}}/it/termini-condizioni/privacy/" target="_blank">Informativa sulla Privacy</a></li><li><a href="{{$users}}/it/termini-condizioni/trasporto/" target="_blank">Condizioni di Trasporto</a></li><li><a href="{{$users}}/it/termini-condizioni/generali/" target="_blank">Termini e Condizioni</a></li></ul></div><div class="col-xs-12 col-md-2"><h5>Utente</h5><ul class="list"><li><a href="{{$users}}/it/viaggio/pianifica/" target="_blank">Effettua una ricerca</a></li><li><a href="{{$users}}/it/utente/accesso/" target="_blank">Accesso Utente</a></li></ul></div><div class="col-xs-12 col-md-4"><div class="row dropdown"><div class="col-xs-12 col-sm-6"><select><option value="Lingua" disabled="disabled">Scegli la tua lingua</option><option selected="selected" value="it">Italiano</option></select></div><div class="col-xs-12 col-sm-6"><select><option value="Valuta" disabled="disabled">Scegli la tua valuta</option><option selected="selected" value="EUR">\u20AC EUR</option></select></div></div><div class="row"><div class="col-xs-12"><ul class="credit-cards"><li><img src="./assets/images/payments/mastercard-curved.png" alt="Mastercard"></li><li><img src="./assets/images/payments/visa-curved.png" alt="Visa"></li><li><img src="./assets/images/payments/maestro-curved.png" alt="Maestro"></li><li><img src="./assets/images/payments/american-express-curved.png" alt="American Express"></li><li><img src="./assets/images/payments/discover-curved.png" alt="Discover"></li><li><img src="./assets/images/payments/paypal-curved.png" alt="Paypal"></li></ul></div></div></div></div><hr><div class="copyright">Busrapido SRL - Via Flaminia, 135, 00196 Roma (Italia) - P.IVA: 13860691008 - Copyright 2016-{{$year}} | Tutti i diritti riservati.</div></div></footer>');
$templateCache.put('app/elements/howitworks/howitworks.html','<section class="howitworks"><div class="container"><div class="intro"><h3>Come funziona?</h3><p>Inizia a ricevere prenotazioni in 3 semplici passi</p></div><div class="row"><div class="col-xs-12 col-sm-4"><div class="whiteframe-container whiteframe"><div class="content content-evidence"><h4>#1 Tu ci descrivi i tuoi veicoli...</h4><p>In fase di registrazione inserisci i dati dei tuoi veicoli, le foto e il tuo tariffario. Dopo la nostra conferma, potrai mettere online i tuoi veicoli e iniziare a ricevere prenotazioni immediatamente!</p></div></div></div><div class="col-xs-12 col-sm-4"><div class="whiteframe-container whiteframe"><div class="content content-evidence"><h4>#2 Noi li mostriamo a tutto il mondo...</h4><p>Presentiamo i tuoi veicoli in modo che siano rilevanti per i viaggiatori di tutto il mondo, in pi\xF9 lingue e li pubblicizziamo su motori di ricerca come Google e Bing. Cos\xEC ti aiutiamo a vendere pi\xF9 servizi di trasporto e aumentare i tuoi profitti!</p></div></div></div><div class="col-xs-12 col-sm-4"><div class="whiteframe-container whiteframe"><div class="content content-evidence"><h4>#3 ...e tu ricevi prenotazioni e recensioni!</h4><p>Tutte le prenotazioni effettuate su Busrapido sono pronte per essere confermate. Gli utenti di Busrapido lasciano un giudizio sulla loro esperienza di viaggio, aiutando i futuri clienti a decidere se prenotare dalla tua azienda. Avrai finalmente una vetrina online dove mostrare la tua professionalit\xE0 e differenziare i tuoi servizi da quelli dei tuoi concorrenti.</p></div></div></div></div></div></section>');
$templateCache.put('app/elements/navbar/navbar.html','<header class="navbar"><nav><a class="comp brand pull-left" data-ui-sref="root.it.home"><div class="mark"></div><div class="busrapido"><p class="logo"><strong>Busrapido</strong></p><p class="payoff"><strong>Partner</strong></p></div></a><div class="comp pull-right hidden-xs visible-sm" data-ng-if="navbar.isAuthenticated()"><p>{{navbar.supplier.tcompany}} <i class="icon icon-menu"></i></p><div class="dropdown"><div class="item"><a data-ui-sref="root.it.supplier.profile.name">Profilo</a></div><div class="item"><a data-ui-sref="root.it.supplier.subscribe.list">Subscription</a></div><div class="item"><a data-ui-sref="root.it.supplier.profile.company({type: \'visualizza\'})">Sedi</a></div><div class="item"><a data-ng-click="navbar.signout()">Esci</a></div></div></div><div class="comp pull-right hidden-xs visible-sm" data-ng-if="!navbar.isAuthenticated()"><a data-ui-sref="root.it.supplier.signin">Accedi come partner</a></div><div class="comp pull-right hidden-xs visible-sm" style="background: #e74c3c; border: #ff3a24 1px solid; color: #ececec" data-ng-if="!navbar.isAuthenticated()"><a data-ui-sref="root.it.supplier.signup">Registrati come partner</a></div><div class="comp pull-right hidden-xs visible-sm" data-ng-if="!navbar.isAuthenticated()"><a href="#saysaboutus">Dicono di noi</a></div><div class="comp pull-right hidden-xs visible-sm" data-ng-if="!navbar.isAuthenticated()"><a href="#advantages">Vantaggi</a></div><div class="side visible-xs hidden-md"><ul class="toggle"><li><a><i class="icon icon-menu" data-ng-click="navbar.openSidebar()"></i></a></li></ul><div class="bar" data-ng-class="{\'visible\' : navbar.sidebar}"><div class="mask" data-ng-click="navbar.closeSidebar()"></div><div class="content"><div class="header" data-ng-if="navbar.isAuthenticated()"><img src="assets/images/brand/busrapido-icon-white.png" alt="Busrapido"><p>{{navbar.supplier.name}} {{navbar.supplier.surname}}</p></div><div class="wrapper"><ul data-ng-if="!navbar.isAuthenticated()"><li><a href="#advantages">Vantaggi</a></li><li><a href="#saysaboutus">Dicono di noi</a></li></ul><ul data-ng-if="!navbar.isAuthenticated()"><li><a data-ui-sref="root.it.supplier.signup">Registrati come partner</a></li><li><a data-ui-sref="root.it.supplier.signin">Accedi come partner</a></li></ul><ul data-ng-if="navbar.isAuthenticated()"><li><a data-ui-sref="root.it.supplier.trips.list">Prenotazioni</a></li><li><a data-ui-sref="root.it.supplier.profile.name">Profilo</a></li><li><a data-ui-sref="root.it.supplier.places.list">Sedi</a></li><li><a data-ui-sref="root.it.supplier.subscribe.list">Subscription</a></li><li><a data-ng-click="navbar.signout()">Esci</a></li></ul><ul><li><a data-ng-href="tel:{{$tel}}">Chiamaci ora</a></li></ul></div></div></div></div></nav></header>');
$templateCache.put('app/elements/navbar/navbar.modal.html','<div class="modal"><div class="modal-dialog"><div class="close" data-ng-click="modal.close(false)"><i class="icon icon-cancel"></i></div><h3 class="top-title" data-ng-if="modal.mode == \'signin\'">Effettua l\'accesso</h3><h3 class="top-title" data-ng-if="modal.mode == \'recover\'">Recupera la password</h3><h3 class="top-title" data-ng-if="modal.mode == \'reset\'">Reimposta la password</h3><data-br-auth data-br-mode="modal.mode" data-br-on-signin="modal.close(true)"></data-br-auth></div></div>');
$templateCache.put('app/elements/offering/offering.html','<section class="offering"><div class=""><div class="intro"><h3>Entra nel Club di Bus Operator pi\xF9 esclusivo d\'Italia</h3></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-3"><div class="icon-circle icon-visibility firt-circle"></div><div class="whiteframe-container whiteframe"><div class="content content-evidence"><h4><span class="icon icon-thick"></span> Libero accesso alla Dashboard</h4><p>Scegli il piano pi\xF9 adatto alle tue esigenze. Potrai accedere alla nuova Dashboard in qualsiasi momento e da tutti i tuoi dispositivi: in ufficio, a casa o in giro avrai sempre il tuo business a portata di click.</p></div></div></div><div class="col-xs-12 col-sm-6 col-md-3"><div class="icon-circle icon-prenotation"></div><div class="whiteframe-container whiteframe"><div class="content content-evidence"><h4><span class="icon icon-thick"></span> Assistenza 24/7 e gestione emergenze</h4><p>Offriamo a te e ai tuoi clienti un\'assistenza multilingue attiva h24, 7 giorni su 7. Dimentica gli imprevisti: grazie alla nuova Dashboard e all\'intervento del Team Emergenze, il buon esito del viaggio \xE8 assicurato!</p></div></div></div><div class="col-xs-12 col-sm-6 col-md-3"><div class="icon-circle icon-optimize"></div><div class="whiteframe-container whiteframe"><div class="content content-evidence"><h4><span class="icon icon-thick"></span> Pagamenti puntuali</h4><p>Aderisci al servizio ed avrai data certa e incassi garantiti per ogni viaggio. Sar\xE0 Busrapido a farsi carico del pagamento del servizio che ti ha assegnato, anche quando il cliente \xE8 in mora.</p></div></div></div><div class="col-xs-12 col-sm-6 col-md-3"><div class="icon-circle icon-optimize"></div><div class="whiteframe-container whiteframe"><div class="content content-evidence"><h4><span class="icon icon-thick"></span> Pi\xF9 prenotazioni, pi\xF9 felici</h4><p>Aumenta fino a cinque volte le richieste di prenotazione e fai crescere il tuo business! Ti mettiamo a disposizione tutti gli strumenti di cui necessiti per lavorare meglio e fatturare di pi\xF9.</p></div></div></div></div></div></section>');
$templateCache.put('app/elements/offering-supplier/offering.html','<section class="offering"><div class=""><div class="intro"><h3>Entra nel Club di Bus Operator pi\xF9 esclusivo d\'Italia</h3></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-3"><div class="icon-circle icon-visibility firt-circle"></div><div class="whiteframe-container whiteframe"><div class="content content-evidence"><h4><span class="icon icon-thick"></span> Libero accesso alla Dashboard</h4><p>Scegli il piano pi\xF9 adatto alle tue esigenze. Potrai accedere alla nuova Dashboard in qualsiasi momento e da tutti i tuoi dispositivi: in ufficio, a casa o in giro avrai sempre il tuo business a portata di click.</p></div></div></div><div class="col-xs-12 col-sm-6 col-md-3"><div class="icon-circle icon-prenotation"></div><div class="whiteframe-container whiteframe"><div class="content content-evidence"><h4><span class="icon icon-thick"></span> Assistenza 24/7 e gestione emergenze</h4><p>Offriamo a te e ai tuoi clienti un\'assistenza multilingue attiva h24, 7 giorni su 7. Dimentica gli imprevisti: grazie alla nuova Dashboard e all\'intervento del Team Emergenze, il buon esito del viaggio \xE8 assicurato!</p></div></div></div><div class="col-xs-12 col-sm-6 col-md-3"><div class="icon-circle icon-optimize"></div><div class="whiteframe-container whiteframe"><div class="content content-evidence"><h4><span class="icon icon-thick"></span> Pagamenti puntuali</h4><p>Aderisci al servizio ed avrai data certa e incassi garantiti per ogni viaggio. Sar\xE0 Busrapido a farsi carico del pagamento del servizio che ti ha assegnato, anche quando il cliente \xE8 in mora.</p></div></div></div><div class="col-xs-12 col-sm-6 col-md-3"><div class="icon-circle icon-optimize"></div><div class="whiteframe-container whiteframe"><div class="content content-evidence"><h4><span class="icon icon-thick"></span> Garanzia money-back</h4><p>In nostro obiettivo \xE8 far crescere il tuo business. Se a fine anno non ti porteremo incassi per l\'importo equivalente al costo del tuo abbonamento, ti rimborseremo la differenza!</p></div></div></div></div></div></section>');
$templateCache.put('app/elements/planner/planner.html','<form class="planner" novalidate="" data-ng-show="planner.data.trip.legs.length" data-ng-submit="planner.stepSend()"><ul class="trip-steps"><li><div class="trip-steps-timeline"></div><div class="trip-steps-dot bottom"></div><div class="trip-steps-revert" data-ng-class="{\'disabled\': !planner.data.trip.steps[planner.data.trip.legs[0].to].arrive || planner.data.trip.steps[planner.data.trip.legs[0].from].place.address == planner.data.trip.steps[planner.data.trip.legs[1].to].place.address}" data-ng-click="planner.switchStep(planner.data.trip.legs[0].from, planner.data.trip.legs[0].to)"><span class="icon icon-updown-circle"></span></div><div class="trip-steps-content"><data-br-placepicker data-br-label="Da dove parti?" data-br-placeholder="Indirizzo, ristorante, hotel, chiesa, areoporto, stazione" data-br-disabled="false" data-br-to="planner.data.trip.steps[planner.data.trip.legs[0].from].place" data-br-on-select="planner.stepPlaceSelect(planner.data.trip.legs[0].from)" data-br-on-geocode="planner.stepPlaceGeocode(planner.data.trip.legs[0].from)"></data-br-placepicker><data-br-datetimepicker data-br-label-date="{{(planner.data.trip.steps[planner.data.trip.legs[0].from].place.address | labelText : \'Che giorno vuoi partire?\' : \'Che giorno vuoi partire da \' : \'?\')}}" data-br-label-time="A che ora?" data-br-placeholder-date="Data" data-br-placeholder-time="Ora" data-br-info-time="Ti consigliamo di presentarti almeno 15-30 minuti prima dell\'ora indicata." data-br-disabled="false" data-br-date="planner.data.trip.steps[planner.data.trip.legs[0].from].depart" data-br-def-time="08:00" data-br-min-date="planner.MIN_DEPART_DATE" data-br-on-change="planner.stepDepartChange(planner.data.trip.legs[0].from)"></data-br-datetimepicker></div></li><li class="collapse-step" data-ng-repeat="leg in planner.data.trip.legs"><div class="trip-steps-timeline" data-ng-class="{\'disabled\': !planner.data.trip.steps[planner.data.trip.legs[$index].to].arrive, \'last\': $index == planner.data.trip.legs.length-1}"></div><div class="trip-steps-dot"></div><div class="trip-steps-revert" data-ng-if="planner.data.trip.legs[$index+1].to <= planner.data.trip.steps.length-1" data-ng-class="{\'disabled\': !planner.data.trip.steps[planner.data.trip.legs[$index+1].to].arrive || planner.data.trip.steps[planner.data.trip.legs[$index+1].to].place.address == planner.data.trip.steps[planner.data.trip.legs[$index].from].place.address}" data-ng-click="planner.switchStep(planner.data.trip.legs[$index+1].from, planner.data.trip.legs[$index+1].to)"><span class="icon icon-updown-circle"></span></div><div class="trip-steps-content"><div class="row"><div class="col-xs"><data-br-placepicker data-br-label="Qual \xE8 la prossima tappa/destinazione del tuo viaggio?" data-br-label-bottom="{{(planner.data.trip.steps[planner.data.trip.legs[$index].to].arrive | labelArrive : planner.data.trip.legs[$index].directions.total.duration : planner.data.trip.legs[$index].stopover : \'Arrivo previsto: \')}}" data-br-placeholder="Indirizzo, ristorante, hotel, chiesa, areoporto, stazione" data-br-info="Se il tuo viaggio \xE9 finito inserisci qui il punto di arrivo, altrimenti inserisci la prossima tappa." data-br-disabled="false" data-br-from="planner.data.trip.steps[planner.data.trip.legs[$index].from].place" data-br-to="planner.data.trip.steps[planner.data.trip.legs[$index].to].place" data-br-directions="planner.data.trip.legs[$index].directions" data-br-depart-time="planner.data.trip.steps[planner.data.trip.legs[$index].from].depart" data-br-hw-speed="planner.MIN_HW_SPEED" data-br-speed-limit="planner.MAX_VEHICLE_SPEED" data-br-on-select="planner.stepPlaceSelect(planner.data.trip.legs[$index].to)" data-br-on-geocode="planner.stepPlaceGeocode(planner.data.trip.legs[$index].to)" data-br-on-compute="planner.stepPlaceCompute(planner.data.trip.legs[$index].to)"></data-br-placepicker></div><div class="rel col-xs-4 hidden-xs visible-sm" data-ng-if="!planner.data.trip.steps[planner.data.trip.legs[$index].to].place.address && planner.data.trip.steps[planner.data.trip.legs[0].from].place.address && $index === planner.data.trip.legs.length-1 && planner.data.trip.steps[planner.data.trip.legs[$index].from].place.address !== planner.data.trip.steps[planner.data.trip.legs[0].from].place.address"><button tabindex="1" type="button" class="btn btn-lg btn-primary to-start" data-ng-click="planner.setToStart(planner.data.trip.legs[$index].to)">Ritorna al punto di partenza</button></div></div><data-br-datetimepicker data-ng-show="$index < planner.data.trip.legs.length-1" data-br-label-date="{{(planner.data.trip.steps[planner.data.trip.legs[$index].to].place.address | labelText : \'Che giorno vuoi ripartire?\' : \'Che giorno vuoi ripartire da \' : \'?\')}}" data-br-label-time="A che ora?" data-br-label-bottom-time="{{(planner.data.trip.steps[planner.data.trip.legs[$index].to].layover | labelLayover : planner.data.trip.steps[planner.data.trip.legs[$index].to].depart : \'Sosta: \')}}" data-br-placeholder-date="Data" data-br-placeholder-time="Ora" data-br-disabled="false" data-br-date="planner.data.trip.steps[planner.data.trip.legs[$index].to].depart" data-br-def-time="08:00" data-br-min-date="planner.temp[$index].min" data-br-on-change="planner.stepDepartChange(planner.data.trip.legs[$index].to)"></data-br-datetimepicker><div data-ng-show="planner.data.trip.steps[planner.data.trip.legs[$index].to].depart"><input tabindex="1" type="checkbox" data-ng-model="planner.data.trip.steps[planner.data.trip.legs[$index].to].keep"> Pullman a disposizione. <span class="info icon icon-info" tooltips="" tooltip-template="In generale nel tempo indicato come \'sosta\' non viene garantita la presenza in loco del pullman. La sua presenza \xE8 garantita solo 15 minuti dopo l\'arrivo in questa tappa e 15 minuti prima della partenza verso la prossima tappa. Se vuoi che il pullman rimanga dove l\'hai lasciato seleziona la spunta. Nota che potrebbe essere applicata una tariffazione maggiorata." tooltip-side="top"></span></div><div data-ng-show="planner.data.trip.steps[planner.data.trip.legs[$index].to].depart"><input tabindex="1" type="checkbox" data-ng-model="planner.data.trip.steps[planner.data.trip.legs[$index].to].tour"> Tour della citt\xE0 <span class="info icon icon-info" tooltips="" tooltip-template="Richiesta di un tour della citt\xE0" tooltip-side="top"></span></div></div></li><li><div tabindex="-1" class="trip-steps-dot top last" data-ng-click="planner.stepCreate(planner.data.trip.steps.length)" data-ng-class="{\'disabled\': planner.data.trip.steps.length >= planner.MAX_GOOGLE_STEPS || !planner.data.trip.steps[planner.data.trip.steps.length-1].arrive}"></div><div class="trip-steps-content"><div class="row"><div tabindex="1" class="col-xs-7" data-ng-click="planner.stepCreate(planner.data.trip.steps.length)" data-ng-class="{\'disabled\': planner.data.trip.steps.length >= planner.MAX_GOOGLE_STEPS || !planner.data.trip.steps[planner.data.trip.steps.length-1].arrive}"><span class="add"><span class="icon icon-add"></span>Aggiungi tappa / o rientro</span></div><div tabindex="1" class="col-xs-5" data-ng-click="planner.stepDelete(planner.data.trip.steps.length-1)" data-ng-if="planner.data.trip.steps.length > 2"><span class="del"><span class="icon icon-cancel"></span>Rimuovi tappa</span></div></div></div></li></ul><div class="warn collapse-step" data-ng-switch="planner.warning" data-ng-if="planner.warning"><p data-ng-switch-when="1">Controlla che tutti i campi siano correttamente compilati prima di aggiungere una nuova tappa.</p><p data-ng-switch-when="2">Ti sei dimenticato di inserire la data di partenza dall\'ultima tappa.</p><p data-ng-switch-when="3">Ti sei dimenticato di inserire l\'arrivo nell\'ultima tappa.</p><p data-ng-switch-when="4">Controlla di aver compilato tutti i campi correttamente.</p><p data-ng-switch-when="5">Ti sei dimenticato di inserire il numero di passeggeri.</p><p data-ng-switch-when="6">Il numero di passeggeri non pu\xF2 essere inferiore di 1.</p><p data-ng-switch-when="7">Il numero di passeggeri non pu\xF2 essere maggiore di 9999.</p></div></form>');
$templateCache.put('app/elements/planner-shuttle/planner.html','<form class="planner" novalidate="" data-ng-show="planner.data.trip.legs.length" data-ng-submit="planner.stepSend()"><ul><li data-ng-repeat="time in planner.data.times"><data-br-datetimepicker data-br-label-date="Ripeti il" data-br-label-time="A che ora?" data-br-placeholder-date="Data" data-br-placeholder-time="Ora" data-br-disabled="false" data-br-date="time" data-br-def-time="08:00" data-br-min-date="planner.MIN_DEPART_DATE"></data-br-datetimepicker></li><li><data-br-datetimepicker data-br-label-date="Ripeti il" data-br-label-time="A che ora?" data-br-placeholder-date="Data" data-br-placeholder-time="Ora" data-br-disabled="false" data-br-date="planner.tmpTime" data-br-def-time="08:00" data-br-min-date="planner.MIN_DEPART_DATE"></data-br-datetimepicker></li><button tabindex="1" class="btn btn-md" data-ng-click="planner.timeCreate(planner.tmpTime)">Aggiungi orario</button></ul><ul class="trip-steps"><li><div class="trip-steps-timeline"></div><div class="trip-steps-dot bottom"></div><div class="trip-steps-revert" data-ng-class="{\'disabled\': !planner.data.trip.steps[planner.data.trip.legs[0].to].arrive || planner.data.trip.steps[planner.data.trip.legs[0].from].place.address == planner.data.trip.steps[planner.data.trip.legs[1].to].place.address}" data-ng-click="planner.switchStep(planner.data.trip.legs[0].from, planner.data.trip.legs[0].to)"><span class="icon icon-updown-circle"></span></div><div class="trip-steps-content"><data-br-placepicker data-br-label="Da dove parti?" data-br-placeholder="Indirizzo, ristorante, hotel, chiesa, areoporto, stazione" data-br-disabled="false" data-br-to="planner.data.trip.steps[planner.data.trip.legs[0].from].place" data-br-on-select="planner.stepPlaceSelect(planner.data.trip.legs[0].from)" data-br-on-geocode="planner.stepPlaceGeocode(planner.data.trip.legs[0].from)"></data-br-placepicker><data-br-datetimepicker data-br-label-date="{{(planner.data.trip.steps[planner.data.trip.legs[0].from].place.address | labelText : \'Che giorno vuoi partire?\' : \'Che giorno vuoi partire da \' : \'?\')}}" data-br-label-time="A che ora?" data-br-placeholder-date="Data" data-br-placeholder-time="Ora" data-br-info-time="Ti consigliamo di presentarti almeno 15-30 minuti prima dell\'ora indicata." data-br-disabled="false" data-br-date="planner.data.trip.steps[planner.data.trip.legs[0].from].depart" data-br-def-time="08:00" data-br-min-date="planner.MIN_DEPART_DATE" data-br-on-change="planner.stepDepartChange(planner.data.trip.legs[0].from)"></data-br-datetimepicker></div></li><li class="collapse-step" data-ng-repeat="leg in planner.data.trip.legs"><div class="trip-steps-timeline" data-ng-class="{\'disabled\': !planner.data.trip.steps[planner.data.trip.legs[$index].to].arrive, \'last\': $index == planner.data.trip.legs.length-1}"></div><div class="trip-steps-dot"></div><div class="trip-steps-revert" data-ng-if="planner.data.trip.legs[$index+1].to <= planner.data.trip.steps.length-1" data-ng-class="{\'disabled\': !planner.data.trip.steps[planner.data.trip.legs[$index+1].to].arrive || planner.data.trip.steps[planner.data.trip.legs[$index+1].to].place.address == planner.data.trip.steps[planner.data.trip.legs[$index].from].place.address}" data-ng-click="planner.switchStep(planner.data.trip.legs[$index+1].from, planner.data.trip.legs[$index+1].to)"><span class="icon icon-updown-circle"></span></div><div class="trip-steps-content"><div class="row"><div class="col-xs"><data-br-placepicker data-br-label="Qual \xE8 la prossima tappa/destinazione del tuo viaggio?" data-br-label-bottom="{{(planner.data.trip.steps[planner.data.trip.legs[$index].to].arrive | labelArrive : planner.data.trip.legs[$index].directions.total.duration : planner.data.trip.legs[$index].stopover : \'Arrivo previsto: \')}}" data-br-placeholder="Indirizzo, ristorante, hotel, chiesa, areoporto, stazione" data-br-info="Se il tuo viaggio \xE9 finito inserisci qui il punto di arrivo, altrimenti inserisci la prossima tappa." data-br-disabled="false" data-br-from="planner.data.trip.steps[planner.data.trip.legs[$index].from].place" data-br-to="planner.data.trip.steps[planner.data.trip.legs[$index].to].place" data-br-directions="planner.data.trip.legs[$index].directions" data-br-depart-time="planner.data.trip.steps[planner.data.trip.legs[$index].from].depart" data-br-hw-speed="planner.MIN_HW_SPEED" data-br-speed-limit="planner.MAX_VEHICLE_SPEED" data-br-on-select="planner.stepPlaceSelect(planner.data.trip.legs[$index].to)" data-br-on-geocode="planner.stepPlaceGeocode(planner.data.trip.legs[$index].to)" data-br-on-compute="planner.stepPlaceCompute(planner.data.trip.legs[$index].to)"></data-br-placepicker></div><div class="rel col-xs-4 hidden-xs visible-sm" data-ng-if="!planner.data.trip.steps[planner.data.trip.legs[$index].to].place.address && planner.data.trip.steps[planner.data.trip.legs[0].from].place.address && $index === planner.data.trip.legs.length-1 && planner.data.trip.steps[planner.data.trip.legs[$index].from].place.address !== planner.data.trip.steps[planner.data.trip.legs[0].from].place.address"><button type="button" class="btn btn-lg btn-primary to-start" data-ng-click="planner.setToStart(planner.data.trip.legs[$index].to)">Ritorna al punto di partenza</button></div></div><data-br-datetimepicker data-ng-show="$index < planner.data.trip.legs.length-1" data-br-label-date="{{(planner.data.trip.steps[planner.data.trip.legs[$index].to].place.address | labelText : \'Che giorno vuoi ripartire?\' : \'Che giorno vuoi ripartire da \' : \'?\')}}" data-br-label-time="A che ora?" data-br-label-bottom-time="{{(planner.data.trip.steps[planner.data.trip.legs[$index].to].layover | labelLayover : planner.data.trip.steps[planner.data.trip.legs[$index].to].depart : \'Sosta: \')}}" data-br-placeholder-date="Data" data-br-placeholder-time="Ora" data-br-disabled="false" data-br-date="planner.data.trip.steps[planner.data.trip.legs[$index].to].depart" data-br-def-time="08:00" data-br-min-date="planner.temp[$index].min" data-br-on-change="planner.stepDepartChange(planner.data.trip.legs[$index].to)"></data-br-datetimepicker><div data-ng-show="planner.data.trip.steps[planner.data.trip.legs[$index].to].depart"><input type="checkbox" data-ng-model="planner.data.trip.steps[planner.data.trip.legs[$index].to].keep"> Desidero il pullman a disposizione. <span class="info icon icon-info" tooltips="" tooltip-template="In generale nel tempo indicato come \'sosta\' non viene garantita la presenza in loco del pullman. La sua presenza \xE8 garantita solo 15 minuti dopo l\'arrivo in questa tappa e 15 minuti prima della partenza verso la prossima tappa. Se vuoi che il pullman rimanga dove l\'hai lasciato seleziona la spunta. Nota che potrebbe essere applicata una tariffazione maggiorata." tooltip-side="top"></span></div></div></li><li><div class="trip-steps-dot top last" data-ng-click="planner.stepCreate(planner.data.trip.steps.length)" data-ng-class="{\'disabled\': planner.data.trip.steps.length >= planner.MAX_GOOGLE_STEPS || !planner.data.trip.steps[planner.data.trip.steps.length-1].arrive}"></div><div class="trip-steps-content"><div class="row"><div class="col-xs-7" data-ng-click="planner.stepCreate(planner.data.trip.steps.length)" data-ng-class="{\'disabled\': planner.data.trip.steps.length >= planner.MAX_GOOGLE_STEPS || !planner.data.trip.steps[planner.data.trip.steps.length-1].arrive}"><span class="add"><span class="icon icon-add"></span>Aggiungi tappa / o rientro</span></div><div class="col-xs-5" data-ng-click="planner.stepDelete(planner.data.trip.steps.length-1)" data-ng-if="planner.data.trip.steps.length > 2"><span class="del"><span class="icon icon-cancel"></span>Rimuovi tappa</span></div></div></div></li></ul><div class="warn collapse-step" data-ng-switch="planner.warning" data-ng-if="planner.warning"><p data-ng-switch-when="1">Controlla che tutti i campi siano correttamente compilati prima di aggiungere una nuova tappa.</p><p data-ng-switch-when="2">Ti sei dimenticato di inserire la data di partenza dall\'ultima tappa.</p><p data-ng-switch-when="3">Ti sei dimenticato di inserire l\'arrivo nell\'ultima tappa.</p><p data-ng-switch-when="4">Controlla di aver compilato tutti i campi correttamente.</p><p data-ng-switch-when="5">Ti sei dimenticato di inserire il numero di passeggeri.</p><p data-ng-switch-when="6">Il numero di passeggeri non pu\xF2 essere inferiore di 1.</p><p data-ng-switch-when="7">Il numero di passeggeri non pu\xF2 essere maggiore di 9999.</p></div></form>');
$templateCache.put('app/elements/planner-topic/planner.html','<form class="br-planner-topic" novalidate="" data-ng-if="planner.loaded"><ul class="trip-steps" dnd-list="request.services" data-ng-repeat="request in planner.data.requests"><li data-ng-repeat="service in request.services" data-ng-switch="service.type" data-ng-class="{\'selected\': planner.selected === service}"><div class="trip-steps-timeline" data-ng-if="(service.type !== \'end\' && request.services[$index + 1].type !== \'end\') || ($parent.$index !== planner.data.requests.length - 1 && request.services[request.services.length - 1].type === \'end\')"></div><div class="trip-steps-dot bottom" data-ng-if="service.type !== \'end\'"></div><div class="trip-steps-content"><data-br-pickup-service data-br-maps="planner.maps" data-br-google-directions-service="planner.googleDirectionsService" data-br-index="$index" data-br-request="request" data-ng-switch-when="pickup"></data-br-pickup-service><data-br-transit-service data-br-maps="planner.maps" data-br-google-directions-service="planner.googleDirectionsService" data-br-index="$index" data-br-request="request" data-ng-switch-when="transit"></data-br-transit-service><data-br-transfer-service data-br-maps="planner.maps" data-br-google-directions-service="planner.googleDirectionsService" data-br-index="$index" data-br-request="request" data-ng-switch-when="transfer"></data-br-transfer-service><data-br-disposal-service data-br-maps="planner.maps" data-br-google-directions-service="planner.googleDirectionsService" data-br-index="$index" data-br-request="request" data-ng-switch-when="disposal"></data-br-disposal-service><data-br-citytour-service data-br-maps="planner.maps" data-br-google-directions-service="planner.googleDirectionsService" data-br-index="$index" data-br-request="request" data-ng-switch-when="city"></data-br-citytour-service><data-br-bus-service data-br-maps="planner.maps" data-br-google-directions-service="planner.googleDirectionsService" data-br-index="$index" data-br-request="request" data-ng-switch-when="bus"></data-br-bus-service><data-br-return-service data-br-maps="planner.maps" data-br-google-directions-service="planner.googleDirectionsService" data-br-index="$index" data-br-request="request" data-ng-switch-when="return"></data-br-return-service><data-br-shuttle-service data-br-maps="planner.maps" data-br-google-directions-service="planner.googleDirectionsService" data-br-index="$index" data-br-request="request" data-ng-switch-when="shuttle"></data-br-shuttle-service></div></li><li data-ng-if="$index !== planner.data.requests.length - 1"><div class="nav"><div class="comp pull-left hidden-xs visible-sm"><div class="row"><div tabindex="1" class="dot enabled" tooltips="" tooltip-template="Aggiungi" data-ng-click="request.dropdown = !request.dropdown"><span class="icon icon-add"></span></div><div class="dropdown" click-outside="request.dropdown = false" data-ng-show="request.dropdown"><div tabindex="1" class="item" data-ng-repeat="service in planner.types[request.services[request.services.length - 2].type]" data-ng-click="planner.addService(request, service, -1)"><p>{{service | serviceType}}</p></div></div><div class="dot" tooltips="" tooltip-template="Cancella ultimo step" data-ng-click="planner.pop($index)" data-ng-class="{\'disabled\': request.services.length == 0 || ($index === 0 && request.services.length === 1), \'enabled\': request.services.length > 0 && !($index === 0 && request.services.length === 1)}"><span class="icon icon-cancel"></span></div></div></div></div></li><li data-ng-if="request.services[request.services.length - 1].type === \'end\'"><data-br-end-service data-br-maps="planner.maps" data-br-google-directions-service="planner.googleDirectionsService" data-br-index="$index" data-br-request="request"></data-br-end-service></li><li data-ng-if="$index === planner.data.requests.length - 1"><div class="nav"><div class="comp pull-left hidden-xs visible-sm"><div class="row"><div tabindex="1" class="dot enabled" tooltips="" tooltip-template="Aggiungi" data-ng-click="request.dropdown = !request.dropdown"><span class="icon icon-add"></span></div><div class="dropdown" click-outside="request.dropdown = false" data-ng-show="request.dropdown"><div tabindex="1" class="item" data-ng-repeat="service in planner.types[request.services[request.services.length - 1].type]" data-ng-click="planner.addService(request, service)"><p>{{service | serviceType}}</p></div></div><div class="dot" tooltips="" tooltip-template="Undo" data-ng-click="planner.undo()" data-ng-class="{\'disabled\': planner.history.backward.length == 0, \'enabled\': planner.history.backward.length > 0}"><span class="icon icon-open-left"></span></div><div class="dot" tooltips="" tooltip-template="Redo" data-ng-click="planner.redo()" data-ng-class="{\'disabled\': planner.history.forward.length == 0, \'enabled\': planner.history.forward.length > 0}"><span class="icon icon-open-right"></span></div><div class="dot" tooltips="" tooltip-template="Cancella ultimo step" data-ng-click="planner.pop($index)" data-ng-class="{\'disabled\': request.services.length == 0 || ($index === 0 && request.services.length === 1), \'enabled\': request.services.length > 0 && !($index === 0 && request.services.length === 1)}"><span class="icon icon-cancel"></span></div><div class="dot" tooltips="" tooltip-template="Mostra su google maps" data-ng-click="planner.showMaps = !planner.showMaps" data-ng-class="{\'disabled\': request.services.length == 0, \'enabled\': request.services.length > 0}"><span class="icon icon-map"></span></div><div class="dropdown" click-outside="planner.showMaps = false" data-ng-show="planner.showMaps"><div tabindex="1" class="item" data-ng-repeat="request1 in planner.data.requests" data-ng-if="request1.services[0].depart"><a target="_blank" rel="noreferrer" data-ng-href="{{planner.getDirectionsLink(request1)}}">Itinerario del {{request1.services[0].depart | dates}}</a></div></div><div class="dot" tooltips="" tooltip-template="{{planner.copyText}}" ngclipboard="" ngclipboard-success="planner.copy()" data-clipboard-text="{{planner.text}}" data-ng-class="{\'disabled\': request.services.length == 0, \'enabled\': request.services.length > 0}"><span class="icon icon-docs"></span></div></div></div></div></li></ul><div class="warn collapse-step" data-ng-switch="planner.warning" data-ng-if="planner.warning"><p data-ng-switch-when="1">Controlla che tutti i campi siano correttamente compilati prima di aggiungere una nuova tappa.</p><p data-ng-switch-when="2">Ti sei dimenticato di inserire la data di partenza dall\'ultima tappa.</p><p data-ng-switch-when="3">Ti sei dimenticato di inserire l\'arrivo nell\'ultima tappa.</p><p data-ng-switch-when="4">Controlla di aver compilato tutti i campi correttamente.</p><p data-ng-switch-when="5">Ti sei dimenticato di inserire il numero di passeggeri.</p><p data-ng-switch-when="6">Il numero di passeggeri non pu\xF2 essere inferiore di 1.</p><p data-ng-switch-when="7">Il numero di passeggeri non pu\xF2 essere maggiore di 9999.</p><p data-ng-switch-when="8">Controlla la data di partenza</p><p data-ng-switch-when="9">Non \xE8 stato possibile calcolare il tragitto verso la tappa selezionata</p></div></form>');
$templateCache.put('app/elements/planner-tour/planner.html','<form class="planner" novalidate="" data-ng-show="planner.data.trip.legs.length"><ul><li><div class="trip-steps-content"><data-br-datetimepicker data-br-label-date="Data Inizio Tour" data-br-label-time="A che ora?" data-br-placeholder-date="Data" data-br-placeholder-time="Ora" data-br-info-time="Ti consigliamo di presentarti almeno 15-30 minuti prima dell\'ora indicata." data-br-disabled="false" data-br-date="planner.data.start" data-br-def-time="08:00"></data-br-datetimepicker></div></li><li><div class="trip-steps-content"><data-br-datetimepicker data-br-label-date="Data Fine Tour" data-br-label-time="A che ora?" data-br-placeholder-date="Data" data-br-placeholder-time="Ora" data-br-info-time="Ti consigliamo di presentarti almeno 15-30 minuti prima dell\'ora indicata." data-br-disabled="false" data-br-date="planner.data.end" data-br-def-time="08:00"></data-br-datetimepicker></div></li></ul><ul class="trip-steps"><ul class="trip-steps"><li><div class="trip-steps-timeline"></div><div class="trip-steps-dot bottom"></div><div class="trip-steps-content"><div class="row"><div class="col-xs-12"><div class="row header header-accent"><div><p>Giorno</p></div><div class="col-xs"><data-br-datepicker data-br-model="planner.data.trip.steps[0].depart" data-br-on-change="planner.stepDepartChange(0)" data-br-min-date="planner.data.start"></data-br-datepicker></div><div class="col-xs"><p><b>Distanza:</b> {{planner.days[0].distance | distance}}</p></div><div class="col-xs"><p><b>Tempo di guida:</b> {{planner.days[0].duration | duration}}</p></div></div></div></div></div></li><li><div class="trip-steps-timeline"></div><div class="trip-steps-dot bottom"></div><div class="trip-steps-content"><div class="row"><div class="col-xs-6"><data-br-placepicker data-br-label="Da dove parti?" data-br-placeholder="Indirizzo, ristorante, hotel, chiesa, areoporto, stazione" data-br-label-bottom="{{(planner.data.trip.steps[0].arrive | labelArriveMetrics : planner.data.trip.legs[$index].directions.total.duration : planner.data.trip.legs[$index].stopover : \'Arrivo: \' : planner.data.trip.legs[$index].directions.total.distance : \' Distanza: \' : planner.data.trip.steps[0].depart : \' Partenza: \')}}" data-br-disabled="false" data-br-to="planner.data.trip.steps[planner.data.trip.legs[0].from].place" data-br-on-select="planner.stepPlaceSelect(planner.data.trip.legs[0].from)" data-br-on-geocode="planner.stepPlaceGeocode(planner.data.trip.legs[0].from)"></data-br-placepicker></div><div class="col-xs-4"><data-br-datetimepicker data-br-show-date="false" data-br-label-time="Ora partenza" data-br-placeholder-time="Ora" data-br-disabled="false" data-br-date="planner.data.trip.steps[planner.data.trip.legs[0].from].depart" data-br-on-change="planner.stepDepartChange(planner.data.trip.legs[0].from)"></data-br-datetimepicker></div><div class="col-xs-2"><button class="btn btn-md btn-outline" style="margin-bottom: 3px;" data-ng-click="planner.deleteStep(0)">rimuovi <span class="icon icon-cancel"></span></button> <button class="btn btn-md btn-outline" data-ng-click="planner.createStep(1)">aggiungi<span class="icon icon-arrow-down"></span></button></div></div></div></li><li class="collapse-step" data-ng-repeat="leg in planner.data.trip.legs"><div class="trip-steps-content" data-ng-if="planner.data.trip.legs.length !== $index - 1 && planner.days[$index+1] !== undefined && planner.days[$index+1].date.getDate() !== planner.data.trip.steps[planner.data.trip.legs[$index].to].arrive.getDate()"><div class="row"><div class="col-xs"><div class="row"><div class="col-xs-6"><data-br-placepicker data-br-label="Qual \xE8 la prossima tappa/destinazione del tuo viaggio?" data-br-label-bottom="{{(planner.data.trip.steps[planner.data.trip.legs[$index].to].arrive | labelArriveMetrics : planner.data.trip.legs[$index].directions.total.duration : planner.data.trip.legs[$index].stopover : \'Arrivo: \' : planner.data.trip.legs[$index].directions.total.distance : \' Distanza: \' : planner.data.trip.steps[planner.data.trip.legs[$index].to].depart : \' Partenza: \')}}" data-br-placeholder="Indirizzo, ristorante, hotel, chiesa, areoporto, stazione" data-br-info="Se il tuo viaggio \xE9 finito inserisci qui il punto di arrivo, altrimenti inserisci la prossima tappa." data-br-disabled="false" data-br-from="planner.data.trip.steps[planner.data.trip.legs[$index].from].place" data-br-to="planner.data.trip.steps[planner.data.trip.legs[$index].to].place" data-br-directions="planner.data.trip.legs[$index].directions" data-br-depart-time="planner.data.trip.steps[planner.data.trip.legs[$index].from].depart" data-br-hw-speed="planner.MIN_HW_SPEED" data-br-speed-limit="planner.MAX_VEHICLE_SPEED" data-br-on-select="planner.stepPlaceSelect(planner.data.trip.legs[$index].to)" data-br-on-geocode="planner.stepPlaceGeocode(planner.data.trip.legs[$index].to)" data-br-on-compute="planner.stepPlaceCompute(planner.data.trip.legs[$index].to)"></data-br-placepicker></div><div class="col-xs-4"><data-br-datetimepicker data-ng-show="$index < planner.data.trip.legs.length-1" data-br-show-date="false" data-br-label-time="Ora partenza" data-br-placeholder-time="Ora" data-br-disabled="false" data-br-date="planner.data.trip.steps[planner.data.trip.legs[$index].to].depart" data-br-on-change="planner.stepDepartChange(planner.data.trip.legs[$index].to)"></data-br-datetimepicker></div><div class="col-xs-2"><button class="btn btn-md btn-outline" style="margin-bottom: 3px;" data-ng-click="planner.deleteStep(planner.data.trip.legs[$index].to)">rimuovi <span class="icon icon-cancel"></span></button> <button class="btn btn-md btn-outline" data-ng-click="planner.createStep(planner.data.trip.legs[$index].to + 1)">aggiungi<span class="icon icon-arrow-down"></span></button></div></div></div></div></div><div class="trip-steps-content" data-ng-if="planner.days[$index+1] !== undefined"><div class="row"><div class="col-xs-12"><div class="row header header-accent"><div><p>Giorno</p></div><div class="col-xs"><data-br-datepicker data-br-model="planner.data.trip.steps[planner.days[$index+1].step].depart" data-br-on-change="planner.stepDepartChange(planner.days[$index+1].step)" data-br-min-date="planner.MIN_DEPART_DATE"></data-br-datepicker></div><div class="col-xs"><p><b>Distanza:</b> {{planner.days[$index+1].distance | distance}}</p></div><div class="col-xs"><p><b>Tempo di guida:</b> {{planner.days[$index+1].duration | duration}}</p></div></div></div></div></div><div class="trip-steps-timeline" data-ng-class="{\'disabled\': !planner.data.trip.steps[planner.data.trip.legs[$index].to].arrive, \'last\': $index == planner.data.trip.legs.length-1}"></div><div class="trip-steps-dot"></div><div class="trip-steps-content"><div class="row"><div class="col-xs"><div class="row"><div class="col-xs-6"><data-br-placepicker data-br-label="Qual \xE8 la prossima tappa/destinazione del tuo viaggio?" data-br-label-bottom="{{(planner.data.trip.steps[planner.data.trip.legs[$index].to].arrive | labelArriveMetrics : planner.data.trip.legs[$index].directions.total.duration : planner.data.trip.legs[$index].stopover : \'Arrivo: \' : planner.data.trip.legs[$index].directions.total.distance : \' Distanza: \' : planner.data.trip.steps[planner.data.trip.legs[$index].to].depart : \' Partenza: \')}}" data-br-placeholder="Indirizzo, ristorante, hotel, chiesa, areoporto, stazione" data-br-info="Se il tuo viaggio \xE9 finito inserisci qui il punto di arrivo, altrimenti inserisci la prossima tappa." data-br-disabled="false" data-br-from="planner.data.trip.steps[planner.data.trip.legs[$index].from].place" data-br-to="planner.data.trip.steps[planner.data.trip.legs[$index].to].place" data-br-directions="planner.data.trip.legs[$index].directions" data-br-depart-time="planner.data.trip.steps[planner.data.trip.legs[$index].from].depart" data-br-hw-speed="planner.MIN_HW_SPEED" data-br-speed-limit="planner.MAX_VEHICLE_SPEED" data-br-on-select="planner.stepPlaceSelect(planner.data.trip.legs[$index].to)" data-br-on-geocode="planner.stepPlaceGeocode(planner.data.trip.legs[$index].to)" data-br-on-compute="planner.stepPlaceCompute(planner.data.trip.legs[$index].to)"></data-br-placepicker></div><div class="col-xs-4"><data-br-datetimepicker data-ng-show="$index < planner.data.trip.legs.length-1" data-br-show-date="false" data-br-label-time="Ora partenza" data-br-placeholder-time="Ora" data-br-disabled="false" data-br-date="planner.data.trip.steps[planner.data.trip.legs[$index].to].depart" data-br-on-change="planner.stepDepartChange(planner.data.trip.legs[$index].to)"></data-br-datetimepicker></div><div class="col-xs-2"><button class="btn btn-md btn-outline" style="margin-bottom: 3px;" data-ng-click="planner.deleteStep(planner.data.trip.legs[$index].to)">rimuovi <span class="icon icon-cancel"></span></button> <button class="btn btn-md btn-outline" data-ng-click="planner.createStep(planner.data.trip.legs[$index].to + 1)">aggiungi<span class="icon icon-arrow-down"></span></button></div></div></div><div class="rel col-xs-4 hidden-xs visible-sm" data-ng-if="!planner.data.trip.steps[planner.data.trip.legs[$index].to].place.address && planner.data.trip.steps[planner.data.trip.legs[0].from].place.address && $index === planner.data.trip.legs.length-1 && planner.data.trip.steps[planner.data.trip.legs[$index].from].place.address !== planner.data.trip.steps[planner.data.trip.legs[0].from].place.address"><button tabindex="1" type="button" class="btn btn-lg btn-primary to-start" data-ng-click="planner.setToStart(planner.data.trip.legs[$index].to)">Ritorna al punto di partenza</button></div></div><div data-ng-show="planner.data.trip.steps[planner.data.trip.legs[$index].to].depart"></div></div></li><li><div class="trip-steps-dot top last" data-ng-click="planner.stepCreate(planner.data.trip.steps.length)" data-ng-class="{\'disabled\': planner.data.trip.steps.length >= planner.MAX_GOOGLE_STEPS || !planner.data.trip.steps[planner.data.trip.steps.length-1].place.address}"></div><div class="trip-steps-content"><div class="row"><div class="col-xs-7" data-ng-click="planner.stepCreate(planner.data.trip.steps.length)" data-ng-class="{\'disabled\': planner.data.trip.steps.length >= planner.MAX_GOOGLE_STEPS || !planner.data.trip.steps[planner.data.trip.steps.length-1].place.address}"><span class="add"><span class="icon icon-add"></span>Aggiungi tappa / o rientro</span></div><div class="col-xs-5" data-ng-click="planner.stepDelete(planner.data.trip.steps.length-1)" data-ng-if="planner.data.trip.steps.length > 2"><span class="del"><span class="icon icon-cancel"></span>Rimuovi tappa</span></div></div></div></li><li><div class="trip-steps-dot top last" data-ng-click="planner.dayCreate(planner.data.trip.steps.length-1)" data-ng-class="{\'disabled\': planner.data.trip.steps.length >= planner.MAX_GOOGLE_STEPS || !planner.data.trip.steps[planner.data.trip.steps.length-1].place.address}"></div><div class="trip-steps-content"><div class="row"><div class="col-xs-7" data-ng-click="planner.dayCreate(planner.data.trip.steps.length-1)" data-ng-class="{\'disabled\': planner.data.trip.steps.length >= planner.MAX_GOOGLE_STEPS || !planner.data.trip.steps[planner.data.trip.steps.length-1].place.address}"><span class="add"><span class="icon icon-add"></span>Aggiungi Giorno</span></div></div></div></li></ul></ul><div class="warn collapse-step" data-ng-switch="planner.warning" data-ng-if="planner.warning"><p data-ng-switch-when="1">Controlla che tutti i campi siano correttamente compilati prima di aggiungere una nuova tappa.</p><p data-ng-switch-when="2">Ti sei dimenticato di inserire la data di partenza dall\'ultima tappa.</p><p data-ng-switch-when="3">Ti sei dimenticato di inserire l\'arrivo nell\'ultima tappa.</p><p data-ng-switch-when="4">Controlla di aver compilato tutti i campi correttamente.</p><p data-ng-switch-when="5">Ti sei dimenticato di inserire il numero di passeggeri.</p><p data-ng-switch-when="6">Il numero di passeggeri non pu\xF2 essere inferiore di 1.</p><p data-ng-switch-when="7">Il numero di passeggeri non pu\xF2 essere maggiore di 9999.</p></div></form>');
$templateCache.put('app/elements/requirements/requirements.html','<section class="requirements" id="requirements"><div class="container"><div class="intro"><h3>I requisiti per entrare nel Club di Busrapido</h3><p>\u200B\u200BIl Club di Busrapido offre una vetrina esclusiva per tutte le aziende di noleggio autobus che lavorano con i pi\xF9 alti standard di qualit\xE0 e professionalit\xE0:</p></div><div class="row"><div class="col-xs-12 col-sm-4"><div class="icon-circle icon-documentation firt-circle"></div><div class="whiteframe-container whiteframe arrow-top"><div class="content content-evidence"><h4>Documentazione in regola</h4><p>Per diventare partner di Busrapido la tua azienda deve essere in possesso di tutti i permessi, licenze, autorizzazioni e requisiti necessari per svolgere il servizio di trasporto persone in modo conforme alla legge.</p></div></div></div><div class="col-xs-12 col-sm-4"><div class="icon-circle icon-new"></div><div class="whiteframe-container whiteframe arrow-top"><div class="content content-evidence"><h4>Veicoli nuovi</h4><p>\u200B\u200B\u200BBusrapido lavora solo con veicoli immatricolati da meno di 15 anni e con classe ambientale uguale o superiore ad Euro 3, cos\xEC da garantire uno standard di servizio ai clienti che vogliono acquistare online.</p></div></div></div><div class="col-xs-12 col-sm-4"><div class="icon-circle icon-assurance"></div><div class="whiteframe-container whiteframe arrow-top"><div class="content content-evidence"><h4>Massimale assicurativo</h4><p>\u200BBusrapido lavora solo con autobus a noleggio con massimali assicurativi superiori a 30 milioni di euro, per garantire i pi\xF9 alti standard di sicurezza ai clienti che vogliono acquistare online.</p></div></div></div></div></div></section>');
$templateCache.put('app/elements/saysaboutus/saysaboutus.html','<section class="saysaboutus" id="saysaboutus"><div class="intro"><h3>Dicono di noi</h3><p>Direttamente dai nostri partner</p></div><div class="container"><div class="details row"><div class="col-xs-12 col-sm-4"><div class="whiteframe-container whiteframe arrow-bottom"><div class="content"><p>"Busrapido.com \xE8 un opportunit\xE0 per far conoscere la nostra azienda e i nostri servizi a milioni di viaggiatori."</p></div></div><div class="client"><div class="quote"><i class="icon icon-quote-left"></i></div><div class="info"><span class="name">Giancarlo P.</span><div class="company">Autoservizi Meridionali,</div><div class="company">Napoli</div></div><div class="image"><img src="assets/images/saysaboutus/pic_1.jpg" alt="Giancarlo Pannella"/></div></div></div><div class="col-xs-12 col-sm-4"><div class="whiteframe-container whiteframe arrow-bottom"><div class="content"><p>"Ci hanno portato pi\xF9 di 100.000\u20AC di fatturato in meno di un anno. All\'inizio quasi non ci credevo!"</p></div></div><div class="client"><div class="quote"><i class="icon icon-quote-left"></i></div><div class="info"><span class="name">Alessio T.</span><div class="company">Maxima Travel,</div><div class="company">Roma</div></div><div class="image"><img src="assets/images/saysaboutus/pic_2.jpg" alt="Alessio Tinti"/></div></div></div><div class="col-xs-12 col-sm-4"><div class="whiteframe-container whiteframe arrow-bottom"><div class="content"><p>"Il loro servizio clienti \xE8 fantastico. Sanno davvero come prendersi cura dei clienti e dei partner."</p></div></div><div class="client"><div class="quote"><i class="icon icon-quote-left"></i></div><div class="info"><span class="name">Matteo M.</span><div class="company">Meo Matteo Srl,</div><div class="company">Messina</div></div><div class="image"><img src="assets/images/saysaboutus/pic_3.jpg" alt="Matteo Meo"/></div></div></div></div></div></section>');
$templateCache.put('app/elements/signup/signup.html','<div class="auth"><form class="auth" novalidate="" data-ng-if="auth.mode === \'signin\'" data-ng-submit="auth.processSignin()"><div class="row"><div class="col-xs-12"><label><div class="top"><span class="label">La tua email</span></div><input type="email" name="email" placeholder="Email" data-ng-model="auth.user.signin.email" data-br-no-email-validation=""></label></div><div class="col-xs-12"><label><div class="top"><span class="label">La tua password</span></div><input type="password" name="password" placeholder="Password" data-br-password="" data-ng-model="auth.user.signin.password"></label></div></div><div class="warn collapse-step" data-ng-if="auth.user.signin.warning"><p>{{auth.user.signin.warning}}</p></div><div class="row"><div class="col-xs-12" data-ng-class="{\'disabled\': (!auth.user.signin.email || !auth.user.signin.password || !auth.enabled) }"><button type="submit" class="btn btn-lg btn-primary btn-block" data-ng-disabled="!auth.enabled">Accedi</button></div></div><div class="row"><div class="col-xs-12 col-sm-6"><p class="bottom left">Non hai un account? <a data-ng-click="auth.changeMode(\'signup\')">Registrati</a></p></div><div class="col-xs-12 col-sm-6"><p class="bottom right">Non ricordi la password? <a data-ng-click="auth.changeMode(\'recover\')">Recuperala</a></p></div></div></form><form class="auth" novalidate="" data-ng-if="auth.mode === \'recover\'" data-ng-submit="auth.processRecover()"><div class="row"><div class="col-xs-12"><label><div class="top"><span class="label">La tua email</span></div><input type="email" name="email" placeholder="Email" data-ng-model="auth.user.recover.email" data-br-no-email-validation=""></label></div></div><div class="warn collapse-step" data-ng-if="auth.user.recover.warning"><p>{{auth.user.recover.warning}}</p></div><div class="row"><div class="col-xs-12" data-ng-class="{\'disabled\': (!auth.user.recover.email || !auth.enabled)}"><button type="submit" class="btn btn-lg btn-primary btn-block" data-ng-disabled="!auth.enabled">Recupera password</button></div></div><div class="row"><div class="col-xs-12 col-sm-6"><p class="bottom left">Non hai un account? <a data-ng-click="auth.changeMode(\'signup\')">Registrati</a></p></div><div class="col-xs-12 col-sm-6"><p class="bottom right">Sei gi\xE0 un membro di Busrapido? <a data-ng-click="auth.changeMode(\'signin\')">Accedi</a></p></div></div></form><form class="auth" novalidate="" data-ng-if="auth.mode === \'reset\'" data-ng-submit="auth.processReset()"><div class="row"><div class="col-xs-12"><label><div class="top"><span class="label">Password</span></div><input type="password" name="password" placeholder="Inserisci la nuova password" data-br-password="" data-ng-model="auth.user.reset.password"></label></div></div><div class="warn collapse-step" data-ng-if="auth.user.reset.warning"><p>{{auth.user.reset.warning}}</p></div><div class="row"><div class="col-xs-12" data-ng-class="{\'disabled\': (!auth.user.reset.password || !auth.enabled)}"><button type="submit" class="btn btn-lg btn-primary btn-block" data-ng-disabled="!auth.enabled">Reimposta password</button></div></div><div class="row"><div class="col-xs-12 col-sm-5"><p class="bottom left">Ti sei ricordato la password? <a data-ng-click="auth.changeMode(\'signin\')">Accedi</a></p></div><div class="col-xs-12 col-sm-7"><p class="bottom right">La reimpostazione \xE8 fallita? <a data-ng-click="auth.changeMode(\'recover\')">Recuperala</a></p></div></div></form><form class="auth" novalidate="" data-ng-if="auth.mode === \'signup\'" data-ng-submit="auth.processSignup()"><div class="row"><div class="col-xs-6"><label><div class="top"><span class="label">Nome*</span></div><input type="text" name="name" placeholder="Inserisci il nome del responsabile" data-ng-model="auth.user.signup.name"></label></div><div class="col-xs-6"><label><div class="top"><span class="label">Cognome*</span></div><input type="text" name="surname" placeholder="Inserisci il cognome del responsabile" data-ng-model="auth.user.signup.surname"></label></div></div><div class="row"><div class="col-xs-12"><label><div class="top"><span class="label">Nome dell\'azienda*</span></div><input type="text" name="companyname" placeholder="Inserisci il nome dell\'azienda" data-ng-model="auth.user.signup.companyname"></label></div></div><div class="row"><div class="col-xs-12"><label><div class="top"><span class="label">Indirizzo email*</span></div><input type="email" name="email" placeholder="Inserisci l\'indirizzo email" data-ng-model="auth.user.signup.email" data-br-no-email-validation=""></label></div></div><div class="row"><div class="col-xs-12"><label><div class="top"><span class="label">Password*</span></div><input type="password" name="password" placeholder="Inserisci la password" data-br-password="" data-ng-model="auth.user.signup.password"></label></div></div><div class="row"><div class="col-xs-12"><h2>Dati responsabile servizio di noleggio</h2></div></div><div class="row"><div class="col-xs-12"><label><div class="top"><span class="label">Nome*</span></div><input type="text" name="name" placeholder="Inserisci il telefono del resposabile" data-ng-model="auth.user.signup.phone"></label></div></div><div class="row"><div class="col-xs-12"><label><div class="top"><span class="label">Ragione sociale*</span></div><input type="text" name="company" placeholder="Inserisci il nome dell\'azienda" data-ng-model="auth.user.signup.company"></label></div></div><div class="row"><div class="col-xs-12"><label><div class="top"><span class="label">Numero di telefono aziendale*</span></div><input type="text" name="companyphone" placeholder="Inserisci il numero di telefono dell\'azienda" data-ng-model="auth.user.signup.companyphone"></label></div></div><div class="row"><div class="col-xs-12"><label><div class="top"><span class="label">Numero di telefono emergenze/H24*</span></div><input type="text" name="emergencyphone" placeholder="Inserisci il numero di telefono emergenze/H24 dell\'azienda" data-ng-model="auth.user.signup.emergencyphone"></label></div></div><div class="row"><div class="col-xs-12"><label><div class="top"><span class="label">Partita IVA*</span></div><input type="text" name="taxcode" placeholder="Inserisci la partita IVA dell\'azienda" data-ng-model="auth.user.signup.taxcode"></label></div></div><div class="row"><div class="col-xs-12"><data-br-placepicker data-br-label="Sede legale*" data-br-placeholder="Inserisci l\'indirizzo di fatturazione dell\'azienda" data-br-to="auth.user.signup.place"></data-br-placepicker></div></div><div class="warn collapse-step" data-ng-if="auth.user.signup.warning"><p>{{auth.user.signup.warning}}</p></div><div class="row"><div class="col-xs-12"><span class="terms">*Creando un account come partner, accetti automaticamente i <a href="{{auth.$users}}/it/termini-condizioni/generali/" target="_blank">Termini e Condizioni</a> e l\'<a href="{{auth.$users}}/it/termini-condizioni/privacy/" target="_blank">Informativa sulla Privacy</a> di Busrapido.</span></div></div><div class="row"><div class="col-xs-12" data-ng-class="{\'disabled\': (!auth.user.signup.name || !auth.user.signup.surname || !auth.user.signup.phone || !auth.user.signup.email || !auth.user.signup.password || !auth.user.signup.companyphone || !auth.user.signup.emergencyphone || !auth.user.signup.taxcode || !auth.user.signup.place.address || !auth.enabled) }"><button type="submit" class="btn btn-lg btn-primary btn-block" data-ng-disabled="!auth.enabled">Registrati</button></div></div><div class="row"><div class="col-xs-12"><p class="bottom">Sei gi\xE0 un partner di Busrapido? <a data-ng-click="auth.changeMode(\'signin\')">Accedi</a></p></div></div></form></div>');
$templateCache.put('app/elements/successstories/saysaboutus.html','<section class="saysaboutus"><div class="padded-line-sm text-center"><h5><b>Storie di successo</b></h5></div><div class=""><div class="details row"><div class="col-xs-12 col-sm-4 no-margin no-padding"><div class="whiteframe-container whiteframe arrow-bottom"><div class="content"><p>"Busrapido.com \xE8 un opportunit\xE0 per far conoscere la nostra azienda e i nostri servizi a milioni di viaggiatori."</p></div></div><div class="client"><div class="quote"><i class="icon icon-quote-left"></i></div><div class="info"><span class="name">Giancarlo P.</span><div class="company">Autoservizi Meridionali,</div><div class="company">Napoli</div></div><div class="image"><img src="assets/images/saysaboutus/pic_1.jpg" alt="Giancarlo Pannella"/></div></div></div><div class="col-xs-12 col-sm-4 small-padding"><div class="whiteframe-container whiteframe arrow-bottom"><div class="content"><p>"Ci hanno portato pi\xF9 di 100.000\u20AC di fatturato in meno di un anno. All\'inizio quasi non ci credevo!"</p></div></div><div class="client"><div class="quote"><i class="icon icon-quote-left"></i></div><div class="info"><span class="name">Alessio T.</span><div class="company">Maxima Travel,</div><div class="company">Roma</div></div><div class="image"><img src="assets/images/saysaboutus/pic_2.jpg" alt="Alessio Tinti"/></div></div></div><div class="col-xs-12 col-sm-4 no-margin no-padding"><div class="whiteframe-container whiteframe arrow-bottom"><div class="content"><p>"Il loro servizio clienti \xE8 fantastico. Sanno davvero come prendersi cura dei clienti e dei partner."</p></div></div><div class="client"><div class="quote"><i class="icon icon-quote-left"></i></div><div class="info"><span class="name">Matteo M.</span><div class="company">Meo Matteo Srl,</div><div class="company">Messina</div></div><div class="image"><img src="assets/images/saysaboutus/pic_3.jpg" alt="Matteo Meo"/></div></div></div></div></div></section>');
$templateCache.put('app/elements/whyus/whyus.html','<section class="whyus"><div class="container"><div class="intro"><h3>Perch\xE9 Busrapido</h3></div><div class="row"><div class="col-xs-12"><p>Busrapido \xE8 il primo motore di ricerca in Italia dove poter noleggiare pullman, con conducente, online.<br/>Vogliamo rendere possibile per tutti noleggiare autobus, minibus e van con conducente online,<br/>mostrando la migliore soluzione disponibile in tempo reale.</p></div></div></div></section>');
$templateCache.put('app/views/abstracts/general.html','<div data-ui-view=""></div>');
$templateCache.put('app/views/abstracts/root.html','<data-br-cookielaw></data-br-cookielaw><data-br-navbar></data-br-navbar><div data-ui-view=""></div>');
$templateCache.put('app/views/abstracts/supplier.html','<data-br-complete-registration></data-br-complete-registration><data-br-confirmemail></data-br-confirmemail><div class="subnav" data-ng-if="$state.current.authenticate"><div class="container"><ul class="subnav-list"><li data-ng-class="{\'active\': $state.includes(\'root.it.supplier.quotes\') && !$state.includes(\'root.it.supplier.quotes.accepted\')}"><a data-ui-sref="root.it.supplier.quotes.list">Nuove Richieste</a></li><li data-ng-class="{\'active\': $state.includes(\'root.it.supplier.quotes.accepted\')}"><a data-ui-sref="root.it.supplier.quotes.accepted">Prenotazioni</a></li><li data-ng-class="{\'active\': $state.includes(\'root.it.supplier.sentquotes\')}"><a data-ui-sref="root.it.supplier.sentquotes.list">Servizi</a></li><li data-ng-class="{\'active\': $state.includes(\'root.it.supplier.pricing\')}"><a data-ui-sref="root.it.supplier.pricing.list">Tariffario</a></li><li data-ng-class="{\'active\': $state.includes(\'root.it.supplier.network\')}"><a data-ui-sref="root.it.supplier.network.list">Network</a></li><li data-ng-class="{\'active\': $state.includes(\'root.it.supplier.vehicles\')}"><a data-ui-sref="root.it.supplier.vehicles.list">Veicoli</a></li><li data-ng-class="{\'active\': $state.includes(\'root.it.supplier.black-list\')}"><a data-ui-sref="root.it.supplier.black-list">Black List</a></li></ul></div></div><div data-ui-view=""></div>');
$templateCache.put('app/views/external/details.html','<update-title title="Nuove prenotazioni | Busrapido"></update-title><update-meta property="og:title" content="Nuove prenotazioni | Busrapido"></update-meta><update-meta name="twitter:title" content="Nuove prenotazioni | Busrapido"></update-meta><main class="main-trips"><div class="loader-container loader-icon-container" data-ng-class="{\'loader-show\' : !vm.loaded}"><div class="loader-icon">Loading...</div></div><section data-ng-if="vm.loaded"><div class="container"><data-br-quote-details data-br-quote="vm.quote"></data-br-quote-details></div></section></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/landing/e404.html','<update-title title="Pagina non trovata | Busrapido"></update-title><update-meta property="og:title" content="Pagina non trovata | Busrapido"></update-meta><update-meta name="twitter:title" content="Pagina non trovata | Busrapido"></update-meta><update-meta name="description" content="Busrapido \xE8 il migliore motore di ricerca per il noleggio di pullman e pulmini in Europa. Scopri le offerte pi\xF9 vantaggiose e prenota il tuo pullman online."></update-meta><main class="main-e404"><div class="container"><div class="row"><div class="col-xs-12"><ol class="whiteframe-container"><li class="whiteframe"><article class="content content-nocontent"><p><span class="icon icon-emo-unhappy"></span></p><p class="message">Non troviamo la pagina che stai cercando.</p><p>Torna alla <a data-ui-sref="root.it.home">home</a></p></article></li></ol></div></div></div></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/landing/loading.html','<update-title title="Pagina non trovata | Busrapido"></update-title><update-meta property="og:title" content="Pagina non trovata | Busrapido"></update-meta><update-meta name="twitter:title" content="Pagina non trovata | Busrapido"></update-meta><update-meta name="description" content="Busrapido \xE8 il migliore motore di ricerca per il noleggio di pullman e pulmini in Europa. Scopri le offerte pi\xF9 vantaggiose e prenota il tuo pullman online."></update-meta><main class="main-e404"><div class="container"><div class="row"><div class="col-xs-12"><iframe style="min-height: 80vh" src="https://docs.google.com/document/d/e/2PACX-1vQ4zw-2z6y4xvZdauHDklU87qfmBE11Rf0dsMTVnCWTvQsEwb9fGqeGSOAv4kUK5q1WRUw8ptRL0U3Y/pub?embedded=true"></iframe></div></div></div></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/landing/suppliers.html','<update-title title="Valorizza i tuoi pullman | Busrapido"></update-title><update-meta property="og:title" content="Valorizza i tuoi pullman | Busrapido"></update-meta><update-meta name="twitter:title" content="Valorizza i tuoi pullman | Busrapido"></update-meta><main class="main-suppliers"><section id="vendor-signup" class="jumbo-container jumbo-primary jumbo-opacity header"><div class="jumbo-content" data-ng-if="!vm.auth"><h1>Unisciti a <span>Busrapido</span></h1><h2>I tuoi clienti ti aspettano. Entra nel Club di Busrapido e raddoppia i tuoi guadagni.</h2><a data-ui-sref="root.it.supplier.signup" data-br-track="Click Signup"><button class="btn btn-lg btn-primary">Entra nel club</button></a></div><div class="jumbo-content" data-ng-if="vm.auth"><h1>Benvenuto su <span>Busrapido</span></h1><a data-ui-sref="root.it.supplier.signup"><button class="btn btn-lg btn-primary">Vai al tuo profilo</button></a></div></section><data-br-whyus></data-br-whyus><data-br-advantages></data-br-advantages><div class="container"><data-br-dashboard data-br-header="\'Scopri la nuova\'" data-br-action="\'Diventa Partner!\'" data-br-target="\'root.it.supplier.signup\'"></data-br-dashboard><data-br-offering></data-br-offering></div><data-br-clients></data-br-clients><data-br-requirements></data-br-requirements><data-br-howitoworks></data-br-howitoworks><data-br-saysaboutus></data-br-saysaboutus><section class="conventions"><div class="container"><div class="intro"><h3>Altri vantaggi</h3><p>Entrando nel nostro club potrai usufruire di numerose convenzioni</p></div><div class="row"><div class="col-xs-12 col-sm-4"><a href="http://www.trasportopersone.it" target="_blank"><img src="assets/images/conventions/logo-trasporto-persone.svg" alt="Trasporto Persone"></a></div><div class="col-xs-12 col-sm-4"><a href="http://finaxit.com" target="_blank"><img src="assets/images/conventions/finaxit.png" alt="FINAXIT"></a></div><div class="col-xs-12 col-sm-4"><a href="https://www.sengerio.com/it/" target="_blank"><img src="assets/images/conventions/logo-sengerio.svg" alt="Sengerio"></a></div></div><div class="row"><div class="col-xs-12"><a data-ui-sref="root.it.supplier.signup" data-br-track="Click Signup"><button class="btn btn-lg btn-primary">Entra nel club</button></a></div></div></div></section></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/supplier/accepted.html','<update-title title="Nuove prenotazioni | Busrapido"></update-title><update-meta property="og:title" content="Nuove prenotazioni | Busrapido"></update-meta><update-meta name="twitter:title" content="Nuove prenotazioni | Busrapido"></update-meta><main class="main-trips"><div class="loader-container loader-icon-container" data-ng-class="{\'loader-show\' : !vm.loaded}"><div class="loader-icon">Loading...</div></div><section data-ng-if="vm.loaded"><div class="container-xl"><div class="row"><div class="col-xs-12"><div class="whiteframe-container whiteframe"><div class="content content-float"><div class="left"><div class="row"><input type="text" placeholder="Numero prenotazione" data-ng-model="vm.number" data-ng-keydown="$event.keyCode === 13 && vm.search(vm.number)"> <button class="btn btn-md btn-primary" data-ng-click="vm.search(vm.number)">Cerca</button><div class="col-xs"><p>Mostra: <select name="filters" data-ng-model="vm.show"><option value=""></option><option value="request">Prenotazioni</option><option value="other">Opzioni</option><option value="onlyrequest">Only for you - Prenotazioni</option><option value="onlyother">Only for you - Opzioni</option></select></p></div></div></div></div></div><div class="whiteframe-container whiteframe"><div class="content content-float"><div class="row"><div><div class="top">Filtri</div><div class="row no-margin"><div><button class="btn btn-md btn-outline" data-ng-click="vm.openFilters()" data-ng-class="{\'disabled\': !vm.filtersLoaded, \'enabled\': vm.filtersLoaded}" data-ng-disabled="!vm.filtersLoaded"><span class="icon icon-sliders"></span> Seleziona</button></div><div><button class="btn btn-md btn-outline" tooltips="" tooltip-template="Salva questo filtro" tooltip-side="right" data-ng-click="vm.saveFilter(vm.currentFilter)" data-ng-class="{\'disabled\': !vm.filtersLoaded, \'enabled\': vm.filtersLoaded}" data-ng-disabled="!vm.filtersLoaded"><span class="icon icon-floppy"></span> Salva</button></div></div></div><div class="content"></div><div><div class="top">Selezione</div><div class="row no-margin"><div><button class="btn btn-md btn-outline" data-ng-click="vm.export()" data-ng-class="{\'disabled\': vm.gridApi.selection.getSelectedRows().length === 0, \'enabled\': vm.gridApi.selection.getSelectedRows().length !== 0}" data-ng-disabled="vm.gridApi.selection.getSelectedRows().length === 0"><span class="icon icon-download"></span> Scarica come csv</button></div></div></div><div class="content"></div><div><div class="top">Prenotazioni</div><div class="row no-margin"><div><button class="btn btn-md btn-outline" data-ng-click="vm.reload()"><span class="icon icon-arrows-cw"></span> Aggiorna</button><data-br-dropdown></data-br-dropdown></div></div></div><div class="content"></div><div><div class="top">Livello di zoom</div><label><select data-ng-change="vm.resize(vm.zoom)" data-ng-model="vm.zoom"><option data-ng-value="50">50%</option><option data-ng-value="60">60%</option><option data-ng-value="70">70%</option><option data-ng-value="80">80%</option><option data-ng-value="90">90%</option><option data-ng-value="100">100%</option><option data-ng-value="110">110%</option><option data-ng-value="120">120%</option><option data-ng-value="130">130%</option></select></label></div></div></div></div><div class="whiteframe-container whiteframe table-container"><div data-ui-grid="vm.gridOptions" data-ng-style="vm.gridStyle" data-ui-grid-auto-resize="" data-ui-grid-pagination="" data-ui-grid-selection="" data-ui-grid-pinning=""></div></div></div></div></div></section></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/supplier/black-list.html','<update-title title="Black List | Busrapido"></update-title><update-meta property="og:title" content="Black List | Busrapido"></update-meta><update-meta name="twitter:title" content="Black List | Busrapido"></update-meta><main class="main-black-list"><section><div class="container"><div class="row"><div class="col-xs-12"><div class="whiteframe-container whiteframe"><div class="content"><p>Questo file \xE8 un supporto per la nostra comunit\xE0 di partner. Creato grazie alle vostre segnalazioni.</p><p>Per aggiunte, modifiche o correzioni scrivete a <a href="mailto:info@busrapido.com">info@busrapido.com</a> con oggetto: "Modifica Black List"</p></div></div></div><div class="col-xs-12"><div class="whiteframe-container whiteframe"><iframe class="spreadsheet" src="https://docs.google.com/spreadsheets/d/e/2PACX-1vR50Vl_GsVHU_AsqMVjxePJAJ8tgA35UUXefZFWrWMOUyQ-gpFx9SJNt2nEiWRAkZ7J0GCpziC2lfl9/pubhtml?widget=true&headers=false"></iframe></div></div></div></div></section></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/supplier/confirm.html','<update-title title="Conferma email | Busrapido"></update-title><update-meta property="og:title" content="Conferma email | Busrapido"></update-meta><update-meta name="twitter:title" content="Conferma email | Busrapido"></update-meta><main class="main-searches"><div class="loader-container loader-icon-container" data-ng-class="{\'loader-show\' : !vm.loaded}"><div class="loader-icon">Loading...</div></div><section data-ng-if="vm.loaded"><div class="container"><div class="row"><div class="col-xs-12"><ol class="whiteframe-container"><li class="whiteframe" data-ng-if="vm.confirmed"><article class="content content-nocontent"><p><span class="icon icon-emo-happy"></span></p><p class="message">La tua mail \xE8 stata confermata con successo.</p><p>Torna alle tue <a data-ui-sref="root.it.supplier.quotes.list">prenotazioni</a>.</p></article></li><li class="whiteframe" data-ng-if="vm.already"><article class="content content-nocontent"><p><span class="icon icon-emo-happy"></span></p><p class="message">Il tuo account \xE8 gi\xE0 stato verificato.</p><p>Torna alle tue <a data-ui-sref="root.it.supplier.quotes.list">prenotazioni</a>.</p></article></li><li class="whiteframe" data-ng-if="vm.failed"><article class="content content-nocontent"><p><span class="icon icon-emo-unhappy"></span></p><p class="message">La richiesta di verifica dell\'email \xE8 fallita.</p><p>Invia nuovamente la mail di verifica <span class="a" data-ng-click="vm.sendConfirmation()">cliccando qui</span>.</p></article></li></ol></div></div></div></section></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/supplier/credentials.html','<div data-ng-switch="vm.mode"><div data-ng-switch-when="signin"><update-title title="Effettua l\'accesso come partner | Busrapido"></update-title><update-meta property="og:title" content="Effettua l\'accesso come partner | Busrapido"></update-meta><update-meta name="twitter:title" content="Effettua l\'accesso come partner | Busrapido"></update-meta></div><div data-ng-switch-when="signup"><update-title title="Effettua la registrazione | Busrapido"></update-title><update-meta property="og:title" content="Effettua la registrazione come partner | Busrapido"></update-meta><update-meta name="twitter:title" content="Effettua la registrazione come partner | Busrapido"></update-meta></div><div data-ng-switch-when="recover"><update-title title="Recupera la password partner | Busrapido"></update-title><update-meta property="og:title" content="Recupera la password partner | Busrapido"></update-meta><update-meta name="twitter:title" content="Recupera la password partner | Busrapido"></update-meta></div><div data-ng-switch-when="reset"><update-title title="Reimposta la password partner | Busrapido"></update-title><update-meta property="og:title" content="Reimposta la password partner | Busrapido"></update-meta><update-meta name="twitter:title" content="Reimposta la password partner | Busrapido"></update-meta></div></div><main class="main-signin"><div class="container"><div class="auth"><h3 class="top-title" data-ng-if="vm.mode == \'signin\'">Effettua l\'accesso come partner</h3><h3 class="top-title" data-ng-if="vm.mode == \'recover\'">Recupera la password partner</h3><h3 class="top-title" data-ng-if="vm.mode == \'reset\'">Reimposta la password partner</h3><data-br-auth data-br-mode="vm.mode" data-br-data="vm.data" data-br-on-mode-change="vm.onAuthModeChange()"></data-br-auth></div></div></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/supplier/details.html','<update-title title="{{vm.quote.Quote.id | quoteId}}_Busrapido"></update-title><update-meta property="og:title" content="{{vm.quote.Quote.id | quoteId}}_Busrapido"></update-meta><update-meta name="twitter:title" content="{{vm.quote.Quote.id | quoteId}}_Busrapido"></update-meta><main class="main-trips"><div class="loader-container loader-icon-container" data-ng-class="{\'loader-show\' : !vm.loaded}"><div class="loader-icon">Loading...</div></div><section data-ng-if="vm.loaded"><div class="container"><data-br-quote-details data-br-quote="vm.quote"></data-br-quote-details></div></section></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/supplier/places.add.html','<update-title title="Aggiungi una sede | Busrapido"></update-title><update-meta property="og:title" content="Aggiungi una sede | Busrapido"></update-meta><update-meta name="twitter:title" content="Aggiungi una sede | Busrapido"></update-meta><main class="main-places"><div class="loader-container loader-icon-container" data-ng-class="{\'loader-show\' : !vm.loaded}"><div class="loader-icon">Loading...</div></div><section data-ng-if="vm.loaded"><div class="container"><div class="row"><div class="col-xs-12"><div class="whiteframe-container whiteframe"><div class="content content-float"><div class="left"><a class="btn btn-sm btn-primary" data-ui-sref="root.it.supplier.places.list"><span class="icon icon-arrow-left"></span> Indietro</a></div></div></div><div class="whiteframe-container whiteframe" data-ng-if="!vm.activated"><div class="content content-nocontent"><p><span class="icon icon-emo-unhappy"></span></p><p class="message">Account non verificato</p><p>Prima di poter aggiungere una nuova sede, devi verificare il tuo indirizzo email.</p></div></div><div class="whiteframe-container whiteframe" data-ng-if="vm.activated"><div class="content-map"><data-br-markers data-br-waypoints="vm.place" data-br-object="location" data-br-zoom="4"></data-br-markers></div><div class="content content-form"><form novalidate="" data-ng-submit="vm.addPlace()"><data-br-placepicker data-br-label="Indirizzo della sede da dove partono i veicoli" data-br-placeholder="Inserisci la via della sede che vuoi aggiungere" data-br-to="vm.place"></data-br-placepicker><div class="warn" data-ng-if="vm.warning"><p>{{vm.warning}}</p></div><button type="submit" class="btn btn-lg btn-primary btn-mrg-top btn-block">Aggiungi</button></form></div></div></div></div></div></section></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/supplier/places.edit.html','<update-title title="Modifica una sede | Busrapido"></update-title><update-meta property="og:title" content="Modifica una sede | Busrapido"></update-meta><update-meta name="twitter:title" content="Modifica una sede | Busrapido"></update-meta><main class="main-places"><div class="loader-container loader-icon-container" data-ng-class="{\'loader-show\' : !vm.loaded}"><div class="loader-icon">Loading...</div></div><section data-ng-if="vm.loaded"><div class="container"><div class="row"><div class="col-xs-12"><div class="whiteframe-container whiteframe"><div class="content content-float"><div class="left"><a class="btn btn-sm btn-primary" data-ui-sref="root.it.supplier.places.list"><span class="icon icon-arrow-left"></span> Indietro</a></div></div></div><div class="whiteframe-container whiteframe"><div class="content-map"><data-br-markers data-br-waypoints="vm.place" data-br-object="place.location" data-br-zoom="4"></data-br-markers></div><div class="content content-form"><form novalidate="" data-ng-submit="vm.updatePlace()"><data-br-placepicker data-br-label="Indirizzo della sede da dove partono i veicoli" data-br-placeholder="Inserisci la via della sede che vuoi aggiungere" data-br-to="vm.place.place">{{vm.place}}</data-br-placepicker><div class="warn" data-ng-if="vm.warning"><p>{{vm.warning}}</p></div><button type="submit" class="btn btn-lg btn-primary btn-mrg-top btn-block">Salva modifiche</button></form></div></div></div></div></div></section></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/supplier/places.html','<update-title title="Sedi | Busrapido"></update-title><update-meta property="og:title" content="Sedi | Busrapido"></update-meta><update-meta name="twitter:title" content="Sedi | Busrapido"></update-meta><main class="main-places"><div class="loader-container loader-icon-container" data-ng-class="{\'loader-show\' : !vm.loaded}"><div class="loader-icon">Loading...</div></div><section data-ng-if="vm.loaded"><div class="container"><div class="row"><div class="col-xs-12"><div class="whiteframe-container whiteframe"><div class="content content-float"><div class="left"><p>Mostrando <span data-ng-bind="filtered.length"></span> di <span data-ng-bind="::vm.places.length"></span> risultati</p></div><div class="right"><a class="btn btn-sm btn-primary" data-ui-sref="root.it.supplier.places.add">Aggiungi sede</a></div><p class="right">Mostra: <select name="filters" data-ng-model="vm.filters"><option value="all">Tutti</option><option value="enabled">Abilitate</option><option value="disabled">Disabilitate</option></select></p></div></div><ol class="whiteframe-container"><li class="whiteframe" data-ng-show="::vm.places.length < 1"><article class="content content-nocontent"><p><span class="icon icon-emo-happy"></span></p><p class="message">Non hai aggiunto ancora nessuna sede.</p><p>Aggiungi subito una <a data-ui-sref="root.it.supplier.places.add">nuova sede</a>.</p></article></li><li class="whiteframe" data-ng-show="vm.places.length > 0 && filtered.length === 0"><article class="content content-nocontent"><p><span class="icon icon-emo-unhappy"></span></p><p class="message">Nessuna sede da visualizzare</p><p>I filtri applicati non corrispondono a nessuna sede. <span class="a" data-ng-click="vm.filters = \'all\'">Visualizza tutte le sedi</span>.</p></article></li><li class="whiteframe" data-ng-repeat="place in vm.places | filter: vm.applyFilter as filtered track by place._id"><article class="content-items"><div class="row"><div class="col-xs-12 col-sm-3"><data-br-markers data-br-waypoints="::place.place" data-br-object="location"></data-br-markers></div><div class="col-xs re-padding-left-xs rm-padding-left-sm"><div class="row"><div class="col-xs"><div class="details"><h3>{{::place.place.address}}</h3></div></div><div class="col-xs-5"><div class="right-action"><a class="btn btn-sm btn-primary" data-ui-sref="root.it.supplier.places.edit(::{id: place._id})">Modifica</a> <button class="btn btn-sm btn-green" data-ng-if="place.disabled" data-ng-click="vm.setPlaceDisabledState(place, false)">Abilita</button> <button class="btn btn-sm btn-grey" data-ng-if="!place.disabled" data-ng-click="vm.setPlaceDisabledState(place, true)">Disabilita</button></div></div></div></div></div></article></li></ol></div></div></div></section></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/supplier/profile.html','<update-title title="Profilo | Busrapido"></update-title><update-meta property="og:title" content="Profilo | Busrapido"></update-meta><update-meta name="twitter:title" content="Profilo | Busrapido"></update-meta><main class="main-profile"><section><div class="container bootstrap"><div class="whiteframe-container"><div class="flex-sm-row row"><div class="whiteframe col-2 tab" data-ng-class="{\'active\' : vm.section === \'1\'}" data-ng-click="vm.navigateTo(\'root.it.supplier.profile.name\')"><div class="row no-margin"><span class="col-sm-12 col-md no-padding no-margin icon icon-ok-circle text-success"></span> <a class="warp">Account</a></div></div><div class="whiteframe col-2 tab" data-ng-class="{\'active\' : vm.section === \'2\'}" data-ng-click="vm.navigateTo(\'root.it.supplier.profile.poc\')"><div class="row no-margin"><span class="col-sm-12 col-md no-padding no-margin icon icon-ok-circle text-success" data-ng-if="vm.ok2"></span> <span class="col-sm-12 col-md no-padding no-margin icon icon-cancel text-warning" data-ng-if="!vm.ok2"></span> <a class="warp">Dati Responsabile</a></div></div><div class="whiteframe col-2 tab" data-ng-class="{\'active\' : vm.section === \'3\'}" data-ng-click="vm.navigateTo(\'root.it.supplier.profile.company\')"><div class="row no-margin"><span class="col-sm-12 col-md no-padding no-margin icon icon-ok-circle text-success" data-ng-if="vm.ok3"></span> <span class="col-sm-12 col-md no-padding no-margin icon icon-cancel text-warning" data-ng-if="!vm.ok3"></span> <a class="warp">Dati Azienda</a></div></div><div class="whiteframe col-2 tab" data-ng-class="{\'active\' : vm.section === \'5\'}" data-ng-click="vm.navigateTo(\'root.it.supplier.profile.additional\')"><div class="row no-margin"><span class="col-sm-12 col-md no-padding no-margin icon icon-ok-circle text-success" data-ng-if="vm.ok5"></span> <span class="col-sm-12 col-md no-padding no-margin icon icon-cancel text-warning" data-ng-if="!vm.ok5"></span> <a class="warp">Dati Aggiuntivi</a></div></div><div class="whiteframe col-2 tab" data-ng-class="{\'active\' : vm.section === \'7\'}" data-ng-click="vm.navigateTo(\'root.it.supplier.profile.notification\')"><div class="row no-margin"><span class="col-sm-12 col-md no-padding no-margin icon icon-ok-circle text-success" data-ng-if="vm.ok7"></span> <span class="col-sm-12 col-md no-padding no-margin icon icon-cancel text-warning" data-ng-if="!vm.ok7"></span> <a class="warp">Impostazione Notifiche</a></div></div><div class="whiteframe col-2 tab" data-ng-class="{\'active\' : vm.section === \'8\'}" data-ng-click="vm.navigateTo(\'root.it.supplier.profile.requesttypes\')"><div class="row no-margin"><span class="col-sm-12 col-md no-padding no-margin icon icon-ok-circle text-success" data-ng-if="vm.ok8"></span> <span class="col-sm-12 col-md no-padding no-margin icon icon-cancel text-warning" data-ng-if="!vm.ok8"></span> <a class="warp">Scheda dei Veicoli</a></div></div></div><div class="row"><div class="col-xs-12" data-ng-if="!vm.loaded"><div class="loader-container loader-icon-container" data-ng-class="{\'loader-show\' : !vm.loaded}"><div class="loader-icon">Loading...</div></div></div><div class="whiteframe"><div class="col-xs-12" data-ng-if="vm.loaded"><div class="whiteframe-container" data-ng-if="vm.step == 2"><div class="col-xs-12"><h3 class="top-title" data-ng-if="vm.step == 2">Benvenuto a bordo! <span style="color: red" class="icon icon-bus"></span></h3><p>Inizia col dirci il nome, il cognome e il numero di telefono cellulare del responsabile dei servizi di noleggio nella tua azienda.</p><h2 data-ng-if="vm.step == 3">Completa il tuo profilo per ricevere richieste</h2><h2 data-ng-if="vm.step >= 5">Completa il tuo profilo per ricevere pi\xF9 richieste</h2></div></div><form class="whiteframe-container" novalidate="" data-ng-class="{\' no-margin-top\': vm.step == 2}" data-ng-submit="vm.saveChanges($event)" data-ng-switch="vm.section"><data-br-name-step data-br-data="vm.user.signup" data-ng-switch-when="1" data-br-profile="true"></data-br-name-step><data-br-poc-step data-br-data="vm.user.signup" data-ng-switch-when="2"></data-br-poc-step><data-br-company-step data-br-data="vm.user.signup" data-ng-switch-when="3"></data-br-company-step><data-br-cheer-step data-br-data="vm.user.signup" data-ng-switch-when="4"></data-br-cheer-step><data-br-additional-step data-br-data="vm.user.signup" data-ng-switch-when="5"></data-br-additional-step><data-br-first-completed-step data-br-data="vm.user.signup" data-ng-switch-when="6"></data-br-first-completed-step><data-br-notification-step data-br-data="vm.user.signup" data-ng-switch-when="7"></data-br-notification-step><data-br-request-types-step data-br-data="vm.user.signup" data-ng-switch-when="8"></data-br-request-types-step><div novalidate="" data-ng-switch-when="password"><div class="heading"><h2>Modifica password</h2></div><div class="form-group"><div class="col-xs-12"><label>Vecchia password*</label><div class="input-group input-group-sm"><input class="form-control" type="password" data-br-password="" data-ng-model="vm.user.signup.opsswrd"><div class="invalid-feedback">Inserisci la vecchia password</div></div><i class="form-text text-muted">Lascia vuoto se non vuoi cambiare password</i></div></div><div class="form-group"><div class="col-xs-12"><label>Nuova password*</label><div class="input-group input-group-sm"><input class="form-control" type="password" data-br-password="" data-ng-model="vm.user.signup.psswrd"><div class="invalid-feedback">Inserisci la nuova password</div></div></div></div></div><div class="flex-column flex-sm-row row no-margin" data-ng-if="vm.ok"><div class="col-md-6 col-xs"><button class="btn btn-secondary" type="button" data-ng-click="vm.resetChanges();  $event.stopPropagation();" data-ng-cloak="">Annulla</button></div><div class="col-md-6 col-xs"><button class="btn btn-success" type="submit" data-ng-cloak="">Salva modifiche</button></div></div><div class="row no-margin" data-ng-if="!vm.ok"><div class="col-md-6 col-xs"><button class="btn btn-success" type="submit" data-ng-cloak="">Salva e Continua</button></div></div></form></div></div></div></div></div></section></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/supplier/quotes.html','<update-title title="Nuove prenotazioni | Busrapido"></update-title><update-meta property="og:title" content="Nuove prenotazioni | Busrapido"></update-meta><update-meta name="twitter:title" content="Nuove prenotazioni | Busrapido"></update-meta><main class="main-trips"><div class="loader-container loader-icon-container" data-ng-class="{\'loader-show\' : !vm.loaded}"><div class="loader-icon">Loading...</div></div><section data-ng-if="vm.loaded"><div class="container-xl"><div class="row"><div class="whiteframe-container whiteframe"><div class="content content-float"><div class="left"><div class="row"><input type="text" placeholder="Numero prenotazione" data-ng-model="vm.number" data-ng-keydown="$event.keyCode === 13 && vm.search(vm.number)"> <button class="btn btn-md btn-primary" data-ng-click="vm.search(vm.number)">Cerca</button><div class="col-xs"><p>Mostra: <select name="filters" data-ng-model="vm.show"><option value="">In attesa di conferma</option><option value="request">Prenotazioni</option><option value="other">Opzioni</option><option value="onlyrequest">Only for you - Prenotazioni</option><option value="onlyother">Only for you - Opzioni</option><option value="rejected">Rifiutate</option></select></p></div></div></div></div></div><div class="whiteframe-container whiteframe"><div class="content content-float"><div class="row"><div><div class="top">Filtri</div><div class="row no-margin"><div><button class="btn btn-md btn-outline" data-ng-click="vm.openFilters()" data-ng-class="{\'disabled\': !vm.filtersLoaded, \'enabled\': vm.filtersLoaded}" data-ng-disabled="!vm.filtersLoaded"><span class="icon icon-sliders"></span> Seleziona</button></div><div><button class="btn btn-md btn-outline" tooltips="" tooltip-template="Salva questo filtro" tooltip-side="right" data-ng-click="vm.saveFilter(vm.currentFilter)" data-ng-class="{\'disabled\': !vm.filtersLoaded, \'enabled\': vm.filtersLoaded}" data-ng-disabled="!vm.filtersLoaded"><span class="icon icon-floppy"></span> Salva</button></div></div></div><div class="content"></div><div><div class="top">Selezione</div><div class="row no-margin"><div><button class="btn btn-md btn-outline" data-ng-click="vm.export()" data-ng-class="{\'disabled\': vm.gridApi.selection.getSelectedRows().length === 0, \'enabled\': vm.gridApi.selection.getSelectedRows().length !== 0}" data-ng-disabled="vm.gridApi.selection.getSelectedRows().length === 0"><span class="icon icon-download"></span> Scarica come csv</button></div></div></div><div class="content"></div><div><div class="top">Prenotazioni</div><div class="row no-margin"><div><button class="btn btn-md btn-outline" data-ng-click="vm.reload()"><span class="icon icon-arrows-cw"></span> Aggiorna</button><data-br-dropdown></data-br-dropdown></div></div></div><div class="content"></div><div><div class="top">Livello di zoom</div><label><select data-ng-change="vm.resize(vm.zoom)" data-ng-model="vm.zoom"><option data-ng-value="50">50%</option><option data-ng-value="60">60%</option><option data-ng-value="70">70%</option><option data-ng-value="80">80%</option><option data-ng-value="90">90%</option><option data-ng-value="100">100%</option><option data-ng-value="110">110%</option><option data-ng-value="120">120%</option><option data-ng-value="130">130%</option></select></label></div></div></div></div><ol class="whiteframe-container whiteframe table-container" data-ng-if="!vm.hasSubscription()"><li class="whiteframe bootstrap"><article class="content content-nocontent"><p><span class="icon icon-emo-happy"></span></p><p class="message">Vuoi ricevere prenotazioni per aumentare il tuo fatturato o inviare le tue all\'interno della nostra rete?</p><button class="btn btn-success" data-ui-sref="root.it.supplier.subscribe.list">Join the club</button></article></li></ol><ol class="whiteframe-container whiteframe table-container" data-ng-if="!(vm.verified && vm.hasSubscription())"><li class="whiteframe"><article class="content content-nocontent"><p><span class="icon icon-emo-happy"></span></p><p class="message">Stiamo confermando i dati della tua registrazione</p><p>Se non vedi l\'ora di iniziare inviaci una email a <a href="mailto:info@busrapido.com" target="_blank" noreferrer="" noopener="">info@busrapido.com</a>!</p></article></li></ol><div class="whiteframe-container whiteframe table-container" data-ng-if="vm.verified"><div data-ui-grid="vm.gridOptions" data-ng-style="vm.gridStyle" data-ui-grid-auto-resize="" data-ui-grid-pagination="" data-ui-grid-selection="" data-ui-grid-pinning=""></div></div></div></div></section></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/supplier/trips.details.html','<update-title title="Dettagli prenotazione {{vm.trip._id}} | Busrapido"></update-title><update-meta property="og:title" content="Dettagli prenotazione {{vm.trip._id}} | Busrapido"></update-meta><update-meta name="twitter:title" content="Dettagli prenotazione {{vm.trip._id}} | Busrapido"></update-meta><main class="main-checkout"><div class="loader-container loader-icon-container" data-ng-class="{\'loader-show\' : !vm.loaded}"><div class="loader-icon">Loading...</div></div><section class="evidence-content" data-ng-show="vm.loaded"><div class="container"><div class="row"><div class="col-xs-12 col-md-8"><div class="row"><div class="col-xs-12 company-description"><h1>Prenotazione <span class="small">{{vm.trip._id}}</span></h1></div></div></div></div></div></section><section data-ng-show="vm.loaded"><div class="container overlappping-content"><div class="row whiteframe-container"><div class="col-xs-12 col-md-8"><ol><li class="whiteframe" data-ng-repeat="order in ::vm.trip.Orders | orderBy: \'-createdAt\' track by order._id"><div class="header"><div class="row"><div class="col-xs-5"><h4>Ordine <span class="small">{{order._id}}</span></h4></div><div class="col-xs-7"><div class="right" data-ng-if="order.status==\'pending\'"><a class="tag tag-yellow tag-sm" tooltips="" tooltip-template="Tu o un altro fornitore dovete ancora confermare questo ordine." tooltip-side="left" data-ui-sref="root.it.supplier.trips.order({id: order._id})">Da confermare!</a></div><div class="right" data-ng-if="order.status==\'accepted\'"><a class="tag tag-yellow tag-sm" tooltips="" tooltip-template="Devi attendere che il pagamento del cliente vada a buon fine o che gli altri ordini vengano confermati. Se ti sono stati richiesti pi\xF9 ordini, conferma anche gli altri." tooltip-side="left" data-ui-sref="root.it.supplier.trips.order({id: order._id})">In attesa <span class="icon icon-spin animate-spin"></span></a></div><div class="right" data-ng-if="order.status==\'confirmed\'"><a class="tag tag-green tag-sm" data-ui-sref="root.it.supplier.trips.order({id: order._id})">Confermato <span class="icon icon-thick"></span></a></div><div class="right" data-ng-if="order.status==\'voided\'"><a class="tag tag-red tag-sm" tooltips="" tooltip-template="Tu o un altro fornitore avete rifiutato questo ordine." tooltip-side="left" data-ui-sref="root.it.supplier.trips.order({id: order._id})">Rifiutato <span class="icon icon-cancel"></span></a></div><div class="right" data-ng-if="order.status==\'rejected\'"><a class="tag tag-red tag-sm" tooltips="" tooltip-template="Il cliente ha annullato questo ordine." tooltip-side="left" data-ui-sref="root.it.supplier.trips.order({id: order._id})">Annullato <span class="icon icon-cancel"></span></a></div><div class="right" data-ng-if="order.status==\'expired\'"><a class="tag tag-red tag-sm" tooltips="" tooltip-template="L\'ordine non \xE8 stato confermato in tempo." tooltip-side="left" data-ui-sref="root.it.supplier.trips.order({id: order._id})">Scaduto <span class="icon icon-cancel"></span></a></div></div></div></div><article><ul class="content-items"><li><div class="row"><div class="image col-xs-3 rm-padding-right-xs"><data-br-slider data-br-alt="Noleggio Pullman" data-br-imgs="order.Vehicle.imgs" data-br-sizes="{width: 280, height: 128}" data-br-cloudinary="true"></data-br-slider></div><div class="col-xs rm-padding-left-xs"><div class="row"><div class="col-xs"><div class="details"><h3>{{order.Vehicle.specs.manufacturer}} {{order.Vehicle.specs.model}} <span class="small">{{order.Vehicle.specs.matriculation}} - {{vm.emissionClass[order.Vehicle.specs.emissionClass]}}</span></h3><p>Posti: {{order.computed.seats.passengers}} <span tooltips="" tooltip-template="*Posti riservati a guide o accompagnatori turistici" tooltip-side="right" data-ng-if="order.computed.seats.drivers > 0">+ {{order.computed.seats.drivers}}*</span> | Autisti: {{order.computed.drivers}}</p></div></div><div class="col-xs-4 col-sm-3"><div class="price"><strong>{{order.computed.costs.trip.total | number:2}}\u20AC</strong></div></div></div><div class="row"><div class="col-xs"><div class="details"><p>Complessivo: <span class="icon icon-star"></span><span class="icon icon-star"></span><span class="icon icon-star" data-ng-show="vm.year-order.Vehicle.specs.matriculation <= 12"></span><span class="icon icon-star" data-ng-show="vm.year-order.Vehicle.specs.matriculation <= 9"></span><span class="icon icon-star" data-ng-show="vm.year-order.Vehicle.specs.matriculation <= 6"></span></p><p>Azienda: <span class="icon icon-star"></span><span class="icon icon-star"></span><span class="icon icon-star"></span><span class="icon icon-star"></span><span class="icon icon-star"></span> Veicolo: <span class="icon icon-star"></span><span class="icon icon-star" data-ng-show="vm.year-order.Vehicle.specs.matriculation <= 12"></span><span class="icon icon-star" data-ng-show="vm.year-order.Vehicle.specs.matriculation <= 9"></span><span class="icon icon-star" data-ng-show="vm.year-order.Vehicle.specs.matriculation <= 6"></span><span class="icon icon-star" data-ng-show="vm.year-order.Vehicle.specs.matriculation <= 3"></span></p></div></div></div><div class="row"><div class="col-xs"><div class="services-20"><ul><li data-ng-repeat="(key, service) in ::vm.services track by key" data-ng-class="::{\'active\': order.Vehicle.services[key]}"><span class="tooltip"><span class="icon" data-ng-class="::service.icon"></span> <span class="tip">{{::service.name}}</span></span></li></ul></div></div></div></div></div></li></ul></article><div class="content-itineray content-collpase" data-ng-if="order.itinerary"><data-br-htrip data-br-steps="order.trip.steps" data-br-legs="order.trip.legs"></data-br-htrip></div><div class="content-more"><div class="row"><div class="col-xs-8"><div class="left-action"><button class="btn btn-md btn-grey" data-ng-click="order.itinerary = false" data-ng-show="order.itinerary"><span class="icon icon-arrow-up"></span>Nascondi itinerario partner</button> <button class="btn btn-md btn-primary" data-ng-click="order.itinerary = true" data-ng-show="!order.itinerary"><span class="icon icon-arrow-down"></span>Mostra itinerario partner</button></div></div><div class="col-xs-4"><div class="right-action" data-ng-if="order.supplier_id == vm.supplier_id"><a class="btn btn-md btn-primary btn-block" data-ui-sref="root.it.supplier.trips.order({id: order._id})">Visualizza l\'ordine <span class="icon icon-arrow-right"></span></a></div></div></div></div></li></ol></div><div class="col-xs-12 col-md-4"><div class="whiteframe"><div class="header"><h4>Dettagli della prenotazione</h4></div><div class="content-checkout"><table><tbody><tr><td class="status colspan" colspan="2" data-ng-if="vm.trip.status==\'pending\'"><span class="state">Stato</span> <span class="tag tag-right tag-yellow tag-sm" tooltips="" tooltip-template="Ci sono ancora degli ordini non confermati per questa prenotazione." tooltip-side="left">In attesa di conferma</span></td><td class="status colspan" colspan="2" data-ng-if="vm.trip.status==\'accepted\'"><span class="state">Stato</span> <span class="tag tag-right tag-green tag-sm">Confermata <span class="icon icon-thick"></span></span></td><td class="status colspan" colspan="2" data-ng-if="vm.trip.status==\'rejected\'"><span class="state">Stato</span> <span class="tag tag-right tag-red tag-sm" tooltips="" tooltip-template="Tu o un altro fornitore avete rifiutato questa prenotazione." tooltip-side="left">Rifiutata</span></td><td class="status colspan" colspan="2" data-ng-if="vm.trip.status==\'voided\'"><span class="state">Stato</span> <span class="tag tag-right tag-red tag-sm" tooltips="" tooltip-template="Il cliente ha annullato questa prenotazione." tooltip-side="left">Annullata <span class="icon icon-cancel"></span></span></td><td class="status colspan" colspan="2" data-ng-if="vm.trip.status==\'refundpending\'"><span class="state">Stato</span> <span class="tag tag-right tag-red tag-sm" tooltips="" tooltip-template="Tu un altro fornitore o il cliente avete annullato questa prenotazione." tooltip-side="left">In attesa di rimborso <span class="icon icon-cancel"></span></span></td><td class="status colspan" colspan="2" data-ng-if="vm.trip.status==\'waitingtransfer\' || vm.trip.status==\'paymentfailed\'"><span class="state">Stato</span> <span class="tag tag-right tag-yellow tag-sm" tooltips="" tooltip-template="La prenotazione sar\xE0 confermata non appena il cliente effettuer\xE0 le azione richieste." tooltip-side="left">In attesa del cliente <span class="icon icon-spin animate-spin"></span></span></td><td class="status colspan" colspan="2" data-ng-if="vm.trip.status==\'expired\'"><span class="state">Stato</span> <span class="tag tag-right tag-red tag-sm" tooltips="" tooltip-template="La prenotazione non \xE8 stata confermata in tempo." tooltip-side="left">Scaduta <span class="icon icon-cancel"></span></span></td></tr></tbody><tbody class="solid"><tr><td>Codice prenotazione</td><td class="code">{{vm.trip._id}}</td></tr><tr><td>Prenotato il</td><td>{{vm.trip.createdAt | dates}}</td></tr><tr><td>Inizio noleggio</td><td>{{vm.trip.startedAt | dates}}</td></tr><tr><td>Termine noleggio</td><td>{{vm.trip.endedAt | dates}}</td></tr><tr><td>Passeggeri</td><td>{{vm.trip.passengers}}</td></tr></tbody><tbody class="line"><tr><td>Totale posti passeggero</td><td>{{vm.solution.computed.seats.passengers}}</td></tr><tr data-ng-if="vm.solution.computed.seats.drivers > 0"><td>Totale posti accompagnatore/guida</td><td>{{vm.solution.computed.seats.drivers}}</td></tr><tr><td>Totale veicoli</td><td>{{vm.solution.valid.length}}</td></tr><tr><td>Totale autisti</td><td>{{vm.solution.computed.drivers}}</td></tr></tbody><tbody class="line" data-ng-repeat="order in ::vm.solution.orders track by order._id" data-ng-if="vm.solution.orders.length > 1" data-ng-class="{\'disabled\' : order.status == \'voided\'}"><tr><td>Costo noleggio {{order.Vehicle.specs.model}}</td><td>{{order.computed.costs.trip.total-order.computed.costs.trip.taxes | number: 2}}\u20AC</td></tr><tr><td>IVA {{order.Vehicle.specs.model}}</td><td>{{order.computed.costs.trip.taxes | number: 2}}\u20AC</td></tr><tr><td>Subtotale {{order.Vehicle.specs.model}}</td><td>{{order.computed.costs.trip.total | number: 2}}\u20AC</td></tr></tbody><tbody class="solid"><tr><td>Costo noleggio totale</td><td>{{vm.solution.computed.costs.trip.total-vm.solution.computed.costs.trip.taxes | number: 2}}\u20AC</td></tr><tr><td>IVA totale</td><td>{{vm.solution.computed.costs.trip.taxes | number: 2}}\u20AC</td></tr></tbody><tbody class="line"><tr><td>Totale</td><td>{{vm.solution.computed.costs.trip.total | number: 2}}\u20AC</td></tr></tbody></table></div></div><div class="whiteframe"><div class="header"><h4>Informazioni cliente</h4></div><div class="item-foot"><div class="details" data-ng-if="vm.trip.status != \'accepted\'"><h3><span tooltips="" tooltip-template="Queste informazioni ti vengono mostrate solo se la prenotazione viene confermata" tooltip-side="right"><span class="blur">{{vm.trip.User.name + \' \' + vm.trip.User.surname}}</span></span></h3><p data-ng-if="vm.trip.User.email">Email: <span tooltips="" tooltip-template="Queste informazioni ti vengono mostrate solo se la prenotazione viene confermata" tooltip-side="right"><span class="blur">{{vm.trip.User.email}}</span></span></p><p data-ng-if="vm.trip.User.temail">Email: <span tooltips="" tooltip-template="Queste informazioni ti vengono mostrate solo se la prenotazione viene confermata" tooltip-side="right"><span class="blur">{{vm.trip.User.temail}}</span></span></p><p>Telefono: <span tooltips="" tooltip-template="Queste informazioni ti vengono mostrate solo se la prenotazione viene confermata" tooltip-side="right"><span class="blur">{{vm.trip.User.phone}}</span></span></p><p>CF/PIVA: <span tooltips="" tooltip-template="Queste informazioni ti vengono mostrate solo se la prenotazione viene confermata" tooltip-side="right"><span class="blur">{{vm.trip.User.taxcode}}</span></span></p><p>Ind. Fatturazione: <span tooltips="" tooltip-template="Queste informazioni ti vengono mostrate solo se la prenotazione viene confermata" tooltip-side="right"><span class="blur">{{vm.trip.User.place.address}}</span></span></p></div><div class="details" data-ng-if="vm.trip.status == \'accepted\'"><h3>{{vm.trip.User.name + \' \' + vm.trip.User.surname}}</h3><p data-ng-if="vm.trip.User.email">Email: {{vm.trip.User.email}} <span class="small" tooltips="" tooltip-template="Indirizzo email verificato" tooltip-side="right"><span class="icon icon-shield"></span></span></p><p data-ng-if="vm.trip.User.temail">Email: {{vm.trip.User.temail}}</p><p>Telefono: {{vm.trip.User.phone}}</p><p>CF/PIVA: {{vm.trip.User.taxcode}}</p><p>Ind. Fatturazione: {{vm.trip.User.place.address}}</p></div></div></div><div class="whiteframe" data-ng-if="vm.reviews > 0"><div class="header"><h4>Recensione</h4></div><div class="content" data-ng-repeat="review in ::vm.trip.Reviews track by review._id" data-ng-if="(review.status == \'tomoderate\' || review.status == \'published\') && review.supplier_id == vm.supplier_id"><p>Valutazione: {{review.rating}}/5</p><p>Commento: {{review.comment}}</p><p data-ng-if="review.answer">Risposta: {{review.answer}}</p><a class="btn btn-lg btn-block btn-green btn-mrg-top" data-ui-sref="root.it.supplier.trips.review({id: vm.trip._id})" data-ng-if="!review.answer">Rispondi alla recensione <span class="icon icon-arrow-right"></span></a></div></div><button class="btn btn-lg btn-block btn-green" data-ng-click="vm.acceptAllOrder()" data-ng-if="vm.acceptable"><span class="icon icon-thick"></span> Accetta tutti gli ordini</button> <button class="btn btn-lg btn-block btn-grey btn-mrg-top" data-ng-click="vm.rejectAllOrder()" data-ng-if="vm.acceptable"><span class="icon icon-cancel"></span> Rifiuta tutti gli ordini</button></div></div></div></section><section class="evidence-content" data-ng-show="vm.loaded"><div class="container"><div class="row trip-details"><div class="col-xs-12 col-md-8"><h4>Mappa</h4><data-br-maps data-br-waypoints="vm.trip.trip.steps" data-br-object="place.location"></data-br-maps></div><div class="col-xs-12 col-md-4"><h4>Itinerario cliente</h4><data-br-trip data-br-steps="vm.trip.trip.steps"></data-br-trip></div></div></div></section></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/supplier/trips.html','<update-title title="Prenotazioni | Busrapido"></update-title><update-meta property="og:title" content="Prenotazioni | Busrapido"></update-meta><update-meta name="twitter:title" content="Prenotazioni | Busrapido"></update-meta><main class="main-trips"><div class="loader-container loader-icon-container" data-ng-class="{\'loader-show\' : !vm.loaded}"><div class="loader-icon">Loading...</div></div><section data-ng-if="vm.loaded"><div class="container"><div class="row"><div class="col-xs-12"><div class="whiteframe-container whiteframe"><div class="content content-float"><div class="left"><p>Mostrando <span data-ng-bind="filtered.length"></span> di <span data-ng-bind="::vm.trips.length"></span> prenotazioni</p></div><p class="right">Ordina per: <select name="filters" data-ng-model="vm.order"><option value="-createdAt">Data prenotazione</option><option value="startedAt">Data inizio prenotazione</option><option value="endedAt">Data fine prenotazione</option></select></p><p class="right">Mostra: <select name="filters" data-ng-model="vm.filters"><option value="all">Tutte</option><option value="active">Rilevanti</option><option value="ended">Terminate</option><option value="pending">Da confermare</option><option value="accepted">Confermate</option><option value="rejected">Rifiutate</option><option value="refundpending">In attesa di rimborso</option><option value="voided">Annullate</option><option value="action">In attesa del cliente</option></select></p></div></div><ol class="whiteframe-container"><li class="whiteframe" data-ng-show="::vm.trips.length < 1"><article class="content content-nocontent"><p><span class="icon icon-emo-happy"></span></p><p class="message">Non hai ancora ricevuto nessuna prenotazione.</p><p>Se non l\'hai ancora fatto, aggiungi subito un <a data-ui-sref="root.it.supplier.vehicles.add">nuovo veicolo</a> per iniziare a ricevere prenotazioni!</p></article></li><li class="whiteframe" data-ng-show="vm.trips.length > 0 && filtered.length === 0"><article class="content content-nocontent"><p><span class="icon icon-emo-unhappy"></span></p><p class="message">Nessuna prenotazione da visualizzare</p><p>I filtri applicati non corrispondono a nessuna prenotazione. <span class="a" data-ng-click="vm.filters = \'all\'">Visualizza tutte le prenotazioni</span>.</p></article></li><li class="whiteframe" data-ng-repeat="trip in vm.trips | orderBy: vm.order | filter: vm.applyFilter as filtered track by trip._id"><div class="header"><div class="row"><div class="col-xs-6"><h4>Prenotazione <span class="small">{{::trip._id}}</span></h4></div><div class="col-xs-6"><div class="right" data-ng-if="::trip.status==\'pending\'"><a class="tag tag-yellow tag-sm" tooltips="" tooltip-template="Ci sono ancora degli ordini non confermati per questa prenotazione." tooltip-side="left" data-ui-sref="root.it.supplier.trips.details(::{id: trip._id})">In attesa di conferma</a></div><div class="right" data-ng-if="::trip.status==\'accepted\'"><a class="tag tag-green tag-sm" data-ui-sref="root.it.supplier.trips.details(::{id: trip._id})">Confermata <span class="icon icon-thick"></span></a></div><div class="right" data-ng-if="::trip.status==\'rejected\'"><a class="tag tag-red tag-sm" tooltips="" tooltip-template="Tu o un altro fornitore avete rifiutato questa prenotazione." tooltip-side="left" data-ui-sref="root.it.supplier.trips.details(::{id: trip._id})">Rifiutata</a></div><div class="right" data-ng-if="::trip.status==\'voided\'"><a class="tag tag-red tag-sm" tooltips="" tooltip-template="Il cliente ha annullato questa prenotazione." tooltip-side="left" data-ui-sref="root.it.supplier.trips.details(::{id: trip._id})">Annullata <span class="icon icon-cancel"></span></a></div><div class="right" data-ng-if="::trip.status==\'refundpending\'"><a class="tag tag-red tag-sm" tooltips="" tooltip-template="Tu un altro fornitore o il cliente avete annullato questa prenotazione." tooltip-side="left" data-ui-sref="root.it.supplier.trips.details(::{id: trip._id})">In attesa di rimborso <span class="icon icon-cancel"></span></a></div><div class="right" data-ng-if="::trip.status==\'waitingtransfer\' || trip.status==\'paymentfailed\'"><a class="tag tag-yellow tag-sm" tooltips="" tooltip-template="La prenotazione sar\xE0 confermata non appena il cliente effettuer\xE0 le azione richieste." tooltip-side="left" data-ui-sref="root.it.supplier.trips.details(::{id: trip._id})">In attesa del cliente <span class="icon icon-spin animate-spin"></span></a></div><div class="right" data-ng-if="::trip.status==\'expired\'"><a class="tag tag-red tag-sm" tooltips="" tooltip-template="La prenotazione non \xE8 stata confermata in tempo." tooltip-side="left" data-ui-sref="root.it.supplier.trips.details(::{id: trip._id})">Scaduta <span class="icon icon-cancel"></span></a></div></div></div></div><article><ul class="content-items"><li data-ng-repeat="order in ::trip.solution.orders track by order._id" data-ng-class="::{\'disabled\' : trip.status == \'rejected\'}"><div class="row"><div class="image col-xs-3 rm-padding-right-xs"><data-br-slider data-br-alt="Noleggio Pullman" data-br-imgs="::order.Vehicle.imgs" data-br-sizes="{width: 280, height: 128}" data-br-cloudinary="true"></data-br-slider></div><div class="col-xs rm-padding-left-xs"><div class="row"><div class="col-xs"><div class="details"><h3>{{::order.Vehicle.specs.manufacturer}} {{::order.Vehicle.specs.model}} <span class="small">{{::order.Vehicle.specs.matriculation}} - {{::vm.emissionClass[order.Vehicle.specs.emissionClass]}}</span></h3><p>Posti: <span tooltips="" tooltip-template="Posti disponibili per la seduta dei passeggeri" tooltip-side="right">{{::order.computed.seats.passengers}}</span> <span tooltips="" tooltip-template="*Posti riservati a guide o accompagnatori turistici" tooltip-side="right" data-ng-if="::order.computed.seats.drivers > 0">+ {{::order.computed.seats.drivers}}*</span> | Autisti: {{::order.computed.drivers}}</p></div></div><div class="col-xs-4 col-sm-3"><div class="price"><strong>{{::order.computed.costs.trip.total | number:2}}\u20AC</strong><p>{{::order.computed.costs.trip.total/trip.passengers | number:2}}\u20AC a persona</p></div></div></div><div class="row"><div class="col-xs"><div class="details"><p>Complessivo: <span class="icon icon-star"></span><span class="icon icon-star"></span><span class="icon icon-star" data-ng-show="::vm.year-order.Vehicle.specs.matriculation <= 12"></span><span class="icon icon-star" data-ng-show="::vm.year-order.Vehicle.specs.matriculation <= 9"></span><span class="icon icon-star" data-ng-show="::vm.year-order.Vehicle.specs.matriculation <= 6"></span></p><p>Azienda: <span class="icon icon-star"></span><span class="icon icon-star"></span><span class="icon icon-star"></span><span class="icon icon-star"></span><span class="icon icon-star"></span> Veicolo: <span class="icon icon-star"></span><span class="icon icon-star" data-ng-show="::vm.year-order.Vehicle.specs.matriculation <= 12"></span><span class="icon icon-star" data-ng-show="::vm.year-order.Vehicle.specs.matriculation <= 9"></span><span class="icon icon-star" data-ng-show="::vm.year-order.Vehicle.specs.matriculation <= 6"></span><span class="icon icon-star" data-ng-show="::vm.year-order.Vehicle.specs.matriculation <= 3"></span></p></div></div></div><div class="row"><div class="col-xs"><div class="services-20"><ul><li data-ng-repeat="(key, service) in ::vm.services track by key" data-ng-class="::{\'active\': order.Vehicle.services[key]}"><span class="tooltip"><span class="icon" data-ng-class="::service.icon"></span> <span class="tip">{{::service.name}}</span></span></li></ul></div></div></div></div></div></li></ul><div class="item-foot"><div class="row"><div class="col-sm-6 col-xs-12"><div class="details" data-ng-if="::trip.status != \'accepted\'"><h3><span tooltips="" tooltip-template="Queste informazioni ti vengono mostrate solo se la prenotazione viene confermata" tooltip-side="right"><span class="blur">{{::trip.User.name + \' \' + trip.User.surname}}</span></span></h3><p data-ng-if="::trip.User.email">Email: <span tooltips="" tooltip-template="Queste informazioni ti vengono mostrate solo se la prenotazione viene confermata" tooltip-side="right"><span class="blur">{{::trip.User.email}}</span></span></p><p data-ng-if="::trip.User.temail">Email: <span tooltips="" tooltip-template="Queste informazioni ti vengono mostrate solo se la prenotazione viene confermata" tooltip-side="right"><span class="blur">{{::trip.User.temail}}</span></span></p><p>Telefono: <span tooltips="" tooltip-template="Queste informazioni ti vengono mostrate solo se la prenotazione viene confermata" tooltip-side="right"><span class="blur">{{::trip.User.phone}}</span></span></p><p>CF/PIVA: <span tooltips="" tooltip-template="Queste informazioni ti vengono mostrate solo se la prenotazione viene confermata" tooltip-side="right"><span class="blur">{{::trip.User.taxcode}}</span></span></p><p>Ind. Fatturazione: <span tooltips="" tooltip-template="Queste informazioni ti vengono mostrate solo se la prenotazione viene confermata" tooltip-side="right"><span class="blur">{{::trip.User.place.address}}</span></span></p></div><div class="details" data-ng-if="::trip.status == \'accepted\'"><h3>{{::trip.User.name + \' \' + trip.User.surname}}</h3><p data-ng-if="::trip.User.email">Email: {{::trip.User.email}} <span class="small" tooltips="" tooltip-template="Indirizzo email verificato" tooltip-side="right"><span class="icon icon-shield"></span></span></p><p data-ng-if="::trip.User.temail">Email: {{::trip.User.temail}}</p><p>Telefono: {{::trip.User.phone}}</p><p>CF/PIVA: {{::trip.User.taxcode}}</p><p>Ind. Fatturazione: {{::trip.User.place.address}}</p></div></div><div class="col-sm-6 col-xs-12"><div class="row"><div class="col-xs"><div class="details"><h3>Dettagli della prenotazione</h3><p>Passeggeri: {{::trip.passengers}}</p><p>Posti: {{::trip.solution.computed.seats.passengers}} <span tooltips="" tooltip-template="*Posti riservati a guide o accompagnatori turistici" tooltip-side="right" data-ng-if="trip.solution.computed.seats.drivers > 0">+ {{::trip.solution.computed.seats.drivers}}*</span> | Autisti: {{::trip.solution.computed.drivers}}</p><p>Data inizio: {{::trip.startedAt | dates}}</p><p>Data fine: {{::trip.endedAt | dates}}</p></div></div><div class="col-xs-4 col-sm-3"><div class="price"><strong>{{::trip.solution.computed.costs.trip.total | number:2}}\u20AC</strong><p>{{::trip.solution.computed.costs.trip.total/trip.passengers | number:2}}\u20AC a persona</p></div></div></div></div></div></div></article><div class="content-itineray content-collpase" data-ng-if="trip.itinerary"><data-br-htrip data-br-steps="::trip.trip.steps" data-br-legs="::trip.trip.legs"></data-br-htrip></div><div class="content-more"><div class="row"><div class="col-xs-8"><div class="left-action"><button class="btn btn-md btn-grey" data-ng-click="trip.itinerary = false" data-ng-show="trip.itinerary"><span class="icon icon-arrow-up"></span>Nascondi itinerario cliente</button> <button class="btn btn-md btn-primary" data-ng-click="trip.itinerary = true" data-ng-show="!trip.itinerary"><span class="icon icon-arrow-down"></span>Mostra itinerario cliente</button></div></div><div class="col-xs-4"><div class="right-action"><a class="btn btn-md btn-primary btn-block" data-ui-sref="root.it.supplier.trips.details(::{id: trip._id})">Visualizza la prenotazione<span class="icon icon-arrow-right"></span></a></div></div></div></div></li></ol></div></div></div></section></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/supplier/trips.order.html','<update-title title="Dettagli ordine {{vm.order._id}} | Busrapido"></update-title><update-meta property="og:title" content="Dettagli ordine {{vm.order._id}} | Busrapido"></update-meta><update-meta name="twitter:title" content="Dettagli ordine {{vm.order._id}} | Busrapido"></update-meta><main class="main-checkout main-order"><div class="loader-container loader-icon-container" data-ng-class="{\'loader-show\' : !vm.loaded}"><div class="loader-icon">Loading...</div></div><section class="evidence-content" data-ng-show="vm.loaded"><div class="container"><div class="row"><div class="col-xs-12 col-md-8"><div class="row"><div class="col-xs-12 company-description"><h1>{{vm.order.Vehicle.specs.manufacturer}} {{vm.order.Vehicle.specs.model}} <span class="small">{{vm.order.Vehicle.specs.matriculation}} - {{vm.emissionClass[vm.order.Vehicle.specs.emissionClass]}}</span></h1></div></div></div></div></div></section><section data-ng-show="vm.loaded"><div class="container overlappping-content"><div class="row whiteframe-container"><div class="col-xs-12 col-md-8"><div class="whiteframe"><div class="content-gallery"><data-br-slider data-br-alt="Noleggio Pullman" data-br-imgs="vm.order.Vehicle.imgs" data-br-thumbnails="true" data-br-cloudinary="true"></data-br-slider></div></div><div class="row vehicle-details separator"><div class="col-xs-12"><h4>Servizi a bordo</h4><div class="row"><div class="col-xs-6 services" data-ng-repeat="(key, service) in ::vm.services track by key" data-ng-class="{\'active\': vm.order.Vehicle.services[key]}" data-ng-show="vm.order.Vehicle.services[key]"><span class="icon" data-ng-class="service.icon"></span><span>{{service.name}}</span></div></div></div></div><div class="row vehicle-details separator"><div class="col-xs-12"><h4>Incluso nel prezzo</h4><div class="row"><div class="col-xs-6 services active"><span class="icon"></span><span>Noleggio veicolo</span></div><div class="col-xs-6 services active"><span class="icon"></span><span>Autisti</span></div><div class="col-xs-6 services active"><span class="icon"></span><span>Pedaggi autostradali <span class="small">(Ove previsti)</span></span></div><div class="col-xs-6 services active"><span class="icon"></span><span>Carburante</span></div><div class="col-xs-6 services active"><span class="icon"></span><span>Assicurazione RCA <span class="info icon icon-info tooltips" tooltips="" tooltip-template="Copre i danni alle persone per un minimo di 5.000.000,00\u20AC e danni alle cose per un minimo di 1.000.000,00\u20AC in caso di sinistro" tooltip-side="top"></span></span></div><div class="col-xs-6 services active"><span class="icon"></span><span>IVA <span class="info icon icon-info tooltips" tooltips="" tooltip-template="L\'importo totale del viaggio include gi\xE0 l\'IVA, pari al 10% del costo totale del noleggio." tooltip-side="top"></span></span></div></div></div></div><div class="row vehicle-details separator"><div class="col-xs-12"><h4>Non incluso nel prezzo</h4><div class="row"><div class="col-xs-6 services active"><span class="icon"></span><span>Vitto e alloggio degli autisti <span class="small">(Se necessari)</span></span></div><div class="col-xs-6 services active"><span class="icon"></span><span>Parcheggi, Checkpoint e ZTL <span class="small">(Se necessari)</span></span></div></div></div></div></div><div class="col-xs-12 col-md-4"><div class="whiteframe"><div class="header"><h4>Dettagli dell\'ordine</h4></div><div class="content-checkout"><table><tbody><tr><td class="status colspan" colspan="2" data-ng-if="vm.order.status==\'pending\'"><span class="state">Stato</span> <span class="tag tag-right tag-yellow tag-sm" tooltips="" tooltip-template="Tu o un altro fornitore dovete ancora confermare questo ordine." tooltip-side="left">Da confermare!</span></td><td class="status colspan" colspan="2" data-ng-if="vm.order.status==\'accepted\'"><span class="state">Stato</span> <span class="tag tag-right tag-yellow tag-sm" tooltips="" tooltip-template="Devi attendere che il pagamento del cliente vada a buon fine o che gli altri ordini vengano confermati. Se ti sono stati richiesti pi\xF9 ordini, conferma anche gli altri." tooltip-side="left">In attesa <span class="icon icon-spin animate-spin"></span></span></td><td class="status colspan" colspan="2" data-ng-if="vm.order.status==\'confirmed\'"><span class="state">Stato</span> <span class="tag tag-right tag-green tag-sm">Confermato <span class="icon icon-thick"></span></span></td><td class="status colspan" colspan="2" data-ng-if="vm.order.status==\'voided\'"><span class="state">Stato</span> <span class="tag tag-right tag-red tag-sm" tooltips="" tooltip-template="Tu o un altro fornitore avete rifiutato questo ordine." tooltip-side="left">Rifiutato <span class="icon icon-cancel"></span></span></td><td class="status colspan" colspan="2" data-ng-if="vm.order.status==\'rejected\'"><span class="state">Stato</span> <span class="tag tag-right tag-red tag-sm" tooltips="" tooltip-template="Il cliente ha annullato questo ordine." tooltip-side="left">Annullato <span class="icon icon-cancel"></span></span></td><td class="status colspan" colspan="2" data-ng-if="vm.order.status==\'expired\'"><span class="state">Stato</span> <span class="tag tag-right tag-red tag-sm" tooltips="" tooltip-template="L\'ordine non \xE8 stato confermato in tempo." tooltip-side="left">Scaduto <span class="icon icon-cancel"></span></span></td></tr></tbody><tbody class="solid"><tr><td>Codice ordine</td><td class="code">{{vm.order._id}}</td></tr><tr><td>Inizio noleggio</td><td>{{vm.order.startedAt | dates}}</td></tr><tr><td>Termine noleggio</td><td>{{vm.order.endedAt | dates}}</td></tr></tbody><tbody class="line"><tr><td>Totale posti passeggero</td><td>{{vm.order.computed.seats.passengers}}</td></tr><tr data-ng-if="vm.order.computed.seats.drivers > 0"><td>Totale posti accompagnatore/guida</td><td>{{vm.order.computed.seats.drivers}}</td></tr><tr><td>Totale autisti</td><td>{{vm.order.computed.drivers}}</td></tr><tr><td>Totale chilometri</td><td>{{vm.order.trip.info.directions.total.distance | distance}}</td></tr><tr><td>Totale tempo in viaggio</td><td>{{vm.order.trip.info.directions.total.duration | duration}}</td></tr></tbody><tbody class="solid"><tr><td>Costo noleggio totale</td><td>{{vm.order.computed.costs.trip.total-vm.order.computed.costs.trip.taxes | number: 2}}\u20AC</td></tr><tr><td>IVA totale</td><td>{{vm.order.computed.costs.trip.taxes | number: 2}}\u20AC</td></tr></tbody><tbody class="line"><tr><td>Totale</td><td>{{vm.order.computed.costs.trip.total | number: 2}}\u20AC</td></tr></tbody></table></div></div><div class="whiteframe"><div class="header"><h4>Informazioni cliente</h4></div><div class="item-foot"><div class="details" data-ng-if="vm.order.status != \'confirmed\'"><h3><span tooltips="" tooltip-template="Queste informazioni ti vengono mostrate solo se la prenotazione associata a questo ordine viene confermata" tooltip-side="right"><span class="blur">{{vm.order.User.name + \' \' + vm.order.User.surname}}</span></span></h3><p data-ng-if="vm.order.User.email">Email: <span tooltips="" tooltip-template="Queste informazioni ti vengono mostrate solo se la prenotazione associata a questo ordine viene confermata" tooltip-side="right"><span class="blur">{{vm.order.User.email}}</span></span></p><p data-ng-if="vm.order.User.temail">Email: <span tooltips="" tooltip-template="Queste informazioni ti vengono mostrate solo se la prenotazione associata a questo ordine viene confermata" tooltip-side="right"><span class="blur">{{vm.order.User.temail}}</span></span></p><p>Telefono: <span tooltips="" tooltip-template="Queste informazioni ti vengono mostrate solo se la prenotazione associata a questo ordine viene confermata" tooltip-side="right"><span class="blur">{{vm.order.User.phone}}</span></span></p><p>CF/PIVA: <span tooltips="" tooltip-template="Queste informazioni ti vengono mostrate solo se la prenotazione associata a questo ordine viene confermata" tooltip-side="right"><span class="blur">{{vm.order.User.taxcode}}</span></span></p><p>Ind. Fatturazione: <span tooltips="" tooltip-template="Queste informazioni ti vengono mostrate solo se la prenotazione associata a questo ordine viene confermata" tooltip-side="right"><span class="blur">{{vm.order.User.place.address}}</span></span></p></div><div class="details" data-ng-if="vm.order.status == \'confirmed\'"><h3>{{vm.order.User.name + \' \' + vm.order.User.surname}}</h3><p data-ng-if="vm.order.User.email">Email: {{vm.order.User.email}} <span class="small" tooltips="" tooltip-template="Indirizzo email verificato" tooltip-side="right"><span class="icon icon-shield"></span></span></p><p data-ng-if="vm.order.User.temail">Email: {{vm.order.User.temail}}</p><p>Telefono: {{vm.order.User.phone}}</p><p>CF/PIVA: {{vm.order.User.taxcode}}</p><p>Ind. Fatturazione: {{vm.order.User.place.address}}</p></div></div></div></div></div></div></section><section class="evidence-content" data-ng-show="vm.loaded"><div class="container"><div class="row trip-details"><div class="col-xs-12 col-md-8"><h4>Mappa</h4><data-br-maps data-br-waypoints="vm.order.trip.steps" data-br-object="place.location"></data-br-maps></div><div class="col-xs-12 col-md-4"><h4>Itinerario partner</h4><data-br-trip data-br-steps="vm.order.trip.steps"></data-br-trip></div></div></div></section></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/supplier/trips.review.html','<update-title title="Lascia una recensione | Busrapido"></update-title><update-meta property="og:title" content="Lascia una recensione | Busrapido"></update-meta><update-meta name="twitter:title" content="Lascia una recensione | Busrapido"></update-meta><main class="main-payment"><div class="loader-container loader-icon-container" data-ng-class="{\'loader-show\' : !vm.loaded}"><div class="loader-icon">Loading...</div></div><section class="evidence-content" data-ng-show="vm.loaded"><div class="container"><div class="row"><div class="col-xs-12 section-description"><h1>Lascia una recesione</h1></div></div></div></section><section data-ng-show="vm.loaded"><div class="container overlappping-content"><div class="row whiteframe-container"><div class="col-xs-12 col-md-8"><div class="whiteframe"><div class="content content-form"><form novalidate="" data-ng-submit="vm.sendReview()"><div data-ng-repeat="review in vm.trip.Reviews" data-ng-if="(review.status == \'tomoderate\' || review.status == \'published\') && review.supplier_id == vm.supplier_id"><p>Valutazione: {{review.rating}}/5</p><p>Commento: {{review.comment}}</p><label><div class="top"><span class="label">Risposta</span></div><textarea name="answer" placeholder="Commento..." data-ng-model="review.answer"></textarea></label></div><div class="warn collapse-step" data-ng-if="vm.warning"><p>{{vm.warning}}</p></div><button type="submit" class="btn btn-lg btn-block btn-green btn-mrg-top"><span class="icon icon-arrow-right"></span> Invia risposta</button></form></div></div></div><div class="col-xs-12 col-md-4"><div class="whiteframe"><div class="header"><h4>Dettagli del noleggio</h4></div><div class="content-gallery"><data-br-slider data-br-alt="Noleggio Pullman" data-br-imgs="vm.solution.imgs" data-br-sizes="{width: 350, height: 200}" data-br-cloudinary="true"></data-br-slider></div><div class="content-checkout"><data-br-trip data-br-steps="vm.trip.trip.steps"></data-br-trip><table><tbody class="line"><tr><td>Inizio noleggio</td><td>{{vm.trip.startedAt | dates}}</td></tr><tr><td>Termine noleggio</td><td>{{vm.trip.endedAt | dates}}</td></tr><tr><td>Passeggeri</td><td>{{vm.trip.passengers}}</td></tr></tbody><tbody class="line"><tr><td>Totale posti passeggero</td><td>{{vm.solution.computed.seats.passengers}}</td></tr><tr data-ng-if="vm.solution.computed.seats.drivers > 0"><td>Totale posti accompagnatore/guida</td><td>{{vm.solution.computed.seats.drivers}}</td></tr><tr><td>Totale veicoli</td><td>{{vm.solution.orders.length}}</td></tr><tr><td>Totale autisti</td><td>{{vm.solution.computed.drivers}}</td></tr></tbody><tbody class="line" data-ng-repeat="order in vm.solution.orders" data-ng-if="vm.solution.orders.length > 1"><tr><td>Costo noleggio {{order.vehicle.specs.model}}</td><td>{{order.computed.costs.trip.total-order.computed.costs.trip.taxes | number: 2}}\u20AC</td></tr><tr><td>IVA {{order.vehicle.specs.model}}</td><td>{{order.computed.costs.trip.taxes | number: 2}}\u20AC</td></tr><tr><td>Subtotale {{order.vehicle.specs.model}}</td><td>{{order.computed.costs.trip.total | number: 2}}\u20AC</td></tr></tbody><tbody class="solid"><tr><td>Costo noleggio totale</td><td>{{vm.solution.computed.costs.trip.total-vm.solution.computed.costs.trip.taxes | number: 2}}\u20AC</td></tr><tr><td>IVA totale</td><td>{{vm.solution.computed.costs.trip.taxes | number: 2}}\u20AC</td></tr></tbody><tbody class="line"><tr><td>Totale</td><td>{{vm.solution.computed.costs.trip.total | number: 2}}\u20AC</td></tr></tbody></table></div></div></div></div></div></section></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/supplier/vehicles.add.html','<update-title title="Aggiungi un veicolo | Busrapido"></update-title><update-meta property="og:title" content="Aggiungi un veicolo | Busrapido"></update-meta><update-meta name="twitter:title" content="Aggiungi un veicolo | Busrapido"></update-meta><main class="main-vehicles"><div class="loader-container loader-icon-container" data-ng-class="{\'loader-show\' : !vm.loaded}"><div class="loader-icon">Loading...</div></div><section class="vehicles" data-ng-if="vm.loaded"><div class="container"><div class="row"><div class="col-xs-12"><div class="whiteframe-container whiteframe"><div class="content content-float"><div class="left"><a class="btn btn-sm btn-primary" data-ui-sref="root.it.supplier.vehicles.list"><span class="icon icon-arrow-left"></span> Indietro</a></div></div></div><div class="whiteframe-container whiteframe" data-ng-if="vm.inputs.places.length < 1"><div class="content content-nocontent"><p><span class="icon icon-emo-happy"></span></p><p class="message">Nessuna sede disponibile</p><p>Prima di poter aggiungere un nuovo veicolo, devi avere almeno una sede. <a data-ui-sref="root.it.supplier.profile.name({\'section\': \'3\'})">Aggiungi subito una sede</a>.</p></div></div><div class="whiteframe-container" data-ng-if="vm.inputs.places.length > 0"><form novalidate="" data-ng-submit="vm.addVehicle()"><h2 class="heading">Specifiche</h2><div class="whiteframe"><div class="content content-form"><div class="row"><div class="col-xs-6 col-sm-4"><label><div class="top"><span class="label">Marca*</span></div><input type="text" name="manufacturer" placeholder="Marca" data-ng-model="vm.vehicle.specs.manufacturer"></label></div><div class="col-xs-6 col-sm-4"><label><div class="top"><span class="label">Modello*</span></div><input type="text" name="model" placeholder="Modello" data-ng-model="vm.vehicle.specs.model"></label></div><div class="col-xs-6 col-sm-4"><label><div class="top"><span class="label">Targa*</span></div><input type="text" name="plate" placeholder="Targa" data-ng-model="vm.vehicle.specs.plate"></label></div></div><div class="row"><div class="col-xs-4"><label><div class="top"><span class="label">Numero di assi*</span></div><select required name="axis" data-ng-model="vm.vehicle.specs.axis"><option value="" disabled="disabled" selected="selected" hidden>Assi</option><option data-ng-repeat="item in ::vm.inputs.axis track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div><div class="col-xs-4"><label><div class="top"><span class="label">Categoria Euro*</span></div><select required name="emissionsClass" data-ng-model="vm.vehicle.specs.emissionClass"><option value="" disabled="disabled" selected="selected" hidden>Categoria Euro</option><option data-ng-repeat="item in ::vm.inputs.emissions track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div><div class="col-xs-4"><label><div class="top"><span class="label">Immatricolazione*</span></div><select required name="matriculation" data-ng-model="vm.vehicle.specs.matriculation"><option value="" disabled="disabled" selected="selected" hidden>Prima immatricolazione</option><option data-ng-repeat="item in ::vm.inputs.years track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div></div><div class="row"><div class="col-xs-4"><label><div class="top"><span class="label">Lunghezza</span></div><select name="lengthiness" data-ng-model="vm.vehicle.specs.lengthiness"><option value="" disabled="disabled" selected="selected" hidden>Lunghezza in metri</option><option data-ng-repeat="item in ::vm.inputs.lengthiness track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div><div class="col-xs-4"><label><div class="top"><span class="label">Larghezza</span></div><select name="largeness" data-ng-model="vm.vehicle.specs.largeness"><option value="" disabled="disabled" selected="selected" hidden>Larghezza in metri</option><option data-ng-repeat="item in ::vm.inputs.largeness track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div><div class="col-xs-4"><label><div class="top"><span class="label">Altezza</span></div><select name="highness" data-ng-model="vm.vehicle.specs.highness"><option value="" disabled="disabled" selected="selected" hidden>Altezza in metri</option><option data-ng-repeat="item in ::vm.inputs.highness track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div></div><div class="row"><div class="col-xs-12 col-sm-6"><label><div class="top"><span class="label">Posti Passeggeri*</span></div><select required name="passengers" data-ng-model="vm.vehicle.specs.seats.passengers"><option value="" disabled="disabled" selected="selected" hidden>Posti passeggero</option><option data-ng-repeat="item in ::vm.inputs.passengers track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div><div class="col-xs-12 col-sm-6"><label><div class="top"><span class="label">Posti accompagnatore</span></div><select name="drivers" data-ng-model="vm.vehicle.specs.seats.drivers"><option value="" disabled="disabled" selected="selected" hidden>Posti accompagnatore</option><option data-ng-repeat="item in ::vm.inputs.drivers track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div></div><div class="row"><div class="col-xs-6"><label><div class="top"><span class="label">Colore del veicolo</span></div><input required name="color" placeholder="Rosso, verde, nero, bianco, etc." data-ng-model="vm.vehicle.specs.color"></label></div><div class="col-xs-6"><label><div class="top"><span class="label">Cinture di sicurezza</span></div><select required name="seatbelts" data-ng-model="vm.vehicle.specs.seatbelts"><option value="" disabled="disabled" selected="selected" hidden>Cinture di sicurezza</option><option data-ng-repeat="item in ::vm.inputs.seatbelts track by item.value" data-ng-attr-value="{{item.value}}">{{item.name | seatbelts}}</option></select></label></div></div></div></div><h2 class="heading">Deposito operativo</h2><div class="whiteframe"><div class="content content-form"><label><div class="top"><span class="label">Qual \xE8 l\'indirizzo del deposito da cui partono i veicoli?*</span></div><select name="place" required data-ng-model="vm.vehicle.place_id"><option value="" disabled="disabled" selected="selected" hidden>Scegli la tua rimessa da cui parte il veicolo</option><option data-ng-repeat="item in ::vm.inputs.places track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div></div><h2 class="heading">Servizi a Bordo</h2><p>Seleziona gli optional di cui dispone il veicolo:</p><br><div class="whiteframe"><div class="content content-services-bottom"><div class="row"><div class="col-xs-12"><ul class="services-10"><li data-ng-repeat="(key, service) in vm.services track by key" data-ng-class="{\'active\': vm.vehicle.services[key]}" data-ng-click="vm.vehicle.services[key] = !vm.vehicle.services[key]"><span class="icon" tooltips="" tooltip-template="{{service.name}}" tooltip-side="top" data-ng-class="service.icon"></span><p style="color: black">{{service.name}}</p></li></ul></div></div></div></div><h2 class="heading">Immagini</h2><div class="bootstrap"><p></p><p>Avere ottime foto aiuta i viaggiatori a farsi una buona immagine della tua azienda ancora prima di partire.<br>Le aziende in possesso di foto del proprio parco veicoli ricevono in media il doppio di richieste di prenotazione su base mensile.</p></div><div class="whiteframe"><div class="content content-form"><data-br-uploader data-br-label="Inserisci le immagini" data-br-info="Trascina o clicca sul +<br/>(.jpg,.jpeg,.png,.gif)" data-br-imgs="vm.vehicle.imgs" data-br-files="vm.files"></data-br-uploader></div></div><div class="bootstrap"><p><br>Carica foto ad alta risoluzione che mostrino sia gli interni che gli esterni dei tuoi veicoli. Mostreremo queste foto ai clienti per farti ricevere pi\xF9 prenotazioni.vere ottime foto aiuta i viaggiatori a farsi una buona immagine della tua azienda ancora prima di partire.</p></div><div class="whiteframe"><div class="content"><div class="row"><div class="col-xs-12"><div class="warn collapse-step" data-ng-if="vm.warning"><p>{{vm.warning}}</p></div></div><div class="col-xs-12"><button type="submit" class="btn btn-lg btn-primary">Aggiungi veicolo</button></div></div></div></div></form></div></div></div></div></section></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/supplier/vehicles.edit.html','<update-title title="Modifica veicolo | Busrapido"></update-title><update-meta property="og:title" content="Modifica veicolo | Busrapido"></update-meta><update-meta name="twitter:title" content="Modifica veicolo | Busrapido"></update-meta><main class="main-vehicles"><div class="loader-container loader-icon-container" data-ng-class="{\'loader-show\' : !vm.loaded}"><div class="loader-icon">Loading...</div></div><section class="vehicles" data-ng-if="vm.loaded"><div class="container"><div class="row"><div class="col-xs-12"><div class="whiteframe-container whiteframe"><div class="content content-float"><div class="left"><a class="btn btn-sm btn-primary" data-ui-sref="root.it.supplier.vehicles.list"><span class="icon icon-arrow-left"></span> Indietro</a></div></div></div><div class="whiteframe-container whiteframe" data-ng-if="vm.inputs.places.length < 1"><div class="content content-nocontent"><p><span class="icon icon-emo-unhappy"></span></p><p class="message">Nessuna sede disponibile</p><p>Prima di poter aggiungere un nuovo veicolo, devi avere almeno una sede. <a data-ui-sref="root.it.supplier.profile.name({\'section\': \'3\'})">Aggiungi subito una sede</a>.</p></div></div><div class="whiteframe-container" data-ng-if="vm.inputs.places.length > 0"><form novalidate="" data-ng-submit="vm.updateVehicle()"><h2 class="heading">Specifiche</h2><div class="whiteframe"><div class="content content-form"><div class="row"><div class="col-xs-6 col-sm-4"><label><div class="top"><span class="label">Marca*</span></div><input type="text" name="manufacturer" placeholder="Marca" data-ng-model="vm.vehicle.specs.manufacturer"></label></div><div class="col-xs-6 col-sm-4"><label><div class="top"><span class="label">Modello*</span></div><input type="text" name="model" placeholder="Modello" data-ng-model="vm.vehicle.specs.model"></label></div><div class="col-xs-6 col-sm-4"><label><div class="top"><span class="label">Targa*</span></div><input type="text" name="plate" placeholder="Targa" data-ng-model="vm.vehicle.specs.plate"></label></div></div><div class="row"><div class="col-xs-4"><label><div class="top"><span class="label">Numero di assi*</span></div><select required name="axis" data-ng-model="vm.vehicle.specs.axis"><option value="" disabled="disabled" selected="selected" hidden>Assi</option><option data-ng-repeat="item in ::vm.inputs.axis track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div><div class="col-xs-4"><label><div class="top"><span class="label">Categoria Euro*</span></div><select required name="emissionsClass" data-ng-model="vm.vehicle.specs.emissionClass"><option value="" disabled="disabled" selected="selected" hidden>Categoria Euro</option><option data-ng-repeat="item in ::vm.inputs.emissions track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div><div class="col-xs-4"><label><div class="top"><span class="label">Immatricolazione*</span></div><select required name="matriculation" data-ng-model="vm.vehicle.specs.matriculation"><option value="" disabled="disabled" selected="selected" hidden>Prima immatricolazione</option><option data-ng-repeat="item in ::vm.inputs.years track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div></div><div class="row"><div class="col-xs-4"><label><div class="top"><span class="label">Lunghezza</span></div><select name="lengthiness" data-ng-model="vm.vehicle.specs.lengthiness"><option value="" disabled="disabled" selected="selected" hidden>Lunghezza in metri</option><option data-ng-repeat="item in ::vm.inputs.lengthiness track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div><div class="col-xs-4"><label><div class="top"><span class="label">Larghezza</span></div><select name="largeness" data-ng-model="vm.vehicle.specs.largeness"><option value="" disabled="disabled" selected="selected" hidden>Larghezza in metri</option><option data-ng-repeat="item in ::vm.inputs.largeness track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div><div class="col-xs-4"><label><div class="top"><span class="label">Altezza</span></div><select name="highness" data-ng-model="vm.vehicle.specs.highness"><option value="" disabled="disabled" selected="selected" hidden>Altezza in metri</option><option data-ng-repeat="item in ::vm.inputs.highness track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div></div><div class="row"><div class="col-xs-12 col-sm-6"><label><div class="top"><span class="label">Posti Passeggeri*</span></div><select required name="passengers" data-ng-model="vm.vehicle.specs.seats.passengers"><option value="" disabled="disabled" selected="selected" hidden>Posti passeggero</option><option data-ng-repeat="item in ::vm.inputs.passengers track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div><div class="col-xs-12 col-sm-6"><label><div class="top"><span class="label">Posti accompagnatore</span></div><select name="drivers" data-ng-model="vm.vehicle.specs.seats.drivers"><option value="" disabled="disabled" selected="selected" hidden>Posti accompagnatore</option><option data-ng-repeat="item in ::vm.inputs.drivers track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div></div><div class="row"><div class="col-xs-6"><label><div class="top"><span class="label">Colore del veicolo</span></div><input required name="color" placeholder="Rosso, verde, nero, bianco, etc." data-ng-model="vm.vehicle.specs.color"></label></div><div class="col-xs-6"><label><div class="top"><span class="label">Cinture di sicurezza</span></div><select required name="seatbelts" data-ng-model="vm.vehicle.specs.seatbelts"><option value="" disabled="disabled" selected="selected" hidden>Cinture di sicurezza</option><option data-ng-repeat="item in ::vm.inputs.seatbelts track by item.value" data-ng-attr-value="{{item.value}}">{{item.name | seatbelts}}</option></select></label></div></div></div></div><h2 class="heading">Deposito operativo</h2><div class="whiteframe"><div class="content content-form"><label><div class="top"><span class="label">Qual \xE8 l\'indirizzo del deposito da cui partono i veicoli?</span></div><select name="place" required data-ng-model="vm.vehicle.place_id"><option value="" disabled="disabled" selected="selected" hidden>Scegli la tua rimessa da cui parte il veicolo</option><option data-ng-repeat="item in ::vm.inputs.places track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div></div><h2 class="heading">Servizi a Bordo</h2><p>Seleziona gli optional di cui dispone il veicolo:</p><br><div class="whiteframe"><div class="content content-services-bottom"><div class="row"><div class="col-xs-12"><ul class="services-10"><li data-ng-repeat="(key, service) in vm.services track by key" data-ng-class="{\'active\': vm.vehicle.services[key]}" data-ng-click="vm.vehicle.services[key] = !vm.vehicle.services[key]"><span class="icon" tooltips="" tooltip-template="{{service.name}}" tooltip-side="top" data-ng-class="service.icon"></span><p style="color: black">{{service.name}}</p></li></ul></div></div></div></div><h2 class="heading">Immagini</h2><div class="bootstrap"><p></p><p>Avere ottime foto aiuta i viaggiatori a farsi una buona immagine della tua azienda ancora prima di partire.<br>Le aziende in possesso di foto del proprio parco veicoli ricevono in media il doppio di richieste di prenotazione su base mensile.</p></div><div class="whiteframe"><div class="content content-form"><data-br-uploader data-br-label="Inserisci le immagini" data-br-info="Trascina o clicca sul +<br/>(.jpg,.jpeg,.png,.gif)" data-br-imgs="vm.vehicle.imgs" data-br-files="vm.files"></data-br-uploader></div></div><div class="bootstrap"><p><br>Carica foto ad alta risoluzione che mostrino sia gli interni che gli esterni dei tuoi veicoli. Mostreremo queste foto ai clienti per farti ricevere pi\xF9 prenotazioni.vere ottime foto aiuta i viaggiatori a farsi una buona immagine della tua azienda ancora prima di partire.</p></div><div class="whiteframe"><div class="content"><div class="row"><div class="col-xs-12"><div class="warn collapse-step" data-ng-if="vm.warning"><p>{{vm.warning}}</p></div></div><div class="col-xs-12"><button type="submit" class="btn btn-lg btn-primary">Salva modifiche</button></div></div></div></div></form></div></div></div></div></section></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/supplier/vehicles.html','<update-title title="Veicoli | Busrapido"></update-title><update-meta property="og:title" content="Veicoli | Busrapido"></update-meta><update-meta name="twitter:title" content="Veicoli | Busrapido"></update-meta><main class="main-vehicles"><div class="loader-container loader-icon-container" data-ng-class="{\'loader-show\' : !vm.loaded}"><div class="loader-icon">Loading...</div></div><section data-ng-if="vm.loaded"><div class="container"><div class="row"><div class="col-xs-12"><div class="whiteframe-container whiteframe"><div class="content content-float"><div class="left"><p>Mostrando <span data-ng-bind="filtered.length"></span> di <span data-ng-bind="::vm.vehicles.length"></span> risultati</p></div><div class="right"><a class="btn btn-sm btn-primary" data-ui-sref="root.it.supplier.vehicles.add">Aggiungi veicolo</a></div><p class="right">Mostra: <select name="filters" data-ng-model="vm.filters"><option value="all">Tutti</option><option value="enabled">Abilitati</option><option value="disabled">Disabilitati</option></select></p></div></div><ol class="whiteframe-container"><li class="whiteframe" data-ng-show="::vm.vehicles.length < 1"><article class="content content-nocontent"><p><span class="icon icon-emo-happy"></span></p><p class="message">Non hai aggiunto ancora nessun veicolo.</p><p>Aggiungi subito un <a data-ui-sref="root.it.supplier.vehicles.add">nuovo veicolo</a>.</p></article></li><li class="whiteframe" data-ng-show="vm.vehicles.length > 0 && filtered.length === 0"><article class="content content-nocontent"><p><span class="icon icon-emo-unhappy"></span></p><p class="message">Nessuna veicolo da visualizzare</p><p>I filtri applicati non corrispondono a nessun veicolo. <span class="a" data-ng-click="vm.filters = \'all\'">Visualizza tutti i veicoli</span>.</p></article></li><li class="whiteframe" data-ng-repeat="vehicle in vm.vehicles | filter: vm.applyFilter as filtered track by vehicle._id"><article class="content-items"><div class="row"><div class="image-supplier col-xs-12 col-sm-3"><data-br-slider data-br-alt="Noleggio Pullman" data-br-imgs="::vehicle.imgs" data-br-sizes="{width: 250, height: 150}" data-br-cloudinary="true"></data-br-slider></div><div class="col-xs re-padding-left-xs rm-padding-left-sm"><div class="row"><div class="col-xs"><div class="details"><h3>{{::vehicle.specs.manufacturer}} {{::vehicle.specs.model}} {{::vehicle.specs.type}}</h3><p><span class="icon icon-bus"></span> Targa: {{::vehicle.specs.plate}} <span class="icon icon-calendar"></span> Anno: {{::vehicle.specs.matriculation}} <span class="icon icon-tree"></span> {{::vehicle.specs.emissionClass}} - {{::vehicle.specs.axis}} assi</p><p><span class="icon icon-location"></span> Sede: {{::vehicle.Place.place.address}}</p><p><span class="icon icon-user-male"></span> Posti passeggero: {{::vehicle.specs.seats.passengers}}</p></div></div><div class="col-xs-5"><div class="right-action"><a class="btn btn-sm btn-toactive" data-ui-sref="root.it.supplier.vehicles.duplicate(::{id: vehicle._id})">Duplica</a> <a class="btn btn-sm btn-primary" data-ui-sref="root.it.supplier.vehicles.edit(::{id: vehicle._id})">Modifica</a> <button class="btn btn-sm btn-green" data-ng-if="vehicle.disabled" data-ng-click="vm.setVehicleDisabledState(vehicle, false)">Abilita</button> <button class="btn btn-sm btn-grey" data-ng-if="!vehicle.disabled" data-ng-click="vm.setVehicleDisabledState(vehicle, true)">Disabilita</button></div></div></div><div class="row"><div class="col-sm-8 co-xs-12"><div class="services-20"><ul><li data-ng-repeat="(key, service) in ::vm.services track by key" data-ng-class="::{\'active\': vehicle.services[key]}"><span class="tooltip"><span class="icon" data-ng-class="::service.icon"></span> <span class="tip">{{::service.name}}</span></span></li></ul></div></div></div></div></div></article></li></ol></div></div></div></section></main><data-br-footer></data-br-footer>');
$templateCache.put('app/components/complete/modal/alert.modal.html','<div class="modal complete"><div class="modal-dialog"><div class="close" data-ng-click="auth.closeIt(-1)" data-ng-show="auth.step > 5"><i class="icon icon-cancel"></i></div><div class="whiteframe-container whiteframe"><div class="header" data-ng-if="auth.step < 9 && auth.step !== 4 && auth.step !== 6"><h4 data-ng-if="auth.step == 2">Benvenuto a bordo! <span style="color: red" class="icon icon-bus"></span></h4><h2 data-ng-if="auth.step == 3">Completa il tuo profilo per ricevere richieste</h2><h2 data-ng-if="auth.step >= 5">Completa il tuo profilo per ricevere <span style="color: red">pi\xF9</span> richieste</h2></div><div class="bootstrap"><div class="progress no-margin half-height" data-ng-if="auth.step == 2"><div class="progress-bar bg-warning" role="progressbar" style="width: 10%" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div></div><div class="progress no-margin half-height" data-ng-if="auth.step == 3"><div class="progress-bar bg-warning" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div></div><div class="progress no-margin half-height" data-ng-if="auth.step == 5"><div class="progress-bar bg-info" role="progressbar" style="width: 50%" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div></div><div class="progress no-margin half-height" data-ng-if="auth.step == 7"><div class="progress-bar bg-success" role="progressbar" style="width: 75%" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div></div><div class="progress no-margin half-height" data-ng-if="auth.step == 8"><div class="progress-bar bg-success" role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div></div></div><div class="content whiteframe-content"><div class="bootstrap"><form novalidate="" data-ng-submit="auth.advanceSignup(auth.step, auth.step + 1, $event)"><div data-ng-switch="auth.step"><data-br-poc-step data-br-data="auth.user.signup" data-ng-switch-when="2"></data-br-poc-step><data-br-company-step data-br-data="auth.user.signup" data-ng-switch-when="3"></data-br-company-step><data-br-cheer-step data-br-data="auth.user.signup" data-ng-switch-when="4"></data-br-cheer-step><data-br-additional-step data-br-data="auth.user.signup" data-ng-switch-when="5"></data-br-additional-step><data-br-first-completed-step data-br-data="auth.user.signup" data-ng-switch-when="6"></data-br-first-completed-step><data-br-notification-step data-br-data="auth.user.signup" data-ng-switch-when="7"></data-br-notification-step><data-br-request-types-step data-br-data="auth.user.signup" data-ng-switch-when="8"></data-br-request-types-step><data-br-vehicle-step data-br-data="auth.user.signup" data-ng-switch-when="9"></data-br-vehicle-step></div><div class="col-sm"><button class="btn btn-success" type="submit" data-ng-show="auth.step === 1" data-ng-cloak="">Registrati</button> <button class="btn btn-success" type="submit" data-ng-show="auth.step !== 1" data-ng-cloak="">Avanti</button></div></form></div></div></div></div></div>');
$templateCache.put('app/components/quote-details/classic/classic.html','<div class="content" data-ng-if="iter.trip"><div class="content" data-ng-repeat="leg in iter.trip.legs"><div data-ng-if="iter.trip.steps[leg.from].tour">Giro citt\xE0<br>Localit\xE0 {{iter.trip.steps[leg.from].place.address}}<br><br></div>TRF {{$index + 1}}<br>Data e ora di partenza <span data-ng-bind="iter.trip.steps[leg.from].depart | dates"></span><br>Punto di partenza {{iter.trip.steps[leg.from].place.address}}<br>Destinazione {{iter.trip.steps[leg.to].place.address}}<br><span data-ng-if="leg.keep">Disposizione richiesta<br></span></div></div>');
$templateCache.put('app/components/quote-details/tour/tour.html','<div class="content" data-ng-if="iter.trip"><div class="content" data-ng-repeat="leg in iter.trip.legs"><div data-ng-if="iter.trip.legs.length !== $index - 1 && iter.days[$index] !== undefined"><br><p class="tag tag-sm">Giorno {{iter.days[$index].date | dates}}</p><br><br></div>Tappa {{$index + 1}}<br>Data e ora di partenza <span data-ng-bind="iter.trip.steps[leg.from].depart | dates"></span><br>Punto di partenza {{iter.trip.steps[leg.from].place.address}}<br>Destinazione {{iter.trip.steps[leg.to].place.address}}<br><span data-ng-if="leg.keep">Disposizione richiesta<br></span></div></div>');
$templateCache.put('app/components/quote-details/reject/alert.modal.html','<div class="modal complete"><div class="modal-dialog"><div class="close" data-ng-click="modal.closeIt(-1)"><i class="icon icon-cancel"></i></div><div class="whiteframe-container whiteframe"><div class="header"><h2>Perch\xE9 stai rifiutando la richiesta?</h2></div><div class="content whiteframe-content" data-ng-cloak="" data-ng-if="modal.step == 0"><div class="bootstrap"><form novalidate="" data-ng-submit="modal.submit($event)" data-ng-class="{\'was-validated\': modal.validated}"><div class="row"><div class="col-sm"><button class="btn btn-outline-primary" type="button" data-ng-click="modal.closeIt(\'notavailable\');  $event.stopPropagation();" data-ng-cloak="">Non ho disponibilit\xE0</button></div><div class="col-sm"><button class="btn btn-outline-primary" type="button" data-ng-click="modal.closeIt(\'lowprice\');  $event.stopPropagation();" data-ng-cloak="">Prezzo troppo basso</button></div><div class="col-sm"><button class="btn btn-outline-primary" data-ng-click="modal.step = 1; $event.stopPropagation();" data-ng-cloak="">Altro</button></div></div></form></div></div><div class="content whiteframe-content" data-ng-cloak="" data-ng-show="modal.step == 1"><div class="bootstrap"><form novalidate="" data-ng-submit="modal.submit($event)" data-ng-class="{\'was-validated\': modal.validated}"><p>Comunica a Busrapido perch\xE9 vuoi rifiutare il servizio</p><textarea class="form-control" rows="3" required data-ng-model="modal.data.reason"></textarea><div class="invalid-feedback">Lasciaci un commento con pi\xF9 dettagli</div><p></p><div class="row"><div class="col-sm"><button class="btn btn-outline-secondary" type="button" data-ng-click="modal.closeIt(-1);  $event.stopPropagation();" data-ng-cloak="">Annulla</button></div><div class="col-sm"><button class="btn btn-outline-primary" type="submit" data-ng-cloak="">Invia</button></div></div></form></div></div></div></div></div>');
$templateCache.put('app/components/quote-details/new/new.html','<div class="content" data-ng-if="iter.trip"><pre data-ng-bind="iter.getRequestsString(iter.trip, iter.serviceType)">\n\n  </pre></div>');
$templateCache.put('app/elements/auth/step1/name.html','<div class="wrapper name" data-ng-class="{\'was-validated\': step.validated}"><div class="form-group"><div class="col-xs-12"><h3 class="top-title" data-ng-if="!step.profile">Effettua la registrazione come partner</h3><h3 class="top-title" data-ng-if="step.profile">Dati Account</h3><label>Nome dell\'azienda*</label><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="Nome dell\'azienda" required data-ng-model="step.data.tcompany"><div class="invalid-feedback">Ti sei dimenticato di scrivere il nome dell\'azienda</div></div></div></div><div class="form-group"><div class="col-xs-12"><label>Email*</label><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="Email" pattern="{{step.rex.email.source}}" required data-ng-model="step.data.email"><div class="invalid-feedback">L\'email inserita non \xE8 valida</div></div><i class="form-text text-muted">Questo sar\xE0 il tuo username</i></div></div><div class="form-group" data-ng-if="!step.profile"><div class="col-xs-12"><label>Password*</label><div class="input-group input-group-sm"><input type="password" class="form-control" placeholder="Password" pattern="{{step.rex.password.source}}" required data-ng-model="step.data.password"><div class="invalid-feedback">La password deve contenere almeno 6 caratteri e non pu\xF2 contenere spazi</div></div></div></div><div class="form-group" data-ng-if="step.profile"><div class="col-xs-12"><h2>Modifica password</h2></div><div class="col-xs-12"><label>Vecchia password*</label><div class="input-group input-group-sm"><input class="form-control" type="password" required data-br-password="" data-ng-model="step.data.opsswrd"><div class="invalid-feedback">Inserisci la vecchia password</div></div><p><i class="form-text text-muted">Lascia vuoto questo campo se non vuoi cambiare password</i></p></div><div class="col-xs-12"><label>Nuova password*</label><div class="input-group input-group-sm"><input class="form-control" type="password" required data-br-password="" data-ng-model="step.data.psswrd"><div class="invalid-feedback">Inserisci la nuova password</div></div><p><i class="form-text text-muted">Lascia vuoto questo campo se non vuoi cambiare password</i></p></div></div></div>');
$templateCache.put('app/elements/auth/step2/poc.html','<div class="wrapper poc" data-ng-class="{\'was-validated\': step.validated}"><div class="form-group"><div class="col-xs-12"><h3 class="top-title">Dati Responsabile Servizio di Noleggio</h3><label>Nome*</label><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="Nome" required data-ng-model="step.data.name"><div class="invalid-feedback">Ti sei dimenticato di scrivere il nome del responsabile</div></div></div></div><div class="form-group"><div class="col-xs-12"><label>Cognome*</label><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="Cognome" required data-ng-model="step.data.surname"><div class="invalid-feedback">Ti sei dimenticato di scrivere il cognome del responsabile</div></div></div></div><div class="form-group"><div class="col-xs-12"><label>Numero di telefono cellulare del responsabile *</label><div class="input-group input-group-sm"><input type="tel" class="form-control form-control-sm" placeholder="Numero di telefono cellulare del responsabile " pattern="{{step.rex.phone.source}}" required data-ng-model="step.data.phone" data-ng-intl-tel-input=""><div class="invalid-feedback">Ti sei dimenticato di scrivere il numero di telefono del responsabile</div></div></div></div></div>');
$templateCache.put('app/elements/auth/step3/company.html','<div class="wrapper company" data-ng-class="{\'was-validated\': step.validated}"><div class="form-group"><div class="col-xs-12"><h3 class="top-title">Dati Azienda</h3><label>Ragione sociale*</label> <label><i>Hai una ragione sociale diversa? Inserisci la ragione sociale giusta nel campo qui sotto:</i></label><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="Ragione sociale" required data-ng-model="step.data.company"><div class="invalid-feedback">Ti sei dimenticato di scrivere la ragione sociale</div></div></div></div><div class="form-group"><div class="col-xs-12 neg-narrow"><label>Sede legale*</label><data-br-placepicker-slim data-br-label="Sede legale*" data-br-placeholder="Inserisci l\'indirizzo di fatturazione dell\'azienda" data-br-to="step.data.place"></data-br-placepicker-slim></div></div><div class="form-group"><div class="col-xs-12"><label>Partita IVA*</label><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="Partita IVA" required data-ng-model="step.data.taxcode"><div class="invalid-feedback">Controlla la Partita IVA</div></div></div></div><div class="form-group"><div class="col-xs-12"><label>Numero di telefono aziendale*</label><div class="input-group input-group-sm"><input type="tel" class="form-control form-control-sm" pattern="{{step.rex.phone.source}}" placeholder="Numero di telefono aziendale" required data-ng-model="step.data.companyphone" data-ng-intl-tel-input=""><div class="invalid-feedback">Ti sei dimenticato di scrivere il Numero di telefono aziendale</div></div></div></div><div class="form-group"><div class="col-xs-12"><label>Numero di telefono emergenze h24*</label><div class="input-group input-group-sm"><input type="tel" class="form-control form-control-sm" pattern="{{step.rex.phone.source}}" placeholder="Numero di telefono emergenze h24" required data-ng-model="step.data.emergencyphone" data-ng-intl-tel-input=""><div class="invalid-feedback">Ti sei dimenticato di scrivere il Numero di telefono emergenze h24</div></div></div></div><div class="form-group"><div class="col-xs-12"><label>Indirizzo di posta elettronica certificata (PEC)*</label><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="Indirizzo di posta elettronica certificata (PEC)" pattern="{{step.rex.email.source}}" required data-ng-model="step.data.pec"><div class="invalid-feedback">Ti sei dimenticato di scrivere l\'Indirizzo di posta elettronica certificata (PEC)</div></div></div></div><div class="form-group"><div class="col-xs-12"><label>Codice Univoco Destinatario (SDI)</label><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="Codice Univoco Destinatario (SDI)" data-ng-model="step.data.sdi"><div class="invalid-feedback">Ti sei dimenticato di scrivere il Codice Univoco Destinatario (SDI)</div></div></div></div><div class="col-xs-12"><label>Dove vuoi ricevere i pagamenti?</label><div class="" data-ng-repeat="bank in step.data.legal.it.banking track by $index"><p></p><span data-ng-show="step.data.legal.it.banking.length > 1" data-ng-click="step.removeBank($index); $event.stopPropagation();"><span class="icon icon-cancel"></span> </span><label>IBAN</label><div class="input-group input-group-sm"><input type="text" class="form-control form-control-sm" aria-label="IBAN" placeholder="Inserisci IBAN del conto" pattern="{{step.rex.iban.source}}" required data-ng-model="step.data.legal.it.banking[$index].iban" data-ng-model-options="{allowInvalid: true}" data-ng-change="step.capitalizeIBAN($index)"><div class="invalid-feedback">Ti sei dimenticato di scrivere l\'IBAN</div></div><p></p><label>Banca</label><div class="input-group input-group-sm"><input type="text" class="form-control form-control-sm" aria-label="Banca" placeholder="Inserisci nome della banca presso il quale il tuo conto \xE8 aperto " required data-ng-model="step.data.legal.it.banking[$index].bank"><div class="invalid-feedback">Ti sei dimenticato di scrivere il nome della banca</div></div></div><br><div class="row no-margin"><button class="btn btn-sm no-margin-top btn-outline-success" type="button" data-ng-click="step.addBank();  $event.stopPropagation();"><span class="icon icon-add"></span> Aggiungi un altro IBAN</button></div><p></p><i class="text-muted">Inserisci uno o pi\xF9 IBAN e banca dove vuoi ricevere i pagamenti da parte di Busrapido</i><p></p></div><div class="form-group"><div class="col-xs-12"><label>Numero di iscrizione REN</label><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="Numero di iscrizione REN" data-ng-model="step.data.legal.it.ren"><div class="invalid-feedback">Ti sei dimenticato di scrivere il Numero di iscrizione REN</div></div></div></div><div class="form-group"><div class="col-xs-12"><label>Sede del deposito dei veicoli (il tuo garage)*</label><div class="input-group input-group-sm" data-ng-repeat="warehouse in step.data.contact.warehouses track by $index"><div class="input-group-prepend"><button class="btn no-margin-top btn-outline-secondary" type="button" data-ng-show="step.data.contact.warehouses.length > 1" data-ng-click="step.removeWarehouse($index); $event.stopPropagation();"><span class="icon icon-cancel"></span></button></div><data-br-placepicker-slim class="col-sm no-margin no-padding" style="min-width: 300px" data-br-placeholder="Sede del deposito dei veicoli n\xBA {{$index + 1}}" data-br-to="step.data.contact.warehouses[$index]"></data-br-placepicker-slim></div><br><div class="row"><div class="top"><i class="col-sm">Hai pi\xF9 di un deposito? Clicca su [+] per aggiungere un altro deposito operativo</i></div></div><br><div class="row"><div class="col-sm-6"><button class="btn btn-sm no-margin-top btn-outline-success" type="button" data-ng-click="step.addWarehouse();  $event.stopPropagation();"><span class="icon icon-add"></span> Aggiungi deposito</button></div></div></div></div></div>');
$templateCache.put('app/elements/auth/step4/cheer.html','<div class="wrapper cheer" data-ng-class="{\'was-validated\': step.validated}"><div class="col-xs-12"><h3 class="top-title">Grazie di aver inserito i tuoi dati aziendali su Busrapido!</h3><br><p>Completa ora il tuo profilo per ricevere pi\xF9 prenotazioni</p></div></div>');
$templateCache.put('app/elements/auth/step7/notification.html','<div class="wrapper notification" data-ng-class="{\'was-validated\': step.validated}"><div class="form-group"><div class="col-xs-12"><h3 class="top-title">Impostazione Notifiche</h3><p>Scegli ora gli indirizzi email dove vuoi ricevere le richieste di prenotazione e i tuoi migliori numeri di telefono cellulare a cui possiamo inviarti richieste di SOS/Emergenze.</p><label>Dove vuoi ricevere le nostre email con le richieste di prenotazione?</label><div class="input-group input-group-sm" data-ng-repeat="email in step.data.contact.emails track by $index"><div class="input-group-prepend" data-ng-show="step.data.contact.emails.length !== 1"><button class="btn no-margin-top btn-outline-secondary" type="button" data-ng-click="step.removeEmail($index); $event.stopPropagation();"><span class="icon icon-cancel" tooltips="" tooltip-template="Rimuovi questa email"></span></button></div><input type="email" class="form-control" aria-label="Email" placeholder="Email" pattern="{{step.rex.email.source}}" required data-ng-model="step.data.contact.emails[$index]"></div><br><div class="row no-margin"><button class="btn btn-sm no-margin-top btn-outline-success" type="button" data-ng-click="step.addEmail();  $event.stopPropagation();"><span class="icon icon-add"></span> Aggiungi un\'altra email</button></div><p></p><i class="text-muted">Se aggiungi pi\xF9 email riceverai le richieste su tutti gli indirizzi email inseriti</i><p></p></div><div class="col-xs-12"><label>Vuoi ricevere messaggi per richieste di SOS/Emergenze via WhatsApp?**</label><div class="btn-group btn-group-sm btn-group-toggle"><label class="btn btn-sm no-margin btn-outline-success" data-ng-class="{\'active\': step.data.contact.canwhatsapp}"><input type="radio" class="form-control" name="canwhatsapp" required data-ng-model="step.data.contact.canwhatsapp" data-ng-value="true"> S\xEC</label> <label class="btn btn-sm no-margin btn-outline-danger" data-ng-class="{\'active\': step.data.contact.canwhatsapp === false}"><input type="radio" class="form-control" name="canwhatsapp" required data-ng-model="step.data.contact.canwhatsapp" data-ng-value="false"> No</label></div></div></div><div class="form-group" data-ng-if="step.data.contact.canwhatsapp"><div class="col-xs-12"><label>Quale \xE8 il tuo miglior numero WhatsApp a cui possiamo inviarti richieste di SOS/Emergenze?</label><div class="input-group input-group-sm" data-ng-repeat="whatsapp in step.data.contact.whatsapps track by $index"><div class="input-group-prepend"><span class="input-group-text icon icon-whatsapp"></span></div><input type="tel" class="form-control form-control-sm" aria-label="whatsapp" pattern="{{step.rex.phone.source}}" placeholder="Numero di whatsapp n\xBA {{$index + 1}}" required data-ng-model="step.data.contact.whatsapps[$index]" data-ng-intl-tel-input=""><div class="input-group-append"><button class="btn no-margin-top btn-outline-secondary" type="button" data-ng-click="step.removeWhatsapp($index); $event.stopPropagation();"><span class="icon icon-cancel" tooltips="" tooltip-side="left" tooltip-template="Rimuovi questo numero"></span></button></div></div><p></p><p><i class="text-muted" data-ng-if="step.data.contact.whatsapps.length === 0" data-ng-cloak="">Clicca su [+] per aggiungere un numero </i><i class="text-muted" data-ng-if="step.data.contact.whatsapps.length > 0" data-ng-cloak="">Clicca su [+] per aggiungere un altro numero</i></p><div class="row no-margin"><button class="btn btn-sm no-margin-top btn-outline-success" type="button" data-ng-click="step.addWhatsapp();  $event.stopPropagation();" data-ng-if="step.data.contact.whatsapps.length == 0" data-ng-cloak=""><span class="icon icon-add"></span> Aggiungi un numero</button> <button class="btn btn-sm no-margin-top btn-outline-success" type="button" data-ng-click="step.addWhatsapp();  $event.stopPropagation();" data-ng-if="step.data.contact.whatsapps.length > 0" data-ng-cloak=""><span class="icon icon-add"></span> Aggiungi un altro numero</button></div></div></div><div class="form-group"><div class="col-xs-12"><label>Vuoi ricevere messaggi per richieste di SOS/Emergenze via SMS?**</label><div class="btn-group btn-group-sm btn-group-toggle"><label class="btn btn-sm no-margin btn-outline-success" data-ng-class="{\'active\': step.data.contact.cansos}"><input type="radio" class="form-control" name="cansos" required data-ng-model="step.data.contact.cansos" data-ng-value="true"> S\xEC</label> <label class="btn btn-sm no-margin btn-outline-danger" data-ng-class="{\'active\': step.data.contact.cansos === false}"><input type="radio" class="form-control" name="cansos" required data-ng-model="step.data.contact.cansos" data-ng-value="false"> No</label></div></div></div><div class="form-group" data-ng-if="step.data.contact.cansos"><div class="col-xs-12"><label><span data-ng-if="!step.data.contact.canwhatsapp">Se non hai Whatsapp, inserisci</span> <span data-ng-if="step.data.contact.canwhatsapp">Inserisci</span> di seguito il tuo miglior numero di telefono cellulare a cui possiamo inviarti richieste di SOS/Emergenze tramite SMS</label><div class="input-group input-group-sm" data-ng-repeat="phone in step.data.contact.sos track by $index"><div class="input-group-prepend"><span class="input-group-text icon icon-chat-empty"></span></div><input type="tel" class="form-control form-control-sm" aria-label="phone" pattern="{{step.rex.phone.source}}" placeholder="Numero per le emergenze n\xBA {{$index + 1}}" required data-ng-model="step.data.contact.sos[$index]" data-ng-intl-tel-input=""><div class="input-group-append"><button class="btn no-margin-top btn-outline-secondary" type="button" data-ng-click="step.removePhone($index); $event.stopPropagation();"><span class="icon icon-cancel" tooltips="" tooltip-side="left" tooltip-template="Rimuovi questo numero"></span></button></div></div><p></p><p><i class="text-muted" data-ng-if="step.data.contact.sos.length === 0" data-ng-cloak="">Clicca su [+] per aggiungere un numero </i><i class="text-muted" data-ng-if="step.data.contact.sos.length > 0" data-ng-cloak="">Clicca su [+] per aggiungere un altro numero</i></p><div class="row no-margin"><button class="btn btn-sm no-margin-top btn-outline-success" type="button" data-ng-click="step.addPhone();  $event.stopPropagation();" data-ng-if="step.data.contact.sos.length == 0" data-ng-cloak=""><span class="icon icon-add"></span> Aggiungi un numero</button> <button class="btn btn-sm no-margin-top btn-outline-success" type="button" data-ng-click="step.addPhone();  $event.stopPropagation();" data-ng-if="step.data.contact.sos.length > 0" data-ng-cloak=""><span class="icon icon-add"></span> Aggiungi un altro numero</button></div></div></div><div class="col-xs-12"><p><i>**Inserendo il tuo numero autorizzi Busrapido ad inviarti richieste di SOS/Emergenze tramite applicazioni di messaggistica, quali WhatsApp, Telegram ed SMS.</i></p></div></div>');
$templateCache.put('app/elements/auth/step6/firstcompleted.html','<div class="wrapper firstcompleted" data-ng-class="{\'was-validated\': step.validated}"><div class="col-xs-12"><p>Grazie di aver completato la prima fase di registrazione su Busrapido! Scegli ora i tuoi indirizzi email e numeri di telefono preferiti per ricevere le richieste di prenotazione.</p></div></div>');
$templateCache.put('app/elements/auth/step9/vehicle.html','<div class="wrapper vehicle" data-ng-class="{\'was-validated\': step.validated}"><h3 class="top-title">Complimenti!</h3><div class="content"><p class="big-font"><center>Hai completato la registrazione su Busrapido\xA0<icon style="color: red" class="icon icon-bus"></icon></center><br><center>Aggiungi i veicoli della tua flotta per iniziare a ricevere prenotazioni!</center></p></div></div>');
$templateCache.put('app/elements/auth/step8/requesttypes.html','<div class="wrapper requesttypes" data-ng-class="{\'was-validated\': step.validated}"><div class="col-xs-12"><h3 class="top-title">Scheda Veicoli</h3><p>Compila ora la scheda veicoli per ricevere richieste personalizzate in base alla tua flotta:</p></div><div class="form-group"><div class="col-xs-12"><h2>Quanti veicoli hai nella tua flotta?</h2><div class="input-group input-group-sm"><input type="number" class="form-control" placeholder="N\xBA di veicoli" required data-ng-model="step.data.vehicles.fleet"><div class="invalid-feedback">Controlla il numero di veicoli nella flotta</div></div><br><h2>Quali tipologie di veicoli possiedi?*</h2><p data-ng-class="{\'text-danger\': step.invalid && step.validated, \'ng-invalid\': step.invalid}">(Aggiungi una spunta alle tipologie di veicoli che possiedi nella tua flotta)</p><div class="input-group input-group-sm"><div class="input-group-prepend" data-ng-click="step.data.vehicles.common.car = !step.data.vehicles.common.car;"><div class="input-group-text"><input type="checkbox" data-ng-click="$event.stopPropagation()" data-ng-model="step.data.vehicles.common.car"></div></div><p class="form-control">Auto (1-5 pax)</p></div><div class="input-group input-group-sm"><div class="input-group-prepend" data-ng-click="step.data.vehicles.common.minivan = !step.data.vehicles.common.minivan;"><div class="input-group-text"><input type="checkbox" data-ng-click="$event.stopPropagation()" data-ng-model="step.data.vehicles.common.minivan"></div></div><p class="form-control">Minivan (6-7-8 pax)</p></div><div class="input-group input-group-sm"><div class="input-group-prepend" data-ng-click="step.data.vehicles.common.minibus = !step.data.vehicles.common.minibus;"><div class="input-group-text"><input type="checkbox" data-ng-click="$event.stopPropagation()" data-ng-model="step.data.vehicles.common.minibus"></div></div><p class="form-control">Minibus (9-18 pax)</p></div><div class="input-group input-group-sm"><div class="input-group-prepend" data-ng-click="step.data.vehicles.common.minibuslg = !step.data.vehicles.common.minibuslg;"><div class="input-group-text"><input type="checkbox" data-ng-click="$event.stopPropagation()" data-ng-model="step.data.vehicles.common.minibuslg"></div></div><p class="form-control">Minibus (19-28 pax)</p></div><div class="input-group input-group-sm"><div class="input-group-prepend" data-ng-click="step.data.vehicles.common.coach = !step.data.vehicles.common.coach;"><div class="input-group-text"><input type="checkbox" data-ng-click="$event.stopPropagation()" data-ng-model="step.data.vehicles.common.coach"></div></div><p class="form-control">Autobus (29-40 pax)</p></div><div class="input-group input-group-sm"><div class="input-group-prepend" data-ng-click="step.data.vehicles.common.coachlg = !step.data.vehicles.common.coachlg;"><div class="input-group-text"><input type="checkbox" data-ng-click="$event.stopPropagation()" data-ng-model="step.data.vehicles.common.coachlg"></div></div><p class="form-control">Autobus (41-56 pax)</p></div><div class="input-group input-group-sm"><div class="input-group-prepend" data-ng-click="step.data.vehicles.common.coach3 = !step.data.vehicles.common.coach3;"><div class="input-group-text"><input type="checkbox" data-ng-click="$event.stopPropagation()" data-ng-model="step.data.vehicles.common.coach3"></div></div><p class="form-control">Autobus 3 assi (57-64 pax)</p></div><div class="input-group input-group-sm"><div class="input-group-prepend" data-ng-click="step.data.vehicles.common.double = !step.data.vehicles.common.double;"><div class="input-group-text"><input type="checkbox" data-ng-click="$event.stopPropagation()" data-ng-model="step.data.vehicles.common.double"></div></div><p class="form-control">Autobus 2 piani (65+ pax)</p></div><div class="input-group input-group-sm"><div class="input-group-prepend" data-ng-click="step.data.vehicles.common.vintage = !step.data.vehicles.common.vintage;"><div class="input-group-text"><input type="checkbox" data-ng-click="$event.stopPropagation()" data-ng-model="step.data.vehicles.common.vintage"></div></div><p class="form-control">Veicoli d\'epoca</p></div><div class="input-group input-group-sm"><div class="input-group-prepend" data-ng-click="step.data.vehicles.common.limousine = !step.data.vehicles.common.limousine;"><div class="input-group-text"><input type="checkbox" data-ng-click="$event.stopPropagation()" data-ng-model="step.data.vehicles.common.limousine"></div></div><p class="form-control">Limousine</p></div><br><h2>Possiedi veicoli per il trasporto disabili?</h2><div class="btn-group btn-group-sm btn-group-toggle"><label class="btn btn-sm no-margin btn-outline-success" data-ng-class="{\'active\': step.wheelchair}"><input type="radio" name="options" data-ng-model="step.wheelchair" data-ng-value="true"> S\xEC</label> <label class="btn btn-sm no-margin btn-outline-danger" data-ng-class="{\'active\': step.wheelchair === false}"><input type="radio" name="options" data-ng-model="step.wheelchair" data-ng-value="false"> No</label></div><p></p><div data-ng-show="step.wheelchair"><p><i>(Aggiungi una spunta alle tipologie di veicoli per il trasporto disabili che possiedi nella tua flotta)</i><br></p><div class="input-group input-group-sm"><div class="input-group-prepend" data-ng-click="step.data.vehicles.wheelchair.minivan = !step.data.vehicles.wheelchair.minivan;"><div class="input-group-text"><input type="checkbox" data-ng-click="$event.stopPropagation()" data-ng-model="step.data.vehicles.wheelchair.minivan"></div></div><p class="form-control">Minivan (3-6 pax)</p></div><div class="input-group input-group-sm"><div class="input-group-prepend" data-ng-click="step.data.vehicles.wheelchair.minibus = !step.data.vehicles.wheelchair.minibus;"><div class="input-group-text"><input type="checkbox" data-ng-click="$event.stopPropagation()" data-ng-model="step.data.vehicles.wheelchair.minibus"></div></div><p class="form-control">Minibus (9-13 pax)</p></div><div class="input-group input-group-sm"><div class="input-group-prepend" data-ng-click="step.data.vehicles.wheelchair.minibuslg = !step.data.vehicles.wheelchair.minibuslg;"><div class="input-group-text"><input type="checkbox" data-ng-click="$event.stopPropagation()" data-ng-model="step.data.vehicles.wheelchair.minibuslg"></div></div><p class="form-control">Minibus (14-30 pax)</p></div><div class="input-group input-group-sm"><div class="input-group-prepend" data-ng-click="step.data.vehicles.wheelchair.coach = !step.data.vehicles.wheelchair.coach;"><div class="input-group-text"><input type="checkbox" data-ng-click="$event.stopPropagation()" data-ng-model="step.data.vehicles.wheelchair.coach"></div></div><p class="form-control">Autobus (31-48 pax)</p></div><div class="input-group input-group-sm"><div class="input-group-prepend" data-ng-click="step.data.vehicles.wheelchair.coach3 = !step.data.vehicles.wheelchair.coach3;"><div class="input-group-text"><input type="checkbox" data-ng-click="$event.stopPropagation()" data-ng-model="step.data.vehicles.wheelchair.coach3"></div></div><p class="form-control">Autobus 3 Assi (49-61 pax)</p></div></div></div></div><div class="col-xs-12"><h2>Quale \xE8 il Massimale Assicurativo dei tuoi Veicoli?**</h2></div><div class="input-group input-group-sm" data-ng-if="step.data.vehicles.common.car || step.data.vehicles.wheelchair.car"><div class="input-group-prepend col-sm no-padding"><div class="input-group-text"><span>Auto</span></div></div><input class="form-control align-right" type="number" placeholder="Inserisci il massimale assicurativo" required data-ng-model="step.data.insurance.car"><div class="input-group-append"><div class="input-group-text"><span>Milioni</span></div></div></div><div class="input-group input-group-sm" data-ng-if="step.data.vehicles.common.minivan || step.data.vehicles.wheelchair.minivan"><div class="input-group-prepend col-sm no-padding"><div class="input-group-text"><span>Minivan</span></div></div><input class="form-control align-right" type="number" placeholder="Inserisci il massimale assicurativo" required data-ng-model="step.data.insurance.minivan"><div class="input-group-append"><div class="input-group-text"><span>Milioni</span></div></div></div><div class="input-group input-group-sm" data-ng-if="step.data.vehicles.common.minibus || step.data.vehicles.wheelchair.minibus || step.data.vehicles.common.minibuslg || step.data.vehicles.wheelchair.minibuslg"><div class="input-group-prepend col-sm no-padding"><div class="input-group-text"><span>Minibus</span></div></div><input class="form-control align-right" type="number" placeholder="Inserisci il massimale assicurativo" required data-ng-model="step.data.insurance.minibus"><div class="input-group-append"><div class="input-group-text"><span>Milioni</span></div></div></div><div class="input-group input-group-sm" data-ng-if="step.data.vehicles.common.coach || step.data.vehicles.common.coachlg || step.data.vehicles.wheelchair.coach"><div class="input-group-prepend col-sm no-padding"><div class="input-group-text"><span>Autobus</span></div></div><input class="form-control align-right" type="number" placeholder="Inserisci il massimale assicurativo" required data-ng-model="step.data.insurance.coach"><div class="input-group-append"><div class="input-group-text"><span>Milioni</span></div></div></div><div class="input-group input-group-sm" data-ng-if="step.data.vehicles.common.coach3 || step.data.vehicles.wheelchair.coach3"><div class="input-group-prepend col-sm no-padding"><div class="input-group-text"><span>Autobus 3 assi</span></div></div><input class="form-control align-right" type="number" placeholder="Inserisci il massimale assicurativo" required data-ng-model="step.data.insurance.coach3"><div class="input-group-append"><div class="input-group-text"><span>Milioni</span></div></div></div><div class="input-group input-group-sm" data-ng-if="step.data.vehicles.common.double || step.data.vehicles.wheelchair.double"><div class="input-group-prepend col-sm no-padding"><div class="input-group-text"><span>Autobus 2 piani</span></div></div><input class="form-control align-right" type="number" placeholder="Inserisci il massimale assicurativo" required data-ng-model="step.data.insurance.double"><div class="input-group-append"><div class="input-group-text"><span>Milioni</span></div></div></div><div class="input-group input-group-sm" data-ng-if="step.data.vehicles.common.vintage || step.data.vehicles.wheelchair.vintage"><div class="input-group-prepend col-sm no-padding"><div class="input-group-text"><span>Veicoli d\'epoca</span></div></div><input class="form-control align-right" type="number" placeholder="Inserisci il massimale assicurativo" required data-ng-model="step.data.insurance.vintage"><div class="input-group-append"><div class="input-group-text"><span>Milioni</span></div></div></div><div class="input-group input-group-sm" data-ng-if="step.data.vehicles.common.limousine || step.data.vehicles.wheelchair.limousine"><div class="input-group-prepend col-sm no-padding"><div class="input-group-text"><span>Limousine</span></div></div><input class="form-control align-right" type="number" placeholder="Inserisci il massimale assicurativo" required data-ng-model="step.data.insurance.limousine"><div class="input-group-append"><div class="input-group-text"><span>Milioni</span></div></div></div><br><div class="col-xs-12"><i>**Selezionando gli importi di massimale assicurativo sopra dichiari di essere in possesso di veicoli assicurati per un valore corrispondente almeno agli importi selezionati. Busrapido si avvale della facolt\xE0 di escludere l\'azienda dalla piattaforma in caso di dichiarazioni false.</i></div><br></div>');
$templateCache.put('app/elements/auth/step5/additional.html','<div class="wrapper additional" data-ng-class="{\'was-validated\': step.validated}"><div class="col-xs-12"><h3 class="top-title">Dati Aggiuntivi</h3><p>Ora indica qualche dettaglio generale sulla tua azienda, per esempio se puoi emettere fattura elettronica, a quali consorzi o associazioni di categoria sei associato, i tuoi contatti social.</p></div><div class="col-xs-12"><h2>Social Links</h2></div><div class="form-group"><div class="col-xs-12"><label>Link al tuo sito web</label><div class="input-group input-group-sm"><div class="input-group-prepend"><span class="input-group-text icon icon-globe"></span></div><input type="text" class="form-control" placeholder="Link al tuo sito web" data-ng-model="step.data.contact.website"></div></div></div><div class="form-group"><div class="col-xs-12"><label>Link alla tua pagina Facebook</label><div class="input-group input-group-sm"><div class="input-group-prepend"><span class="input-group-text icon icon-facebook-squared"></span></div><input type="text" class="form-control" placeholder="Link alla tua pagina Facebook" data-ng-model="step.data.contact.facebook"></div></div></div><div class="form-group"><div class="col-xs-12"><label>Link al tuo profilo Twitter</label><div class="input-group input-group-sm"><div class="input-group-prepend"><span class="input-group-text icon icon-twitter"></span></div><input type="text" class="form-control" placeholder="Link al tuo profilo twitter" data-ng-model="step.data.contact.twitter"></div></div></div><div class="form-group"><div class="col-xs-12"><label>Sei iscritto al MEPA?*</label><div class="btn-group btn-group-sm btn-group-toggle"><label class="btn btn-sm no-margin btn-outline-success" data-ng-class="{\'active\': step.data.legal.it.mepa === true}"><input type="radio" class="form-control" name="mepa" required data-ng-model="step.data.legal.it.mepa" data-ng-value="true"> S\xEC</label> <label class="btn btn-sm no-margin btn-outline-danger" data-ng-class="{\'active\': step.data.legal.it.mepa === false}"><input type="radio" class="form-control" name="mepa" required data-ng-model="step.data.legal.it.mepa" data-ng-value="false"> No</label></div><input type="radio" class="form-control invisible" name="mepa" required data-ng-model="step.data.legal.it.mepa" data-ng-value="true"><div class="invalid-feedback">Ti sei dimenticato di indicare se sei iscritto al MEPA</div></div></div><div class="form-group"><div class="col-xs-12"><label>Puoi emettere Fatture Elettroniche?*</label><div class="btn-group btn-group-sm btn-group-toggle"><label class="btn btn-sm no-margin btn-outline-success" data-ng-class="{\'active\': step.data.legal.it.einvoice}"><input type="radio" class="form-control" name="einvoice" required data-ng-model="step.data.legal.it.einvoice" data-ng-value="true"> S\xEC</label> <label class="btn btn-sm no-margin btn-outline-danger" data-ng-class="{\'active\': step.data.legal.it.einvoice === false}"><input type="radio" class="form-control" name="einvoice" required data-ng-model="step.data.legal.it.einvoice" data-ng-value="false"> No</label></div><input type="radio" class="form-control invisible" name="einvoice" required data-ng-model="step.data.legal.it.einvoice" data-ng-value="true"><div class="invalid-feedback">Ti sei dimenticato di indicare se puoi emettere fatture elettroniche</div></div></div><div class="form-group"><div class="col-xs-12"><label>Usi un software gestionale?*</label><div class="btn-group btn-group-sm btn-group-toggle"><label class="btn btn-sm no-margin btn-outline-success" data-ng-class="{\'active\': step.data.cansoftware}"><input type="radio" class="form-control" name="cansoftware" required data-ng-model="step.data.cansoftware" data-ng-value="true"> S\xEC</label> <label class="btn btn-sm no-margin btn-outline-danger" data-ng-class="{\'active\': step.data.cansoftware === false}"><input type="radio" class="form-control" name="cansoftware" required data-ng-model="step.data.cansoftware" data-ng-value="false"> No</label></div><br><input type="radio" class="form-control invisible" name="cansoftware" placeholder="Inserisci il nome del software gestionale" required data-ng-model="step.data.cansoftware" data-ng-value="true"><div class="invalid-feedback">Ti sei dimenticato di indicare se usi un software gestionale</div></div><div class="col-xs-12" data-ng-if="step.data.cansoftware"><label>Nome del sofware gestionale</label><div class="input-group input-group-sm"><div class="input-group-prepend"><span class="input-group-text icon icon-cog"></span></div><input type="text" class="form-control" placeholder="Nome del sofware gestionale" data-ng-model="step.data.software"></div></div></div><div class="form-group"><div class="col-xs-12"><p>Sei iscritto ad una associazione di categoria?</p><div class="btn-group btn-group-sm btn-group-toggle"><label class="btn btn-sm no-margin btn-outline-success" data-ng-class="{\'active\': step.data.contact.associations.length > 0}"><input type="radio" class="form-control" data-ng-click="step.setHasAssociation(true)"> S\xEC</label> <label class="btn btn-sm no-margin btn-outline-danger" data-ng-class="{\'active\': step.data.contact.associations.length <= 0}"><input type="radio" class="form-control" data-ng-click="step.setHasAssociation(false)"> No</label></div><p></p><div data-ng-show=" step.data.contact.associations.length > 0"><div class="input-group input-group-sm" data-ng-repeat="association in step.data.contact.associations track by $index"><div class="input-group-prepend"><button class="btn no-margin-top btn-outline-danger" type="button" data-ng-click="step.removeAssociation($index); $event.stopPropagation();"><span class="icon icon-cancel" tooltips="" tooltip-side="right" tooltip-template="Rimuovi questa associazione"></span></button></div><input type="text" class="form-control" aria-label="Nome dell\'associazione" placeholder="Nome dell\'associazione" data-ng-model="step.data.contact.associations[$index]"></div><p></p><p><i data-ng-if="step.data.contact.associations.length == 0">Clicca su [+] per aggiungere un\'associazione di categoria</i> <i data-ng-if="step.data.contact.associations.length >= 1">Sei iscritto a pi\xF9 di una associazione di categoria? Clicca su [+] per aggiungere un\'altra associazione di categoria</i></p><div class="row"><div class="input-group input-group-sm col-sm-6"><button class="btn btn-sm no-margin-top btn-outline-success" type="button" data-ng-click="step.addAssociation();  $event.stopPropagation();"><span class="icon icon-add"></span> Aggiungi associazione</button></div></div></div></div></div><div class="form-group"><div class="col-xs-12"><p>Sei iscritto ad un consorzio?</p><div class="btn-group btn-group-sm btn-group-toggle"><label class="btn btn-sm no-margin btn-outline-success" data-ng-class="{\'active\': step.data.contact.unions.length > 0}"><input type="radio" class="form-control" data-ng-click="step.setHasUnion(true)"> S\xEC</label> <label class="btn btn-sm no-margin btn-outline-danger" data-ng-class="{\'active\': step.data.contact.unions.length <= 0}"><input type="radio" class="form-control" data-ng-click="step.setHasUnion(false)"> No</label></div><p></p><div data-ng-show=" step.data.contact.unions.length > 0"><div class="input-group input-group-sm" data-ng-repeat="union in step.data.contact.unions track by $index"><div class="input-group-prepend"><button class="btn no-margin-top btn-outline-danger" type="button" data-ng-click="step.removeUnion($index); $event.stopPropagation();"><span class="icon icon-cancel" tooltips="" tooltip-side="right" tooltip-template="Rimuovi questa associazione"></span></button></div><input type="text" class="form-control" aria-label="Nome del consorzio" placeholder="Nome del consorzio" required data-ng-model="step.data.contact.unions[$index]"></div><p></p><p><i data-ng-if="step.data.contact.unions.length == 0">Clicca su [+] per aggiungere un consorzio</i> <i data-ng-if="step.data.contact.unions.length >= 1">Sei iscritto a pi\xF9 di un consorzio? Clicca su [+] per aggiungere un altro consorzio</i></p><div class="row"><div class="input-group input-group-sm col-sm-6"><button class="btn btn-sm no-margin-top btn-outline-success" type="button" data-ng-click="step.addUnion();  $event.stopPropagation();"><span class="icon icon-add"></span> Aggiungi consorzio</button></div></div></div></div></div></div>');
$templateCache.put('app/views/supplier/book/newquote.html','<update-title title="Nuove prenotazioni | Busrapido"></update-title><update-meta property="og:title" content="Nuove prenotazioni | Busrapido"></update-meta><update-meta name="twitter:title" content="Nuove prenotazioni | Busrapido"></update-meta><main class="main-results"><md-content layout-fill=""><div class="loader-container loader-icon-container" data-ng-class="{\'loader-show\' : !vm.loaded}"><div class="loader-icon">Loading...</div></div><section data-ng-if="vm.loaded"><div class="container"><div class="row"><div class="col-xs-12"><data-br-book-plan data-br-quote="vm.quote"></data-br-book-plan><data-br-book-overview data-br-quote="vm.quote"></data-br-book-overview><data-br-book-price data-br-quote="vm.quote"></data-br-book-price><data-br-book-users data-br-quote="vm.quote" data-ng-if="vm.admin"></data-br-book-users><data-br-book-drivers data-br-quote="vm.quote"></data-br-book-drivers><data-br-book-standards data-br-quote="vm.quote"></data-br-book-standards><data-br-book-attachment data-br-quote="vm.quote"></data-br-book-attachment><data-br-book-email data-br-quote="vm.quote" data-ng-if="vm.admin"></data-br-book-email><data-br-book-partners data-br-quote="vm.quote" data-ng-if="vm.admin"></data-br-book-partners><data-br-book-network data-br-quote="vm.quote"></data-br-book-network><data-br-book-supplier data-br-quote="vm.quote" data-br-supplier="vm.supplier" data-ng-if="vm.admin"></data-br-book-supplier><data-br-book-publish data-br-quote="vm.quote" data-br-supplier-quote="vm.supplier.quote"></data-br-book-publish><br></div></div></div><div class="col-xs-12 whiteframe-container" style="position: fixed; bottom: 0px; padding:0px; margin: 0px; right: 0px;"><div class="whiteframe"><div class="container"><div class="content"><div class="col-xs-12"><div><button class="btn btn-md">La richiesta \xE8 {{vm.quote.status | adminStatus}}</button> <button tabindex="2" class="btn-green btn btn-md" data-ng-click="vm.saveChanges()" data-ng-if="vm.quote.status === \'hidden\'">Salva Bozza</button> <button tabindex="2" class="btn-primary btn btn-md" data-ng-click="vm.publish()" data-ng-if="vm.quote.status === \'hidden\'">Invia richiesta</button></div></div></div></div></div></div></section></md-content></main>');
$templateCache.put('app/views/supplier/subscribe/subscribe.html','<update-title title="Profilo | Busrapido"></update-title><update-meta property="og:title" content="Profilo | Busrapido"></update-meta><update-meta name="twitter:title" content="Profilo | Busrapido"></update-meta><main class="main-subscribe"><section><div class="container"><div class="col-sm-12"><div class="whiteframe-container"><div class="col-xs-12" data-ng-if="!vm.loaded"><div class="loader-container loader-icon-container" data-ng-class="{\'loader-show\' : !vm.loaded}"><div class="loader-icon">Loading...</div></div></div><div class="whiteframe no-margin"><div class="col-xs-12 no-margin bootstrap" data-ng-if="vm.loaded"><div class="card"><div class="card-body"><div class="text-center"><h5 class="big">Status abbonamento</h5><data-br-dashboard data-br-header="\'Sfrutta al massimo la nuova\'" data-br-action="vm.current.gocardless ? \'Vai su nuove richieste\' : \'Abbonati subito!\'" data-br-target="vm.current.gocardless ?  \'root.it.supplier.quotes.list\' : \'root.it.supplier.subscribe.list({ \\\'#\\\': \\\'plans\\\' })\'"></data-br-dashboard><data-br-offering-supplier></data-br-offering-supplier></div><div class="text-center"><h5 class="big">Scegli il piano<br>pi\xF9 adatto alle tue esigenze</h5><div class="card-deck" id="plans"><div class="card rounded-border"><div class="card-body"><div style="margin: 2em;"><img src="./assets/images/icons/basic.svg" style="width: 10em; height: 10em; object-fit: scale-down" alt="Bus Busrapido" class="rounded-circle"></div><h5 class="card-title">Basic partner</h5><p class="card-text">Iscrizione gratuita</p><p><small>Commissione del 10% sui servizi che accetti</small></p><div><div data-ng-if="(vm.tier == \'base\' || vm.tier == \'free\') && vm.current.gocardless"><button class="btn btn-success" style="margin-bottom: 0.2em;" data-ng-click="vm.subscribe()">Hai scelto il piano base</button></div><div data-ng-if="!vm.tier || !vm.current.gocardless"><button class="btn btn-success" style="margin-bottom: 0.2em;" data-ng-click="vm.subscribe()">Scegli il piano base</button></div></div></div><div class="card-footer"><div class="card feature-box"><div class="card-body"><p class="card-text"><span class="icon icon-ok-circle gold"></span>Visualizza le richieste ancora disponibili</p><p class="card-text"><span class="icon icon-ok-circle gold"></span>Pagamento garantito a 30 gg</p><p class="card-text"><span class="icon icon-ok-circle gold"></span>Aumenta il tuo fatturato</p><p class="card-text"><span class="icon icon-ok-circle gold"></span>Base globale di clienti</p></div></div></div></div><div class="card rounded-border"><div class="card-body"><div style="margin: 2em;"><img src="./assets/images/icons/standard.svg" style="width: 10em; height: 10em; object-fit: scale-down" alt="Bus Busrapido" class="rounded-circle"></div><h5 class="card-title">Standard partner</h5><div data-ng-if="vm.tier == \'free\' || vm.tier == \'base\' || vm.tier == \'standard\' || !vm.current.gocardless"><p class="card-text price">{{vm.plan.standard.monthly.amount | currency}} / mese</p><p class="card-text">{{vm.plan.standard.yearly.amount | currency}} / anno (risparmi il 20%)</p></div><div><div data-ng-if="vm.tier == \'standard\' && vm.current.gocardless"><button class="btn btn-success">Hai scelto il piano standard <span data-ng-if="vm.interval == \'monthly\'">mensile</span> <span data-ng-if="vm.interval == \'yearly\'">annuale</span> <span>{{vm.current.subscription.amount | currency}}</span></button></div><div data-ng-if="!vm.tier || !vm.current.gocardless || vm.tier == \'free\' || vm.tier==\'base\'"><a href="{{vm.mandateLink.standard.monthly}}" target="_blank" data-ng-click="vm.choose(vm.plan.standard.monthly)"><button class="btn btn-success">Scegli Standard mensile</button> </a><a href="{{vm.mandateLink.standard.yearly}}" target="_blank" data-ng-click="vm.choose(vm.plan.standard.yearly)"><button class="btn btn-sm btn-secondary" style="margin-top: 0.2em;">Scegli Standard annuale</button></a></div></div></div><div class="card-footer"><div class="card feature-box"><div class="card-body"><p class="card-text"><span class="icon icon-thick green"></span>Ricevi il doppio delle richieste rispetto al piano Basic</p><p class="card-text"><span class="icon icon-thick green"></span>Pagamento garantito a 30gg</p><p class="card-text"><span class="icon icon-thick green"></span><b>Nessuna commissione</b></p><p class="card-text"><span class="icon icon-thick green"></span><b>Assistenza 24/7 e sistema di gestione emergenze</b></p><p class="card-text"><span class="icon icon-thick green"></span>Crea la tua rete personalizzata di collaboratori</p><p class="card-text"><span class="icon icon-thick green"></span>Crea richieste di servizi e assegnale ai tuoi collaboratori</p></div></div></div></div><div class="card rounded-border"><div class="card-body"><div style="margin: 2em;"><img src="./assets/images/icons/premium.svg" style="width: 10em; height: 10em; object-fit: scale-down" alt="Bus Busrapido" class="rounded-circle"></div><h5 class="card-title">Premium partner</h5><p class="card-text">Prezzo su misura</p><div><div data-ng-if="vm.tier == \'premium\' && vm.current.gocardless"><button class="btn btn-success" style="margin-bottom: 0.2em;">Hai scelto l\'abbonamento premium per {{vm.amount | currency}} <span data-ng-if="vm.interval == \'monthly\'">mese</span> <span data-ng-if="vm.interval == \'yearly\'">anno</span></button></div><div data-ng-if="!vm.tier || !vm.current.gocardless || vm.tier == \'free\' || vm.tier==\'base\'"><a href="{{vm.mandateLink.premium.monthly}}" target="_blank" data-ng-click="vm.choose(vm.plan.premium.monthly)" data-ng-if="vm.mandateLink.premium && vm.mandateLink.premium.monthly"><button class="btn btn-success">Scegli Premium mensile {{vm.plan.premium.monthly.amount | currency}}</button> </a><a href="{{vm.mandateLink.premium.yearly}}" target="_blank" data-ng-click="vm.choose(vm.plan.premium.yearly)" data-ng-if="vm.mandateLink.premium && vm.mandateLink.premium.yearly"><button class="btn btn-sm btn-secondary" style="margin-top: 0.2em;">Scegli Premium annuale {{vm.plan.premium.yearly.amount | currency}}</button> </a><a href="mailto:info@busrapido.com?subject=Busrapido Richiesta contatto per abbonamento Premium - {{vm.current.company}}" target="_blank" data-ng-if="!vm.mandateLink.premium || !(vm.mandateLink.premium.yearly || vm.mandateLink.premium.monthly)"><button class="btn btn-success" style="margin-bottom: 0.2em;">Contattaci</button></a></div></div></div><div class="card-footer"><div class="card feature-box"><div class="card-body"><p class="card-text"><span class="icon icon-thick green"></span><b>Visualizza le richieste con 2 ore di anticipo rispetto agli altri</b></p><p class="card-text"><span class="icon icon-thick green"></span><b>Garanzia money-back*</b><br>(Soddisfatto o rimborsato)</p><p class="card-text"><span class="icon icon-thick green"></span>Ricevi fino a 5 volte delle richieste rispetto al piano Basic</p><p class="card-text"><span class="icon icon-thick green"></span><b>Pagamento garantito a 7gg</b></p><p class="card-text"><span class="icon icon-thick green"></span><b>Nessuna commissione</b></p><p class="card-text"><span class="icon icon-thick green"></span><b>Assistenza 24/7 e sistema di gestione emergenze</b></p><p class="card-text"><span class="icon icon-thick green"></span>Crea la tua rete personalizzata di collaboratori</p><p class="card-text"><span class="icon icon-thick green"></span>Crea richieste di servizi e assegnale ai tuoi collaboratori</p></div></div></div></div></div></div></div></div><div class="text-center"><p><small>Puoi disiscriverti quando vuoi, gratuitamente. Siamo sicuri che non lo farai.</small></p><p><small>*Garanzia money-back: Scegliendo il piano mensile Premium Partner, Busrapido ti garantir\xE0 servizi di trasporto di importo almeno pari al costo del tuo abbonamento. Se nel corso del periodo di 12 mesi dalla sua sottoscrizione non riceverai da Busrapido richieste per un importo pari ad almeno il valore del tuo abbonamento, Busrapido ti rimborser\xE0 la differenza.</small></p><p><small>Sottoscrivendo l\'abbonamento accetti integralmente il <a href="{{vm.$users}}/it/termini-condizioni/contratto-di-licenza-uso/">Contratto di Licenza d\'Uso</a>, i <a href="{{vm.$users}}/it/termini-condizioni/generali/" target="_blank" rel="noopener noreferrer">Termini e Condizioni</a> e l\'<a href="{{vm.$users}}/it/termini-condizioni/privacy/" target="_blank" rel="noopener noreferrer">Informativa sulla Privacy</a> di Busrapido.</small></p></div></div></div></div></div></div></section></main><data-br-footer></data-br-footer>');
$templateCache.put('app/elements/planner-topic/services/citytour/citytour.html','<div class="wrapper city"><div class="row"><div class="type col-xs-2"><span class="bootstrap">City tour <span class="badge badge-pill badge-primary" tooltips="" tooltip-template="Clicca per aggiungere informazioni" data-ng-show="!service.request.services[service.index].more" data-ng-click="service.request.services[service.index].more = true"><span class="icon icon-add"></span> </span><span class="badge badge-pill badge-primary" tooltips="" tooltip-template="Clicca per nascondere le informazioni opzionali" data-ng-show="service.request.services[service.index].more" data-ng-click="service.request.services[service.index].more = false"><span class="icon icon-cancel"></span></span></span></div></div><div class="row"><data-br-datetimepicker class="col-xs" data-br-date="service.request.services[service.index-1].depart" data-br-label-date="Dal giorno" data-br-label-time="Ore" data-ng-if="!service.request.services[service.index-1].depart && service.showStart" data-br-def-time="08:00"></data-br-datetimepicker><data-br-datetimepicker class="col-xs" data-br-date="service.request.services[service.index].depart" data-br-label-date="Fino al giorno" data-br-label-time="Ore" data-br-def-time="08:00"></data-br-datetimepicker></div><div class="row" data-ng-show="service.request.services[service.index].more"><div class="col-xs"><label><div class="top">Note aggiuntive</div></label><div class="bootstrap"><textarea class="form-control-sm col-sm" aria-label="Note aggiuntive" placeholder="Note aggiuntive" data-ng-model="service.request.services[service.index].notes"></textarea></div></div></div></div>');
$templateCache.put('app/elements/planner-topic/services/end/end.html','<div class="wrapper end"><div class="row"><div class="type"><span class="bootstrap">Fine servizio <span class="badge badge-pill badge-primary" tooltips="" tooltip-template="Clicca per aggiungere informazioni" data-ng-show="!service.request.services[service.index].more" data-ng-click="service.request.services[service.index].more = true"><span class="icon icon-add"></span> </span><span class="badge badge-pill badge-primary" tooltips="" tooltip-template="Clicca per nascondere le informazioni opzionali" data-ng-show="service.request.services[service.index].more" data-ng-click="service.request.services[service.index].more = false"><span class="icon icon-cancel"></span></span></span></div></div><div data-ng-if="service.request.services[service.index].more"><div class="row"><data-br-placepicker-fast class="col-xs" data-br-label="In che luogo finisce il servizio?" data-br-to="service.request.services[service.index].place" data-br-placeholder="Indirizzo, ristorante, hotel, chiesa, areoporto, stazione" data-br-from="service.from.place" data-br-waypoints="service.waypoints" data-br-depart-time="service.from.depart" data-br-maps="service.maps" data-br-google-directions-service="service.googleDirectionsService" data-br-on-compute="service.onCompute()" data-br-directions="service.directions" data-br-hw-speed="planner.MIN_HW_SPEED" data-br-speed-limit="planner.MAX_VEHICLE_SPEED" data-br-label-bottom="{{(service.request.services[service.index].arrive | labelArrive : service.directions.total.duration : service.request.services[service.index].layover : \'Arrivo previsto: \')}}"></data-br-placepicker-fast></div><div class="row"><data-br-datetimepicker class="col-xs" data-br-label-date="Che giorno finisce il servizio?" data-br-label-time="a che ore?" data-br-def="08:00" data-br-date="service.request.services[service.index].depart" data-br-placeholder-date="Data" data-br-placeholder-time="Ora"></data-br-datetimepicker></div><div class="row"><div class="col-xs"><label><div class="top">Informazioni aggiuntive (opzionale)</div></label><div class="bootstrap"><textarea class="form-control-sm col-sm" aria-label="Informazioni aggiuntive (opzionale)" placeholder="Informazioni aggiuntive (opzionale)" data-ng-model="service.request.services[service.index].notes"></textarea></div></div></div><br></div></div>');
$templateCache.put('app/elements/planner-topic/services/disposal/disposal.html','<div class="wrapper disposal"><div class="row"><div class="type col-xs-2"><span class="bootstrap">Disposal <span class="badge badge-pill badge-primary" tooltips="" tooltip-template="Clicca per aggiungere informazioni" data-ng-show="!service.request.services[service.index].more" data-ng-click="service.request.services[service.index].more = true"><span class="icon icon-add"></span> </span><span class="badge badge-pill badge-primary" tooltips="" tooltip-template="Clicca per nascondere le informazioni opzionali" data-ng-show="service.request.services[service.index].more" data-ng-click="service.request.services[service.index].more = false"><span class="icon icon-cancel"></span></span></span></div></div><div class="row"><data-br-datetimepicker class="col-xs" data-br-date="service.request.services[service.index-1].depart" data-br-label-date="Dal giorno" data-br-label-time="Ore" data-ng-if="!service.request.services[service.index-1].depart && service.showStart" data-br-def-time="08:00"></data-br-datetimepicker><data-br-datetimepicker class="col-xs" data-br-date="service.request.services[service.index].depart" data-br-label-date="Fino al giorno" data-br-label-time="Ore" data-br-def-time="08:00"></data-br-datetimepicker></div><div class="row" data-ng-show="service.request.services[service.index].more"><div class="col-xs"><label><div class="top">Note aggiuntive</div></label><div class="bootstrap"><textarea class="form-control-sm col-sm" aria-label="Note aggiuntive" placeholder="Note aggiuntive" data-ng-model="service.request.services[service.index].notes"></textarea></div></div></div></div>');
$templateCache.put('app/elements/planner-topic/services/pickup/pickup.html','<div class="wrapper pickup"><div class="row"><div class="type">Pickup</div></div><div class="row"><data-br-datepicker class="align-left" data-br-label="Che giorno vuoi partire?" data-br-placeholder="Data" data-br-model="service.modelDatepicker" data-br-change="service.onDateChange()"></data-br-datepicker><div class="col-xs"><div class="header"><div class="row"><div class="col-xs">Distanza {{service.distance | distance}}</div><div class="col-xs">Tempo di guida {{service.drive | duration}}</div><div class="col-xs">Durata noleggio {{service.duration | duration}}</div></div></div></div></div><div class="row place"><data-br-placepicker-fast class="col-xs-8" data-br-label="Da dove parti?" data-br-placeholder="Indirizzo, ristorante, hotel, chiesa, areoporto, stazione" data-br-disabled="false" data-br-to="service.request.services[service.index].place" data-br-on-select="" data-br-maps="service.maps" data-br-google-directions-service="service.googleDirectionsService" data-br-on-geocode=""></data-br-placepicker-fast><data-br-timepicker class="col-xs-4" data-br-label="a che ora?" data-br-placeholder="Ora" data-br-model="service.modelTimepicker" data-br-change="service.onTimeChange()"></data-br-timepicker></div></div>');
$templateCache.put('app/elements/planner-topic/services/return/return.html','<div class="wrapper return"><div class="row"><div class="type col-xs-2">Ritorno</div></div><div class="row" data-ng-if="!service.from.depart"><data-br-datetimepicker class="col-xs" data-br-label-date="Che giorno parti?" data-br-label-time="a che ore?" data-br-def="08:00" data-br-date="service.from.depart" data-br-placeholder-date="Data" data-br-placeholder-time="Ora"></data-br-datetimepicker></div><div class="row"><data-br-placepicker-fast class="col-xs" data-br-label="Ritorna a" data-br-to="service.request.services[service.index].place" data-br-placeholder="Indirizzo, ristorante, hotel, chiesa, areoporto, stazione" data-br-from="service.from.place" data-br-waypoints="service.waypoints" data-br-depart-time="service.from.depart" data-br-maps="service.maps" data-br-google-directions-service="service.googleDirectionsService" data-br-on-compute="service.onCompute()" data-br-directions="service.directions" data-br-hw-speed="planner.MIN_HW_SPEED" data-br-speed-limit="planner.MAX_VEHICLE_SPEED" data-br-label-bottom="{{(service.request.services[service.index].arrive | labelArrive : service.directions.total.duration : service.request.services[service.index].layover : \'Arrivo previsto: \')}}"></data-br-placepicker-fast></div></div>');
$templateCache.put('app/elements/planner-topic/services/shuttle/shuttle.html','<div class="wrapper shuttle"><div class="row"><div class="type col-xs-2">Ripeti</div></div><div class="row"><label for="" class="col-xs-4"><div class="top">Ripeti ogni</div><select name="" id="" data-ng-model="service.request.services[service.index].delta"><option data-ng-value="delta" data-ng-repeat="delta in service.deltas">{{delta | interval}}</option></select></label><data-br-datetimepicker class="col-xs" data-br-date="service.request.services[service.index].depart" data-br-label-date="Fino al giorno" data-br-label-time="Ore" data-br-def-time="08:00"></data-br-datetimepicker></div></div>');
$templateCache.put('app/elements/planner-topic/services/transfer/transfer.html','<div class="wrapper transfer"><div class="row"><div class="type col-xs-2">Transfer</div></div><div class="row"><data-br-placepicker-fast class="col-xs" data-br-label="Qual \xE8 la prossima destinazione?" data-br-to="service.request.services[service.index].place" data-br-placeholder="Indirizzo, ristorante, hotel, chiesa, areoporto, stazione" data-br-from="service.from.place" data-br-waypoints="service.waypoints" data-br-depart-time="service.from.depart" data-br-maps="service.maps" data-br-google-directions-service="service.googleDirectionsService" data-br-on-compute="service.onCompute()" data-br-directions="service.directions" data-br-hw-speed="planner.MIN_HW_SPEED" data-br-speed-limit="planner.MAX_VEHICLE_SPEED" data-br-label-bottom="{{(service.request.services[service.index].arrive | labelArrive : service.directions.total.duration : service.request.services[service.index].layover : \'Arrivo previsto: \')}}"></data-br-placepicker-fast></div><div class="row" data-ng-if="service.request.services.length - 1 > service.index && (service.request.services[service.index + 1].type == \'transfer\' || service.request.services[service.index + 1].type == \'return\' || service.request.services[service.index + 1].type == \'transit\')"><data-br-datetimepicker class="col-xs" data-br-label-date="Che giorno riparti?" data-br-label-time="a che ore?" data-br-def="08:00" data-br-date="service.request.services[service.index].depart" data-br-placeholder-date="Data" data-br-placeholder-time="Ora"></data-br-datetimepicker></div></div>');
$templateCache.put('app/elements/planner-topic/services/bus/bus.html','<div class="wrapper bus"><div class="row"><div class="type col-xs-2">Bus in loco</div></div><div class="row"><data-br-datetimepicker class="col-xs" data-br-date="service.request.services[service.index-1].depart" data-br-label-date="Dal giorno" data-br-label-time="Ore" data-ng-if="!service.request.services[service.index-1].depart && service.showStart" data-br-def-time="08:00"></data-br-datetimepicker><data-br-datetimepicker class="col-xs" data-br-date="service.request.services[service.index].depart" data-br-label-date="Fino al giorno" data-br-label-time="Ore" data-br-def-time="08:00"></data-br-datetimepicker></div></div>');
$templateCache.put('app/elements/planner-topic/services/transit/transit.html','<div class="wrapper transit"><div class="row"><div class="type col-xs-2"><span class="bootstrap">Transit <span class="badge badge-pill badge-primary" tooltips="" tooltip-template="Clicca per aggiungere informazioni" data-ng-show="!service.request.services[service.index].more" data-ng-click="service.request.services[service.index].more = true"><span class="icon icon-add"></span> </span><span class="badge badge-pill badge-primary" tooltips="" tooltip-template="Clicca per nascondere le informazioni opzionali" data-ng-show="service.request.services[service.index].more" data-ng-click="service.request.services[service.index].more = false"><span class="icon icon-cancel"></span></span></span></div></div><div class="row"><data-br-placepicker-fast class="col-xs" data-br-label="Luogo di transito" data-br-to="service.request.services[service.index].place" data-br-maps="service.maps" data-br-google-directions-service="service.googleDirectionsService" data-br-hw-speed="service.MIN_HW_SPEED" data-br-speed-limit="service.MAX_VEHICLE_SPEED"></data-br-placepicker-fast></div><div class="row" data-ng-show="service.request.services[service.index].more"><div class="col-xs"><label><div class="top">Note aggiuntive</div></label><div class="bootstrap"><textarea class="form-control-sm col-sm" aria-label="Note aggiuntive" placeholder="Note aggiuntive" data-ng-model="service.request.services[service.index].notes"></textarea></div></div></div></div>');
$templateCache.put('app/views/supplier/book/drivers/drivers.html','<div class="content"><section data-ng-if="vm.loaded"><div class="container"><div class="row"><div class="container col-xs-12"><div class="whiteframe-container"><form class="whiteframe" novalidate=""><div class="header"><h4>Requisiti Autista</h4></div><div class="content"><label><div class="top"><span class="label">Sesso</span></div><select data-ng-model="vm.quote.driver_gender"><option value="other">Nessun requisito specifico</option><option value="male">Uomo</option><option value="female">Donna</option></select></label> <label><div class="top"><span class="label">Abbigliamento/divisa</span></div><select data-ng-model="vm.quote.driver_dresscode"><option value="other">Nessun requisito specifico</option><option value="formal">Giacca e Cravatta</option><option value="shirt">Camicia</option></select></label> <label><div class="top"><span class="label">Fumatore/smoking policy</span></div><select data-ng-model="vm.quote.driver_smoking"><option data-ng-value="true">Nessun requisito specifico</option><option data-ng-value="false">Non fumatore</option></select></label> <label><div class="top"><span>Lingua</span></div><input type="text" placeholder="Inglese, francese, spagnolo, etc." data-ng-model="vm.quote.driver_language"></label> <label><div class="top"><span class="label">\xC8 richiesta la certificazione Halal?</span></div><div class="bootstrap"><div class="btn-group btn-group-sm btn-group-toggle"><label class="btn btn-sm no-margin btn-outline-success" data-ng-class="{\'active\': vm.quote.driver_halal === true}"><input type="radio" class="form-control" data-ng-model="vm.quote.driver_halal" data-ng-value="true"> S\xEC</label> <label class="btn btn-sm no-margin btn-outline-danger" data-ng-class="{\'active\': vm.quote.driver_halal === false}"><input type="radio" class="form-control" data-ng-model="vm.quote.driver_halal" data-ng-value="false"> No</label></div></div></label> <label><div class="top"><span>Altri requisiti:</span></div><input type="text" data-ng-model="vm.quote.driver_other"></label></div></form></div></div></div></div></section></div>');
$templateCache.put('app/views/supplier/book/attachments/attachments.html','<div class="content"><section data-ng-if="vm.loaded"><div class="container"><div class="row"><div class="container col-xs-12"><div class="whiteframe-container"><form class="whiteframe" novalidate=""><div class="header"><h4>Allegati</h4></div><div class="content content-form"><data-br-uploader-doc data-br-label="Inserisci gli allegati" data-br-info="Trascina o clicca sul +<br/>" data-br-docs="vm.quote.attachments" data-br-files="vm.files" data-br-tags="vm.tags"></data-br-uploader-doc></div></form></div></div></div></div></section></div>');
$templateCache.put('app/views/supplier/book/email/email.html','<div class="content"><section data-ng-if="vm.loaded"><div class="container"><div class="row"><div class="container col-xs-12"><div class="whiteframe-container email bootstrap"><form class="whiteframe" novalidate=""><div class="header"><h4>Email Work in progress</h4></div><div class="content"><div class="input-group mb-3"><div class="input-group-prepend input-group-prepend-7"><span class="input-group-text">Template</span></div><select class="custom-select" data-ng-model="vm.template"><option data-ng-value="$index" data-ng-repeat="template in vm.templates">{{template.Name}}</option></select><div class="input-group-append" tooltips="" tooltip-template="Ricarica il template con i dati della richiesta aggiornati" data-ng-click="vm.refreshEmail()"><button class="btn btn-outline-secondary" type="button"><span class="icon icon-arrows-cw"></span></button></div></div><div class="input-group mb-3"><div class="input-group-prepend input-group-prepend-7"><span class="input-group-text">Sender name</span></div><input type="text" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default" data-ng-model="vm.quote.email.name"></div><div class="input-group mb-3"><div class="input-group-prepend input-group-prepend-7"><span class="input-group-text">From</span></div><input type="text" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default" data-ng-model="vm.quote.email.from"></div><div class="input-group mb-3"><div class="input-group-prepend input-group-prepend-7"><span class="input-group-text">Reply To<md-tooltip>L\'indirizzo a cui arrivano le risposte</md-tooltip></span></div><input type="text" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default" data-ng-model="vm.quote.email.reply"></div><div class="input-group mb-3"><div class="input-group-prepend input-group-prepend-7"><span class="input-group-text">Subject</span></div><input type="text" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default" data-ng-model="vm.quote.email.subject"></div><text-angular ta-unsafe-sanitizer="true" ta-keep-styles="true" ta-text-editor-class="form-content" ta-html-editor-class="form-content" ta-focussed-class="focussed" data-ng-model="vm.quote.email.html"></text-angular></div></form></div></div></div></div></section></div>');
$templateCache.put('app/views/supplier/book/network/network.html','<div class="content"><section data-ng-if="vm.loaded"><div class="container"><div class="row"><div class="container col-xs-12"><div class="whiteframe-container"><form class="whiteframe" novalidate=""><div class="header"><h4>Network</h4></div><div class="bootstrap"><div class="content"><p>Seleziona i partner del tuo Network a cui vuoi inviare la richiesta</p><div class="input-group input-group-sm"><div class="input-group-prepend" data-ng-click="vm.quote.all = !vm.quote.all;"><div class="input-group-text"><input type="checkbox" data-ng-click="$event.stopPropagation()" data-ng-model="vm.quote.all"></div></div><p class="form-control">Invia a tutta la rete di Busrapido</p></div><div class="input-group input-group-sm"><div class="input-group-prepend" data-ng-click="vm.flipAll()"><div class="input-group-text"><input type="checkbox" data-ng-change=" vm.flipAll();  " data-ng-model="vm.networkAll"></div></div><p class="form-control">Invia a tutti i tuoi partner</p></div><div data-ng-if="vm.network.length == 0"><a target="_blank" data-ui-sref="root.it.supplier.network.list"><button class="btn btn-success">Aggiungi ora partner al tuo network!</button></a></div><div class="input-group input-group-sm" data-ng-repeat="partner in vm.network track by $index"><div class="input-group-prepend" data-ng-click="vm.network[$index].selected = !vm.network[$index].selected;"><div class="input-group-text"><input type="checkbox" data-ng-click="$event.stopPropagation()" data-ng-model="vm.network[$index].selected"></div></div><p class="form-control">{{vm.network[$index].name}}</p><p class="form-control">{{vm.network[$index].email}}</p></div></div></div></form></div></div></div></div></section></div>');
$templateCache.put('app/views/supplier/book/overview/overview.html','<div class="content"><section data-ng-if="vm.loaded"><div class="container"><div class="row"><div class="container col-xs-12"><div class="whiteframe-container"><form class="whiteframe" novalidate=""><div class="header"><h4>Overview Prenotazione</h4></div><div class="content"><label><div class="top"><span class="label">Numero prenotazione</span></div><span>{{vm.quote.id | quoteId}}</span></label> <label data-ng-if="vm.admin"><div class="top"><span class="label" tooltips="" tooltip-template="Questo campo \xE8 visibile solo agli admin">Admin responsabile</span></div><select data-ng-model="vm.quote.owner"><option value="Gabriele">Gabriele</option><option value="Andrea">Andrea</option><option value="Roberto">Roberto</option><option value="Luca">Luca</option><option value="Elena">Elena</option></select></label> <label><div class="top"><span class="label">Tipologia Servizio</span></div><select tabindex="1" required name="service_type" data-ng-model="vm.quote.service_type"><option value="TRF">TRANSFER</option><option value="DISPO">DISPOSAL</option><option value="FD">FULL DAY</option><option value="TOUR">TOUR</option><option value="INT">INTERNATIONAL</option><option value="SHUTTLE">SHUTTLE</option><option value="OTHER">OTHER</option></select></label> <label><div class="top"><span class="label">Tipo di richiesta</span></div><select tabindex="1" required name="request_type" data-ng-model="vm.quote.request_type"><option value="real">Preventivo</option><option value="request">Prenotazione</option><option value="other">Opzione</option><option value="onlyrequest">Only for you - Prenotazione</option><option value="onlyother">Only for you - Opzione</option></select></label> <label><div class="top"><span class="label">Passeggeri</span></div><input tabindex="1" type="number" data-ng-model="vm.quote.onboard.passengers" data-ng-attr-placeholder="{{vm.quote.onboard.passengers}}"></label> <label><div class="top"><span class="label">Numero autisti</span></div><input tabindex="1" type="number" data-ng-model="vm.quote.onboard.drivers" data-ng-attr-placeholder="{{vm.quote.onboard.drivers}}"></label> <label><div class="top"><span class="label">Numero guide/accompagnatori</span></div><input tabindex="1" type="number" data-ng-model="vm.quote.onboard.others" data-ng-attr-placeholder="{{vm.quote.onboard.others}}"></label> <label><div class="top"><span class="label">Descrizione corta servizio</span></div><div class="row"><div class="col-xs-8"><input tabindex="1" type="text" placeholder="Ad esempio TRF ROMA - MILANO..." data-ng-model="vm.quote.info"></div><div class="col-xs-4"><button class="btn btn-md btn-primary" data-ng-click="vm.quote.info = vm.name(vm.quote.onboard.passengers, vm.quote.requests, vm.quote.service_type)">Genera automaticamente</button></div></div></label><div class="warn collapse-step" data-ng-if="vm.warning"><p>{{vm.warning}}</p></div></div></form></div></div></div></div></section></div>');
$templateCache.put('app/views/supplier/book/partners/partners.html','<div class="content"><section data-ng-if="vm.loaded"><div class="container"><div class="row"><div class="container col-xs-12"><div class="whiteframe-container"><form class="whiteframe" novalidate=""><div class="header"><h4>Aggiungi partner</h4></div><div class="content"><div class="col-xs-12"><label for="">Distanza massima in chilometri <input tabindex="1" type="number" data-ng-model="vm.distance"></label><div class="row"><div class="col-xs-12"><data-br-placepicker data-br-label="Cerca partner vicini a" data-br-info="" data-br-to="vm.place"></data-br-placepicker></div><div class="col-xs-12"><label><input type="text" placeholder="Cerca tra i dati dell\'azienda" data-ng-model="vm.number" data-ng-keydown="$event.keyCode === 13 && vm.search(vm.number)"></label></div><div class="col-xs-4"><button class="btn btn-md btn-primary offset" data-ng-click="vm.searchSuppliers()">Cerca</button></div></div><div class="content"><div class="row"><div class="col-xs"><button class="btn btn-md btn-primary" data-ng-click="vm.sendQuotes()"><span class="icon icon-share"></span> Rendi visibile ai partner selezionati <span data-ng-if="vm.gridApi.selection.getSelectedCount() > 0">({{vm.gridApi.selection.getSelectedCount() }})</span></button></div><div class="col-xs"><button class="btn btn-md btn-primary" data-ng-click="vm.sendQuoteEmails()"><span class="icon icon-mail-alt"></span> Invia email ai partner selezionati <span data-ng-if="vm.gridApi.selection.getSelectedCount() > 0">({{vm.gridApi.selection.getSelectedCount() }})</span></button></div></div></div><div class="warn collapse-step" data-ng-if="vm.warning"><p>{{vm.warning}}</p></div><div class="table table-bordered table-condensed table-container" data-ui-grid="vm.gridOptions" data-ng-style="vm.gridStyle" data-ui-grid-auto-resize="" data-ui-grid-pagination="" data-ui-grid-pinning="" data-ui-grid-selection=""></div></div></div></form></div></div></div></div></section></div>');
$templateCache.put('app/views/supplier/book/plan/plan.html','<div class="content"><section data-ng-if="vm.loaded"><div class="view plan container"><div class="row"><div class="container col-xs-12"><div class="whiteframe-container"><div class="whiteframe"><div class="header"><h4>Itinerario</h4></div><md-tabs md-selected="vm.index" md-dynamic-height="" md-border-bottom=""><md-tab md-on-select="vm.select(\'new\')"><md-label>Planner</md-label><md-tab-body><div class="plan col-xs-12"><data-br-planner-topic class="planner" data-br-data="vm.quote" data-br-low-passengers-alert="0"></data-br-planner-topic></div></md-tab-body></md-tab><md-tab md-on-select="vm.select(\'manual\')" data-ng-if="vm.admin"><md-label>Manuale</md-label><md-tab-body><md-content class="content whiteframe"><form><label><div class="top">Descrizione del viaggio</div><textarea type="text" md-maxrows="50" rows="20" aria-label="Descrizione del viaggio..." data-ng-model="vm.quote.details"></textarea></label></form></md-content></md-tab-body></md-tab><md-tab data-ng-if="vm.admin"><md-label>Appunti <span class="icon icon-info"><md-tooltip>Questa sezione \xE8 visibile solo agli admin</md-tooltip></span></md-label><md-tab-body><md-content class="content whiteframe"><form><label><textarea type="text" md-maxrows="50" rows="20" aria-label="Descrizione del viaggio..." data-ng-model="vm.quote.notes"></textarea></label></form></md-content></md-tab-body></md-tab></md-tabs></div></div></div></div></div></section></div>');
$templateCache.put('app/views/supplier/book/price/price.html','<div class="content"><section data-ng-if="vm.loaded"><div class="view plan container"><div class="row"><div class="container col-xs-12"><div class="content"><div class="whiteframe-container"><div class="whiteframe"><div class="header"><h4 data-ng-if="vm.admin">Prezzo</h4><h4 data-ng-if="!vm.admin">Prezzo offerto alla tua rete di collaboratori</h4></div><form data-ng-if="vm.admin"><div class="content"><div class="row"><div class="col-xs-10"><div class="row"><div class="col-sm"><label><div class="top"><span class="label">Prezzo netto cliente</span></div><input tabindex="1" type="number" data-ng-model="vm.quote.client_price" data-ng-change="vm.updateClientPrice()"></label></div><div class="col-sm"><label><div class="top"><span class="label">IVA cliente</span></div><input tabindex="1" type="number" data-ng-model="vm.quote.client_vat" data-ng-change="vm.updateClientVat()"></label></div><div class="col-sm"><label><div class="top"><span class="label">Prezzo lordo cliente</span></div><input tabindex="1" type="number" data-ng-model="vm.quote.client_total" data-ng-change="vm.updateClientTotal()"></label></div></div><div class="row"><div class="col-sm"><label><div class="top"><span class="label">Prezzo netto partner</span></div><input tabindex="1" type="number" data-ng-model="vm.quote.partner_price" data-ng-change="vm.updatePartnerPrice()"></label></div><div class="col-sm"><label><div class="top"><span class="label">IVA partner</span></div><input tabindex="1" type="number" data-ng-model="vm.quote.vat" data-ng-change="vm.updatePartnerVat()"></label></div><div class="col-sm"><label><div class="top"><span class="label">Prezzo lordo partner</span></div><input tabindex="1" type="number" data-ng-model="vm.quote.partner_total" data-ng-change="vm.updatePartnerTotal()"></label></div></div></div><div class="tag col-xs-2 margin" data-ng-class="{\'tag-green\': vm.quote.client_total - vm.quote.partner_total > 0, \'tag-red\': vm.quote.client_total - vm.quote.partner_total < 0}">{{vm.quote.client_total - vm.quote.partner_total | margin}}</div></div></div></form><form data-ng-if="!vm.admin"><div class="content"><div class="row"><div class="col-xs-12"><div class="row"><div class="col-sm"><label><div class="top"><span class="label">Prezzo al netto dell\'IVA</span></div><input tabindex="1" type="number" data-ng-model="vm.quote.client_price" data-ng-change="vm.updateClientPrice()"></label></div><div class="col-sm"><label><div class="top"><span class="label">IVA</span></div><input tabindex="1" type="number" data-ng-model="vm.quote.client_vat" data-ng-change="vm.updateClientVat()"></label></div><div class="col-sm"><label><div class="top"><span class="label">Prezzo IVA inclusa</span></div><input tabindex="1" type="number" data-ng-model="vm.quote.client_total" data-ng-change="vm.updateClientTotal()"></label></div></div></div></div></div></form><div class="header"><h4>Spese</h4></div><div class="content"><div class="content"><p>Clicca "+" per aggiungere una spesa inclusa nel prezzo o a carico del gruppo</p></div></div><div class="content"><div class="content" data-ng-repeat="cost in vm.quote.costs"><div class="row"><div class="dot enabled" data-ng-click="vm.removeCost($index)"><span class="icon icon-cancel"></span></div><div class="col-xs"><label>Descrizione spesa <input type="text" data-ng-model="vm.quote.costs[$index].name"></label></div><div class="col-xs"><label>Importo netto spesa <input type="text" data-ng-model="vm.quote.costs[$index].value"></label></div><div class="col-xs"><label>IVA % <input type="text" data-ng-model="vm.quote.costs[$index].vat"></label></div><div class="col-xs"><label>Chi paga? <select data-ng-model="vm.quote.costs[$index].who"><option data-ng-value="who" data-ng-repeat="who in vm.who">{{who | costPayer}}</option></select></label></div></div></div><div class="content"><div class="row"><div class="dot enabled" data-ng-click="vm.addCost()"><span class="icon icon-add"></span></div></div></div></div></div></div></div></div></div></div></section></div>');
$templateCache.put('app/views/supplier/book/publish/publish.html','<div class="content"><section data-ng-if="vm.loaded"><div class="container"><data-br-quote-details data-br-quote="vm.quote" data-br-prefix="vm.prefix"></data-br-quote-details></div></section></div>');
$templateCache.put('app/views/supplier/book/standards/standards.html','<div class="content"><section data-ng-if="vm.loaded"><div class="container"><div class="row"><div class="container col-xs-12"><div class="whiteframe-container"><form class="whiteframe" novalidate=""><div class="whiteframe"><div class="heading"><h2>Requisiti minimi</h2></div><div class="content content-form"><div class="row"><div class="col-xs"><button tabindex="1" class="btn btn-outline btn-md" data-ng-click="vm.setStandards(0)">RESET</button></div><div class="col-xs"><button tabindex="1" class="btn btn-outline btn-md" data-ng-click="vm.setStandards(1)">ECONOMY</button></div><div class="col-xs"><button tabindex="1" class="btn btn-outline btn-md" data-ng-click="vm.setStandards(2)">COMFORT</button></div><div class="col-xs"><button tabindex="1" class="btn btn-outline btn-md" data-ng-click="vm.setStandards(3)">COMFORT SUPERIOR</button></div><div class="col-xs"><button tabindex="1" class="btn btn-outline btn-md" data-ng-click="vm.setStandards(4)">FIRST CLASS</button></div><div class="col-xs"><button tabindex="1" class="btn btn-outline btn-md" data-ng-click="vm.setStandards(5)">FIRST CLASS SUPERIOR</button></div></div><div class="row"><div class="col-xs-4"><label><div class="top"><span class="label">Numero di assi</span></div><select tabindex="1" required name="axis" data-ng-model="vm.quote.vehicle.specs.axis"><option value="" disabled="disabled" selected="selected" hidden>Assi</option><option data-ng-repeat="item in ::vm.inputs.axis track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div><div class="col-xs-4"><label><div class="top"><span class="label">Categoria Euro</span></div><select tabindex="1" required name="emissionsClass" data-ng-model="vm.quote.vehicle.specs.emissionClass"><option value="" disabled="disabled" selected="selected" hidden>Categoria Euro</option><option data-ng-repeat="item in ::vm.inputs.emissions track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div><div class="col-xs-4"><label><div class="top"><span class="label">Immatricolazione</span></div><select tabindex="1" required name="matriculation" data-ng-model="vm.quote.vehicle.specs.matriculation"><option value="" disabled="disabled" selected="selected" hidden>Prima immatricolazione</option><option data-ng-repeat="item in ::vm.inputs.years track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div></div><div class="row"><div class="col-xs-4"><label><div class="top"><span class="label">Lunghezza</span></div><select tabindex="1" required name="lengthiness" data-ng-model="vm.quote.vehicle.specs.lengthiness"><option value="" disabled="disabled" selected="selected" hidden>Lunghezza in metri</option><option data-ng-repeat="item in ::vm.inputs.lengthiness track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div><div class="col-xs-4"><label><div class="top"><span class="label">Larghezza</span></div><select tabindex="1" required name="largeness" data-ng-model="vm.quote.vehicle.specs.largeness"><option value="" disabled="disabled" selected="selected" hidden>Larghezza in metri</option><option data-ng-repeat="item in ::vm.inputs.largeness track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div><div class="col-xs-4"><label><div class="top"><span class="label">Altezza</span></div><select tabindex="1" required name="highness" data-ng-model="vm.quote.vehicle.specs.highness"><option value="" disabled="disabled" selected="selected" hidden>Altezza in metri</option><option data-ng-repeat="item in ::vm.inputs.highness track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div></div><div class="row"><div class="col-xs-4"><label><div class="top"><span class="label">Posti Passeggeri</span></div><select tabindex="1" required name="passengers" data-ng-model="vm.quote.vehicle.specs.seats.passengers"><option value="" disabled="disabled" selected="selected" hidden>Posti passeggero</option><option data-ng-repeat="item in ::vm.inputs.passengers track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div><div class="col-xs-4"><label><div class="top"><span class="label">Posti accompagnatore</span></div><select tabindex="1" required name="drivers" data-ng-model="vm.quote.vehicle.specs.seats.drivers"><option value="" disabled="disabled" selected="selected" hidden>Posti accompagnatore</option><option data-ng-repeat="item in ::vm.inputs.drivers track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div><div class="col-xs-4"><label><div class="top"><span class="label">Massimale assicurativo minimo</span></div><select tabindex="1" required name="drivers" data-ng-model="vm.quote.insurance"><option value="" disabled="disabled" selected="selected" hidden>Massimale assicurativo minimo</option><option data-ng-repeat="item in ::vm.inputs.insurance track by item.value" data-ng-attr-value="{{item.value}}">{{item.name}}</option></select></label></div></div><div class="row"><div class="col-xs-6"><label><div class="top"><span class="label">Colore del veicolo</span></div><input tabindex="1" required name="color" placeholder="Rosso, verde, nero, bianco, etc." data-ng-model="vm.quote.vehicle.specs.color"></label></div><div class="col-xs-6"><label><div class="top"><span class="label">Cinture di sicurezza</span></div><select tabindex="1" required name="seatbelts" data-ng-model="vm.quote.vehicle.specs.seatbelts"><option value="" disabled="disabled" selected="selected" hidden>Cinture di sicurezza</option><option data-ng-repeat="item in ::vm.inputs.seatbelts track by item.value" data-ng-attr-value="{{item.value}}">{{item.name | seatbelts}}</option></select></label></div></div></div><div class="heading"><h2>Servizi a bordo</h2></div><div class="content content-services-text"><div class="row"><div class="col-xs-12"><p>Optional del veicolo</p><ul class="services-10"><li data-ng-repeat="(key, service) in vm.services track by key" data-ng-class="{\'active\': vm.quote.vehicle.services[key]}" data-ng-click="vm.quote.vehicle.services[key] = !vm.quote.vehicle.services[key]"><span tabindex="1" class="icon" data-ng-class="service.icon"></span><p style="color: black">{{service.name}}</p></li></ul></div></div></div></div></form></div></div></div></div></section></div>');
$templateCache.put('app/views/supplier/book/users/users.html','<div class="content"><section data-ng-if="vm.loaded"><div class="container"><div class="row"><div class="container col-xs-12"><div class="whiteframe-container"><form class="whiteframe" novalidate=""><div class="header"><h4>Cliente</h4></div><div class="content"><label><div class="top"><span tooltips="" tooltip-template="Visibile solo agli admin">Nome</span></div><input type="text" data-ng-model="vm.quote.client_name"></label> <label><div class="top"><span tooltips="" tooltip-template="Visibile solo agli admin">Email</span></div><input type="text" data-ng-model="vm.quote.client_email"></label> <label><div class="top"><span tooltips="" tooltip-template="Visibile solo agli admin">Appunti</span></div><input type="text" data-ng-model="vm.quote.client"></label></div></form></div></div></div></div></section></div>');
$templateCache.put('app/views/supplier/book/supplier/supplier.html','<div class="content"><section data-ng-if="vm.loaded"><div class="container"><div class="row"><div class="container col-xs-12"><div class="whiteframe-container"><div class="whiteframe"><div class="header"><h4>Status partner contattati</h4></div><div class="row"><div class="content"><div class="col-xs"><button class="btn btn-md btn-primary" data-ng-click="vm.hideSelected()"><span class="icon icon-cancel"></span> Nascondi ai partner selezionati</button></div></div></div><div class="content"><div class="table table-bordered table-condensed" data-ui-grid="vm.gridOptions2" data-ui-grid-auto-resize="" data-ui-grid-selection="" data-ui-grid-pinning=""></div></div></div></div></div></div></div></section></div>');
$templateCache.put('app/views/supplier/tables/network/network.html','<update-title title="Rete | Busrapido"></update-title><update-meta property="og:title" content="Rete | Busrapido"></update-meta><update-meta name="twitter:title" content="Rete | Busrapido"></update-meta><main class="main-trips vehicle-table"><div class="loader-container loader-icon-container" data-ng-class="{\'loader-show\' : !vm.loaded}"><div class="loader-icon">Loading...</div></div><section data-ng-if="vm.loaded"><div class="container"><div class="whiteframe-container whiteframe"><div class="content"><div class="bootstrap"><h5 class="text-center padded-line-md roberto-poster-title">Network di collaboratori</h5><div class="input-group input-group-sm" data-ng-repeat="partner in vm.network track by $index"><div class="input-group-prepend"><button class="btn no-margin-top btn-outline-danger" type="button" data-ng-click="vm.removePartner($index); $event.stopPropagation();"><span class="icon icon-cancel" tooltips="" tooltip-side="right" tooltip-template="Rimuovi questa associazione"></span></button></div><input type="text" class="form-control" aria-label="Email del collaboratore" placeholder="Email del collaboratore" data-ng-model="vm.network[$index].email"> <input type="text" class="form-control" aria-label="Nome del collaboratore" placeholder="Nome del collaboratore" data-ng-model="vm.network[$index].name"></div><p></p><p><i data-ng-if="vm.network.length == 0">Clicca su [+] per aggiungere un partner al tuo network</i> <i data-ng-if="vm.network.length >= 1">Clicca su [+] per aggiungere un altro partner al tuo network</i></p><div class="row"><div class="input-group input-group-sm col-sm-6"><button class="btn btn-sm no-margin-top btn-outline-success" type="button" data-ng-click="vm.addPartner();  $event.stopPropagation();"><span class="icon icon-add"></span> Aggiungi partner</button></div></div><br><div class="flex-column flex-sm-row row"><div class="col-md-6 col-xs"><button class="btn btn-sm btn-secondary" type="button" data-ng-click="vm.resetChanges();  $event.stopPropagation();" data-ng-cloak="">Annulla</button></div><div class="col-md-6 col-xs"><button class="btn btn-sm btn-success" data-ng-click="vm.save()" data-ng-cloak="">Salva modifiche</button></div></div></div></div></div></div></section></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/supplier/tables/sent-quote/list.html','<update-title title="Gira servizi | Busrapido"></update-title><update-meta property="og:title" content="Gira servizi | Busrapido"></update-meta><update-meta name="twitter:title" content="Gira servizi | Busrapido"></update-meta><main class="main-trips vehicle-table"><div class="loader-container loader-icon-container" data-ng-class="{\'loader-show\' : !vm.loaded}"><div class="loader-icon">Loading...</div></div><section data-ng-if="vm.loaded"><div class="container-xl"><div class="whiteframe-container whiteframe"><div class="content content-float"><div class="row no-margin"><div><label><div class="top"></div><div class="row no-margin"><div><input type="text" placeholder="Cerca un servizio per numero" data-ng-model="vm.number" data-ng-keyup="vm.search(vm.number)"></div><div><button class="btn btn-md btn-primary btn-height" data-ng-click="vm.search(vm.number)">Cerca</button></div></div></label></div><div class="content"></div><div><label><div class="top"></div><div class="row no-margin"><div class="no-width"><input type="text"></div><div><button class="btn btn-height btn-md btn-outline" data-ng-click="vm.duplicate()" data-ng-class="{\'disabled\': vm.gridApi.selection.getSelectedRows().length !== 1, \'enabled\': vm.gridApi.selection.getSelectedRows().length === 1}" data-ng-disabled="vm.gridApi.selection.getSelectedRows().length !== 1"><span class="icon icon-docs" tooltip-side="right" tooltips="" tooltip-template="Seleziona un servizio per duplicarlo"></span> Duplica</button></div></div></label></div><div class="content"></div><div><div class="top">Livello di zoom</div><label><select data-ng-change="vm.resize(vm.zoom)" data-ng-model="vm.zoom"><option data-ng-value="50">50%</option><option data-ng-value="60">60%</option><option data-ng-value="70">70%</option><option data-ng-value="80">80%</option><option data-ng-value="90">90%</option><option data-ng-value="100">100%</option><option data-ng-value="110">110%</option><option data-ng-value="120">120%</option><option data-ng-value="130">130%</option></select></label></div><div class="content"></div><div><label><div class="top"></div><div class="row no-margin"><div class="no-width"><input type="text"></div><div><button class="btn-height btn btn-md btn-primary" data-ng-click="vm.createQuote()"><span class="icon icon-add"></span> Aggiungi servizio</button></div></div></label></div></div></div></div><div class="whiteframe-container whiteframe table-container"><div data-ui-grid="vm.gridOptions" data-ng-style="vm.gridStyle" data-ui-grid-auto-resize="" data-ui-grid-pagination="" data-ui-grid-selection="" data-ui-grid-pinning=""></div></div></div></section></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/supplier/tables/pricing/pricing.html','<update-title title="Tariffario | Busrapido"></update-title><update-meta property="og:title" content="Tariffario | Busrapido"></update-meta><update-meta name="twitter:title" content="Tariffario | Busrapido"></update-meta><main class="main-trips vehicle-table"><div class="loader-container loader-icon-container" data-ng-class="{\'loader-show\' : !vm.loaded}"><div class="loader-icon">Loading...</div></div><section data-ng-if="vm.loaded"><div class="container-xl"><div class="whiteframe-container whiteframe content"><div class="table-container no-overflow-x bootstrap pricing"><div class="content"><h5 class="text-center padded-line-md roberto-poster-title">Listino confidenziale</h5><p class="text-center">I prezzi sono da intendersi al\u2002<b>netto</b>\u2002di IVA (10%)</p><p class="text-center roberto-poster-emph">Clicca due volte su un prezzo per modificarlo</p><div class="auto-margin" data-ui-grid="vm.gridOptions" data-ng-style="vm.gridStyle" data-ui-grid-auto-resize="" data-ui-grid-edit=""></div><p></p><h5 class="text-center roberto-poster-subtitle">Trasferimenti</h5><p></p><p class="text-center">Aggiungi prezzi per alcune tratte specifiche</p><div class="col-sm-12 col-md-8 col-lg-5 auto-margin" style="min-width: 600px;"><div class="content text-center"><p><i>Clicca su [+] per aggiungere un trasferimento a prezzo fisso</i></p><div class="row"><div class="input-group input-group-sm col-sm-6"><button class="btn btn-sm no-margin-top btn-outline-success" type="button" data-ng-click="vm.addTransfer();  $event.stopPropagation();"><span class="icon icon-add"></span> Aggiungi trasferimento</button></div><div class="input-group input-group-sm col-sm-6 margin-auto"><button class="btn btn-sm no-margin-top btn-outline-success" type="button" data-ng-click="vm.removeSelected();  $event.stopPropagation();" data-ng-show="vm.gridApiTransfers.selection.getSelectedRows().length > 0"><span class="icon icon-cancel"></span> Rimuovi selezionati</button></div></div></div></div><div class="form-group"><div class="auto-margin" data-ui-grid="vm.gridOptionsTransfers" data-ng-style="vm.gridStyleTransfers" data-ui-grid-auto-resize="" data-ui-grid-edit="" data-ui-grid-selection=""></div></div><p></p><h5 class="text-center roberto-poster-subtitle">Tariffari in PDF o EXEL</h5><p></p><div class="col-sm-12 col-md-8 col-lg-5 auto-margin" style="min-width: 600px;"><p>Se vuoi oltre alla tabella, che dovrai compilare per ricevere pi\xF9 preventivi, puoi allegarci i tariffari che applichi ai tuoi migliori clienti.</p><p>Questo aiuter\xE0 il nostro team a mandarti viaggi in linea con quelli da voi svolti.</p><p>Le aziende che inseriscono tariffari completi ricevono in media il triplo di richieste di prenotazione su base mensile.</p><div class="content content-form"><data-br-uploader-doc data-br-label="Inserisci i tariffari" data-br-info="Trascina o clicca sul +<br/>" data-br-docs="vm.current.subscription.attachments" data-br-files="vm.files"></data-br-uploader-doc></div></div><p></p><h5 class="text-center roberto-poster-subtitle">Extra Charges (\u20AC)</h5><p></p><div class="form-group"><div class="auto-margin" data-ui-grid="vm.gridOptionsCharges" data-ng-style="vm.gridStyleCharges" data-ui-grid-auto-resize="" data-ui-grid-edit=""></div></div></div><div><div class="col-sm-12 col-md-8 col-lg-5 auto-margin" style="min-width: 600px;"><div class="content"><p></p><h5 class="text-center roberto-poster-subtitle">Extra Charges (%)</h5><p></p><div class="form-group"><p></p><h6>Notturno</h6><p></p><div class="row no-margin"><div><data-br-timepicker data-br-model="vm.nightstart" data-br-label="Inizio orario notturno"></data-br-timepicker></div><div class="content"></div><div><data-br-timepicker data-br-model="vm.nightend" data-br-label="Fine orario notturno"></data-br-timepicker></div></div><div class="input-group input-group-sm mb-3"><div class="input-group-prepend col-sm-10 no-padding"><span class="input-group-text">Sovrapprezzo per servizi in orario notturno:</span></div><input type="number" class="form-control col-sm-1" aria-label="" placeholder="10" data-ng-model="vm.night"><div class="input-group-append"><span class="input-group-text">%</span></div></div><p></p><h6>Giornate specifiche</h6><p></p><div class="input-group input-group-sm mb-3"><div class="input-group-prepend col-sm-10 no-padding"><span class="input-group-text">Sovrapprezzo per servizi di Sabato:</span></div><input type="number" class="form-control col-sm-1" aria-label="" placeholder="10" data-ng-model="vm.saturday"><div class="input-group-append"><span class="input-group-text">%</span></div></div><div class="input-group input-group-sm mb-3"><div class="input-group-prepend col-sm-10 no-padding"><span class="input-group-text">Sovrapprezzo per servizi di Domenica:</span></div><input type="number" class="form-control col-sm-1" aria-label="" placeholder="10" data-ng-model="vm.sunday"><div class="input-group-append"><span class="input-group-text">%</span></div></div><p></p><h6>Special days</h6><p></p><div class="input-group input-group-sm mb-3"><div class="input-group-prepend col-sm-10 no-padding"><span class="input-group-text">Sovrapprezzo per giornate speciali (ad es. Natale, Capodanno, Pasqua):</span></div><input type="number" class="form-control col-sm-1" aria-label="" placeholder="10" data-ng-model="vm.special"><div class="input-group-append"><span class="input-group-text">%</span></div></div><p></p><h6>Emergenze</h6><p></p><div class="input-group input-group-sm mb-3"><div class="input-group-prepend col-sm-10 no-padding"><span class="input-group-text">Sovrapprezzo per coprire emergenze</span></div><input type="number" class="form-control col-sm-1" aria-label="" placeholder="10" data-ng-model="vm.emergency"><div class="input-group-append"><span class="input-group-text">%</span></div></div><p></p><h6>Alta stagione</h6><p></p><div class="input-group input-group-sm mb-3"><div class="input-group-prepend col-sm-10 no-padding"><span class="input-group-text">Sovrapprezzo per servizi in alta stagione:</span></div><input type="number" class="form-control col-sm-1" aria-label="" placeholder="10" data-ng-model="vm.high"><div class="input-group-append"><span class="input-group-text">%</span></div></div></div><p></p><h6 class="text-center">Quali sono i mesi di alta stagione per te?</h6><p></p><div class="input-group input-group-sm" data-ng-repeat="month in vm.monthNames"><div class="input-group-prepend" data-ng-click="vm.months[$index] = !vm.months[$index];"><div class="input-group-text"><input type="checkbox" data-ng-click="$event.stopPropagation()" data-ng-model="vm.months[$index]"></div></div><p class="form-control col-sm-11">{{vm.monthNames[$index]}}</p></div><p></p><h5 class="text-center roberto-poster-subtitle">PREFERENZE PER IL TRASPORTO E PER CATEGORIE SPECIALI DI PASSEGGERI</h5><p></p><div class="form-group"><div class="row"><label><div class="top"><span class="label">Effettui servizi di trasporto internazionali?</span></div><select data-ng-model="vm.current.international"><option data-ng-value="undefined" data-ng-selected=""></option><option value="all">S\xEC, sia nei paesi UE che extra-UE</option><option value="eu">S\xEC, solo nei paesi dell\'Unione Europea (UE)</option><option value="none">No, effettuo servizi solo all\'interno dei confini nazionali</option></select></label></div><div class="row"><label><div class="top"><span class="label">Trasporti passeggeri da/verso discoteche?</span></div><div class="bootstrap"><div class="btn-group btn-group-sm btn-group-toggle"><label class="btn btn-sm no-margin btn-outline-success" data-ng-class="{\'active\': vm.current.club === true}"><input type="radio" class="form-control" data-ng-model="vm.current.club" data-ng-value="true"> S\xEC</label> <label class="btn btn-sm no-margin btn-outline-danger" data-ng-class="{\'active\': vm.current.club === false}"><input type="radio" class="form-control" data-ng-model="vm.current.club" data-ng-value="false"> No</label></div></div></label></div><div class="row"><label><div class="top"><span class="label">Trasporti tifosi?</span></div><div class="bootstrap"><div class="btn-group btn-group-sm btn-group-toggle"><label class="btn btn-sm no-margin btn-outline-success" data-ng-class="{\'active\': vm.current.fans === true}"><input type="radio" class="form-control" data-ng-model="vm.current.fans" data-ng-value="true"> S\xEC</label> <label class="btn btn-sm no-margin btn-outline-danger" data-ng-class="{\'active\': vm.current.fans === false}"><input type="radio" class="form-control" data-ng-model="vm.current.fans" data-ng-value="false"> No</label></div></div></label></div><div class="row"><label><div class="top"><span class="label">Trasporti passeggeri per manifestazioni politiche?</span></div><div class="bootstrap"><div class="btn-group btn-group-sm btn-group-toggle"><label class="btn btn-sm no-margin btn-outline-success" data-ng-class="{\'active\': vm.current.politics === true}"><input type="radio" class="form-control" data-ng-model="vm.current.politics" data-ng-value="true"> S\xEC</label> <label class="btn btn-sm no-margin btn-outline-danger" data-ng-class="{\'active\': vm.current.politics === false}"><input type="radio" class="form-control" data-ng-model="vm.current.politics" data-ng-value="false"> No</label></div></div></label> <label>Ci sono altre particolari categorie di passeggeri che preferisci non trasportare? <textarea rows="5" data-ng-model="vm.current.blacklist"></textarea></label></div></div></div></div></div></div></div><div class="whiteframe-container bootstrap" style="position: fixed; bottom: 0px; padding:0px; margin: 0px; right: 0px;"><div class="whiteframe"><div class="content"><div><button class="btn btn-success" data-ng-click="vm.save()">Salva tariffario</button></div></div></div></div></div></section></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/supplier/tables/vehicles/vehicles.html','<update-title title="Nuove prenotazioni | Busrapido"></update-title><update-meta property="og:title" content="Nuove prenotazioni | Busrapido"></update-meta><update-meta name="twitter:title" content="Nuove prenotazioni | Busrapido"></update-meta><main class="main-trips vehicle-table"><div class="loader-container loader-icon-container" data-ng-class="{\'loader-show\' : !vm.loaded}"><div class="loader-icon">Loading...</div></div><section data-ng-if="vm.loaded"><div class="container-xl"><div class="whiteframe-container whiteframe"><div class="content content-float"><div class="row no-margin"><div><label><div class="top"></div><div class="row no-margin"><div><input type="text" placeholder="Cerca un veicolo per targa" data-ng-model="vm.number" data-ng-keyup="vm.search(vm.number)"></div><div><button class="btn btn-md btn-primary btn-height" data-ng-click="vm.search(vm.number)">Cerca</button></div></div></label></div><div class="content"></div><div><label><div class="top"></div><div class="row no-margin"><div class="no-width"><input type="text"></div><div><button class="btn btn-height btn-md btn-outline" data-ng-click="vm.duplicate()" data-ng-class="{\'disabled\': vm.gridApi.selection.getSelectedRows().length !== 1, \'enabled\': vm.gridApi.selection.getSelectedRows().length === 1}" data-ng-disabled="vm.gridApi.selection.getSelectedRows().length !== 1"><span class="icon icon-docs" tooltip-side="right" tooltips="" tooltip-template="Seleziona un veicolo per duplicarlo"></span> Duplica</button></div></div></label></div><div class="content"></div><div><div class="top">Livello di zoom</div><label><select data-ng-change="vm.resize(vm.zoom)" data-ng-model="vm.zoom"><option data-ng-value="50">50%</option><option data-ng-value="60">60%</option><option data-ng-value="70">70%</option><option data-ng-value="80">80%</option><option data-ng-value="90">90%</option><option data-ng-value="100">100%</option><option data-ng-value="110">110%</option><option data-ng-value="120">120%</option><option data-ng-value="130">130%</option></select></label></div><div class="content"></div><div><label><div class="top"></div><div class="row no-margin"><div class="no-width"><input type="text"></div><div><button class="btn-height btn btn-md btn-primary" data-ui-sref="root.it.supplier.vehicles.add"><span class="icon icon-add" tooltip-side="right" tooltips="" tooltip-template="Clicca su + per aggiungere un veicolo"></span>Aggiungi veicolo</button></div></div></label></div></div></div></div><ol class="whiteframe-container whiteframe" data-ng-if="vm.unfiltered.length < 1"><li class="whiteframe bootstrap"><article class="content content-nocontent"><p><span class="icon icon-emo-happy"></span></p><p class="message">Non hai aggiunto ancora nessun veicolo.</p><p>Aggiungi il primo veicolo della tua flotta per iniziare a ricevere prenotazioni</p><button class="btn btn-success" data-ui-sref="root.it.supplier.vehicles.add">Aggiungi veicolo</button></article></li></ol><div class="whiteframe-container whiteframe table-container" data-ng-if="vm.unfiltered.length >= 1"><div data-ui-grid="vm.gridOptions" data-ng-style="vm.gridStyle" data-ui-grid-auto-resize="" data-ui-grid-pagination="" data-ui-grid-selection="" data-ui-grid-pinning=""></div></div></div></section></main><data-br-footer></data-br-footer>');
$templateCache.put('app/views/supplier/tables/pricing/modal/alert.modal.html','<div class="modal"><div class="modal-dialog"><div class="close" data-ng-click="alert.closeIt(-1)" data-ng-show="alert.modal.cross"><i class="icon icon-cancel"></i></div><div class="whiteframe-container whiteframe"><div class="header"><h2>Inserisci targa e anno di immatricolazione</h2></div><div class="content whiteframe-content"><div class="bootstrap"><form novalidate="" data-ng-submit="modal.submit($event)" data-ng-class="{\'was-validated\': modal.validated}"><div class="form-group"><div class="col-xs-12"><label>Targa*</label><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="Targa" required data-ng-model="modal.data.specs.plate"><div class="invalid-feedback">Comunicaci la targa</div></div></div></div><div class="form-group"><div class="col-xs-12"><label>Immatricolazione*</label><div class="input-group input-group-sm"><select name="matriculation" class="form-control" required data-ng-model="modal.data.specs.matriculation"><option value="" disabled="disabled" selected="selected" hidden>Prima immatricolazione</option><option data-ng-repeat="item in ::modal.inputs.years track by item.value" data-ng-value="{{item.value}}">{{item.name}}</option></select><div class="invalid-feedback">Comunicaci l\'anno di immatricolazione</div></div></div></div><div class="row"><div class="col-sm"><button class="btn btn-secondary" type="button" data-ng-click="modal.closeIt(0);  $event.stopPropagation();" data-ng-cloak="">Annulla</button></div><div class="col-sm"><button class="btn btn-success" type="submit" data-ng-cloak="">Duplica veicolo</button></div></div></form></div></div></div></div></div>');
$templateCache.put('app/views/supplier/tables/vehicles/modal/alert.modal.html','<div class="modal"><div class="modal-dialog"><div class="close" data-ng-click="alert.closeIt(-1)" data-ng-show="alert.modal.cross"><i class="icon icon-cancel"></i></div><div class="whiteframe-container whiteframe"><div class="header"><h2>Inserisci targa e anno di immatricolazione</h2></div><div class="content whiteframe-content"><div class="bootstrap"><form novalidate="" data-ng-submit="modal.submit($event)" data-ng-class="{\'was-validated\': modal.validated}"><div class="form-group"><div class="col-xs-12"><label>Targa*</label><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="Targa" required data-ng-model="modal.data.specs.plate"><div class="invalid-feedback">Comunicaci la targa</div></div></div></div><div class="form-group"><div class="col-xs-12"><label>Immatricolazione*</label><div class="input-group input-group-sm"><select name="matriculation" class="form-control" required data-ng-model="modal.data.specs.matriculation"><option value="" disabled="disabled" selected="selected" hidden>Prima immatricolazione</option><option data-ng-repeat="item in ::modal.inputs.years track by item.value" data-ng-value="{{item.value}}">{{item.name}}</option></select><div class="invalid-feedback">Comunicaci l\'anno di immatricolazione</div></div></div></div><div class="row"><div class="col-sm"><button class="btn btn-secondary" type="button" data-ng-click="modal.closeIt(0);  $event.stopPropagation();" data-ng-cloak="">Annulla</button></div><div class="col-sm"><button class="btn btn-success" type="submit" data-ng-cloak="">Duplica veicolo</button></div></div></form></div></div></div></div></div>');}]);